!(function (e, t) {
	if ("object" == typeof exports && "object" == typeof module)
	  module.exports = t();
	else if ("function" == typeof define && define.amd) define([], t);
	else {
	  var o = t();
	  for (var n in o) ("object" == typeof exports ? exports : e)[n] = o[n];
	}
  })(self, function () {
	return (function () {
	  var e,
		t = {
		  90643: function (e) {
			e.exports.default = [
			  "إبدأ في الكتابة...",
			  "حول جوديت",
			  "محرر جوديت",
			  null,
			  "دليل مستخدم جوديت",
			  "يحتوي على مساعدة مفصلة للاستخدام",
			  "للحصول على معلومات حول الترخيص، يرجى الذهاب لموقعنا:",
			  "شراء النسخة الكاملة",
			  "حقوق الطبع والنشر © XDSoft.net - Chupurnov Valeriy. كل الحقوق محفوظة.",
			  "مِرْساة",
			  "فتح في نافذة جديدة",
			  "فتح المحرر في الحجم الكامل",
			  "مسح التنسيق",
			  "ملء اللون أو تعيين لون النص",
			  "إعادة",
			  "تراجع",
			  "عريض",
			  "مائل",
			  "إدراج قائمة غير مرتبة",
			  "إدراج قائمة مرتبة",
			  "محاذاة للوسط",
			  "محاذاة مثبتة",
			  "محاذاة لليسار",
			  "محاذاة لليمين",
			  "إدراج خط أفقي",
			  "إدراج صورة",
			  "ادخال الملف",
			  "إدراج فيديو يوتيوب/فيميو ",
			  "إدراج رابط",
			  "حجم الخط",
			  "نوع الخط",
			  "إدراج كتلة تنسيق",
			  "عادي",
			  "عنوان 1",
			  "عنوان 2",
			  "عنوان 3",
			  "عنوان 4",
			  "إقتباس",
			  "كود",
			  "إدراج",
			  "إدراج جدول",
			  "تقليل المسافة البادئة",
			  "زيادة المسافة البادئة",
			  "تحديد أحرف خاصة",
			  "إدراج حرف خاص",
			  "تنسيق الرسم",
			  "تغيير الوضع",
			  "هوامش",
			  "أعلى",
			  "يمين",
			  "أسفل",
			  "يسار",
			  "الأنماط",
			  "الطبقات",
			  "محاذاة",
			  "اليمين",
			  "الوسط",
			  "اليسار",
			  "--غير مضبوط--",
			  "Src",
			  "العنوان",
			  "العنوان البديل",
			  "الرابط",
			  "افتح الرابط في نافذة جديدة",
			  "الصورة",
			  "ملف",
			  "متقدم",
			  "خصائص الصورة",
			  "إلغاء",
			  "حسنا",
			  "يشبه الكود الخاص بك HTML. تبقي كما HTML؟",
			  "الصق ك HTML",
			  "احتفظ",
			  "نظيفة",
			  "إدراج كنص",
			  "إدراج النص فقط",
			  "كلمة لصق الكشف عن",
			  "للصق المحتوى قادم من Microsoft Word/Excel الوثيقة. هل تريد أن تبقي شكل أو تنظيفه ؟ ",
			  "متصفح الملفات",
			  "حدث خطأ في تحميل القائمة ",
			  "حدث خطأ في تحميل المجلدات",
			  "هل أنت واثق؟",
			  "أدخل اسم المجلد",
			  "إنشاء مجلد",
			  "أكتب إسم",
			  "إسقاط صورة",
			  "إسقاط الملف",
			  "أو أنقر",
			  "النص البديل",
			  "تصفح",
			  "رفع",
			  "الخلفية",
			  "نص",
			  "أعلى",
			  "الوسط",
			  "الأسفل",
			  "إدراج عمود قبل",
			  "إدراج عمود بعد",
			  "إدراج صف أعلى",
			  "إدراج صف أسفل",
			  "حذف الجدول",
			  "حذف الصف",
			  "حذف العمود",
			  "خلية فارغة",
			  "مصدر",
			  "بالخط العريض",
			  "مائل",
			  "شغل",
			  "صلة",
			  "إلغاء",
			  "كرر",
			  "طاولة",
			  "صورة",
			  "نظيف",
			  "فقرة",
			  "حجم الخط",
			  "فيديو",
			  "الخط",
			  "حول المحرر",
			  "طباعة",
			  "أكد",
			  "شطب",
			  "المسافة البادئة",
			  "نتوء",
			  "ملء الشاشة",
			  "الحجم التقليدي",
			  "الخط",
			  "قائمة",
			  "قائمة مرقمة",
			  "قطع",
			  "اختر الكل",
			  "قانون",
			  "فتح الرابط",
			  "تعديل الرابط",
			  "سمة Nofollow",
			  "إزالة الرابط",
			  "مراجعة",
			  "لتحرير",
			  "تحديث",
			  "URL",
			  "تحرير",
			  "محاذاة أفقية",
			  "فلتر",
			  "عن طريق التغيير",
			  "بالاسم",
			  "حسب الحجم",
			  "إضافة مجلد",
			  "إعادة",
			  "احتفظ",
			  "حفظ باسم",
			  "تغيير الحجم",
			  "حجم القطع",
			  "عرض",
			  "ارتفاع",
			  "حافظ على النسب",
			  "أن",
			  "لا",
			  "حذف",
			  "تميز",
			  "%d حرف",
			  "%d كلام",
			  null,
			  "تميز %s",
			  "اختر الكل",
			  "محاذاة عمودية",
			  "انشق، مزق",
			  "انقسام عمودي",
			  "تقسيم أفقي",
			  "اذهب",
			  "أضف العمود",
			  "اضف سطر",
			  "حذف",
			  "الحدود",
			  "رخصة %s",
			  "اضرب من خلال",
			  "أكد",
			  "حرف فوقي",
			  "مخطوطة",
			  "قطع الاختيار",
			  "استراحة",
			  "البحث عن",
			  "استبدل ب",
			  "محل",
			  "معجون",
			  "اختر محتوى للصق",
			  "يمكنك فقط تحرير صورك الخاصة. تحميل هذه الصورة على المضيف؟",
			  "تم تحميل الصورة بنجاح على الخادم!",
			  "لوحة",
			  "لا توجد ملفات في هذا الدليل.",
			  "إعادة تسمية",
			  "أدخل اسم جديد",
			  "معاينة",
			  "تحميل",
			  "لصق من الحافظة",
			  "متصفحك لا يدعم إمكانية الوصول المباشر إلى الحافظة.",
			  "نسخ التحديد",
			  "نسخ",
			  "دائرة نصف قطرها الحدود",
			  "عرض كل",
			  "تطبيق",
			  "يرجى ملء هذا المجال",
			  "يرجى إدخال عنوان ويب",
			  "الافتراضي",
			  "دائرة",
			  "نقطة",
			  "المربعة",
			  "البحث",
			  "تجد السابقة",
			  "تجد التالي",
			  "أدخل اسم الفصل",
			  "اضغط البديل لتغيير حجم مخصص",
			];
		  },
		  52532: function (e) {
			e.exports.default = [
			  "Napiš něco",
			  "O Jodit",
			  "Editor Jodit",
			  "Verze pro nekomerční použití",
			  "Jodit Uživatelská příručka",
			  "obsahuje detailní nápovědu",
			  "Pro informace o licenci, prosím, přejděte na naši stránku:",
			  "Koupit plnou verzi",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Všechna práva vyhrazena.",
			  "Anchor",
			  "Otevřít v nové záložce",
			  "Otevřít v celoobrazovkovém režimu",
			  "Vyčistit formátování",
			  "Barva výplně a písma",
			  "Vpřed",
			  "Zpět",
			  "Tučné",
			  "Kurzíva",
			  "Odrážky",
			  "Číslovaný seznam",
			  "Zarovnat na střed",
			  "Zarovnat do bloku",
			  "Zarovnat vlevo",
			  "Zarovnat vpravo",
			  "Vložit horizontální linku",
			  "Vložit obrázek",
			  "Vložit soubor",
			  "Vložit video (YT/Vimeo)",
			  "Vložit odkaz",
			  "Velikost písma",
			  "Typ písma",
			  "Formátovat blok",
			  "Normální text",
			  "Nadpis 1",
			  "Nadpis 2",
			  "Nadpis 3",
			  "Nadpis 4",
			  "Citát",
			  "Kód",
			  "Vložit",
			  "Vložit tabulku",
			  "Zmenšit odsazení",
			  "Zvětšit odsazení",
			  "Vybrat speciální symbol",
			  "Vložit speciální symbol",
			  "Použít formát",
			  "Změnit mód",
			  "Okraje",
			  "horní",
			  "pravý",
			  "spodní",
			  "levý",
			  "Styly",
			  "Třídy",
			  "Zarovnání",
			  "Vpravo",
			  "Na střed",
			  "Vlevo",
			  "--nenastaveno--",
			  "src",
			  "Titulek",
			  "Alternativní text (alt)",
			  "Link",
			  "Otevřít link v nové záložce",
			  "Obrázek",
			  "soubor",
			  "Rozšířené",
			  "Vlastnosti obrázku",
			  "Zpět",
			  "Ok",
			  "Váš text se podobá HTML. Vložit ho jako HTML?",
			  "Vložit jako HTML",
			  "Ponechat originál",
			  "Vyčistit",
			  "Vložit jako TEXT",
			  "Vložit pouze TEXT",
			  "Detekován fragment z Wordu nebo Excelu",
			  "Obsah, který vkládáte, je pravděpodobně z Microsoft Word / Excel. Chcete ponechat formát nebo vložit pouze text?",
			  "Prohlížeč souborů",
			  "Chyba při načítání seznamu souborů",
			  "Chyba při načítání složek",
			  "Jste si jistý(á)?",
			  "Název složky",
			  "Vytvořit složku",
			  "název",
			  "Přetáhněte sem obrázek",
			  "Přetáhněte sem soubor",
			  "nebo klikněte",
			  "Alternativní text",
			  "Server",
			  "Nahrát",
			  "Pozadí",
			  "Text",
			  "Nahoru",
			  "Na střed",
			  "Dolu",
			  "Vložit sloupec před",
			  "Vložit sloupec za",
			  "Vložit řádek nad",
			  "Vložit řádek pod",
			  "Vymazat tabulku",
			  "Vymazat řádku",
			  "Vymazat sloupec",
			  "Vyčistit buňku",
			  "HTML",
			  "tučně",
			  "kurzíva",
			  "štětec",
			  "odkaz",
			  "zpět",
			  "vpřed",
			  "tabulka",
			  "obrázek",
			  "guma",
			  "odstavec",
			  "velikost písma",
			  "video",
			  "písmo",
			  "о editoru",
			  "tisk",
			  "podtrženo",
			  "přeškrtnuto",
			  "zvětšit odsazení",
			  "zmenšit odsazení",
			  "celoobrazovkový režim",
			  "smrsknout",
			  "Linka",
			  "Odrážka",
			  "Číslovaný seznam",
			  "Vyjmout",
			  "Označit vše",
			  "Kód",
			  "Otevřít odkaz",
			  "Upravit odkaz",
			  "Atribut no-follow",
			  "Odstranit odkaz",
			  "Zobrazit",
			  "Chcete-li upravit",
			  "Aktualizovat",
			  "URL",
			  "Editovat",
			  "Horizontální zarovnání",
			  "Filtr",
			  "Dle poslední změny",
			  "Dle názvu",
			  "Dle velikosti",
			  "Přidat složku",
			  "Reset",
			  "Uložit",
			  "Uložit jako...",
			  "Změnit rozměr",
			  "Ořezat",
			  "Šířka",
			  "Výška",
			  "Ponechat poměr",
			  "Ano",
			  "Ne",
			  "Vyjmout",
			  "Označit",
			  "Znaky: %d",
			  "Slova: %d",
			  "Vše",
			  "Označit %s",
			  "Označit vše",
			  "Vertikální zarovnání",
			  "Rozdělit",
			  "Rozdělit vertikálně",
			  "Rozdělit horizontálně",
			  "Spojit",
			  "Přidat sloupec",
			  "Přidat řádek",
			  "Vymazat",
			  "Okraj",
			  "Licence: %s",
			  "Přeškrtnuto",
			  "Podtrženo",
			  "Horní index",
			  "Dolní index",
			  "Vyjmout označené",
			  "Zalomení",
			  "Najdi",
			  "Nahradit za",
			  "Vyměňte",
			  "Vložit",
			  "Vyber obsah pro vložení",
			  "Můžete upravovat pouze své obrázky. Načíst obrázek?",
			  "Obrázek byl úspěšně nahrán!",
			  "paleta",
			  "V tomto adresáři nejsou žádné soubory.",
			  "přejmenovat",
			  "Zadejte nový název",
			  "náhled",
			  "Stažení",
			  "Vložit ze schránky",
			  "Váš prohlížeč nepodporuje přímý přístup do schránky.",
			  "Kopírovat výběr",
			  "kopírování",
			  "Border radius",
			  "Zobrazit všechny",
			  "Platí",
			  "Prosím, vyplňte toto pole",
			  "Prosím, zadejte webovou adresu",
			  "Výchozí",
			  "Kruh",
			  "Dot",
			  "Quadrate",
			  "Najít",
			  "Najít Předchozí",
			  "Najít Další",
			  "Vložte název třídy",
			  "Stiskněte Alt pro vlastní změnu velikosti",
			];
		  },
		  75178: function (e) {
			e.exports.default = [
			  "Bitte geben Sie einen Text ein",
			  "Über Jodit",
			  "Jodit Editor",
			  null,
			  "Das Jodit Benutzerhandbuch",
			  "beinhaltet ausführliche Informationen wie Sie den Editor verwenden können.",
			  "Für Informationen zur Lizenz, besuchen Sie bitte unsere Web-Präsenz:",
			  "Vollversion kaufen",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.",
			  "Anker",
			  "In neuer Registerkarte öffnen",
			  "Editor in voller Größe öffnen",
			  "Formatierung löschen",
			  "Füllfarbe oder Textfarbe ändern",
			  "Wiederholen",
			  "Rückgängig machen",
			  "Fett",
			  "Kursiv",
			  "Unsortierte Liste einfügen",
			  "Nummerierte Liste einfügen",
			  "Mittig ausrichten",
			  "Blocksatz",
			  "Links ausrichten",
			  "Rechts ausrichten",
			  "Horizontale Linie einfügen",
			  "Bild einfügen",
			  "Datei einfügen",
			  "Youtube/vimeo Video einfügen",
			  "Link einfügen",
			  "Schriftgröße",
			  "Schriftfamilie",
			  "Formatblock einfügen",
			  "Normal",
			  "Überschrift 1",
			  "Überschrift 2",
			  "Überschrift 3",
			  "Überschrift 4",
			  "Zitat",
			  "Code",
			  "Einfügen",
			  "Tabelle einfügen",
			  "Einzug verkleinern",
			  "Einzug vergrößern",
			  "Sonderzeichen auswählen",
			  "Sonderzeichen einfügen",
			  "Format kopieren",
			  "Änderungsmodus",
			  "Ränder",
			  "Oben",
			  "Rechts",
			  "Unten",
			  "Links",
			  "CSS Stil",
			  "CSS Klassen",
			  "Ausrichtung",
			  "Rechts",
			  "Zentriert",
			  "Links",
			  "Keine",
			  "Pfad",
			  "Titel",
			  "Alternativer Text",
			  "Link",
			  "Link in neuem Tab öffnen",
			  "Bild",
			  "Datei",
			  "Fortgeschritten",
			  "Bildeigenschaften",
			  "Abbrechen",
			  "OK",
			  "Ihr Text ähnelt HTML-Code. Als HTML beibehalten?",
			  "Als HTML einfügen?",
			  "Original speichern",
			  "Säubern",
			  "Als Text einfügen",
			  "Nur Text einfügen",
			  "In Word formatierter Text erkannt",
			  "Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format erhalten oder bereinigen?",
			  "Dateibrowser",
			  "Fehler beim Laden der Liste",
			  "Fehler beim Laden der Ordner",
			  "Sind Sie sicher?",
			  "Geben Sie den Verzeichnisnamen ein",
			  "Verzeichnis erstellen",
			  "Typname",
			  "Bild hier hinziehen",
			  "Datei löschen",
			  "oder hier klicken",
			  "Alternativtext",
			  "Auswählen",
			  "Hochladen",
			  "Hintergrund",
			  "Text",
			  "Oben",
			  "Mittig",
			  "Unten",
			  "Spalte davor einfügen",
			  "Spalte danach einfügen",
			  "Zeile oberhalb einfügen",
			  "Zeile unterhalb einfügen",
			  "Tabelle löschen",
			  "Zeile löschen",
			  "Spalte löschen",
			  "Zelle leeren",
			  "HTML",
			  "Fett gedruckt",
			  "Kursiv",
			  "Bürste",
			  "Verknüpfung",
			  "Rückgängig machen",
			  "Wiederholen",
			  "Tabelle",
			  "Bild",
			  "Radiergummi",
			  "Absatz",
			  "Schriftgröße",
			  "Video",
			  "Schriftart",
			  "Über",
			  "Drucken",
			  "Unterstreichen",
			  "Durchstreichen",
			  "Einzug",
			  "Herausstellen",
			  "Vollgröße",
			  "Schrumpfen",
			  "die Linie",
			  "Liste von",
			  "Nummerierte Liste",
			  "Schneiden",
			  "Wählen Sie Alle aus",
			  "Code einbetten",
			  "Link öffnen",
			  "Link bearbeiten",
			  "Nofollow-Attribut",
			  "Link entfernen",
			  "Ansehen",
			  "Bearbeiten",
			  "Aktualisieren",
			  "URL",
			  "Bearbeiten",
			  "Horizontale Ausrichtung",
			  "Filter",
			  "Sortieren nach geändert",
			  "Nach Name sortieren",
			  "Nach Größe sortiert",
			  "Ordner hinzufügen",
			  "Wiederherstellen",
			  "Speichern",
			  "Speichern als",
			  "Größe ändern",
			  "Größe anpassen",
			  "Breite",
			  "Höhe",
			  "Seitenverhältnis beibehalten",
			  "Ja",
			  "Nein",
			  "Entfernen",
			  "Markieren",
			  "Zeichen: %d",
			  "Wörter: %d",
			  "Alles markieren",
			  "Markieren: %s",
			  "Alles markieren",
			  "Vertikale Ausrichtung",
			  "Unterteilen",
			  "Vertikal unterteilen",
			  "Horizontal unterteilen",
			  "Vereinen",
			  "Spalte hinzufügen",
			  "Zeile hinzufügen",
			  "Löschen",
			  "Rand",
			  null,
			  "Durchstreichen",
			  "Unterstreichen",
			  "Hochstellen",
			  "Tiefstellen",
			  "Auswahl ausschneiden",
			  "Pause",
			  "Suche nach",
			  "Ersetzen durch",
			  "Ersetzen",
			  "Einfügen",
			  "Wählen Sie den Inhalt zum Einfügen aus",
			  "Sie können nur Ihre eigenen Bilder bearbeiten. Dieses Bild auf den Host herunterladen?",
			  "Das Bild wurde erfolgreich auf den Server hochgeladen!",
			  "Palette",
			  "In diesem Verzeichnis befinden sich keine Dateien.",
			  "Umbenennen",
			  "Geben Sie einen neuen Namen ein",
			  "Vorschau",
			  "Herunterladen",
			  "Aus Zwischenablage einfügen",
			  "Ihr Browser unterstützt keinen direkten Zugriff auf die Zwischenablage.",
			  "Auswahl kopieren",
			  "Kopieren",
			  "Radius für abgerundete Ecken",
			  "Alle anzeigen",
			  "Anwenden",
			  "Bitte füllen Sie dieses Feld aus",
			  "Bitte geben Sie eine Web-Adresse ein",
			  "Standard",
			  "Kreis",
			  "Punkte",
			  "Quadrate",
			  "Suchen",
			  "Suche vorherige",
			  "Weitersuchen",
			  "className (CSS) einfügen",
			  "Drücken Sie Alt für benutzerdefinierte Größenanpassung",
			];
		  },
		  51048: function (e) {
			e.exports.default = {
			  "Type something": "Start writing...",
			  pencil: "Edit",
			  Quadrate: "Square",
			};
		  },
		  22999: function (e) {
			e.exports.default = [
			  "Escriba algo...",
			  "Acerca de Jodit",
			  "Jodit Editor",
			  null,
			  "Guía de usuario Jodit",
			  "contiene ayuda detallada para el uso.",
			  "Para información sobre la licencia, por favor visite nuestro sitio:",
			  "Compre la versión completa",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Todos los derechos reservados.",
			  "Anclar",
			  "Abrir en nueva pestaña",
			  "Abrir editor en pantalla completa",
			  "Limpiar formato",
			  "Color de relleno o de letra",
			  "Rehacer",
			  "Deshacer",
			  "Negrita",
			  "Cursiva",
			  "Insertar lista no ordenada",
			  "Insertar lista ordenada",
			  "Alinear Centrado",
			  "Alinear Justificado",
			  "Alinear Izquierda",
			  "Alinear Derecha",
			  "Insertar línea horizontal",
			  "Insertar imagen",
			  "Insertar archivo",
			  "Insertar video de Youtube/vimeo",
			  "Insertar vínculo",
			  "Tamaño de letra",
			  "Familia de letra",
			  "Insertar bloque",
			  "Normal",
			  "Encabezado 1",
			  "Encabezado 2",
			  "Encabezado 3",
			  "Encabezado 4",
			  "Cita",
			  "Código",
			  "Insertar",
			  "Insertar tabla",
			  "Disminuir sangría",
			  "Aumentar sangría",
			  "Seleccionar caracter especial",
			  "Insertar caracter especial",
			  "Copiar formato",
			  "Cambiar modo",
			  "Márgenes",
			  "arriba",
			  "derecha",
			  "abajo",
			  "izquierda",
			  "Estilos CSS",
			  "Clases CSS",
			  "Alinear",
			  "Derecha",
			  "Centrado",
			  "Izquierda",
			  "--No Establecido--",
			  "Fuente",
			  "Título",
			  "Texto Alternativo",
			  "Vínculo",
			  "Abrir vínculo en nueva pestaña",
			  "Imagen",
			  "Archivo",
			  "Avanzado",
			  "Propiedades de imagen",
			  "Cancelar",
			  "Aceptar",
			  "El código es similar a HTML. ¿Mantener como HTML?",
			  "Pegar como HTML?",
			  "Mantener",
			  "Limpiar",
			  "Insertar como texto",
			  "Insertar solo texto",
			  "Pegado desde Word detectado",
			  "El contenido pegado proviene de un documento de Microsoft Word/Excel. ¿Desea mantener el formato o limpiarlo?",
			  "Buscar archivo",
			  "Error al cargar la lista",
			  "Error al cargar las carpetas",
			  "¿Está seguro?",
			  "Entre nombre de carpeta",
			  "Crear carpeta",
			  "Entre el nombre",
			  "Soltar imagen",
			  "Soltar archivo",
			  "o click",
			  "Texto alternativo",
			  "Buscar",
			  "Subir",
			  "Fondo",
			  "Texto",
			  "Arriba",
			  "Centro",
			  "Abajo",
			  "Insertar columna antes",
			  "Interar columna después",
			  "Insertar fila arriba",
			  "Insertar fila debajo",
			  "Borrar tabla",
			  "Borrar fila",
			  "Borrar columna",
			  "Vaciar celda",
			  "HTML",
			  "negrita",
			  "cursiva",
			  "Brocha",
			  "Vínculo",
			  "deshacer",
			  "rehacer",
			  "Tabla",
			  "Imagen",
			  "Borrar",
			  "Párrafo",
			  "Tamaño de letra",
			  "Video",
			  "Letra",
			  "Acerca de",
			  "Imprimir",
			  "subrayar",
			  "tachar",
			  "sangría",
			  "quitar sangría",
			  "Tamaño completo",
			  "encoger",
			  "línea horizontal",
			  "lista sin ordenar",
			  "lista ordenada",
			  "Cortar",
			  "Seleccionar todo",
			  "Incluir código",
			  "Abrir vínculo",
			  "Editar vínculo",
			  "No seguir",
			  "Desvincular",
			  "Ver",
			  "Para editar",
			  "Actualizar",
			  "URL",
			  "Editar",
			  "Alineación horizontal",
			  "Filtrar",
			  "Ordenar por fecha modificación",
			  "Ordenar por nombre",
			  "Ordenar por tamaño",
			  "Agregar carpeta",
			  "Resetear",
			  "Guardar",
			  "Guardar como...",
			  "Redimensionar",
			  "Recortar",
			  "Ancho",
			  "Alto",
			  "Mantener relación de aspecto",
			  "Si",
			  "No",
			  "Quitar",
			  "Seleccionar",
			  "Caracteres: %d",
			  "Palabras: %d",
			  "Todo",
			  "Seleccionar: %s",
			  "Seleccionar todo",
			  "Alineación vertical",
			  "Dividir",
			  "Dividir vertical",
			  "Dividir horizontal",
			  "Mezclar",
			  "Agregar columna",
			  "Agregar fila",
			  "Borrar",
			  "Borde",
			  null,
			  "Tachado",
			  "Subrayado",
			  "superíndice",
			  "subíndice",
			  "Cortar selección",
			  "Pausa",
			  "Buscar",
			  "Reemplazar con",
			  "Reemplazar",
			  "Pegar",
			  "Seleccionar contenido para pegar",
			  "Solo puedes editar tus propias imágenes. ¿Descargar esta imagen en el servidor?",
			  "¡La imagen se ha subido correctamente al servidor!",
			  "paleta",
			  "No hay archivos en este directorio.",
			  "renombrar",
			  "Ingresa un nuevo nombre",
			  "avance",
			  "Descargar",
			  "Pegar desde el portapapeles",
			  "Su navegador no soporta el acceso directo en el portapapeles.",
			  "Selección de copia",
			  "copia",
			  "Radio frontera",
			  "Mostrar todos los",
			  "Aplicar",
			  "Por favor, rellene este campo",
			  "Por favor, introduzca una dirección web",
			  "Predeterminado",
			  "Círculo",
			  "Punto",
			  "Cuadro",
			  "Encontrar",
			  "Buscar Anterior",
			  "Buscar Siguiente",
			  "Insertar nombre de clase",
			  "Presione Alt para cambiar el tamaño personalizado",
			];
		  },
		  34145: function (e) {
			e.exports.default = [
			  "Ecrivez ici",
			  "A propos de Jodit",
			  "Editeur Jodit",
			  null,
			  "Guide de l'utilisateur",
			  "Aide détaillée à l'utilisation",
			  "Consulter la licence sur notre site web:",
			  "Acheter la version complète",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Tous droits réservés.",
			  "Ancre",
			  "Ouvrir dans un nouvel onglet",
			  "Ouvrir l'éditeur en pleine page",
			  "Supprimer le formattage",
			  "Modifier la couleur du fond ou du texte",
			  "Refaire",
			  "Défaire",
			  "Gras",
			  "Italique",
			  "Liste non ordonnée",
			  "Liste ordonnée",
			  "Centrer",
			  "Justifier",
			  "Aligner à gauche ",
			  "Aligner à droite",
			  "Insérer une ligne horizontale",
			  "Insérer une image",
			  "Insérer un fichier",
			  "Insérer une vidéo",
			  "Insérer un lien",
			  "Taille des caractères",
			  "Famille des caractères",
			  "Bloc formatté",
			  "Normal",
			  "Titre 1",
			  "Titre 2",
			  "Titre 3",
			  "Titre 4",
			  "Citation",
			  "Code",
			  "Insérer",
			  "Insérer un tableau",
			  "Diminuer le retrait",
			  "Retrait plus",
			  "Sélectionnez un caractère spécial",
			  "Insérer un caractère spécial",
			  "Cloner le format",
			  "Mode wysiwyg <-> code html",
			  "Marges",
			  "haut",
			  "droite",
			  "Bas",
			  "gauche",
			  "Styles",
			  "Classes",
			  "Alignement",
			  "Droite",
			  "Centre",
			  "Gauche",
			  "--Non disponible--",
			  "Source",
			  "Titre",
			  "Alternative",
			  "Lien",
			  "Ouvrir le lien dans un nouvel onglet",
			  "Image",
			  "fichier",
			  "Avancé",
			  "Propriétés de l'image",
			  "Annuler",
			  "OK",
			  "Votre texte que vous essayez de coller est similaire au HTML. Collez-le en HTML?",
			  "Coller en HTML?",
			  "Sauvegarder l'original",
			  "Nettoyer",
			  "Coller en tant que texte",
			  "Coller le texte seulement",
			  "C'est peut-être un fragment de Word ou Excel",
			  "Le contenu que vous insérez provient d'un document Microsoft Word / Excel. Voulez-vous enregistrer le format ou l'effacer?",
			  "Explorateur de fichiers",
			  "Erreur de liste de chargement",
			  "Erreur de dossier de chargement",
			  "Etes-vous sûrs ?",
			  "Entrer le nom de dossier",
			  "Créer un dossier",
			  "type de fichier",
			  "Coller une image",
			  "Déposer un fichier",
			  "ou cliquer",
			  "Texte de remplacemement",
			  "Chercher",
			  "Charger",
			  "Arrière-plan",
			  "Texte",
			  "Haut",
			  "Milieu",
			  "Bas",
			  "Insérer une colonne avant",
			  "Insérer une colonne après",
			  "Insérer une ligne au dessus",
			  "Insérer une ligne en dessous",
			  "Supprimer le tableau",
			  "Supprimer la ligne",
			  "Supprimer la colonne",
			  "Vider la cellule",
			  "la source",
			  "gras",
			  "italique",
			  "pinceau",
			  "lien",
			  "annuler",
			  "refaire",
			  "tableau",
			  "image",
			  "gomme",
			  "clause",
			  "taille de police",
			  "Video",
			  "police",
			  "à propos de l'éditeur",
			  "impression",
			  "souligné",
			  "barré",
			  "indentation",
			  "retrait",
			  "taille réelle",
			  "taille conventionnelle",
			  "la ligne",
			  "Liste",
			  "Liste numérotée",
			  "Couper",
			  "Sélectionner tout",
			  null,
			  "Ouvrir le lien",
			  "Modifier le lien",
			  "Attribut Nofollow",
			  "Supprimer le lien",
			  "Voir",
			  "Pour éditer",
			  "Mettre à jour",
			  "URL",
			  null,
			  "Alignement horizontal",
			  "Filtre",
			  "Trier par modification",
			  "Trier par nom",
			  "Trier par taille",
			  "Créer le dossier",
			  "Restaurer",
			  "Sauvegarder",
			  "Enregistrer sous",
			  "Changer la taille",
			  "Taille de garniture",
			  "Largeur",
			  "Hauteur",
			  "Garder les proportions",
			  "Oui",
			  "Non",
			  "Supprimer",
			  "Mettre en évidence",
			  "Symboles: %d",
			  "Mots: %d",
			  null,
			  "Mettre en évidence: %s",
			  "Tout sélectionner",
			  "Alignement vertical",
			  "Split",
			  "Split vertical",
			  "Split horizontal",
			  "aller",
			  "Ajouter une colonne",
			  "Ajouter une rangée",
			  "Effacer",
			  "Bordure",
			  null,
			  "Barrer",
			  "Souligner",
			  "exposant",
			  "indice",
			  "Couper la sélection",
			  "Pause",
			  "Rechercher",
			  "Remplacer par",
			  "Remplacer",
			  "Coller",
			  "Choisissez le contenu à coller",
			  "Vous ne pouvez éditer que vos propres images. Téléchargez cette image sur l'hôte?",
			  "L'image a été téléchargée avec succès sur le serveur!",
			  "Palette",
			  "Il n'y a aucun fichier dans ce répertoire.",
			  "renommer",
			  "Entrez un nouveau nom",
			  "Aperçu",
			  "Télécharger",
			  "Coller à partir du presse-papiers",
			  "Votre navigateur ne prend pas en charge l'accès direct au presse-papiers.",
			  "Copier la sélection",
			  "copie",
			  "Rayon des bordures",
			  "Afficher tous",
			  "Appliquer",
			  "Veuillez remplir ce champ",
			  "Veuillez entrer une adresse web",
			  "Par défaut",
			  "Cercle",
			  "Point",
			  "Quadratique",
			  "Trouver",
			  "Précédent",
			  "Suivant",
			  "Insérer un nom de classe",
			  "Appuyez sur Alt pour un redimensionnement personnalisé",
			];
		  },
		  40272: function (e) {
			e.exports.default = [
			  "הקלד משהו...",
			  "About Jodit",
			  "Jodit Editor",
			  null,
			  "Jodit User's Guide",
			  "contains detailed help for using.",
			  "For information about the license, please go to our website:",
			  "Buy full version",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
			  "מקום עיגון",
			  "פתח בכרטיסיה חדשה",
			  "פתח את העורך בחלון חדש",
			  "נקה עיצוב",
			  "שנה צבע טקסט או רקע",
			  "בצע שוב",
			  "בטל",
			  "מודגש",
			  "נטוי",
			  "הכנס רשימת תבליטים",
			  "הכנס רשימה ממוספרת",
			  "מרכז",
			  "ישר ",
			  "ישר לשמאל",
			  "ישר לימין",
			  "הכנס קו אופקי",
			  "הכנס תמונה",
			  "הכנס קובץ",
			  "הכנס סרטון וידאו מYouTube/Vimeo",
			  "הכנס קישור",
			  "גודל גופן",
			  "גופן",
			  "מעוצב מראש",
			  "רגיל",
			  "כותרת 1",
			  "כותרת 2",
			  "כותרת 3",
			  "כותרת 4",
			  "ציטוט",
			  "קוד",
			  "הכנס",
			  "הכנס טבלה",
			  "הקטן כניסה",
			  "הגדל כניסה",
			  "בחר תו מיוחד",
			  "הכנס תו מיוחד",
			  "העתק עיצוב",
			  "החלף מצב",
			  "ריווח",
			  "עליון",
			  "ימין",
			  "תחתון",
			  "שמאל",
			  "עיצוב CSS",
			  "מחלקת CSS",
			  "יישור",
			  "ימין",
			  "מרכז",
			  "שמאל",
			  "--לא נקבע--",
			  "מקור",
			  "כותרת",
			  "כיתוב חלופי",
			  "קישור",
			  "פתח בכרטיסיה חדשה",
			  "תמונה",
			  "קובץ",
			  "מתקדם",
			  "מאפייני תמונה",
			  "ביטול",
			  "אישור",
			  "הקוד דומה לHTML, האם להשאיר כHTML",
			  "הדבק כHTML",
			  "השאר",
			  "נקה",
			  "הכנס כטקסט",
			  "הכנס טקסט בלבד",
			  'זוהתה הדבקה מ"וורד"',
			  "התוכן המודבק מגיע ממסמך וורד/אקסל. האם ברצונך להשאיר את העיצוב או לנקותו",
			  "סייר הקבצים",
			  "שגיאה  בזמן טעינת רשימה",
			  "שגיאה בזמן טעינת תקיות",
			  "האם אתה בטוח?",
			  "הכנס שם תקיה",
			  "צור תקיה",
			  "סוג הקובץ",
			  "הסר תמונה",
			  "הסר קובץ",
			  "או לחץ",
			  "כיתוב חלופי",
			  "סייר",
			  "העלה",
			  "רקע",
			  "טקסט",
			  "עליון",
			  "מרכז",
			  "תחתון",
			  "הכנס עמודה לפני",
			  "הכנס עמודה אחרי",
			  "הכנס שורה מעל",
			  "הכנס שורה מתחת",
			  "מחק טבלה",
			  "מחק שורה",
			  "מחק עמודה",
			  "רוקן תא",
			  "HTML",
			  "מודגש",
			  "נטוי",
			  "מברשת",
			  "קישור",
			  "בטל",
			  "בצע שוב",
			  "טבלה",
			  "תמונה",
			  "מחק",
			  "פסקה",
			  "גודל גופן",
			  "וידאו",
			  "גופן",
			  "עלינו",
			  "הדפס",
			  "קו תחתון",
			  "קו חוצה",
			  "הגדל כניסה",
			  "הקטן כניסה",
			  "גודל מלא",
			  "כווץ",
			  "קו אופקי",
			  "רשימת תבליטים",
			  "רשימה ממוספרת",
			  "חתוך",
			  "בחר הכל",
			  "הוסף קוד",
			  "פתח קישור",
			  "ערוך קישור",
			  "ללא מעקב",
			  "בטל קישור",
			  "הצג",
			  "כדי לערוך",
			  "עדכן",
			  "כתובת",
			  "ערוך",
			  "יישור אופקי",
			  "סנן",
			  "מין לפי שינוי",
			  "מיין לפי שם",
			  "מיין לפי גודל",
			  "הוסף תקייה",
			  "אפס",
			  "שמור",
			  "שמור בשם...",
			  "שנה גודל",
			  "חתוך",
			  "רוחב",
			  "גובה",
			  "שמור יחס",
			  "כן",
			  "לא",
			  "הסר",
			  "בחר",
			  "תווים: %d",
			  "מילים: %d",
			  "הכל",
			  "נבחר: %s",
			  "בחר הכל",
			  "יישור אנכי",
			  "פיצול",
			  "פיצול אנכי",
			  "פיצול אופקי",
			  "מזג",
			  "הוסף עמודה",
			  "הוסף שורה",
			  "מחק",
			  "מסגרת",
			  null,
			  "קו חוצה",
			  "קו תחתון",
			  "superscript",
			  "subscript",
			  "גזור בחירה",
			  "שבירת שורה",
			  "חפש",
			  "החלף ב",
			  "להחליף",
			  "הדבק",
			  "בחר תוכן להדבקה",
			  "רק קבצים המשוייכים שלך ניתנים לעריכה. האם להוריד את הקובץ?",
			  "התמונה עלתה בהצלחה!",
			  "לוח",
			  "אין קבצים בספריה זו.",
			  "הונגרית",
			  "הזן שם חדש",
			  "תצוגה מקדימה",
			  "הורד",
			  "להדביק מהלוח",
			  "הדפדפן שלך לא תומך גישה ישירה ללוח.",
			  "העתק בחירה",
			  "העתק",
			  "רדיוס הגבול",
			  "הצג את כל",
			  "החל",
			  "נא למלא שדה זה",
			  "אנא הזן כתובת אינטרנט",
			  "ברירת המחדל",
			  "מעגל",
			  "נקודה",
			  "הריבוע הזה",
			  "למצוא",
			  "מצא את הקודם",
			  "חפש את הבא",
			  "הכנס את שם הכיתה",
			  "לחץ על אלט לשינוי גודל מותאם אישית",
			];
		  },
		  2978: function (e) {
			e.exports.default = [
			  "Írjon be valamit",
			  "Joditról",
			  "Jodit Editor",
			  "Ingyenes változat",
			  "Jodit útmutató",
			  "további segítséget tartalmaz",
			  "További licence információkért látogassa meg a weboldalunkat:",
			  "Teljes verzió megvásárlása",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Minden jog fenntartva.",
			  "Horgony",
			  "Megnyitás új lapon",
			  "Megnyitás teljes méretben",
			  "Formázás törlése",
			  "Háttér/szöveg szín",
			  "Újra",
			  "Visszavon",
			  "Félkövér",
			  "Dőlt",
			  "Pontozott lista",
			  "Számozott lista",
			  "Középre zárt",
			  "Sorkizárt",
			  "Balra zárt",
			  "Jobbra zárt",
			  "Vízszintes vonal beszúrása",
			  "Kép beszúrás",
			  "Fájl beszúrás",
			  "Youtube videó beszúrása",
			  "Link beszúrás",
			  "Betűméret",
			  "Betűtípus",
			  "Formázott blokk beszúrása",
			  "Normál",
			  "Fejléc 1",
			  "Fejléc 2",
			  "Fejléc 3",
			  "Fejléc 4",
			  "Idézet",
			  "Kód",
			  "Beszúr",
			  "Táblázat beszúrása",
			  "Behúzás csökkentése",
			  "Behúzás növelése",
			  "Speciális karakter kiválasztása",
			  "Speciális karakter beszúrása",
			  "Kép formázása",
			  "Nézet váltása",
			  "Szegélyek",
			  "felső",
			  "jobb",
			  "alsó",
			  "bal",
			  "CSS stílusok",
			  "CSS osztályok",
			  "Igazítás",
			  "Jobbra",
			  "Középre",
			  "Balra",
			  "Nincs",
			  "Forrás",
			  "Cím",
			  "Helyettesítő szöveg",
			  "Link",
			  "Link megnyitása új lapon",
			  "Kép",
			  "Fájl",
			  "Haladó",
			  "Kép tulajdonságai",
			  "Mégsem",
			  "OK",
			  "A beillesztett szöveg HTML-nek tűnik. Megtartsuk HTML-ként?",
			  "Beszúrás HTML-ként",
			  "Megtartás",
			  "Elvetés",
			  "Beszúrás szövegként",
			  "Csak szöveg beillesztése",
			  "Word-ből másolt szöveg",
			  "A beillesztett tartalom Microsoft Word/Excel dokumentumból származik. Meg szeretné tartani a formátumát?",
			  "Fájl tallózó",
			  "Hiba a lista betöltése közben",
			  "Hiba a mappák betöltése közben",
			  "Biztosan ezt szeretné?",
			  "Írjon be egy mappanevet",
			  "Mappa létrehozása",
			  "írjon be bevet",
			  "Húzza ide a képet",
			  "Húzza ide a fájlt",
			  "vagy kattintson",
			  "Helyettesítő szöveg",
			  "Tallóz",
			  "Feltölt",
			  "Háttér",
			  "Szöveg",
			  "Fent",
			  "Középen",
			  "Lent",
			  "Oszlop beszúrás elé",
			  "Oszlop beszúrás utána",
			  "Sor beszúrás fölé",
			  "Sor beszúrás alá",
			  "Táblázat törlése",
			  "Sor törlése",
			  "Oszlop törlése",
			  "Cella tartalmának törlése",
			  "HTML",
			  "Félkövér",
			  "Dőlt",
			  "Ecset",
			  "Link",
			  "Visszavon",
			  "Újra",
			  "Táblázat",
			  "Kép",
			  "Törlés",
			  "Paragráfus",
			  "Betűméret",
			  "Videó",
			  "Betű",
			  "Rólunk",
			  "Nyomtat",
			  "Aláhúzott",
			  "Áthúzott",
			  "Behúzás",
			  "Aussenseiter",
			  "Teljes méret",
			  "Összenyom",
			  "Egyenes vonal",
			  "Lista",
			  "Számozott lista",
			  "Kivág",
			  "Összes kijelölése",
			  "Beágyazott kód",
			  "Link megnyitása",
			  "Link szerkesztése",
			  "Nincs követés",
			  "Link leválasztása",
			  "felülvizsgálat",
			  "Szerkesztés",
			  "Frissít",
			  "URL",
			  "Szerkeszt",
			  "Vízszintes igazítás",
			  "Szűrő",
			  "Rendezés módosítás szerint",
			  "Rendezés név szerint",
			  "Rendezés méret szerint",
			  "Mappa hozzáadás",
			  "Visszaállít",
			  "Mentés",
			  "Mentés másként...",
			  "Átméretezés",
			  "Kivág",
			  "Szélesség",
			  "Magasság",
			  "Képarány megtartása",
			  "Igen",
			  "Nem",
			  "Eltávolít",
			  "Kijelöl",
			  "Karakterek száma: %d",
			  "Szavak száma: %d",
			  "Összes",
			  "Kijelöl: %s",
			  "Összes kijelölése",
			  "Függőleges igazítás",
			  "Felosztás",
			  "Függőleges felosztás",
			  "Vízszintes felosztás",
			  "Összevonás",
			  "Oszlop hozzáadás",
			  "Sor hozzáadás",
			  "Törlés",
			  "Szegély",
			  null,
			  "Áthúzott",
			  "Aláhúzott",
			  "Felső index",
			  "Alsó index",
			  "Kivágás",
			  "Szünet",
			  "Keresés",
			  "Csere erre",
			  "Cserélje ki",
			  "Beillesztés",
			  "Válasszon tartalmat a beillesztéshez",
			  "Csak a saját képeit tudja szerkeszteni. Letölti ezt a képet?",
			  "Kép sikeresen feltöltve!",
			  "Palette",
			  "Er zijn geen bestanden in deze map.",
			  "átnevezés",
			  "Adja meg az új nevet",
			  "előnézet",
			  "Letöltés",
			  "Illessze be a vágólap",
			  "A böngésző nem támogatja a közvetlen hozzáférést biztosít a vágólapra.",
			  "Másolás kiválasztása",
			  "másolás",
			  "Határ sugár",
			  "Összes",
			  "Alkalmazni",
			  "Kérjük, töltse ki ezt a mezőt,",
			  "Kérjük, írja be a webcímet",
			  "Alapértelmezett",
			  "Kör",
			  "Pont",
			  "Quadrate",
			  "Találni",
			  "Megtalálja Előző",
			  "Következő Keresése",
			  "Helyezze be az osztály nevét",
			  "Nyomja meg az Alt egyéni átméretezés",
			];
		  },
		  99113: function (e) {
			e.exports.default = [
			  "Ketik sesuatu",
			  "Tentang Jodit",
			  "Editor Jodit",
			  "Versi Bebas Non-komersil",
			  "Panduan Pengguna Jodit",
			  "mencakup detail bantuan penggunaan",
			  "Untuk informasi tentang lisensi, silakan kunjungi website:",
			  "Beli versi lengkap",
			  "Hak Cipta © XDSoft.net - Chupurnov Valeriy. Hak cipta dilindungi undang-undang.",
			  "Tautan",
			  "Buka di tab baru",
			  "Buka editor dalam ukuran penuh",
			  "Hapus Pemformatan",
			  "Isi warna atau atur warna teks",
			  "Ulangi",
			  "Batalkan",
			  "Tebal",
			  "Miring",
			  "Sisipkan Daftar Tidak Berurut",
			  "Sisipkan Daftar Berurut",
			  "Tengah",
			  "Penuh",
			  "Kiri",
			  "Kanan",
			  "Sisipkan Garis Horizontal",
			  "Sisipkan Gambar",
			  "Sisipkan Berkas",
			  "Sisipkan video youtube/vimeo",
			  "Sisipkan tautan",
			  "Ukuran font",
			  "Keluarga font",
			  "Sisipkan blok format",
			  "Normal",
			  "Heading 1",
			  "Heading 2",
			  "Heading 3",
			  "Heading 4",
			  "Kutip",
			  "Kode",
			  "Sisipkan",
			  "Sisipkan tabel",
			  "Kurangi Indentasi",
			  "Tambah Indentasi",
			  "Pilih Karakter Spesial",
			  "Sisipkan Karakter Spesial",
			  "Formar warna",
			  "Ubah mode",
			  "Batas",
			  "atas",
			  "kanan",
			  "bawah",
			  "kiri",
			  "Gaya",
			  "Class",
			  "Rata",
			  "Kanan",
			  "Tengah",
			  "Kiri",
			  "--Tidak diset--",
			  "Src",
			  "Judul",
			  "Teks alternatif",
			  "Tautan",
			  "Buka tautan di tab baru",
			  "Gambar",
			  "berkas",
			  "Lanjutan",
			  "Properti gambar",
			  "Batal",
			  "Ya",
			  "Kode Anda cenderung ke HTML. Biarkan sebagai HTML?",
			  "Paste sebagai HTML",
			  "Jaga",
			  "Bersih",
			  "Sisipkan sebagai teks",
			  "Sisipkan hanya teks",
			  "Terdeteksi paste dari Word",
			  "Konten dipaste dari dokumen Microsoft Word/Excel. Apakah Anda ingin tetap menjaga format atau membersihkannya?",
			  "Penjelajah Berkas",
			  "Error ketika memuat list",
			  "Error ketika memuat folder",
			  "Apakah Anda yakin?",
			  "Masukkan nama Direktori",
			  "Buat direktori",
			  "ketik nama",
			  "Letakkan gambar",
			  "Letakkan berkas",
			  "atau klik",
			  "Teks alternatif",
			  "Jelajahi",
			  "Unggah",
			  "Latar Belakang",
			  "Teks",
			  "Atas",
			  "Tengah",
			  "Bawah",
			  "Sisipkan kolom sebelumnya",
			  "Sisipkan kolom setelahnya",
			  "Sisipkan baris di atasnya",
			  "Sisipkan baris di bawahnya",
			  "Hapus tabel",
			  "Hapus baris",
			  "Hapus kolom",
			  "Kosongkan cell",
			  "sumber",
			  "tebal",
			  "miring",
			  "sikat",
			  "tautan",
			  "batalkan",
			  "ulangi",
			  "tabel",
			  "gambar",
			  "penghapus",
			  "paragraf",
			  "ukuran font",
			  "video",
			  "font",
			  "tentang",
			  "cetak",
			  "garis bawah",
			  "coret",
			  "menjorok ke dalam",
			  "menjorok ke luar",
			  "ukuran penuh",
			  "menyusut",
			  "hr",
			  "ul",
			  "ol",
			  "potong",
			  "Pilih semua",
			  "Kode embed",
			  "Buka tautan",
			  "Edit tautan",
			  "No follow",
			  "Hapus tautan",
			  "Mata",
			  "pensil",
			  "Perbarui",
			  "URL",
			  "Edit",
			  "Perataan horizontal",
			  "Filter",
			  "Urutkan berdasarkan perubahan",
			  "Urutkan berdasarkan nama",
			  "Urutkan berdasarkan ukuran",
			  "Tambah folder",
			  "Reset",
			  "Simpan",
			  "Simpan sebagai...",
			  "Ubah ukuran",
			  "Crop",
			  "Lebar",
			  "Tinggi",
			  "Jaga aspek rasio",
			  "Ya",
			  "Tidak",
			  "Copot",
			  "Pilih",
			  "Karakter: %d",
			  "Kata: %d",
			  "Semua",
			  "Pilih %s",
			  "Pilih semua",
			  "Rata vertikal",
			  "Bagi",
			  "Bagi secara vertikal",
			  "Bagi secara horizontal",
			  "Gabungkan",
			  "Tambah kolom",
			  "tambah baris",
			  "Hapus",
			  "Bingkai",
			  "Lisensi: %s",
			  "Coret",
			  "Garis Bawah",
			  "Superskrip",
			  "Subskrip",
			  "Potong pilihan",
			  "Berhenti",
			  "Mencari",
			  "Ganti dengan",
			  "Mengganti",
			  "Paste",
			  "Pilih konten untuk dipaste",
			  "Anda hanya dapat mengedit gambar Anda sendiri. Unduh gambar ini di host?",
			  "Gambar telah sukses diunggah ke host!",
			  "palet",
			  "Tidak ada berkas",
			  "ganti nama",
			  "Masukkan nama baru",
			  "pratinjau",
			  "Unduh",
			  "Paste dari clipboard",
			  "Browser anda tidak mendukung akses langsung ke clipboard.",
			  "Copy seleksi",
			  "copy",
			  "Border radius",
			  "Tampilkan semua",
			  "Menerapkan",
			  "Silahkan mengisi kolom ini",
			  "Silahkan masukkan alamat web",
			  "Default",
			  "Lingkaran",
			  "Dot",
			  "Kuadrat",
			  "Menemukan",
			  "Menemukan Sebelumnya",
			  "Menemukan Berikutnya",
			  "Masukkan nama kelas",
			  "Tekan Alt untuk mengubah ukuran kustom",
			];
		  },
		  51923: function (e) {
			e.exports.default = [
			  "Scrivi qualcosa...",
			  "A proposito di Jodit",
			  "Jodit Editor",
			  null,
			  "Guida utente di Jodit",
			  "contiene una guida dettagliata per l'uso.",
			  "Per informazioni sulla licenza, si prega di visitare il nostro sito:",
			  "Acquista la versione completa",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.",
			  "Ancora",
			  "Apri in una nuova scheda",
			  "Apri l'editor a schermo intero",
			  "Formato chiaro",
			  "Riempi colore o lettera",
			  "Ripristina",
			  "Annulla",
			  "Grassetto",
			  "Corsivo",
			  "Inserisci lista non ordinata",
			  "Inserisci l'elenco ordinato",
			  "Allinea Centra",
			  "Allineare Giustificato",
			  "Allinea a Sinistra",
			  "Allinea a Destra",
			  "Inserisci la linea orizzontale",
			  "Inserisci immagine",
			  "Inserisci un file",
			  "Inserisci video Youtube/Vimeo",
			  "Inserisci il link",
			  "Dimensione del carattere",
			  "Tipo di font",
			  "Inserisci blocco",
			  "Normale",
			  "Heading 1",
			  "Heading 2",
			  "Heading 3",
			  "Heading 4",
			  "Citazione",
			  "Codice",
			  "Inserisci",
			  "Inserisci tabella",
			  "Riduci il rientro",
			  "Aumenta il rientro",
			  "Seleziona una funzione speciale",
			  "Inserisci un carattere speciale",
			  "Copia formato",
			  "Cambia modo",
			  "Margini",
			  "su",
			  "destra",
			  "giù",
			  "sinistra",
			  "Stili CSS",
			  "Classi CSS",
			  "Allinea",
			  "Destra",
			  "Centro",
			  "Sinistra",
			  "--Non Impostato--",
			  "Fonte",
			  "Titolo",
			  "Testo Alternativo",
			  "Link",
			  "Apri il link in una nuova scheda",
			  "Immagine",
			  "Archivio",
			  "Avanzato",
			  "Proprietà dell'immagine",
			  "Annulla",
			  "Accetta",
			  "Il codice è simile all'HTML. Mantieni come HTML?",
			  "Incolla come HTML?",
			  "Mantieni",
			  "Pulisci",
			  "Inserisci come testo",
			  "Inserisci solo il testo",
			  "Incollato da Word rilevato",
			  "Il contenuto incollato proviene da un documento Microsoft Word / Excel. Vuoi mantenere il formato o pulirlo?",
			  "Cerca il file",
			  "Errore durante il caricamento dell'elenco",
			  "Errore durante il caricamento delle cartelle",
			  "Sei sicuro?",
			  "Inserisci il nome della cartella",
			  "Crea cartella",
			  "Entre el nombre",
			  "Rilascia l'immagine",
			  "Rilascia file",
			  "o click",
			  "Testo alternativo",
			  "Sfoglia",
			  "Carica",
			  "Sfondo",
			  "Testo",
			  "Su",
			  "Centro",
			  "Sotto",
			  "Inserisci prima la colonna",
			  "Inserisci colonna dopo",
			  "Inserisci la riga sopra",
			  "Inserisci la riga sotto",
			  "Elimina tabella",
			  "Elimina riga",
			  "Elimina colonna",
			  "Cella vuota",
			  "HTML",
			  "Grassetto",
			  "Corsivo",
			  "Pennello",
			  "Link",
			  "Annulla",
			  "Ripristina",
			  "Tabella",
			  "Immagine",
			  "Gomma",
			  "Paragrafo",
			  "Dimensione del carattere",
			  "Video",
			  "Font",
			  "Approposito di",
			  "Stampa",
			  "Sottolineato",
			  "Barrato",
			  "trattino",
			  "annulla rientro",
			  "A grandezza normale",
			  "comprimere",
			  "linea orizzontale",
			  "lista non ordinata",
			  "lista ordinata",
			  "Taglia",
			  "Seleziona tutto",
			  "Includi codice",
			  "Apri link",
			  "Modifica link",
			  "Non seguire",
			  "Togli link",
			  "Recensione",
			  "Per modificare",
			  "Aggiornare",
			  " URL",
			  "Modifica",
			  "Allineamento orizzontale",
			  "Filtro",
			  "Ordina per data di modifica",
			  "Ordina per nome",
			  "Ordina per dimensione",
			  "Aggiungi cartella",
			  "Reset",
			  "Salva",
			  "Salva con nome...",
			  "Ridimensiona",
			  "Tagliare",
			  "Larghezza",
			  "Altezza",
			  "Mantenere le proporzioni",
			  "Si",
			  "No",
			  "Rimuovere",
			  "Seleziona",
			  "Caratteri: %d",
			  "Parole: %d",
			  "Tutto",
			  "Seleziona: %s",
			  "Seleziona tutto",
			  "Allineamento verticala",
			  "Dividere",
			  "Dividere verticalmente",
			  "Diviso orizzontale",
			  "Fondi",
			  "Aggiungi colonna",
			  "Aggiungi riga",
			  "Cancella",
			  "Bordo",
			  null,
			  "Barrato",
			  "Sottolineato",
			  "indice",
			  "deponente",
			  "Taglia la selezione",
			  "Pausa",
			  "Cerca",
			  "Sostituisci con",
			  "Sostituire",
			  "Incolla",
			  "Seleziona il contenuto da incollare",
			  "Puoi modificare solo le tue immagini. Scarica questa immagine sul server?",
			  "L'immagine è stata caricata con successo sul server!",
			  "tavolozza",
			  "Non ci sono file in questa directory.",
			  "ungherese",
			  "Inserisci un nuovo nome",
			  "anteprima",
			  "Scaricare",
			  "Incolla dagli appunti",
			  "Il tuo browser non supporta l'accesso diretto agli appunti.",
			  "Selezione di copia",
			  "copia",
			  "Border radius",
			  "Mostra tutti",
			  "Applicare",
			  "Si prega di compilare questo campo",
			  "Si prega di inserire un indirizzo web",
			  "Di Default",
			  "Cerchio",
			  "Dot",
			  "Quadrate",
			  "Trovare",
			  "Trova Precedente",
			  "Trova Successivo",
			  "Inserisci il nome della classe",
			  "Premere Alt per il ridimensionamento personalizzato",
			];
		  },
		  21268: function (e) {
			e.exports.default = [
			  "なにかタイプしてください",
			  "Joditについて",
			  "Jodit Editor",
			  null,
			  "Jodit ユーザーズ・ガイド",
			  "詳しい使い方",
			  "ライセンス詳細についてはJodit Webサイトを確認ください：",
			  "フルバージョンを購入",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
			  "Anchor",
			  "新しいタブで開く",
			  "エディターのサイズ（フル/ノーマル）",
			  "書式をクリア",
			  "テキストの色",
			  "やり直し",
			  "元に戻す",
			  "太字",
			  "斜体",
			  "箇条書き",
			  "番号付きリスト",
			  "中央揃え",
			  "両端揃え",
			  "左揃え",
			  "右揃え",
			  "区切り線を挿入",
			  "画像を挿入",
			  "ファイルを挿入",
			  "Youtube/Vimeo 動画",
			  "リンクを挿入",
			  "フォントサイズ",
			  "フォント",
			  "テキストのスタイル",
			  "指定なし",
			  "タイトル1",
			  "タイトル2",
			  "タイトル3",
			  "タイトル4",
			  "引用",
			  "コード",
			  "挿入",
			  "表を挿入",
			  "インデント減",
			  "インデント増",
			  "特殊文字を選択",
			  "特殊文字を挿入",
			  "書式を貼付け",
			  "編集モード切替え",
			  "マージン",
			  "上",
			  "右",
			  "下",
			  "左",
			  "スタイル",
			  "クラス",
			  "配置",
			  "右寄せ",
			  "中央寄せ",
			  "左寄せ",
			  "指定なし",
			  "ソース",
			  "タイトル",
			  "代替テキスト",
			  "リンク",
			  "新しいタブで開く",
			  "画像",
			  "ファイル",
			  "高度な設定",
			  "画像のプロパティー",
			  "キャンセル",
			  "確定",
			  "HTMLコードを保持しますか？",
			  "HTMLで貼付け",
			  "HTMLを保持",
			  "Clean",
			  "HTMLをテキストにする",
			  "テキストだけ",
			  "Word Paste Detected",
			  "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?",
			  "File Browser",
			  "Error on load list",
			  "Error on load folders",
			  "Are you sure?",
			  "Enter Directory name",
			  "Create directory",
			  "type name",
			  "ここに画像をドロップ",
			  "ここにファイルをドロップ",
			  "or クリック",
			  "代替テキスト",
			  "ブラウズ",
			  "アップロード",
			  "背景",
			  "文字",
			  "上",
			  "中央",
			  "下",
			  "左に列を挿入",
			  "右に列を挿入",
			  "上に行を挿入",
			  "下に行を挿入",
			  "表を削除",
			  "行を削除",
			  "列を削除",
			  "セルを空にする",
			  "source",
			  "bold",
			  "italic",
			  "brush",
			  "link",
			  "undo",
			  "redo",
			  "table",
			  "image",
			  "eraser",
			  "paragraph",
			  "fontsize",
			  "video",
			  "font",
			  "about",
			  "print",
			  "underline",
			  "strikethrough",
			  "indent",
			  "outdent",
			  "fullsize",
			  "shrink",
			  "分割線",
			  "箇条書き",
			  "番号付きリスト",
			  "切り取り",
			  "すべて選択",
			  "埋め込みコード",
			  "リンクを開く",
			  "リンクを編集",
			  "No follow",
			  "リンク解除",
			  "サイトを確認",
			  "鉛筆",
			  "更新",
			  "URL",
			  "編集",
			  "水平方向の配置",
			  "Filter",
			  "Sort by changed",
			  "Sort by name",
			  "Sort by size",
			  "Add folder",
			  "リセット",
			  "保存",
			  "Save as ...",
			  "リサイズ",
			  "Crop",
			  "幅",
			  "高さ",
			  "縦横比を保持",
			  "はい",
			  "いいえ",
			  "移除",
			  "選択",
			  "文字数: %d",
			  "単語数: %d",
			  "全部",
			  "選択: %s",
			  "すべて選択",
			  "垂直方向の配置",
			  "分割",
			  "セルの分割（垂直方向）",
			  "セルの分割（水平方向）",
			  "セルの結合",
			  "列を追加",
			  "行を追加",
			  "削除",
			  "境界線",
			  null,
			  "取り消し線",
			  "下線",
			  "上付き文字",
			  "下付き文字",
			  "切り取り",
			  "Pause",
			  "検索",
			  "置換",
			  "交換",
			  "貼付け",
			  "選択した内容を貼付け",
			  "You can only edit your own images. Download this image on the host?",
			  "The image has been successfully uploaded to the host!",
			  "パレット",
			  "There are no files",
			  "Rename",
			  "Enter new name",
			  "プレビュー",
			  "ダウンロード",
			  "貼り付け",
			  "お使いのブラウザはクリップボードを使用できません",
			  "コピー",
			  "copy",
			  "角の丸み",
			  "全て表示",
			  "適用",
			  "まだこの分野",
			  "を入力してくださいウェブアドレス",
			  "デフォルト",
			  "白丸",
			  "黒丸",
			  "四角",
			  "見",
			  "探前",
			  "由来",
			  "クラス名を挿入",
			  "カスタムサイズ変更のためのAltキーを押します",
			];
		  },
		  11399: function (e) {
			e.exports.default = [
			  "Type something",
			  "About Jodit",
			  "Jodit Editor",
			  "Free Non-commercial Version",
			  "Jodit User's Guide",
			  "contains detailed help for using",
			  "For information about the license, please go to our website:",
			  "Buy full version",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
			  "Anchor",
			  "Open in new tab",
			  "Open in fullsize",
			  "Clear Formatting",
			  "Fill color or set the text color",
			  "Redo",
			  "Undo",
			  "Bold",
			  "Italic",
			  "Insert Unordered List",
			  "Insert Ordered List",
			  "Align Center",
			  "Align Justify",
			  "Align Left",
			  "Align Right",
			  "Insert Horizontal Line",
			  "Insert Image",
			  "Insert file",
			  "Insert youtube/vimeo video",
			  "Insert link",
			  "Font size",
			  "Font family",
			  "Insert format block",
			  "Normal",
			  "Heading 1",
			  "Heading 2",
			  "Heading 3",
			  "Heading 4",
			  "Quote",
			  "Code",
			  "Insert",
			  "Insert table",
			  "Decrease Indent",
			  "Increase Indent",
			  "Select Special Character",
			  "Insert Special Character",
			  "Paint format",
			  "Change mode",
			  "Margins",
			  "top",
			  "right",
			  "bottom",
			  "left",
			  "Styles",
			  "Classes",
			  "Align",
			  "Right",
			  "Center",
			  "Left",
			  "--Not Set--",
			  "Src",
			  "Title",
			  "Alternative",
			  "Link",
			  "Open link in new tab",
			  "Image",
			  "file",
			  "Advanced",
			  "Image properties",
			  "Cancel",
			  "Ok",
			  "Your code is similar to HTML. Keep as HTML?",
			  "Paste as HTML",
			  "Keep",
			  "Clean",
			  "Insert as Text",
			  "Insert only Text",
			  "Word Paste Detected",
			  "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?",
			  "File Browser",
			  "Error on load list",
			  "Error on load folders",
			  "Are you sure?",
			  "Enter Directory name",
			  "Create directory",
			  "type name",
			  "Drop image",
			  "Drop file",
			  "or click",
			  "Alternative text",
			  "Browse",
			  "Upload",
			  "Background",
			  "Text",
			  "Top",
			  "Middle",
			  "Bottom",
			  "Insert column before",
			  "Insert column after",
			  "Insert row above",
			  "Insert row below",
			  "Delete table",
			  "Delete row",
			  "Delete column",
			  "Empty cell",
			  "source",
			  "bold",
			  "italic",
			  "brush",
			  "link",
			  "undo",
			  "redo",
			  "table",
			  "image",
			  "eraser",
			  "paragraph",
			  "fontsize",
			  "video",
			  "font",
			  "about",
			  "print",
			  "underline",
			  "strikethrough",
			  "indent",
			  "outdent",
			  "fullsize",
			  "shrink",
			  "hr",
			  "ul",
			  "ol",
			  "cut",
			  "selectall",
			  "Embed code",
			  "Open link",
			  "Edit link",
			  "No follow",
			  "Unlink",
			  "Eye",
			  "pencil",
			  "Update",
			  " URL",
			  "Edit",
			  "Horizontal align",
			  "Filter",
			  "Sort by changed",
			  "Sort by name",
			  "Sort by size",
			  "Add folder",
			  "Reset",
			  "Save",
			  "Save as ...",
			  "Resize",
			  "Crop",
			  "Width",
			  "Height",
			  "Keep Aspect Ratio",
			  "Yes",
			  "No",
			  "Remove",
			  "Select",
			  "Chars: %d",
			  "Words: %d",
			  "All",
			  "Select %s",
			  "Select all",
			  "Vertical align",
			  "Split",
			  "Split vertical",
			  "Split horizontal",
			  "Merge",
			  "Add column",
			  "Add row",
			  "Delete",
			  "Border",
			  "License: %s",
			  "Strike through",
			  "Underline",
			  "superscript",
			  "subscript",
			  "Cut selection",
			  "Break",
			  "Search for",
			  "Replace with",
			  "Replace",
			  "Paste",
			  "Choose Content to Paste",
			  "You can only edit your own images. Download this image on the host?",
			  "The image has been successfully uploaded to the host!",
			  "palette",
			  "There are no files",
			  "Rename",
			  "Enter new name",
			  "preview",
			  "download",
			  "Paste from clipboard",
			  "Your browser doesn't support direct access to the clipboard.",
			  "Copy selection",
			  "copy",
			  "Border radius",
			  "Show all",
			  "Apply",
			  "Please fill out this field",
			  "Please enter a web address",
			  "Default",
			  "Circle",
			  "Dot",
			  "Quadrate",
			  "Find",
			  "Find Previous",
			  "Find Next",
			  "Insert className",
			  "Press Alt for custom resizing",
			];
		  },
		  37289: function (e) {
			e.exports.default = [
			  "무엇이든 입력하세요",
			  "Jodit에 대하여",
			  "Jodit Editor",
			  null,
			  "Jodit 사용자 안내서",
			  "자세한 도움말이 들어있어요",
			  "라이센스에 관해서는 Jodit 웹 사이트를 방문해주세요：",
			  "풀 버전 구입하기",
			  "© XDSoft.net - Chupurnov Valeriy. 에게 저작권과 모든 권리가 있습니다.",
			  "Anchor",
			  "새 탭에서 열기",
			  "전체 크기로 보기",
			  "서식 지우기",
			  "글씨 색상",
			  "재실행",
			  "실행 취소",
			  "굵게",
			  "기울임",
			  "글머리 목록",
			  "번호 목록",
			  "가운데 정렬",
			  "양쪽 정렬",
			  "왼쪽 정렬",
			  "오른쪽 정렬",
			  "수평 구분선 넣기",
			  "이미지 넣기",
			  "파일 넣기",
			  "Youtube/Vimeo 동영상",
			  "링크 넣기",
			  "글꼴 크기",
			  "글꼴",
			  "블록 요소 넣기",
			  "일반 텍스트",
			  "제목 1",
			  "제목 2",
			  "제목 3",
			  "제목 4",
			  "인용",
			  "코드",
			  "붙여 넣기",
			  "테이블",
			  "들여쓰기 감소",
			  "들여쓰기 증가",
			  "특수문자 선택",
			  "특수문자 입력",
			  "페인트 형식",
			  "편집모드 변경",
			  "마진",
			  "위",
			  "오른쪽",
			  "아래",
			  "왼쪽",
			  "스타일",
			  "클래스",
			  "정렬",
			  "오른쪽으로",
			  "가운데로",
			  "왼쪽으로",
			  "--지정 안 함--",
			  "경로(src)",
			  "제목",
			  "대체 텍스트(alt)",
			  "링크",
			  "새 탭에서 열기",
			  null,
			  "파일",
			  "고급",
			  "이미지 속성",
			  "취소",
			  "확인",
			  "HTML 코드로 감지했어요. 코드인채로 붙여넣을까요?",
			  "HTML로 붙여넣기",
			  "원본 유지",
			  "지우기",
			  "텍스트로 넣기",
			  "텍스트만 넣기",
			  "Word 붙여넣기 감지",
			  "Microsoft Word/Excel 문서로 감지했어요. 서식을 유지한채로 붙여넣을까요?",
			  "파일 탐색기",
			  "목록 불러오기 에러",
			  "폴더 불러오기",
			  "정말 진행할까요?",
			  "디렉토리 이름 입력",
			  "디렉토리 생성",
			  "이름 입력",
			  "이미지 드래그",
			  "파일 드래그",
			  "혹은 클릭",
			  "대체 텍스트",
			  "탐색",
			  "업로드",
			  "배경",
			  "텍스트",
			  "위",
			  "중앙",
			  "아래",
			  "이전 열에 삽입",
			  "다음 열에 삽입",
			  "위 행에 삽입",
			  "아래 행에 삽입",
			  "테이블 삭제",
			  "행 삭제",
			  "열 삭제",
			  "빈 셀",
			  "HTML 소스",
			  "볼드",
			  "이탤릭",
			  "브러시",
			  "링크",
			  "실행 취소",
			  "재실행",
			  "테이블",
			  "이미지",
			  "지우개",
			  "문단",
			  "글꼴 크기",
			  "비디오",
			  "글꼴",
			  "편집기 정보",
			  "프린트",
			  "밑줄",
			  "취소선",
			  "들여쓰기",
			  "내어쓰기",
			  "전체 화면",
			  "일반 화면",
			  "구분선",
			  "글머리 목록",
			  "번호 목록",
			  "잘라내기",
			  "모두 선택",
			  "Embed 코드",
			  "링크 열기",
			  "링크 편집",
			  "No follow",
			  "링크 제거",
			  "사이트 확인",
			  "연필",
			  "갱신",
			  "URL",
			  "편집",
			  "수평 정렬",
			  "필터",
			  "변경일 정렬",
			  "이름 정렬",
			  "크기 정렬",
			  "새 폴더",
			  "초기화",
			  "저장",
			  "새로 저장하기 ...",
			  "리사이즈",
			  "크롭",
			  "가로 길이",
			  "세로 높이",
			  "비율 유지하기",
			  "네",
			  "아니오",
			  "제거",
			  "선택",
			  "문자수: %d",
			  "단어수: %d",
			  "모두",
			  "선택: %s",
			  "모두 선택",
			  "수직 정렬",
			  "분할",
			  "세로 셀 분할",
			  "가로 셀 분할",
			  "셀 병합",
			  "열 추가",
			  "행 추가",
			  "삭제",
			  "외곽선",
			  "라이센스: %s",
			  "취소선",
			  "밑줄",
			  "윗첨자",
			  "아래첨자",
			  "선택 잘라내기",
			  "구분자",
			  "검색",
			  "대체하기",
			  "대체",
			  "붙여넣기",
			  "붙여넣을 내용 선택",
			  "외부 이미지는 편집할 수 없어요. 외부 이미지를 다운로드 할까요?",
			  "이미지를 무사히 업로드 했어요!",
			  "팔레트",
			  "파일이 없어요",
			  "이름 변경",
			  "새 이름 입력",
			  "미리보기",
			  "다운로드",
			  "클립보드 붙여넣기",
			  "사용중인 브라우저가 클립보드 접근을 지원하지 않아요.",
			  "선택 복사",
			  "복사",
			  "둥근 테두리",
			  "모두 보기",
			  "적용",
			  "이 항목을 입력해주세요!",
			  "웹 URL을 입력해주세요.",
			  "기본",
			  "원",
			  "점",
			  "정사각형",
			  "찾기",
			  "이전 찾기",
			  "다음 찾기",
			  "className 입력",
			  "사용자 지정 크기 조정에 대 한 고도 누르십시오",
			];
		  },
		  26501: function (e) {
			e.exports.default = [
			  "Бичээд үзээрэй",
			  "Jodit-ын талаар ",
			  "Jodit програм",
			  null,
			  "Jodit гарын авлага",
			  "хэрэглээний талаар дэлгэрэнгүй мэдээллийг агуулна",
			  "Лицензийн мэдээллийг манай вэб хуудаснаас авна уу:",
			  "Бүрэн хувилбар худалдан авах",
			  "Зохиогчийн эрх хамгаалагдсан © XDSoft.net - Chupurnov Valeriy. Бүх эрхийг эзэмшинэ.",
			  "Холбоо барих",
			  "Шинэ табаар нээх",
			  "Бүтэн дэлгэцээр нээх",
			  "Форматыг арилгах",
			  "Өнгөөр будах эсвэл текстийн өнгө сонгох",
			  "Дахих",
			  "Буцаах",
			  "Тод",
			  "Налуу",
			  "Тэмдэгт жагсаалт нэмэх",
			  "Дугаарт жагсаалт нэмэх",
			  "Голлож байрлуулах",
			  "Тэгшитгэн байрлуулах",
			  "Зүүнд байрлуулах",
			  "Баруунд байрлуулах",
			  "Хэвтээ зураас нэмэх",
			  "Зураг нэмэх",
			  "Файл нэмэх",
			  "Youtube/Vimeo видео нэмэх",
			  "Холбоос нэмэх",
			  "Фонтын хэмжээ",
			  "Фонтын бүл",
			  "Блок нэмэх",
			  "Хэвийн",
			  "Гарчиг 1",
			  "Гарчиг 2",
			  "Гарчиг 3",
			  "Гарчиг 4",
			  "Ишлэл",
			  "Код",
			  "Оруулах",
			  "Хүснэгт оруулах",
			  "Доголын зай хасах",
			  "Доголын зай нэмэх",
			  "Тусгай тэмдэгт сонгох",
			  "Тусгай тэмдэгт нэмэх",
			  "Зургийн формат",
			  "Горим өөрчлөх",
			  "Цаасны зай",
			  "Дээрээс",
			  "Баруунаас",
			  "Доороос",
			  "Зүүнээс",
			  "CSS стиль",
			  "CSS анги",
			  "Байрлуулах",
			  "Баруун",
			  "Төв",
			  "Зүүн",
			  "--Тодорхойгүй--",
			  "Эх үүсвэр",
			  "Гарчиг",
			  "Алтернатив текст",
			  "Холбоос",
			  "Холбоосыг шинэ хавтсанд нээх",
			  "Зураг",
			  "Файл",
			  "Дэвшилтэт",
			  "Зургийн үзүүлэлт",
			  "Цуцлах",
			  "Ok",
			  "Таны код HTML кодтой адил байна. HTML форматаар үргэлжлүүлэх үү?",
			  "HTML байдлаар буулгах",
			  "Хадгалах",
			  "Цэвэрлэх",
			  "Текст байдлаар нэмэх",
			  "Зөвхөн текст оруулах",
			  "Word байдлаар буулгасан байна",
			  "Буулгасан агуулга Microsoft Word/Excel форматтай байна. Энэ форматыг хэвээр хадгалах уу эсвэл арилгах уу?",
			  "Файлын цонх",
			  "Жагсаалт татах үед алдаа гарлаа",
			  "Хавтас татах үед алдаа гарлаа",
			  "Итгэлтэй байна уу?",
			  "Хавтсын нэр оруулах",
			  "Хавтас үүсгэх",
			  "Нэр бичих",
			  "Зураг буулгах",
			  "Файл буулгах",
			  "эсвэл товш",
			  "Алтернатив текст",
			  "Үзэх",
			  "Байршуулах",
			  "Арын зураг",
			  "Текст",
			  "Дээр",
			  "Дунд",
			  "Доор",
			  "Урд нь багана нэмэх",
			  "Ард нь багана нэмэх",
			  "Дээр нь мөр нэмэх",
			  "Доор нь мөр нэмэх",
			  "Хүснэгт устгах",
			  "Мөр устгах",
			  "Багана устгах",
			  "Нүд цэвэрлэх",
			  "Эх үүсвэр",
			  "Тод",
			  "Налуу",
			  "Будах",
			  "Холбоос",
			  "Буцаах",
			  "Дахих",
			  "Хүснэгт",
			  "Зураг",
			  "Баллуур",
			  "Параграф",
			  "Фонтын хэмжээ",
			  "Видео",
			  "Фонт",
			  "Тухай",
			  "Хэвлэх",
			  "Доогуур зураас",
			  "Дээгүүр зураас",
			  "Догол нэмэх",
			  "Догол багасгах",
			  "Бүтэн дэлгэц",
			  "Багасга",
			  "Хаалт",
			  "Тэмдэгт жагсаалт",
			  "Дугаарласан жагсаалт",
			  "Таслах",
			  "Бүгдийг сонго",
			  "Код оруулах",
			  "Холбоос нээх",
			  "Холбоос засах",
			  "Nofollow özelliği",
			  "Холбоос салгах",
			  "Нүд",
			  "Засах",
			  "Шинэчлэх",
			  "URL",
			  "Засах",
			  "Хэвтээ эгнүүлэх",
			  "Шүүх",
			  "Сүүлд өөрчлөгдсөнөөр жагсаах",
			  "Нэрээр жагсаах",
			  "Хэмжээгээр жагсаах",
			  "Хавтас нэмэх",
			  "Буцаах",
			  "Хадгалах",
			  "Өөрөөр хадгалах",
			  "Хэмжээг өөрчил",
			  "Тайрах",
			  "Өргөн",
			  "Өндөр",
			  "Харьцааг хадгал",
			  "Тийм",
			  "Үгүй",
			  "Арилга",
			  "Сонго",
			  "Тэмдэгт: %d",
			  "Үг: %d",
			  "Бүгдийг",
			  "Сонго: %s",
			  "Бүгдийг сонго",
			  "Босоо эгнүүлэх",
			  "Задлах",
			  "Баганаар задлах",
			  "Мөрөөр задлах",
			  "Нэгтгэх",
			  "Багана нэмэх",
			  "Мөр нэмэх",
			  "Устгах",
			  "Хүрээ",
			  null,
			  "Дээгүүр зураас",
			  "Доогуур зураас",
			  "Дээд индекс",
			  "Доод индекс",
			  "Сонголтыг таслах",
			  "Мөрийг таслах",
			  "Хайх",
			  "Үүгээр солих",
			  "Солих",
			  "Буулгах",
			  "Буулгах агуулгаа сонгоно уу",
			  "Та зөвхөн өөрийн зургуудаа янзлах боломжтой. Энэ зургийг өөр лүүгээ татмаар байна уу?",
			  "Зургийг хост руу амжилттай хадгалсан",
			  "Палет",
			  "Энд ямар нэг файл алга",
			  "Шинээр нэрлэх",
			  "Шинэ нэр оруулна уу",
			  "Урьдчилан харах",
			  "Татах",
			  "Самбараас хуулах ",
			  "Энэ вэб хөтчөөс самбарт хандах эрх алга.",
			  "Сонголтыг хуул",
			  "Хуулах",
			  "Хүрээний радиус",
			  "Бүгдийг харуулах",
			  "Хэрэгжүүл",
			  "Энэ талбарыг бөглөнө үү",
			  "Вэб хаягаа оруулна уу",
			  "Үндсэн",
			  "Дугуй",
			  "Цэг",
			  "Дөрвөлжин",
			  "Хайх",
			  "Өмнөхийг ол",
			  "Дараагийнхийг ол",
			  "Бүлгийн нэрээ оруулна уу",
			  "Хэмжээсийг шинээр өөчрлөхийн тулд Alt товчин дээр дарна уу",
			];
		  },
		  17084: function (e) {
			e.exports.default = [
			  "Begin met typen..",
			  "Over Jodit",
			  "Jodit Editor",
			  "Gratis niet-commerciële versie",
			  "Jodit gebruikershandleiding",
			  "bevat gedetailleerde informatie voor gebruik.",
			  "Voor informatie over de licentie, ga naar onze website:",
			  "Volledige versie kopen",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Alle rechten voorbehouden.",
			  "Anker",
			  "Open in nieuwe tab",
			  "Editor in volledig scherm openen",
			  "Opmaak verwijderen",
			  "Vulkleur of tekstkleur aanpassen",
			  "Opnieuw",
			  "Ongedaan maken",
			  "Vet",
			  "Cursief",
			  "Geordende list invoegen",
			  "Ongeordende lijst invoegen",
			  "Centreren",
			  "Uitlijnen op volledige breedte",
			  "Links uitlijnen",
			  "Rechts uitlijnen",
			  "Horizontale lijn invoegen",
			  "Afbeelding invoegen",
			  "Bestand invoegen",
			  "Youtube/Vimeo video invoegen",
			  "Link toevoegen",
			  "Tekstgrootte",
			  "Lettertype",
			  "Format blok invoegen",
			  "Normaal",
			  "Koptekst 1",
			  "Koptekst 2",
			  "Koptekst 3",
			  "Koptekst 4",
			  "Citaat",
			  "Code",
			  "Invoegen",
			  "Tabel invoegen",
			  "Inspringing verkleinen",
			  "Inspringing vergroten",
			  "Symbool selecteren",
			  "Symbool invoegen",
			  "Opmaak kopieren",
			  "Modus veranderen",
			  "Marges",
			  "Boven",
			  "Rechts",
			  "Onder",
			  "Links",
			  "CSS styles",
			  "CSS classes",
			  "Uitlijning",
			  "Rechts",
			  "Gecentreerd",
			  "Links",
			  "--Leeg--",
			  "Src",
			  "Titel",
			  "Alternatieve tekst",
			  "Link",
			  "Link in nieuwe tab openen",
			  "Afbeelding",
			  "Bestand",
			  "Geavanceerd",
			  "Afbeeldingseigenschappen",
			  "Annuleren",
			  "OK",
			  "Deze code lijkt op HTML. Als HTML behouden?",
			  "Invoegen als HTML",
			  "Origineel behouden",
			  "Opschonen",
			  "Als tekst invoegen",
			  "Als onopgemaakte tekst invoegen",
			  "Word-tekst gedetecteerd",
			  "De geplakte tekst is afkomstig van een Microsoft Word/Excel document. Wil je de opmaak behouden of opschonen?",
			  "Bestandsbrowser",
			  "Fout bij het laden van de lijst",
			  "Fout bij het laden van de mappenlijst",
			  "Weet je het zeker?",
			  "Geef de map een naam",
			  "Map aanmaken",
			  "Type naam",
			  "Sleep hier een afbeelding naartoe",
			  "Sleep hier een bestand naartoe",
			  "of klik",
			  "Alternatieve tekst",
			  "Bladeren",
			  "Uploaden",
			  "Achtergrond",
			  "Tekst",
			  "Boven",
			  "Midden",
			  "Onder",
			  "Kolom invoegen (voor)",
			  "Kolom invoegen (na)",
			  "Rij invoegen (boven)",
			  "Rij invoegen (onder)",
			  "Tabel verwijderen",
			  "Rij verwijderen",
			  "Kolom verwijderen",
			  "Cel leegmaken",
			  "Broncode",
			  "vet",
			  "cursief",
			  "kwast",
			  "link",
			  "ongedaan maken",
			  "opnieuw",
			  "tabel",
			  "afbeelding",
			  "gum",
			  "paragraaf",
			  "lettergrootte",
			  "video",
			  "lettertype",
			  "over",
			  "afdrukken",
			  "onderstreept",
			  "doorgestreept",
			  "inspringen",
			  "minder inspringen",
			  "volledige grootte",
			  "kleiner maken",
			  "horizontale lijn",
			  "lijst",
			  "genummerde lijst",
			  "knip",
			  "alles selecteren",
			  "Embed code",
			  "link openen",
			  "link aanpassen",
			  "niet volgen",
			  "link verwijderen",
			  "Recensie",
			  "Om te bewerken",
			  "Updaten",
			  " URL",
			  "Bewerken",
			  "Horizontaal uitlijnen",
			  "Filteren",
			  "Sorteren op wijzigingsdatum",
			  "Sorteren op naam",
			  "Sorteren op grootte",
			  "Map toevoegen",
			  "Herstellen",
			  "Opslaan",
			  "Opslaan als ...",
			  "Grootte aanpassen",
			  "Bijknippen",
			  "Breedte",
			  "Hoogte",
			  "Verhouding behouden",
			  "Ja",
			  "Nee",
			  "Verwijderen",
			  "Selecteren",
			  "Tekens: %d",
			  "Woorden: %d",
			  "Alles",
			  "Selecteer: %s",
			  "Selecteer alles",
			  "Verticaal uitlijnen",
			  "Splitsen",
			  "Verticaal splitsen",
			  "Horizontaal splitsen",
			  "Samenvoegen",
			  "Kolom toevoegen",
			  "Rij toevoegen",
			  "Verwijderen",
			  "Rand",
			  null,
			  "Doorstrepen",
			  "Onderstrepen",
			  "Superscript",
			  "Subscript",
			  "Selectie knippen",
			  "Enter",
			  "Zoek naar",
			  "Vervangen door",
			  "Vervangen",
			  "Plakken",
			  "Kies content om te plakken",
			  "Je kunt alleen je eigen afbeeldingen aanpassen. Deze afbeelding downloaden?",
			  "De afbeelding is succesvol geüploadet!",
			  "Palette",
			  "Er zijn geen bestanden in deze map.",
			  "Hongaars",
			  "Voer een nieuwe naam in",
			  "voorvertoning",
			  "Download",
			  "Plakken van klembord",
			  "Uw browser ondersteunt geen directe toegang tot het klembord.",
			  "Selectie kopiëren",
			  "kopiëren",
			  "Border radius",
			  "Toon alle",
			  "Toepassing",
			  "Vul dit veld",
			  "Voer een webadres",
			  "Standaard",
			  "Cirkel",
			  "Dot",
			  "Quadrate",
			  "Zoeken",
			  "Vorige Zoeken",
			  "Volgende Zoeken",
			  "Voeg de klassenaam in",
			  "Druk op Alt voor aangepaste grootte",
			];
		  },
		  96891: function (e) {
			e.exports.default = [
			  "Napisz coś",
			  "O Jodit",
			  "Edytor Jodit",
			  null,
			  "Instrukcja Jodit",
			  "zawiera szczegółowe informacje dotyczące użytkowania.",
			  "Odwiedź naszą stronę, aby uzyskać więcej informacji na temat licencji:",
			  "Zakup pełnej wersji",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Wszystkie prawa zastrzeżone.",
			  "Kotwica",
			  "Otwórz w nowej zakładce",
			  "Otwórz edytor w pełnym rozmiarze",
			  "Wyczyść formatowanie",
			  "Kolor wypełnienia lub ustaw kolor tekstu",
			  "Ponów",
			  "Cofnij",
			  "Pogrubienie",
			  "Kursywa",
			  "Wstaw listę wypunktowaną",
			  "Wstaw listę numeryczną",
			  "Wyśrodkuj",
			  "Wyjustuj",
			  "Wyrównaj do lewej",
			  "Wyrównaj do prawej",
			  "Wstaw linię poziomą",
			  "Wstaw grafikę",
			  "Wstaw plik",
			  "Wstaw film Youtube/vimeo",
			  "Wstaw link",
			  "Rozmiar tekstu",
			  "Krój czcionki",
			  "Wstaw formatowanie",
			  "Normalne",
			  "Nagłówek 1",
			  "Nagłówek 2",
			  "Nagłówek 3",
			  "Nagłówek 4",
			  "Cytat",
			  "Kod",
			  "Wstaw",
			  "Wstaw tabelę",
			  "Zmniejsz wcięcie",
			  "Zwiększ wcięcie",
			  "Wybierz znak specjalny",
			  "Wstaw znak specjalny",
			  "Malarz formatów",
			  "Zmień tryb",
			  "Marginesy",
			  "Górny",
			  "Prawy",
			  "Dolny",
			  "Levy",
			  "Style CSS",
			  "Klasy CSS",
			  "Wyrównanie",
			  "Prawa",
			  "środek",
			  "Lewa",
			  "brak",
			  "Źródło",
			  "Tytuł",
			  "Tekst alternatywny",
			  "Link",
			  "Otwórz w nowej zakładce",
			  "Grafika",
			  "Plik",
			  "Zaawansowane",
			  "Właściwości grafiki",
			  "Anuluj",
			  "OK",
			  "Twój kod wygląda jak HTML. Zachować HTML?",
			  "Wkleić jako HTML?",
			  "Oryginalny tekst",
			  "Wyczyść",
			  "Wstaw jako tekst",
			  "Wstaw tylko treść",
			  "Wykryto tekst w formacie Word",
			  "Wklejany tekst pochodzi z dokumentu Microsoft Word/Excel. Chcesz zachować ten format czy wyczyścić go? ",
			  "Przeglądarka plików",
			  "Błąd ładowania listy plików",
			  "Błąd ładowania folderów",
			  "Czy jesteś pewien?",
			  "Wprowadź nazwę folderu",
			  "Utwórz folder",
			  "wprowadź nazwę",
			  "Upuść plik graficzny",
			  "Upuść plik",
			  "lub kliknij tu",
			  "Tekst alternatywny",
			  "Przeglądaj",
			  "Wczytaj",
			  "Tło",
			  "Treść",
			  "Góra",
			  "Środek",
			  "Dół",
			  "Wstaw kolumnę przed",
			  "Wstaw kolumnę po",
			  "Wstaw wiersz przed",
			  "Wstaw wiersz po",
			  "Usuń tabelę",
			  "Usuń wiersz",
			  "Usuń kolumnę",
			  "Wyczyść komórkę",
			  "HTML",
			  "pogrubienie",
			  "kursywa",
			  "pędzel",
			  "link",
			  "cofnij",
			  "ponów",
			  "tabela",
			  "grafika",
			  "wyczyść",
			  "akapit",
			  "rozmiar czcionki",
			  "wideo",
			  "czcionka",
			  "O programie",
			  "drukuj",
			  "podkreślenie",
			  "przekreślenie",
			  "wcięcie",
			  "wycięcie",
			  "pełen rozmiar",
			  "przytnij",
			  "linia pozioma",
			  "lista",
			  "lista numerowana",
			  "wytnij",
			  "zaznacz wszystko",
			  "Wstaw kod",
			  "otwórz link",
			  "edytuj link",
			  "Atrybut no-follow",
			  "Usuń link",
			  "szukaj",
			  "edytuj",
			  "Aktualizuj",
			  "URL",
			  "Edytuj",
			  "Wyrównywanie w poziomie",
			  "Filtruj",
			  "Sortuj wg zmiany",
			  "Sortuj wg nazwy",
			  "Sortuj wg rozmiaru",
			  "Dodaj folder",
			  "wyczyść",
			  "zapisz",
			  "zapisz jako",
			  "Zmień rozmiar",
			  "Przytnij",
			  "Szerokość",
			  "Wysokość",
			  "Zachowaj proporcje",
			  "Tak",
			  "Nie",
			  "Usuń",
			  "Wybierz",
			  "Znaki: %d",
			  "Słowa: %d",
			  "Wszystko",
			  "Wybierz: %s",
			  "Wybierz wszystko",
			  "Wyrównywanie w pionie",
			  "Podziel",
			  "Podziel w pionie",
			  "Podziel w poziomie",
			  "Scal",
			  "Dodaj kolumnę",
			  "Dodaj wiersz",
			  "Usuń",
			  "Obramowanie",
			  null,
			  "Przekreślenie",
			  "Podkreślenie",
			  "indeks górny",
			  "index dolny",
			  "Wytnij zaznaczenie",
			  "Przerwa",
			  "Szukaj",
			  "Zamień na",
			  "Wymienić",
			  "Wklej",
			  "Wybierz zawartość do wklejenia",
			  "Możesz edytować tylko swoje grafiki. Czy chcesz pobrać tą grafikę?",
			  "Grafika została pomyślnienie dodana na serwer",
			  "Paleta",
			  "Brak plików.",
			  "zmień nazwę",
			  "Wprowadź nową nazwę",
			  "podgląd",
			  "pobierz",
			  "Wklej ze schowka",
			  "Twoja przeglądarka nie obsługuje schowka",
			  "Kopiuj zaznaczenie",
			  "kopiuj",
			  "Zaokrąglenie krawędzi",
			  "Pokaż wszystkie",
			  "Zastosuj",
			  "Proszę wypełnić to pole",
			  "Proszę, wpisz adres sieci web",
			  "Domyślnie",
			  "Koło",
			  "Punkt",
			  "Kwadrat",
			  "Znaleźć",
			  "Znaleźć Poprzednie",
			  "Znajdź Dalej",
			  "Wstaw nazwę zajęć",
			  "Naciśnij Alt, aby zmienić rozmiar",
			];
		  },
		  31211: function (e) {
			e.exports.default = [
			  "Escreva algo...",
			  "Sobre o Jodit",
			  "Editor Jodit",
			  null,
			  "Guia de usuário Jodit",
			  "contém ajuda detalhada para o uso.",
			  "Para informação sobre a licença, por favor visite nosso site:",
			  "Compre a versão completa",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Todos os direitos reservados.",
			  "Link",
			  "Abrir em nova aba",
			  "Abrir editor em tela cheia",
			  "Limpar formatação",
			  "Cor de preenchimento ou cor do texto",
			  "Refazer",
			  "Desfazer",
			  "Negrito",
			  "Itálico",
			  "Inserir lista não ordenada",
			  "Inserir lista ordenada",
			  "Centralizar",
			  "Justificar",
			  "Alinhar à Esquerda",
			  "Alinhar à Direita",
			  "Inserir linha horizontal",
			  "Inserir imagem",
			  "Inserir arquivo",
			  "Inserir vídeo do Youtube/vimeo",
			  "Inserir link",
			  "Tamanho da letra",
			  "Fonte",
			  "Inserir bloco",
			  "Normal",
			  "Cabeçalho 1",
			  "Cabeçalho 2",
			  "Cabeçalho 3",
			  "Cabeçalho 4",
			  "Citação",
			  "Código",
			  "Inserir",
			  "Inserir tabela",
			  "Diminuir recuo",
			  "Aumentar recuo",
			  "Selecionar caractere especial",
			  "Inserir caractere especial",
			  "Copiar formato",
			  "Mudar modo",
			  "Margens",
			  "cima",
			  "direta",
			  "baixo",
			  "esquerda",
			  "Estilos CSS",
			  "Classes CSS",
			  "Alinhamento",
			  "Direita",
			  "Centro",
			  "Esquerda",
			  "--Não Estabelecido--",
			  "Fonte",
			  "Título",
			  "Texto Alternativo",
			  "Link",
			  "Abrir link em nova aba",
			  "Imagem",
			  "Arquivo",
			  "Avançado",
			  "Propriedades da imagem",
			  "Cancelar",
			  "Ok",
			  "Seu código é similar ao HTML. Manter como HTML?",
			  "Colar como HTML?",
			  "Manter",
			  "Limpar",
			  "Inserir como Texto",
			  "Inserir somente o Texto",
			  "Colado do Word Detectado",
			  "O conteúdo colado veio de um documento Microsoft Word/Excel. Você deseja manter o formato ou limpa-lo?",
			  "Procurar arquivo",
			  "Erro ao carregar a lista",
			  "Erro ao carregar as pastas",
			  "Você tem certeza?",
			  "Escreva o nome da pasta",
			  "Criar pasta",
			  "Escreva seu nome",
			  "Soltar imagem",
			  "Soltar arquivo",
			  "ou clique",
			  "Texto alternativo",
			  "Explorar",
			  "Upload",
			  "Fundo",
			  "Texto",
			  "Cima",
			  "Meio",
			  "Baixo",
			  "Inserir coluna antes",
			  "Inserir coluna depois",
			  "Inserir linha acima",
			  "Inserir linha abaixo",
			  "Excluir tabela",
			  "Excluir linha",
			  "Excluir coluna",
			  "Limpar célula",
			  "HTML",
			  "negrito",
			  "itálico",
			  "pincel",
			  "link",
			  "desfazer",
			  "refazer",
			  "tabela",
			  "imagem",
			  "apagar",
			  "parágrafo",
			  "tamanho da letra",
			  "vídeo",
			  "fonte",
			  "Sobre de",
			  "Imprimir",
			  "sublinhar",
			  "tachado",
			  "recuar",
			  "diminuir recuo",
			  "Tamanho completo",
			  "diminuir",
			  "linha horizontal",
			  "lista não ordenada",
			  "lista ordenada",
			  "Cortar",
			  "Selecionar tudo",
			  "Incluir código",
			  "Abrir link",
			  "Editar link",
			  "Não siga",
			  "Remover link",
			  "Visualizar",
			  "Editar",
			  "Atualizar",
			  "URL",
			  "Editar",
			  "Alinhamento horizontal",
			  "filtrar",
			  "Ordenar por modificação",
			  "Ordenar por nome",
			  "Ordenar por tamanho",
			  "Adicionar pasta",
			  "Resetar",
			  "Salvar",
			  "Salvar como...",
			  "Redimensionar",
			  "Recortar",
			  "Largura",
			  "Altura",
			  "Manter a proporção",
			  "Sim",
			  "Não",
			  "Remover",
			  "Selecionar",
			  "Caracteres: %d",
			  "Palavras: %d",
			  "Tudo",
			  "Selecionar: %s",
			  "Selecionar tudo",
			  "Alinhamento vertical",
			  "Dividir",
			  "Dividir vertical",
			  "Dividir horizontal",
			  "Mesclar",
			  "Adicionar coluna",
			  "Adicionar linha",
			  "Excluir",
			  "Borda",
			  null,
			  "Tachado",
			  "Sublinhar",
			  "sobrescrito",
			  "subscrito",
			  "Cortar seleção",
			  "Pausa",
			  "Procurar por",
			  "Substituir com",
			  "Substituir",
			  "Colar",
			  "Escolher conteúdo para colar",
			  "Você só pode editar suas próprias imagens. Baixar essa imagem pro servidor?",
			  "A imagem foi enviada com sucesso para o servidor!",
			  "Palette",
			  "Não há arquivos nesse diretório.",
			  "Húngara",
			  "Digite um novo nome",
			  "preview",
			  "Baixar",
			  "Colar da área de transferência",
			  "O seu navegador não oferece suporte a acesso direto para a área de transferência.",
			  "Selecção de cópia",
			  "cópia",
			  "Border radius",
			  "Mostrar todos os",
			  "Aplicar",
			  "Por favor, preencha este campo",
			  "Por favor introduza um endereço web",
			  "Padrão",
			  "Círculo",
			  "Ponto",
			  "Quadro",
			  "Encontrar",
			  "Encontrar Anteriores",
			  "Localizar Próxima",
			  "Insira o nome da classe",
			  "Pressione Alt para redimensionamento personalizado",
			];
		  },
		  31109: function (e) {
			e.exports.default = [
			  "Напишите что-либо",
			  "О Jodit",
			  "Редактор Jodit",
			  null,
			  "Jodit Руководство пользователя",
			  "содержит детальную информацию по использованию",
			  "Для получения сведений о лицензии , пожалуйста, перейдите на наш сайт:",
			  "Купить полную версию",
			  "Авторские права © XDSoft.net - Чупурнов Валерий. Все права защищены.",
			  "Анкор",
			  "Открывать ссылку в новой вкладке",
			  "Открыть редактор в полном размере",
			  "Очистить форматирование",
			  "Цвет заливки или цвет текста",
			  "Повтор",
			  "Отмена",
			  "Жирный",
			  "Наклонный",
			  "Вставка маркированного списка",
			  "Вставить нумерованный список",
			  "Выровнять по центру",
			  "Выровнять по ширине",
			  "Выровнять по левому краю",
			  "Выровнять по правому краю",
			  "Вставить горизонтальную линию",
			  "Вставить изображение",
			  "Вставить файл",
			  "Вставьте видео",
			  "Вставить ссылку",
			  "Размер шрифта",
			  "Шрифт",
			  "Вставить блочный элемент",
			  "Нормальный текст",
			  "Заголовок 1",
			  "Заголовок 2",
			  "Заголовок 3",
			  "Заголовок 4",
			  "Цитата",
			  "Код",
			  "Вставить",
			  "Вставить таблицу",
			  "Уменьшить отступ",
			  "Увеличить отступ",
			  "Выберите специальный символ",
			  "Вставить специальный символ",
			  "Формат краски",
			  "Источник",
			  "Отступы",
			  "сверху",
			  "справа",
			  "снизу",
			  "слева",
			  "Стили",
			  "Классы",
			  "Выравнивание",
			  "По правому краю",
			  "По центру",
			  "По левому краю",
			  "--не устанавливать--",
			  "src",
			  "Заголовок",
			  "Альтернативный текст (alt)",
			  "Ссылка",
			  "Открывать ссылку в новом окне",
			  null,
			  "Файл",
			  "Расширенные",
			  "Свойства изображения",
			  "Отмена",
			  "Ок",
			  "Ваш текст, который вы пытаетесь вставить похож на HTML. Вставить его как HTML?",
			  "Вставить как HTML?",
			  "Сохранить оригинал",
			  "Почистить",
			  "Вставить как текст",
			  "Вставить только текст",
			  "Возможно это фрагмент Word или Excel",
			  "Контент который вы вставляете поступает из документа Microsoft Word / Excel. Вы хотите сохранить формат или очистить его?",
			  "Браузер файлов",
			  "Ошибка при загрузке списка изображений",
			  "Ошибка при загрузке списка директорий",
			  "Вы уверены?",
			  "Введите название директории",
			  "Создать директорию",
			  "введите название",
			  "Перетащите сюда изображение",
			  "Перетащите сюда файл",
			  "или нажмите",
			  "Альтернативный текст",
			  "Сервер",
			  "Загрузка",
			  "Фон",
			  "Текст",
			  " К верху",
			  "По середине",
			  "К низу",
			  "Вставить столбец до",
			  "Вставить столбец после",
			  "Вставить ряд выше",
			  "Вставить ряд ниже",
			  "Удалить таблицу",
			  "Удалять ряд",
			  "Удалить столбец",
			  "Очистить ячейку",
			  "HTML",
			  "жирный",
			  "курсив",
			  "заливка",
			  "ссылка",
			  "отменить",
			  "повторить",
			  "таблица",
			  "Изображение",
			  "очистить",
			  "параграф",
			  "размер шрифта",
			  "видео",
			  "шрифт",
			  "о редакторе",
			  "печать",
			  "подчеркнутый",
			  "перечеркнутый",
			  "отступ",
			  "выступ",
			  "во весь экран",
			  "обычный размер",
			  "линия",
			  "Список",
			  "Нумерованный список",
			  "Вырезать",
			  "Выделить все",
			  "Код",
			  "Открыть ссылку",
			  "Редактировать ссылку",
			  "Атрибут nofollow",
			  "Убрать ссылку",
			  "Просмотр",
			  "Редактировать",
			  "Обновить",
			  "URL",
			  "Редактировать",
			  "Горизонтальное выравнивание",
			  "Фильтр",
			  "По изменению",
			  "По имени",
			  "По размеру",
			  "Добавить папку",
			  "Восстановить",
			  "Сохранить",
			  "Сохранить как",
			  "Изменить размер",
			  "Обрезать размер",
			  "Ширина",
			  "Высота",
			  "Сохранять пропорции",
			  "Да",
			  "Нет",
			  "Удалить",
			  "Выделить",
			  "Символов: %d",
			  "Слов: %d",
			  "Выделить все",
			  "Выделить: %s",
			  "Выделить все",
			  "Вертикальное выравнивание",
			  "Разделить",
			  "Разделить по вертикали",
			  "Разделить по горизонтали",
			  "Объединить в одну",
			  "Добавить столбец",
			  "Добавить строку",
			  "Удалить",
			  "Рамка",
			  "Лицензия: %s",
			  "Перечеркнуть",
			  "Подчеркивание",
			  "верхний индекс",
			  "индекс",
			  "Вырезать",
			  "Разделитель",
			  "Найти",
			  "Заменить на",
			  "Заменить",
			  "Вставить",
			  "Выбрать контент для вставки",
			  "Вы можете редактировать только свои собственные изображения. Загрузить это изображение на ваш сервер?",
			  "Изображение успешно загружено на сервер!",
			  "палитра",
			  "В данном каталоге нет файлов",
			  "Переименовать",
			  "Введите новое имя",
			  "Предпросмотр",
			  "Скачать",
			  "Вставить из буфера обмена",
			  "Ваш браузер не поддерживает прямой доступ к буферу обмена.",
			  "Скопировать выделенное",
			  "копия",
			  "Радиус границы",
			  "Показать все",
			  "Применить",
			  "Пожалуйста, заполните это поле",
			  "Пожалуйста, введите веб-адрес",
			  "По умолчанию",
			  "Круг",
			  "Точка",
			  "Квадрат",
			  "Найти",
			  "Найти Предыдущие",
			  "Найти Далее",
			  "Вставить название класса",
			  "Нажмите Alt для изменения пользовательского размера",
			];
		  },
		  79375: function (e) {
			e.exports.default = [
			  "Bir şeyler yaz",
			  "Jodit Hakkında",
			  "Jodit Editor",
			  null,
			  "Jodit Kullanım Kılavuzu",
			  "kullanım için detaylı bilgiler içerir",
			  "Lisans hakkında bilgi için lütfen web sitemize gidin:",
			  "Tam versiyonunu satın al",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. Tüm hakları saklıdır.",
			  "Bağlantı",
			  "Yeni sekmede aç",
			  "Editörü tam ekranda aç",
			  "Stili temizle",
			  "Renk doldur veya yazı rengi seç",
			  "Yinele",
			  "Geri Al",
			  "Kalın",
			  "İtalik",
			  "Sırasız Liste Ekle",
			  "Sıralı Liste Ekle",
			  "Ortala",
			  "Kenarlara Yasla",
			  "Sola Yasla",
			  "Sağa Yasla",
			  "Yatay Çizgi Ekle",
			  "Resim Ekle",
			  "Dosya Ekle",
			  "Youtube/Vimeo Videosu Ekle",
			  "Bağlantı Ekle",
			  "Font Boyutu",
			  "Font Ailesi",
			  "Blok Ekle",
			  "Normal",
			  "Başlık 1",
			  "Başlık 2",
			  "Başlık 3",
			  "Başlık 4",
			  "Alıntı",
			  "Kod",
			  "Ekle",
			  "Tablo Ekle",
			  "Girintiyi Azalt",
			  "Girintiyi Arttır",
			  "Özel Karakter Seç",
			  "Özel Karakter Ekle",
			  "Resim Biçimi",
			  "Mod Değiştir",
			  "Boşluklar",
			  "Üst",
			  "Sağ",
			  "Alt",
			  "Sol",
			  "CSS Stilleri",
			  "CSS Sınıfları",
			  "Hizalama",
			  "Sağ",
			  "Ortalı",
			  "Sol",
			  "Belirsiz",
			  "Kaynak",
			  "Başlık",
			  "Alternatif Yazı",
			  "Link",
			  "Bağlantıyı yeni sekmede aç",
			  "Resim",
			  "Dosya",
			  "Gelişmiş",
			  "Resim özellikleri",
			  "İptal",
			  "Tamam",
			  "Kodunuz HTML koduna benziyor. HTML olarak devam etmek ister misiniz?",
			  "HTML olarak yapıştır",
			  "Sakla",
			  "Temizle",
			  "Yazı olarak ekle",
			  "Sadece yazıyı ekle",
			  "Word biçiminde yapıştırma algılandı",
			  "Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format erhalten oder löschen?",
			  "Dosya Listeleyici",
			  "Liste yüklenirken hata oluştu",
			  "Klasörler yüklenirken hata oluştur",
			  "Emin misiniz?",
			  "Dizin yolu giriniz",
			  "Dizin oluştur",
			  "İsim yaz",
			  "Resim bırak",
			  "Dosya bırak",
			  "veya tıkla",
			  "Alternatif yazı",
			  "Gözat",
			  "Yükle",
			  "Arka plan",
			  "Yazı",
			  "Üst",
			  "Orta",
			  "Aşağı",
			  "Öncesine kolon ekle",
			  "Sonrasına kolon ekle",
			  "Üstüne satır ekle",
			  "Altına satır ekle",
			  "Tabloyu sil",
			  "Satırı sil",
			  "Kolonu sil",
			  "Hücreyi temizle",
			  "Kaynak",
			  "Kalın",
			  "italik",
			  "Fırça",
			  "Bağlantı",
			  "Geri al",
			  "Yinele",
			  "Tablo",
			  "Resim",
			  "Silgi",
			  "Paragraf",
			  "Font boyutu",
			  "Video",
			  "Font",
			  "Hakkında",
			  "Yazdır",
			  "Alt çizgi",
			  "Üstü çizili",
			  "Girinti",
			  "Çıkıntı",
			  "Tam ekran",
			  "Küçült",
			  "Ayraç",
			  "Sırasız liste",
			  "Sıralı liste",
			  "Kes",
			  "Tümünü seç",
			  "Kod ekle",
			  "Bağlantıyı aç",
			  "Bağlantıyı düzenle",
			  "Nofollow özelliği",
			  "Bağlantıyı kaldır",
			  "Yorumu",
			  "Düzenlemek için",
			  "Güncelle",
			  "URL",
			  "Düzenle",
			  "Yatay hizala",
			  "Filtre",
			  "Değişime göre sırala",
			  "İsme göre sırala",
			  "Boyuta göre sırala",
			  "Klasör ekle",
			  "Sıfırla",
			  "Kaydet",
			  "Farklı kaydet",
			  "Boyutlandır",
			  "Kırp",
			  "Genişlik",
			  "Yükseklik",
			  "En boy oranını koru",
			  "Evet",
			  "Hayır",
			  "Sil",
			  "Seç",
			  "Harfler: %d",
			  "Kelimeler: %d",
			  "Tümü",
			  "Seç: %s",
			  "Tümünü seç",
			  "Dikey hizala",
			  "Ayır",
			  "Dikey ayır",
			  "Yatay ayır",
			  "Birleştir",
			  "Kolon ekle",
			  "Satır ekle",
			  "Sil",
			  "Kenarlık",
			  null,
			  "Üstü çizili",
			  "Alt çizgi",
			  "Üst yazı",
			  "Alt yazı",
			  "Seçilimi kes",
			  "Satır sonu",
			  "Ara",
			  "Şununla değiştir",
			  "Değiştir",
			  "Yapıştır",
			  "Yapıştırılacak içerik seç",
			  "Sadece kendi resimlerinizi düzenleyebilirsiniz. Bu görseli kendi hostunuza indirmek ister misiniz?",
			  "Görsel başarıyla hostunuza yüklendi",
			  "Palet",
			  "Bu dizinde dosya yok",
			  "Yeniden isimlendir",
			  "Yeni isim girin",
			  "Ön izleme",
			  "İndir",
			  "Panodan yapıştır ",
			  "Tarayıcınız panoya doğrudan erişimi desteklemiyor.",
			  "Seçimi kopyala",
			  "Kopyala",
			  "Sınır yarıçapı",
			  "Tümünü Göster",
			  "Uygula",
			  "Lütfen bu alanı doldurun",
			  "Lütfen bir web adresi girin",
			  "Varsayılan",
			  "Daire",
			  "Nokta",
			  "Kare",
			  "Bul",
			  "Öncekini Bul",
			  "Sonrakini Bul",
			  "Sınıf adı girin",
			  "Özel yeniden boyutlandırma için Alt tuşuna basın",
			];
		  },
		  21042: function (e) {
			e.exports.default = [
			  "输入一些内容",
			  "关于Jodit",
			  "Jodit Editor",
			  "Free Non-commercial Version",
			  "开发者指南",
			  "使用帮助",
			  "有关许可证的信息，请访问我们的网站：",
			  "购买完整版本",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. 版权所有",
			  "Anchor",
			  "在新窗口打开",
			  "全屏编辑",
			  "清除样式",
			  "颜色",
			  "重做",
			  "撤销",
			  "粗体",
			  "斜体",
			  "符号列表",
			  "编号",
			  "居中",
			  "对齐文本",
			  "左对齐",
			  "右对齐",
			  "分割线",
			  "图片",
			  "文件",
			  "视频",
			  "链接",
			  "字号",
			  "字体",
			  "格式块",
			  "默认",
			  "标题1",
			  "标题2",
			  "标题3",
			  "标题4",
			  "引用",
			  "代码",
			  "插入",
			  "表格",
			  "减少缩进",
			  "增加缩进",
			  "选择特殊符号",
			  "特殊符号",
			  "格式复制",
			  "改变模式",
			  "外边距（Margins）",
			  "top",
			  "right",
			  "bottom",
			  "left",
			  "样式",
			  "Classes",
			  "对齐方式",
			  "居右",
			  "居中",
			  "居左",
			  "无",
			  "Src",
			  "Title",
			  "Alternative",
			  "Link",
			  "在新窗口打开链接",
			  "图片",
			  "file",
			  "高级",
			  "图片属性",
			  "取消",
			  "确定",
			  "你粘贴的文本是一段html代码，是否保留源格式",
			  "html粘贴",
			  "保留源格式",
			  "匹配目标格式",
			  "把html代码视为普通文本",
			  "只保留文本",
			  "文本粘贴",
			  "正在粘贴 Word/Excel 的文本，是否保留源格式？",
			  "文件管理",
			  "加载list错误",
			  "加载folders错误",
			  "你确定吗？",
			  "输入路径",
			  "创建路径",
			  "type name",
			  "拖动图片到此",
			  "拖动文件到此",
			  "或点击",
			  "Alternative text",
			  "浏览",
			  "上传",
			  "背景色",
			  "文字",
			  "顶部",
			  "中间",
			  "底部",
			  "在之前插入列",
			  "在之后插入列",
			  "在之前插入行",
			  "在之后插入行",
			  "删除表格",
			  "删除行",
			  "删除列",
			  "清除内容",
			  "源码",
			  "粗体",
			  "斜体",
			  "颜色",
			  "链接",
			  "撤销",
			  "重做",
			  "表格",
			  "图片",
			  "橡皮擦",
			  "段落",
			  "字号",
			  "视频",
			  "字体",
			  "关于",
			  "打印",
			  "下划线",
			  "上出现",
			  "增加缩进",
			  "减少缩进",
			  "全屏",
			  "收缩",
			  "分割线",
			  "无序列表",
			  "顺序列表",
			  "剪切",
			  "全选",
			  "嵌入代码",
			  "打开链接",
			  "编辑链接",
			  "No follow",
			  "取消链接",
			  "预览",
			  "铅笔",
			  "更新",
			  "URL",
			  "编辑",
			  "水平对齐",
			  "筛选",
			  "修改时间排序",
			  "名称排序",
			  "大小排序",
			  "新建文件夹",
			  "重置",
			  "保存",
			  "保存为",
			  "调整大小",
			  "剪切",
			  "宽",
			  "高",
			  "保持长宽比",
			  "是",
			  "不",
			  "移除",
			  "选择",
			  "字符数: %d",
			  "单词数: %d",
			  "全部",
			  "选择: %s",
			  "全选",
			  "垂直对齐",
			  "拆分",
			  "拆分两列",
			  "拆分两行",
			  "合并",
			  "添加列",
			  "添加行",
			  "删除",
			  "边框",
			  null,
			  "删除线",
			  "下划线",
			  "上标",
			  "下标",
			  "剪切",
			  "Break",
			  "查找",
			  "替换为",
			  "替换",
			  "粘贴",
			  "选择内容并粘贴",
			  "你只能编辑你自己的图片。Download this image on the host?",
			  "图片上传成功",
			  "调色板",
			  "此目录中沒有文件。",
			  "重命名",
			  "输入新名称",
			  "预览",
			  "下载",
			  "粘贴从剪贴板",
			  "你浏览器不支持直接访问的剪贴板。",
			  "复制选中内容",
			  "复制",
			  "边界半径",
			  "显示所有",
			  "应用",
			  "请填写这个字段",
			  "请输入一个网址",
			  "默认",
			  "圆圈",
			  "点",
			  "方形",
			  "搜索",
			  "查找上一个",
			  "查找下一个",
			  "插入班级名称",
			  "按Alt自定义调整大小",
			];
		  },
		  73895: function (e) {
			e.exports.default = [
			  "輸入一些內容",
			  "關於Jodit",
			  "Jodit Editor",
			  null,
			  "開發者指南",
			  "使用幫助",
			  "有關許可證的信息，請訪問我們的網站：",
			  "購買完整版本",
			  "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
			  "Anchor",
			  "在新窗口打開",
			  "全屏編輯",
			  "清除樣式",
			  "顏色",
			  "重做",
			  "撤銷",
			  "粗體",
			  "斜體",
			  "符號列表",
			  "編號",
			  "居中",
			  "對齊文本",
			  "左對齊",
			  "右對齊",
			  "分割線",
			  "圖片",
			  "文件",
			  "youtube/vimeo 影片",
			  "鏈接",
			  "字號",
			  "字體",
			  "格式塊",
			  "文本",
			  "標題1",
			  "標題2",
			  "標題3",
			  "標題4",
			  "引用",
			  "代碼",
			  "插入",
			  "表格",
			  "減少縮進",
			  "增加縮進",
			  "選擇特殊符號",
			  "特殊符號",
			  "格式複製",
			  "改變模式",
			  "外邊距（Margins）",
			  "top",
			  "right",
			  "bottom",
			  "left",
			  "樣式",
			  "Classes",
			  "對齊方式",
			  "居右",
			  "居中",
			  "居左",
			  "無",
			  "Src",
			  "Title",
			  "替代",
			  "Link",
			  "在新窗口打開鏈接",
			  "圖片",
			  "file",
			  "高級",
			  "圖片屬性",
			  "取消",
			  "確定",
			  "你黏貼的文本是一段html代碼，是否保留源格式",
			  "html黏貼",
			  "保留源格式",
			  "匹配目標格式",
			  "把html代碼視為普通文本",
			  "只保留文本",
			  "文本黏貼",
			  "正在黏貼 Word/Excel 的文本，是否保留源格式？",
			  "文件管理",
			  "加載list錯誤",
			  "加載folders錯誤",
			  "你確定嗎？",
			  "輸入路徑",
			  "創建路徑",
			  "type name",
			  "拖動圖片到此",
			  "拖動文件到此",
			  "或點擊",
			  "替代文字",
			  "瀏覽",
			  "上傳",
			  "背景色",
			  "文字",
			  "頂部",
			  "中間",
			  "底部",
			  "在之前插入列",
			  "在之後插入列",
			  "在之前插入行",
			  "在之後插入行",
			  "刪除表格",
			  "刪除行",
			  "刪除列",
			  "清除內容",
			  "源碼",
			  "粗體",
			  "斜體",
			  "顏色",
			  "鏈接",
			  "撤銷",
			  "重做",
			  "表格",
			  "圖片",
			  "橡皮擦",
			  "段落",
			  "字號",
			  "影片",
			  "字體",
			  "關於",
			  "打印",
			  "下劃線",
			  "上出現",
			  "增加縮進",
			  "減少縮進",
			  "全屏",
			  "收縮",
			  "分割線",
			  "無序列表",
			  "順序列表",
			  "剪切",
			  "全選",
			  "嵌入代碼",
			  "打開鏈接",
			  "編輯鏈接",
			  "No follow",
			  "取消連結",
			  "回顧",
			  "鉛筆",
			  "更新",
			  "URL",
			  null,
			  "水平對齊",
			  "篩選",
			  "修改時間排序",
			  "名稱排序",
			  "大小排序",
			  "新建文件夾",
			  "重置",
			  "保存",
			  "保存為",
			  "調整大小",
			  "Crop",
			  "寬",
			  "高",
			  "保存長寬比",
			  "是",
			  "不",
			  "移除",
			  "選擇",
			  "字符數: %d",
			  "單詞數: %d",
			  "全部",
			  "選擇: %s",
			  "全選",
			  "垂直對齊",
			  "拆分",
			  "拆分两列",
			  "拆分两行",
			  "合併",
			  "添加列",
			  "添加行",
			  "刪除",
			  "邊框",
			  null,
			  "刪除線",
			  "下劃線",
			  "上標",
			  "下標",
			  "剪切",
			  "Pause",
			  "查找",
			  "替換為",
			  "แทนที่",
			  "黏貼",
			  "選擇內容並黏貼",
			  "你只能編輯你自己的圖片。是否下載此圖片到本地?",
			  "圖片上傳成功",
			  "調色板",
			  "此目錄中沒有文件。",
			  "重命名",
			  "輸入新名稱",
			  "預覽",
			  "下載",
			  "從剪貼板貼上",
			  "瀏覽器無法存取剪贴板。",
			  "複製已選取項目",
			  "複製",
			  "邊框圓角",
			  "顯示所有",
			  "應用",
			  "ได้โปรดกรอกช่องข้อมูลนี้",
			  "โปรดเติมที่อยู่บนเว็บ",
			  "ค่าปริยาย",
			  "วงกลม",
			  "จุด",
			  "Quadrate",
			  "ค้นหา",
			  "ค้นหาก่อนหน้านี้",
			  "ค้นหาถัดไป",
			  "ใส่ชื่อคลาส",
			  "กดอัลท์สำหรับการปรับขนาดที่กำหนดเอง",
			];
		  },
		  3610: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M621 1280h595v-595zm-45-45l595-595h-595v595zm1152 77v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z"/> </svg>';
		  },
		  56170: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <g transform="translate(-251.000000, -443.000000)"> <g transform="translate(215.000000, 119.000000)"/> <path d="M252,448 L256,448 L256,444 L252,444 L252,448 Z M257,448 L269,448 L269,446 L257,446 L257,448 Z M257,464 L269,464 L269,462 L257,462 L257,464 Z M270,444 L270,448 L274,448 L274,444 L270,444 Z M252,462 L252,466 L256,466 L256,462 L252,462 Z M270,462 L270,466 L274,466 L274,462 L270,462 Z M254,461 L256,461 L256,449 L254,449 L254,461 Z M270,461 L272,461 L272,449 L270,449 L270,461 Z"/> </g> </svg>';
		  },
		  95331: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' x="0px" y="0px" viewBox="0 0 459 459"> <g> <path d="M229.5,0C102,0,0,102,0,229.5S102,459,229.5,459c20.4,0,38.25-17.85,38.25-38.25c0-10.2-2.55-17.85-10.2-25.5 c-5.1-7.65-10.2-15.3-10.2-25.5c0-20.4,17.851-38.25,38.25-38.25h45.9c71.4,0,127.5-56.1,127.5-127.5C459,91.8,357,0,229.5,0z M89.25,229.5c-20.4,0-38.25-17.85-38.25-38.25S68.85,153,89.25,153s38.25,17.85,38.25,38.25S109.65,229.5,89.25,229.5z M165.75,127.5c-20.4,0-38.25-17.85-38.25-38.25S145.35,51,165.75,51S204,68.85,204,89.25S186.15,127.5,165.75,127.5z M293.25,127.5c-20.4,0-38.25-17.85-38.25-38.25S272.85,51,293.25,51s38.25,17.85,38.25,38.25S313.65,127.5,293.25,127.5z M369.75,229.5c-20.4,0-38.25-17.85-38.25-38.25S349.35,153,369.75,153S408,170.85,408,191.25S390.15,229.5,369.75,229.5z" /> </g> </svg>';
		  },
		  84279: function (e) {
			e.exports =
			  '<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"> <path d="M1088 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zm316-600q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z"/> </svg>';
		  },
		  11257: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 128 128" xml:space="preserve"> <polygon points="112.4560547,23.3203125 112.4560547,75.8154297 31.4853516,75.8154297 31.4853516,61.953125 16.0131836,72.6357422 0.5410156,83.3164063 16.0131836,93.9990234 31.4853516,104.6796875 31.4853516,90.8183594 112.4560547,90.8183594 112.4560547,90.8339844 127.4589844,90.8339844 127.4589844,23.3203125"/> </svg>';
		  },
		  25141: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"/> </svg>';
		  },
		  24557: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"/> </svg>';
		  },
		  10859: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zm-1277-64q-28-35-51-80-48-97-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zm507 256h411q7 39 7 92 0 111-41 212-23 55-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"/> </svg>';
		  },
		  9813: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm639 217v206h-514l-4-27q-3-45-3-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 80-65 188-65 110 0 178 59.5t68 158.5q0 66-34.5 118.5t-84 86-99.5 62.5-87 63-41 73h232v-80h126z"/> </svg>';
		  },
		  93395: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm637-679v206h-514l-3-27q-4-28-4-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 83-65 188-65 110 0 178 59.5t68 158.5q0 56-24.5 103t-62 76.5-81.5 58.5-82 50.5-65.5 51.5-30.5 63h232v-80h126z"/> </svg>';
		  },
		  98213: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M176 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 .5 32.5t.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zm1488 1409v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"/> </svg>';
		  },
		  20026: function (e) {
			e.exports =
			  '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path d="M36 4h-24c-2.21 0-4 1.79-4 4v32c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-32c0-2.21-1.79-4-4-4zm-24 4h10v16l-5-3-5 3v-16z"/> </svg>';
		  },
		  66911: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M832 1408l336-384h-768l-336 384h768zm1013-1077q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"/> </svg>';
		  },
		  50018: function (e) {
			e.exports =
			  '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"> <path d="M24.89,6.61H22.31V4.47A2.47,2.47,0,0,0,19.84,2H6.78A2.47,2.47,0,0,0,4.31,4.47V22.92a2.47,2.47,0,0,0,2.47,2.47H9.69V27.2a2.8,2.8,0,0,0,2.8,2.8h12.4a2.8,2.8,0,0,0,2.8-2.8V9.41A2.8,2.8,0,0,0,24.89,6.61ZM6.78,23.52a.61.61,0,0,1-.61-.6V4.47a.61.61,0,0,1,.61-.6H19.84a.61.61,0,0,1,.61.6V6.61h-8a2.8,2.8,0,0,0-2.8,2.8V23.52Zm19,3.68a.94.94,0,0,1-.94.93H12.49a.94.94,0,0,1-.94-.93V9.41a.94.94,0,0,1,.94-.93h12.4a.94.94,0,0,1,.94.93Z"/> <path d="M23.49,13.53h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z"/> <path d="M23.49,17.37h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z"/> <path d="M23.49,21.22h-9.6a.93.93,0,1,0,0,1.86h9.6a.93.93,0,1,0,0-1.86Z"/> </svg>';
		  },
		  99738: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zm300 64l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zm-681-260q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zm-85 745q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zm178-613l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zm224 224l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zm704 416l128-64-520-408-177 138q-2 3-13 7z"/> </svg>';
		  },
		  9185: function (e) {
			e.exports =
			  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"> <path stroke-width="0" d="M10.5 20H2a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1V3l2.03-.4a3 3 0 0 1 5.94 0L13 3v1h1a2 2 0 0 1 2 2v1h-2V6h-1v1H3V6H2v12h5v2h3.5zM8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2 4h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2zm0 2v8h8v-8h-8z"/> </svg>';
		  },
		  8619: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 18 18"> <g fill-rule="evenodd" stroke="none" stroke-width="1"> <g transform="translate(-381.000000, -381.000000)"> <g transform="translate(381.000000, 381.000000)"> <path d="M0,2 L2,2 L2,0 C0.9,0 0,0.9 0,2 L0,2 Z M0,10 L2,10 L2,8 L0,8 L0,10 L0,10 Z M4,18 L6,18 L6,16 L4,16 L4,18 L4,18 Z M0,6 L2,6 L2,4 L0,4 L0,6 L0,6 Z M10,0 L8,0 L8,2 L10,2 L10,0 L10,0 Z M16,0 L16,2 L18,2 C18,0.9 17.1,0 16,0 L16,0 Z M2,18 L2,16 L0,16 C0,17.1 0.9,18 2,18 L2,18 Z M0,14 L2,14 L2,12 L0,12 L0,14 L0,14 Z M6,0 L4,0 L4,2 L6,2 L6,0 L6,0 Z M8,18 L10,18 L10,16 L8,16 L8,18 L8,18 Z M16,10 L18,10 L18,8 L16,8 L16,10 L16,10 Z M16,18 C17.1,18 18,17.1 18,16 L16,16 L16,18 L16,18 Z M16,6 L18,6 L18,4 L16,4 L16,6 L16,6 Z M16,14 L18,14 L18,12 L16,12 L16,14 L16,14 Z M12,18 L14,18 L14,16 L12,16 L12,18 L12,18 Z M12,2 L14,2 L14,0 L12,0 L12,2 L12,2 Z M4,14 L14,14 L14,4 L4,4 L4,14 L4,14 Z M6,6 L12,6 L12,12 L6,12 L6,6 L6,6 Z"/> </g> </g> </g> </svg>';
		  },
		  73894: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M896 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zm512-128q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z"/> </svg>';
		  },
		  83301: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 16 16"> <path stroke-width="0" d="M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"/> </svg>';
		  },
		  84142: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M789 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 4-.5 13t-.5 13q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z"/> </svg>';
		  },
		  57292: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1744 1408q33 0 42 18.5t-11 44.5l-126 162q-20 26-49 26t-49-26l-126-162q-20-26-11-44.5t42-18.5h80v-1024h-80q-33 0-42-18.5t11-44.5l126-162q20-26 49-26t49 26l126 162q20 26 11 44.5t-42 18.5h-80v1024h80zm-1663-1279l54 27q12 5 211 5 44 0 132-2t132-2q36 0 107.5.5t107.5.5h293q6 0 21 .5t20.5 0 16-3 17.5-9 15-17.5l42-1q4 0 14 .5t14 .5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-48t-14.5-73.5-7.5-35.5q-6-8-12-12.5t-15.5-6-13-2.5-18-.5-16.5.5q-17 0-66.5-.5t-74.5-.5-64 2-71 6q-9 81-8 136 0 94 2 388t2 455q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q19-42 19-383 0-101-3-303t-3-303v-117q0-2 .5-15.5t.5-25-1-25.5-3-24-5-14q-11-12-162-12-33 0-93 12t-80 26q-19 13-34 72.5t-31.5 111-42.5 53.5q-42-26-56-44v-383z"/> </svg>';
		  },
		  18019: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M1534 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z"/></svg>';
		  },
		  45146: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <path stroke-width="0" d="M22,20.6L3.4,2H8V0H0v8h2V3.4L20.6,22H16v2h8v-8h-2V20.6z M16,0v2h4.7l-6.3,6.3l1.4,1.4L22,3.5V8h2V0H16z M8.3,14.3L2,20.6V16H0v8h8v-2H3.5l6.3-6.3L8.3,14.3z"/> </svg>';
		  },
		  53576: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M896 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zm755-672q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z"/> </svg>';
		  },
		  14655: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1600 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"/> </svg>';
		  },
		  53477: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"/> </svg>';
		  },
		  90053: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M352 832q0 14-9 23l-288 288q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-576q0-13 9.5-22.5t22.5-9.5q14 0 23 9l288 288q9 9 9 23zm1440 480v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
		  },
		  72230: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zm1408 768v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
		  },
		  78321: function (e) {
			e.exports =
			  '<svg viewBox="0 0 18.151 18.151" xmlns="http://www.w3.org/2000/svg"> <g> <path stroke-width="0" d="M6.237,16.546H3.649V1.604h5.916v5.728c0.474-0.122,0.968-0.194,1.479-0.194 c0.042,0,0.083,0.006,0.125,0.006V0H2.044v18.15h5.934C7.295,17.736,6.704,17.19,6.237,16.546z"/> <path stroke-width="0" d="M11.169,8.275c-2.723,0-4.938,2.215-4.938,4.938s2.215,4.938,4.938,4.938s4.938-2.215,4.938-4.938 S13.892,8.275,11.169,8.275z M11.169,16.81c-1.983,0-3.598-1.612-3.598-3.598c0-1.983,1.614-3.597,3.598-3.597 s3.597,1.613,3.597,3.597C14.766,15.198,13.153,16.81,11.169,16.81z"/> <polygon stroke-width="0" points="11.792,11.073 10.502,11.073 10.502,12.578 9.03,12.578 9.03,13.868 10.502,13.868 10.502,15.352 11.792,15.352 11.792,13.868 13.309,13.868 13.309,12.578 11.792,12.578 "/> </g> </svg>';
		  },
		  77654: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 432 432"> <g> <polygon points="203.688,96 0,96 0,144 155.688,144 "/> <polygon points="155.719,288 0,288 0,336 203.719,336 "/> <path d="M97.844,230.125c-3.701-3.703-5.856-8.906-5.856-14.141s2.154-10.438,5.856-14.141l9.844-9.844H0v48h107.719 L97.844,230.125z"/> <polygon points="232,176 232,96 112,216 232,336 232,256 432,256 432,176"/> </g> </svg>';
		  },
		  43371: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 312 312"> <g transform="translate(0.000000,312.000000) scale(0.100000,-0.100000)" stroke="none"> <path d="M50 3109 c0 -7 -11 -22 -25 -35 l-25 -23 0 -961 0 -961 32 -29 32 -30 501 -2 500 -3 3 -502 2 -502 31 -30 31 -31 958 0 958 0 23 25 c13 13 30 25 37 25 9 0 12 199 12 960 0 686 -3 960 -11 960 -6 0 -24 12 -40 28 l-29 27 -503 5 -502 5 -5 502 -5 503 -28 29 c-15 16 -27 34 -27 40 0 8 -274 11 -960 11 -710 0 -960 -3 -960 -11z m1738 -698 l2 -453 -40 -40 c-22 -22 -40 -43 -40 -47 0 -4 36 -42 79 -85 88 -87 82 -87 141 -23 l26 27 455 -2 454 -3 0 -775 0 -775 -775 0 -775 0 -3 450 -2 449 47 48 47 48 -82 80 c-44 44 -84 80 -87 80 -3 0 -25 -18 -48 -40 l-41 -40 -456 2 -455 3 -3 765 c-1 421 0 771 3 778 3 10 164 12 777 10 l773 -3 3 -454z"/> <path d="M607 2492 c-42 -42 -77 -82 -77 -87 0 -6 86 -96 190 -200 105 -104 190 -197 190 -205 0 -8 -41 -56 -92 -107 -65 -65 -87 -94 -77 -98 8 -3 138 -4 289 -3 l275 3 3 275 c1 151 0 281 -3 289 -4 10 -35 -14 -103 -82 -54 -53 -103 -97 -109 -97 -7 0 -99 88 -206 195 -107 107 -196 195 -198 195 -3 0 -39 -35 -82 -78z"/> <path d="M1470 1639 c-47 -49 -87 -91 -89 -94 -5 -6 149 -165 160 -165 9 0 189 179 189 188 0 12 -154 162 -165 161 -6 0 -48 -41 -95 -90z"/> <path d="M1797 1303 c-9 -8 -9 -568 0 -576 4 -4 50 36 103 88 54 52 101 95 106 95 5 0 95 -85 199 -190 104 -104 194 -190 200 -190 6 0 46 36 90 80 l79 79 -197 196 c-108 108 -197 199 -197 203 0 4 45 52 99 106 55 55 98 103 95 108 -6 10 -568 11 -577 1z"/> </g> </svg>';
		  },
		  44563: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 48 48"> <path d="M6 42h4v-4h-4v4zm4-28h-4v4h4v-4zm-4 20h4v-4h-4v4zm8 8h4v-4h-4v4zm-4-36h-4v4h4v-4zm8 0h-4v4h4v-4zm16 0h-4v4h4v-4zm-8 8h-4v4h4v-4zm0-8h-4v4h4v-4zm12 28h4v-4h-4v4zm-16 8h4v-4h-4v4zm-16-16h36v-4h-36v4zm32-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-16 16h4v-4h-4v4zm8 8h4v-4h-4v4zm8 0h4v-4h-4v4z"/> <path d="M0 0h48v48h-48z" fill="none"/> </svg>';
		  },
		  53183: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 48 48"> <path d="M6 18h4v-4h-4v4zm0-8h4v-4h-4v4zm8 32h4v-4h-4v4zm0-16h4v-4h-4v4zm-8 0h4v-4h-4v4zm0 16h4v-4h-4v4zm0-8h4v-4h-4v4zm8-24h4v-4h-4v4zm24 24h4v-4h-4v4zm-16 8h4v-36h-4v36zm16 0h4v-4h-4v4zm0-16h4v-4h-4v4zm0-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-8-8h4v-4h-4v4zm0 32h4v-4h-4v4zm0-16h4v-4h-4v4z"/> <path d="M0 0h48v48h-48z" fill="none"/> </svg>';
		  },
		  18548: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm-1280-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z"/> </svg>';
		  },
		  52242: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68z"/> </svg>';
		  },
		  87498: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45z"/> </svg>';
		  },
		  7986: function (e) {
			e.exports =
			  '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path d="M5.09668 6.99707H7.17358L4.17358 3.99707L1.17358 6.99707H3.09668V17.0031H1.15881L4.15881 20.0031L7.15881 17.0031H5.09668V6.99707Z"/> <path d="M22.8412 7H8.84119V5H22.8412V7Z"/> <path d="M22.8412 11H8.84119V9H22.8412V11Z"/> <path d="M8.84119 15H22.8412V13H8.84119V15Z"/> <path d="M22.8412 19H8.84119V17H22.8412V19Z"/> </svg>';
		  },
		  23075: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"/> </svg>';
		  },
		  10655: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"/> </svg>';
		  },
		  15476: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path stroke-width="0" d="M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
		  },
		  59403: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path stroke-width="0" d="M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
		  },
		  22860: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"/> </svg>';
		  },
		  95600: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 14 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"/> </svg>';
		  },
		  76214: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"/> </svg>';
		  },
		  41197: function (e) {
			e.exports =
			  '<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg"> <path clip-rule="evenodd" d="M306.39,154.09c19.628,4.543,35.244,21.259,39.787,39.523 c1.551,8.54,8.998,14.989,17.904,14.989c9.991,0,18.168-8.175,18.168-18.17c0-13.083-10.991-32.98-25.985-47.881 c-14.719-14.537-32.252-24.802-46.695-24.802c-9.991,0-18.172,8.45-18.172,18.446C291.396,145.094,297.847,152.546,306.39,154.09z M56.629,392.312c-14.09,14.08-14.09,36.979,0,51.059c14.08,14.092,36.981,14.092,50.965,0l104.392-104.303 c24.347,15.181,53.062,23.991,83.953,23.991c87.857,0,158.995-71.142,158.995-158.999c0-87.854-71.138-158.995-158.995-158.995 c-87.856,0-158.995,71.141-158.995,158.995c0,30.802,8.819,59.606,23.992,83.953L56.629,392.312z M182.371,204.06 c0-62.687,50.875-113.568,113.568-113.568s113.569,50.881,113.569,113.568c0,62.694-50.876,113.569-113.569,113.569 S182.371,266.754,182.371,204.06z" fill-rule="evenodd"/> </svg>';
		  },
		  9342: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M553 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zm591-1067l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zm657 651l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"/> </svg>';
		  },
		  69546: function (e) {
			e.exports =
			  '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path d="M24.89 32h4.18L18.86 6h-3.71L4.93 32h4.18l2.25-6h11.29l2.24 6zM12.86 22L17 10.95 21.14 22h-8.28zm30.31 1.17L27 39.34 19.66 32l-2.83 2.83L27 45l19-19-2.83-2.83z"/> </svg>';
		  },
		  43158: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 270 270"> <path d="m240.443652,220.45085l-47.410809,0l0,-10.342138c13.89973,-8.43655 25.752896,-19.844464 34.686646,-33.469923c11.445525,-17.455846 17.496072,-37.709239 17.496072,-58.570077c0,-59.589197 -49.208516,-108.068714 -109.693558,-108.068714s-109.69263,48.479517 -109.69263,108.069628c0,20.860839 6.050547,41.113316 17.497001,58.570077c8.93375,13.625459 20.787845,25.032458 34.686646,33.469008l0,10.342138l-47.412666,0c-10.256959,0 -18.571354,8.191376 -18.571354,18.296574c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.98402,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574l0,-39.496814c0,-7.073455 -4.137698,-13.51202 -10.626529,-16.537358c-25.24497,-11.772016 -41.557118,-37.145704 -41.557118,-64.643625c0,-39.411735 32.545369,-71.476481 72.549922,-71.476481c40.004553,0 72.550851,32.064746 72.550851,71.476481c0,27.497006 -16.312149,52.87161 -41.557118,64.643625c-6.487902,3.026253 -10.6256,9.464818 -10.6256,16.537358l0,39.496814c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.982163,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574c0,-10.105198 -8.314395,-18.296574 -18.571354,-18.296574z"/> </svg>';
		  },
		  51716: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M576 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"/> </svg>';
		  },
		  49222: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z"/> </svg>';
		  },
		  1755: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"/> </svg>';
		  },
		  74911: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"/> </svg>';
		  },
		  8805: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"/> </svg>';
		  },
		  16547: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1395 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"/> </svg>';
		  },
		  10856: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/> </svg>';
		  },
		  98441: function (e) {
			e.exports =
			  '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"> <g stroke="none" stroke-width="1"> <path d="M14,1.4 L12.6,0 L7,5.6 L1.4,0 L0,1.4 L5.6,7 L0,12.6 L1.4,14 L7,8.4 L12.6,14 L14,12.6 L8.4,7 L14,1.4 Z"/> </g> </svg>';
		  },
		  52488: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"/> </svg>';
		  },
		  9370: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"/> </svg>';
		  },
		  66543: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 10 10"> <path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/> </svg>';
		  },
		  608: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24" > <circle cx="12" cy="12" r="2.2"/> <circle cx="12" cy="5" r="2.2"/> <circle cx="12" cy="19" r="2.2"/> </svg>';
		  },
		  42840: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z"/> </svg>';
		  },
		  79096: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1152 512v-472q22 14 36 28l408 408q14 14 28 36h-472zm-128 32q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544z"/> </svg>';
		  },
		  33014: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1728 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"/> </svg>';
		  },
		  91677: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"/> </svg>';
		  },
		  8259: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/> </svg>';
		  },
		  64467: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"/></svg>';
		  },
		  86934: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 32 32"> <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"/> </svg>';
		  },
		  76133: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"/></svg>';
		  },
		  45519: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"/></svg>';
		  },
		  90265: function (e) {
			e.exports =
			  '<svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg"> <path d="M5.9814 11.8049C5.59087 11.4144 5.59087 10.7812 5.9814 10.3907L10.224 6.14806C10.6146 5.75754 11.2477 5.75754 11.6383 6.14806C12.0288 6.53859 12.0288 7.17175 11.6383 7.56228L7.39561 11.8049C7.00509 12.1954 6.37192 12.1954 5.9814 11.8049Z"/> <path d="M0.707107 12.0208C0.316582 11.6303 0.316582 10.9971 0.707107 10.6066L10.6066 0.707121C10.9971 0.316597 11.6303 0.316596 12.0208 0.707121C12.4113 1.09764 12.4113 1.73081 12.0208 2.12133L2.12132 12.0208C1.7308 12.4114 1.09763 12.4114 0.707107 12.0208Z"/> </svg>';
		  },
		  81279: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/> </svg>';
		  },
		  68899: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1536h768v-384h-768v384zm896 0h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zm-384-928v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zm640 32v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"/> </svg>';
		  },
		  70744: function (e) {
			e.exports =
			  '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path stroke="null" d="m42.276011,26.302547c0.098397,-0.76605 0.172194,-1.54407 0.172194,-2.33406s-0.073797,-1.56801 -0.172194,-2.33406l5.202718,-3.961917c0.467384,-0.359086 0.602679,-1.005441 0.29519,-1.532101l-4.919828,-8.29489c-0.307489,-0.51469 -0.947067,-0.730142 -1.500548,-0.51469l-6.125186,2.405877c-1.266856,-0.945594 -2.656707,-1.747553 -4.157255,-2.357999l-0.922468,-6.343855c-0.110696,-0.562568 -0.614979,-1.005441 -1.229957,-1.005441l-9.839656,0c-0.614979,0 -1.119261,0.442873 -1.217657,1.005441l-0.922468,6.343855c-1.500548,0.610446 -2.890399,1.400436 -4.157255,2.357999l-6.125186,-2.405877c-0.553481,-0.203482 -1.193058,0 -1.500548,0.51469l-4.919828,8.29489c-0.307489,0.51469 -0.172194,1.161045 0.29519,1.532101l5.190419,3.961917c-0.098397,0.76605 -0.172194,1.54407 -0.172194,2.33406s0.073797,1.56801 0.172194,2.33406l-5.190419,3.961917c-0.467384,0.359086 -0.602679,1.005441 -0.29519,1.532101l4.919828,8.29489c0.307489,0.51469 0.947067,0.730142 1.500548,0.51469l6.125186,-2.405877c1.266856,0.945594 2.656707,1.747553 4.157255,2.357999l0.922468,6.343855c0.098397,0.562568 0.602679,1.005441 1.217657,1.005441l9.839656,0c0.614979,0 1.119261,-0.442873 1.217657,-1.005441l0.922468,-6.343855c1.500548,-0.610446 2.890399,-1.400436 4.157255,-2.357999l6.125186,2.405877c0.553481,0.203482 1.193058,0 1.500548,-0.51469l4.919828,-8.29489c0.307489,-0.51469 0.172194,-1.161045 -0.29519,-1.532101l-5.190419,-3.961917zm-18.277162,6.044617c-4.759934,0 -8.609699,-3.746465 -8.609699,-8.378677s3.849766,-8.378677 8.609699,-8.378677s8.609699,3.746465 8.609699,8.378677s-3.849766,8.378677 -8.609699,8.378677z"/> </svg>';
		  },
		  19201: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1728 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z"/> </svg>';
		  },
		  84930: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/> </svg>';
		  },
		  99704: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1344 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zm-325-648q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z"/> </svg>';
		  },
		  2304: function (e) {
			e.exports =
			  '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1216 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"/> </svg>';
		  },
		  93330: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  45066: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  99895: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  87682: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  50905: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  70446: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  18984: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  4591: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  64194: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  70375: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  90235: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  88477: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  50197: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  39008: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  47086: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  16462: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  40692: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  27452: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  51422: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  62820: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  63421: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  32115: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  53362: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  48904: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  85796: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  28654: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  60819: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  96410: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  33126: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  30724: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  14320: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  9947: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  45109: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  71708: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  51629: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  54860: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  47818: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  6316: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  88582: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  30962: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  68197: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  60057: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  33393: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  51057: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  64618: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  90176: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  91147: function (e, t, o) {
			"use strict";
			o.r(t);
		  },
		  70631: function (e, t) {
			"use strict";
			function o(e) {
			  return (
				(o =
				  "function" == typeof Symbol &&
				  "symbol" == typeof Symbol.iterator
					? function (e) {
						return typeof e;
					  }
					: function (e) {
						return e &&
						  "function" == typeof Symbol &&
						  e.constructor === Symbol &&
						  e !== Symbol.prototype
						  ? "symbol"
						  : typeof e;
					  }),
				o(e)
			  );
			}
			function n(e, t, n) {
			  var r = n.value;
			  if ("function" != typeof r)
				throw new TypeError(
				  "@boundMethod decorator can only be applied to methods not: ".concat(
					o(r),
				  ),
				);
			  var i = !1;
			  return {
				configurable: !0,
				get: function () {
				  if (
					i ||
					this === e.prototype ||
					this.hasOwnProperty(t) ||
					"function" != typeof r
				  )
					return r;
				  var o = r.bind(this);
				  return (
					(i = !0),
					Object.defineProperty(this, t, {
					  configurable: !0,
					  get: function () {
						return o;
					  },
					  set: function (e) {
						(r = e), delete this[t];
					  },
					}),
					(i = !1),
					o
				  );
				},
				set: function (e) {
				  r = e;
				},
			  };
			}
			function r(e) {
			  var t;
			  return (
				"undefined" != typeof Reflect &&
				"function" == typeof Reflect.ownKeys
				  ? (t = Reflect.ownKeys(e.prototype))
				  : ((t = Object.getOwnPropertyNames(e.prototype)),
					"function" == typeof Object.getOwnPropertySymbols &&
					  (t = t.concat(Object.getOwnPropertySymbols(e.prototype)))),
				t.forEach(function (t) {
				  if ("constructor" !== t) {
					var o = Object.getOwnPropertyDescriptor(e.prototype, t);
					"function" == typeof o.value &&
					  Object.defineProperty(e.prototype, t, n(e, t, o));
				  }
				}),
				e
			  );
			}
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.boundClass = t.boundMethod = void 0),
			  (t.boundMethod = n),
			  (t.boundClass = r),
			  (t.default = function () {
				return 1 === arguments.length
				  ? r.apply(void 0, arguments)
				  : n.apply(void 0, arguments);
			  });
		  },
		  61227: function () {
			"use strict";
			"document" in window.self &&
			  ((!("classList" in document.createElement("_")) ||
				(document.createElementNS &&
				  !(
					"classList" in
					document.createElementNS("http://www.w3.org/2000/svg", "g")
				  ))) &&
				(function (e) {
				  if ("Element" in e) {
					var t = "classList",
					  o = e.Element.prototype,
					  n = Object,
					  r =
						String.prototype.trim ||
						function () {
						  return this.replace(/^\s+|\s+$/g, "");
						},
					  i =
						Array.prototype.indexOf ||
						function (e) {
						  for (var t = 0, o = this.length; o > t; t++)
							if (t in this && this[t] === e) return t;
						  return -1;
						},
					  a = function (e, t) {
						(this.name = e),
						  (this.code = DOMException[e]),
						  (this.message = t);
					  },
					  s = function (e, t) {
						if ("" === t)
						  throw new a(
							"SYNTAX_ERR",
							"An invalid or illegal string was specified",
						  );
						if (/\s/.test(t))
						  throw new a(
							"INVALID_CHARACTER_ERR",
							"String contains an invalid character",
						  );
						return i.call(e, t);
					  },
					  l = function (e) {
						for (
						  var t = r.call(e.getAttribute("class") || ""),
							o = t ? t.split(/\s+/) : [],
							n = 0,
							i = o.length;
						  i > n;
						  n++
						)
						  this.push(o[n]);
						this._updateClassName = function () {
						  e.setAttribute("class", this.toString());
						};
					  },
					  c = (l.prototype = []),
					  u = function () {
						return new l(this);
					  };
					if (
					  ((a.prototype = Error.prototype),
					  (c.item = function (e) {
						return this[e] || null;
					  }),
					  (c.contains = function (e) {
						return -1 !== s(this, (e += ""));
					  }),
					  (c.add = function () {
						var e,
						  t = arguments,
						  o = 0,
						  n = t.length,
						  r = !1;
						do {
						  -1 === s(this, (e = t[o] + "")) &&
							(this.push(e), (r = !0));
						} while (++o < n);
						r && this._updateClassName();
					  }),
					  (c.remove = function () {
						var e,
						  t,
						  o = arguments,
						  n = 0,
						  r = o.length,
						  i = !1;
						do {
						  for (t = s(this, (e = o[n] + "")); -1 !== t; )
							this.splice(t, 1), (i = !0), (t = s(this, e));
						} while (++n < r);
						i && this._updateClassName();
					  }),
					  (c.toggle = function (e, t) {
						var o = this.contains((e += "")),
						  n = o ? !0 !== t && "remove" : !1 !== t && "add";
						return n && this[n](e), !0 === t || !1 === t ? t : !o;
					  }),
					  (c.toString = function () {
						return this.join(" ");
					  }),
					  n.defineProperty)
					) {
					  var d = { get: u, enumerable: !0, configurable: !0 };
					  try {
						n.defineProperty(o, t, d);
					  } catch (e) {
						(void 0 !== e.number && -2146823252 !== e.number) ||
						  ((d.enumerable = !1), n.defineProperty(o, t, d));
					  }
					} else
					  n.prototype.__defineGetter__ && o.__defineGetter__(t, u);
				  }
				})(window.self),
			  (function () {
				var e = document.createElement("_");
				if ((e.classList.add("c1", "c2"), !e.classList.contains("c2"))) {
				  var t = function (e) {
					var t = DOMTokenList.prototype[e];
					DOMTokenList.prototype[e] = function (e) {
					  var o,
						n = arguments.length;
					  for (o = 0; n > o; o++) t.call(this, (e = arguments[o]));
					};
				  };
				  t("add"), t("remove");
				}
				if ((e.classList.toggle("c3", !1), e.classList.contains("c3"))) {
				  var o = DOMTokenList.prototype.toggle;
				  DOMTokenList.prototype.toggle = function (e, t) {
					return 1 in arguments && !this.contains(e) == !t
					  ? t
					  : o.call(this, e);
				  };
				}
				e = null;
			  })());
		  },
		  69220: function (e, t, o) {
			"use strict";
			o(22513);
			var n = o(56599);
			e.exports = n("Array", "findIndex");
		  },
		  10444: function (e, t, o) {
			"use strict";
			o(52867), o(70057);
			var n = o(31116);
			e.exports = n.Array.from;
		  },
		  66622: function (e, t, o) {
			"use strict";
			o(54166),
			  o(32044),
			  o(95661),
			  o(28424),
			  o(64514),
			  o(30733),
			  o(40327),
			  o(53639),
			  o(6147),
			  o(7290),
			  o(95122),
			  o(61322),
			  o(39605),
			  o(49341),
			  o(28809),
			  o(82658),
			  o(43967),
			  o(90217),
			  o(73477),
			  o(93697);
			var n = o(31116);
			e.exports = n.Symbol;
		  },
		  98061: function (e, t, o) {
			"use strict";
			var n = o(794),
			  r = o(98418),
			  i = TypeError;
			e.exports = function (e) {
			  if (n(e)) return e;
			  throw i(r(e) + " is not a function");
			};
		  },
		  75839: function (e, t, o) {
			"use strict";
			var n = o(794),
			  r = String,
			  i = TypeError;
			e.exports = function (e) {
			  if ("object" == typeof e || n(e)) return e;
			  throw i("Can't set " + r(e) + " as a prototype");
			};
		  },
		  15179: function (e, t, o) {
			"use strict";
			var n = o(19517),
			  r = o(93503),
			  i = o(73252).f,
			  a = n("unscopables"),
			  s = Array.prototype;
			null == s[a] && i(s, a, { configurable: !0, value: r(null) }),
			  (e.exports = function (e) {
				s[a][e] = !0;
			  });
		  },
		  52313: function (e, t, o) {
			"use strict";
			var n = o(8148),
			  r = String,
			  i = TypeError;
			e.exports = function (e) {
			  if (n(e)) return e;
			  throw i(r(e) + " is not an object");
			};
		  },
		  92707: function (e, t, o) {
			"use strict";
			var n = o(40207),
			  r = o(9093),
			  i = o(68488),
			  a = o(79665),
			  s = o(84997),
			  l = o(15333),
			  c = o(15050),
			  u = o(89476),
			  d = o(27395),
			  p = o(81058),
			  f = Array;
			e.exports = function (e) {
			  var t = i(e),
				o = l(this),
				h = arguments.length,
				m = h > 1 ? arguments[1] : void 0,
				v = void 0 !== m;
			  v && (m = n(m, h > 2 ? arguments[2] : void 0));
			  var g,
				y,
				_,
				b,
				w,
				S,
				C = p(t),
				j = 0;
			  if (!C || (this === f && s(C)))
				for (g = c(t), y = o ? new this(g) : f(g); g > j; j++)
				  (S = v ? m(t[j], j) : t[j]), u(y, j, S);
			  else
				for (
				  w = (b = d(t, C)).next, y = o ? new this() : [];
				  !(_ = r(w, b)).done;
				  j++
				)
				  (S = v ? a(b, m, [_.value, j], !0) : _.value), u(y, j, S);
			  return (y.length = j), y;
			};
		  },
		  79327: function (e, t, o) {
			"use strict";
			var n = o(98651),
			  r = o(10586),
			  i = o(15050),
			  a = function (e) {
				return function (t, o, a) {
				  var s,
					l = n(t),
					c = i(l),
					u = r(a, c);
				  if (e && o != o) {
					for (; c > u; ) if ((s = l[u++]) != s) return !0;
				  } else
					for (; c > u; u++)
					  if ((e || u in l) && l[u] === o) return e || u || 0;
				  return !e && -1;
				};
			  };
			e.exports = { includes: a(!0), indexOf: a(!1) };
		  },
		  56881: function (e, t, o) {
			"use strict";
			var n = o(40207),
			  r = o(90838),
			  i = o(25049),
			  a = o(68488),
			  s = o(15050),
			  l = o(6429),
			  c = r([].push),
			  u = function (e) {
				var t = 1 == e,
				  o = 2 == e,
				  r = 3 == e,
				  u = 4 == e,
				  d = 6 == e,
				  p = 7 == e,
				  f = 5 == e || d;
				return function (h, m, v, g) {
				  for (
					var y,
					  _,
					  b = a(h),
					  w = i(b),
					  S = n(m, v),
					  C = s(w),
					  j = 0,
					  E = g || l,
					  x = t ? E(h, C) : o || p ? E(h, 0) : void 0;
					C > j;
					j++
				  )
					if ((f || j in w) && ((_ = S((y = w[j]), j, b)), e))
					  if (t) x[j] = _;
					  else if (_)
						switch (e) {
						  case 3:
							return !0;
						  case 5:
							return y;
						  case 6:
							return j;
						  case 2:
							c(x, y);
						}
					  else
						switch (e) {
						  case 4:
							return !1;
						  case 7:
							c(x, y);
						}
				  return d ? -1 : r || u ? u : x;
				};
			  };
			e.exports = {
			  forEach: u(0),
			  map: u(1),
			  filter: u(2),
			  some: u(3),
			  every: u(4),
			  find: u(5),
			  findIndex: u(6),
			  filterReject: u(7),
			};
		  },
		  63833: function (e, t, o) {
			"use strict";
			var n = o(75834),
			  r = o(19517),
			  i = o(65190),
			  a = r("species");
			e.exports = function (e) {
			  return (
				i >= 51 ||
				!n(function () {
				  var t = [];
				  return (
					((t.constructor = {})[a] = function () {
					  return { foo: 1 };
					}),
					1 !== t[e](Boolean).foo
				  );
				})
			  );
			};
		  },
		  57652: function (e, t, o) {
			"use strict";
			var n = o(10586),
			  r = o(15050),
			  i = o(89476),
			  a = Array,
			  s = Math.max;
			e.exports = function (e, t, o) {
			  for (
				var l = r(e),
				  c = n(t, l),
				  u = n(void 0 === o ? l : o, l),
				  d = a(s(u - c, 0)),
				  p = 0;
				u > c;
				c++, p++
			  )
				i(d, p, e[c]);
			  return (d.length = p), d;
			};
		  },
		  54832: function (e, t, o) {
			"use strict";
			var n = o(90838);
			e.exports = n([].slice);
		  },
		  22506: function (e, t, o) {
			"use strict";
			var n = o(36222),
			  r = o(15333),
			  i = o(8148),
			  a = o(19517)("species"),
			  s = Array;
			e.exports = function (e) {
			  var t;
			  return (
				n(e) &&
				  ((r((t = e.constructor)) && (t === s || n(t.prototype))) ||
					(i(t) && null === (t = t[a]))) &&
				  (t = void 0),
				void 0 === t ? s : t
			  );
			};
		  },
		  6429: function (e, t, o) {
			"use strict";
			var n = o(22506);
			e.exports = function (e, t) {
			  return new (n(e))(0 === t ? 0 : t);
			};
		  },
		  79665: function (e, t, o) {
			"use strict";
			var n = o(52313),
			  r = o(11274);
			e.exports = function (e, t, o, i) {
			  try {
				return i ? t(n(o)[0], o[1]) : t(o);
			  } catch (t) {
				r(e, "throw", t);
			  }
			};
		  },
		  7581: function (e, t, o) {
			"use strict";
			var n = o(19517)("iterator"),
			  r = !1;
			try {
			  var i = 0,
				a = {
				  next: function () {
					return { done: !!i++ };
				  },
				  return: function () {
					r = !0;
				  },
				};
			  (a[n] = function () {
				return this;
			  }),
				Array.from(a, function () {
				  throw 2;
				});
			} catch (e) {}
			e.exports = function (e, t) {
			  if (!t && !r) return !1;
			  var o = !1;
			  try {
				var i = {};
				(i[n] = function () {
				  return {
					next: function () {
					  return { done: (o = !0) };
					},
				  };
				}),
				  e(i);
			  } catch (e) {}
			  return o;
			};
		  },
		  6285: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = n({}.toString),
			  i = n("".slice);
			e.exports = function (e) {
			  return i(r(e), 8, -1);
			};
		  },
		  8652: function (e, t, o) {
			"use strict";
			var n = o(6424),
			  r = o(794),
			  i = o(6285),
			  a = o(19517)("toStringTag"),
			  s = Object,
			  l =
				"Arguments" ==
				i(
				  (function () {
					return arguments;
				  })(),
				);
			e.exports = n
			  ? i
			  : function (e) {
				  var t, o, n;
				  return void 0 === e
					? "Undefined"
					: null === e
					  ? "Null"
					  : "string" ==
						  typeof (o = (function (e, t) {
							try {
							  return e[t];
							} catch (e) {}
						  })((t = s(e)), a))
						? o
						: l
						  ? i(t)
						  : "Object" == (n = i(t)) && r(t.callee)
							? "Arguments"
							: n;
				};
		  },
		  58392: function (e, t, o) {
			"use strict";
			var n = o(14434),
			  r = o(86671),
			  i = o(36999),
			  a = o(73252);
			e.exports = function (e, t, o) {
			  for (var s = r(t), l = a.f, c = i.f, u = 0; s.length > u; u++) {
				var d = s[u];
				n(e, d) || (o && n(o, d)) || l(e, d, c(t, d));
			  }
			};
		  },
		  27259: function (e, t, o) {
			"use strict";
			var n = o(75834);
			e.exports = !n(function () {
			  function e() {}
			  return (
				(e.prototype.constructor = null),
				Object.getPrototypeOf(new e()) !== e.prototype
			  );
			});
		  },
		  17427: function (e) {
			"use strict";
			e.exports = function (e, t) {
			  return { value: e, done: t };
			};
		  },
		  45840: function (e, t, o) {
			"use strict";
			var n = o(13873),
			  r = o(73252),
			  i = o(32500);
			e.exports = n
			  ? function (e, t, o) {
				  return r.f(e, t, i(1, o));
				}
			  : function (e, t, o) {
				  return (e[t] = o), e;
				};
		  },
		  32500: function (e) {
			"use strict";
			e.exports = function (e, t) {
			  return {
				enumerable: !(1 & e),
				configurable: !(2 & e),
				writable: !(4 & e),
				value: t,
			  };
			};
		  },
		  89476: function (e, t, o) {
			"use strict";
			var n = o(43836),
			  r = o(73252),
			  i = o(32500);
			e.exports = function (e, t, o) {
			  var a = n(t);
			  a in e ? r.f(e, a, i(0, o)) : (e[a] = o);
			};
		  },
		  97548: function (e, t, o) {
			"use strict";
			var n = o(40846),
			  r = o(73252);
			e.exports = function (e, t, o) {
			  return (
				o.get && n(o.get, t, { getter: !0 }),
				o.set && n(o.set, t, { setter: !0 }),
				r.f(e, t, o)
			  );
			};
		  },
		  35065: function (e, t, o) {
			"use strict";
			var n = o(794),
			  r = o(73252),
			  i = o(40846),
			  a = o(25379);
			e.exports = function (e, t, o, s) {
			  s || (s = {});
			  var l = s.enumerable,
				c = void 0 !== s.name ? s.name : t;
			  if ((n(o) && i(o, c, s), s.global)) l ? (e[t] = o) : a(t, o);
			  else {
				try {
				  s.unsafe ? e[t] && (l = !0) : delete e[t];
				} catch (e) {}
				l
				  ? (e[t] = o)
				  : r.f(e, t, {
					  value: o,
					  enumerable: !1,
					  configurable: !s.nonConfigurable,
					  writable: !s.nonWritable,
					});
			  }
			  return e;
			};
		  },
		  25379: function (e, t, o) {
			"use strict";
			var n = o(37042),
			  r = Object.defineProperty;
			e.exports = function (e, t) {
			  try {
				r(n, e, { value: t, configurable: !0, writable: !0 });
			  } catch (o) {
				n[e] = t;
			  }
			  return t;
			};
		  },
		  13873: function (e, t, o) {
			"use strict";
			var n = o(75834);
			e.exports = !n(function () {
			  return (
				7 !=
				Object.defineProperty({}, 1, {
				  get: function () {
					return 7;
				  },
				})[1]
			  );
			});
		  },
		  12062: function (e) {
			"use strict";
			var t = "object" == typeof document && document.all;
			e.exports = { all: t, IS_HTMLDDA: void 0 === t && void 0 !== t };
		  },
		  15192: function (e, t, o) {
			"use strict";
			var n = o(37042),
			  r = o(8148),
			  i = n.document,
			  a = r(i) && r(i.createElement);
			e.exports = function (e) {
			  return a ? i.createElement(e) : {};
			};
		  },
		  39505: function (e) {
			"use strict";
			var t = TypeError;
			e.exports = function (e) {
			  if (e > 9007199254740991) throw t("Maximum allowed index exceeded");
			  return e;
			};
		  },
		  21473: function (e) {
			"use strict";
			e.exports =
			  ("undefined" != typeof navigator && String(navigator.userAgent)) ||
			  "";
		  },
		  65190: function (e, t, o) {
			"use strict";
			var n,
			  r,
			  i = o(37042),
			  a = o(21473),
			  s = i.process,
			  l = i.Deno,
			  c = (s && s.versions) || (l && l.version),
			  u = c && c.v8;
			u && (r = (n = u.split("."))[0] > 0 && 4 > n[0] ? 1 : +(n[0] + n[1])),
			  !r &&
				a &&
				(((n = a.match(/Edge\/(\d+)/)) && 74 > n[1]) ||
				  ((n = a.match(/Chrome\/(\d+)/)) && (r = +n[1]))),
			  (e.exports = r);
		  },
		  56599: function (e, t, o) {
			"use strict";
			var n = o(37042),
			  r = o(90838);
			e.exports = function (e, t) {
			  return r(n[e].prototype[t]);
			};
		  },
		  64456: function (e) {
			"use strict";
			e.exports = [
			  "constructor",
			  "hasOwnProperty",
			  "isPrototypeOf",
			  "propertyIsEnumerable",
			  "toLocaleString",
			  "toString",
			  "valueOf",
			];
		  },
		  50791: function (e, t, o) {
			"use strict";
			var n = o(37042),
			  r = o(36999).f,
			  i = o(45840),
			  a = o(35065),
			  s = o(25379),
			  l = o(58392),
			  c = o(56930);
			e.exports = function (e, t) {
			  var o,
				u,
				d,
				p,
				f,
				h = e.target,
				m = e.global,
				v = e.stat;
			  if ((o = m ? n : v ? n[h] || s(h, {}) : (n[h] || {}).prototype))
				for (u in t) {
				  if (
					((p = t[u]),
					(d = e.dontCallGetSet ? (f = r(o, u)) && f.value : o[u]),
					!c(m ? u : h + (v ? "." : "#") + u, e.forced) && void 0 !== d)
				  ) {
					if (typeof p == typeof d) continue;
					l(p, d);
				  }
				  (e.sham || (d && d.sham)) && i(p, "sham", !0), a(o, u, p, e);
				}
			};
		  },
		  75834: function (e) {
			"use strict";
			e.exports = function (e) {
			  try {
				return !!e();
			  } catch (e) {
				return !0;
			  }
			};
		  },
		  55101: function (e, t, o) {
			"use strict";
			var n = o(32610),
			  r = Function.prototype,
			  i = r.apply,
			  a = r.call;
			e.exports =
			  ("object" == typeof Reflect && Reflect.apply) ||
			  (n
				? a.bind(i)
				: function () {
					return a.apply(i, arguments);
				  });
		  },
		  40207: function (e, t, o) {
			"use strict";
			var n = o(75114),
			  r = o(98061),
			  i = o(32610),
			  a = n(n.bind);
			e.exports = function (e, t) {
			  return (
				r(e),
				void 0 === t
				  ? e
				  : i
					? a(e, t)
					: function () {
						return e.apply(t, arguments);
					  }
			  );
			};
		  },
		  32610: function (e, t, o) {
			"use strict";
			var n = o(75834);
			e.exports = !n(function () {
			  var e = function () {}.bind();
			  return "function" != typeof e || e.hasOwnProperty("prototype");
			});
		  },
		  9093: function (e, t, o) {
			"use strict";
			var n = o(32610),
			  r = Function.prototype.call;
			e.exports = n
			  ? r.bind(r)
			  : function () {
				  return r.apply(r, arguments);
				};
		  },
		  84521: function (e, t, o) {
			"use strict";
			var n = o(13873),
			  r = o(14434),
			  i = Function.prototype,
			  a = n && Object.getOwnPropertyDescriptor,
			  s = r(i, "name"),
			  l = s && "something" === function () {}.name,
			  c = s && (!n || (n && a(i, "name").configurable));
			e.exports = { EXISTS: s, PROPER: l, CONFIGURABLE: c };
		  },
		  47448: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(98061);
			e.exports = function (e, t, o) {
			  try {
				return n(r(Object.getOwnPropertyDescriptor(e, t)[o]));
			  } catch (e) {}
			};
		  },
		  75114: function (e, t, o) {
			"use strict";
			var n = o(6285),
			  r = o(90838);
			e.exports = function (e) {
			  if ("Function" === n(e)) return r(e);
			};
		  },
		  90838: function (e, t, o) {
			"use strict";
			var n = o(32610),
			  r = Function.prototype,
			  i = r.call,
			  a = n && r.bind.bind(i, i);
			e.exports = n
			  ? a
			  : function (e) {
				  return function () {
					return i.apply(e, arguments);
				  };
				};
		  },
		  98945: function (e, t, o) {
			"use strict";
			var n = o(37042),
			  r = o(794),
			  i = function (e) {
				return r(e) ? e : void 0;
			  };
			e.exports = function (e, t) {
			  return 2 > arguments.length ? i(n[e]) : n[e] && n[e][t];
			};
		  },
		  81058: function (e, t, o) {
			"use strict";
			var n = o(8652),
			  r = o(20156),
			  i = o(8140),
			  a = o(84922),
			  s = o(19517)("iterator");
			e.exports = function (e) {
			  if (!i(e)) return r(e, s) || r(e, "@@iterator") || a[n(e)];
			};
		  },
		  27395: function (e, t, o) {
			"use strict";
			var n = o(9093),
			  r = o(98061),
			  i = o(52313),
			  a = o(98418),
			  s = o(81058),
			  l = TypeError;
			e.exports = function (e, t) {
			  var o = 2 > arguments.length ? s(e) : t;
			  if (r(o)) return i(n(o, e));
			  throw l(a(e) + " is not iterable");
			};
		  },
		  6693: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(36222),
			  i = o(794),
			  a = o(6285),
			  s = o(63046),
			  l = n([].push);
			e.exports = function (e) {
			  if (i(e)) return e;
			  if (r(e)) {
				for (var t = e.length, o = [], n = 0; t > n; n++) {
				  var c = e[n];
				  "string" == typeof c
					? l(o, c)
					: ("number" != typeof c &&
						"Number" != a(c) &&
						"String" != a(c)) ||
					  l(o, s(c));
				}
				var u = o.length,
				  d = !0;
				return function (e, t) {
				  if (d) return (d = !1), t;
				  if (r(this)) return t;
				  for (var n = 0; u > n; n++) if (o[n] === e) return t;
				};
			  }
			};
		  },
		  20156: function (e, t, o) {
			"use strict";
			var n = o(98061),
			  r = o(8140);
			e.exports = function (e, t) {
			  var o = e[t];
			  return r(o) ? void 0 : n(o);
			};
		  },
		  37042: function (e, t, o) {
			"use strict";
			var n = function (e) {
			  return e && e.Math == Math && e;
			};
			e.exports =
			  n("object" == typeof globalThis && globalThis) ||
			  n("object" == typeof window && window) ||
			  n("object" == typeof self && self) ||
			  n("object" == typeof o.g && o.g) ||
			  (function () {
				return this;
			  })() ||
			  Function("return this")();
		  },
		  14434: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(68488),
			  i = n({}.hasOwnProperty);
			e.exports =
			  Object.hasOwn ||
			  function (e, t) {
				return i(r(e), t);
			  };
		  },
		  48889: function (e) {
			"use strict";
			e.exports = {};
		  },
		  36249: function (e, t, o) {
			"use strict";
			var n = o(98945);
			e.exports = n("document", "documentElement");
		  },
		  12816: function (e, t, o) {
			"use strict";
			var n = o(13873),
			  r = o(75834),
			  i = o(15192);
			e.exports =
			  !n &&
			  !r(function () {
				return (
				  7 !=
				  Object.defineProperty(i("div"), "a", {
					get: function () {
					  return 7;
					},
				  }).a
				);
			  });
		  },
		  25049: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(75834),
			  i = o(6285),
			  a = Object,
			  s = n("".split);
			e.exports = r(function () {
			  return !a("z").propertyIsEnumerable(0);
			})
			  ? function (e) {
				  return "String" == i(e) ? s(e, "") : a(e);
				}
			  : a;
		  },
		  92355: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(794),
			  i = o(45752),
			  a = n(Function.toString);
			r(i.inspectSource) ||
			  (i.inspectSource = function (e) {
				return a(e);
			  }),
			  (e.exports = i.inspectSource);
		  },
		  56113: function (e, t, o) {
			"use strict";
			var n,
			  r,
			  i,
			  a = o(95473),
			  s = o(37042),
			  l = o(8148),
			  c = o(45840),
			  u = o(14434),
			  d = o(45752),
			  p = o(85475),
			  f = o(48889),
			  h = "Object already initialized",
			  m = s.TypeError;
			if (a || d.state) {
			  var v = d.state || (d.state = new (0, s.WeakMap)());
			  (v.get = v.get),
				(v.has = v.has),
				(v.set = v.set),
				(n = function (e, t) {
				  if (v.has(e)) throw m(h);
				  return (t.facade = e), v.set(e, t), t;
				}),
				(r = function (e) {
				  return v.get(e) || {};
				}),
				(i = function (e) {
				  return v.has(e);
				});
			} else {
			  var g = p("state");
			  (f[g] = !0),
				(n = function (e, t) {
				  if (u(e, g)) throw m(h);
				  return (t.facade = e), c(e, g, t), t;
				}),
				(r = function (e) {
				  return u(e, g) ? e[g] : {};
				}),
				(i = function (e) {
				  return u(e, g);
				});
			}
			e.exports = {
			  set: n,
			  get: r,
			  has: i,
			  enforce: function (e) {
				return i(e) ? r(e) : n(e, {});
			  },
			  getterFor: function (e) {
				return function (t) {
				  var o;
				  if (!l(t) || (o = r(t)).type !== e)
					throw m("Incompatible receiver, " + e + " required");
				  return o;
				};
			  },
			};
		  },
		  84997: function (e, t, o) {
			"use strict";
			var n = o(19517),
			  r = o(84922),
			  i = n("iterator"),
			  a = Array.prototype;
			e.exports = function (e) {
			  return void 0 !== e && (r.Array === e || a[i] === e);
			};
		  },
		  36222: function (e, t, o) {
			"use strict";
			var n = o(6285);
			e.exports =
			  Array.isArray ||
			  function (e) {
				return "Array" == n(e);
			  };
		  },
		  794: function (e, t, o) {
			"use strict";
			var n = o(12062),
			  r = n.all;
			e.exports = n.IS_HTMLDDA
			  ? function (e) {
				  return "function" == typeof e || e === r;
				}
			  : function (e) {
				  return "function" == typeof e;
				};
		  },
		  15333: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(75834),
			  i = o(794),
			  a = o(8652),
			  s = o(98945),
			  l = o(92355),
			  c = function () {},
			  u = [],
			  d = s("Reflect", "construct"),
			  p = /^\s*(?:class|function)\b/,
			  f = n(p.exec),
			  h = !p.exec(c),
			  m = function (e) {
				if (!i(e)) return !1;
				try {
				  return d(c, u, e), !0;
				} catch (e) {
				  return !1;
				}
			  },
			  v = function (e) {
				if (!i(e)) return !1;
				switch (a(e)) {
				  case "AsyncFunction":
				  case "GeneratorFunction":
				  case "AsyncGeneratorFunction":
					return !1;
				}
				try {
				  return h || !!f(p, l(e));
				} catch (e) {
				  return !0;
				}
			  };
			(v.sham = !0),
			  (e.exports =
				!d ||
				r(function () {
				  var e;
				  return (
					m(m.call) ||
					!m(Object) ||
					!m(function () {
					  e = !0;
					}) ||
					e
				  );
				})
				  ? v
				  : m);
		  },
		  56930: function (e, t, o) {
			"use strict";
			var n = o(75834),
			  r = o(794),
			  i = /#|\.prototype\./,
			  a = function (e, t) {
				var o = l[s(e)];
				return o == u || (o != c && (r(t) ? n(t) : !!t));
			  },
			  s = (a.normalize = function (e) {
				return String(e).replace(i, ".").toLowerCase();
			  }),
			  l = (a.data = {}),
			  c = (a.NATIVE = "N"),
			  u = (a.POLYFILL = "P");
			e.exports = a;
		  },
		  8140: function (e) {
			"use strict";
			e.exports = function (e) {
			  return null == e;
			};
		  },
		  8148: function (e, t, o) {
			"use strict";
			var n = o(794),
			  r = o(12062),
			  i = r.all;
			e.exports = r.IS_HTMLDDA
			  ? function (e) {
				  return "object" == typeof e ? null !== e : n(e) || e === i;
				}
			  : function (e) {
				  return "object" == typeof e ? null !== e : n(e);
				};
		  },
		  70852: function (e) {
			"use strict";
			e.exports = !1;
		  },
		  88253: function (e, t, o) {
			"use strict";
			var n = o(98945),
			  r = o(794),
			  i = o(54671),
			  a = o(57982),
			  s = Object;
			e.exports = a
			  ? function (e) {
				  return "symbol" == typeof e;
				}
			  : function (e) {
				  var t = n("Symbol");
				  return r(t) && i(t.prototype, s(e));
				};
		  },
		  11274: function (e, t, o) {
			"use strict";
			var n = o(9093),
			  r = o(52313),
			  i = o(20156);
			e.exports = function (e, t, o) {
			  var a, s;
			  r(e);
			  try {
				if (!(a = i(e, "return"))) {
				  if ("throw" === t) throw o;
				  return o;
				}
				a = n(a, e);
			  } catch (e) {
				(s = !0), (a = e);
			  }
			  if ("throw" === t) throw o;
			  if (s) throw a;
			  return r(a), o;
			};
		  },
		  60928: function (e, t, o) {
			"use strict";
			var n = o(77831).IteratorPrototype,
			  r = o(93503),
			  i = o(32500),
			  a = o(44532),
			  s = o(84922),
			  l = function () {
				return this;
			  };
			e.exports = function (e, t, o, c) {
			  var u = t + " Iterator";
			  return (
				(e.prototype = r(n, { next: i(+!c, o) })),
				a(e, u, !1, !0),
				(s[u] = l),
				e
			  );
			};
		  },
		  13759: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(9093),
			  i = o(70852),
			  a = o(84521),
			  s = o(794),
			  l = o(60928),
			  c = o(1074),
			  u = o(482),
			  d = o(44532),
			  p = o(45840),
			  f = o(35065),
			  h = o(19517),
			  m = o(84922),
			  v = o(77831),
			  g = a.PROPER,
			  y = a.CONFIGURABLE,
			  _ = v.IteratorPrototype,
			  b = v.BUGGY_SAFARI_ITERATORS,
			  w = h("iterator"),
			  S = "keys",
			  C = "values",
			  j = "entries",
			  E = function () {
				return this;
			  };
			e.exports = function (e, t, o, a, h, v, x) {
			  l(o, t, a);
			  var k,
				T,
				I,
				P = function (e) {
				  if (e === h && A) return A;
				  if (!b && e in O) return O[e];
				  switch (e) {
					case S:
					case C:
					case j:
					  return function () {
						return new o(this, e);
					  };
				  }
				  return function () {
					return new o(this);
				  };
				},
				M = t + " Iterator",
				D = !1,
				O = e.prototype,
				z = O[w] || O["@@iterator"] || (h && O[h]),
				A = (!b && z) || P(h),
				L = ("Array" == t && O.entries) || z;
			  if (
				(L &&
				  (k = c(L.call(new e()))) !== Object.prototype &&
				  k.next &&
				  (i || c(k) === _ || (u ? u(k, _) : s(k[w]) || f(k, w, E)),
				  d(k, M, !0, !0),
				  i && (m[M] = E)),
				g &&
				  h == C &&
				  z &&
				  z.name !== C &&
				  (!i && y
					? p(O, "name", C)
					: ((D = !0),
					  (A = function () {
						return r(z, this);
					  }))),
				h)
			  )
				if (
				  ((T = { values: P(C), keys: v ? A : P(S), entries: P(j) }), x)
				)
				  for (I in T) (b || D || !(I in O)) && f(O, I, T[I]);
				else n({ target: t, proto: !0, forced: b || D }, T);
			  return (
				(i && !x) || O[w] === A || f(O, w, A, { name: h }), (m[t] = A), T
			  );
			};
		  },
		  77831: function (e, t, o) {
			"use strict";
			var n,
			  r,
			  i,
			  a = o(75834),
			  s = o(794),
			  l = o(8148),
			  c = o(93503),
			  u = o(1074),
			  d = o(35065),
			  p = o(19517),
			  f = o(70852),
			  h = p("iterator"),
			  m = !1;
			[].keys &&
			  ("next" in (i = [].keys())
				? (r = u(u(i))) !== Object.prototype && (n = r)
				: (m = !0)),
			  !l(n) ||
			  a(function () {
				var e = {};
				return n[h].call(e) !== e;
			  })
				? (n = {})
				: f && (n = c(n)),
			  s(n[h]) ||
				d(n, h, function () {
				  return this;
				}),
			  (e.exports = { IteratorPrototype: n, BUGGY_SAFARI_ITERATORS: m });
		  },
		  84922: function (e) {
			"use strict";
			e.exports = {};
		  },
		  15050: function (e, t, o) {
			"use strict";
			var n = o(24431);
			e.exports = function (e) {
			  return n(e.length);
			};
		  },
		  40846: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(75834),
			  i = o(794),
			  a = o(14434),
			  s = o(13873),
			  l = o(84521).CONFIGURABLE,
			  c = o(92355),
			  u = o(56113),
			  d = u.enforce,
			  p = u.get,
			  f = String,
			  h = Object.defineProperty,
			  m = n("".slice),
			  v = n("".replace),
			  g = n([].join),
			  y =
				s &&
				!r(function () {
				  return 8 !== h(function () {}, "length", { value: 8 }).length;
				}),
			  _ = String(String).split("String"),
			  b = (e.exports = function (e, t, o) {
				"Symbol(" === m(f(t), 0, 7) &&
				  (t = "[" + v(f(t), /^Symbol\(([^)]*)\)/, "$1") + "]"),
				  o && o.getter && (t = "get " + t),
				  o && o.setter && (t = "set " + t),
				  (!a(e, "name") || (l && e.name !== t)) &&
					(s
					  ? h(e, "name", { value: t, configurable: !0 })
					  : (e.name = t)),
				  y &&
					o &&
					a(o, "arity") &&
					e.length !== o.arity &&
					h(e, "length", { value: o.arity });
				try {
				  o && a(o, "constructor") && o.constructor
					? s && h(e, "prototype", { writable: !1 })
					: e.prototype && (e.prototype = void 0);
				} catch (e) {}
				var n = d(e);
				return (
				  a(n, "source") ||
					(n.source = g(_, "string" == typeof t ? t : "")),
				  e
				);
			  });
			Function.prototype.toString = b(function () {
			  return (i(this) && p(this).source) || c(this);
			}, "toString");
		  },
		  43932: function (e) {
			"use strict";
			var t = Math.ceil,
			  o = Math.floor;
			e.exports =
			  Math.trunc ||
			  function (e) {
				var n = +e;
				return (n > 0 ? o : t)(n);
			  };
		  },
		  93503: function (e, t, o) {
			"use strict";
			var n,
			  r = o(52313),
			  i = o(5770),
			  a = o(64456),
			  s = o(48889),
			  l = o(36249),
			  c = o(15192),
			  u = o(85475)("IE_PROTO"),
			  d = function () {},
			  p = function (e) {
				return "<script>" + e + "</script>";
			  },
			  f = function (e) {
				e.write(p("")), e.close();
				var t = e.parentWindow.Object;
				return (e = null), t;
			  },
			  h = function () {
				try {
				  n = new ActiveXObject("htmlfile");
				} catch (e) {}
				var e, t;
				h =
				  "undefined" != typeof document
					? document.domain && n
					  ? f(n)
					  : (((t = c("iframe")).style.display = "none"),
						l.appendChild(t),
						(t.src = String("javascript:")),
						(e = t.contentWindow.document).open(),
						e.write(p("document.F=Object")),
						e.close(),
						e.F)
					: f(n);
				for (var o = a.length; o--; ) delete h.prototype[a[o]];
				return h();
			  };
			(s[u] = !0),
			  (e.exports =
				Object.create ||
				function (e, t) {
				  var o;
				  return (
					null !== e
					  ? ((d.prototype = r(e)),
						(o = new d()),
						(d.prototype = null),
						(o[u] = e))
					  : (o = h()),
					void 0 === t ? o : i.f(o, t)
				  );
				});
		  },
		  5770: function (e, t, o) {
			"use strict";
			var n = o(13873),
			  r = o(63142),
			  i = o(73252),
			  a = o(52313),
			  s = o(98651),
			  l = o(3385);
			t.f =
			  n && !r
				? Object.defineProperties
				: function (e, t) {
					a(e);
					for (var o, n = s(t), r = l(t), c = r.length, u = 0; c > u; )
					  i.f(e, (o = r[u++]), n[o]);
					return e;
				  };
		  },
		  73252: function (e, t, o) {
			"use strict";
			var n = o(13873),
			  r = o(12816),
			  i = o(63142),
			  a = o(52313),
			  s = o(43836),
			  l = TypeError,
			  c = Object.defineProperty,
			  u = Object.getOwnPropertyDescriptor;
			t.f = n
			  ? i
				? function (e, t, o) {
					if (
					  (a(e),
					  (t = s(t)),
					  a(o),
					  "function" == typeof e &&
						"prototype" === t &&
						"value" in o &&
						"writable" in o &&
						!o.writable)
					) {
					  var n = u(e, t);
					  n &&
						n.writable &&
						((e[t] = o.value),
						(o = {
						  configurable:
							"configurable" in o ? o.configurable : n.configurable,
						  enumerable:
							"enumerable" in o ? o.enumerable : n.enumerable,
						  writable: !1,
						}));
					}
					return c(e, t, o);
				  }
				: c
			  : function (e, t, o) {
				  if ((a(e), (t = s(t)), a(o), r))
					try {
					  return c(e, t, o);
					} catch (e) {}
				  if ("get" in o || "set" in o)
					throw l("Accessors not supported");
				  return "value" in o && (e[t] = o.value), e;
				};
		  },
		  36999: function (e, t, o) {
			"use strict";
			var n = o(13873),
			  r = o(9093),
			  i = o(33244),
			  a = o(32500),
			  s = o(98651),
			  l = o(43836),
			  c = o(14434),
			  u = o(12816),
			  d = Object.getOwnPropertyDescriptor;
			t.f = n
			  ? d
			  : function (e, t) {
				  if (((e = s(e)), (t = l(t)), u))
					try {
					  return d(e, t);
					} catch (e) {}
				  if (c(e, t)) return a(!r(i.f, e, t), e[t]);
				};
		  },
		  53305: function (e, t, o) {
			"use strict";
			var n = o(6285),
			  r = o(98651),
			  i = o(7792).f,
			  a = o(57652),
			  s =
				"object" == typeof window && window && Object.getOwnPropertyNames
				  ? Object.getOwnPropertyNames(window)
				  : [];
			e.exports.f = function (e) {
			  return s && "Window" == n(e)
				? (function (e) {
					try {
					  return i(e);
					} catch (e) {
					  return a(s);
					}
				  })(e)
				: i(r(e));
			};
		  },
		  7792: function (e, t, o) {
			"use strict";
			var n = o(84729),
			  r = o(64456).concat("length", "prototype");
			t.f =
			  Object.getOwnPropertyNames ||
			  function (e) {
				return n(e, r);
			  };
		  },
		  23953: function (e, t) {
			"use strict";
			t.f = Object.getOwnPropertySymbols;
		  },
		  1074: function (e, t, o) {
			"use strict";
			var n = o(14434),
			  r = o(794),
			  i = o(68488),
			  a = o(85475),
			  s = o(27259),
			  l = a("IE_PROTO"),
			  c = Object,
			  u = c.prototype;
			e.exports = s
			  ? c.getPrototypeOf
			  : function (e) {
				  var t = i(e);
				  if (n(t, l)) return t[l];
				  var o = t.constructor;
				  return r(o) && t instanceof o
					? o.prototype
					: t instanceof c
					  ? u
					  : null;
				};
		  },
		  54671: function (e, t, o) {
			"use strict";
			var n = o(90838);
			e.exports = n({}.isPrototypeOf);
		  },
		  84729: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(14434),
			  i = o(98651),
			  a = o(79327).indexOf,
			  s = o(48889),
			  l = n([].push);
			e.exports = function (e, t) {
			  var o,
				n = i(e),
				c = 0,
				u = [];
			  for (o in n) !r(s, o) && r(n, o) && l(u, o);
			  for (; t.length > c; ) r(n, (o = t[c++])) && (~a(u, o) || l(u, o));
			  return u;
			};
		  },
		  3385: function (e, t, o) {
			"use strict";
			var n = o(84729),
			  r = o(64456);
			e.exports =
			  Object.keys ||
			  function (e) {
				return n(e, r);
			  };
		  },
		  33244: function (e, t) {
			"use strict";
			var o = {}.propertyIsEnumerable,
			  n = Object.getOwnPropertyDescriptor,
			  r = n && !o.call({ 1: 2 }, 1);
			t.f = r
			  ? function (e) {
				  var t = n(this, e);
				  return !!t && t.enumerable;
				}
			  : o;
		  },
		  482: function (e, t, o) {
			"use strict";
			var n = o(47448),
			  r = o(52313),
			  i = o(75839);
			e.exports =
			  Object.setPrototypeOf ||
			  ("__proto__" in {}
				? (function () {
					var e,
					  t = !1,
					  o = {};
					try {
					  (e = n(Object.prototype, "__proto__", "set"))(o, []),
						(t = o instanceof Array);
					} catch (e) {}
					return function (o, n) {
					  return r(o), i(n), t ? e(o, n) : (o.__proto__ = n), o;
					};
				  })()
				: void 0);
		  },
		  57555: function (e, t, o) {
			"use strict";
			var n = o(6424),
			  r = o(8652);
			e.exports = n
			  ? {}.toString
			  : function () {
				  return "[object " + r(this) + "]";
				};
		  },
		  82472: function (e, t, o) {
			"use strict";
			var n = o(9093),
			  r = o(794),
			  i = o(8148),
			  a = TypeError;
			e.exports = function (e, t) {
			  var o, s;
			  if ("string" === t && r((o = e.toString)) && !i((s = n(o, e))))
				return s;
			  if (r((o = e.valueOf)) && !i((s = n(o, e)))) return s;
			  if ("string" !== t && r((o = e.toString)) && !i((s = n(o, e))))
				return s;
			  throw a("Can't convert object to primitive value");
			};
		  },
		  86671: function (e, t, o) {
			"use strict";
			var n = o(98945),
			  r = o(90838),
			  i = o(7792),
			  a = o(23953),
			  s = o(52313),
			  l = r([].concat);
			e.exports =
			  n("Reflect", "ownKeys") ||
			  function (e) {
				var t = i.f(s(e)),
				  o = a.f;
				return o ? l(t, o(e)) : t;
			  };
		  },
		  31116: function (e, t, o) {
			"use strict";
			var n = o(37042);
			e.exports = n;
		  },
		  60265: function (e, t, o) {
			"use strict";
			var n = o(8140),
			  r = TypeError;
			e.exports = function (e) {
			  if (n(e)) throw r("Can't call method on " + e);
			  return e;
			};
		  },
		  44532: function (e, t, o) {
			"use strict";
			var n = o(73252).f,
			  r = o(14434),
			  i = o(19517)("toStringTag");
			e.exports = function (e, t, o) {
			  e && !o && (e = e.prototype),
				e && !r(e, i) && n(e, i, { configurable: !0, value: t });
			};
		  },
		  85475: function (e, t, o) {
			"use strict";
			var n = o(95138),
			  r = o(15257),
			  i = n("keys");
			e.exports = function (e) {
			  return i[e] || (i[e] = r(e));
			};
		  },
		  45752: function (e, t, o) {
			"use strict";
			var n = o(37042),
			  r = o(25379),
			  i = "__core-js_shared__",
			  a = n[i] || r(i, {});
			e.exports = a;
		  },
		  95138: function (e, t, o) {
			"use strict";
			var n = o(70852),
			  r = o(45752);
			(e.exports = function (e, t) {
			  return r[e] || (r[e] = void 0 !== t ? t : {});
			})("versions", []).push({
			  version: "3.28.0",
			  mode: n ? "pure" : "global",
			  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
			  license: "https://github.com/zloirock/core-js/blob/v3.28.0/LICENSE",
			  source: "https://github.com/zloirock/core-js",
			});
		  },
		  41397: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = o(27876),
			  i = o(63046),
			  a = o(60265),
			  s = n("".charAt),
			  l = n("".charCodeAt),
			  c = n("".slice),
			  u = function (e) {
				return function (t, o) {
				  var n,
					u,
					d = i(a(t)),
					p = r(o),
					f = d.length;
				  return 0 > p || p >= f
					? e
					  ? ""
					  : void 0
					: 55296 > (n = l(d, p)) ||
						n > 56319 ||
						p + 1 === f ||
						56320 > (u = l(d, p + 1)) ||
						u > 57343
					  ? e
						? s(d, p)
						: n
					  : e
						? c(d, p, p + 2)
						: u - 56320 + ((n - 55296) << 10) + 65536;
				};
			  };
			e.exports = { codeAt: u(!1), charAt: u(!0) };
		  },
		  73800: function (e, t, o) {
			"use strict";
			var n = o(65190),
			  r = o(75834);
			e.exports =
			  !!Object.getOwnPropertySymbols &&
			  !r(function () {
				var e = Symbol();
				return (
				  !String(e) ||
				  !(Object(e) instanceof Symbol) ||
				  (!Symbol.sham && n && 41 > n)
				);
			  });
		  },
		  13829: function (e, t, o) {
			"use strict";
			var n = o(9093),
			  r = o(98945),
			  i = o(19517),
			  a = o(35065);
			e.exports = function () {
			  var e = r("Symbol"),
				t = e && e.prototype,
				o = t && t.valueOf,
				s = i("toPrimitive");
			  t &&
				!t[s] &&
				a(
				  t,
				  s,
				  function (e) {
					return n(o, this);
				  },
				  { arity: 1 },
				);
			};
		  },
		  31948: function (e, t, o) {
			"use strict";
			var n = o(73800);
			e.exports = n && !!Symbol.for && !!Symbol.keyFor;
		  },
		  10586: function (e, t, o) {
			"use strict";
			var n = o(27876),
			  r = Math.max,
			  i = Math.min;
			e.exports = function (e, t) {
			  var o = n(e);
			  return 0 > o ? r(o + t, 0) : i(o, t);
			};
		  },
		  98651: function (e, t, o) {
			"use strict";
			var n = o(25049),
			  r = o(60265);
			e.exports = function (e) {
			  return n(r(e));
			};
		  },
		  27876: function (e, t, o) {
			"use strict";
			var n = o(43932);
			e.exports = function (e) {
			  var t = +e;
			  return t != t || 0 === t ? 0 : n(t);
			};
		  },
		  24431: function (e, t, o) {
			"use strict";
			var n = o(27876),
			  r = Math.min;
			e.exports = function (e) {
			  return e > 0 ? r(n(e), 9007199254740991) : 0;
			};
		  },
		  68488: function (e, t, o) {
			"use strict";
			var n = o(60265),
			  r = Object;
			e.exports = function (e) {
			  return r(n(e));
			};
		  },
		  11261: function (e, t, o) {
			"use strict";
			var n = o(9093),
			  r = o(8148),
			  i = o(88253),
			  a = o(20156),
			  s = o(82472),
			  l = o(19517),
			  c = TypeError,
			  u = l("toPrimitive");
			e.exports = function (e, t) {
			  if (!r(e) || i(e)) return e;
			  var o,
				l = a(e, u);
			  if (l) {
				if (
				  (void 0 === t && (t = "default"),
				  (o = n(l, e, t)),
				  !r(o) || i(o))
				)
				  return o;
				throw c("Can't convert object to primitive value");
			  }
			  return void 0 === t && (t = "number"), s(e, t);
			};
		  },
		  43836: function (e, t, o) {
			"use strict";
			var n = o(11261),
			  r = o(88253);
			e.exports = function (e) {
			  var t = n(e, "string");
			  return r(t) ? t : t + "";
			};
		  },
		  6424: function (e, t, o) {
			"use strict";
			var n = {};
			(n[o(19517)("toStringTag")] = "z"),
			  (e.exports = "[object z]" === String(n));
		  },
		  63046: function (e, t, o) {
			"use strict";
			var n = o(8652),
			  r = String;
			e.exports = function (e) {
			  if ("Symbol" === n(e))
				throw TypeError("Cannot convert a Symbol value to a string");
			  return r(e);
			};
		  },
		  98418: function (e) {
			"use strict";
			var t = String;
			e.exports = function (e) {
			  try {
				return t(e);
			  } catch (e) {
				return "Object";
			  }
			};
		  },
		  15257: function (e, t, o) {
			"use strict";
			var n = o(90838),
			  r = 0,
			  i = Math.random(),
			  a = n((1).toString);
			e.exports = function (e) {
			  return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++r + i, 36);
			};
		  },
		  57982: function (e, t, o) {
			"use strict";
			var n = o(73800);
			e.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
		  },
		  63142: function (e, t, o) {
			"use strict";
			var n = o(13873),
			  r = o(75834);
			e.exports =
			  n &&
			  r(function () {
				return (
				  42 !=
				  Object.defineProperty(function () {}, "prototype", {
					value: 42,
					writable: !1,
				  }).prototype
				);
			  });
		  },
		  95473: function (e, t, o) {
			"use strict";
			var n = o(37042),
			  r = o(794),
			  i = n.WeakMap;
			e.exports = r(i) && /native code/.test(String(i));
		  },
		  89633: function (e, t, o) {
			"use strict";
			var n = o(31116),
			  r = o(14434),
			  i = o(96767),
			  a = o(73252).f;
			e.exports = function (e) {
			  var t = n.Symbol || (n.Symbol = {});
			  r(t, e) || a(t, e, { value: i.f(e) });
			};
		  },
		  96767: function (e, t, o) {
			"use strict";
			var n = o(19517);
			t.f = n;
		  },
		  19517: function (e, t, o) {
			"use strict";
			var n = o(37042),
			  r = o(95138),
			  i = o(14434),
			  a = o(15257),
			  s = o(73800),
			  l = o(57982),
			  c = n.Symbol,
			  u = r("wks"),
			  d = l ? c.for || c : (c && c.withoutSetter) || a;
			e.exports = function (e) {
			  return (
				i(u, e) || (u[e] = s && i(c, e) ? c[e] : d("Symbol." + e)), u[e]
			  );
			};
		  },
		  54166: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(75834),
			  i = o(36222),
			  a = o(8148),
			  s = o(68488),
			  l = o(15050),
			  c = o(39505),
			  u = o(89476),
			  d = o(6429),
			  p = o(63833),
			  f = o(19517),
			  h = o(65190),
			  m = f("isConcatSpreadable"),
			  v =
				h >= 51 ||
				!r(function () {
				  var e = [];
				  return (e[m] = !1), e.concat()[0] !== e;
				}),
			  g = function (e) {
				if (!a(e)) return !1;
				var t = e[m];
				return void 0 !== t ? !!t : i(e);
			  };
			n(
			  {
				target: "Array",
				proto: !0,
				arity: 1,
				forced: !v || !p("concat"),
			  },
			  {
				concat: function (e) {
				  var t,
					o,
					n,
					r,
					i,
					a = s(this),
					p = d(a, 0),
					f = 0;
				  for (t = -1, n = arguments.length; n > t; t++)
					if (g((i = -1 === t ? a : arguments[t])))
					  for (r = l(i), c(f + r), o = 0; r > o; o++, f++)
						o in i && u(p, f, i[o]);
					else c(f + 1), u(p, f++, i);
				  return (p.length = f), p;
				},
			  },
			);
		  },
		  22513: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(56881).findIndex,
			  i = o(15179),
			  a = "findIndex",
			  s = !0;
			a in [] &&
			  Array(1).findIndex(function () {
				s = !1;
			  }),
			  n(
				{ target: "Array", proto: !0, forced: s },
				{
				  findIndex: function (e) {
					return r(
					  this,
					  e,
					  arguments.length > 1 ? arguments[1] : void 0,
					);
				  },
				},
			  ),
			  i(a);
		  },
		  70057: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(92707);
			n(
			  {
				target: "Array",
				stat: !0,
				forced: !o(7581)(function (e) {
				  Array.from(e);
				}),
			  },
			  { from: r },
			);
		  },
		  67507: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(98945),
			  i = o(55101),
			  a = o(9093),
			  s = o(90838),
			  l = o(75834),
			  c = o(794),
			  u = o(88253),
			  d = o(54832),
			  p = o(6693),
			  f = o(73800),
			  h = String,
			  m = r("JSON", "stringify"),
			  v = s(/./.exec),
			  g = s("".charAt),
			  y = s("".charCodeAt),
			  _ = s("".replace),
			  b = s((1).toString),
			  w = /[\uD800-\uDFFF]/g,
			  S = /^[\uD800-\uDBFF]$/,
			  C = /^[\uDC00-\uDFFF]$/,
			  j =
				!f ||
				l(function () {
				  var e = r("Symbol")();
				  return (
					"[null]" != m([e]) ||
					"{}" != m({ a: e }) ||
					"{}" != m(Object(e))
				  );
				}),
			  E = l(function () {
				return (
				  '"\\udf06\\ud834"' !== m("\udf06\ud834") ||
				  '"\\udead"' !== m("\udead")
				);
			  }),
			  x = function (e, t) {
				var o = d(arguments),
				  n = p(t);
				if (c(n) || (void 0 !== e && !u(e)))
				  return (
					(o[1] = function (e, t) {
					  if ((c(n) && (t = a(n, this, h(e), t)), !u(t))) return t;
					}),
					i(m, null, o)
				  );
			  },
			  k = function (e, t, o) {
				var n = g(o, t - 1),
				  r = g(o, t + 1);
				return (v(S, e) && !v(C, r)) || (v(C, e) && !v(S, n))
				  ? "\\u" + b(y(e, 0), 16)
				  : e;
			  };
			m &&
			  n(
				{ target: "JSON", stat: !0, arity: 3, forced: j || E },
				{
				  stringify: function (e, t, o) {
					var n = d(arguments),
					  r = i(j ? x : m, null, n);
					return E && "string" == typeof r ? _(r, w, k) : r;
				  },
				},
			  );
		  },
		  90217: function (e, t, o) {
			"use strict";
			var n = o(37042);
			o(44532)(n.JSON, "JSON", !0);
		  },
		  73477: function (e, t, o) {
			"use strict";
			o(44532)(Math, "Math", !0);
		  },
		  30165: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(73800),
			  i = o(75834),
			  a = o(23953),
			  s = o(68488);
			n(
			  {
				target: "Object",
				stat: !0,
				forced:
				  !r ||
				  i(function () {
					a.f(1);
				  }),
			  },
			  {
				getOwnPropertySymbols: function (e) {
				  var t = a.f;
				  return t ? t(s(e)) : [];
				},
			  },
			);
		  },
		  32044: function (e, t, o) {
			"use strict";
			var n = o(6424),
			  r = o(35065),
			  i = o(57555);
			n || r(Object.prototype, "toString", i, { unsafe: !0 });
		  },
		  93697: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(37042),
			  i = o(44532);
			n({ global: !0 }, { Reflect: {} }), i(r.Reflect, "Reflect", !0);
		  },
		  52867: function (e, t, o) {
			"use strict";
			var n = o(41397).charAt,
			  r = o(63046),
			  i = o(56113),
			  a = o(13759),
			  s = o(17427),
			  l = "String Iterator",
			  c = i.set,
			  u = i.getterFor(l);
			a(
			  String,
			  "String",
			  function (e) {
				c(this, { type: l, string: r(e), index: 0 });
			  },
			  function () {
				var e,
				  t = u(this),
				  o = t.string,
				  r = t.index;
				return o.length > r
				  ? ((e = n(o, r)), (t.index += e.length), s(e, !1))
				  : s(void 0, !0);
			  },
			);
		  },
		  28424: function (e, t, o) {
			"use strict";
			o(89633)("asyncIterator");
		  },
		  9656: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(37042),
			  i = o(9093),
			  a = o(90838),
			  s = o(70852),
			  l = o(13873),
			  c = o(73800),
			  u = o(75834),
			  d = o(14434),
			  p = o(54671),
			  f = o(52313),
			  h = o(98651),
			  m = o(43836),
			  v = o(63046),
			  g = o(32500),
			  y = o(93503),
			  _ = o(3385),
			  b = o(7792),
			  w = o(53305),
			  S = o(23953),
			  C = o(36999),
			  j = o(73252),
			  E = o(5770),
			  x = o(33244),
			  k = o(35065),
			  T = o(97548),
			  I = o(95138),
			  P = o(85475),
			  M = o(48889),
			  D = o(15257),
			  O = o(19517),
			  z = o(96767),
			  A = o(89633),
			  L = o(13829),
			  N = o(44532),
			  R = o(56113),
			  B = o(56881).forEach,
			  q = P("hidden"),
			  F = "Symbol",
			  H = R.set,
			  V = R.getterFor(F),
			  U = Object.prototype,
			  W = r.Symbol,
			  Y = W && W.prototype,
			  G = r.TypeError,
			  K = r.QObject,
			  X = C.f,
			  J = j.f,
			  $ = w.f,
			  Z = x.f,
			  Q = a([].push),
			  ee = I("symbols"),
			  te = I("op-symbols"),
			  oe = I("wks"),
			  ne = !K || !K.prototype || !K.prototype.findChild,
			  re =
				l &&
				u(function () {
				  return (
					7 !=
					y(
					  J({}, "a", {
						get: function () {
						  return J(this, "a", { value: 7 }).a;
						},
					  }),
					).a
				  );
				})
				  ? function (e, t, o) {
					  var n = X(U, t);
					  n && delete U[t], J(e, t, o), n && e !== U && J(U, t, n);
					}
				  : J,
			  ie = function (e, t) {
				var o = (ee[e] = y(Y));
				return (
				  H(o, { type: F, tag: e, description: t }),
				  l || (o.description = t),
				  o
				);
			  },
			  ae = function (e, t, o) {
				e === U && ae(te, t, o), f(e);
				var n = m(t);
				return (
				  f(o),
				  d(ee, n)
					? (o.enumerable
						? (d(e, q) && e[q][n] && (e[q][n] = !1),
						  (o = y(o, { enumerable: g(0, !1) })))
						: (d(e, q) || J(e, q, g(1, {})), (e[q][n] = !0)),
					  re(e, n, o))
					: J(e, n, o)
				);
			  },
			  se = function (e, t) {
				f(e);
				var o = h(t),
				  n = _(o).concat(de(o));
				return (
				  B(n, function (t) {
					(l && !i(le, o, t)) || ae(e, t, o[t]);
				  }),
				  e
				);
			  },
			  le = function (e) {
				var t = m(e),
				  o = i(Z, this, t);
				return (
				  !(this === U && d(ee, t) && !d(te, t)) &&
				  (!(
					o ||
					!d(this, t) ||
					!d(ee, t) ||
					(d(this, q) && this[q][t])
				  ) ||
					o)
				);
			  },
			  ce = function (e, t) {
				var o = h(e),
				  n = m(t);
				if (o !== U || !d(ee, n) || d(te, n)) {
				  var r = X(o, n);
				  return (
					!r ||
					  !d(ee, n) ||
					  (d(o, q) && o[q][n]) ||
					  (r.enumerable = !0),
					r
				  );
				}
			  },
			  ue = function (e) {
				var t = $(h(e)),
				  o = [];
				return (
				  B(t, function (e) {
					d(ee, e) || d(M, e) || Q(o, e);
				  }),
				  o
				);
			  },
			  de = function (e) {
				var t = e === U,
				  o = $(t ? te : h(e)),
				  n = [];
				return (
				  B(o, function (e) {
					!d(ee, e) || (t && !d(U, e)) || Q(n, ee[e]);
				  }),
				  n
				);
			  };
			c ||
			  ((W = function () {
				if (p(Y, this)) throw G("Symbol is not a constructor");
				var e =
					arguments.length && void 0 !== arguments[0]
					  ? v(arguments[0])
					  : void 0,
				  t = D(e),
				  o = function (e) {
					this === U && i(o, te, e),
					  d(this, q) && d(this[q], t) && (this[q][t] = !1),
					  re(this, t, g(1, e));
				  };
				return (
				  l && ne && re(U, t, { configurable: !0, set: o }), ie(t, e)
				);
			  }),
			  k((Y = W.prototype), "toString", function () {
				return V(this).tag;
			  }),
			  k(W, "withoutSetter", function (e) {
				return ie(D(e), e);
			  }),
			  (x.f = le),
			  (j.f = ae),
			  (E.f = se),
			  (C.f = ce),
			  (b.f = w.f = ue),
			  (S.f = de),
			  (z.f = function (e) {
				return ie(O(e), e);
			  }),
			  l &&
				(T(Y, "description", {
				  configurable: !0,
				  get: function () {
					return V(this).description;
				  },
				}),
				s || k(U, "propertyIsEnumerable", le, { unsafe: !0 }))),
			  n(
				{ global: !0, constructor: !0, wrap: !0, forced: !c, sham: !c },
				{ Symbol: W },
			  ),
			  B(_(oe), function (e) {
				A(e);
			  }),
			  n(
				{ target: F, stat: !0, forced: !c },
				{
				  useSetter: function () {
					ne = !0;
				  },
				  useSimple: function () {
					ne = !1;
				  },
				},
			  ),
			  n(
				{ target: "Object", stat: !0, forced: !c, sham: !l },
				{
				  create: function (e, t) {
					return void 0 === t ? y(e) : se(y(e), t);
				  },
				  defineProperty: ae,
				  defineProperties: se,
				  getOwnPropertyDescriptor: ce,
				},
			  ),
			  n(
				{ target: "Object", stat: !0, forced: !c },
				{ getOwnPropertyNames: ue },
			  ),
			  L(),
			  N(W, F),
			  (M[q] = !0);
		  },
		  64514: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(13873),
			  i = o(37042),
			  a = o(90838),
			  s = o(14434),
			  l = o(794),
			  c = o(54671),
			  u = o(63046),
			  d = o(97548),
			  p = o(58392),
			  f = i.Symbol,
			  h = f && f.prototype;
			if (
			  r &&
			  l(f) &&
			  (!("description" in h) || void 0 !== f().description)
			) {
			  var m = {},
				v = function () {
				  var e =
					  1 > arguments.length || void 0 === arguments[0]
						? void 0
						: u(arguments[0]),
					t = c(h, this) ? new f(e) : void 0 === e ? f() : f(e);
				  return "" === e && (m[t] = !0), t;
				};
			  p(v, f), (v.prototype = h), (h.constructor = v);
			  var g = "Symbol(test)" == String(f("test")),
				y = a(h.valueOf),
				_ = a(h.toString),
				b = /^Symbol\((.*)\)[^)]+$/,
				w = a("".replace),
				S = a("".slice);
			  d(h, "description", {
				configurable: !0,
				get: function () {
				  var e = y(this);
				  if (s(m, e)) return "";
				  var t = _(e),
					o = g ? S(t, 7, -1) : w(t, b, "$1");
				  return "" === o ? void 0 : o;
				},
			  }),
				n({ global: !0, constructor: !0, forced: !0 }, { Symbol: v });
			}
		  },
		  56202: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(98945),
			  i = o(14434),
			  a = o(63046),
			  s = o(95138),
			  l = o(31948),
			  c = s("string-to-symbol-registry"),
			  u = s("symbol-to-string-registry");
			n(
			  { target: "Symbol", stat: !0, forced: !l },
			  {
				for: function (e) {
				  var t = a(e);
				  if (i(c, t)) return c[t];
				  var o = r("Symbol")(t);
				  return (c[t] = o), (u[o] = t), o;
				},
			  },
			);
		  },
		  30733: function (e, t, o) {
			"use strict";
			o(89633)("hasInstance");
		  },
		  40327: function (e, t, o) {
			"use strict";
			o(89633)("isConcatSpreadable");
		  },
		  53639: function (e, t, o) {
			"use strict";
			o(89633)("iterator");
		  },
		  95661: function (e, t, o) {
			"use strict";
			o(9656), o(56202), o(71940), o(67507), o(30165);
		  },
		  71940: function (e, t, o) {
			"use strict";
			var n = o(50791),
			  r = o(14434),
			  i = o(88253),
			  a = o(98418),
			  s = o(95138),
			  l = o(31948),
			  c = s("symbol-to-string-registry");
			n(
			  { target: "Symbol", stat: !0, forced: !l },
			  {
				keyFor: function (e) {
				  if (!i(e)) throw TypeError(a(e) + " is not a symbol");
				  if (r(c, e)) return c[e];
				},
			  },
			);
		  },
		  7290: function (e, t, o) {
			"use strict";
			o(89633)("matchAll");
		  },
		  6147: function (e, t, o) {
			"use strict";
			o(89633)("match");
		  },
		  95122: function (e, t, o) {
			"use strict";
			o(89633)("replace");
		  },
		  61322: function (e, t, o) {
			"use strict";
			o(89633)("search");
		  },
		  39605: function (e, t, o) {
			"use strict";
			o(89633)("species");
		  },
		  49341: function (e, t, o) {
			"use strict";
			o(89633)("split");
		  },
		  28809: function (e, t, o) {
			"use strict";
			var n = o(89633),
			  r = o(13829);
			n("toPrimitive"), r();
		  },
		  82658: function (e, t, o) {
			"use strict";
			var n = o(98945),
			  r = o(89633),
			  i = o(44532);
			r("toStringTag"), i(n("Symbol"), "Symbol");
		  },
		  43967: function (e, t, o) {
			"use strict";
			o(89633)("unscopables");
		  },
		  690: function (e, t, o) {
			"use strict";
			e.exports = o(26002).polyfill();
		  },
		  26002: function (e, t, o) {
			"use strict";
			e.exports = (function () {
			  function e(e) {
				return "function" == typeof e;
			  }
			  var t = Array.isArray
				  ? Array.isArray
				  : function (e) {
					  return (
						"[object Array]" === Object.prototype.toString.call(e)
					  );
					},
				n = 0,
				r = void 0,
				i = void 0,
				a = function (e, t) {
				  (f[n] = e), (f[n + 1] = t), 2 === (n += 2) && (i ? i(h) : _());
				},
				s = "undefined" != typeof window ? window : void 0,
				l = s || {},
				c = l.MutationObserver || l.WebKitMutationObserver,
				u =
				  "undefined" == typeof self &&
				  "undefined" != typeof process &&
				  "[object process]" === {}.toString.call(process),
				d =
				  "undefined" != typeof Uint8ClampedArray &&
				  "undefined" != typeof importScripts &&
				  "undefined" != typeof MessageChannel;
			  function p() {
				var e = setTimeout;
				return function () {
				  return e(h, 1);
				};
			  }
			  var f = new Array(1e3);
			  function h() {
				for (var e = 0; n > e; e += 2)
				  (0, f[e])(f[e + 1]), (f[e] = void 0), (f[e + 1] = void 0);
				n = 0;
			  }
			  var m,
				v,
				g,
				y,
				_ = void 0;
			  function b(e, t) {
				var o = this,
				  n = new this.constructor(C);
				void 0 === n[S] && z(n);
				var r = o._state;
				if (r) {
				  var i = arguments[r - 1];
				  a(function () {
					return D(r, n, i, o._result);
				  });
				} else P(o, n, e, t);
				return n;
			  }
			  function w(e) {
				if (e && "object" == typeof e && e.constructor === this) return e;
				var t = new this(C);
				return x(t, e), t;
			  }
			  _ = u
				? function () {
					return process.nextTick(h);
				  }
				: c
				  ? ((v = 0),
					(g = new c(h)),
					(y = document.createTextNode("")),
					g.observe(y, { characterData: !0 }),
					function () {
					  y.data = v = ++v % 2;
					})
				  : d
					? (((m = new MessageChannel()).port1.onmessage = h),
					  function () {
						return m.port2.postMessage(0);
					  })
					: void 0 === s
					  ? (function () {
						  try {
							var e = Function("return this")().require("vertx");
							return void 0 !== (r = e.runOnLoop || e.runOnContext)
							  ? function () {
								  r(h);
								}
							  : p();
						  } catch (e) {
							return p();
						  }
						})()
					  : p();
			  var S = Math.random().toString(36).substring(2);
			  function C() {}
			  var j = void 0;
			  function E(t, o, n) {
				o.constructor === t.constructor &&
				n === b &&
				o.constructor.resolve === w
				  ? (function (e, t) {
					  1 === t._state
						? T(e, t._result)
						: 2 === t._state
						  ? I(e, t._result)
						  : P(
							  t,
							  void 0,
							  function (t) {
								return x(e, t);
							  },
							  function (t) {
								return I(e, t);
							  },
							);
					})(t, o)
				  : void 0 === n
					? T(t, o)
					: e(n)
					  ? (function (e, t, o) {
						  a(function (e) {
							var n = !1,
							  r = (function (o, r, i, a) {
								try {
								  o.call(
									r,
									function (o) {
									  n ||
										((n = !0), t !== o ? x(e, o) : T(e, o));
									},
									function (t) {
									  n || ((n = !0), I(e, t));
									},
								  );
								} catch (e) {
								  return e;
								}
							  })(o, t);
							!n && r && ((n = !0), I(e, r));
						  }, e);
						})(t, o, n)
					  : T(t, o);
			  }
			  function x(e, t) {
				if (e === t)
				  I(e, new TypeError("You cannot resolve a promise with itself"));
				else if (
				  ((r = typeof (n = t)),
				  null === n || ("object" !== r && "function" !== r))
				)
				  T(e, t);
				else {
				  var o = void 0;
				  try {
					o = t.then;
				  } catch (t) {
					return void I(e, t);
				  }
				  E(e, t, o);
				}
				var n, r;
			  }
			  function k(e) {
				e._onerror && e._onerror(e._result), M(e);
			  }
			  function T(e, t) {
				e._state === j &&
				  ((e._result = t),
				  (e._state = 1),
				  0 !== e._subscribers.length && a(M, e));
			  }
			  function I(e, t) {
				e._state === j && ((e._state = 2), (e._result = t), a(k, e));
			  }
			  function P(e, t, o, n) {
				var r = e._subscribers,
				  i = r.length;
				(e._onerror = null),
				  (r[i] = t),
				  (r[i + 1] = o),
				  (r[i + 2] = n),
				  0 === i && e._state && a(M, e);
			  }
			  function M(e) {
				var t = e._subscribers,
				  o = e._state;
				if (0 !== t.length) {
				  for (
					var n = void 0, r = void 0, i = e._result, a = 0;
					t.length > a;
					a += 3
				  )
					(r = t[a + o]), (n = t[a]) ? D(o, n, r, i) : r(i);
				  e._subscribers.length = 0;
				}
			  }
			  function D(t, o, n, r) {
				var i = e(n),
				  a = void 0,
				  s = void 0,
				  l = !0;
				if (i) {
				  try {
					a = n(r);
				  } catch (e) {
					(l = !1), (s = e);
				  }
				  if (o === a)
					return void I(
					  o,
					  new TypeError(
						"A promises callback cannot return that same promise.",
					  ),
					);
				} else a = r;
				o._state !== j ||
				  (i && l
					? x(o, a)
					: !1 === l
					  ? I(o, s)
					  : 1 === t
						? T(o, a)
						: 2 === t && I(o, a));
			  }
			  var O = 0;
			  function z(e) {
				(e[S] = O++),
				  (e._state = void 0),
				  (e._result = void 0),
				  (e._subscribers = []);
			  }
			  var A = (function () {
				  function e(e, o) {
					(this._instanceConstructor = e),
					  (this.promise = new e(C)),
					  this.promise[S] || z(this.promise),
					  t(o)
						? ((this.length = o.length),
						  (this._remaining = o.length),
						  (this._result = new Array(this.length)),
						  0 === this.length
							? T(this.promise, this._result)
							: ((this.length = this.length || 0),
							  this._enumerate(o),
							  0 === this._remaining &&
								T(this.promise, this._result)))
						: I(
							this.promise,
							new Error("Array Methods must be provided an Array"),
						  );
				  }
				  return (
					(e.prototype._enumerate = function (e) {
					  for (var t = 0; this._state === j && e.length > t; t++)
						this._eachEntry(e[t], t);
					}),
					(e.prototype._eachEntry = function (e, t) {
					  var o = this._instanceConstructor,
						n = o.resolve;
					  if (n === w) {
						var r = void 0,
						  i = void 0,
						  a = !1;
						try {
						  r = e.then;
						} catch (e) {
						  (a = !0), (i = e);
						}
						if (r === b && e._state !== j)
						  this._settledAt(e._state, t, e._result);
						else if ("function" != typeof r)
						  this._remaining--, (this._result[t] = e);
						else if (o === L) {
						  var s = new o(C);
						  a ? I(s, i) : E(s, e, r), this._willSettleAt(s, t);
						} else
						  this._willSettleAt(
							new o(function (t) {
							  return t(e);
							}),
							t,
						  );
					  } else this._willSettleAt(n(e), t);
					}),
					(e.prototype._settledAt = function (e, t, o) {
					  var n = this.promise;
					  n._state === j &&
						(this._remaining--,
						2 === e ? I(n, o) : (this._result[t] = o)),
						0 === this._remaining && T(n, this._result);
					}),
					(e.prototype._willSettleAt = function (e, t) {
					  var o = this;
					  P(
						e,
						void 0,
						function (e) {
						  return o._settledAt(1, t, e);
						},
						function (e) {
						  return o._settledAt(2, t, e);
						},
					  );
					}),
					e
				  );
				})(),
				L = (function () {
				  function t(e) {
					(this[S] = O++),
					  (this._result = this._state = void 0),
					  (this._subscribers = []),
					  C !== e &&
						("function" != typeof e &&
						  (function () {
							throw new TypeError(
							  "You must pass a resolver function as the first argument to the promise constructor",
							);
						  })(),
						this instanceof t
						  ? (function (e, t) {
							  try {
								t(
								  function (t) {
									x(e, t);
								  },
								  function (t) {
									I(e, t);
								  },
								);
							  } catch (t) {
								I(e, t);
							  }
							})(this, e)
						  : (function () {
							  throw new TypeError(
								"Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.",
							  );
							})());
				  }
				  return (
					(t.prototype.catch = function (e) {
					  return this.then(null, e);
					}),
					(t.prototype.finally = function (t) {
					  var o = this,
						n = o.constructor;
					  return e(t)
						? o.then(
							function (e) {
							  return n.resolve(t()).then(function () {
								return e;
							  });
							},
							function (e) {
							  return n.resolve(t()).then(function () {
								throw e;
							  });
							},
						  )
						: o.then(t, t);
					}),
					t
				  );
				})();
			  return (
				(L.prototype.then = b),
				(L.all = function (e) {
				  return new A(this, e).promise;
				}),
				(L.race = function (e) {
				  var o = this;
				  return t(e)
					? new o(function (t, n) {
						for (var r = e.length, i = 0; r > i; i++)
						  o.resolve(e[i]).then(t, n);
					  })
					: new o(function (e, t) {
						return t(
						  new TypeError("You must pass an array to race."),
						);
					  });
				}),
				(L.resolve = w),
				(L.reject = function (e) {
				  var t = new this(C);
				  return I(t, e), t;
				}),
				(L._setScheduler = function (e) {
				  i = e;
				}),
				(L._setAsap = function (e) {
				  a = e;
				}),
				(L._asap = a),
				(L.polyfill = function () {
				  var e = void 0;
				  if (void 0 !== o.g) e = o.g;
				  else if ("undefined" != typeof self) e = self;
				  else
					try {
					  e = Function("return this")();
					} catch (e) {
					  throw new Error(
						"polyfill failed because global object is unavailable in this environment",
					  );
					}
				  var t = e.Promise;
				  if (t) {
					var n = null;
					try {
					  n = Object.prototype.toString.call(t.resolve());
					} catch (e) {}
					if ("[object Promise]" === n && !t.cast) return;
				  }
				  e.Promise = L;
				}),
				(L.Promise = L),
				L
			  );
			})();
		  },
		  20255: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.__classPrivateFieldIn =
				t.__classPrivateFieldSet =
				t.__classPrivateFieldGet =
				t.__importDefault =
				t.__importStar =
				t.__makeTemplateObject =
				t.__asyncValues =
				t.__asyncDelegator =
				t.__asyncGenerator =
				t.__await =
				t.__spreadArray =
				t.__spreadArrays =
				t.__spread =
				t.__read =
				t.__values =
				t.__exportStar =
				t.__createBinding =
				t.__generator =
				t.__awaiter =
				t.__metadata =
				t.__setFunctionName =
				t.__propKey =
				t.__runInitializers =
				t.__esDecorate =
				t.__param =
				t.__decorate =
				t.__rest =
				t.__assign =
				t.__extends =
				  void 0);
			var o = function (e, t) {
			  return (
				(o =
				  Object.setPrototypeOf ||
				  ({ __proto__: [] } instanceof Array &&
					function (e, t) {
					  e.__proto__ = t;
					}) ||
				  function (e, t) {
					for (var o in t)
					  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
				  }),
				o(e, t)
			  );
			};
			function n(e) {
			  var t = "function" == typeof Symbol && Symbol.iterator,
				o = t && e[t],
				n = 0;
			  if (o) return o.call(e);
			  if (e && "number" == typeof e.length)
				return {
				  next: function () {
					return (
					  e && n >= e.length && (e = void 0),
					  { value: e && e[n++], done: !e }
					);
				  },
				};
			  throw new TypeError(
				t ? "Object is not iterable." : "Symbol.iterator is not defined.",
			  );
			}
			function r(e, t) {
			  var o = "function" == typeof Symbol && e[Symbol.iterator];
			  if (!o) return e;
			  var n,
				r,
				i = o.call(e),
				a = [];
			  try {
				for (; (void 0 === t || t-- > 0) && !(n = i.next()).done; )
				  a.push(n.value);
			  } catch (e) {
				r = { error: e };
			  } finally {
				try {
				  n && !n.done && (o = i.return) && o.call(i);
				} finally {
				  if (r) throw r.error;
				}
			  }
			  return a;
			}
			function i(e) {
			  return this instanceof i ? ((this.v = e), this) : new i(e);
			}
			(t.__extends = function (e, t) {
			  if ("function" != typeof t && null !== t)
				throw new TypeError(
				  "Class extends value " +
					String(t) +
					" is not a constructor or null",
				);
			  function n() {
				this.constructor = e;
			  }
			  o(e, t),
				(e.prototype =
				  null === t
					? Object.create(t)
					: ((n.prototype = t.prototype), new n()));
			}),
			  (t.__assign = function () {
				return (
				  (t.__assign =
					Object.assign ||
					function (e) {
					  for (var t, o = 1, n = arguments.length; n > o; o++)
						for (var r in (t = arguments[o]))
						  Object.prototype.hasOwnProperty.call(t, r) &&
							(e[r] = t[r]);
					  return e;
					}),
				  t.__assign.apply(this, arguments)
				);
			  }),
			  (t.__rest = function (e, t) {
				var o = {};
				for (var n in e)
				  Object.prototype.hasOwnProperty.call(e, n) &&
					0 > t.indexOf(n) &&
					(o[n] = e[n]);
				if (
				  null != e &&
				  "function" == typeof Object.getOwnPropertySymbols
				) {
				  var r = 0;
				  for (n = Object.getOwnPropertySymbols(e); n.length > r; r++)
					0 > t.indexOf(n[r]) &&
					  Object.prototype.propertyIsEnumerable.call(e, n[r]) &&
					  (o[n[r]] = e[n[r]]);
				}
				return o;
			  }),
			  (t.__decorate = function (e, t, o, n) {
				var r,
				  i = arguments.length,
				  a =
					3 > i
					  ? t
					  : null === n
						? (n = Object.getOwnPropertyDescriptor(t, o))
						: n;
				if (
				  "object" == typeof Reflect &&
				  "function" == typeof Reflect.decorate
				)
				  a = Reflect.decorate(e, t, o, n);
				else
				  for (var s = e.length - 1; s >= 0; s--)
					(r = e[s]) &&
					  (a = (3 > i ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
				return i > 3 && a && Object.defineProperty(t, o, a), a;
			  }),
			  (t.__param = function (e, t) {
				return function (o, n) {
				  t(o, n, e);
				};
			  }),
			  (t.__esDecorate = function (e, t, o, n, r, i) {
				function a(e) {
				  if (void 0 !== e && "function" != typeof e)
					throw new TypeError("Function expected");
				  return e;
				}
				for (
				  var s,
					l = n.kind,
					c = "getter" === l ? "get" : "setter" === l ? "set" : "value",
					u = !t && e ? (n.static ? e : e.prototype) : null,
					d =
					  t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}),
					p = !1,
					f = o.length - 1;
				  f >= 0;
				  f--
				) {
				  var h = {};
				  for (var m in n) h[m] = "access" === m ? {} : n[m];
				  for (var m in n.access) h.access[m] = n.access[m];
				  h.addInitializer = function (e) {
					if (p)
					  throw new TypeError(
						"Cannot add initializers after decoration has completed",
					  );
					i.push(a(e || null));
				  };
				  var v = (0, o[f])(
					"accessor" === l ? { get: d.get, set: d.set } : d[c],
					h,
				  );
				  if ("accessor" === l) {
					if (void 0 === v) continue;
					if (null === v || "object" != typeof v)
					  throw new TypeError("Object expected");
					(s = a(v.get)) && (d.get = s),
					  (s = a(v.set)) && (d.set = s),
					  (s = a(v.init)) && r.push(s);
				  } else (s = a(v)) && ("field" === l ? r.push(s) : (d[c] = s));
				}
				u && Object.defineProperty(u, n.name, d), (p = !0);
			  }),
			  (t.__runInitializers = function (e, t, o) {
				for (var n = arguments.length > 2, r = 0; t.length > r; r++)
				  o = n ? t[r].call(e, o) : t[r].call(e);
				return n ? o : void 0;
			  }),
			  (t.__propKey = function (e) {
				return "symbol" == typeof e ? e : "".concat(e);
			  }),
			  (t.__setFunctionName = function (e, t, o) {
				return (
				  "symbol" == typeof t &&
					(t = t.description ? "[".concat(t.description, "]") : ""),
				  Object.defineProperty(e, "name", {
					configurable: !0,
					value: o ? "".concat(o, " ", t) : t,
				  })
				);
			  }),
			  (t.__metadata = function (e, t) {
				if (
				  "object" == typeof Reflect &&
				  "function" == typeof Reflect.metadata
				)
				  return Reflect.metadata(e, t);
			  }),
			  (t.__awaiter = function (e, t, o, n) {
				return new (o || (o = Promise))(function (r, i) {
				  function a(e) {
					try {
					  l(n.next(e));
					} catch (e) {
					  i(e);
					}
				  }
				  function s(e) {
					try {
					  l(n.throw(e));
					} catch (e) {
					  i(e);
					}
				  }
				  function l(e) {
					var t;
					e.done
					  ? r(e.value)
					  : ((t = e.value),
						t instanceof o
						  ? t
						  : new o(function (e) {
							  e(t);
							})).then(a, s);
				  }
				  l((n = n.apply(e, t || [])).next());
				});
			  }),
			  (t.__generator = function (e, t) {
				var o,
				  n,
				  r,
				  i,
				  a = {
					label: 0,
					sent: function () {
					  if (1 & r[0]) throw r[1];
					  return r[1];
					},
					trys: [],
					ops: [],
				  };
				return (
				  (i = { next: s(0), throw: s(1), return: s(2) }),
				  "function" == typeof Symbol &&
					(i[Symbol.iterator] = function () {
					  return this;
					}),
				  i
				);
				function s(s) {
				  return function (l) {
					return (function (s) {
					  if (o)
						throw new TypeError("Generator is already executing.");
					  for (; i && ((i = 0), s[0] && (a = 0)), a; )
						try {
						  if (
							((o = 1),
							n &&
							  (r =
								2 & s[0]
								  ? n.return
								  : s[0]
									? n.throw || ((r = n.return) && r.call(n), 0)
									: n.next) &&
							  !(r = r.call(n, s[1])).done)
						  )
							return r;
						  switch (
							((n = 0), r && (s = [2 & s[0], r.value]), s[0])
						  ) {
							case 0:
							case 1:
							  r = s;
							  break;
							case 4:
							  return a.label++, { value: s[1], done: !1 };
							case 5:
							  a.label++, (n = s[1]), (s = [0]);
							  continue;
							case 7:
							  (s = a.ops.pop()), a.trys.pop();
							  continue;
							default:
							  if (
								!(
								  (r =
									(r = a.trys).length > 0 && r[r.length - 1]) ||
								  (6 !== s[0] && 2 !== s[0])
								)
							  ) {
								a = 0;
								continue;
							  }
							  if (
								3 === s[0] &&
								(!r || (s[1] > r[0] && r[3] > s[1]))
							  ) {
								a.label = s[1];
								break;
							  }
							  if (6 === s[0] && r[1] > a.label) {
								(a.label = r[1]), (r = s);
								break;
							  }
							  if (r && r[2] > a.label) {
								(a.label = r[2]), a.ops.push(s);
								break;
							  }
							  r[2] && a.ops.pop(), a.trys.pop();
							  continue;
						  }
						  s = t.call(e, a);
						} catch (e) {
						  (s = [6, e]), (n = 0);
						} finally {
						  o = r = 0;
						}
					  if (5 & s[0]) throw s[1];
					  return { value: s[0] ? s[1] : void 0, done: !0 };
					})([s, l]);
				  };
				}
			  }),
			  (t.__createBinding = Object.create
				? function (e, t, o, n) {
					void 0 === n && (n = o);
					var r = Object.getOwnPropertyDescriptor(t, o);
					(r &&
					  !("get" in r
						? !t.__esModule
						: r.writable || r.configurable)) ||
					  (r = {
						enumerable: !0,
						get: function () {
						  return t[o];
						},
					  }),
					  Object.defineProperty(e, n, r);
				  }
				: function (e, t, o, n) {
					void 0 === n && (n = o), (e[n] = t[o]);
				  }),
			  (t.__exportStar = function (e, o) {
				for (var n in e)
				  "default" === n ||
					Object.prototype.hasOwnProperty.call(o, n) ||
					(0, t.__createBinding)(o, e, n);
			  }),
			  (t.__values = n),
			  (t.__read = r),
			  (t.__spread = function () {
				for (var e = [], t = 0; arguments.length > t; t++)
				  e = e.concat(r(arguments[t]));
				return e;
			  }),
			  (t.__spreadArrays = function () {
				for (var e = 0, t = 0, o = arguments.length; o > t; t++)
				  e += arguments[t].length;
				var n = Array(e),
				  r = 0;
				for (t = 0; o > t; t++)
				  for (var i = arguments[t], a = 0, s = i.length; s > a; a++, r++)
					n[r] = i[a];
				return n;
			  }),
			  (t.__spreadArray = function (e, t, o) {
				if (o || 2 === arguments.length)
				  for (var n, r = 0, i = t.length; i > r; r++)
					(!n && r in t) ||
					  (n || (n = Array.prototype.slice.call(t, 0, r)),
					  (n[r] = t[r]));
				return e.concat(n || Array.prototype.slice.call(t));
			  }),
			  (t.__await = i),
			  (t.__asyncGenerator = function (e, t, o) {
				if (!Symbol.asyncIterator)
				  throw new TypeError("Symbol.asyncIterator is not defined.");
				var n,
				  r = o.apply(e, t || []),
				  a = [];
				return (
				  (n = {}),
				  s("next"),
				  s("throw"),
				  s("return"),
				  (n[Symbol.asyncIterator] = function () {
					return this;
				  }),
				  n
				);
				function s(e) {
				  r[e] &&
					(n[e] = function (t) {
					  return new Promise(function (o, n) {
						a.push([e, t, o, n]) > 1 || l(e, t);
					  });
					});
				}
				function l(e, t) {
				  try {
					(o = r[e](t)).value instanceof i
					  ? Promise.resolve(o.value.v).then(c, u)
					  : d(a[0][2], o);
				  } catch (e) {
					d(a[0][3], e);
				  }
				  var o;
				}
				function c(e) {
				  l("next", e);
				}
				function u(e) {
				  l("throw", e);
				}
				function d(e, t) {
				  e(t), a.shift(), a.length && l(a[0][0], a[0][1]);
				}
			  }),
			  (t.__asyncDelegator = function (e) {
				var t, o;
				return (
				  (t = {}),
				  n("next"),
				  n("throw", function (e) {
					throw e;
				  }),
				  n("return"),
				  (t[Symbol.iterator] = function () {
					return this;
				  }),
				  t
				);
				function n(n, r) {
				  t[n] = e[n]
					? function (t) {
						return (o = !o)
						  ? { value: i(e[n](t)), done: !1 }
						  : r
							? r(t)
							: t;
					  }
					: r;
				}
			  }),
			  (t.__asyncValues = function (e) {
				if (!Symbol.asyncIterator)
				  throw new TypeError("Symbol.asyncIterator is not defined.");
				var t,
				  o = e[Symbol.asyncIterator];
				return o
				  ? o.call(e)
				  : ((e = n(e)),
					(t = {}),
					r("next"),
					r("throw"),
					r("return"),
					(t[Symbol.asyncIterator] = function () {
					  return this;
					}),
					t);
				function r(o) {
				  t[o] =
					e[o] &&
					function (t) {
					  return new Promise(function (n, r) {
						!(function (e, t, o, n) {
						  Promise.resolve(n).then(function (t) {
							e({ value: t, done: o });
						  }, t);
						})(n, r, (t = e[o](t)).done, t.value);
					  });
					};
				}
			  }),
			  (t.__makeTemplateObject = function (e, t) {
				return (
				  Object.defineProperty
					? Object.defineProperty(e, "raw", { value: t })
					: (e.raw = t),
				  e
				);
			  });
			var a = Object.create
			  ? function (e, t) {
				  Object.defineProperty(e, "default", {
					enumerable: !0,
					value: t,
				  });
				}
			  : function (e, t) {
				  e.default = t;
				};
			(t.__importStar = function (e) {
			  if (e && e.__esModule) return e;
			  var o = {};
			  if (null != e)
				for (var n in e)
				  "default" !== n &&
					Object.prototype.hasOwnProperty.call(e, n) &&
					(0, t.__createBinding)(o, e, n);
			  return a(o, e), o;
			}),
			  (t.__importDefault = function (e) {
				return e && e.__esModule ? e : { default: e };
			  }),
			  (t.__classPrivateFieldGet = function (e, t, o, n) {
				if ("a" === o && !n)
				  throw new TypeError(
					"Private accessor was defined without a getter",
				  );
				if ("function" == typeof t ? e !== t || !n : !t.has(e))
				  throw new TypeError(
					"Cannot read private member from an object whose class did not declare it",
				  );
				return "m" === o
				  ? n
				  : "a" === o
					? n.call(e)
					: n
					  ? n.value
					  : t.get(e);
			  }),
			  (t.__classPrivateFieldSet = function (e, t, o, n, r) {
				if ("m" === n)
				  throw new TypeError("Private method is not writable");
				if ("a" === n && !r)
				  throw new TypeError(
					"Private accessor was defined without a setter",
				  );
				if ("function" == typeof t ? e !== t || !r : !t.has(e))
				  throw new TypeError(
					"Cannot write private member to an object whose class did not declare it",
				  );
				return (
				  "a" === n ? r.call(e, o) : r ? (r.value = o) : t.set(e, o), o
				);
			  }),
			  (t.__classPrivateFieldIn = function (e, t) {
				if (
				  null === t ||
				  ("object" != typeof t && "function" != typeof t)
				)
				  throw new TypeError("Cannot use 'in' operator on non-object");
				return "function" == typeof e ? t === e : e.has(t);
			  });
		  },
		  93166: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Config = void 0);
			var n = o(86893),
			  r = o(86893),
			  i = (function () {
				function e() {
				  (this.defaultTimeout = 100),
					(this.namespace = ""),
					(this.safeMode = !1),
					(this.width = "auto"),
					(this.height = "auto"),
					(this.safePluginsList = [
					  "about",
					  "enter",
					  "backspace",
					  "size",
					]),
					(this.license = ""),
					(this.preset = "custom"),
					(this.presets = {
					  inline: {
						inline: !0,
						toolbar: !1,
						toolbarInline: !0,
						toolbarInlineForSelection: !0,
						showXPathInStatusbar: !1,
						showCharsCounter: !1,
						showWordsCounter: !1,
						showPlaceholder: !1,
					  },
					}),
					(this.ownerDocument =
					  "undefined" != typeof document ? document : null),
					(this.ownerWindow =
					  "undefined" != typeof window ? window : null),
					(this.shadowRoot = null),
					(this.zIndex = 0),
					(this.readonly = !1),
					(this.disabled = !1),
					(this.activeButtonsInReadOnly = [
					  "source",
					  "fullsize",
					  "print",
					  "about",
					  "dots",
					  "selectall",
					]),
					(this.allowCommandsInReadOnly = [
					  "selectall",
					  "preview",
					  "print",
					]),
					(this.toolbarButtonSize = "middle"),
					(this.allowTabNavigation = !1),
					(this.inline = !1),
					(this.theme = "default"),
					(this.saveModeInStorage = !1),
					(this.editorClassName = !1),
					(this.editorCssClass = !1),
					(this.className = !1),
					(this.style = !1),
					(this.containerStyle = !1),
					(this.styleValues = {}),
					(this.triggerChangeEvent = !0),
					(this.direction = ""),
					(this.language = "auto"),
					(this.debugLanguage = !1),
					(this.i18n = !1),
					(this.tabIndex = -1),
					(this.toolbar = !0),
					(this.statusbar = !0),
					(this.showTooltip = !0),
					(this.showTooltipDelay = 1e3),
					(this.useNativeTooltip = !1),
					(this.defaultActionOnPaste = r.INSERT_AS_HTML),
					(this.enter = n.PARAGRAPH),
					(this.iframe = !1),
					(this.editHTMLDocumentMode = !1),
					(this.enterBlock =
					  "br" !== this.enter ? this.enter : n.PARAGRAPH),
					(this.defaultMode = n.MODE_WYSIWYG),
					(this.useSplitMode = !1),
					(this.colors = {
					  greyscale: [
						"#000000",
						"#434343",
						"#666666",
						"#999999",
						"#B7B7B7",
						"#CCCCCC",
						"#D9D9D9",
						"#EFEFEF",
						"#F3F3F3",
						"#FFFFFF",
					  ],
					  palette: [
						"#980000",
						"#FF0000",
						"#FF9900",
						"#FFFF00",
						"#00F0F0",
						"#00FFFF",
						"#4A86E8",
						"#0000FF",
						"#9900FF",
						"#FF00FF",
					  ],
					  full: [
						"#E6B8AF",
						"#F4CCCC",
						"#FCE5CD",
						"#FFF2CC",
						"#D9EAD3",
						"#D0E0E3",
						"#C9DAF8",
						"#CFE2F3",
						"#D9D2E9",
						"#EAD1DC",
						"#DD7E6B",
						"#EA9999",
						"#F9CB9C",
						"#FFE599",
						"#B6D7A8",
						"#A2C4C9",
						"#A4C2F4",
						"#9FC5E8",
						"#B4A7D6",
						"#D5A6BD",
						"#CC4125",
						"#E06666",
						"#F6B26B",
						"#FFD966",
						"#93C47D",
						"#76A5AF",
						"#6D9EEB",
						"#6FA8DC",
						"#8E7CC3",
						"#C27BA0",
						"#A61C00",
						"#CC0000",
						"#E69138",
						"#F1C232",
						"#6AA84F",
						"#45818E",
						"#3C78D8",
						"#3D85C6",
						"#674EA7",
						"#A64D79",
						"#85200C",
						"#990000",
						"#B45F06",
						"#BF9000",
						"#38761D",
						"#134F5C",
						"#1155CC",
						"#0B5394",
						"#351C75",
						"#733554",
						"#5B0F00",
						"#660000",
						"#783F04",
						"#7F6000",
						"#274E13",
						"#0C343D",
						"#1C4587",
						"#073763",
						"#20124D",
						"#4C1130",
					  ],
					}),
					(this.colorPickerDefaultTab = "background"),
					(this.imageDefaultWidth = 300),
					(this.removeButtons = []),
					(this.disablePlugins = []),
					(this.extraPlugins = []),
					(this.extraButtons = []),
					(this.extraIcons = {}),
					(this.createAttributes = {
					  table: { style: "border-collapse:collapse;width: 100%;" },
					}),
					(this.sizeLG = 900),
					(this.sizeMD = 700),
					(this.sizeSM = 400),
					(this.buttons = [
					  { group: "font-style", buttons: [] },
					  { group: "list", buttons: [] },
					  { group: "font", buttons: [] },
					  "---",
					  { group: "script", buttons: [] },
					  { group: "media", buttons: [] },
					  "\n",
					  { group: "state", buttons: [] },
					  { group: "clipboard", buttons: [] },
					  { group: "insert", buttons: [] },
					  { group: "indent", buttons: [] },
					  { group: "color", buttons: [] },
					  { group: "form", buttons: [] },
					  "---",
					  { group: "history", buttons: [] },
					  { group: "search", buttons: [] },
					  { group: "source", buttons: [] },
					  { group: "other", buttons: [] },
					  { group: "info", buttons: [] },
					]),
					(this.buttonsMD = [
					  "bold",
					  "italic",
					  "|",
					  "ul",
					  "ol",
					  "eraser",
					  "|",
					  "font",
					  "fontsize",
					  "---",
					  "image",
					  "table",
					  "|",
					  "link",
					  "\n",
					  "brush",
					  "paragraph",
					  "align",
					  "|",
					  "hr",
					  "copyformat",
					  "fullsize",
					  "---",
					  "undo",
					  "redo",
					  "|",
					  "dots",
					]),
					(this.buttonsSM = [
					  "bold",
					  "italic",
					  "|",
					  "ul",
					  "ol",
					  "eraser",
					  "|",
					  "fontsize",
					  "brush",
					  "paragraph",
					  "---",
					  "image",
					  "table",
					  "\n",
					  "link",
					  "|",
					  "align",
					  "|",
					  "undo",
					  "redo",
					  "|",
					  "copyformat",
					  "fullsize",
					  "---",
					  "dots",
					]),
					(this.buttonsXS = [
					  "bold",
					  "brush",
					  "paragraph",
					  "eraser",
					  "|",
					  "fontsize",
					  "---",
					  "image",
					  "\n",
					  "align",
					  "undo",
					  "redo",
					  "|",
					  "link",
					  "table",
					  "---",
					  "dots",
					]),
					(this.events = {}),
					(this.textIcons = !1),
					(this.showBrowserColorPicker = !0);
				}
				return (
				  Object.defineProperty(e, "defaultOptions", {
					get: function () {
					  return (
						e.__defaultOptions || (e.__defaultOptions = new e()),
						e.__defaultOptions
					  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  e
				);
			  })();
			(t.Config = i), (i.prototype.controls = {});
		  },
		  77536: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Async = void 0);
			var n = o(20255),
			  r = o(4696),
			  i = o(42096),
			  a = o(79736),
			  s = o(26335),
			  l = o(24421),
			  c = o(61817),
			  u =
				(o(52378),
				(function () {
				  function e() {
					var e,
					  t,
					  o,
					  n,
					  r = this;
					(this.timers = new Map()),
					  (this.__callbacks = new Map()),
					  (this.promisesRejections = new Set()),
					  (this.requestsIdle = new Set()),
					  (this.requestsRaf = new Set()),
					  (this.requestIdleCallbackNative =
						null !==
						  (t =
							null === (e = window.requestIdleCallback) ||
							void 0 === e
							  ? void 0
							  : e.bind(window)) && void 0 !== t
						  ? t
						  : function (e, t) {
							  var o,
								n = Date.now();
							  return r.setTimeout(
								function () {
								  e({
									didTimeout: !1,
									timeRemaining: function () {
									  return Math.max(0, 50 - (Date.now() - n));
									},
								  });
								},
								null !== (o = null == t ? void 0 : t.timeout) &&
								  void 0 !== o
								  ? o
								  : 1,
							  );
							}),
					  (this.cancelIdleCallbackNative =
						null !==
						  (n =
							null === (o = window.cancelIdleCallback) ||
							void 0 === o
							  ? void 0
							  : o.bind(window)) && void 0 !== n
						  ? n
						  : function (e) {
							  r.clearTimeout(e);
							}),
					  (this.isDestructed = !1);
				  }
				  return (
					(e.prototype.delay = function (e) {
					  var t = this;
					  return this.promise(function (o) {
						return t.setTimeout(o, e);
					  });
					}),
					(e.prototype.setTimeout = function (e, t) {
					  for (var o = [], i = 2; arguments.length > i; i++)
						o[i - 2] = arguments[i];
					  if (this.isDestructed) return 0;
					  var a = {};
					  (0, c.isNumber)(t) || (t = (a = t).timeout || 0),
						a.label && this.clearLabel(a.label);
					  var s = r.setTimeout.apply(
						  void 0,
						  n.__spreadArray([e, t], n.__read(o), !1),
						),
						l = a.label || s;
					  return this.timers.set(l, s), this.__callbacks.set(l, e), s;
					}),
					(e.prototype.updateTimeout = function (e, t) {
					  if (!e || !this.timers.has(e)) return null;
					  var o = this.__callbacks.get(e);
					  return this.setTimeout(o, { label: e, timeout: t });
					}),
					(e.prototype.clearLabel = function (e) {
					  e &&
						this.timers.has(e) &&
						((0, r.clearTimeout)(this.timers.get(e)),
						this.timers.delete(e),
						this.__callbacks.delete(e));
					}),
					(e.prototype.clearTimeout = function (e) {
					  if ((0, l.isString)(e)) return this.clearLabel(e);
					  (0, r.clearTimeout)(e),
						this.timers.delete(e),
						this.__callbacks.delete(e);
					}),
					(e.prototype.debounce = function (e, t, o) {
					  var l = this;
					  void 0 === o && (o = !1);
					  var c = 0,
						u = !1,
						d = [],
						p = function () {
						  for (var t = [], o = 0; arguments.length > o; o++)
							t[o] = arguments[o];
						  if (!u) {
							c = 0;
							var r = e.apply(
							  void 0,
							  n.__spreadArray([], n.__read(t), !1),
							);
							if (((u = !0), d.length)) {
							  var i = function () {
								d.forEach(function (e) {
								  return e();
								}),
								  (d.length = 0);
							  };
							  (0, s.isPromise)(r) ? r.finally(i) : i();
							}
						  }
						},
						f = function () {
						  for (var a = [], s = 0; arguments.length > s; s++)
							a[s] = arguments[s];
						  (u = !1),
							t
							  ? (!c &&
								  o &&
								  p.apply(
									void 0,
									n.__spreadArray([], n.__read(a), !1),
								  ),
								(0, r.clearTimeout)(c),
								(c = l.setTimeout(
								  function () {
									return p.apply(
									  void 0,
									  n.__spreadArray([], n.__read(a), !1),
									);
								  },
								  (0, i.isFunction)(t) ? t() : t,
								)),
								l.timers.set(e, c))
							  : p.apply(
								  void 0,
								  n.__spreadArray([], n.__read(a), !1),
								);
						};
					  return (0, a.isPlainObject)(t) && t.promisify
						? function () {
							for (var e = [], t = 0; arguments.length > t; t++)
							  e[t] = arguments[t];
							var o = l.promise(function (e) {
							  d.push(e);
							});
							return (
							  f.apply(
								void 0,
								n.__spreadArray([], n.__read(e), !1),
							  ),
							  o
							);
						  }
						: f;
					}),
					(e.prototype.throttle = function (e, t, o) {
					  var r = this;
					  void 0 === o && (o = !1);
					  var a,
						s,
						l,
						c = null;
					  return function () {
						for (var o = [], u = 0; arguments.length > u; u++)
						  o[u] = arguments[u];
						(a = !0),
						  (l = o),
						  t
							? c ||
							  (s = function () {
								a
								  ? (e.apply(
									  void 0,
									  n.__spreadArray([], n.__read(l), !1),
									),
									(a = !1),
									(c = r.setTimeout(
									  s,
									  (0, i.isFunction)(t) ? t() : t,
									)),
									r.timers.set(s, c))
								  : (c = null);
							  })()
							: e.apply(
								void 0,
								n.__spreadArray([], n.__read(l), !1),
							  );
					  };
					}),
					(e.prototype.promise = function (e) {
					  var t = this,
						o = function () {},
						n = new Promise(function (n, r) {
						  return t.promisesRejections.add(r), (o = r), e(n, r);
						});
					  return (
						n.finally ||
						  (n.finally = function (e) {
							return n.then(e).catch(e), n;
						  }),
						n
						  .finally(function () {
							t.promisesRejections.delete(o);
						  })
						  .catch(function () {
							return null;
						  }),
						(n.rejectCallback = o),
						n
					  );
					}),
					(e.prototype.promiseState = function (e) {
					  var t = this;
					  if (e.status) return e.status;
					  if (!Promise.race)
						return new Promise(function (o) {
						  e.then(
							function (e) {
							  return o("fulfilled"), e;
							},
							function (e) {
							  throw (o("rejected"), e);
							},
						  ),
							t.setTimeout(function () {
							  o("pending");
							}, 100);
						});
					  var o = {};
					  return Promise.race([e, o]).then(
						function (e) {
						  return e === o ? "pending" : "fulfilled";
						},
						function () {
						  return "rejected";
						},
					  );
					}),
					(e.prototype.requestIdleCallback = function (e, t) {
					  var o = this.requestIdleCallbackNative(e, t);
					  return this.requestsIdle.add(o), o;
					}),
					(e.prototype.requestIdlePromise = function (e) {
					  var t = this;
					  return this.promise(function (o) {
						var n = t.requestIdleCallback(function () {
						  return o(n);
						}, e);
					  });
					}),
					(e.prototype.cancelIdleCallback = function (e) {
					  return (
						this.requestsIdle.delete(e),
						this.cancelIdleCallbackNative(e)
					  );
					}),
					(e.prototype.requestAnimationFrame = function (e) {
					  var t = requestAnimationFrame(e);
					  return this.requestsRaf.add(t), t;
					}),
					(e.prototype.cancelAnimationFrame = function (e) {
					  this.requestsRaf.delete(e), cancelAnimationFrame(e);
					}),
					(e.prototype.clear = function () {
					  var e = this;
					  this.requestsIdle.forEach(function (t) {
						return e.cancelIdleCallback(t);
					  }),
						this.requestsRaf.forEach(function (t) {
						  return e.cancelAnimationFrame(t);
						}),
						this.timers.forEach(function (t) {
						  return (0, r.clearTimeout)(e.timers.get(t));
						}),
						this.timers.clear(),
						this.promisesRejections.forEach(function (e) {
						  return e();
						}),
						this.promisesRejections.clear();
					}),
					(e.prototype.destruct = function () {
					  this.clear(), (this.isDestructed = !0);
					}),
					e
				  );
				})());
			t.Async = u;
		  },
		  22630: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(77536), t);
		  },
		  45113: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Component = void 0);
			var n = o(40332),
			  r = o(17332),
			  i = o(29411),
			  a = o(22630),
			  s = new Map(),
			  l = (function () {
				function e() {
				  (this.async = new a.Async()),
					(this.ownerWindow = window),
					(this.__componentStatus = i.STATUSES.beforeInit),
					(this.uid = "jodit-uid-" + (0, r.uniqueUid)());
				}
				return (
				  Object.defineProperty(e.prototype, "componentName", {
					get: function () {
					  return (
						this.__componentName ||
						  (this.__componentName =
							"jodit-" +
							(0, n.kebabCase)(
							  ((0, n.isFunction)(this.className)
								? this.className()
								: "") || (0, n.getClassName)(this),
							)),
						this.__componentName
					  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (e.prototype.getFullElName = function (e, t, o) {
					var r = [this.componentName];
					return (
					  e &&
						((e = e.replace(/[^a-z0-9-]/gi, "-")),
						r.push("__".concat(e))),
					  t &&
						(r.push("_", t),
						r.push("_", (0, n.isVoid)(o) ? "true" : o.toString())),
					  r.join("")
					);
				  }),
				  Object.defineProperty(e.prototype, "ownerDocument", {
					get: function () {
					  return this.ow.document;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(e.prototype, "od", {
					get: function () {
					  return this.ownerDocument;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(e.prototype, "ow", {
					get: function () {
					  return this.ownerWindow;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (e.prototype.get = function (e, t) {
					return (0, n.get)(e, t || this);
				  }),
				  Object.defineProperty(e.prototype, "isReady", {
					get: function () {
					  return this.componentStatus === i.STATUSES.ready;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(e.prototype, "isDestructed", {
					get: function () {
					  return this.componentStatus === i.STATUSES.destructed;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(e.prototype, "isInDestruct", {
					get: function () {
					  return (
						i.STATUSES.beforeDestruct === this.componentStatus ||
						i.STATUSES.destructed === this.componentStatus
					  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (e.prototype.bindDestruct = function (e) {
					var t = this;
					return (
					  e.hookStatus(i.STATUSES.beforeDestruct, function () {
						return !t.isInDestruct && t.destruct();
					  }),
					  this
					);
				  }),
				  (e.prototype.destruct = function () {
					this.setStatus(i.STATUSES.destructed),
					  this.async.destruct(),
					  s.get(this) && s.delete(this);
				  }),
				  Object.defineProperty(e.prototype, "componentStatus", {
					get: function () {
					  return this.__componentStatus;
					},
					set: function (e) {
					  this.setStatus(e);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (e.prototype.setStatus = function (e) {
					return this.setStatusComponent(e, this);
				  }),
				  (e.prototype.setStatusComponent = function (e, t) {
					if (e !== this.__componentStatus) {
					  t === this && (this.__componentStatus = e);
					  var o = Object.getPrototypeOf(this);
					  o &&
						(0, n.isFunction)(o.setStatusComponent) &&
						o.setStatusComponent(e, t);
					  var r = s.get(this),
						i = null == r ? void 0 : r[e];
					  i &&
						i.length &&
						i.forEach(function (e) {
						  return e(t);
						});
					}
				  }),
				  (e.prototype.hookStatus = function (e, t) {
					var o = s.get(this);
					o || s.set(this, (o = {})), o[e] || (o[e] = []), o[e].push(t);
				  }),
				  (e.isInstanceOf = function (e, t) {
					return e instanceof t;
				  }),
				  (e.STATUSES = i.STATUSES),
				  e
				);
			  })();
			t.Component = l;
		  },
		  56562: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(29411), t),
			  n.__exportStar(o(45113), t),
			  n.__exportStar(o(39840), t);
		  },
		  29411: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.STATUSES = void 0),
			  (t.STATUSES = {
				beforeInit: "beforeInit",
				ready: "ready",
				beforeDestruct: "beforeDestruct",
				destructed: "destructed",
			  });
		  },
		  39840: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ViewComponent = void 0);
			var n = o(20255),
			  r = (function (e) {
				function t(t) {
				  var o = e.call(this) || this;
				  return o.setParentView(t), o;
				}
				return (
				  n.__extends(t, e),
				  Object.defineProperty(t.prototype, "j", {
					get: function () {
					  return this.jodit;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "defaultTimeout", {
					get: function () {
					  return this.j.defaultTimeout;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.i18n = function (e) {
					for (var t, o = [], r = 1; arguments.length > r; r++)
					  o[r - 1] = arguments[r];
					return (t = this.j).i18n.apply(
					  t,
					  n.__spreadArray([e], n.__read(o), !1),
					);
				  }),
				  (t.prototype.setParentView = function (e) {
					return (this.jodit = e), e.components.add(this), this;
				  }),
				  (t.prototype.destruct = function () {
					return (
					  this.j.components.delete(this),
					  e.prototype.destruct.call(this)
					);
				  }),
				  t
				);
			  })(o(45113).Component);
			t.ViewComponent = r;
		  },
		  86893: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.CLIPBOARD_ID =
				t.lang =
				t.TEMP_ATTR =
				t.BASE_PATH =
				t.KEY_ALIASES =
				t.IS_MAC =
				t.SAFE_COUNT_CHANGE_CALL =
				t.INSERT_ONLY_TEXT =
				t.INSERT_AS_TEXT =
				t.INSERT_CLEAR_HTML =
				t.INSERT_AS_HTML =
				t.EMULATE_DBLCLICK_TIMEOUT =
				t.MARKER_CLASS =
				t.TEXT_RTF =
				t.TEXT_HTML =
				t.TEXT_PLAIN =
				t.IS_IE =
				t.MODE_SPLIT =
				t.MODE_SOURCE =
				t.MODE_WYSIWYG =
				t.PARAGRAPH =
				t.BR =
				t.COMMAND_KEYS =
				t.ACCURACY =
				t.NEARBY =
				t.KEY_F3 =
				t.KEY_DELETE =
				t.KEY_SPACE =
				t.KEY_DOWN =
				t.KEY_RIGHT =
				t.KEY_UP =
				t.KEY_LEFT =
				t.KEY_ALT =
				t.KEY_ESC =
				t.KEY_ENTER =
				t.KEY_TAB =
				t.KEY_BACKSPACE =
				t.KEY_META =
				t.NO_EMPTY_TAGS =
				t.INSEPARABLE_TAGS =
				t.IS_INLINE =
				t.IS_BLOCK =
				t.SPACE_REG_EXP_END =
				t.SPACE_REG_EXP_START =
				t.SPACE_REG_EXP =
				t.INVISIBLE_SPACE_REG_EXP_START =
				t.INVISIBLE_SPACE_REG_EXP_END =
				t.INVISIBLE_SPACE_REG_EXP =
				t.NBSP_SPACE =
				t.INVISIBLE_SPACE =
				  void 0),
			  (t.SOURCE_CONSUMER = void 0);
			var n = o(20255);
			(t.INVISIBLE_SPACE = "\ufeff"),
			  (t.NBSP_SPACE = " "),
			  (t.INVISIBLE_SPACE_REG_EXP = function () {
				return /[\uFEFF]/g;
			  }),
			  (t.INVISIBLE_SPACE_REG_EXP_END = function () {
				return /[\uFEFF]+$/g;
			  }),
			  (t.INVISIBLE_SPACE_REG_EXP_START = function () {
				return /^[\uFEFF]+/g;
			  }),
			  (t.SPACE_REG_EXP = function () {
				return /[\s\n\t\r\uFEFF\u200b]+/g;
			  }),
			  (t.SPACE_REG_EXP_START = function () {
				return /^[\s\n\t\r\uFEFF\u200b]+/g;
			  }),
			  (t.SPACE_REG_EXP_END = function () {
				return /[\s\n\t\r\uFEFF\u200b]+$/g;
			  }),
			  (t.IS_BLOCK =
				/^(ADDRESS|ARTICLE|ASIDE|BLOCKQUOTE|CANVAS|DD|DFN|DIV|DL|DT|FIELDSET|FIGCAPTION|FIGURE|FOOTER|FORM|H[1-6]|HEADER|HGROUP|HR|LI|MAIN|NAV|NOSCRIPT|OUTPUT|P|PRE|RUBY|SCRIPT|STYLE|OBJECT|OL|SECTION|IFRAME|JODIT|JODIT-MEDIA|UL|TR|TD|TH|TBODY|THEAD|TFOOT|TABLE|BODY|HTML|VIDEO)$/i),
			  (t.IS_INLINE = /^(STRONG|SPAN|I|EM|B|SUP|SUB|A|U)$/i);
			var r = [
			  "img",
			  "video",
			  "svg",
			  "iframe",
			  "script",
			  "input",
			  "textarea",
			  "link",
			  "jodit",
			  "jodit-media",
			];
			(t.INSEPARABLE_TAGS = new Set(
			  n.__spreadArray(
				n.__spreadArray([], n.__read(r), !1),
				["br", "hr"],
				!1,
			  ),
			)),
			  (t.NO_EMPTY_TAGS = new Set(r)),
			  (t.KEY_META = "Meta"),
			  (t.KEY_BACKSPACE = "Backspace"),
			  (t.KEY_TAB = "Tab"),
			  (t.KEY_ENTER = "Enter"),
			  (t.KEY_ESC = "Escape"),
			  (t.KEY_ALT = "Alt"),
			  (t.KEY_LEFT = "ArrowLeft"),
			  (t.KEY_UP = "ArrowUp"),
			  (t.KEY_RIGHT = "ArrowRight"),
			  (t.KEY_DOWN = "ArrowDown"),
			  (t.KEY_SPACE = "Space"),
			  (t.KEY_DELETE = "Delete"),
			  (t.KEY_F3 = "F3"),
			  (t.NEARBY = 5),
			  (t.ACCURACY = 10),
			  (t.COMMAND_KEYS = [
				t.KEY_META,
				t.KEY_BACKSPACE,
				t.KEY_DELETE,
				t.KEY_UP,
				t.KEY_DOWN,
				t.KEY_RIGHT,
				t.KEY_LEFT,
				t.KEY_ENTER,
				t.KEY_ESC,
				t.KEY_F3,
				t.KEY_TAB,
			  ]),
			  (t.BR = "br"),
			  (t.PARAGRAPH = "p"),
			  (t.MODE_WYSIWYG = 1),
			  (t.MODE_SOURCE = 2),
			  (t.MODE_SPLIT = 3),
			  (t.IS_IE =
				"undefined" != typeof navigator &&
				(-1 !== navigator.userAgent.indexOf("MSIE") ||
				  /rv:11.0/i.test(navigator.userAgent))),
			  (t.TEXT_PLAIN = t.IS_IE ? "text" : "text/plain"),
			  (t.TEXT_HTML = t.IS_IE ? "html" : "text/html"),
			  (t.TEXT_RTF = t.IS_IE ? "rtf" : "text/rtf"),
			  (t.MARKER_CLASS = "jodit-selection_marker"),
			  (t.EMULATE_DBLCLICK_TIMEOUT = 300),
			  (t.INSERT_AS_HTML = "insert_as_html"),
			  (t.INSERT_CLEAR_HTML = "insert_clear_html"),
			  (t.INSERT_AS_TEXT = "insert_as_text"),
			  (t.INSERT_ONLY_TEXT = "insert_only_text"),
			  (t.SAFE_COUNT_CHANGE_CALL = 10),
			  (t.IS_MAC =
				"undefined" != typeof window &&
				/Mac|iPod|iPhone|iPad/.test(window.navigator.platform)),
			  (t.KEY_ALIASES = {
				add: "+",
				break: "pause",
				cmd: "meta",
				command: "meta",
				ctl: "control",
				ctrl: "control",
				del: "delete",
				down: "arrowdown",
				esc: "escape",
				ins: "insert",
				left: "arrowleft",
				mod: t.IS_MAC ? "meta" : "control",
				opt: "alt",
				option: "alt",
				return: "enter",
				right: "arrowright",
				space: " ",
				spacebar: " ",
				up: "arrowup",
				win: "meta",
				windows: "meta",
			  }),
			  (t.BASE_PATH = (function () {
				if ("undefined" == typeof document) return "";
				var e = document.currentScript,
				  t = function (e) {
					var t = e.split("/");
					return /\.js/.test(t[t.length - 1])
					  ? t.slice(0, t.length - 1).join("/") + "/"
					  : e;
				  };
				if (e) return t(e.src);
				var o = document.querySelectorAll("script[src]");
				return o && o.length
				  ? t(o[o.length - 1].src)
				  : window.location.href;
			  })()),
			  (t.TEMP_ATTR = "data-jodit-temp"),
			  (t.lang = {}),
			  (t.CLIPBOARD_ID = "clipboard"),
			  (t.SOURCE_CONSUMER = "source-consumer");
		  },
		  31897: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Create = void 0);
			var n = o(40332),
			  r = (o(52378), o(64968)),
			  i = o(86893),
			  a = (function () {
				function e(e, t) {
				  (this.document = e), (this.createAttributes = t);
				}
				return (
				  Object.defineProperty(e.prototype, "doc", {
					get: function () {
					  return (0, n.isFunction)(this.document)
						? this.document()
						: this.document;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (e.prototype.element = function (e, t, o) {
					var r = this,
					  i = this.doc.createElement(e.toLowerCase());
					return (
					  this.applyCreateAttributes(i),
					  t &&
						((0, n.isPlainObject)(t) ? (0, n.attr)(i, t) : (o = t)),
					  o &&
						(0, n.asArray)(o).forEach(function (e) {
						  return i.appendChild(
							(0, n.isString)(e) ? r.fromHTML(e) : e,
						  );
						}),
					  i
					);
				  }),
				  (e.prototype.div = function (e, t, o) {
					var n = this.element("div", t, o);
					return e && (n.className = e), n;
				  }),
				  (e.prototype.sandbox = function () {
					var e,
					  t = this.element("iframe", {
						sandbox: "allow-same-origin",
					  });
					this.doc.body.appendChild(t);
					var o =
					  null === (e = t.contentWindow) || void 0 === e
						? void 0
						: e.document;
					if (!o) throw Error("Iframe error");
					return (
					  o.open(),
					  o.write(
						"<!DOCTYPE html><html><head></head><body></body></html>",
					  ),
					  o.close(),
					  o.body
					);
				  }),
				  (e.prototype.span = function (e, t, o) {
					var n = this.element("span", t, o);
					return e && (n.className = e), n;
				  }),
				  (e.prototype.a = function (e, t, o) {
					var n = this.element("a", t, o);
					return e && (n.className = e), n;
				  }),
				  (e.prototype.text = function (e) {
					return this.doc.createTextNode(e);
				  }),
				  (e.prototype.fake = function () {
					return this.text(i.INVISIBLE_SPACE);
				  }),
				  (e.prototype.fragment = function () {
					return this.doc.createDocumentFragment();
				  }),
				  (e.prototype.fromHTML = function (e, t) {
					var o = this.div();
					o.innerHTML = e.toString();
					var i =
					  o.firstChild === o.lastChild && o.firstChild
						? o.firstChild
						: o;
					if ((r.Dom.safeRemove(i), t)) {
					  var a = (0, n.refs)(i);
					  Object.keys(t).forEach(function (e) {
						var o = a[e];
						o && !1 === t[e] && r.Dom.hide(o);
					  });
					}
					return i;
				  }),
				  (e.prototype.applyCreateAttributes = function (e) {
					if (this.createAttributes) {
					  var t = this.createAttributes;
					  if (t && t[e.tagName.toLowerCase()]) {
						var o = t[e.tagName.toLowerCase()];
						(0, n.isFunction)(o)
						  ? o(e)
						  : (0, n.isPlainObject)(o) && (0, n.attr)(e, o);
					  }
					}
				  }),
				  e
				);
			  })();
			t.Create = a;
		  },
		  42841: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(31897), t);
		  },
		  32358: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.cache = void 0);
			var n = o(40332);
			t.cache = function (e, t, o) {
			  var r = o.get;
			  if (!r) throw (0, n.error)("Getter property descriptor expected");
			  o.get = function () {
				var e = r.call(this);
				return (
				  (e && !0 === e.noCache) ||
					Object.defineProperty(this, t, {
					  configurable: o.configurable,
					  enumerable: o.enumerable,
					  writable: !1,
					  value: e,
					}),
				  e
				);
			  };
			};
		  },
		  11441: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.component = void 0);
			var n = o(20255);
			t.component = function (e) {
			  var t = (function (e) {
				function t() {
				  for (var o = [], r = 0; arguments.length > r; r++)
					o[r] = arguments[r];
				  var i =
					  e.apply(this, n.__spreadArray([], n.__read(o), !1)) || this,
					a = i.constructor === t;
				  return (
					a &&
					  (i instanceof t || Object.setPrototypeOf(i, t.prototype),
					  i.setStatus("ready")),
					i
				  );
				}
				return n.__extends(t, e), t;
			  })(e);
			  return t;
			};
		  },
		  55773: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.throttle = t.debounce = void 0);
			var n = o(10172),
			  r = o(56562),
			  i = o(56964);
			function a(e, t, o) {
			  return (
				void 0 === t && (t = !1),
				void 0 === o && (o = "debounce"),
				function (a, s) {
				  var l = a[s];
				  if (!(0, n.isFunction)(l))
					throw (0, i.error)("Handler must be a Function");
				  return (
					a.hookStatus(r.STATUSES.ready, function (r) {
					  var i = r.async,
						a = (0, n.isFunction)(e) ? e(r) : e;
					  Object.defineProperty(r, s, {
						configurable: !0,
						value: i[o](
						  r[s].bind(r),
						  (0, n.isNumber)(a) || (0, n.isPlainObject)(a)
							? a
							: r.defaultTimeout,
						  t,
						),
					  });
					}),
					{
					  configurable: !0,
					  get: function () {
						return l.bind(this);
					  },
					}
				  );
				}
			  );
			}
			o(52378),
			  (t.debounce = a),
			  (t.throttle = function (e, t) {
				return void 0 === t && (t = !1), a(e, t, "throttle");
			  });
		  },
		  70669: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.derive = void 0);
			var n = o(20255),
			  r = o(10172);
			t.derive = function () {
			  for (var e = [], t = 0; arguments.length > t; t++)
				e[t] = arguments[t];
			  return function (t) {
				for (var o = t.prototype, i = 0; e.length > i; i++)
				  for (
					var a = e[i],
					  s = Object.getOwnPropertyNames(a.prototype),
					  l = function (e) {
						var t = s[e],
						  i = Object.getOwnPropertyDescriptor(a.prototype, t);
						null != i &&
						  (0, r.isFunction)(i.value) &&
						  !(0, r.isFunction)(o[t]) &&
						  Object.defineProperty(o, t, {
							enumerable: !0,
							configurable: !0,
							writable: !0,
							value: function () {
							  for (
								var e, t = [], o = 0;
								arguments.length > o;
								o++
							  )
								t[o] = arguments[o];
							  return (e = i.value).call.apply(
								e,
								n.__spreadArray([this], n.__read(t), !1),
							  );
							},
						  });
					  },
					  c = 0;
					s.length > c;
					c++
				  )
					l(c);
			  };
			};
		  },
		  64522: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.hook = void 0);
			var n = o(10172),
			  r = o(56964);
			t.hook = function (e) {
			  return function (t, o) {
				if (!(0, n.isFunction)(t[o]))
				  throw (0, r.error)("Handler must be a Function");
				t.hookStatus(e, function (e) {
				  e[o].call(e);
				});
			  };
			};
		  },
		  58682: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.idle = void 0);
			var n = o(20255),
			  r = o(56562),
			  i = o(40332);
			t.idle = function () {
			  return function (e, t) {
				if (!(0, i.isFunction)(e[t]))
				  throw (0, i.error)("Handler must be a Function");
				e.hookStatus(r.STATUSES.ready, function (e) {
				  var o = e.async,
					r = e[t];
				  e[t] = function () {
					for (var t = [], i = 0; arguments.length > i; i++)
					  t[i] = arguments[i];
					return o.requestIdleCallback(
					  r.bind.apply(r, n.__spreadArray([e], n.__read(t), !1)),
					);
				  };
				});
			  };
			};
		  },
		  43441: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.autobind = void 0);
			var n = o(20255);
			n.__exportStar(o(32358), t),
			  n.__exportStar(o(11441), t),
			  n.__exportStar(o(55773), t),
			  n.__exportStar(o(58682), t),
			  n.__exportStar(o(64522), t),
			  n.__exportStar(o(91627), t),
			  n.__exportStar(o(31418), t),
			  n.__exportStar(o(67587), t),
			  n.__exportStar(o(46163), t),
			  n.__exportStar(o(70669), t);
			var r = o(70631);
			Object.defineProperty(t, "autobind", {
			  enumerable: !0,
			  get: function () {
				return r.default;
			  },
			});
		  },
		  91627: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.nonenumerable = void 0),
			  (t.nonenumerable = function (e, t) {
				!1 !== (Object.getOwnPropertyDescriptor(e, t) || {}).enumerable &&
				  Object.defineProperty(e, t, {
					enumerable: !1,
					set: function (e) {
					  Object.defineProperty(this, t, {
						enumerable: !1,
						writable: !0,
						value: e,
					  });
					},
				  });
			  });
		  },
		  31418: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.persistent = void 0);
			var n = o(56562),
			  r = o(96574);
			t.persistent = function (e, t) {
			  e.hookStatus(n.STATUSES.ready, function (e) {
				var o = (0, r.isViewObject)(e) ? e : e.jodit,
				  n = ""
					.concat(o.options.namespace)
					.concat(e.componentName, "_prop_")
					.concat(t),
				  i = e[t];
				Object.defineProperty(e, t, {
				  get: function () {
					var e;
					return null !== (e = o.storage.get(n)) && void 0 !== e
					  ? e
					  : i;
				  },
				  set: function (e) {
					o.storage.set(n, e);
				  },
				});
			  });
			};
		  },
		  67587: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.wait = void 0);
			var n = o(20255),
			  r = o(40332),
			  i = o(56562);
			t.wait = function (e) {
			  return function (t, o) {
				if (!(0, r.isFunction)(t[o]))
				  throw (0, r.error)("Handler must be a Function");
				t.hookStatus(i.STATUSES.ready, function (t) {
				  var r = t.async,
					i = t[o],
					a = 0;
				  Object.defineProperty(t, o, {
					configurable: !0,
					value: function o() {
					  for (var s = [], l = 0; arguments.length > l; l++)
						s[l] = arguments[l];
					  r.clearTimeout(a),
						e(t)
						  ? i.apply(t, s)
						  : (a = r.setTimeout(function () {
							  return o.apply(
								void 0,
								n.__spreadArray([], n.__read(s), !1),
							  );
							}, 10));
					},
				  });
				});
			  };
			};
		  },
		  46163: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.watch = t.getPropertyDescriptor = void 0);
			var n = o(20255),
			  r = o(42096),
			  i = o(79736),
			  a = o(96574),
			  s = o(88418),
			  l = o(29411),
			  c = o(14556),
			  u = o(56964);
			function d(e, t) {
			  var o;
			  do {
				(o = Object.getOwnPropertyDescriptor(e, t)),
				  (e = Object.getPrototypeOf(e));
			  } while (!o && e);
			  return o;
			}
			function p(e, t) {
			  return function (o, p) {
				if (!(0, r.isFunction)(o[p]))
				  throw (0, u.error)("Handler must be a Function");
				var f = function (l) {
				  var u = function (e) {
					for (var t, o = [], r = 1; arguments.length > r; r++)
					  o[r - 1] = arguments[r];
					if (!l.isInDestruct)
					  return (t = l)[p].apply(
						t,
						n.__spreadArray([e], n.__read(o), !1),
					  );
				  };
				  (0, c.splitArray)(e).forEach(function (e) {
					if (/:/.test(e)) {
					  var c = n.__read(e.split(":"), 2),
						p = c[0],
						f = c[1],
						h = t,
						m = (0, a.isViewObject)(l) ? l : l.jodit;
					  return (
						p.length && (h = l.get(p)),
						(0, r.isFunction)(h) && (h = h(l)),
						m.events.on(h || l, f, u),
						h || m.events.on(f, u),
						void l.hookStatus("beforeDestruct", function () {
						  m.events.off(h || l, f, u).off(f, u);
						})
					  );
					}
					var v = e.split("."),
					  g = n.__read(v, 1)[0],
					  y = v.slice(1),
					  _ = l[g];
					(0, i.isPlainObject)(_) &&
					  (0, s.observable)(_).on("change.".concat(y.join(".")), u);
					var b = d(o, g);
					Object.defineProperty(l, g, {
					  configurable: !0,
					  set: function (e) {
						var t = _;
						t !== e &&
						  ((_ = e),
						  b && b.set && b.set.call(l, e),
						  (0, i.isPlainObject)(_) &&
							(_ = (0, s.observable)(_)).on(
							  "change.".concat(y.join(".")),
							  u,
							),
						  u(g, t, _));
					  },
					  get: function () {
						return b && b.get ? b.get.call(l) : _;
					  },
					});
				  });
				};
				(0, r.isFunction)(o.hookStatus)
				  ? o.hookStatus(l.STATUSES.ready, f)
				  : f(o);
			  };
			}
			(t.getPropertyDescriptor = d), (t.watch = p), (t.default = p);
		  },
		  24263: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Dom = void 0);
			var n = o(20255),
			  r = o(86893),
			  i = o(10172),
			  a = o(12557),
			  s = o(19035),
			  l = o(76502),
			  c = o(37204),
			  u = o(86893),
			  d = (function () {
				function e() {}
				return (
				  (e.detach = function (e) {
					for (; e.firstChild; ) e.removeChild(e.firstChild);
				  }),
				  (e.wrapInline = function (t, o, n) {
					var r,
					  a = t,
					  s = t;
					n.s.save();
					var l = !1;
					do {
					  (l = !1),
						(r = a.previousSibling) &&
						  !e.isBlock(r) &&
						  ((l = !0), (a = r));
					} while (l);
					do {
					  (l = !1),
						(r = s.nextSibling) &&
						  !e.isBlock(r) &&
						  ((l = !0), (s = r));
					} while (l);
					var c = (0, i.isString)(o) ? n.createInside.element(o) : o;
					a.parentNode && a.parentNode.insertBefore(c, a);
					for (
					  var u = a;
					  u && ((u = a.nextSibling), c.appendChild(a), a !== s && u);
  
					)
					  a = u;
					return n.s.restore(), c;
				  }),
				  (e.wrap = function (t, o, n) {
					var r = (0, i.isString)(o) ? n.element(o) : o;
					if (e.isNode(t)) {
					  if (!t.parentNode)
						throw (0, l.error)("Element should be in DOM");
					  t.parentNode.insertBefore(r, t), r.appendChild(t);
					} else {
					  var a = t.extractContents();
					  t.insertNode(r), r.appendChild(a);
					}
					return r;
				  }),
				  (e.unwrap = function (t) {
					var o = t.parentNode;
					if (o) {
					  for (; t.firstChild; ) o.insertBefore(t.firstChild, t);
					  e.safeRemove(t);
					}
				  }),
				  (e.between = function (e, t, o) {
					for (var n = e; n && n !== t && (e === n || !o(n)); ) {
					  var r = n.firstChild || n.nextSibling;
					  if (!r) {
						for (; n && !n.nextSibling; ) n = n.parentNode;
						r = null == n ? void 0 : n.nextSibling;
					  }
					  n = r;
					}
				  }),
				  (e.replace = function (t, o, n, r, s) {
					void 0 === r && (r = !1),
					  void 0 === s && (s = !1),
					  (0, i.isHTML)(o) && (o = n.fromHTML(o));
					var l = (0, i.isString)(o) ? n.element(o) : o;
					if (!s) for (; t.firstChild; ) l.appendChild(t.firstChild);
					return (
					  r &&
						e.isElement(t) &&
						e.isElement(l) &&
						(0, a.toArray)(t.attributes).forEach(function (e) {
						  l.setAttribute(e.name, e.value);
						}),
					  t.parentNode && t.parentNode.replaceChild(l, t),
					  l
					);
				  }),
				  (e.isEmptyTextNode = function (t) {
					return (
					  e.isText(t) &&
					  (!t.nodeValue ||
						0 ===
						  t.nodeValue
							.replace(r.INVISIBLE_SPACE_REG_EXP(), "")
							.trim().length)
					);
				  }),
				  (e.isEmptyContent = function (t) {
					return e.each(t, function (t) {
					  return e.isEmptyTextNode(t);
					});
				  }),
				  (e.isContentEditable = function (t, o) {
					return (
					  e.isNode(t) &&
					  !e.closest(
						t,
						function (t) {
						  return (
							e.isElement(t) &&
							"false" === t.getAttribute("contenteditable")
						  );
						},
						o,
					  )
					);
				  }),
				  (e.isEmpty = function (t, o) {
					if ((void 0 === o && (o = u.NO_EMPTY_TAGS), !t)) return !0;
					var n;
					n = (0, i.isFunction)(o)
					  ? o
					  : function (e) {
						  return o.has(e.nodeName.toLowerCase());
						};
					var r = function (e) {
					  return (
						null == e.nodeValue ||
						0 === (0, s.trim)(e.nodeValue).length
					  );
					};
					return e.isText(t)
					  ? r(t)
					  : !(e.isElement(t) && n(t)) &&
						  e.each(t, function (t) {
							if (
							  (e.isText(t) && !r(t)) ||
							  (e.isElement(t) && n(t))
							)
							  return !1;
						  });
				  }),
				  (e.isNode = function (e) {
					return Boolean(
					  e &&
						(0, i.isString)(e.nodeName) &&
						"number" == typeof e.nodeType &&
						e.childNodes &&
						(0, i.isFunction)(e.appendChild),
					);
				  }),
				  (e.isCell = function (t) {
					return e.isNode(t) && /^(td|th)$/i.test(t.nodeName);
				  }),
				  (e.isImage = function (t) {
					return (
					  e.isNode(t) &&
					  /^(img|svg|picture|canvas)$/i.test(t.nodeName)
					);
				  }),
				  (e.isBlock = function (t) {
					return (
					  !(0, i.isVoid)(t) &&
					  "object" == typeof t &&
					  e.isNode(t) &&
					  r.IS_BLOCK.test(t.nodeName)
					);
				  }),
				  (e.isText = function (e) {
					return Boolean(e && e.nodeType === Node.TEXT_NODE);
				  }),
				  (e.isElement = function (t) {
					var o;
					if (!e.isNode(t)) return !1;
					var n =
					  null === (o = t.ownerDocument) || void 0 === o
						? void 0
						: o.defaultView;
					return Boolean(n && t.nodeType === Node.ELEMENT_NODE);
				  }),
				  (e.isFragment = function (t) {
					var o;
					if (!e.isNode(t)) return !1;
					var n =
					  null === (o = t.ownerDocument) || void 0 === o
						? void 0
						: o.defaultView;
					return Boolean(
					  n && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE,
					);
				  }),
				  (e.isHTMLElement = function (t) {
					var o;
					if (!e.isNode(t)) return !1;
					var n =
					  null === (o = t.ownerDocument) || void 0 === o
						? void 0
						: o.defaultView;
					return Boolean(n && t instanceof n.HTMLElement);
				  }),
				  (e.isInlineBlock = function (t) {
					return (
					  e.isElement(t) &&
					  !/^(BR|HR)$/i.test(t.tagName) &&
					  -1 !==
						["inline", "inline-block"].indexOf(
						  (0, l.css)(t, "display").toString(),
						)
					);
				  }),
				  (e.canSplitBlock = function (t) {
					return (
					  !(0, i.isVoid)(t) &&
					  e.isHTMLElement(t) &&
					  e.isBlock(t) &&
					  !/^(TD|TH|CAPTION|FORM)$/.test(t.nodeName) &&
					  void 0 !== t.style &&
					  !/^(fixed|absolute)/i.test(t.style.position)
					);
				  }),
				  (e.last = function (e, t) {
					var o = null == e ? void 0 : e.lastChild;
					if (!o) return null;
					do {
					  if (t(o)) return o;
					  var n = o.lastChild;
					  if (
						(n || (n = o.previousSibling), !n && o.parentNode !== e)
					  ) {
						do {
						  o = o.parentNode;
						} while (
						  o &&
						  !(null == o ? void 0 : o.previousSibling) &&
						  o.parentNode !== e
						);
						n = null == o ? void 0 : o.previousSibling;
					  }
					  o = n;
					} while (o);
					return null;
				  }),
				  (e.prev = function (t, o, n, r) {
					return void 0 === r && (r = !0), e.find(t, o, n, !1, r);
				  }),
				  (e.next = function (t, o, n, r) {
					return void 0 === r && (r = !0), e.find(t, o, n, !0, r);
				  }),
				  (e.prevWithClass = function (t, o) {
					return e.prev(
					  t,
					  function (t) {
						return e.isElement(t) && t.classList.contains(o);
					  },
					  t.parentNode,
					);
				  }),
				  (e.nextWithClass = function (t, o) {
					return e.next(
					  t,
					  function (t) {
						return e.isElement(t) && t.classList.contains(o);
					  },
					  t.parentNode,
					);
				  }),
				  (e.find = function (e, t, o, n, r) {
					void 0 === n && (n = !0), void 0 === r && (r = !0);
					for (
					  var i = this.nextGen(e, o, n, r), a = i.next();
					  !a.done;
  
					) {
					  if (t(a.value)) return a.value;
					  a = i.next();
					}
					return null;
				  }),
				  (e.nextGen = function (e, t, o, r) {
					var i, a, s;
					return (
					  void 0 === o && (o = !0),
					  void 0 === r && (r = !0),
					  n.__generator(this, function (l) {
						switch (l.label) {
						  case 0:
							(i = []), (a = e), (l.label = 1);
						  case 1:
							for (s = o ? a.nextSibling : a.previousSibling; s; )
							  i.unshift(s),
								(s = o ? s.nextSibling : s.previousSibling);
							return [5, n.__values(this.runInStack(e, i, o, r))];
						  case 2:
							l.sent(), (a = a.parentNode), (l.label = 3);
						  case 3:
							if (a && a !== t) return [3, 1];
							l.label = 4;
						  case 4:
							return [2, null];
						}
					  })
					);
				  }),
				  (e.each = function (e, t, o) {
					void 0 === o && (o = !0);
					for (var n = this.eachGen(e, o), r = n.next(); !r.done; ) {
					  if (!1 === t(r.value)) return !1;
					  r = n.next();
					}
					return !0;
				  }),
				  (e.eachGen = function (e, t) {
					return void 0 === t && (t = !0), this.runInStack(e, [e], t);
				  }),
				  (e.runInStack = function (e, t, o, r) {
					var i, a;
					return (
					  void 0 === r && (r = !0),
					  n.__generator(this, function (n) {
						switch (n.label) {
						  case 0:
							if (!t.length) return [3, 3];
							if (((i = t.pop()), r))
							  for (a = o ? i.lastChild : i.firstChild; a; )
								t.push(a),
								  (a = o ? a.previousSibling : a.nextSibling);
							return e === i ? [3, 2] : [4, i];
						  case 1:
							n.sent(), (n.label = 2);
						  case 2:
							return [3, 0];
						  case 3:
							return [2];
						}
					  })
					);
				  }),
				  (e.findWithCurrent = function (t, o, n, r, i) {
					void 0 === r && (r = "nextSibling"),
					  void 0 === i && (i = "firstChild");
					var a = t;
					do {
					  if (o(a)) return a || null;
					  if (i && a && a[i]) {
						var s = e.findWithCurrent(a[i], o, a, r, i);
						if (s) return s;
					  }
					  for (; a && !a[r] && a !== n; ) a = a.parentNode;
					  a && a[r] && a !== n && (a = a[r]);
					} while (a && a !== n);
					return null;
				  }),
				  (e.findSibling = function (t, o, n) {
					void 0 === o && (o = !0),
					  void 0 === n &&
						(n = function (t) {
						  return !e.isEmptyTextNode(t);
						});
					for (var r = e.sibling(t, o); r && !n(r); )
					  r = e.sibling(r, o);
					return r && n(r) ? r : null;
				  }),
				  (e.findNotEmptySibling = function (t, o) {
					return e.findSibling(t, o, function (t) {
					  var o;
					  return (
						!e.isEmptyTextNode(t) &&
						Boolean(
						  !e.isText(t) ||
							((null === (o = t.nodeValue) || void 0 === o
							  ? void 0
							  : o.length) &&
							  (0, s.trim)(t.nodeValue)),
						)
					  );
					});
				  }),
				  (e.findNotEmptyNeighbor = function (t, o, n) {
					return (0, l.call)(
					  o ? e.prev : e.next,
					  t,
					  function (t) {
						return Boolean(
						  t &&
							(!e.isText(t) ||
							  (0, s.trim)(
								(null == t ? void 0 : t.nodeValue) || "",
							  ).length),
						);
					  },
					  n,
					);
				  }),
				  (e.sibling = function (e, t) {
					return t ? e.previousSibling : e.nextSibling;
				  }),
				  (e.up = function (e, t, o, n) {
					void 0 === n && (n = !1);
					var r = e;
					if (!r) return null;
					do {
					  if (t(r)) return r;
					  if (r === o || !r.parentNode) break;
					  r = r.parentNode;
					} while (r && r !== o);
					return r === o && n && t(r) ? r : null;
				  }),
				  (e.closest = function (t, o, n) {
					var r,
					  a = function (e) {
						return e.toLowerCase();
					  };
					if ((0, i.isFunction)(o)) r = o;
					else if ((0, i.isArray)(o)) {
					  var s = new Set(o.map(a));
					  r = function (e) {
						return Boolean(e && s.has(a(e.nodeName)));
					  };
					} else
					  r = function (e) {
						return Boolean(e && a(o) === a(e.nodeName));
					  };
					return e.up(t, r, n);
				  }),
				  (e.furthest = function (e, t, o) {
					for (
					  var n = null, r = null == e ? void 0 : e.parentElement;
					  r && r !== o;
  
					)
					  t(r) && (n = r), (r = null == r ? void 0 : r.parentElement);
					return n;
				  }),
				  (e.appendChildFirst = function (e, t) {
					var o = e.firstChild;
					o ? o !== t && e.insertBefore(t, o) : e.appendChild(t);
				  }),
				  (e.after = function (e, t) {
					var o = e.parentNode;
					o &&
					  (o.lastChild === e
						? o.appendChild(t)
						: o.insertBefore(t, e.nextSibling));
				  }),
				  (e.before = function (e, t) {
					var o = e.parentNode;
					o && o.insertBefore(t, e);
				  }),
				  (e.prepend = function (e, t) {
					e.insertBefore(t, e.firstChild);
				  }),
				  (e.append = function (e, t) {
					var o = this;
					(0, i.isArray)(t)
					  ? t.forEach(function (t) {
						  o.append(e, t);
						})
					  : e.appendChild(t);
				  }),
				  (e.moveContent = function (t, o, n, r) {
					void 0 === n && (n = !1),
					  void 0 === r &&
						(r = function () {
						  return !0;
						});
					var i = (
					  t.ownerDocument || document
					).createDocumentFragment();
					(0, a.toArray)(t.childNodes)
					  .filter(function (t) {
						return !!r(t) || (e.safeRemove(t), !1);
					  })
					  .forEach(function (e) {
						i.appendChild(e);
					  }),
					  n && o.firstChild
						? o.insertBefore(i, o.firstChild)
						: o.appendChild(i);
				  }),
				  (e.isOrContains = function (e, t, o) {
					return (
					  void 0 === o && (o = !1),
					  e === t
						? !o
						: Boolean(
							t &&
							  e &&
							  this.up(
								t,
								function (t) {
								  return t === e;
								},
								e,
								!0,
							  ),
						  )
					);
				  }),
				  (e.safeRemove = function () {
					for (var t = [], o = 0; arguments.length > o; o++)
					  t[o] = arguments[o];
					t.forEach(function (t) {
					  return (
						e.isNode(t) && t.parentNode && t.parentNode.removeChild(t)
					  );
					});
				  }),
				  (e.safeInsertNode = function (t, o) {
					t.collapsed || t.deleteContents(),
					  t.insertNode(o),
					  t.setStartBefore(o),
					  t.collapse(!0),
					  [o.nextSibling, o.previousSibling].forEach(function (t) {
						return e.isText(t) && !t.nodeValue && e.safeRemove(t);
					  });
				  }),
				  (e.hide = function (e) {
					e &&
					  ((0, l.dataBind)(e, "__old_display", e.style.display),
					  (e.style.display = "none"));
				  }),
				  (e.show = function (e) {
					if (e) {
					  var t = (0, l.dataBind)(e, "__old_display");
					  "none" === e.style.display && (e.style.display = t || "");
					}
				  }),
				  (e.isTag = function (e, t) {
					if (!this.isElement(e)) return !1;
					var o = e.tagName.toLowerCase(),
					  n = e.tagName.toUpperCase();
					if (t instanceof Set) return t.has(o) || t.has(n);
					for (
					  var r = (0, a.asArray)(t).map(function (e) {
						  return String(e).toLowerCase();
						}),
						i = 0;
					  r.length > i;
					  i += 1
					)
					  if (o === r[i] || n === r[i]) return !0;
					return !1;
				  }),
				  (e.markTemporary = function (e, t) {
					return (
					  t && (0, l.attr)(e, t), (0, l.attr)(e, u.TEMP_ATTR, !0), e
					);
				  }),
				  (e.isTemporary = function (t) {
					return (
					  !!e.isElement(t) &&
					  ((0, c.isMarker)(t) ||
						"true" === (0, l.attr)(t, u.TEMP_ATTR))
					);
				  }),
				  (e.replaceTemporaryFromString = function (e) {
					return e.replace(
					  /<([a-z]+)[^>]+data-jodit-temp[^>]+>(.+?)<\/\1>/gi,
					  "$2",
					);
				  }),
				  (e.temporaryList = function (e) {
					return (0, l.$$)("[".concat(u.TEMP_ATTR, "]"), e);
				  }),
				  e
				);
			  })();
			t.Dom = d;
		  },
		  64968: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(24263), t), n.__exportStar(o(33841), t);
		  },
		  33841: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.LazyWalker = void 0);
			var n = o(20255),
			  r = o(73852),
			  i = o(43441),
			  a = o(24263),
			  s = (function (e) {
				function t(t, o) {
				  void 0 === o && (o = {});
				  var n = e.call(this) || this;
				  return (
					(n.async = t),
					(n.options = o),
					(n.workNodes = null),
					(n.hadAffect = !1),
					(n.isWorked = !1),
					(n.isFinished = !1),
					(n.idleId = 0),
					n
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.setWork = function (e) {
					return (
					  this.isWorked && this.break(),
					  (this.workNodes = a.Dom.eachGen(e, !this.options.reverse)),
					  (this.isFinished = !1),
					  this.startIdleRequest(),
					  this
					);
				  }),
				  (t.prototype.startIdleRequest = function () {
					var e;
					this.idleId = this.async.requestIdleCallback(
					  this.workPerform,
					  {
						timeout:
						  null !== (e = this.options.timeout) && void 0 !== e
							? e
							: 10,
					  },
					);
				  }),
				  (t.prototype.break = function (e) {
					this.isWorked && (this.stop(), this.emit("break", e));
				  }),
				  (t.prototype.end = function () {
					this.isWorked &&
					  (this.stop(),
					  this.emit("end", this.hadAffect),
					  (this.hadAffect = !1));
				  }),
				  (t.prototype.stop = function () {
					(this.isWorked = !1),
					  (this.isFinished = !0),
					  (this.workNodes = null),
					  this.async.cancelIdleCallback(this.idleId);
				  }),
				  (t.prototype.destruct = function () {
					e.prototype.destruct.call(this), this.stop();
				  }),
				  (t.prototype.workPerform = function (e) {
					var t;
					if (this.workNodes) {
					  this.isWorked = !0;
					  for (
						var o = 0,
						  n =
							null !== (t = this.options.timeoutChunkSize) &&
							void 0 !== t
							  ? t
							  : 50;
						!this.isFinished &&
						(e.timeRemaining() > 0 || (e.didTimeout && n >= o));
  
					  ) {
						var r = this.workNodes.next();
						if (
						  ((o += 1),
						  this.visitNode(r.value) && (this.hadAffect = !0),
						  r.done)
						)
						  return void this.end();
					  }
					} else this.end();
					this.isFinished || this.startIdleRequest();
				  }),
				  (t.prototype.visitNode = function (e) {
					var t;
					return (
					  !(
						!e ||
						(void 0 !== this.options.whatToShow &&
						  e.nodeType !== this.options.whatToShow)
					  ) &&
					  null !== (t = this.emit("visit", e)) &&
					  void 0 !== t &&
					  t
					);
				  }),
				  n.__decorate([i.autobind], t.prototype, "workPerform", null),
				  t
				);
			  })(r.Eventify);
			t.LazyWalker = s;
		  },
		  3808: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.EventEmitter = void 0);
			var n = o(20255),
			  r = o(83611),
			  i = o(24421),
			  a = o(42096),
			  s = o(49781),
			  l = o(56964),
			  c = o(14556),
			  u = (function () {
				function e(e) {
				  var t = this;
				  (this.__mutedEvents = new Set()),
					(this.__key = "__JoditEventEmitterNamespaces"),
					(this.__doc = document),
					(this.__prepareEvent = function (e) {
					  e.cancelBubble ||
						(e.composed &&
						  (0, a.isFunction)(e.composedPath) &&
						  e.composedPath()[0] &&
						  Object.defineProperty(e, "target", {
							value: e.composedPath()[0],
							configurable: !0,
							enumerable: !0,
						  }),
						e.type.match(/^touch/) &&
						  e.changedTouches &&
						  e.changedTouches.length &&
						  ["clientX", "clientY", "pageX", "pageY"].forEach(
							function (t) {
							  Object.defineProperty(e, t, {
								value: e.changedTouches[0][t],
								configurable: !0,
								enumerable: !0,
							  });
							},
						  ),
						e.originalEvent || (e.originalEvent = e),
						"paste" === e.type &&
						  void 0 === e.clipboardData &&
						  t.__doc.defaultView.clipboardData &&
						  Object.defineProperty(e, "clipboardData", {
							get: function () {
							  return t.__doc.defaultView.clipboardData;
							},
							configurable: !0,
							enumerable: !0,
						  }));
					}),
					(this.currents = []),
					(this.__stopped = []),
					(this.__isDestructed = !1),
					e && (this.__doc = e),
					(this.__key += new Date().getTime());
				}
				return (
				  (e.prototype.mute = function (e) {
					return this.__mutedEvents.add(null != e ? e : "*"), this;
				  }),
				  (e.prototype.isMuted = function (e) {
					return (
					  !(!e || !this.__mutedEvents.has(e)) ||
					  this.__mutedEvents.has("*")
					);
				  }),
				  (e.prototype.unmute = function (e) {
					return this.__mutedEvents.delete(null != e ? e : "*"), this;
				  }),
				  (e.prototype.__eachEvent = function (e, t) {
					var o = this;
					(0, c.splitArray)(e)
					  .map(function (e) {
						return e.trim();
					  })
					  .forEach(function (e) {
						var n = e.split(".");
						t.call(o, n[0], n[1] || r.defaultNameSpace);
					  });
				  }),
				  (e.prototype.__getStore = function (e) {
					if (!e) throw (0, l.error)("Need subject");
					if (void 0 === e[this.__key]) {
					  var t = new r.EventHandlersStore();
					  Object.defineProperty(e, this.__key, {
						enumerable: !1,
						configurable: !0,
						writable: !0,
						value: t,
					  });
					}
					return e[this.__key];
				  }),
				  (e.prototype.__removeStoreFromSubject = function (e) {
					void 0 !== e[this.__key] &&
					  Object.defineProperty(e, this.__key, {
						enumerable: !1,
						configurable: !0,
						writable: !0,
						value: void 0,
					  });
				  }),
				  (e.prototype.__triggerNativeEvent = function (e, t) {
					var o = this.__doc.createEvent("HTMLEvents");
					(0, i.isString)(t)
					  ? o.initEvent(t, !0, !0)
					  : (o.initEvent(t.type, t.bubbles, t.cancelable),
						[
						  "screenX",
						  "screenY",
						  "clientX",
						  "clientY",
						  "target",
						  "srcElement",
						  "currentTarget",
						  "timeStamp",
						  "which",
						  "keyCode",
						].forEach(function (e) {
						  Object.defineProperty(o, e, {
							value: t[e],
							enumerable: !0,
						  });
						}),
						Object.defineProperty(o, "originalEvent", {
						  value: t,
						  enumerable: !0,
						})),
					  e.dispatchEvent(o);
				  }),
				  Object.defineProperty(e.prototype, "current", {
					get: function () {
					  return this.currents[this.currents.length - 1];
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (e.prototype.on = function (e, t, o, r) {
					var c,
					  u,
					  d,
					  p,
					  f = this;
					if (
					  ((0, i.isString)(e) || (0, i.isStringArray)(e)
						? ((c = this), (u = e), (d = t), (p = o))
						: ((c = e), (u = t), (d = o), (p = r)),
					  (!(0, i.isString)(u) && !(0, i.isStringArray)(u)) ||
						0 === u.length)
					)
					  throw (0, l.error)("Need events names");
					if (!(0, a.isFunction)(d))
					  throw (0, l.error)("Need event handler");
					if ((0, s.isArray)(c))
					  return (
						c.forEach(function (e) {
						  f.on(e, u, d, p);
						}),
						this
					  );
					var h = c,
					  m = this.__getStore(h),
					  v = (0, a.isFunction)(h.addEventListener),
					  g = this,
					  y = function (e) {
						for (var t = [], o = 1; arguments.length > o; o++)
						  t[o - 1] = arguments[o];
						if (!g.isMuted(e))
						  return (
							d &&
							d.call.apply(
							  d,
							  n.__spreadArray([this], n.__read(t), !1),
							)
						  );
					  };
					return (
					  v &&
						(y = function (e) {
						  if (!g.isMuted(e.type))
							return (
							  g.__prepareEvent(e),
							  d && !1 === d.call(this, e)
								? (e.preventDefault(),
								  e.stopImmediatePropagation(),
								  !1)
								: void 0
							);
						}),
					  this.__eachEvent(u, function (e, t) {
						if (0 === e.length) throw (0, l.error)("Need event name");
						if (
						  !1 === m.indexOf(e, t, d) &&
						  (m.set(
							e,
							t,
							{
							  event: e,
							  originalCallback: d,
							  syntheticCallback: y,
							},
							null == p ? void 0 : p.top,
						  ),
						  v)
						) {
						  var o = !![
							"touchstart",
							"touchend",
							"scroll",
							"mousewheel",
							"mousemove",
							"touchmove",
						  ].includes(e) && { passive: !0 };
						  h.addEventListener(e, y, o);
						}
					  }),
					  this
					);
				  }),
				  (e.prototype.one = function (e, t, o, r) {
					var a,
					  s,
					  l,
					  c,
					  u = this;
					(0, i.isString)(e) || (0, i.isStringArray)(e)
					  ? ((a = this), (s = e), (l = t), (c = o))
					  : ((a = e), (s = t), (l = o), (c = r));
					var d = function () {
					  for (var e = [], t = 0; arguments.length > t; t++)
						e[t] = arguments[t];
					  return (
						u.off(a, s, d),
						l.apply(void 0, n.__spreadArray([], n.__read(e), !1))
					  );
					};
					return this.on(a, s, d, c), this;
				  }),
				  (e.prototype.off = function (e, t, o) {
					var n,
					  l,
					  c,
					  u = this;
					if (
					  ((0, i.isString)(e) || (0, i.isStringArray)(e)
						? ((n = this), (l = e), (c = t))
						: ((n = e), (l = t), (c = o)),
					  (0, s.isArray)(n))
					)
					  return (
						n.forEach(function (e) {
						  u.off(e, l, c);
						}),
						this
					  );
					var d = n,
					  p = this.__getStore(d);
					if (
					  (!(0, i.isString)(l) && !(0, i.isStringArray)(l)) ||
					  0 === l.length
					)
					  return (
						p.namespaces().forEach(function (e) {
						  u.off(d, "." + e);
						}),
						this.__removeStoreFromSubject(d),
						this
					  );
					var f = (0, a.isFunction)(d.removeEventListener),
					  h = function (e) {
						f &&
						  d.removeEventListener(e.event, e.syntheticCallback, !1);
					  },
					  m = function (e, t) {
						if ("" !== e) {
						  var o = p.get(e, t);
						  if (o && o.length)
							if ((0, a.isFunction)(c)) {
							  var n = p.indexOf(e, t, c);
							  !1 !== n &&
								(h(o[n]),
								o.splice(n, 1),
								o.length || p.clearEvents(t, e));
							} else
							  o.forEach(h), (o.length = 0), p.clearEvents(t, e);
						} else
						  p.events(t).forEach(function (e) {
							"" !== e && m(e, t);
						  });
					  };
					return (
					  this.__eachEvent(l, function (e, t) {
						t === r.defaultNameSpace
						  ? p.namespaces().forEach(function (t) {
							  m(e, t);
							})
						  : m(e, t);
					  }),
					  p.isEmpty() && this.__removeStoreFromSubject(d),
					  this
					);
				  }),
				  (e.prototype.stopPropagation = function (e, t) {
					var o = this,
					  n = (0, i.isString)(e) ? this : e,
					  a = (0, i.isString)(e) ? e : t;
					if ("string" != typeof a)
					  throw (0, l.error)("Need event names");
					var s = this.__getStore(n);
					this.__eachEvent(a, function (e, t) {
					  var i = s.get(e, t);
					  i && o.__stopped.push(i),
						t === r.defaultNameSpace &&
						  s.namespaces(!0).forEach(function (t) {
							return o.stopPropagation(n, e + "." + t);
						  });
					});
				  }),
				  (e.prototype.__removeStop = function (e) {
					if (e) {
					  var t = this.__stopped.indexOf(e);
					  -1 !== t && this.__stopped.splice(0, t + 1);
					}
				  }),
				  (e.prototype.__isStopped = function (e) {
					return void 0 !== e && -1 !== this.__stopped.indexOf(e);
				  }),
				  (e.prototype.fire = function (e, t) {
					for (
					  var o, s, c = this, u = [], d = 2;
					  arguments.length > d;
					  d++
					)
					  u[d - 2] = arguments[d];
					var p = (0, i.isString)(e) ? this : e,
					  f = (0, i.isString)(e) ? e : t,
					  h = (0, i.isString)(e)
						? n.__spreadArray([t], n.__read(u), !1)
						: u,
					  m = (0, a.isFunction)(p.dispatchEvent);
					if (!m && !(0, i.isString)(f))
					  throw (0, l.error)("Need events names");
					var v = this.__getStore(p);
					return (
					  !(0, i.isString)(f) && m
						? this.__triggerNativeEvent(p, t)
						: this.__eachEvent(f, function (e, t) {
							if (m) c.__triggerNativeEvent(p, e);
							else {
							  var i = v.get(e, t);
							  if (i)
								try {
								  n.__spreadArray([], n.__read(i), !1).every(
									function (t) {
									  var r;
									  return (
										!c.__isStopped(i) &&
										(c.currents.push(e),
										(s = (r = t.syntheticCallback).call.apply(
										  r,
										  n.__spreadArray(
											[p, e],
											n.__read(h),
											!1,
										  ),
										)),
										c.currents.pop(),
										void 0 !== s && (o = s),
										!0)
									  );
									},
								  );
								} finally {
								  c.__removeStop(i);
								}
							  t !== r.defaultNameSpace ||
								m ||
								v
								  .namespaces()
								  .filter(function (e) {
									return e !== t;
								  })
								  .forEach(function (t) {
									var r = c.fire.apply(
									  c,
									  n.__spreadArray(
										[p, e + "." + t],
										n.__read(h),
										!1,
									  ),
									);
									void 0 !== r && (o = r);
								  });
							}
						  }),
					  o
					);
				  }),
				  (e.prototype.destruct = function () {
					this.__isDestructed &&
					  ((this.__isDestructed = !0),
					  this.off(this),
					  this.__getStore(this).clear(),
					  this.__removeStoreFromSubject(this));
				  }),
				  e
				);
			  })();
			t.EventEmitter = u;
		  },
		  73852: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Eventify = void 0);
			var n = o(20255),
			  r = (function () {
				function e() {
				  this.__map = new Map();
				}
				return (
				  (e.prototype.on = function (e, t) {
					var o;
					return (
					  this.__map.has(e) || this.__map.set(e, new Set()),
					  null === (o = this.__map.get(e)) ||
						void 0 === o ||
						o.add(t),
					  this
					);
				  }),
				  (e.prototype.off = function (e, t) {
					var o;
					return (
					  this.__map.has(e) &&
						(null === (o = this.__map.get(e)) ||
						  void 0 === o ||
						  o.delete(t)),
					  this
					);
				  }),
				  (e.prototype.destruct = function () {
					this.__map.clear();
				  }),
				  (e.prototype.emit = function (e) {
					for (var t, o, r = [], i = 1; arguments.length > i; i++)
					  r[i - 1] = arguments[i];
					return (
					  this.__map.has(e) &&
						(null === (t = this.__map.get(e)) ||
						  void 0 === t ||
						  t.forEach(function (e) {
							o = e.apply(
							  void 0,
							  n.__spreadArray([], n.__read(r), !1),
							);
						  })),
					  o
					);
				  }),
				  e
				);
			  })();
			t.Eventify = r;
		  },
		  55395: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(3808), t),
			  n.__exportStar(o(73852), t),
			  n.__exportStar(o(88418), t),
			  n.__exportStar(o(83611), t);
		  },
		  88418: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.observable = void 0);
			var n = o(20255),
			  r = o(49781),
			  i = o(32756),
			  a = o(79736),
			  s = o(46163),
			  l = Symbol("observable-object");
			function c(e) {
			  return void 0 !== e[l];
			}
			t.observable = function (e) {
			  if (c(e)) return e;
			  var t = {},
				o = {},
				u = function (t, n) {
				  return (0, r.isArray)(t)
					? (t.map(function (e) {
						return u(e, n);
					  }),
					  e)
					: (o[t] || (o[t] = []), o[t].push(n), e);
				},
				d = function (i) {
				  for (var a = [], s = 1; arguments.length > s; s++)
					a[s - 1] = arguments[s];
				  if ((0, r.isArray)(i))
					i.map(function (e) {
					  return d.apply(
						void 0,
						n.__spreadArray([e], n.__read(a), !1),
					  );
					});
				  else
					try {
					  !t[i] &&
						o[i] &&
						((t[i] = !0),
						o[i].forEach(function (t) {
						  return t.call.apply(
							t,
							n.__spreadArray([e], n.__read(a), !1),
						  );
						}));
					} finally {
					  t[i] = !1;
					}
				},
				p = function (t, o) {
				  void 0 === o && (o = []);
				  var r = {};
				  c(t) ||
					(Object.defineProperty(t, l, { enumerable: !1, value: !0 }),
					Object.keys(t).forEach(function (l) {
					  var c = l,
						u = o.concat(c).filter(function (e) {
						  return e.length;
						});
					  r[c] = t[c];
					  var f = (0, s.getPropertyDescriptor)(t, c);
					  Object.defineProperty(t, c, {
						set: function (t) {
						  var o = r[c];
						  if (!(0, i.isFastEqual)(r[c], t)) {
							d(
							  [
								"beforeChange",
								"beforeChange.".concat(u.join(".")),
							  ],
							  c,
							  t,
							),
							  (0, a.isPlainObject)(t) && p(t, u),
							  f && f.set ? f.set.call(e, t) : (r[c] = t);
							var s = [];
							d(
							  n.__spreadArray(
								["change"],
								n.__read(
								  u.reduce(function (e, t) {
									return (
									  s.push(t),
									  e.push("change.".concat(s.join("."))),
									  e
									);
								  }, []),
								),
								!1,
							  ),
							  u.join("."),
							  o,
							  (null == t ? void 0 : t.valueOf) ? t.valueOf() : t,
							);
						  }
						},
						get: function () {
						  return f && f.get ? f.get.call(e) : r[c];
						},
						enumerable: !0,
						configurable: !0,
					  }),
						(0, a.isPlainObject)(r[c]) && p(r[c], u);
					}),
					Object.defineProperty(e, "on", { value: u }));
				};
			  return p(e), e;
			};
		  },
		  83611: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.EventHandlersStore = t.defaultNameSpace = void 0),
			  o(52378);
			var n = o(1853);
			t.defaultNameSpace = "JoditEventDefaultNamespace";
			var r = (function () {
			  function e() {
				this.__store = new Map();
			  }
			  return (
				(e.prototype.get = function (e, t) {
				  if (this.__store.has(t)) return this.__store.get(t)[e];
				}),
				(e.prototype.indexOf = function (e, t, o) {
				  var n = this.get(e, t);
				  if (n)
					for (var r = 0; n.length > r; r += 1)
					  if (n[r].originalCallback === o) return r;
				  return !1;
				}),
				(e.prototype.namespaces = function (e) {
				  void 0 === e && (e = !1);
				  var o = (0, n.toArray)(this.__store.keys());
				  return e
					? o.filter(function (e) {
						return e !== t.defaultNameSpace;
					  })
					: o;
				}),
				(e.prototype.events = function (e) {
				  var t = this.__store.get(e);
				  return t ? Object.keys(t) : [];
				}),
				(e.prototype.set = function (e, t, o, n) {
				  void 0 === n && (n = !1);
				  var r = this.__store.get(t);
				  r || this.__store.set(t, (r = {})),
					void 0 === r[e] && (r[e] = []),
					n ? r[e].unshift(o) : r[e].push(o);
				}),
				(e.prototype.clear = function () {
				  this.__store.clear();
				}),
				(e.prototype.clearEvents = function (e, t) {
				  var o = this.__store.get(e);
				  o &&
					o[t] &&
					(delete o[t],
					Object.keys(o).length || this.__store.delete(e));
				}),
				(e.prototype.isEmpty = function () {
				  return 0 === this.__store.size;
				}),
				e
			  );
			})();
			t.EventHandlersStore = r;
		  },
		  17332: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.eventEmitter =
				t.getContainer =
				t.extendLang =
				t.modules =
				t.pluginSystem =
				t.uniqueUid =
				t.instances =
				  void 0);
			var n = o(44540),
			  r = o(64968),
			  i = o(55395),
			  a = o(77892),
			  s = o(96574),
			  l = o(87247),
			  c = o(11278),
			  u = o(86893);
			t.instances = {};
			var d = 1,
			  p = new Set();
			(t.uniqueUid = function () {
			  function e() {
				return (
				  (d += 10 * (Math.random() + 1)), Math.round(d).toString(16)
				);
			  }
			  for (var t = e(); p.has(t); ) t = e();
			  return p.add(t), t;
			}),
			  (t.pluginSystem = new n.PluginSystem()),
			  (t.modules = {}),
			  (t.extendLang = function (e) {
				Object.keys(e).forEach(function (t) {
				  u.lang[t] ? Object.assign(u.lang[t], e[t]) : (u.lang[t] = e[t]);
				});
			  });
			var f = new WeakMap();
			(t.getContainer = function (e, t, o, n) {
			  void 0 === o && (o = "div"), void 0 === n && (n = !1);
			  var i = t ? (0, l.getClassName)(t.prototype) : "jodit-utils",
				u = f.get(e) || {},
				d = i + o,
				p = (0, s.isViewObject)(e) ? e : e.j;
			  if (!u[d]) {
				var h = p.c,
				  m =
					(0, a.isJoditObject)(e) && e.o.shadowRoot
					  ? e.o.shadowRoot
					  : e.od.body;
				if (n && (0, a.isJoditObject)(e) && e.od !== e.ed) {
				  h = e.createInside;
				  var v = "style" === o ? e.ed.head : e.ed.body;
				  m =
					(0, a.isJoditObject)(e) && e.o.shadowRoot
					  ? e.o.shadowRoot
					  : v;
				}
				var g = h.element(o, {
				  className: "jodit jodit-".concat(
					(0, c.kebabCase)(i),
					"-container jodit-box",
				  ),
				});
				g.classList.add("jodit_theme_".concat(p.o.theme || "default")),
				  m.appendChild(g),
				  (u[d] = g),
				  e.hookStatus("beforeDestruct", function () {
					r.Dom.safeRemove(g),
					  delete u[d],
					  Object.keys(u).length && f.delete(e);
				  }),
				  f.set(e, u);
			  }
			  return (
				u[d].classList.remove("jodit_theme_default", "jodit_theme_dark"),
				u[d].classList.add("jodit_theme_".concat(p.o.theme || "default")),
				u[d]
			  );
			}),
			  (t.eventEmitter = new i.EventEmitter());
		  },
		  34578: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.asArray = void 0);
			var n = o(49781);
			t.asArray = function (e) {
			  return (0, n.isArray)(e) ? e : [e];
			};
		  },
		  12557: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.toArray = t.splitArray = t.asArray = void 0);
			var n = o(34578);
			Object.defineProperty(t, "asArray", {
			  enumerable: !0,
			  get: function () {
				return n.asArray;
			  },
			});
			var r = o(14556);
			Object.defineProperty(t, "splitArray", {
			  enumerable: !0,
			  get: function () {
				return r.splitArray;
			  },
			});
			var i = o(1853);
			Object.defineProperty(t, "toArray", {
			  enumerable: !0,
			  get: function () {
				return i.toArray;
			  },
			});
		  },
		  14556: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.splitArray = void 0),
			  (t.splitArray = function (e) {
				return Array.isArray(e) ? e : e.split(/[,\s]+/);
			  });
		  },
		  1853: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.toArray = void 0);
			var n = o(80861),
			  r = o(28069);
			t.toArray = function () {
			  for (var e, t = [], o = 0; arguments.length > o; o++)
				t[o] = arguments[o];
			  var i = (0, r.isNativeFunction)(Array.from)
				? Array.from
				: null !== (e = (0, n.reset)("Array.from")) && void 0 !== e
				  ? e
				  : Array.from;
			  return i.apply(Array, t);
			};
		  },
		  4696: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(27512), t);
		  },
		  27512: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.clearTimeout = t.setTimeout = void 0);
			var n = o(20255);
			(t.setTimeout = function (e, t) {
			  for (var o = [], r = 2; arguments.length > r; r++)
				o[r - 2] = arguments[r];
			  return t
				? window.setTimeout.apply(
					window,
					n.__spreadArray([e, t], n.__read(o), !1),
				  )
				: (e.call.apply(e, n.__spreadArray([null], n.__read(o), !1)), 0);
			}),
			  (t.clearTimeout = function (e) {
				window.clearTimeout(e);
			  });
		  },
		  31553: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.hasBrowserColorPicker = void 0),
			  (t.hasBrowserColorPicker = function () {
				var e = !0;
				try {
				  var t = document.createElement("input");
				  (t.type = "color"),
					(t.value = "!"),
					(e = "color" === t.type && "!" !== t.value);
				} catch (t) {
				  e = !1;
				}
				return e;
			  });
		  },
		  10172: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(31553), t),
			  n.__exportStar(o(49781), t),
			  n.__exportStar(o(67749), t),
			  n.__exportStar(o(32756), t),
			  n.__exportStar(o(42096), t),
			  n.__exportStar(o(66869), t),
			  n.__exportStar(o(72543), t),
			  n.__exportStar(o(33156), t),
			  n.__exportStar(o(93578), t),
			  n.__exportStar(o(77892), t),
			  n.__exportStar(o(96574), t),
			  n.__exportStar(o(60280), t),
			  n.__exportStar(o(28069), t),
			  n.__exportStar(o(61817), t),
			  n.__exportStar(o(57649), t),
			  n.__exportStar(o(79736), t),
			  n.__exportStar(o(26335), t),
			  n.__exportStar(o(24421), t),
			  n.__exportStar(o(64350), t),
			  n.__exportStar(o(19179), t),
			  n.__exportStar(o(24021), t),
			  n.__exportStar(o(85994), t),
			  n.__exportStar(o(37204), t);
		  },
		  49781: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isArray = void 0),
			  (t.isArray = function (e) {
				return Array.isArray(e);
			  });
		  },
		  67749: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isBoolean = void 0),
			  (t.isBoolean = function (e) {
				return "boolean" == typeof e;
			  });
		  },
		  32756: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isFastEqual = t.isEqual = void 0);
			var n = o(42554);
			(t.isEqual = function (e, t) {
			  return e === t || (0, n.stringify)(e) === (0, n.stringify)(t);
			}),
			  (t.isFastEqual = function (e, t) {
				return e === t;
			  });
		  },
		  42096: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isFunction = void 0),
			  (t.isFunction = function (e) {
				return "function" == typeof e;
			  });
		  },
		  72543: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isHtmlFromWord = void 0),
			  (t.isHtmlFromWord = function (e) {
				return (
				  -1 !== e.search(/<meta.*?Microsoft Excel\s[\d].*?>/) ||
				  -1 !== e.search(/<meta.*?Microsoft Word\s[\d].*?>/) ||
				  (-1 !== e.search(/style="[^"]*mso-/) &&
					-1 !== e.search(/<font/))
				);
			  });
		  },
		  66869: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isHTML = void 0);
			var n = o(24421);
			t.isHTML = function (e) {
			  return (
				(0, n.isString)(e) &&
				/<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/m.test(
				  e.replace(/[\r\n]/g, ""),
				)
			  );
			};
		  },
		  33156: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.hasContainer = t.isDestructable = t.isInitable = void 0);
			var n = o(42096),
			  r = o(24263),
			  i = o(24021);
			(t.isInitable = function (e) {
			  return !(0, i.isVoid)(e) && (0, n.isFunction)(e.init);
			}),
			  (t.isDestructable = function (e) {
				return !(0, i.isVoid)(e) && (0, n.isFunction)(e.destruct);
			  }),
			  (t.hasContainer = function (e) {
				return !(0, i.isVoid)(e) && r.Dom.isElement(e.container);
			  });
		  },
		  93578: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isInt = void 0);
			var n = o(57649),
			  r = o(24421);
			t.isInt = function (e) {
			  return (
				(0, r.isString)(e) && (0, n.isNumeric)(e) && (e = parseFloat(e)),
				"number" == typeof e && Number.isFinite(e) && !(e % 1)
			  );
			};
		  },
		  77892: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isJoditObject = void 0);
			var n = o(42096);
			t.isJoditObject = function (e) {
			  return Boolean(
				e &&
				  e instanceof Object &&
				  (0, n.isFunction)(e.constructor) &&
				  (("undefined" != typeof Jodit && e instanceof Jodit) ||
					e.isJodit),
			  );
			};
		  },
		  60280: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isLicense = void 0);
			var n = o(24421);
			t.isLicense = function (e) {
			  return (
				(0, n.isString)(e) &&
				23 === e.length &&
				/^[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}$/i.test(e)
			  );
			};
		  },
		  37204: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isMarker = void 0);
			var n = o(24263),
			  r = o(86893);
			t.isMarker = function (e) {
			  return (
				n.Dom.isNode(e) &&
				n.Dom.isTag(e, "span") &&
				e.hasAttribute("data-" + r.MARKER_CLASS)
			  );
			};
		  },
		  28069: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isNativeFunction = void 0),
			  (t.isNativeFunction = function (e) {
				return (
				  Boolean(e) &&
				  "function" === (typeof e).toLowerCase() &&
				  (e === Function.prototype ||
					/^\s*function\s*(\b[a-z$_][a-z0-9$_]*\b)*\s*\((|([a-z$_][a-z0-9$_]*)(\s*,[a-z$_][a-z0-9$_]*)*)\)\s*{\s*\[native code]\s*}\s*$/i.test(
					  String(e),
					))
				);
			  });
		  },
		  61817: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isNumber = void 0),
			  (t.isNumber = function (e) {
				return "number" == typeof e && !isNaN(e) && isFinite(e);
			  });
		  },
		  57649: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isNumeric = void 0);
			var n = o(24421);
			t.isNumeric = function (e) {
			  if ((0, n.isString)(e)) {
				if (!e.match(/^([+-])?[0-9]+(\.?)([0-9]+)?(e[0-9]+)?$/))
				  return !1;
				e = parseFloat(e);
			  }
			  return "number" == typeof e && !isNaN(e) && isFinite(e);
			};
		  },
		  79736: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isPlainObject = void 0);
			var n = o(85994);
			t.isPlainObject = function (e) {
			  return !(
				!e ||
				"object" != typeof e ||
				e.nodeType ||
				(0, n.isWindow)(e) ||
				(e.constructor &&
				  !{}.hasOwnProperty.call(
					e.constructor.prototype,
					"isPrototypeOf",
				  ))
			  );
			};
		  },
		  26335: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isPromise = void 0),
			  (t.isPromise = function (e) {
				return e && "function" == typeof e.then;
			  });
		  },
		  24421: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isStringArray = t.isString = void 0);
			var n = o(49781);
			function r(e) {
			  return "string" == typeof e;
			}
			(t.isString = r),
			  (t.isStringArray = function (e) {
				return (0, n.isArray)(e) && r(e[0]);
			  });
		  },
		  64350: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isURL = void 0),
			  (t.isURL = function (e) {
				if (e.includes(" ")) return !1;
				if ("undefined" != typeof URL)
				  try {
					var t = new URL(e);
					return ["https:", "http:", "ftp:", "file:", "rtmp:"].includes(
					  t.protocol,
					);
				  } catch (e) {
					return !1;
				  }
				var o = document.createElement("a");
				return (o.href = e), Boolean(o.hostname);
			  });
		  },
		  19179: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isValidName = void 0),
			  (t.isValidName = function (e) {
				return !!e.length && !/[^0-9A-Za-zа-яА-ЯЁё\w\-_.]/.test(e);
			  });
		  },
		  96574: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isViewObject = void 0);
			var n = o(42096);
			t.isViewObject = function (e) {
			  return Boolean(
				e &&
				  e instanceof Object &&
				  (0, n.isFunction)(e.constructor) &&
				  e.isView,
			  );
			};
		  },
		  24021: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isVoid = void 0),
			  (t.isVoid = function (e) {
				return null == e;
			  });
		  },
		  85994: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isWindow = void 0),
			  (t.isWindow = function (e) {
				return null != e && e === e.window;
			  });
		  },
		  13203: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.colorToHex = void 0),
			  (t.colorToHex = function (e) {
				if ("rgba(0, 0, 0, 0)" === e || "" === e) return !1;
				if (!e) return "#000000";
				if ("#" === e.substr(0, 1)) return e;
				var t =
				  /([\s\n\t\r]*?)rgb\((\d+), (\d+), (\d+)\)/.exec(e) ||
				  /([\s\n\t\r]*?)rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/.exec(e);
				if (!t) return "#000000";
				for (
				  var o = parseInt(t[2], 10),
					n = parseInt(t[3], 10),
					r = (parseInt(t[4], 10) | (n << 8) | (o << 16))
					  .toString(16)
					  .toUpperCase();
				  6 > r.length;
  
				)
				  r = "0" + r;
				return t[1] + "#" + r;
			  });
		  },
		  61354: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(13203), t);
		  },
		  66546: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.applyStyles = void 0);
			var n = o(24263),
			  r = o(76502),
			  i = o(33941);
			function a(e) {
			  return e
				.replace(/mso-[a-z-]+:[\s]*[^;]+;/gi, "")
				.replace(/mso-[a-z-]+:[\s]*[^";']+$/gi, "")
				.replace(/border[a-z-]*:[\s]*[^;]+;/gi, "")
				.replace(/([0-9.]+)(pt|cm)/gi, function (e, t, o) {
				  switch (o.toLowerCase()) {
					case "pt":
					  return (1.328 * parseFloat(t)).toFixed(0) + "px";
					case "cm":
					  return (0.02645833 * parseFloat(t)).toFixed(0) + "px";
				  }
				  return e;
				});
			}
			t.applyStyles = function (e) {
			  if (-1 === e.indexOf("<html ")) return e;
			  e = (e = e.substring(e.indexOf("<html "), e.length)).substring(
				0,
				e.lastIndexOf("</html>") + "</html>".length,
			  );
			  var t = document.createElement("iframe");
			  (t.style.display = "none"), document.body.appendChild(t);
			  var o = "";
			  try {
				var s =
				  t.contentDocument ||
				  (t.contentWindow ? t.contentWindow.document : null);
				if (s) {
				  s.open(), s.write(e), s.close();
				  try {
					for (
					  var l = function (e) {
						  for (
							var t = s.styleSheets[e].cssRules,
							  o = function (e) {
								if ("" === t[e].selectorText) return "continue";
								(0, r.$$)(t[e].selectorText, s.body).forEach(
								  function (o) {
									o.style.cssText = a(
									  t[e].style.cssText + ";" + o.style.cssText,
									);
								  },
								);
							  },
							  n = 0;
							t.length > n;
							n += 1
						  )
							o(n);
						},
						c = 0;
					  s.styleSheets.length > c;
					  c += 1
					)
					  l(c);
				  } catch (e) {}
				  n.Dom.each(s.body, function (e) {
					if (n.Dom.isElement(e)) {
					  var t = e,
						o = t.getAttribute("style");
					  o && (t.style.cssText = a(o)),
						t.hasAttribute("style") &&
						  !t.getAttribute("style") &&
						  t.removeAttribute("style");
					}
				  }),
					(o = s.firstChild ? (0, i.trim)(s.body.innerHTML) : "");
				}
			  } catch (e) {
			  } finally {
				n.Dom.safeRemove(t);
			  }
			  return (
				o && (e = o),
				(0, i.trim)(
				  e
					.replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "")
					.replace(/<!--[^>]*>/g, ""),
				)
			  );
			};
		  },
		  33316: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.cleanFromWord = void 0);
			var n = o(24263),
			  r = o(33941),
			  i = o(1853);
			t.cleanFromWord = function (e) {
			  -1 !== e.indexOf("<html ") &&
				(e = (e = e.substring(e.indexOf("<html "), e.length)).substring(
				  0,
				  e.lastIndexOf("</html>") + "</html>".length,
				));
			  var t = "";
			  try {
				var o = document.createElement("div");
				o.innerHTML = e;
				var a = [];
				o.firstChild &&
				  n.Dom.each(o, function (e) {
					if (e)
					  switch (e.nodeType) {
						case Node.ELEMENT_NODE:
						  switch (e.nodeName) {
							case "STYLE":
							case "LINK":
							case "META":
							  a.push(e);
							  break;
							case "W:SDT":
							case "W:SDTPR":
							case "FONT":
							  n.Dom.unwrap(e);
							  break;
							default:
							  (0, i.toArray)(e.attributes).forEach(function (t) {
								-1 ===
								  ["src", "href", "rel", "content"].indexOf(
									t.name.toLowerCase(),
								  ) && e.removeAttribute(t.name);
							  });
						  }
						  break;
						case Node.TEXT_NODE:
						  break;
						default:
						  a.push(e);
					  }
				  }),
				  n.Dom.safeRemove.apply(null, a),
				  (t = o.innerHTML);
			  } catch (e) {}
			  return (
				t && (e = t),
				(e = e.split(/(\n)/).filter(r.trim).join("\n"))
				  .replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "")
				  .replace(/<!--[^>]*>/g, "")
			  );
			};
		  },
		  46639: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.htmlspecialchars = void 0),
			  (t.htmlspecialchars = function (e) {
				var t = document.createElement("div");
				return (t.textContent = e), t.innerHTML;
			  });
		  },
		  13098: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(66546), t),
			  n.__exportStar(o(33316), t),
			  n.__exportStar(o(46639), t),
			  n.__exportStar(o(11336), t),
			  n.__exportStar(o(67128), t),
			  n.__exportStar(o(86645), t);
		  },
		  86645: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.nl2br = void 0),
			  (t.nl2br = function (e) {
				return e.replace(/\r\n|\r|\n/g, "<br/>");
			  });
		  },
		  67128: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.sanitizeHTMLElement = t.safeHTML = void 0);
			var n = o(76502),
			  r = o(24263);
			function i(e, t) {
			  var o =
				  void 0 === t
					? { safeJavaScriptLink: !0, removeOnError: !0 }
					: t,
				i = o.safeJavaScriptLink,
				a = o.removeOnError;
			  if (!r.Dom.isElement(e)) return !1;
			  var s = !1;
			  a &&
				e.hasAttribute("onerror") &&
				((0, n.attr)(e, "onerror", null), (s = !0));
			  var l = e.getAttribute("href");
			  return (
				i &&
				  l &&
				  0 === l.trim().indexOf("javascript") &&
				  ((0, n.attr)(e, "href", location.protocol + "//" + l),
				  (s = !0)),
				s
			  );
			}
			(t.safeHTML = function (e, t) {
			  (r.Dom.isElement(e) || r.Dom.isFragment(e)) &&
				(t.removeOnError &&
				  (i(e),
				  (0, n.$$)("[onerror]", e).forEach(function (e) {
					return i(e, t);
				  })),
				t.safeJavaScriptLink &&
				  (i(e),
				  (0, n.$$)('a[href^="javascript"]', e).forEach(function (e) {
					return i(e, t);
				  })));
			}),
			  (t.sanitizeHTMLElement = i);
		  },
		  11336: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.stripTags = void 0);
			var n = o(24421),
			  r = o(76502),
			  i = o(33941),
			  a = o(24263),
			  s = new Set([
				"div",
				"p",
				"br",
				"h1",
				"h2",
				"h3",
				"h4",
				"h5",
				"h6",
				"hr",
			  ]),
			  l = new Set(["script", "style"]);
			t.stripTags = function e(t, o, c) {
			  void 0 === o && (o = document), void 0 === c && (c = null);
			  var u = o.createElement("div");
			  return (
				(0, n.isString)(t) ? (u.innerHTML = t) : u.appendChild(t),
				(0, r.$$)("*", u).forEach(function (t) {
				  var n = t.parentNode;
				  if (n) {
					if (c && a.Dom.isTag(t, c)) {
					  var r = t.nodeName.toLowerCase(),
						i = a.Dom.isTag(t, ["br", "hr", "input"])
						  ? "%%%jodit-single-".concat(r, "%%%")
						  : "%%%jodit-"
							  .concat(r, "%%%")
							  .concat(e(t.innerHTML, o, c), "%%%/jodit-")
							  .concat(r, "%%%");
					  return (
						a.Dom.before(t, o.createTextNode(i)),
						void a.Dom.safeRemove(t)
					  );
					}
					if (a.Dom.isTag(t, l)) a.Dom.safeRemove(t);
					else if (a.Dom.isTag(t, s)) {
					  var u = t.nextSibling;
					  (a.Dom.isText(u) && /^\s/.test(u.nodeValue || "")) ||
						(u && n.insertBefore(o.createTextNode(" "), u));
					}
				  }
				}),
				(0, i.trim)(u.innerText).replace(
				  /%%%(\/)?jodit(-single)?-([\w\n]+)%%%/g,
				  function (e, t, o, n) {
					return "<".concat(t ? "/" : "").concat(n, ">");
				  },
				)
			  );
			};
		  },
		  40332: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(76502), t),
			  n.__exportStar(o(12557), t),
			  n.__exportStar(o(4696), t),
			  n.__exportStar(o(10172), t),
			  n.__exportStar(o(61354), t),
			  n.__exportStar(o(13098), t),
			  n.__exportStar(o(89693), t),
			  n.__exportStar(o(90954), t),
			  n.__exportStar(o(19035), t);
		  },
		  89693: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(48926), t),
			  n.__exportStar(o(78648), t),
			  n.__exportStar(o(74504), t),
			  n.__exportStar(o(50870), t),
			  n.__exportStar(o(76787), t),
			  n.__exportStar(o(93251), t),
			  n.__exportStar(o(91518), t),
			  n.__exportStar(o(49353), t),
			  n.__exportStar(o(64274), t);
		  },
		  64274: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeColor = void 0);
			var n = o(61354),
			  r = o(19035);
			t.normalizeColor = function (e) {
			  var t = ["#"],
				o = (0, n.colorToHex)(e);
			  if (!o) return !1;
			  if (
				3 === (o = (o = (0, r.trim)(o.toUpperCase())).substr(1)).length
			  ) {
				for (var i = 0; 3 > i; i += 1) t.push(o[i]), t.push(o[i]);
				return t.join("");
			  }
			  return o.length > 6 && (o = o.substr(0, 6)), "#" + o;
			};
		  },
		  49353: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeCssValue =
				t.normalizeCssNumericValue =
				t.NUMBER_FIELDS_REG =
				  void 0);
			var n = o(57649),
			  r = o(11278),
			  i = o(13203),
			  a = o(24021);
			(t.NUMBER_FIELDS_REG =
			  /^(left|top|bottom|right|width|min|max|height|margin|padding|fontsize|font-size)/i),
			  (t.normalizeCssNumericValue = function (e, o) {
				return !(0, a.isVoid)(o) &&
				  t.NUMBER_FIELDS_REG.test(e) &&
				  (0, n.isNumeric)(o.toString())
				  ? parseInt(o.toString(), 10) + "px"
				  : o;
			  }),
			  (t.normalizeCssValue = function (e, t) {
				if ("font-weight" === (0, r.kebabCase)(e)) {
				  switch (t.toString().toLowerCase()) {
					case "700":
					case "bold":
					  return 700;
					case "400":
					case "normal":
					  return 400;
					case "900":
					case "heavy":
					  return 900;
				  }
				  return (0, n.isNumeric)(t) ? Number(t) : t;
				}
				return (
				  (/color/i.test(e) &&
					/^rgb/i.test(t.toString()) &&
					(0, i.colorToHex)(t.toString())) ||
				  t
				);
			  });
		  },
		  48926: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeKeyAliases = void 0);
			var n = o(33941),
			  r = o(86893);
			t.normalizeKeyAliases = function (e) {
			  var t = {},
				o = { meta: 1, ctrl: 2, control: 2, alt: 3, shift: 4 };
			  return e
				.replace(/\+\+/g, "+add")
				.split(/[\s]*\+[\s]*/)
				.map(function (e) {
				  return (0, n.trim)(e.toLowerCase());
				})
				.map(function (e) {
				  return r.KEY_ALIASES[e] || e;
				})
				.sort(function (e, t) {
				  return o[e] && !o[t]
					? -1
					: !o[e] && o[t]
					  ? 1
					  : o[e] && o[t]
						? o[e] - o[t]
						: e > t
						  ? 1
						  : -1;
				})
				.filter(function (e) {
				  return !t[e] && "" !== e && (t[e] = !0);
				})
				.join("+");
			};
		  },
		  78648: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeLicense = void 0),
			  (t.normalizeLicense = function (e, t) {
				void 0 === t && (t = 8);
				for (var o = []; e.length; )
				  o.push(e.substr(0, t)), (e = e.substr(t));
				return (
				  (o[1] = o[1].replace(/./g, "*")),
				  (o[2] = o[2].replace(/./g, "*")),
				  o.join("-")
				);
			  });
		  },
		  74504: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeNode = void 0);
			var n = o(86893),
			  r = o(24263);
			t.normalizeNode = function e(t) {
			  if (t) {
				if (r.Dom.isText(t) && null != t.nodeValue && t.parentNode)
				  for (; r.Dom.isText(t.nextSibling); )
					null != t.nextSibling.nodeValue &&
					  (t.nodeValue += t.nextSibling.nodeValue),
					  (t.nodeValue = t.nodeValue.replace(
						(0, n.INVISIBLE_SPACE_REG_EXP)(),
						"",
					  )),
					  r.Dom.safeRemove(t.nextSibling);
				else e(t.firstChild);
				e(t.nextSibling);
			  }
			};
		  },
		  50870: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizePath = void 0);
			var n = o(19035);
			t.normalizePath = function () {
			  for (var e = [], t = 0; arguments.length > t; t++)
				e[t] = arguments[t];
			  return e
				.filter(function (e) {
				  return (0, n.trim)(e).length;
				})
				.map(function (t, o) {
				  return (
					(t = t.replace(/([^:])[\\/]+/g, "$1/")),
					o && (t = t.replace(/^\//, "")),
					o !== e.length - 1 && (t = t.replace(/\/$/, "")),
					t
				  );
				})
				.join("/");
			};
		  },
		  76787: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeRelativePath = void 0),
			  (t.normalizeRelativePath = function (e) {
				return (
				  e
					.split("/")
					.reduce(function (e, t) {
					  switch (t) {
						case "":
						case ".":
						  break;
						case "..":
						  e.pop();
						  break;
						default:
						  e.push(t);
					  }
					  return e;
					}, [])
					.join("/") + (e.endsWith("/") ? "/" : "")
				);
			  });
		  },
		  93251: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeSize = void 0),
			  (t.normalizeSize = function (e) {
				return /^[0-9]+$/.test(e.toString()) ? e + "px" : e.toString();
			  });
		  },
		  91518: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeUrl = void 0),
			  (t.normalizeUrl = function () {
				for (var e = [], t = 0; arguments.length > t; t++)
				  e[t] = arguments[t];
				return e
				  .filter(function (e) {
					return e.length;
				  })
				  .map(function (e) {
					return e.replace(/\/$/, "");
				  })
				  .join("/")
				  .replace(/([^:])[\\/]+/g, "$1/");
			  });
		  },
		  1684: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getContentWidth = void 0),
			  (t.getContentWidth = function (e, t) {
				var o = function (e) {
					return parseInt(e, 10);
				  },
				  n = t.getComputedStyle(e);
				return (
				  e.offsetWidth -
				  o(n.getPropertyValue("padding-left") || "0") -
				  o(n.getPropertyValue("padding-right") || "0")
				);
			  });
		  },
		  73874: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getScrollParent = void 0);
			var n = o(76502),
			  r = o(24263);
			t.getScrollParent = function e(t) {
			  if (!t) return null;
			  var o = r.Dom.isHTMLElement(t),
				i = o && (0, n.css)(t, "overflowY");
			  return o &&
				"visible" !== i &&
				"hidden" !== i &&
				t.scrollHeight >= t.clientHeight
				? t
				: e(t.parentNode) || document.scrollingElement || document.body;
			};
		  },
		  90954: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(1684), t),
			  n.__exportStar(o(73874), t),
			  n.__exportStar(o(83810), t),
			  n.__exportStar(o(98701), t),
			  n.__exportStar(o(81710), t),
			  n.__exportStar(o(16492), t);
		  },
		  83810: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.innerWidth = void 0),
			  (t.innerWidth = function (e, t) {
				var o = t.getComputedStyle(e);
				return (
				  e.clientWidth -
				  (parseFloat(o.paddingLeft || "0") +
					parseFloat(o.paddingRight || "0"))
				);
			  });
		  },
		  16492: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.size = void 0);
			var n = o(10172);
			t.size = function (e) {
			  return (0, n.isString)(e) || (0, n.isArray)(e)
				? e.length
				: (0, n.isPlainObject)(e)
				  ? Object.keys(e).length
				  : 0;
			};
		  },
		  98701: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.offset = void 0),
			  (t.offset = function (e, o, n, r) {
				var i;
				void 0 === r && (r = !1);
				try {
				  i = e.getBoundingClientRect();
				} catch (e) {
				  i = {
					top: 0,
					bottom: 0,
					left: 0,
					right: 0,
					width: 0,
					height: 0,
				  };
				}
				var a,
				  s,
				  l = n.body,
				  c = n.documentElement || {
					clientTop: 0,
					clientLeft: 0,
					scrollTop: 0,
					scrollLeft: 0,
				  },
				  u = n.defaultView || n.parentWindow,
				  d = u.pageYOffset || c.scrollTop || l.scrollTop,
				  p = u.pageXOffset || c.scrollLeft || l.scrollLeft,
				  f = c.clientTop || l.clientTop || 0,
				  h = c.clientLeft || l.clientLeft || 0,
				  m = o.iframe;
				if (!r && o && o.options && o.o.iframe && m) {
				  var v = (0, t.offset)(m, o, o.od, !0);
				  (a = i.top + v.top), (s = i.left + v.left);
				} else (a = i.top + d - f), (s = i.left + p - h);
				return {
				  top: Math.round(a),
				  left: Math.round(s),
				  width: i.width,
				  height: i.height,
				};
			  });
		  },
		  81710: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.position = void 0);
			var n = o(77892);
			t.position = function e(t, o, r) {
			  void 0 === r && (r = !1);
			  var i = t.getBoundingClientRect(),
				a = i.left,
				s = i.top;
			  if (
				(0, n.isJoditObject)(o) &&
				o.iframe &&
				o.ed.body.contains(t) &&
				!r
			  ) {
				var l = e(o.iframe, o, !0);
				(a += l.left), (s += l.top);
			  }
			  return {
				left: Math.round(a),
				top: Math.round(s),
				width: Math.round(t.offsetWidth),
				height: Math.round(t.offsetHeight),
			  };
			};
		  },
		  26596: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.camelCase = void 0),
			  (t.camelCase = function (e) {
				return e.replace(/([-_])(.)/g, function (e, t, o) {
				  return o.toUpperCase();
				});
			  });
		  },
		  93163: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.fuzzySearchIndex = void 0);
			var n = o(86893);
			t.fuzzySearchIndex = function (e, t, o, r) {
			  void 0 === o && (o = 0), void 0 === r && (r = 1);
			  var i = 0,
				a = 0,
				s = -1,
				l = 0,
				c = 0;
			  for (a = o; e.length > i && t.length > a; )
				e[i].toLowerCase() === t[a].toLowerCase()
				  ? (i++, l++, (c = 0), -1 === s && (s = a))
				  : i > 0 &&
					(r > c || t[a] === n.INVISIBLE_SPACE
					  ? (c++, l++)
					  : ((i = 0), (s = -1), (l = 0), (c = 0), a--)),
				  a++;
			  return i === e.length ? [s, l] : [-1, 0];
			};
		  },
		  11625: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.i18n = t.sprintf = void 0);
			var n = o(93166),
			  r = o(76502),
			  i = o(24421),
			  a = o(13449),
			  s = o(86893);
			(t.sprintf = function (e, t) {
			  if (!t || !t.length) return e;
			  for (
				var o = /%([sd])/g, n = o.exec(e), r = e, i = 0;
				n && void 0 !== t[i];
  
			  )
				(r = r.replace(n[0], t[i].toString())), (i += 1), (n = o.exec(e));
			  return r;
			}),
			  (t.i18n = function (e, o, l) {
				if (!(0, i.isString)(e))
				  throw (0, r.error)("i18n: Need string in first argument");
				if (!e.length) return e;
				var c = Boolean(null == l ? void 0 : l.debugLanguage),
				  u = {},
				  d = function (e) {
					return o && o.length ? (0, t.sprintf)(e, o) : e;
				  },
				  p = (0, r.defaultLanguage)(
					n.Config.defaultOptions.language,
					n.Config.defaultOptions.language,
				  ),
				  f = (0, r.defaultLanguage)(null == l ? void 0 : l.language, p),
				  h = function (t) {
					if (t) {
					  if ((0, i.isString)(t[e])) return d(t[e]);
					  var o = e.toLowerCase();
					  if ((0, i.isString)(t[o])) return d(t[o]);
					  var n = (0, a.ucfirst)(e);
					  return (0, i.isString)(t[n]) ? d(t[n]) : void 0;
					}
				  };
				void 0 !== s.lang[f]
				  ? (u = s.lang[f])
				  : c || (u = void 0 !== s.lang[p] ? s.lang[p] : s.lang.en);
				var m = null == l ? void 0 : l.i18n;
				if (m && m[f]) {
				  var v = h(m[f]);
				  if (v) return v;
				}
				return (
				  h(u) ||
				  (!c &&
				  s.lang.en &&
				  (0, i.isString)(s.lang.en[e]) &&
				  s.lang.en[e]
					? d(s.lang.en[e])
					: c
					  ? "{" + e + "}"
					  : d(e))
				);
			  });
		  },
		  19035: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(26596), t),
			  n.__exportStar(o(93163), t),
			  n.__exportStar(o(11625), t),
			  n.__exportStar(o(11278), t),
			  n.__exportStar(o(42554), t),
			  n.__exportStar(o(33941), t),
			  n.__exportStar(o(13449), t);
		  },
		  11278: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.CamelCaseToKebabCase = t.kebabCase = void 0),
			  (t.kebabCase = function (e) {
				return e
				  .replace(/([A-Z])([A-Z])([a-z])/g, "$1-$2$3")
				  .replace(/([a-z])([A-Z])/g, "$1-$2")
				  .replace(/[\s_]+/g, "-")
				  .toLowerCase();
			  }),
			  (t.CamelCaseToKebabCase = function (e) {
				return e
				  .replace(/([A-Z])([A-Z])([a-z])/g, "$1-$2$3")
				  .replace(/([a-z])([A-Z])/g, "$1-$2")
				  .toLowerCase();
			  });
		  },
		  42554: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.stringify = void 0),
			  (t.stringify = function (e, t) {
				if ((void 0 === t && (t = {}), "object" != typeof e))
				  return String(e);
				var o = new Set(t.excludeKeys),
				  n = new WeakMap();
				return JSON.stringify(
				  e,
				  function (e, t) {
					if (!o.has(e)) {
					  if ("object" == typeof t && null != t) {
						if (n.get(t)) return "[refObject]";
						n.set(t, !0);
					  }
					  return t;
					}
				  },
				  t.prettify,
				);
			  });
		  },
		  33941: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.trimInv = t.trim = void 0);
			var n = o(86893);
			(t.trim = function (e) {
			  return e
				.replace((0, n.SPACE_REG_EXP_END)(), "")
				.replace((0, n.SPACE_REG_EXP_START)(), "");
			}),
			  (t.trimInv = function (e) {
				return e
				  .replace((0, n.INVISIBLE_SPACE_REG_EXP_END)(), "")
				  .replace((0, n.INVISIBLE_SPACE_REG_EXP_START)(), "");
			  });
		  },
		  13449: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ucfirst = void 0),
			  (t.ucfirst = function (e) {
				return e.length ? e[0].toUpperCase() + e.substr(1) : "";
			  });
		  },
		  60303: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.alignElement = t.clearAlign = t.hAlignElement = void 0);
			var n = o(64968),
			  r = o(26911);
			function i(e) {
			  n.Dom.each(e, function (e) {
				n.Dom.isHTMLElement(e) &&
				  e.style.textAlign &&
				  ((e.style.textAlign = ""),
				  e.style.cssText.trim().length || e.removeAttribute("style"));
			  });
			}
			(t.hAlignElement = function (e, t) {
			  t && "normal" !== t
				? "center" !== t
				  ? ((0, r.css)(e, "float", t), (0, r.clearCenterAlign)(e))
				  : (0, r.css)(e, {
					  float: "",
					  display: "block",
					  marginLeft: "auto",
					  marginRight: "auto",
					})
				: ((0, r.css)(e, "float") &&
					-1 !==
					  ["right", "left"].indexOf(
						(0, r.css)(e, "float").toString().toLowerCase(),
					  ) &&
					(0, r.css)(e, "float", ""),
				  (0, r.clearCenterAlign)(e));
			}),
			  (t.clearAlign = i),
			  (t.alignElement = function (e, t) {
				if (n.Dom.isNode(t) && n.Dom.isElement(t))
				  switch ((i(t), e.toLowerCase())) {
					case "justifyfull":
					  t.style.textAlign = "justify";
					  break;
					case "justifyright":
					  t.style.textAlign = "right";
					  break;
					case "justifyleft":
					  t.style.textAlign = "left";
					  break;
					case "justifycenter":
					  t.style.textAlign = "center";
				  }
			  });
		  },
		  62462: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.loadNextStyle =
				t.loadNext =
				t.appendStyleAsync =
				t.appendScriptAsync =
				t.appendScript =
				  void 0);
			var n = o(20255),
			  r = o(48240),
			  i = o(42096),
			  a = o(24421),
			  s = new Map(),
			  l = function (e) {
				return function (t, o) {
				  return n.__awaiter(void 0, void 0, Promise, function () {
					var r;
					return n.__generator(this, function (n) {
					  return s.has(o)
						? [2, s.get(o)]
						: ((r = e(t, o)), s.set(o, r), [2, r]);
					});
				  });
				};
			  };
			(t.appendScript = function (e, t, o) {
			  var n = e.c.element("script");
			  return (
				(n.type = "text/javascript"),
				(n.async = !0),
				(0, i.isFunction)(o) && !e.isInDestruct && e.e.on(n, "load", o),
				n.src || (n.src = (0, r.completeUrl)(t)),
				e.od.body.appendChild(n),
				{ callback: o, element: n }
			  );
			}),
			  (t.appendScriptAsync = l(function (e, o) {
				return new Promise(function (n, r) {
				  var i = (0, t.appendScript)(e, o, n).element;
				  !e.isInDestruct && e.e.on(i, "error", r);
				});
			  })),
			  (t.appendStyleAsync = l(function (e, t) {
				return new Promise(function (o, n) {
				  var i = e.c.element("link");
				  (i.rel = "stylesheet"),
					(i.media = "all"),
					(i.crossOrigin = "anonymous"),
					!e.isInDestruct &&
					  e.e
						.on(i, "load", function () {
						  return o(i);
						})
						.on(i, "error", n),
					(i.href = (0, r.completeUrl)(t)),
					e.o.shadowRoot
					  ? e.o.shadowRoot.appendChild(i)
					  : e.od.body.appendChild(i);
				});
			  })),
			  (t.loadNext = function (e, o, n) {
				return (
				  void 0 === n && (n = 0),
				  (0, a.isString)(o[n])
					? (0, t.appendScriptAsync)(e, o[n]).then(function () {
						return (0, t.loadNext)(e, o, n + 1);
					  })
					: Promise.resolve()
				);
			  }),
			  (t.loadNextStyle = function (e, o, n) {
				return (
				  void 0 === n && (n = 0),
				  (0, a.isString)(o[n])
					? (0, t.appendStyleAsync)(e, o[n]).then(function () {
						return (0, t.loadNextStyle)(e, o, n + 1);
					  })
					: Promise.resolve()
				);
			  });
		  },
		  603: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.assert = void 0);
			var n = o(20255),
			  r = (function (e) {
				function t(t) {
				  var o = e.call(this, t) || this;
				  return (o.name = "AssertionError"), o;
				}
				return n.__extends(t, e), t;
			  })(Error);
			t.assert = function (e, t) {
			  if (!e) throw new r("Assertion failed: ".concat(t));
			};
		  },
		  37682: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.browser = void 0),
			  (t.browser = function (e) {
				var t = navigator.userAgent.toLowerCase(),
				  o =
					/(firefox)[\s/]([\w.]+)/.exec(t) ||
					/(chrome)[\s/]([\w.]+)/.exec(t) ||
					/(webkit)[\s/]([\w.]+)/.exec(t) ||
					/(opera)(?:.*version)[\s/]([\w.]+)/.exec(t) ||
					/(msie)[\s]([\w.]+)/.exec(t) ||
					/(trident)\/([\w.]+)/.exec(t) ||
					0 > t.indexOf("compatible") ||
					[];
				return "version" === e
				  ? o[2]
				  : "webkit" === e
					? "chrome" === o[1] || "webkit" === o[1]
					: "ff" === e
					  ? "firefox" === o[1]
					  : "msie" === e
						? "trident" === o[1] || "msie" === o[1]
						: o[1] === e;
			  });
		  },
		  71567: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.buildQuery = void 0);
			var n = o(79736);
			t.buildQuery = function (e, o) {
			  var r = [],
				i = encodeURIComponent;
			  for (var a in e)
				if (Object.prototype.hasOwnProperty.call(e, a)) {
				  var s = o ? o + "[" + a + "]" : a,
					l = e[a];
				  r.push(
					(0, n.isPlainObject)(l)
					  ? (0, t.buildQuery)(l, s)
					  : i(s) + "=" + i(l),
				  );
				}
			  return r.join("&");
			};
		  },
		  48240: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.completeUrl = void 0),
			  (t.completeUrl = function (e) {
				return (
				  "file:" === window.location.protocol &&
					/^\/\//.test(e) &&
					(e = "https:" + e),
				  e
				);
			  });
		  },
		  64981: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ConfigFlatten = t.ConfigProto = void 0);
			var n = o(20255),
			  r = o(7935),
			  i = o(49781),
			  a = o(79736),
			  s = o(24421),
			  l = o(24021),
			  c = o(93166),
			  u = o(67309);
			(t.ConfigProto = function e(t, o, u) {
			  if (
				(void 0 === u && (u = 0),
				Object.getPrototypeOf(t) !== Object.prototype)
			  )
				return t;
			  var d = c.Config.defaultOptions;
			  if ((0, s.isString)(t.preset)) {
				if (void 0 !== d.presets[t.preset]) {
				  var p = d.presets[t.preset];
				  Object.keys(p).forEach(function (e) {
					(0, l.isVoid)(t[e]) && (t[e] = p[e]);
				  });
				}
				delete t.preset;
			  }
			  var f = {};
			  return (
				Object.keys(t).forEach(function (s) {
				  var l = t[s],
					c = o ? o[s] : null;
				  f[s] =
					(0, a.isPlainObject)(l) &&
					(0, a.isPlainObject)(c) &&
					!(0, r.isAtom)(l)
					  ? e(l, c, u + 1)
					  : 0 !== u &&
						  (0, i.isArray)(l) &&
						  !(0, r.isAtom)(l) &&
						  (0, i.isArray)(c)
						? n.__spreadArray(
							n.__spreadArray([], n.__read(l), !1),
							n.__read(c.slice(l.length)),
							!1,
						  )
						: l;
				}),
				Object.setPrototypeOf(f, o),
				f
			  );
			}),
			  (t.ConfigFlatten = function (e) {
				return (0, u.keys)(e, !1).reduce(function (t, o) {
				  return (t[o] = e[o]), t;
				}, {});
			  });
		  },
		  42051: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.convertMediaUrlToVideoEmbed = void 0);
			var n = o(64350),
			  r = o(67285);
			t.convertMediaUrlToVideoEmbed = function (e, t, o) {
			  if (
				(void 0 === t && (t = 400),
				void 0 === o && (o = 345),
				!(0, n.isURL)(e))
			  )
				return e;
			  var i = document.createElement("a"),
				a = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
			  (i.href = e), t || (t = 400), o || (o = 345);
			  var s = i.protocol || "";
			  switch (i.hostname) {
				case "www.vimeo.com":
				case "vimeo.com":
				  return a.test(e)
					? e.replace(
						a,
						'<iframe width="' +
						  t +
						  '" height="' +
						  o +
						  '" src="' +
						  s +
						  '//player.vimeo.com/video/$1" frameborder="0" allowfullscreen></iframe>',
					  )
					: e;
				case "youtube.com":
				case "www.youtube.com":
				case "youtu.be":
				case "www.youtu.be":
				  var l = i.search
					? (0, r.parseQuery)(i.search)
					: { v: i.pathname.substr(1) };
				  return l.v
					? '<iframe width="' +
						t +
						'" height="' +
						o +
						'" src="' +
						s +
						"//www.youtube.com/embed/" +
						l.v +
						'" frameborder="0" allowfullscreen></iframe>'
					: e;
			  }
			  return e;
			};
		  },
		  26911: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.clearCenterAlign = t.css = void 0);
			var n = o(79736),
			  r = o(67749),
			  i = o(49353),
			  a = o(26596),
			  s = o(11278);
			function l(e, t, o, c) {
			  if (
				(void 0 === c && (c = !1),
				(0, r.isBoolean)(o) && ((c = o), (o = void 0)),
				(0, n.isPlainObject)(t) || void 0 !== o)
			  ) {
				var u = function (e, t, o) {
				  void 0 === (o = (0, i.normalizeCssNumericValue)(t, o)) ||
					(null != o &&
					  l(e, t, !0) === (0, i.normalizeCssValue)(t, o)) ||
					(e.style[t] = o);
				};
				if ((0, n.isPlainObject)(t))
				  for (var d = Object.keys(t), p = 0; d.length > p; p += 1)
					u(e, (0, a.camelCase)(d[p]), t[d[p]]);
				else u(e, (0, a.camelCase)(t), o);
				return "";
			  }
			  var f = (0, s.kebabCase)(t),
				h = e.ownerDocument || document,
				m = !!h && (h.defaultView || h.parentWindow),
				v = e.style[t],
				g = "";
			  return (
				void 0 !== v && "" !== v
				  ? (g = v)
				  : m && !c && (g = m.getComputedStyle(e).getPropertyValue(f)),
				i.NUMBER_FIELDS_REG.test(t) &&
				  /^[-+]?[0-9.]+px$/.test(g.toString()) &&
				  (g = parseInt(g.toString(), 10)),
				(0, i.normalizeCssValue)(t, g)
			  );
			}
			(t.css = l),
			  (t.clearCenterAlign = function (e) {
				"block" === l(e, "display") && l(e, "display", "");
				var t = e.style;
				"auto" === t.marginLeft &&
				  "auto" === t.marginRight &&
				  ((t.marginLeft = ""), (t.marginRight = ""));
			  });
		  },
		  2522: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ctrlKey = void 0),
			  (t.ctrlKey = function (e) {
				if (
				  "undefined" != typeof navigator &&
				  -1 !== navigator.userAgent.indexOf("Mac OS X")
				) {
				  if (e.metaKey && !e.altKey) return !0;
				} else if (e.ctrlKey && !e.altKey) return !0;
				return !1;
			  });
		  },
		  63122: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.dataBind = void 0);
			var n = o(96574),
			  r = new WeakMap();
			t.dataBind = function (e, t, o) {
			  var i = r.get(e);
			  if (!i) {
				r.set(e, (i = {}));
				var a = null;
				(0, n.isViewObject)(e.j) && (a = e.j.e),
				  (0, n.isViewObject)(e) && (a = e.e),
				  a &&
					a.on("beforeDestruct", function () {
					  r.delete(e);
					});
			  }
			  return void 0 === o ? i[t] : ((i[t] = o), o);
			};
		  },
		  93351: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.defaultLanguage = void 0);
			var n = o(24421);
			t.defaultLanguage = function (e, t) {
			  return (
				void 0 === t && (t = "en"),
				"auto" !== e && (0, n.isString)(e)
				  ? e
				  : document.documentElement && document.documentElement.lang
					? document.documentElement.lang
					: navigator.language
					  ? navigator.language.substring(0, 2)
					  : t
			  );
			};
		  },
		  41579: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isAbort = t.abort = t.options = t.connection = t.error = void 0);
			var n = o(45339);
			(t.error = function (e) {
			  return new TypeError(e);
			}),
			  (t.connection = function (e) {
				return new n.ConnectionError(e);
			  }),
			  (t.options = function (e) {
				return new n.OptionsError(e);
			  }),
			  (t.abort = function (e) {
				return new n.AbortError(e);
			  }),
			  (t.isAbort = function (e) {
				return e instanceof n.AbortError;
			  });
		  },
		  86768: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.AbortError = void 0);
			var n = o(20255),
			  r = (function (e) {
				function t(o) {
				  var n = e.call(this, o) || this;
				  return Object.setPrototypeOf(n, t.prototype), n;
				}
				return n.__extends(t, e), t;
			  })(Error);
			t.AbortError = r;
		  },
		  43380: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ConnectionError = void 0);
			var n = o(20255),
			  r = (function (e) {
				function t(o) {
				  var n = e.call(this, o) || this;
				  return Object.setPrototypeOf(n, t.prototype), n;
				}
				return n.__extends(t, e), t;
			  })(Error);
			t.ConnectionError = r;
		  },
		  45339: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(86768), t),
			  n.__exportStar(o(43380), t),
			  n.__exportStar(o(47403), t);
		  },
		  47403: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.OptionsError = void 0);
			var n = o(20255),
			  r = (function (e) {
				function t(o) {
				  var n = e.call(this, o) || this;
				  return Object.setPrototypeOf(n, t.prototype), n;
				}
				return n.__extends(t, e), t;
			  })(TypeError);
			t.OptionsError = r;
		  },
		  56964: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(41579), t), n.__exportStar(o(45339), t);
		  },
		  7935: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.fastClone = t.markAsAtomic = t.isAtom = void 0);
			var n = o(42554);
			(t.isAtom = function (e) {
			  return e && e.isAtom;
			}),
			  (t.markAsAtomic = function (e) {
				return (
				  Object.defineProperty(e, "isAtom", {
					enumerable: !1,
					value: !0,
					configurable: !1,
				  }),
				  e
				);
			  }),
			  (t.fastClone = function (e) {
				return JSON.parse((0, n.stringify)(e));
			  });
		  },
		  87247: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getClassName = t.keepNames = void 0);
			var n = o(42096);
			(t.keepNames = new Map()),
			  (t.getClassName = function (e) {
				var o;
				if ((0, n.isFunction)(e.className)) return e.className();
				var r =
				  (null === (o = e.constructor) || void 0 === o
					? void 0
					: o.originalConstructor) || e.constructor;
				if (t.keepNames.has(r)) return t.keepNames.get(r);
				if (r.name) return r.name;
				var i = new RegExp(/^\s*function\s*(\S*)\s*\(/),
				  a = r.toString().match(i);
				return a ? a[1] : "";
			  });
		  },
		  69384: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.get = void 0);
			var n = o(20255),
			  r = o(24421),
			  i = o(24021);
			t.get = function (e, t) {
			  var o, a;
			  if (!(0, r.isString)(e) || !e.length) return null;
			  var s = e.split("."),
				l = t;
			  try {
				try {
				  for (
					var c = n.__values(s), u = c.next();
					!u.done;
					u = c.next()
				  ) {
					var d = u.value;
					if ((0, i.isVoid)(l[d])) return null;
					l = l[d];
				  }
				} catch (e) {
				  o = { error: e };
				} finally {
				  try {
					u && !u.done && (a = c.return) && a.call(c);
				  } finally {
					if (o) throw o.error;
				  }
				}
			  } catch (e) {
				return null;
			  }
			  return (0, i.isVoid)(l) ? null : l;
			};
		  },
		  6102: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.humanSizeToBytes = void 0),
			  (t.humanSizeToBytes = function (e) {
				if (/^[0-9.]+$/.test(e.toString())) return parseFloat(e);
				var t = e.substr(-2, 2).toUpperCase(),
				  o = ["KB", "MB", "GB", "TB"],
				  n = parseFloat(e.substr(0, e.length - 2));
				return -1 !== o.indexOf(t)
				  ? n * Math.pow(1024, o.indexOf(t) + 1)
				  : parseInt(e, 10);
			  });
		  },
		  76502: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(60303), t),
			  n.__exportStar(o(62462), t),
			  n.__exportStar(o(52378), t),
			  n.__exportStar(o(37682), t),
			  n.__exportStar(o(71567), t),
			  n.__exportStar(o(48240), t),
			  n.__exportStar(o(64981), t),
			  n.__exportStar(o(42051), t),
			  n.__exportStar(o(26911), t),
			  n.__exportStar(o(2522), t),
			  n.__exportStar(o(63122), t),
			  n.__exportStar(o(93351), t),
			  n.__exportStar(o(56964), t),
			  n.__exportStar(o(7935), t),
			  n.__exportStar(o(69384), t),
			  n.__exportStar(o(87247), t),
			  n.__exportStar(o(6102), t),
			  n.__exportStar(o(47580), t),
			  n.__exportStar(o(67285), t),
			  n.__exportStar(o(21498), t),
			  n.__exportStar(o(80861), t),
			  n.__exportStar(o(9005), t),
			  n.__exportStar(o(54188), t),
			  n.__exportStar(o(21518), t),
			  n.__exportStar(o(37228), t),
			  n.__exportStar(o(67309), t),
			  n.__exportStar(o(22362), t);
		  },
		  47580: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.markDeprecated = t.cns = void 0);
			var n = o(20255);
			(t.cns = console),
			  (t.markDeprecated = function (e, o, r) {
				return (
				  void 0 === o && (o = [""]),
				  void 0 === r && (r = null),
				  function () {
					for (var i = [], a = 0; arguments.length > a; a++)
					  i[a] = arguments[a];
					return (
					  t.cns.warn(
						'Method "'.concat(o[0], '" deprecated.') +
						  (o[1] ? ' Use "'.concat(o[1], '" instead') : ""),
					  ),
					  e.call.apply(e, n.__spreadArray([r], n.__read(i), !1))
					);
				  }
				);
			  });
		  },
		  67285: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.parseQuery = void 0),
			  (t.parseQuery = function (e) {
				for (
				  var t = {}, o = e.substring(1).split("&"), n = 0;
				  o.length > n;
				  n += 1
				) {
				  var r = o[n].split("=");
				  t[decodeURIComponent(r[0])] = decodeURIComponent(r[1] || "");
				}
				return t;
			  });
		  },
		  21498: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.previewBox = void 0);
			var n = o(24421),
			  r = o(24263),
			  i = o(26911),
			  a = o(67309),
			  s = o(54188);
			t.previewBox = function (e, t, o, l) {
			  void 0 === o && (o = "px"), void 0 === l && (l = null);
			  var c = (function (e, t) {
				var o = [];
				try {
				  (0, s.$$)("img", e.editor).forEach(function (n) {
					var i = [
					  (0, a.attr)(n, "width"),
					  (0, a.attr)(n, "height"),
					  n.src,
					];
					(0, a.attr)(n, {
					  width: n.offsetWidth + t,
					  height: n.offsetHeight + t,
					});
					var s = e.createInside.a();
					e.ed.body.appendChild(s),
					  (s.href = n.src),
					  (n.src = s.href),
					  r.Dom.safeRemove(s),
					  o.push(function () {
						var e;
						(n.src = null !== (e = i[2]) && void 0 !== e ? e : ""),
						  (0, a.attr)(n, {
							width: i[0] || null,
							height: i[1] || null,
						  });
					  });
				  });
				} catch (e) {
				  throw (
					(o.forEach(function (e) {
					  return e();
					}),
					(o.length = 0),
					e)
				  );
				}
				return o;
			  })(e, o);
			  try {
				var u = e.e.fire("beforePreviewBox", t, o);
				if (null != u) return u;
				var d = e.c.div("jodit__preview-box jodit-context");
				l && l.appendChild(d),
				  (0, i.css)(d, { position: "relative", padding: 16 });
				var p =
				  e.value ||
				  "<div style='position: absolute;left:50%;top:50%;transform: translateX(-50%) translateY(-50%);color:#ccc;'>".concat(
					e.i18n("Empty"),
					"</div>",
				  );
				if (e.iframe) {
				  var f = e.create.element("iframe");
				  (0, i.css)(f, { minWidth: 800, minHeight: 600, border: 0 }),
					d.appendChild(f);
				  var h = f.contentWindow;
				  if (
					h &&
					(e.e.fire("generateDocumentStructure.iframe", h.document, e),
					(d = h.document.body),
					"function" == typeof ResizeObserver)
				  ) {
					var m = new ResizeObserver(function (e) {
					  f.style.height = h.document.body.offsetHeight + 20 + "px";
					});
					m.observe(h.document.body),
					  e.e.on("beforeDestruct", function () {
						m.unobserve(h.document.body);
					  });
				  }
				} else
				  (0, i.css)(d, { minWidth: 1024, minHeight: 600, border: 0 });
				var v = function (t, o) {
				  var i = (0, n.isString)(o) ? e.c.div() : o;
				  (0, n.isString)(o) && (i.innerHTML = o);
				  for (var s = 0; i.childNodes.length > s; s += 1) {
					var l = i.childNodes[s];
					if (r.Dom.isElement(l)) {
					  for (
						var c = t.ownerDocument.createElement(l.nodeName), u = 0;
						l.attributes.length > u;
						u += 1
					  )
						(0, a.attr)(
						  c,
						  l.attributes[u].nodeName,
						  l.attributes[u].nodeValue,
						);
					  0 === l.childNodes.length || r.Dom.isTag(l, ["table"])
						? "SCRIPT" === l.nodeName
						  ? l.textContent && (c.textContent = l.textContent)
						  : l.innerHTML && (c.innerHTML = l.innerHTML)
						: v(c, l);
					  try {
						t.appendChild(c);
					  } catch (e) {}
					} else
					  try {
						t.appendChild(l.cloneNode(!0));
					  } catch (e) {}
				  }
				};
				return v(d, p), e.e.fire("afterPreviewBox", d), d;
			  } finally {
				c.forEach(function (e) {
				  return e();
				});
			  }
			};
		  },
		  80861: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.reset = void 0);
			var n = o(69384),
			  r = o(42096),
			  i = {};
			t.reset = function (e) {
			  var t, o;
			  if (!(e in i)) {
				var a = document.createElement("iframe");
				try {
				  if (
					((a.src = "about:blank"),
					document.body.appendChild(a),
					!a.contentWindow)
				  )
					return null;
				  var s = (0, n.get)(e, a.contentWindow),
					l = (0, n.get)(
					  e.split(".").slice(0, -1).join("."),
					  a.contentWindow,
					);
				  (0, r.isFunction)(s) && (i[e] = s.bind(l));
				} catch (e) {
				} finally {
				  null === (t = a.parentNode) || void 0 === t || t.removeChild(a);
				}
			  }
			  return null !== (o = i[e]) && void 0 !== o ? o : null;
			};
		  },
		  9005: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.scrollIntoViewIfNeeded = t.inView = void 0);
			var n = o(24263);
			(t.inView = function (e, t, o) {
			  var n = e.getBoundingClientRect(),
				r = e,
				i = n.top,
				a = n.height;
			  do {
				if (r && r.parentNode) {
				  if ((n = (r = r.parentNode).getBoundingClientRect()).bottom < i)
					return !1;
				  if (n.top >= i + a) return !1;
				}
			  } while (r && r !== t && r.parentNode);
			  return (
				((o.documentElement && o.documentElement.clientHeight) || 0) >= i
			  );
			}),
			  (t.scrollIntoViewIfNeeded = function (e, o, r) {
				n.Dom.isHTMLElement(e) &&
				  !(0, t.inView)(e, o, r) &&
				  (o.clientHeight !== o.scrollHeight &&
					(o.scrollTop = e.offsetTop),
				  (0, t.inView)(e, o, r) || e.scrollIntoView());
			  });
		  },
		  54188: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.resolveElement =
				t.cssPath =
				t.refs =
				t.getXPathByElement =
				t.$$ =
				  void 0);
			var n = o(86893),
			  r = o(24421),
			  i = o(76502),
			  a = o(24263),
			  s = o(26596),
			  l = o(1853),
			  c = o(53929),
			  u = o(45113),
			  d = 1;
			function p(e, t) {
			  var o;
			  if (
				!/:scope/.test(e) ||
				!n.IS_IE ||
				(t && t.nodeType === Node.DOCUMENT_NODE)
			  )
				o = t.querySelectorAll(e);
			  else {
				var r = t.id,
				  i = r || "_selector_id_" + String(Math.random()).slice(2) + ++d;
				(e = e.replace(/:scope/g, "#" + i)),
				  !r && t.setAttribute("id", i),
				  (o = t.parentNode.querySelectorAll(e)),
				  r || t.removeAttribute("id");
			  }
			  return [].slice.call(o);
			}
			(t.$$ = p),
			  (t.getXPathByElement = function (e, o) {
				if (!e || e.nodeType !== Node.ELEMENT_NODE) return "";
				if (!e.parentNode || o === e) return "";
				if (e.id) return "//*[@id='" + e.id + "']";
				var n = [].filter.call(e.parentNode.childNodes, function (t) {
				  return t.nodeName === e.nodeName;
				});
				return (
				  (0, t.getXPathByElement)(e.parentNode, o) +
				  "/" +
				  e.nodeName.toLowerCase() +
				  (n.length > 1
					? "[" + ((0, l.toArray)(n).indexOf(e) + 1) + "]"
					: "")
				);
			  }),
			  (t.refs = function (e) {
				return (
				  u.Component.isInstanceOf(e, c.UIElement) && (e = e.container),
				  p("[ref],[data-ref]", e).reduce(function (e, t) {
					var o = (0, i.attr)(t, "-ref");
					return (
					  o &&
						(0, r.isString)(o) &&
						((e[(0, s.camelCase)(o)] = t), (e[o] = t)),
					  e
					);
				  }, {})
				);
			  }),
			  (t.cssPath = function (e) {
				if (!a.Dom.isElement(e)) return null;
				for (var t = [], o = e; o && o.nodeType === Node.ELEMENT_NODE; ) {
				  var n = o.nodeName.toLowerCase();
				  if (o.id) {
					t.unshift((n += "#" + o.id));
					break;
				  }
				  var r = o,
					i = 1;
				  do {
					(r = r.previousElementSibling) &&
					  r.nodeName.toLowerCase() === n &&
					  i++;
				  } while (r);
				  t.unshift((n += ":nth-of-type(" + i + ")")), (o = o.parentNode);
				}
				return t.join(" > ");
			  }),
			  (t.resolveElement = function (e, t) {
				var o = e;
				if ((0, r.isString)(e))
				  try {
					o = t.querySelector(e);
				  } catch (t) {
					throw (0, i.error)(
					  'String "' + e + '" should be valid HTML selector',
					);
				  }
				if (
				  !o ||
				  "object" != typeof o ||
				  !a.Dom.isElement(o) ||
				  !o.cloneNode
				)
				  throw (0, i.error)(
					'Element "' +
					  e +
					  '" should be string or HTMLElement instance',
				  );
				return o;
			  });
		  },
		  21518: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.set = void 0);
			var n = o(24421),
			  r = o(57649),
			  i = o(49781),
			  a = o(79736);
			t.set = function (e, t, o) {
			  if ((0, n.isString)(e) && e.length) {
				for (
				  var s = e.split("."), l = o, c = s[0], u = 0;
				  s.length - 1 > u;
				  u += 1
				)
				  (0, i.isArray)(l[(c = s[u])]) ||
					(0, a.isPlainObject)(l[c]) ||
					(l[c] = (0, r.isNumeric)(s[u + 1]) ? [] : {}),
					(l = l[c]);
				l && (l[s[s.length - 1]] = t);
			  }
			};
		  },
		  37228: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.LimitedStack = void 0);
			var o = (function () {
			  function e(e) {
				(this.limit = e), (this.stack = []);
			  }
			  return (
				(e.prototype.push = function (e) {
				  return (
					this.stack.push(e),
					this.stack.length > this.limit && this.stack.shift(),
					this
				  );
				}),
				(e.prototype.pop = function () {
				  return this.stack.pop();
				}),
				(e.prototype.find = function (e) {
				  return this.stack.find(e);
				}),
				e
			  );
			})();
			t.LimitedStack = o;
		  },
		  67309: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getDataTransfer =
				t.memorizeExec =
				t.keys =
				t.loadImage =
				t.callPromise =
				t.markOwner =
				t.attr =
				t.call =
				  void 0);
			var n = o(20255),
			  r = o(42096),
			  i = o(26335),
			  a = o(24021),
			  s = o(79736),
			  l = o(24421),
			  c = o(63122),
			  u = o(26911),
			  d = o(11278);
			function p(e, t, o) {
			  if (!e || !(0, r.isFunction)(e.getAttribute)) return null;
			  if (!(0, l.isString)(t))
				return (
				  Object.keys(t).forEach(function (o) {
					var n = t[o];
					(0, s.isPlainObject)(n) && "style" === o
					  ? (0, u.css)(e, n)
					  : ("className" === o && (o = "class"), p(e, o, n));
				  }),
				  null
				);
			  var n = (0, d.CamelCaseToKebabCase)(t);
			  if (/^-/.test(n)) {
				var i = p(e, "data".concat(n));
				if (i) return i;
				n = n.substr(1);
			  }
			  if (void 0 !== o) {
				if (null != o)
				  return e.setAttribute(n, o.toString()), o.toString();
				e.hasAttribute(n) && e.removeAttribute(n);
			  }
			  return e.getAttribute(n);
			}
			(t.call = function (e) {
			  for (var t = [], o = 1; arguments.length > o; o++)
				t[o - 1] = arguments[o];
			  return e.apply(void 0, n.__spreadArray([], n.__read(t), !1));
			}),
			  (t.attr = p),
			  (t.markOwner = function (e, t) {
				p(t, "data-editor_id", e.id),
				  !t.component && Object.defineProperty(t, "jodit", { value: e });
			  }),
			  (t.callPromise = function (e, t) {
				return (0, i.isPromise)(e) ? e.finally(t) : t();
			  }),
			  (t.loadImage = function (e, t) {
				return t.async.promise(function (o, n) {
				  var r = new Image(),
					i = function () {
					  t.e.off(r), null == n || n();
					},
					a = function () {
					  t.e.off(r), o(r);
					};
				  t.e.one(r, "load", a).one(r, "error", i).one(r, "abort", i),
					(r.src = e),
					r.complete && a();
				});
			  }),
			  (t.keys = function (e, t) {
				if ((void 0 === t && (t = !0), t)) return Object.keys(e);
				var o = [];
				for (var n in e) o.push(n);
				return o;
			  }),
			  (t.memorizeExec = function (e, t, o, n) {
				var r,
				  i = o.control,
				  s = "button".concat(i.command),
				  l =
					null !== (r = i.args && i.args[0]) && void 0 !== r
					  ? r
					  : (0, c.dataBind)(e, s);
				if ((0, a.isVoid)(l)) return !1;
				(0, c.dataBind)(e, s, l),
				  n && (l = n(l)),
				  e.execCommand(i.command, !1, null != l ? l : void 0);
			  }),
			  (t.getDataTransfer = function (e) {
				if (e.clipboardData) return e.clipboardData;
				try {
				  return e.dataTransfer || new DataTransfer();
				} catch (e) {
				  return null;
				}
			  });
		  },
		  22362: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.val = void 0),
			  (t.val = function (e, t, o) {
				var n = e.querySelector(t);
				return n ? (o && (n.value = o), n.value) : "";
			  });
		  },
		  33286: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.init = t.initInstance = void 0);
			var n = o(10172),
			  r = o(90338);
			function i(e, t, o, i, a) {
			  var s = o.requires;
			  if (
				(null == s ? void 0 : s.length) &&
				!s.every(function (e) {
				  return i.has(e);
				})
			  )
				return (a[t] = o), !1;
			  if ((0, n.isInitable)(o))
				try {
				  o.init(e);
				} catch (e) {}
			  return (
				i.add(t),
				delete a[t],
				o.hasStyle && (0, r.loadStyle)(e, t).catch(function (e) {}),
				!0
			  );
			}
			(t.initInstance = function (e, t, o, n, r) {
			  i(e, t, o, n, r) &&
				Object.keys(r).forEach(function (t) {
				  i(e, t, r[t], n, r);
				});
			}),
			  (t.init = i);
		  },
		  90338: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.loadExtras = t.loadStyle = void 0);
			var n = o(20255),
			  r = o(62462),
			  i = o(11278),
			  a = o(93498),
			  s = new Set();
			function l(e, t, o) {
			  return (
				(t = (0, i.kebabCase)(t)),
				e.basePath + "plugins/" + t + "/" + t + "." + (o ? "js" : "css")
			  );
			}
			(t.loadStyle = function (e, t) {
			  return n.__awaiter(this, void 0, Promise, function () {
				var o;
				return n.__generator(this, function (n) {
				  return (
					(o = l(e, t, !1)),
					s.has(o)
					  ? [2]
					  : (s.add(o), [2, (0, r.appendStyleAsync)(e, o)])
				  );
				});
			  });
			}),
			  (t.loadExtras = function (e, t, o, n) {
				try {
				  var i = o.filter(function (t) {
					return !e.has((0, a.normalizeName)(t.name));
				  });
				  i.length &&
					(function (e, t, o) {
					  t.map(function (t) {
						var n = t.url || l(e, t.name, !0);
						return (0, r.appendScriptAsync)(e, n)
						  .then(o)
						  .catch(function () {
							return null;
						  });
					  });
					})(t, i, n);
				} catch (e) {}
			  });
		  },
		  24342: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.makeInstance = void 0);
			var n = o(10172);
			t.makeInstance = function (e, t) {
			  try {
				try {
				  return (0, n.isFunction)(t) ? new t(e) : t;
				} catch (o) {
				  if ((0, n.isFunction)(t) && !t.prototype) return t(e);
				}
			  } catch (e) {}
			  return null;
			};
		  },
		  93498: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.normalizeName = void 0);
			var n = o(11278);
			t.normalizeName = function (e) {
			  return (0, n.kebabCase)(e).toLowerCase();
			};
		  },
		  57549: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(44540), t), n.__exportStar(o(85605), t);
		  },
		  13573: function () {},
		  44540: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.PluginSystem = void 0);
			var n = o(20255);
			o(13573);
			var r = o(10172),
			  i = o(12557),
			  a = o(17332),
			  s = o(90338),
			  l = o(93498),
			  c = o(24342),
			  u = o(33286),
			  d = (function () {
				function e() {
				  this.__items = new Map();
				}
				return (
				  (e.prototype.add = function (e, t) {
					this.__items.set((0, l.normalizeName)(e), t),
					  a.eventEmitter.fire("plugin:".concat(e, ":ready"));
				  }),
				  (e.prototype.get = function (e) {
					return this.__items.get((0, l.normalizeName)(e));
				  }),
				  (e.prototype.remove = function (e) {
					this.__items.delete((0, l.normalizeName)(e));
				  }),
				  (e.prototype.__filter = function (e) {
					var t = [];
					return (
					  this.__items.forEach(function (o, n) {
						(e && !e.has(n)) || t.push([n, o]);
					  }),
					  t
					);
				  }),
				  (e.prototype.__init = function (e) {
					var t = this,
					  o = (function (e) {
						return {
						  extrasList: e.o.extraPlugins.map(function (e) {
							return (0, r.isString)(e) ? { name: e } : e;
						  }),
						  disableList: new Set(
							(0, i.splitArray)(e.o.disablePlugins).map(
							  l.normalizeName,
							),
						  ),
						  filter: e.o.safeMode
							? new Set(e.o.safePluginsList)
							: null,
						};
					  })(e),
					  a = o.extrasList,
					  d = o.disableList,
					  p = o.filter,
					  f = new Set(),
					  h = {},
					  m = {};
					e.__plugins = m;
					var v = function () {
					  if (!e.isInDestruct) {
						var o = !1;
						t.__filter(p).forEach(function (t) {
						  var i = n.__read(t, 2),
							a = i[0],
							s = i[1];
						  if (!(d.has(a) || f.has(a) || h[a])) {
							var l = null == s ? void 0 : s.requires;
							if (
							  !(
								l &&
								(0, r.isArray)(l) &&
								Boolean(
								  l.some(function (e) {
									return d.has(e);
								  }),
								)
							  )
							) {
							  o = !0;
							  var p = (0, c.makeInstance)(e, s);
							  if (!p) return f.add(a), void delete h[a];
							  (0, u.initInstance)(e, a, p, f, h), (m[a] = p);
							}
						  }
						}),
						  o && e.e.fire("updatePlugins");
					  }
					};
					(a && a.length) || (0, s.loadExtras)(this.__items, e, a, v),
					  v(),
					  (function (e, t) {
						e.e.on("beforeDestruct", function () {
						  Object.keys(t).forEach(function (o) {
							var n = t[o];
							(0, r.isDestructable)(n) && n.destruct(e),
							  delete t[o];
						  }),
							delete e.__plugins;
						});
					  })(e, m);
				  }),
				  (e.prototype.wait = function (e) {
					var t = this;
					return new Promise(function (o) {
					  if (t.get(e)) return o();
					  var n = function () {
						o(), a.eventEmitter.off("plugin:".concat(e, ":ready"), n);
					  };
					  a.eventEmitter.on("plugin:".concat(e, ":ready"), n);
					});
				  }),
				  e
				);
			  })();
			t.PluginSystem = d;
		  },
		  85605: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Plugin = void 0);
			var n = o(20255),
			  r = o(56562),
			  i = o(43441),
			  a = o(40332),
			  s = (function (e) {
				function t(t) {
				  var o = e.call(this, t) || this;
				  return (
					(o.requires = []),
					(o.buttons = []),
					(o.hasStyle = !1),
					t.e
					  .on("afterPluginSystemInit", function () {
						var e;
						(0, a.isJoditObject)(t) &&
						  (null === (e = o.buttons) ||
							void 0 === e ||
							e.forEach(function (e) {
							  t.registerButton(e);
							}));
					  })
					  .on("afterInit", function () {
						o.setStatus(r.STATUSES.ready), o.afterInit(t);
					  })
					  .on("beforeDestruct", o.destruct),
					o
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "";
				  }),
				  (t.prototype.init = function (e) {}),
				  (t.prototype.destruct = function () {
					var t, o, n;
					if (this.isReady) {
					  this.setStatus(r.STATUSES.beforeDestruct);
					  var i = this.j;
					  (0, a.isJoditObject)(i) &&
						(null === (t = this.buttons) ||
						  void 0 === t ||
						  t.forEach(function (e) {
							null == i || i.unregisterButton(e);
						  })),
						null ===
						  (n =
							null === (o = this.j) || void 0 === o
							  ? void 0
							  : o.events) ||
						  void 0 === n ||
						  n.off("beforeDestruct", this.destruct),
						this.beforeDestruct(this.j),
						e.prototype.destruct.call(this);
					}
				  }),
				  n.__decorate([i.autobind], t.prototype, "destruct", null),
				  t
				);
			  })(r.ViewComponent);
			t.Plugin = s;
		  },
		  9917: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Ajax = void 0);
			var n = o(20255),
			  r = o(93166),
			  i = o(40332),
			  a = o(56964),
			  s = o(86101),
			  l = o(22630),
			  c = o(43441);
			o(12144);
			var u = (function () {
			  function e(e, t) {
				void 0 === t && (t = r.Config.prototype.defaultAjaxOptions),
				  (this.__async = new l.Async()),
				  (this.__isFulfilled = !1),
				  (this.__activated = !1),
				  (this.__isDestructed = !1),
				  (this.options = (0, i.ConfigProto)(e || {}, t)),
				  (this.xhr = this.o.xhr ? this.o.xhr() : new XMLHttpRequest());
			  }
			  return (
				(e.prototype.__buildParams = function (e, t) {
				  return (0, i.isPlainObject)(e) &&
					this.options.contentType &&
					this.options.contentType.includes("application/json")
					? JSON.stringify(e)
					: (0, i.isFunction)(this.o.queryBuild)
					  ? this.o.queryBuild.call(this, e, t)
					  : (0, i.isString)(e) ||
						  e instanceof window.FormData ||
						  ("object" == typeof e &&
							null != e &&
							(0, i.isFunction)(e.append))
						? e
						: (0, i.buildQuery)(e);
				}),
				Object.defineProperty(e.prototype, "o", {
				  get: function () {
					return this.options;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.abort = function () {
				  if (this.__isFulfilled) return this;
				  try {
					(this.__isFulfilled = !0), this.xhr.abort();
				  } catch (e) {}
				  return this;
				}),
				(e.prototype.send = function () {
				  var e = this;
				  this.__activated = !0;
				  var t = this.xhr,
					o = this.o,
					r = this.prepareRequest();
				  return this.__async.promise(function (l, c) {
					return n.__awaiter(e, void 0, void 0, function () {
					  var e,
						u,
						d,
						p,
						f,
						h = this;
					  return n.__generator(this, function (n) {
						switch (n.label) {
						  case 0:
							return (
							  (e = function () {
								(h.__isFulfilled = !0),
								  c(a.connection("Connection error"));
							  }),
							  (t.onload = u =
								function () {
								  (h.__isFulfilled = !0),
									l(
									  new s.Response(
										r,
										t.status,
										t.statusText,
										t.responseType
										  ? t.response
										  : t.responseText,
									  ),
									);
								}),
							  (t.onabort = function () {
								(h.__isFulfilled = !0),
								  c(a.abort("Abort connection"));
							  }),
							  (t.onerror = e),
							  (t.ontimeout = e),
							  o.responseType && (t.responseType = o.responseType),
							  (t.onprogress = function (e) {
								var t,
								  o,
								  n = 0;
								e.lengthComputable &&
								  (n = (e.loaded / e.total) * 100),
								  null === (o = (t = h.options).onProgress) ||
									void 0 === o ||
									o.call(t, n);
							  }),
							  (t.onreadystatechange = function () {
								var e, n;
								null === (n = (e = h.options).onProgress) ||
								  void 0 === n ||
								  n.call(e, 10),
								  t.readyState === XMLHttpRequest.DONE &&
									(o.successStatuses.includes(t.status)
									  ? u()
									  : t.statusText &&
										((h.__isFulfilled = !0),
										c(a.connection(t.statusText))));
							  }),
							  (t.withCredentials =
								null !== (f = o.withCredentials) &&
								void 0 !== f &&
								f),
							  (d = r.data),
							  t.open(r.method, r.url, !0),
							  o.contentType &&
								t.setRequestHeader &&
								t.setRequestHeader("Content-type", o.contentType),
							  (0, i.isFunction)((p = o.headers))
								? [4, p.call(this)]
								: [3, 2]
							);
						  case 1:
							(p = n.sent()), (n.label = 2);
						  case 2:
							return (
							  p &&
								t.setRequestHeader &&
								Object.keys(p).forEach(function (e) {
								  t.setRequestHeader(e, p[e]);
								}),
							  this.__async.setTimeout(function () {
								t.send(d ? h.__buildParams(d) : void 0);
							  }, 0),
							  [2]
							);
						}
					  });
					});
				  });
				}),
				(e.prototype.prepareRequest = function () {
				  if (!this.o.url) throw a.error("Need URL for AJAX request");
				  var t = this.o.url,
					o = this.o.data,
					r = (this.o.method || "get").toLowerCase();
				  if ("get" === r && o && (0, i.isPlainObject)(o)) {
					var s = t.indexOf("?");
					if (-1 !== s) {
					  var l = (0, i.parseQuery)(t);
					  t =
						t.substring(0, s) +
						"?" +
						(0, i.buildQuery)(n.__assign(n.__assign({}, l), o));
					} else t += "?" + (0, i.buildQuery)(this.o.data);
				  }
				  var c = { url: t, method: r, data: o };
				  return e.log.splice(100), e.log.push(c), c;
				}),
				(e.prototype.destruct = function () {
				  this.__isDestructed ||
					((this.__isDestructed = !0),
					this.__activated &&
					  !this.__isFulfilled &&
					  (this.abort(), (this.__isFulfilled = !0)),
					this.__async.destruct());
				}),
				(e.log = []),
				n.__decorate([c.autobind], e.prototype, "destruct", null),
				e
			  );
			})();
			t.Ajax = u;
		  },
		  12144: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.defaultAjaxOptions = {
				successStatuses: [200, 201, 202],
				method: "GET",
				url: "",
				data: null,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",
				headers: { "X-REQUESTED-WITH": "XMLHttpRequest" },
				withCredentials: !1,
				xhr: function () {
				  return new XMLHttpRequest();
				},
			  });
		  },
		  30056: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(9917), t), n.__exportStar(o(86101), t);
		  },
		  86101: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Response = void 0);
			var n = o(20255),
			  r = (function () {
				function e(e, t, o, n) {
				  (this.request = e),
					(this.status = t),
					(this.statusText = o),
					(this.body = n);
				}
				return (
				  Object.defineProperty(e.prototype, "url", {
					get: function () {
					  return this.request.url;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (e.prototype.json = function () {
					return n.__awaiter(this, void 0, Promise, function () {
					  return n.__generator(this, function (e) {
						return [2, JSON.parse(this.body)];
					  });
					});
				  }),
				  (e.prototype.text = function () {
					return Promise.resolve(this.body);
				  }),
				  (e.prototype.blob = function () {
					return n.__awaiter(this, void 0, Promise, function () {
					  return n.__generator(this, function (e) {
						return [2, this.body];
					  });
					});
				  }),
				  e
				);
			  })();
			t.Response = r;
		  },
		  10109: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(287), t), n.__exportStar(o(10264), t);
		  },
		  287: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.moveNodeInsideStart = void 0);
			var n = o(64968),
			  r = o(86893);
			t.moveNodeInsideStart = function (e, t, o) {
			  for (
				var i = n.Dom.findSibling(t, o), a = n.Dom.findSibling(t, !o);
				n.Dom.isElement(i) &&
				!n.Dom.isTag(i, r.INSEPARABLE_TAGS) &&
				n.Dom.isContentEditable(i, e.editor) &&
				(!a || !n.Dom.closest(t, n.Dom.isElement, e.editor));
  
			  )
				o || !i.firstChild
				  ? i.appendChild(t)
				  : n.Dom.before(i.firstChild, t),
				  (i = n.Dom.sibling(t, o)),
				  (a = n.Dom.sibling(t, !o));
			};
		  },
		  10264: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.moveTheNodeAlongTheEdgeOutward = void 0);
			var n = o(64968);
			t.moveTheNodeAlongTheEdgeOutward = function (e, t, o) {
			  for (var r = e; r && r !== o; ) {
				if (n.Dom.findSibling(r, t)) return;
				(r = r.parentElement) &&
				  r !== o &&
				  (t ? n.Dom.before(r, e) : n.Dom.after(r, e));
			  }
			};
		  },
		  2123: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(70851), t), n.__exportStar(o(77627), t);
		  },
		  2047: function () {},
		  77627: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Select = void 0);
			var n = o(20255),
			  r = o(86893),
			  i = o(86893),
			  a = o(64968),
			  s = o(40332),
			  l = o(70851),
			  c = o(43441),
			  u = o(10109),
			  d = (o(52378), o(10172));
			o(2047);
			var p = (function () {
			  function e(e) {
				var t = this;
				(this.jodit = e),
				  e.e.on("removeMarkers", function () {
					t.removeMarkers();
				  });
			  }
			  return (
				Object.defineProperty(e.prototype, "j", {
				  get: function () {
					return this.jodit;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.errorNode = function (e) {
				  if (!a.Dom.isNode(e))
					throw (0, s.error)("Parameter node must be instance of Node");
				}),
				Object.defineProperty(e.prototype, "area", {
				  get: function () {
					return this.j.editor;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "win", {
				  get: function () {
					return this.j.ew;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "doc", {
				  get: function () {
					return this.j.ed;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "sel", {
				  get: function () {
					return this.j.o.shadowRoot &&
					  (0, d.isFunction)(this.j.o.shadowRoot.getSelection)
					  ? this.j.o.shadowRoot.getSelection()
					  : this.win.getSelection();
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "range", {
				  get: function () {
					var e = this.sel;
					return e && e.rangeCount
					  ? e.getRangeAt(0)
					  : this.createRange();
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "isInsideArea", {
				  get: function () {
					var e = this.sel,
					  t = (null == e ? void 0 : e.rangeCount)
						? e.getRangeAt(0)
						: null;
					return !(
					  !t || !a.Dom.isOrContains(this.area, t.startContainer)
					);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.createRange = function (e) {
				  void 0 === e && (e = !1);
				  var t = this.doc.createRange();
				  return e && this.selectRange(t), t;
				}),
				(e.prototype.remove = function () {
				  var e = this.sel,
					t = this.current();
				  if (e && t)
					for (var o = 0; e.rangeCount > o; o += 1)
					  e.getRangeAt(o).deleteContents(),
						e.getRangeAt(o).collapse(!0);
				}),
				(e.prototype.clear = function () {
				  var e, t;
				  (null === (e = this.sel) || void 0 === e
					? void 0
					: e.rangeCount) &&
					(null === (t = this.sel) ||
					  void 0 === t ||
					  t.removeAllRanges());
				}),
				(e.prototype.removeNode = function (e) {
				  if (!a.Dom.isOrContains(this.j.editor, e, !0))
					throw (0, s.error)(
					  "Selection.removeNode can remove only editor's children",
					);
				  a.Dom.safeRemove(e), this.j.e.fire("afterRemoveNode", e);
				}),
				(e.prototype.insertCursorAtPoint = function (e, t) {
				  var o = this;
				  this.removeMarkers();
				  try {
					var n = this.createRange();
					return (
					  (function () {
						if (
						  o.doc.caretPositionFromPoint &&
						  (r = o.doc.caretPositionFromPoint(e, t))
						)
						  n.setStart(r.offsetNode, r.offset);
						else if (o.doc.caretRangeFromPoint) {
						  var r = o.doc.caretRangeFromPoint(e, t);
						  n.setStart(r.startContainer, r.startOffset);
						}
					  })(),
					  n.collapse(!0),
					  this.selectRange(n),
					  !0
					);
				  } catch (e) {}
				  return !1;
				}),
				Object.defineProperty(e.prototype, "hasMarkers", {
				  get: function () {
					return Boolean(this.markers.length);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "markers", {
				  get: function () {
					return (0, s.$$)(
					  "span[data-" + r.MARKER_CLASS + "]",
					  this.area,
					);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.removeMarkers = function () {
				  a.Dom.safeRemove.apply(null, this.markers);
				}),
				(e.prototype.marker = function (e, t) {
				  void 0 === e && (e = !1);
				  var o = null;
				  t && (o = t.cloneRange()).collapse(e);
				  var n = this.j.createInside.span();
				  return (
					(n.id =
					  r.MARKER_CLASS +
					  "_" +
					  Number(new Date()) +
					  "_" +
					  String(Math.random()).slice(2)),
					(n.style.lineHeight = "0"),
					(n.style.display = "none"),
					a.Dom.markTemporary(n),
					(0, s.attr)(n, "data-" + r.MARKER_CLASS, e ? "start" : "end"),
					n.appendChild(this.j.createInside.text(r.INVISIBLE_SPACE)),
					o &&
					  a.Dom.isOrContains(
						this.area,
						e ? o.startContainer : o.endContainer,
					  ) &&
					  o.insertNode(n),
					n
				  );
				}),
				(e.prototype.restore = function () {
				  var e = !1,
					t = function (e) {
					  return "span[data-"
						.concat(r.MARKER_CLASS, "=")
						.concat(e ? "start" : "end", "]");
					},
					o = this.area.querySelector(t(!0)),
					n = this.area.querySelector(t(!1));
				  if (o) {
					if (((e = this.createRange()), n))
					  e.setStartAfter(o),
						a.Dom.safeRemove(o),
						e.setEndBefore(n),
						a.Dom.safeRemove(n);
					else {
					  var i = o.previousSibling;
					  a.Dom.isText(i)
						? e.setStart(i, i.nodeValue ? i.nodeValue.length : 0)
						: e.setStartBefore(o),
						a.Dom.safeRemove(o),
						e.collapse(!0);
					}
					e && this.selectRange(e);
				  }
				}),
				(e.prototype.save = function (e) {
				  if ((void 0 === e && (e = !1), this.hasMarkers)) return [];
				  var t = this.sel;
				  if (!t || !t.rangeCount) return [];
				  for (var o = [], n = t.rangeCount, r = [], i = 0; n > i; i += 1)
					if (((r[i] = t.getRangeAt(i)), r[i].collapsed)) {
					  var a = this.marker(!0, r[i]);
					  o[i] = {
						startId: a.id,
						collapsed: !0,
						startMarker: a.outerHTML,
					  };
					} else {
					  a = this.marker(!0, r[i]);
					  var s = this.marker(!1, r[i]);
					  o[i] = {
						startId: a.id,
						endId: s.id,
						collapsed: !1,
						startMarker: a.outerHTML,
						endMarker: s.outerHTML,
					  };
					}
				  if (!e)
					for (t.removeAllRanges(), i = n - 1; i >= 0; --i) {
					  var l = this.doc.getElementById(o[i].startId);
					  if (l)
						if (o[i].collapsed)
						  r[i].setStartAfter(l), r[i].collapse(!0);
						else if ((r[i].setStartBefore(l), o[i].endId)) {
						  var c = this.doc.getElementById(o[i].endId);
						  c && r[i].setEndAfter(c);
						}
					  try {
						t.addRange(r[i].cloneRange());
					  } catch (e) {}
					}
				  return o;
				}),
				(e.prototype.focus = function (e) {
				  var t, o;
				  if (
					(void 0 === e && (e = { preventScroll: !0 }),
					!this.isFocused())
				  ) {
					var n = (0, s.getScrollParent)(this.j.container),
					  r = null == n ? void 0 : n.scrollTop;
					this.j.iframe &&
					  "complete" === this.doc.readyState &&
					  this.j.iframe.focus(e),
					  this.win.focus(),
					  this.area.focus(e),
					  r && (null == n ? void 0 : n.scrollTo) && n.scrollTo(0, r);
					var i = this.sel,
					  l = (null == i ? void 0 : i.rangeCount)
						? null == i
						  ? void 0
						  : i.getRangeAt(0)
						: null;
					if (!l || !a.Dom.isOrContains(this.area, l.startContainer)) {
					  var c = this.createRange();
					  c.setStart(this.area, 0),
						c.collapse(!0),
						this.selectRange(c, !1);
					}
					return (
					  this.j.editorIsActive ||
						null ===
						  (o =
							null === (t = this.j) || void 0 === t
							  ? void 0
							  : t.events) ||
						void 0 === o ||
						o.fire("focus"),
					  !0
					);
				  }
				  return !1;
				}),
				(e.prototype.isCollapsed = function () {
				  for (var e = this.sel, t = 0; e && e.rangeCount > t; t += 1)
					if (!e.getRangeAt(t).collapsed) return !1;
				  return !0;
				}),
				(e.prototype.isFocused = function () {
				  return (
					this.doc.hasFocus &&
					this.doc.hasFocus() &&
					this.area === this.doc.activeElement
				  );
				}),
				(e.prototype.current = function (e) {
				  if (
					(void 0 === e && (e = !0),
					this.j.getRealMode() === r.MODE_WYSIWYG)
				  ) {
					var t = this.sel;
					if (!t || 0 === t.rangeCount) return null;
					var o = t.getRangeAt(0),
					  n = o.startContainer,
					  i = !1,
					  s = function (e) {
						return i ? e.lastChild : e.firstChild;
					  };
					if (a.Dom.isTag(n, "br") && t.isCollapsed) return n;
					if (!a.Dom.isText(n)) {
					  if (
						((n = o.startContainer.childNodes[o.startOffset]) ||
						  ((n = o.startContainer.childNodes[o.startOffset - 1]),
						  (i = !0)),
						n && t.isCollapsed && !a.Dom.isText(n))
					  )
						if (!i && a.Dom.isText(n.previousSibling))
						  n = n.previousSibling;
						else if (e)
						  for (var l = s(n); l; ) {
							if (l && a.Dom.isText(l)) {
							  n = l;
							  break;
							}
							l = s(l);
						  }
					  if (n && !t.isCollapsed && !a.Dom.isText(n)) {
						var c = n,
						  u = n;
						do {
						  (c = c.firstChild), (u = u.lastChild);
						} while (c && u && !a.Dom.isText(c));
						c === u && c && a.Dom.isText(c) && (n = c);
					  }
					}
					if (n && a.Dom.isOrContains(this.area, n)) return n;
				  }
				  return null;
				}),
				(e.prototype.insertNode = function (e, t, o) {
				  var n = this;
				  void 0 === t && (t = !0),
					void 0 === o && (o = !0),
					this.errorNode(e),
					this.j.e.fire("safeHTML", e),
					!this.isFocused() &&
					  this.j.isEditorMode() &&
					  (this.focus(), this.restore());
				  var r = this.sel;
				  this.j.history.snapshot.transaction(function () {
					var o;
					if (
					  (n.isCollapsed() || n.j.execCommand("Delete"),
					  n.j.e.fire("beforeInsertNode", e),
					  r && r.rangeCount)
					) {
					  var s = r.getRangeAt(0);
					  a.Dom.isOrContains(n.area, s.commonAncestorContainer)
						? a.Dom.isTag(s.startContainer, i.INSEPARABLE_TAGS) &&
						  s.collapsed
						  ? null === (o = s.startContainer.parentNode) ||
							void 0 === o ||
							o.insertBefore(e, s.startContainer)
						  : a.Dom.safeInsertNode(s, e)
						: n.area.appendChild(e);
					} else n.area.appendChild(e);
					t &&
					  (e.nodeType === Node.DOCUMENT_FRAGMENT_NODE
						? e.lastChild && n.setCursorAfter(e.lastChild)
						: n.setCursorAfter(e));
				  }),
					o && this.j.events && this.j.__imdSynchronizeValues(),
					this.j.events && this.j.e.fire("afterInsertNode", e);
				}),
				(e.prototype.insertHTML = function (e, t) {
				  if ((void 0 === t && (t = !0), "" !== e)) {
					var o,
					  n = this.j.createInside.div(),
					  r = this.j.createInside.fragment();
					if (
					  (!this.isFocused() &&
						this.j.isEditorMode() &&
						(this.focus(), this.restore()),
					  a.Dom.isNode(e)
						? n.appendChild(e)
						: (n.innerHTML = e.toString()),
					  (this.j.isEditorMode() ||
						!1 !== this.j.e.fire("insertHTML", n.innerHTML)) &&
						(o = n.lastChild))
					) {
					  for (; n.firstChild; )
						(o = n.firstChild), r.appendChild(n.firstChild);
					  this.insertNode(
						r.firstChild && r.firstChild === r.lastChild
						  ? r.lastChild
						  : r,
						!1,
						!1,
					  ),
						t && (o ? this.setCursorAfter(o) : this.setCursorIn(r)),
						this.j.__imdSynchronizeValues();
					}
				  }
				}),
				(e.prototype.insertImage = function (e, t, o) {
				  void 0 === t && (t = null), void 0 === o && (o = null);
				  var n = (0, d.isString)(e)
					? this.j.createInside.element("img")
					: e;
				  if (
					((0, d.isString)(e) && n.setAttribute("src", e), null != o)
				  ) {
					var r = o.toString();
					r &&
					  "auto" !== r &&
					  0 > String(r).indexOf("px") &&
					  0 > String(r).indexOf("%") &&
					  (r += "px"),
					  (0, s.call)(
						this.j.o.resizer.forImageChangeAttributes
						  ? s.attr
						  : s.css,
						n,
						"width",
						r,
					  );
				  }
				  t && "object" == typeof t && (0, s.css)(n, t);
				  var i = function () {
					(n.offsetHeight > n.naturalHeight ||
					  n.offsetWidth > n.naturalWidth) &&
					  ((n.style.width = ""), (n.style.height = "")),
					  n.removeEventListener("load", i);
				  };
				  this.j.e.on(n, "load", i),
					n.complete && i(),
					this.insertNode(n),
					this.j.e.fire("afterInsertImage", n);
				}),
				(e.prototype.eachSelection = function (e) {
				  var t,
					o = this,
					n = this.sel;
				  if (n && n.rangeCount) {
					var r = n.getRangeAt(0),
					  l = r.commonAncestorContainer;
					a.Dom.isHTMLElement(l) || (l = l.parentElement);
					var c = [],
					  u = r.startOffset,
					  p = l.childNodes.length,
					  f =
						r.startContainer === this.area
						  ? l.childNodes[p > u ? u : p - 1]
						  : r.startContainer,
					  h =
						r.endContainer === this.area
						  ? l.childNodes[r.endOffset - 1]
						  : r.endContainer;
					a.Dom.isText(f) &&
					  f === r.startContainer &&
					  r.startOffset ===
						(null === (t = f.nodeValue) || void 0 === t
						  ? void 0
						  : t.length) &&
					  f.nextSibling &&
					  (f = f.nextSibling),
					  a.Dom.isText(h) &&
						h === r.endContainer &&
						0 === r.endOffset &&
						h.previousSibling &&
						(h = h.previousSibling);
					var m = function (e) {
					  !e ||
						e === l ||
						a.Dom.isEmptyTextNode(e) ||
						(0, d.isMarker)(e) ||
						c.push(e);
					};
					m(f),
					  f !== h &&
						a.Dom.isOrContains(l, f, !0) &&
						a.Dom.find(
						  f,
						  function (e) {
							return (
							  m(e), e === h || (e && e.contains && e.contains(h))
							);
						  },
						  l,
						  !0,
						  !1,
						);
					var v = function (t) {
					  if (a.Dom.isOrContains(o.j.editor, t, !0)) {
						if (t.nodeName.match(/^(UL|OL)$/))
						  return (0, s.toArray)(t.childNodes).forEach(v);
						if (a.Dom.isTag(t, "li"))
						  if (t.firstChild) t = t.firstChild;
						  else {
							var n = o.j.createInside.text(i.INVISIBLE_SPACE);
							t.appendChild(n), (t = n);
						  }
						e(t);
					  }
					};
					0 === c.length && a.Dom.isEmptyTextNode(f) && c.push(f),
					  0 === c.length && f.firstChild && c.push(f.firstChild),
					  c.forEach(v);
				  }
				}),
				(e.prototype.cursorInTheEdge = function (e, t, o) {
				  var n,
					r,
					l = this;
				  void 0 === o && (o = null);
				  var c = !e,
					u =
					  null === (n = this.sel) || void 0 === n
						? void 0
						: n.getRangeAt(0);
				  if (
					(null != o || (o = this.current(!1)),
					!u || !o || !a.Dom.isOrContains(t, o, !0))
				  )
					return null;
				  var d = e ? u.startContainer : u.endContainer,
					p = e ? u.startOffset : u.endOffset,
					f = function (e) {
					  return Boolean(
						e &&
						  !a.Dom.isTag(e, "br") &&
						  !a.Dom.isEmptyTextNode(e) &&
						  !a.Dom.isTemporary(e) &&
						  !(
							a.Dom.isElement(e) &&
							!0 === l.j.e.fire("isInvisibleForCursor", e)
						  ),
					  );
					};
				  if (a.Dom.isText(d)) {
					var h = (
					  null === (r = d.nodeValue) || void 0 === r
						? void 0
						: r.length
					)
					  ? d.nodeValue
					  : "";
					if (
					  c &&
					  h.replace((0, i.INVISIBLE_SPACE_REG_EXP_END)(), "").length >
						p
					)
					  return !1;
					var m = (0, i.INVISIBLE_SPACE_REG_EXP_START)().exec(h);
					if (e && ((m && p > m[0].length) || (!m && p > 0))) return !1;
				  } else {
					var v = (0, s.toArray)(d.childNodes);
					if (c) {
					  if (v.slice(p).some(f)) return !1;
					} else if (v.slice(0, p).some(f)) return !1;
				  }
				  for (var g = o; g && g !== t; ) {
					var y = a.Dom.sibling(g, e);
					if (y) {
					  if ((g = y) && f(g)) return !1;
					} else g = g.parentNode;
				  }
				  return !0;
				}),
				(e.prototype.cursorOnTheLeft = function (e, t) {
				  return this.cursorInTheEdge(!0, e, t);
				}),
				(e.prototype.cursorOnTheRight = function (e, t) {
				  return this.cursorInTheEdge(!1, e, t);
				}),
				(e.prototype.setCursorAfter = function (e) {
				  return this.setCursorNearWith(e, !1);
				}),
				(e.prototype.setCursorBefore = function (e) {
				  return this.setCursorNearWith(e, !0);
				}),
				(e.prototype.setCursorNearWith = function (e, t) {
				  var o,
					n,
					i = this;
				  if (
					(this.errorNode(e),
					!a.Dom.up(
					  e,
					  function (e) {
						return e === i.area || (e && e.parentNode === i.area);
					  },
					  this.area,
					))
				  )
					throw (0, s.error)("Node element must be in editor");
				  var l = this.createRange(),
					c = null;
				  return (
					a.Dom.isText(e)
					  ? t
						? l.setStart(e, 0)
						: l.setEnd(
							e,
							null !==
							  (n =
								null === (o = e.nodeValue) || void 0 === o
								  ? void 0
								  : o.length) && void 0 !== n
							  ? n
							  : 0,
						  )
					  : ((c = this.j.createInside.text(r.INVISIBLE_SPACE)),
						t ? l.setStartBefore(e) : l.setEndAfter(e),
						l.collapse(t),
						a.Dom.safeInsertNode(l, c),
						l.selectNode(c)),
					l.collapse(t),
					this.selectRange(l),
					c
				  );
				}),
				(e.prototype.setCursorIn = function (e, t) {
				  var o = this;
				  if (
					(void 0 === t && (t = !1),
					this.errorNode(e),
					!a.Dom.up(
					  e,
					  function (e) {
						return e === o.area || (e && e.parentNode === o.area);
					  },
					  this.area,
					))
				  )
					throw (0, s.error)("Node element must be in editor");
				  var n = this.createRange(),
					i = e,
					l = e;
				  do {
					if (a.Dom.isText(i)) break;
					(l = i), (i = t ? i.firstChild : i.lastChild);
				  } while (i);
				  if (!i) {
					var c = this.j.createInside.text(r.INVISIBLE_SPACE);
					/^(img|br|input)$/i.test(l.nodeName)
					  ? (i = l)
					  : (l.appendChild(c), (l = c));
				  }
				  return (
					n.selectNodeContents(i || l),
					n.collapse(t),
					this.selectRange(n),
					l
				  );
				}),
				(e.prototype.selectRange = function (e, t) {
				  void 0 === t && (t = !0);
				  var o = this.sel;
				  return (
					t && !this.isFocused() && this.focus(),
					o && (o.removeAllRanges(), o.addRange(e)),
					this.j.e.fire("changeSelection"),
					this
				  );
				}),
				(e.prototype.select = function (e, t) {
				  var o = this;
				  if (
					(void 0 === t && (t = !1),
					this.errorNode(e),
					!a.Dom.up(
					  e,
					  function (e) {
						return e === o.area || (e && e.parentNode === o.area);
					  },
					  this.area,
					))
				  )
					throw (0, s.error)("Node element must be in editor");
				  var n = this.createRange();
				  return (
					n[t ? "selectNodeContents" : "selectNode"](e),
					this.selectRange(n)
				  );
				}),
				Object.defineProperty(e.prototype, "html", {
				  get: function () {
					var e = this.sel;
					if (e && e.rangeCount > 0) {
					  var t = e.getRangeAt(0).cloneContents(),
						o = this.j.createInside.div();
					  return o.appendChild(t), o.innerHTML;
					}
					return "";
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.wrapInTagGen = function () {
				  var e, t, o, r, l, c, u, p, f, h, m;
				  return n.__generator(this, function (v) {
					switch (v.label) {
					  case 0:
						return this.isCollapsed()
						  ? ((c = this.jodit.createInside.element(
							  "font",
							  i.INVISIBLE_SPACE,
							)),
							this.insertNode(c, !1, !1),
							(e = n.__read(this.markers, 1)),
							(t = e[0])
							  ? c.appendChild(t)
							  : (this.setCursorIn(c), this.save()),
							[4, c])
						  : [3, 2];
					  case 1:
						return v.sent(), a.Dom.unwrap(c), [2];
					  case 2:
						(0, s.$$)("*[style*=font-size]", this.area).forEach(
						  function (e) {
							(0, s.attr)(
							  e,
							  "data-font-size",
							  e.style.fontSize.toString(),
							),
							  e.style.removeProperty("font-size");
						  },
						),
						  this.isCollapsed()
							? ((c = this.j.createInside.element("font")),
							  (0, s.attr)(c, "size", 7),
							  this.insertNode(c, !1, !1))
							: this.j.nativeExecCommand("fontsize", !1, "7"),
						  (0, s.$$)("*[data-font-size]", this.area).forEach(
							function (e) {
							  var t = (0, s.attr)(e, "data-font-size");
							  t &&
								((e.style.fontSize = t),
								(0, s.attr)(e, "data-font-size", null));
							},
						  ),
						  (o = (0, s.$$)('font[size="7"]', this.area)),
						  (v.label = 3);
					  case 3:
						v.trys.push([3, 8, 9, 10]),
						  (r = n.__values(o)),
						  (l = r.next()),
						  (v.label = 4);
					  case 4:
						return l.done
						  ? [3, 7]
						  : ((p = (c = l.value).lastChild),
							(u = c.firstChild) && u === p && (0, d.isMarker)(u)
							  ? (a.Dom.unwrap(c), [3, 6])
							  : (u && (0, d.isMarker)(u) && a.Dom.before(c, u),
								p && (0, d.isMarker)(p) && a.Dom.after(c, p),
								[4, c]));
					  case 5:
						v.sent(), a.Dom.unwrap(c), (v.label = 6);
					  case 6:
						return (l = r.next()), [3, 4];
					  case 7:
						return [3, 10];
					  case 8:
						return (f = v.sent()), (h = { error: f }), [3, 10];
					  case 9:
						try {
						  l && !l.done && (m = r.return) && m.call(r);
						} finally {
						  if (h) throw h.error;
						}
						return [7];
					  case 10:
						return [2];
					}
				  });
				}),
				(e.prototype.wrapInTag = function (e) {
				  var t,
					o,
					r = [];
				  try {
					for (
					  var i = n.__values(this.wrapInTagGen()), s = i.next();
					  !s.done;
					  s = i.next()
					) {
					  var l = s.value;
					  try {
						if (
						  l.firstChild &&
						  l.firstChild === l.lastChild &&
						  (0, d.isMarker)(l.firstChild)
						)
						  continue;
						(0, d.isFunction)(e)
						  ? e(l)
						  : r.push(a.Dom.replace(l, e, this.j.createInside));
					  } finally {
						var c = l.parentNode;
						c &&
						  (a.Dom.unwrap(l), a.Dom.isEmpty(c) && a.Dom.unwrap(c));
					  }
					}
				  } catch (e) {
					t = { error: e };
				  } finally {
					try {
					  s && !s.done && (o = i.return) && o.call(i);
					} finally {
					  if (t) throw t.error;
					}
				  }
				  return r;
				}),
				(e.prototype.commitStyle = function (e) {
				  new l.CommitStyle(e).apply(this.j);
				}),
				(e.prototype.applyStyle = function (e, t) {
				  void 0 === t && (t = {}),
					this.commitStyle(n.__assign({ style: e }, t));
				}),
				(e.prototype.splitSelection = function (e, t) {
				  if (!this.isCollapsed()) return null;
				  var o = this.createRange(),
					n = this.range;
				  o.setStartBefore(e);
				  var r = this.cursorOnTheRight(e, t),
					i = this.cursorOnTheLeft(e, t),
					s = this.j.createInside.element("br"),
					l = this.j.createInside.fake(),
					c = l.cloneNode();
				  try {
					if (r || i) {
					  t ? a.Dom.before(t, s) : a.Dom.safeInsertNode(n, s);
					  var u = function (e, t) {
						for (var o = t(e); o; ) {
						  var n = t(o);
						  if (
							!o ||
							(!a.Dom.isTag(o, "br") && !a.Dom.isEmptyTextNode(o))
						  )
							break;
						  a.Dom.safeRemove(o), (o = n);
						}
					  };
					  u(s, function (e) {
						return e.nextSibling;
					  }),
						u(s, function (e) {
						  return e.previousSibling;
						}),
						a.Dom.after(s, c),
						a.Dom.before(s, l),
						r
						  ? (o.setEndBefore(s), n.setEndBefore(s))
						  : (o.setEndAfter(s), n.setEndAfter(s));
					} else o.setEnd(n.startContainer, n.startOffset);
					var d = o.extractContents(),
					  p = function (e) {
						return a.Dom.each(e, function (e) {
						  return a.Dom.isEmptyTextNode(e) && a.Dom.safeRemove(e);
						});
					  };
					try {
					  if (
						(p(d),
						p(e),
						e.parentNode.insertBefore(d, e),
						!t && r && (null == s ? void 0 : s.parentNode))
					  ) {
						var f = this.createRange();
						f.setStartBefore(s), this.selectRange(f);
					  }
					} catch (e) {}
					var h = function (e) {
					  var t, o, n;
					  (null === (t = null == e ? void 0 : e.parentNode) ||
					  void 0 === t
						? void 0
						: t.firstChild) ===
						(null === (o = null == e ? void 0 : e.parentNode) ||
						void 0 === o
						  ? void 0
						  : o.lastChild) &&
						(null === (n = null == e ? void 0 : e.parentNode) ||
						  void 0 === n ||
						  n.appendChild(s.cloneNode()));
					};
					h(l), h(c);
				  } finally {
					a.Dom.safeRemove(l), a.Dom.safeRemove(c);
				  }
				  return e.previousElementSibling;
				}),
				(e.prototype.expandSelection = function () {
				  var e = this;
				  if (this.isCollapsed()) return this;
				  var t = this.range,
					o = t.cloneRange();
				  if (
					!a.Dom.isOrContains(
					  this.j.editor,
					  t.commonAncestorContainer,
					  !0,
					)
				  )
					return this;
				  var n = function (o) {
					  var n = e.j.createInside.fake(),
						r = t.cloneRange();
					  return (
						r.collapse(o),
						a.Dom.safeInsertNode(r, n),
						(0, u.moveTheNodeAlongTheEdgeOutward)(n, o, e.j.editor),
						n
					  );
					},
					r = n(!0),
					i = n(!1);
				  o.setStartAfter(r), o.setEndBefore(i);
				  var s = a.Dom.findSibling(r, !1),
					l = a.Dom.findSibling(i, !0);
				  if (s !== l) {
					var c = a.Dom.isElement(s) && a.Dom.isOrContains(s, i),
					  d = !c && a.Dom.isElement(l) && a.Dom.isOrContains(l, r);
					if (c || d) {
					  for (var p = c ? s : l, f = p; a.Dom.isElement(p); )
						(p = c ? p.firstElementChild : p.lastElementChild) &&
						  a.Dom.isOrContains(p, c ? i : r) &&
						  (f = p);
					  c ? o.setStart(f, 0) : o.setEnd(f, f.childNodes.length);
					}
				  }
				  return this.selectRange(o), a.Dom.safeRemove(r, i), this;
				}),
				n.__decorate([c.autobind], e.prototype, "createRange", null),
				n.__decorate([c.autobind], e.prototype, "focus", null),
				n.__decorate([c.autobind], e.prototype, "setCursorAfter", null),
				n.__decorate([c.autobind], e.prototype, "setCursorBefore", null),
				n.__decorate([c.autobind], e.prototype, "setCursorIn", null),
				e
			  );
			})();
			t.Select = p;
		  },
		  77846: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.extractSelectedPart = void 0);
			var n = o(67309),
			  r = o(33941),
			  i = o(24263),
			  a = o(37204);
			function s(e, t, o) {
			  var a = t.extractContents();
			  (a.textContent && (0, r.trim)(a.textContent).length) ||
				!a.firstChild ||
				i.Dom.unwrap(a.firstChild),
				e.parentNode && (0, n.call)(o ? i.Dom.before : i.Dom.after, e, a);
			}
			t.extractSelectedPart = function (e, t, o) {
			  var n = o.s.createRange(),
				r = (0, a.isMarker)(t.previousSibling) ? t.previousSibling : t;
			  n.setStartBefore(e), n.setEndBefore(r), s(e, n, !0);
			  var i = (0, a.isMarker)(t.nextSibling) ? t.nextSibling : t;
			  n.setStartAfter(i), n.setEndAfter(e), s(e, n, !1);
			};
		  },
		  95901: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.FiniteStateMachine = void 0),
			  o(24421),
			  o(603);
			var n = (function () {
			  function e(e, t) {
				(this.transitions = t),
				  (this.silent = !0),
				  (this.__previewsStates = new Set()),
				  this.setState(e);
			  }
			  return (
				(e.prototype.setState = function (e) {
				  this.__previewsStates.add(e), (this.__state = e);
				}),
				(e.prototype.getState = function () {
				  return this.__state;
				}),
				(e.prototype.disableSilent = function () {
				  this.silent = !1;
				}),
				(e.prototype.dispatch = function (e, t) {
				  var o = this.transitions[this.getState()][e];
				  if (o) {
					var n = o.call(this, t);
					return this.setState(n.next), n;
				  }
				  throw new Error(
					"invalid action: "
					  .concat(this.getState(), ".")
					  .concat(e.toString()),
				  );
				}),
				e
			  );
			})();
			t.FiniteStateMachine = n;
		  },
		  65774: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getSuitChild = void 0);
			var n = o(24263),
			  r = o(63150),
			  i = o(74477);
			t.getSuitChild = function (e, t) {
			  for (var o = t.firstChild; o && !(0, r.isNormalNode)(o); )
				if (!(o = o.nextSibling)) return null;
			  return o &&
				!n.Dom.next(o, r.isNormalNode, t) &&
				(0, i.isSuitElement)(e, o, !1)
				? o
				: null;
			};
		  },
		  66277: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getSuitParent = void 0);
			var n = o(24263),
			  r = o(63150),
			  i = o(74477);
			t.getSuitParent = function e(t, o, a) {
			  var s = o.parentNode;
			  return s === a ||
				!n.Dom.isHTMLElement(s) ||
				n.Dom.next(o, r.isNormalNode, s) ||
				n.Dom.prev(o, r.isNormalNode, s)
				? null
				: t.isElementCommit && t.elementIsBlock && !n.Dom.isBlock(s)
				  ? e(t, s, a)
				  : !(0, i.isSuitElement)(t, s, !1) ||
					  (n.Dom.isBlock(s) && !t.elementIsBlock)
					? t.isElementCommit && !n.Dom.isBlock(s)
					  ? e(t, s, a)
					  : null
					: s;
			};
		  },
		  18387: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.hasSameStyleKeys = t.hasSameStyle = void 0);
			var n = o(26911),
			  r = o(24021),
			  i = o(49353),
			  a = o(24263);
			o(52378),
			  (t.hasSameStyle = function (e, t) {
				return Boolean(
				  !a.Dom.isTag(e, "font") &&
					a.Dom.isHTMLElement(e) &&
					Object.keys(t).every(function (o) {
					  var a = (0, n.css)(e, o, !0);
					  return (
						("" === a && ("" === t[o] || null == t[o])) ||
						(!(0, r.isVoid)(a) &&
						  "" !== a &&
						  !(0, r.isVoid)(t[o]) &&
						  (0, i.normalizeCssValue)(o, t[o])
							.toString()
							.toLowerCase() === a.toString().toLowerCase())
					  );
					}),
				);
			  }),
			  (document.createElement("div").style.color = "red"),
			  (t.hasSameStyleKeys = function (e, t) {
				return Boolean(
				  !a.Dom.isTag(e, "font") &&
					a.Dom.isHTMLElement(e) &&
					Object.keys(t).every(function (t) {
					  var o = (0, n.css)(e, t, !0);
					  return !(0, r.isVoid)(o);
					}),
				);
			  });
		  },
		  66162: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(93217), t),
			  n.__exportStar(o(11651), t),
			  n.__exportStar(o(29271), t),
			  n.__exportStar(o(18387), t),
			  n.__exportStar(o(77846), t),
			  n.__exportStar(o(95901), t),
			  n.__exportStar(o(65774), t),
			  n.__exportStar(o(66277), t),
			  n.__exportStar(o(76991), t),
			  n.__exportStar(o(47508), t),
			  n.__exportStar(o(63150), t),
			  n.__exportStar(o(74477), t),
			  n.__exportStar(o(26707), t),
			  n.__exportStar(o(8298), t),
			  n.__exportStar(o(6278), t);
		  },
		  76991: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isInsideInvisibleElement = void 0);
			var n = o(24263);
			t.isInsideInvisibleElement = function (e, t) {
			  return Boolean(n.Dom.closest(e, ["style", "script"], t));
			};
		  },
		  63150: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isNormalNode = void 0);
			var n = o(24263),
			  r = o(37204);
			t.isNormalNode = function (e) {
			  return Boolean(
				e &&
				  !n.Dom.isEmptyTextNode(e) &&
				  !n.Dom.isTemporary(e) &&
				  !(0, r.isMarker)(e),
			  );
			};
		  },
		  47508: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.elementsEqualAttributes = t.isSameAttributes = void 0);
			var n = o(76502),
			  r = o(16492),
			  i = (o(52378), o(18387));
			(t.isSameAttributes = function (e, t) {
			  return (
				(!e.attributes.length && !(0, r.size)(t)) ||
				!(0, r.size)(t) ||
				Object.keys(t).every(function (o) {
				  return "class" === o
					? e.classList.contains(t[o])
					: "style" === o
					  ? (0, i.hasSameStyle)(e, t[o])
					  : (0, n.attr)(e, o) === t[o];
				})
			  );
			}),
			  (t.elementsEqualAttributes = function (e, t) {
				return (
				  e.attributes.length === t.attributes.length &&
				  Array.from(e.attributes).every(function (e) {
					return (
					  t.hasAttribute(e.name) && t.getAttribute(e.name) === e.value
					);
				  })
				);
			  });
		  },
		  74477: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isSameStyleChild = t.findSuitClosest = t.isSuitElement = void 0);
			var n = o(24263),
			  r = o(63150),
			  i = o(18387);
			function a(e, t, o) {
			  var a;
			  if (!t) return !1;
			  var s = e.element,
				l = e.elementIsDefault,
				c = e.options,
				u = Boolean(
				  (null === (a = c.attributes) || void 0 === a
					? void 0
					: a.style) && (0, i.hasSameStyle)(t, c.attributes.style),
				),
				d =
				  t.nodeName.toLowerCase() === s ||
				  (n.Dom.isTag(t, ["ul", "ol"]) && e.elementIsList);
			  return (
				!(
				  ((l && o) || !d) &&
				  (!u || !(0, r.isNormalNode)(t) || e.elementIsList)
				) || Boolean(!d && !o && l && n.Dom.isInlineBlock(t))
			  );
			}
			(t.isSuitElement = a),
			  (t.findSuitClosest = function (e, t, o) {
				return n.Dom.closest(
				  t,
				  function (t) {
					return a(e, t, !0);
				  },
				  o,
				);
			  }),
			  (t.isSameStyleChild = function (e, t) {
				var o,
				  n,
				  a = e.element,
				  s = e.options;
				if (!t || !(0, r.isNormalNode)(t)) return !1;
				var l = t.nodeName.toLowerCase() === a,
				  c = Boolean(
					(null === (o = s.attributes) || void 0 === o
					  ? void 0
					  : o.style) &&
					  (0, i.hasSameStyleKeys)(
						t,
						null === (n = s.attributes) || void 0 === n
						  ? void 0
						  : n.style,
					  ),
				  );
				return l && c;
			  });
		  },
		  11651: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.toggleOrderedList = void 0);
			var n = o(24263),
			  r = (o(52378), o(77846)),
			  i = o(70851),
			  a = o(93217),
			  s = o(66162);
			function l(e, t, o, a, s) {
			  return (
				a.e.fire("".concat(i._PREFIX, "BeforeUnwrapList"), e, t, s) ||
				((0, r.extractSelectedPart)(t, o, a),
				n.Dom.unwrap(o.parentElement),
				n.Dom.replace(o, a.o.enter, a.createInside))
			  );
			}
			t.toggleOrderedList = function (e, t, o, n) {
			  if (!t) return n;
			  var r = t.parentElement;
			  if (!r) return n;
			  var c = o.e.fire("".concat(i._PREFIX, "BeforeToggleList"), n, e, r);
			  if (void 0 !== c) return c;
			  var u = o.e.fire.bind(o.e, "".concat(i._PREFIX, "AfterToggleList"));
			  if (n !== i.UNWRAP) {
				var d =
				  (0, a.toggleAttributes)(
					e,
					t.parentElement,
					o,
					i.INITIAL,
					!0,
				  ) === i.CHANGE;
				if (
				  n === i.REPLACE ||
				  d ||
				  r.tagName.toLowerCase() !== e.element
				) {
				  var p = l(i.REPLACE, r, t, o, e),
					f = (0, s.wrapList)(e, p, o);
				  return u(i.REPLACE, f, e), i.REPLACE;
				}
			  }
			  var h = l(i.UNWRAP, r, t, o, e);
			  return u(i.UNWRAP, h, e), i.UNWRAP;
			};
		  },
		  29271: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.wrapList = void 0);
			var n = o(64968),
			  r = o(70851),
			  i = o(66162);
			t.wrapList = function (e, t, o) {
			  var a = o.e.fire(
				  "".concat(r._PREFIX, "BeforeWrapList"),
				  r.REPLACE,
				  t,
				  e,
				),
				s = null != a ? a : n.Dom.replace(t, "li", o.createInside),
				l = s.previousElementSibling,
				c = s.nextElementSibling,
				u = n.Dom.isTag(l, e.element) ? l : null;
			  return (
				null != u || (u = n.Dom.isTag(c, e.element) ? c : null),
				(n.Dom.isTag(u, ["ul", "ol"]) &&
				  (0, i.isSameAttributes)(u, e.options.attributes)) ||
				  ((u = o.createInside.element(e.element)),
				  (0, i.toggleAttributes)(e, u, o, r.INITIAL),
				  n.Dom.before(s, u)),
				l === u ? n.Dom.append(u, s) : n.Dom.prepend(u, s),
				n.Dom.isTag(u.nextElementSibling, e.element) &&
				  (0, i.elementsEqualAttributes)(u, u.nextElementSibling) &&
				  (n.Dom.append(u, Array.from(u.nextElementSibling.childNodes)),
				  n.Dom.safeRemove(u.nextElementSibling)),
				o.e.fire("".concat(r._PREFIX, "AfterWrapList"), r.WRAP, u, e),
				u
			  );
			};
		  },
		  93217: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.toggleAttributes = void 0);
			var n = o(76502),
			  r = o(26911),
			  i = o(63122),
			  a = o(11278),
			  s = o(49353),
			  l = o(16492),
			  c = o(24263),
			  u = o(70851),
			  d = o(17332),
			  p = (o(10172), "toggleAttributes");
			function f(e, t, o) {
			  return (
				(0, n.attr)(t, "style") ||
				  ((0, n.attr)(t, "style", null),
				  t.tagName.toLowerCase() === e.defaultTag &&
					(c.Dom.unwrap(t), (o = u.UNWRAP))),
				o
			  );
			}
			t.toggleAttributes = function (e, t, o, h, m) {
			  if ((void 0 === m && (m = !1), !m && e.isApplied(t, p))) return h;
			  !m && e.setApplied(t, p);
			  var v = e.options.attributes;
			  return (
				v &&
				  (0, l.size)(v) > 0 &&
				  Object.keys(v).forEach(function (l) {
					var p = v[l];
					switch (l) {
					  case "style":
						h = (function (e, t, o, n, l, p) {
						  return (
							Object.keys(o).forEach(function (h) {
							  var m = n.style.getPropertyValue(
								  (0, a.kebabCase)(h),
								),
								v = o[h];
							  if ("" !== m || null != v) {
								if (
								  (function (e, t, o) {
									var n = e.create.element(
									  t.tagName.toLowerCase(),
									);
									(n.style.cssText = t.style.cssText),
									  (function (e) {
										var t;
										if (
										  void 0 !==
										  (0, i.dataBind)(e, "shadowRoot")
										)
										  return (0, i.dataBind)(e, "shadowRoot");
										var o = (0, d.getContainer)(e),
										  n = document.createElement("iframe");
										(0, r.css)(n, {
										  width: 0,
										  height: 0,
										  position: "absolute",
										  border: 0,
										}),
										  (n.src = "about:blank"),
										  o.appendChild(n);
										var a =
											null === (t = n.contentWindow) ||
											void 0 === t
											  ? void 0
											  : t.document,
										  s = a ? a.body : e.od.body;
										return (
										  (0, i.dataBind)(e, "shadowRoot", s), s
										);
									  })(e).appendChild(n);
									var a = (0, r.css)(n, o);
									return c.Dom.safeRemove(n), a;
								  })(t, n, h) === (0, s.normalizeCssValue)(h, v)
								) {
								  if (!m) return;
								  return (
									!l && (0, r.css)(n, h, null),
									void (p = f(e, n, (p = u.UNSET)))
								  );
								}
								(p = u.CHANGE),
								  l || ((0, r.css)(n, h, v), (p = f(e, n, p)));
							  }
							}),
							p
						  );
						})(e, o, p, t, m, h);
						break;
					  case "class":
						h = (function (e, t, o, r, i) {
						  var a = e.e.fire.bind(
							e.e,
							"".concat(u._PREFIX, "AfterToggleAttribute"),
						  );
						  return (
							o.classList.contains(t.toString())
							  ? ((r = u.UNSET),
								i ||
								  (o.classList.remove(t),
								  0 === o.classList.length &&
									((0, n.attr)(o, "class", null),
									a(r, o, "class", null))))
							  : ((r = u.CHANGE),
								i || (o.classList.add(t), a(r, o, "class", t))),
							r
						  );
						})(o, p, t, h, m);
						break;
					  default:
						h = (function (e, t, o, r, i, a) {
						  var s = e.e.fire.bind(
							e.e,
							"".concat(u._PREFIX, "AfterToggleAttribute"),
						  );
						  return (0, n.attr)(o, r) === t
							? (!i && (0, n.attr)(o, r, null),
							  (a = u.UNSET),
							  !i && s(a, o, r, t),
							  a)
							: ((a = u.CHANGE),
							  i || ((0, n.attr)(o, r, t), s(a, o, r, t)),
							  a);
						})(o, p, t, l, m, h);
					}
				  }),
				h
			  );
			};
		  },
		  26707: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.unwrapChildren = void 0);
			var n = o(24263),
			  r = o(40332),
			  i = o(18387),
			  a = o(74477);
			t.unwrapChildren = function (e, t) {
			  var o,
				s,
				l = [],
				c = [],
				u =
				  null === (o = e.options.attributes) || void 0 === o
					? void 0
					: o.style;
			  if (t.firstChild)
				for (
				  var d = n.Dom.eachGen(t),
					p = d.next(),
					f = function () {
					  var t = p.value;
					  !(0, a.isSuitElement)(e, t, !0) ||
					  (u && !(0, i.hasSameStyleKeys)(t, u))
						? u && (0, a.isSameStyleChild)(e, t)
						  ? (void 0 === s && (s = !1),
							c.push(function () {
							  (0, r.css)(
								t,
								Object.keys(u).reduce(function (e, t) {
								  return (e[t] = null), e;
								}, {}),
							  ),
								(0, r.attr)(t, "style") ||
								  (0, r.attr)(t, "style", null),
								(0, r.attr)(t, "style") ||
								  t.nodeName.toLowerCase() !== e.element ||
								  l.push(t);
							}))
						  : n.Dom.isEmptyTextNode(t) || (void 0 === s && (s = !1))
						: (void 0 === s && (s = !0), l.push(t)),
						(p = d.next());
					};
				  !p.done;
  
				)
				  f();
			  return (
				c.forEach(function (e) {
				  return e();
				}),
				l.forEach(n.Dom.unwrap),
				Boolean(s)
			  );
			};
		  },
		  6278: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.wrapUnwrappedText = void 0);
			var n = o(24263),
			  r = o(37204);
			t.wrapUnwrappedText = function (e, t, o) {
			  var i = o.editor,
				a = o.createInside,
				s = function (e, t) {
				  void 0 === t && (t = "previousSibling");
				  for (
					var a = e, s = e;
					s &&
					!(0, r.isMarker)(s) &&
					!n.Dom.isTag(s, o.o.enter) &&
					((a = s),
					(s = s[t]
					  ? s[t]
					  : s.parentNode &&
						  !n.Dom.isBlock(s.parentNode) &&
						  s.parentNode !== i
						? s.parentNode
						: null),
					!n.Dom.isBlock(s));
  
				  );
				  return a;
				},
				l = s(t),
				c = s(t, "nextSibling"),
				u = o.s.createRange();
			  u.setStartBefore(l), u.setEndAfter(c);
			  var d = u.extractContents(),
				p = a.element(e.element);
			  return (
				p.appendChild(d),
				n.Dom.safeInsertNode(u, p),
				e.elementIsBlock &&
				  n.Dom.isEmpty(p) &&
				  !n.Dom.isTag(p.firstElementChild, "br") &&
				  p.appendChild(a.element("br")),
				p
			  );
			};
		  },
		  8298: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.wrap = void 0);
			var n = o(64968),
			  r = o(6278),
			  i = o(67309),
			  a = o(29271);
			t.wrap = function (e, t, o) {
			  var s = (function (e, t, o) {
				return e.elementIsBlock
				  ? n.Dom.up(
					  t,
					  function (e) {
						return (
						  n.Dom.isBlock(e) &&
						  !n.Dom.isTag(e, [
							"td",
							"th",
							"tr",
							"tbody",
							"table",
							"li",
							"ul",
							"ol",
						  ])
						);
					  },
					  o.editor,
					) || (0, r.wrapUnwrappedText)(e, t, o)
				  : ((0, i.attr)(t, "size", null), t);
			  })(e, t, o);
			  return e.elementIsList
				? (0, a.wrapList)(e, s, o)
				: n.Dom.replace(s, e.element, o.createInside, !0);
			};
		  },
		  3097: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ApplyStyle = void 0);
			var n = o(74504),
			  r = o(66162),
			  i = o(33090),
			  a = o(70851);
			t.ApplyStyle = function (e, t) {
			  var o = e.s,
				s = e.editor;
			  o.save(), (0, n.normalizeNode)(s.firstChild);
			  for (
				var l = e.s.wrapInTagGen(),
				  c = l.next(),
				  u = {
					mode: a.INITIAL,
					element: c.value,
					next: i.states.START,
					jodit: e,
					style: t,
				  };
				c && !c.done;
  
			  ) {
				var d = new r.FiniteStateMachine(i.states.START, i.transactions);
				for (u.element = c.value; d.getState() !== i.states.END; )
				  u = d.dispatch("exec", u);
				c = l.next();
			  }
			  o.restore();
			};
		  },
		  70851: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.CommitStyle =
				t._PREFIX =
				t.REPLACE =
				t.INITIAL =
				t.UNSET =
				t.CHANGE =
				t.UNWRAP =
				t.WRAP =
				  void 0);
			var n = o(86893),
			  r = o(26596),
			  i = o(3097);
			(t.WRAP = "wrap"),
			  (t.UNWRAP = "unwrap"),
			  (t.CHANGE = "change"),
			  (t.UNSET = "unset"),
			  (t.INITIAL = "initial"),
			  (t.REPLACE = "replace"),
			  (t._PREFIX = "commitStyle");
			var a = (function () {
			  function e(e) {
				var t, o, n, r;
				(this.options = e),
				  (this.__applyMap = new WeakMap()),
				  (e.attributes =
					((t = e.attributes),
					(r = (o = this.options).className),
					(n = o.style) &&
					  (t ? (t.style = n) : (t = { style: n }),
					  delete this.options.style),
					r &&
					  (t ? (t.class = r) : (t = { class: r }),
					  delete this.options.className),
					t));
			  }
			  return (
				(e.prototype.isApplied = function (e, t) {
				  var o = this.__applyMap.get(e);
				  return !!o && o[t];
				}),
				(e.prototype.setApplied = function (e, t) {
				  var o,
					n =
					  null !== (o = this.__applyMap.get(e)) && void 0 !== o
						? o
						: {};
				  (n[t] = !0), this.__applyMap.set(e, n);
				}),
				Object.defineProperty(e.prototype, "elementIsList", {
				  get: function () {
					return Boolean(
					  this.options.element &&
						["ul", "ol"].includes(this.options.element),
					);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "element", {
				  get: function () {
					return this.options.element || this.defaultTag;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "elementIsBlock", {
				  get: function () {
					return Boolean(
					  this.options.element &&
						n.IS_BLOCK.test(this.options.element),
					);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "isElementCommit", {
				  get: function () {
					return Boolean(
					  this.options.element &&
						this.options.element !== this.options.defaultTag,
					);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "defaultTag", {
				  get: function () {
					return this.options.defaultTag
					  ? this.options.defaultTag
					  : this.elementIsBlock
						? "p"
						: "span";
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				Object.defineProperty(e.prototype, "elementIsDefault", {
				  get: function () {
					return this.element === this.defaultTag;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.apply = function (e) {
				  var o = this.options.hooks;
				  try {
					o &&
					  Object.keys(o).forEach(function (n) {
						e.e.on((0, r.camelCase)(t._PREFIX + "_" + n), o[n]);
					  }),
					  (0, i.ApplyStyle)(e, this);
				  } finally {
					o &&
					  Object.keys(o).forEach(function (n) {
						e.e.off((0, r.camelCase)(t._PREFIX + "_" + n), o[n]);
					  }),
					  (this.__applyMap = new WeakMap());
				  }
				}),
				e
			  );
			})();
			t.CommitStyle = a;
		  },
		  33090: function (e, t, o) {
			"use strict";
			var n;
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.transactions = t.states = void 0);
			var r = o(20255),
			  i = o(2123),
			  a = o(66162),
			  s = o(64968),
			  l = o(2123);
			o(52378),
			  (t.states = {
				START: "START",
				ELEMENT: "ELEMENT",
				UNWRAP: "UNWRAP",
				UNWRAP_CHILDREN: "UNWRAP_CHILDREN",
				CHANGE: "CHANGE",
				REPLACE_DEFAULT: "REPLACE_DEFAULT",
				LIST: "LIST",
				TOGGLE_LIST: "TOGGLE_LIST",
				WRAP: "WRAP",
				EXTRACT: "EXTRACT",
				END: "END",
			  }),
			  (t.transactions =
				(((n = {})[t.states.START] = {
				  exec: function (e) {
					var o = e.element,
					  n = e.jodit,
					  i = e.style,
					  c = e.mode;
					if (
					  (0, a.isInsideInvisibleElement)(o, n.editor) ||
					  s.Dom.isEmptyContent(o)
					)
					  return r.__assign(r.__assign({}, e), {
						next: t.states.END,
					  });
					var u =
					  (0, a.getSuitParent)(i, o, n.editor) ||
					  (0, a.getSuitChild)(i, o);
					if (u)
					  return r.__assign(r.__assign({}, e), {
						next: t.states.ELEMENT,
						element: u,
					  });
					var d = (0, a.findSuitClosest)(i, o, n.editor);
					return i.elementIsList && s.Dom.isTag(d, ["ul", "ol"])
					  ? r.__assign(r.__assign({}, e), { next: t.states.LIST })
					  : r.__assign(
						  r.__assign({}, e),
						  d
							? { next: t.states.EXTRACT }
							: {
								next:
								  c !== l.UNWRAP
									? t.states.UNWRAP_CHILDREN
									: t.states.END,
							  },
						);
				  },
				}),
				(n[t.states.LIST] = {
				  exec: function (e) {
					var o = e.element,
					  n = e.jodit,
					  a = e.mode;
					if (a !== l.INITIAL && a !== l.UNWRAP && a !== i.REPLACE)
					  return r.__assign(r.__assign({}, e), {
						next: t.states.END,
					  });
					var c = s.Dom.closest(o, "li", n.editor);
					if (!c)
					  return r.__assign(r.__assign({}, e), {
						next: t.states.END,
					  });
					var u = s.Dom.closest(o, ["ul", "ol"], n.editor);
					return r.__assign(
					  r.__assign({}, e),
					  u
						? { element: c, next: t.states.TOGGLE_LIST }
						: { next: t.states.END },
					);
				  },
				}),
				(n[t.states.TOGGLE_LIST] = {
				  exec: function (e) {
					return r.__assign(r.__assign({}, e), {
					  mode: (0, a.toggleOrderedList)(
						e.style,
						e.element,
						e.jodit,
						e.mode,
					  ),
					  next: t.states.END,
					});
				  },
				}),
				(n[t.states.EXTRACT] = {
				  exec: function (e) {
					var o = e.element,
					  n = e.jodit,
					  i = e.style,
					  s = (0, a.findSuitClosest)(i, o, n.editor);
					return (
					  i.elementIsBlock || (0, a.extractSelectedPart)(s, o, n),
					  r.__assign(r.__assign({}, e), {
						element: s,
						next: t.states.ELEMENT,
					  })
					);
				  },
				}),
				(n[t.states.UNWRAP_CHILDREN] = {
				  exec: function (e) {
					return (0, a.unwrapChildren)(e.style, e.element)
					  ? r.__assign(r.__assign({}, e), {
						  mode: l.UNWRAP,
						  next: t.states.END,
						})
					  : r.__assign(r.__assign({}, e), { next: t.states.WRAP });
				  },
				}),
				(n[t.states.WRAP] = {
				  exec: function (e) {
					var o = e.style,
					  n = (0, a.wrap)(o, e.element, e.jodit);
					return r.__assign(r.__assign({}, e), {
					  next: o.elementIsList ? t.states.END : t.states.CHANGE,
					  mode: l.WRAP,
					  element: n,
					});
				  },
				}),
				(n[t.states.ELEMENT] = {
				  exec: function (e) {
					var o = e.style,
					  n = e.element;
					return (0, a.toggleAttributes)(
					  o,
					  n,
					  e.jodit,
					  l.INITIAL,
					  !0,
					) !== l.INITIAL
					  ? r.__assign(r.__assign({}, e), { next: t.states.CHANGE })
					  : s.Dom.isTag(n, o.element)
						? r.__assign(r.__assign({}, e), { next: t.states.UNWRAP })
						: r.__assign(r.__assign({}, e), { next: t.states.END });
				  },
				}),
				(n[t.states.CHANGE] = {
				  exec: function (e) {
					var o = e.style,
					  n = e.element,
					  i = e.mode,
					  c = (0, a.toggleAttributes)(o, n, e.jodit, e.mode);
					return i !== l.WRAP &&
					  c === l.UNSET &&
					  !n.attributes.length &&
					  s.Dom.isTag(n, o.element)
					  ? r.__assign(r.__assign({}, e), { next: t.states.UNWRAP })
					  : r.__assign(r.__assign({}, e), {
						  mode: c,
						  next: t.states.END,
						});
				  },
				}),
				(n[t.states.UNWRAP] = {
				  exec: function (e) {
					return e.element.attributes.length &&
					  s.Dom.isTag(e.element, e.style.element)
					  ? r.__assign(r.__assign({}, e), {
						  next: t.states.REPLACE_DEFAULT,
						})
					  : (s.Dom.unwrap(e.element),
						r.__assign(r.__assign({}, e), {
						  mode: l.UNWRAP,
						  next: t.states.END,
						}));
				  },
				}),
				(n[t.states.REPLACE_DEFAULT] = {
				  exec: function (e) {
					return (
					  s.Dom.replace(
						e.element,
						e.style.defaultTag,
						e.jodit.createInside,
						!0,
					  ),
					  r.__assign(r.__assign({}, e), {
						mode: i.REPLACE,
						next: t.states.END,
					  })
					);
				  },
				}),
				(n[t.states.END] = {
				  exec: function (e) {
					return e;
				  },
				}),
				n));
		  },
		  75764: function (e, t) {
			"use strict";
			var o;
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.LocalStorageProvider = t.canUsePersistentStorage = void 0),
			  (t.canUsePersistentStorage = function () {
				return (
				  void 0 === o &&
					(o = (function () {
					  var e = "___Jodit___" + Math.random().toString();
					  try {
						localStorage.setItem(e, "1");
						var t = "1" === localStorage.getItem(e);
						return localStorage.removeItem(e), t;
					  } catch (e) {}
					  return !1;
					})()),
				  o
				);
			  });
			var n = (function () {
			  function e(e) {
				this.rootKey = e;
			  }
			  return (
				(e.prototype.set = function (e, t) {
				  try {
					var o = localStorage.getItem(this.rootKey),
					  n = o ? JSON.parse(o) : {};
					(n[e] = t),
					  localStorage.setItem(this.rootKey, JSON.stringify(n));
				  } catch (e) {}
				  return this;
				}),
				(e.prototype.delete = function (e) {
				  try {
					localStorage.removeItem(this.rootKey);
				  } catch (e) {}
				  return this;
				}),
				(e.prototype.get = function (e) {
				  try {
					var t = localStorage.getItem(this.rootKey),
					  o = t ? JSON.parse(t) : {};
					return void 0 !== o[e] ? o[e] : null;
				  } catch (e) {}
				}),
				(e.prototype.exists = function (e) {
				  return null != this.get(e);
				}),
				(e.prototype.clear = function () {
				  try {
					localStorage.removeItem(this.rootKey);
				  } catch (e) {}
				  return this;
				}),
				e
			  );
			})();
			t.LocalStorageProvider = n;
		  },
		  79905: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.MemoryStorageProvider = void 0);
			var o = (function () {
			  function e() {
				this.data = new Map();
			  }
			  return (
				(e.prototype.set = function (e, t) {
				  return this.data.set(e, t), this;
				}),
				(e.prototype.delete = function (e) {
				  return this.data.delete(e), this;
				}),
				(e.prototype.get = function (e) {
				  return this.data.get(e);
				}),
				(e.prototype.exists = function (e) {
				  return this.data.has(e);
				}),
				(e.prototype.clear = function () {
				  return this.data.clear(), this;
				}),
				e
			  );
			})();
			t.MemoryStorageProvider = o;
		  },
		  77462: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(79905), t),
			  n.__exportStar(o(75764), t),
			  n.__exportStar(o(52015), t);
		  },
		  52015: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Storage = t.StorageKey = void 0);
			var n = o(40332),
			  r = o(75764),
			  i = o(79905);
			t.StorageKey = "Jodit_";
			var a = (function () {
			  function e(e, o) {
				(this.provider = e),
				  (this.prefix = t.StorageKey),
				  o && (this.prefix += o);
			  }
			  return (
				(e.prototype.set = function (e, t) {
				  return (
					this.provider.set((0, n.camelCase)(this.prefix + e), t), this
				  );
				}),
				(e.prototype.delete = function (e) {
				  return (
					this.provider.delete((0, n.camelCase)(this.prefix + e)), this
				  );
				}),
				(e.prototype.get = function (e) {
				  return this.provider.get((0, n.camelCase)(this.prefix + e));
				}),
				(e.prototype.exists = function (e) {
				  return this.provider.exists((0, n.camelCase)(this.prefix + e));
				}),
				(e.prototype.clear = function () {
				  return this.provider.clear(), this;
				}),
				(e.makeStorage = function (o, n) {
				  var a;
				  return (
					void 0 === o && (o = !1),
					o &&
					  (0, r.canUsePersistentStorage)() &&
					  (a = new r.LocalStorageProvider(t.StorageKey + n)),
					a || (a = new i.MemoryStorageProvider()),
					new e(a, n)
				  );
				}),
				e
			  );
			})();
			t.Storage = a;
		  },
		  59363: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Dlgs = void 0);
			var n = o(20255),
			  r = o(87837),
			  i = o(40332),
			  a = (function () {
				function e() {}
				return (
				  (e.prototype.dlg = function (e) {
					var t = new r.Dialog(
					  n.__assign(
						{
						  language: this.o.language,
						  shadowRoot: this.o.shadowRoot,
						  ownerWindow: this.o.ownerWindow,
						  defaultTimeout: this.o.defaultTimeout,
						  theme: this.o.theme,
						  globalFullSize: this.o.globalFullSize,
						},
						e,
					  ),
					);
					return (
					  (0, i.markOwner)(this, t.container),
					  (t.parent = this),
					  t.bindDestruct(this)
					);
				  }),
				  (e.prototype.confirm = function (e, t, o) {
					return (
					  (0, i.isString)(t) && (t = this.i18n(t)),
					  r.Confirm.call(this.dlg(), this.i18n(e), t, o)
					);
				  }),
				  (e.prototype.prompt = function (e, t, o, n, a) {
					return (
					  (0, i.isString)(t) && (t = this.i18n(t)),
					  (0, i.isString)(n) && (n = this.i18n(n)),
					  r.Prompt.call(this.dlg(), this.i18n(e), t, o, n, a)
					);
				  }),
				  (e.prototype.alert = function (e, t, o, n) {
					return (
					  (0, i.isString)(e) && (e = this.i18n(e)),
					  (0, i.isString)(t) && (t = this.i18n(t)),
					  r.Alert.call(this.dlg(), e, t, o, n)
					);
				  }),
				  e
				);
			  })();
			t.Dlgs = a;
		  },
		  14089: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Elms = void 0);
			var n = o(1853),
			  r = (function () {
				function e() {}
				return (
				  (e.prototype.getElm = function (e) {
					return this.container.querySelector(
					  ".".concat(this.getFullElName(e)),
					);
				  }),
				  (e.prototype.getElms = function (e) {
					return (0, n.toArray)(
					  this.container.querySelectorAll(
						".".concat(this.getFullElName(e)),
					  ),
					);
				  }),
				  e
				);
			  })();
			t.Elms = r;
		  },
		  59829: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(14089), t),
			  n.__exportStar(o(41681), t),
			  n.__exportStar(o(59363), t);
		  },
		  41681: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Mods = void 0);
			var n = o(1853),
			  r = o(24021),
			  i = (function () {
				function e() {}
				return (
				  (e.prototype.afterSetMod = function (e, t) {}),
				  (e.prototype.setMod = function (e, t, o) {
					if (((e = e.toLowerCase()), this.mods[e] === t)) return this;
					var i = "".concat(this.componentName, "_").concat(e),
					  a = (o || this.container).classList;
					return (
					  (0, n.toArray)(a).forEach(function (e) {
						0 === e.indexOf(i) && a.remove(e);
					  }),
					  !(0, r.isVoid)(t) &&
						"" !== t &&
						a.add(
						  "".concat(i, "_").concat(t.toString().toLowerCase()),
						),
					  (this.mods[e] = t),
					  this.afterSetMod(e, t),
					  this
					);
				  }),
				  (e.prototype.getMod = function (e) {
					var t;
					return null !== (t = this.mods[e]) && void 0 !== t ? t : null;
				  }),
				  e
				);
			  })();
			t.Mods = i;
		  },
		  96031: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Button = t.UIButton = t.UIButtonState = void 0);
			var n = o(20255);
			o(93330);
			var r = o(53929),
			  i = o(24263),
			  a = o(76502),
			  s = o(24421),
			  l = o(42096),
			  c = o(77904),
			  u = o(47970),
			  d = o(43441),
			  p = o(29411);
			t.UIButtonState = function () {
			  return {
				size: "middle",
				type: "button",
				name: "",
				value: "",
				variant: "initial",
				disabled: !1,
				activated: !1,
				icon: { name: "empty", fill: "", iconURL: "" },
				tooltip: "",
				text: "",
				tabIndex: void 0,
			  };
			};
			var f = (function (e) {
			  function o(o, n) {
				var r = e.call(this, o) || this;
				return (
				  (r.isButton = !0),
				  (r.state = (0, t.UIButtonState)()),
				  (r.actionHandlers = []),
				  r.updateSize(),
				  r.onChangeSize(),
				  r.onChangeStatus(),
				  n &&
					r.hookStatus(p.STATUSES.ready, function () {
					  r.setState(n);
					}),
				  r
				);
			  }
			  return (
				n.__extends(o, e),
				(o.prototype.className = function () {
				  return "UIButton";
				}),
				(o.prototype.setState = function (e) {
				  return Object.assign(this.state, e), this;
				}),
				(o.prototype.onChangeSize = function () {
				  this.setMod("size", this.state.size);
				}),
				(o.prototype.onChangeType = function () {
				  (0, a.attr)(this.container, "type", this.state.type);
				}),
				(o.prototype.updateSize = function () {
				  var e = this.closest(u.UIList);
				  e && (this.state.size = e.buttonSize);
				}),
				(o.prototype.onChangeStatus = function () {
				  this.setMod("variant", this.state.variant);
				}),
				(o.prototype.onChangeText = function () {
				  this.text.textContent = this.jodit.i18n(this.state.text);
				}),
				(o.prototype.onChangeTextSetMode = function () {
				  this.setMod(
					"text-icons",
					Boolean(this.state.text.trim().length),
				  );
				}),
				(o.prototype.onChangeDisabled = function () {
				  (0, a.attr)(
					this.container,
					"disabled",
					this.state.disabled || null,
				  );
				}),
				(o.prototype.onChangeActivated = function () {
				  (0, a.attr)(
					this.container,
					"aria-pressed",
					this.state.activated,
				  );
				}),
				(o.prototype.onChangeName = function () {
				  this.container.classList.add(
					""
					  .concat(this.componentName, "_")
					  .concat(this.clearName(this.state.name)),
				  ),
					(this.name = this.state.name),
					(0, a.attr)(this.container, "data-ref", this.state.name),
					(0, a.attr)(this.container, "ref", this.state.name);
				}),
				(o.prototype.onChangeTooltip = function () {
				  this.get("j.o.useNativeTooltip") &&
					(0, a.attr)(this.container, "title", this.state.tooltip),
					(0, a.attr)(this.container, "aria-label", this.state.tooltip);
				}),
				(o.prototype.onChangeTabIndex = function () {
				  (0, a.attr)(this.container, "tabindex", this.state.tabIndex);
				}),
				(o.prototype.onChangeIcon = function () {
				  var e = this.get("j.o.textIcons");
				  if (
					!(!0 === e || ((0, l.isFunction)(e) && e(this.state.name)))
				  ) {
					i.Dom.detach(this.icon);
					var t = c.Icon.makeIcon(this.j, this.state.icon);
					t && this.icon.appendChild(t);
				  }
				}),
				(o.prototype.focus = function () {
				  this.container.focus();
				}),
				(o.prototype.isFocused = function () {
				  var e = this.od.activeElement;
				  return Boolean(e && i.Dom.isOrContains(this.container, e));
				}),
				(o.prototype.createContainer = function () {
				  var e = this.componentName,
					t = this.j.c.element("button", {
					  class: e,
					  type: "button",
					  role: "button",
					  ariaPressed: !1,
					});
				  return (
					(this.icon = this.j.c.span(e + "__icon")),
					(this.text = this.j.c.span(e + "__text")),
					t.appendChild(this.icon),
					t.appendChild(this.text),
					this.j.e.on(t, "click", this.onActionFire),
					t
				  );
				}),
				(o.prototype.destruct = function () {
				  return (
					this.j.e.off(this.container), e.prototype.destruct.call(this)
				  );
				}),
				(o.prototype.onAction = function (e) {
				  return this.actionHandlers.push(e), this;
				}),
				(o.prototype.onActionFire = function (e) {
				  var t = this;
				  (e.buffer = { actionTrigger: this }),
					this.actionHandlers.forEach(function (o) {
					  return o.call(t, e);
					});
				}),
				n.__decorate(
				  [(0, d.watch)("state.size")],
				  o.prototype,
				  "onChangeSize",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.type")],
				  o.prototype,
				  "onChangeType",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("parentElement")],
				  o.prototype,
				  "updateSize",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.variant")],
				  o.prototype,
				  "onChangeStatus",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.text")],
				  o.prototype,
				  "onChangeText",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.text")],
				  o.prototype,
				  "onChangeTextSetMode",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.disabled")],
				  o.prototype,
				  "onChangeDisabled",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.activated")],
				  o.prototype,
				  "onChangeActivated",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.name")],
				  o.prototype,
				  "onChangeName",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.tooltip")],
				  o.prototype,
				  "onChangeTooltip",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.tabIndex")],
				  o.prototype,
				  "onChangeTabIndex",
				  null,
				),
				n.__decorate(
				  [(0, d.watch)("state.icon")],
				  o.prototype,
				  "onChangeIcon",
				  null,
				),
				n.__decorate([d.autobind], o.prototype, "onActionFire", null),
				n.__decorate([d.component], o)
			  );
			})(r.UIElement);
			(t.UIButton = f),
			  (t.Button = function (e, t, o, n) {
				var r = new f(e);
				return (
				  (r.state.tabIndex = e.o.allowTabNavigation ? 0 : -1),
				  (0, s.isString)(t)
					? ((r.state.icon.name = t),
					  (r.state.name = t),
					  n && (r.state.variant = n),
					  o && (r.state.text = o))
					: r.setState(t),
				  r
				);
			  });
		  },
		  67252: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIButtonGroup = void 0);
			var n = o(20255);
			o(45066);
			var r = o(61479),
			  i = o(11441),
			  a = o(96031),
			  s =
				(o(52378),
				(function (e) {
				  function t(t, o) {
					void 0 === o && (o = { radio: !0 });
					var n,
					  r,
					  i = this;
					return (
					  ((i =
						e.call(
						  this,
						  t,
						  null === (n = o.options) || void 0 === n
							? void 0
							: n.map(function (e) {
								var o = new a.UIButton(t, {
								  text: e.text,
								  value: e.value,
								  variant: "primary",
								});
								return (
								  o.onAction(function () {
									i.select(e.value);
								  }),
								  o
								);
							  }),
						  o,
						) || this).options = o),
					  i.select(null !== (r = o.value) && void 0 !== r ? r : 0),
					  i
					);
				  }
				  return (
					n.__extends(t, e),
					(t.prototype.className = function () {
					  return "UIButtonGroup";
					}),
					(t.prototype.render = function (e) {
					  return '<div>\n\t\t\t<div class="&__label">~'.concat(
						e.label,
						'~</div>\n\t\t\t<div class="&__options"></div>\n\t\t</div>',
					  );
					}),
					(t.prototype.appendChildToContainer = function (e) {
					  this.getElm("options").appendChild(e);
					}),
					(t.prototype.select = function (e) {
					  var t,
						o,
						n = this;
					  this.elements.forEach(function (t, o) {
						o === e || t.state.value === e
						  ? (t.state.activated = !0)
						  : n.options.radio && (t.state.activated = !1);
					  });
					  var r = this.elements
						.filter(function (e) {
						  return e.state.activated;
						})
						.map(function (e) {
						  return { text: e.state.text, value: e.state.value };
						});
					  this.jodit.e.fire(this, "select", r),
						null === (o = (t = this.options).onChange) ||
						  void 0 === o ||
						  o.call(t, r);
					}),
					n.__decorate([i.component], t)
				  );
				})(r.UIGroup));
			t.UIButtonGroup = s;
		  },
		  96516: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(96031), t),
			  n.__exportStar(o(67252), t),
			  n.__exportStar(o(33627), t);
		  },
		  33627: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UITooltip = void 0);
			var n = o(20255);
			o(99895);
			var r = o(40332),
			  i = o(17332),
			  a = o(43441),
			  s = (function (e) {
				function t(o) {
				  var n = e.call(this, o) || this;
				  (n.__isOpened = !1),
					(n.__useCount = 1),
					(n.__delayShowTimeout = 0),
					(0, i.getContainer)(o, t).appendChild(n.container);
				  var r = 0;
				  return (
					o.e
					  .off(".tooltip")
					  .on("showTooltip.tooltip", function (e, t) {
						o.async.clearTimeout(r), n.__open(e, t);
					  })
					  .on("delayShowTooltip.tooltip", n.__delayOpen)
					  .on("escape.tooltip", n.__close)
					  .on(
						"hideTooltip.tooltip change.tooltip scroll.tooltip changePlace.tooltip hidePopup.tooltip closeAllPopups.tooltip",
						function () {
						  n.j.async.clearTimeout(n.__delayShowTimeout),
							(r = o.async.setTimeout(
							  n.__close,
							  n.j.defaultTimeout,
							));
						},
					  ),
					n
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UITooltip";
				  }),
				  (t.make = function (e) {
					var o = (0, r.dataBind)(e, "ui-tooltip");
					return o
					  ? ((o.__useCount += 1), o)
					  : ((o = new t(e)), (0, r.dataBind)(e, "ui-tooltip", o), o);
				  }),
				  (t.prototype.__delayOpen = function (e, t) {
					var o = this,
					  n = this.j.o.showTooltipDelay || this.j.defaultTimeout;
					this.j.async.clearTimeout(this.__delayShowTimeout),
					  (this.__delayShowTimeout = this.j.async.setTimeout(
						function () {
						  return o.__open(e, t);
						},
						{ timeout: n, label: "tooltip" },
					  ));
				  }),
				  (t.prototype.__open = function (e, t) {
					this.setMod("visible", !0),
					  (this.container.innerHTML = t),
					  (this.__isOpened = !0),
					  this.__setPosition(e);
				  }),
				  (t.prototype.__setPosition = function (e) {
					var t = e();
					(0, r.css)(this.container, { left: t.x, top: t.y });
				  }),
				  (t.prototype.__close = function () {
					this.j.async.clearTimeout(this.__delayShowTimeout),
					  this.__isOpened &&
						((this.__isOpened = !1),
						this.setMod("visible", !1),
						(0, r.css)(this.container, { left: -5e3 }));
				  }),
				  (t.prototype.destruct = function () {
					var t;
					this.__useCount--,
					  this.__useCount ||
						(null === (t = this.j) ||
						  void 0 === t ||
						  t.e.off(".tooltip"),
						this.__close(),
						e.prototype.destruct.call(this));
				  }),
				  n.__decorate([a.autobind], t.prototype, "__delayOpen", null),
				  n.__decorate([a.autobind], t.prototype, "__close", null),
				  t
				);
			  })(o(53929).UIElement);
			t.UITooltip = s;
		  },
		  53929: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIElement = void 0);
			var n = o(20255),
			  r = o(56562),
			  i = o(24263),
			  a = o(59829),
			  s = o(24421),
			  l = o(77904),
			  c = o(43441),
			  u = (function (e) {
				function t(t, o) {
				  var n = e.call(this, t) || this;
				  return (
					(n.name = ""),
					(n.__parentElement = null),
					(n.mods = {}),
					(n.container = n.createContainer(o)),
					Object.defineProperty(n.container, "component", {
					  value: n,
					  configurable: !0,
					}),
					n
				  );
				}
				var o;
				return (
				  n.__extends(t, e),
				  (o = t),
				  Object.defineProperty(t.prototype, "parentElement", {
					get: function () {
					  return this.__parentElement;
					},
					set: function (e) {
					  var t = this;
					  (this.__parentElement = e),
						e &&
						  e.hookStatus("beforeDestruct", function () {
							return t.destruct();
						  }),
						this.updateParentElement(this);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.bubble = function (e) {
					for (var t = this.parentElement; t; )
					  e(t), (t = t.parentElement);
					return this;
				  }),
				  (t.prototype.updateParentElement = function (e) {
					var t;
					return (
					  null === (t = this.__parentElement) ||
						void 0 === t ||
						t.updateParentElement(e),
					  this
					);
				  }),
				  (t.prototype.get = function (t, o) {
					return e.prototype.get.call(this, t, o) || this.getElm(t);
				  }),
				  (t.prototype.closest = function (e) {
					for (
					  var t =
						  "object" == typeof e
							? function (t) {
								return t === e;
							  }
							: function (t) {
								return r.Component.isInstanceOf(t, e);
							  },
						n = this.__parentElement;
					  n;
  
					) {
					  if (t(n)) return n;
					  n =
						!n.parentElement && n.container.parentElement
						  ? o.closestElement(n.container.parentElement, o)
						  : n.parentElement;
					}
					return null;
				  }),
				  (t.closestElement = function (e, t) {
					var o = i.Dom.up(e, function (e) {
					  if (e) {
						var o = e.component;
						return o && r.Component.isInstanceOf(o, t);
					  }
					  return !1;
					});
					return o ? (null == o ? void 0 : o.component) : null;
				  }),
				  (t.prototype.update = function () {}),
				  (t.prototype.appendTo = function (e) {
					return e.appendChild(this.container), this;
				  }),
				  (t.prototype.clearName = function (e) {
					return e.replace(/[^a-zA-Z0-9]/g, "_");
				  }),
				  (t.prototype.render = function (e) {
					return this.j.c.div(this.componentName);
				  }),
				  (t.prototype.createContainer = function (e) {
					var t = this.render(e);
					if ((0, s.isString)(t)) {
					  var o = this.parseTemplate(t);
					  return o.classList.add(this.componentName), o;
					}
					return t;
				  }),
				  (t.prototype.parseTemplate = function (e) {
					var t = this;
					return this.j.c.fromHTML(
					  e
						.replace(/\*([^*]+?)\*/g, function (e, t) {
						  return l.Icon.get(t) || "";
						})
						.replace(/&__/g, this.componentName + "__")
						.replace(/~([^~]+?)~/g, function (e, o) {
						  return t.i18n(o);
						}),
					);
				  }),
				  (t.prototype.destruct = function () {
					return (
					  i.Dom.safeRemove(this.container),
					  (this.parentElement = null),
					  e.prototype.destruct.call(this)
					);
				  }),
				  (o = n.__decorate([(0, c.derive)(a.Mods, a.Elms)], t))
				);
			  })(r.ViewComponent);
			t.UIElement = u;
		  },
		  38318: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIBlock = void 0);
			var n = o(20255);
			o(87682);
			var r = o(61479),
			  i = o(76502),
			  a = o(11441),
			  s = (function (e) {
				function t(t, o, n) {
				  void 0 === n && (n = { align: "left" });
				  var r = e.call(this, t, o) || this;
				  return (
					(r.options = n),
					r.setMod("align", r.options.align || "left"),
					r.setMod("width", r.options.width || ""),
					r.options.mod && r.setMod(r.options.mod, !0),
					r.options.className &&
					  r.container.classList.add(r.options.className),
					(0, i.attr)(r.container, "data-ref", n.ref),
					(0, i.attr)(r.container, "ref", n.ref),
					r
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UIBlock";
				  }),
				  n.__decorate([a.component], t)
				);
			  })(r.UIGroup);
			t.UIBlock = s;
		  },
		  26207: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIForm = void 0);
			var n = o(20255),
			  r = o(61479),
			  i = o(30194),
			  a = o(75840),
			  s = o(76502),
			  l = o(11441),
			  c = o(45113),
			  u = (function (e) {
				function t() {
				  for (var t = [], o = 0; arguments.length > o; o++)
					t[o] = arguments[o];
				  var r,
					i,
					a = this;
				  return (
					(null ===
					  (r = (a =
						e.apply(this, n.__spreadArray([], n.__read(t), !1)) ||
						this).options) || void 0 === r
					  ? void 0
					  : r.className) &&
					  a.container.classList.add(
						null === (i = a.options) || void 0 === i
						  ? void 0
						  : i.className,
					  ),
					a
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UIForm";
				  }),
				  (t.prototype.submit = function () {
					this.j.e.fire(this.container, "submit");
				  }),
				  (t.prototype.validate = function () {
					var e,
					  t,
					  o,
					  r,
					  s = this.allChildren.filter(function (e) {
						return c.Component.isInstanceOf(e, i.UIInput);
					  });
					try {
					  for (
						var l = n.__values(s), u = l.next();
						!u.done;
						u = l.next()
					  )
						if (!u.value.validate()) return !1;
					} catch (t) {
					  e = { error: t };
					} finally {
					  try {
						u && !u.done && (t = l.return) && t.call(l);
					  } finally {
						if (e) throw e.error;
					  }
					}
					var d = this.allChildren.filter(function (e) {
					  return c.Component.isInstanceOf(e, a.UISelect);
					});
					try {
					  for (
						var p = n.__values(d), f = p.next();
						!f.done;
						f = p.next()
					  )
						if (!f.value.validate()) return !1;
					} catch (e) {
					  o = { error: e };
					} finally {
					  try {
						f && !f.done && (r = p.return) && r.call(p);
					  } finally {
						if (o) throw o.error;
					  }
					}
					return !0;
				  }),
				  (t.prototype.onSubmit = function (e) {
					var t = this;
					this.j.e.on(this.container, "submit", function () {
					  var o = t.allChildren.filter(function (e) {
						return c.Component.isInstanceOf(e, i.UIInput);
					  });
					  return (
						!!t.validate() &&
						(e(
						  o.reduce(function (e, t) {
							return (e[t.state.name] = t.value), e;
						  }, {}),
						),
						!1)
					  );
					});
				  }),
				  (t.prototype.createContainer = function () {
					var e = this.j.c.element("form");
					return (
					  e.classList.add(this.componentName),
					  (0, s.attr)(e, "dir", this.j.o.direction || "auto"),
					  e
					);
				  }),
				  n.__decorate([l.component], t)
				);
			  })(r.UIGroup);
			t.UIForm = u;
		  },
		  95963: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(26207), t),
			  n.__exportStar(o(63034), t),
			  n.__exportStar(o(38318), t);
		  },
		  21639: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UITextArea = void 0);
			var n = o(20255);
			o(50905);
			var r = o(30194),
			  i = o(11441),
			  a = (function (e) {
				function t(t, r) {
				  var i = e.call(this, t, r) || this;
				  return (
					(i.state = n.__assign({}, o.defaultState)),
					Object.assign(i.state, r),
					!1 === i.state.resizable &&
					  (i.nativeInput.style.resize = "none"),
					i
				  );
				}
				var o;
				return (
				  n.__extends(t, e),
				  (o = t),
				  (t.prototype.className = function () {
					return "UITextArea";
				  }),
				  (t.prototype.createContainer = function (t) {
					return (
					  (this.nativeInput = this.j.create.element("textarea")),
					  e.prototype.createContainer.call(this, t)
					);
				  }),
				  (t.defaultState = n.__assign(
					n.__assign({}, r.UIInput.defaultState),
					{ size: 5, resizable: !0 },
				  )),
				  (o = n.__decorate([i.component], t))
				);
			  })(r.UIInput);
			t.UITextArea = a;
		  },
		  63747: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UICheckbox = void 0);
			var n = o(20255);
			o(70446);
			var r = o(30194),
			  i = o(43441),
			  a = o(24263),
			  s = (function (e) {
				function t(t, r) {
				  var i =
					e.call(
					  this,
					  t,
					  n.__assign(n.__assign({}, r), { type: "checkbox" }),
					) || this;
				  return (
					(i.state = n.__assign({}, o.defaultState)),
					Object.assign(i.state, r),
					i
				  );
				}
				var o;
				return (
				  n.__extends(t, e),
				  (o = t),
				  (t.prototype.className = function () {
					return "UICheckbox";
				  }),
				  (t.prototype.render = function () {
					return this.j.c.element("label", {
					  className: this.componentName,
					});
				  }),
				  (t.prototype.onChangeChecked = function () {
					(this.value = this.state.checked.toString()),
					  (this.nativeInput.checked = this.state.checked),
					  this.setMod("checked", this.state.checked);
				  }),
				  (t.prototype.onChangeNativeCheckBox = function () {
					this.state.checked = this.nativeInput.checked;
				  }),
				  (t.prototype.onChangeSwitch = function () {
					this.setMod("switch", this.state.switch);
					var e = this.getElm("switch-slider");
					this.state.switch
					  ? (e ||
						  (e = this.j.c.div(this.getFullElName("switch-slider"))),
						a.Dom.after(this.nativeInput, e))
					  : a.Dom.safeRemove(e);
				  }),
				  (t.defaultState = n.__assign(
					n.__assign({}, r.UIInput.defaultState),
					{ checked: !1, switch: !1 },
				  )),
				  n.__decorate(
					[(0, i.watch)("state.checked"), (0, i.hook)("ready")],
					t.prototype,
					"onChangeChecked",
					null,
				  ),
				  n.__decorate(
					[(0, i.watch)("nativeInput:change")],
					t.prototype,
					"onChangeNativeCheckBox",
					null,
				  ),
				  n.__decorate(
					[(0, i.watch)("state.switch"), (0, i.hook)("ready")],
					t.prototype,
					"onChangeSwitch",
					null,
				  ),
				  (o = n.__decorate([i.component], t))
				);
			  })(r.UIInput);
			t.UICheckbox = s;
		  },
		  41374: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIFileInput = void 0);
			var n = o(20255);
			o(18984);
			var r = o(30194),
			  i = o(11441),
			  a = o(96031),
			  s = (function (e) {
				function t(t, o) {
				  var i =
					e.call(this, t, n.__assign({ type: "file" }, o)) || this;
				  return (
					(i.state = n.__assign(
					  n.__assign({}, r.UIInput.defaultState),
					  { type: "file", onlyImages: !0 },
					)),
					i
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UIFileInput";
				  }),
				  (t.prototype.createContainer = function (e) {
					this.button = new a.UIButton(this.j, {
					  icon: { name: "plus" },
					});
					var t = this.button.container;
					this.nativeInput ||
					  (this.nativeInput = this.createNativeInput(e));
					var o = this.nativeInput;
					return (
					  o.classList.add(this.getFullElName("input")),
					  t.classList.add(this.componentName),
					  t.appendChild(o),
					  t
					);
				  }),
				  (t.prototype.createNativeInput = function (e) {
					return this.j.create.fromHTML(
					  '<input\n\t\t\ttype="file"\n\t\t\taccept="'.concat(
						e.onlyImages ? "image/*" : "*",
						'"\n\t\t\ttabindex="-1"\n\t\t\tdir="auto"\n\t\t\tmultiple=""\n\t\t/>',
					  ),
					);
				  }),
				  n.__decorate([i.component], t)
				);
			  })(r.UIInput);
			t.UIFileInput = s;
		  },
		  63034: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(30194), t),
			  n.__exportStar(o(21639), t),
			  n.__exportStar(o(63747), t),
			  n.__exportStar(o(75840), t),
			  n.__exportStar(o(41374), t);
		  },
		  30194: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIInput = void 0);
			var n = o(20255);
			o(4591);
			var r = o(53929),
			  i = o(76502),
			  a = o(1853),
			  s = o(24263),
			  l = o(43441),
			  c = o(77904),
			  u = o(60081),
			  d = (function (e) {
				function t(t, r) {
				  var i = e.call(this, t, r) || this;
				  return (
					(i.label = i.j.c.span(i.getFullElName("label"))),
					(i.icon = i.j.c.span(i.getFullElName("icon"))),
					(i.clearButton = i.j.c.span(
					  i.getFullElName("clear"),
					  c.Icon.get("cancel"),
					)),
					(i.state = n.__assign({}, o.defaultState)),
					(i.__errorBox = i.j.c.span(i.getFullElName("error"))),
					(i.validators = new Set([])),
					void 0 !== (null == r ? void 0 : r.value) &&
					  (r.value = r.value.toString()),
					Object.assign(i.state, r),
					void 0 !== i.state.clearButton &&
					  (i.j.e
						.on(i.clearButton, "click", function (e) {
						  e.preventDefault(),
							(i.nativeInput.value = ""),
							i.j.e.fire(i.nativeInput, "input"),
							i.focus();
						})
						.on(i.nativeInput, "input", function () {
						  i.state.clearButton = Boolean(i.value.length);
						}),
					  (i.state.clearButton = Boolean(i.value.length))),
					i.j.e
					  .on(i.nativeInput, "focus blur", function () {
						i.onChangeFocus();
					  })
					  .on(i.nativeInput, "input change", i.onChangeValue),
					i.onChangeState(),
					i.onChangeClassName(),
					i.onChangeStateValue(),
					i
				  );
				}
				var o;
				return (
				  n.__extends(t, e),
				  (o = t),
				  (t.prototype.className = function () {
					return "UIInput";
				  }),
				  (t.prototype.onChangeClear = function () {
					this.state.clearButton
					  ? s.Dom.after(this.nativeInput, this.clearButton)
					  : s.Dom.safeRemove(this.clearButton);
				  }),
				  (t.prototype.onChangeClassName = function (e, t) {
					t && this.container.classList.remove(t),
					  this.state.className &&
						this.container.classList.add(this.state.className);
				  }),
				  (t.prototype.onChangeState = function () {
					this.name = this.state.name;
					var e = this.nativeInput,
					  t = this.state,
					  o = t.name,
					  n = t.icon,
					  r = t.type,
					  a = t.ref,
					  l = t.required,
					  u = t.placeholder,
					  d = t.autocomplete,
					  p = t.label;
					(0, i.attr)(e, "name", o),
					  (0, i.attr)(e, "type", r),
					  (0, i.attr)(e, "data-ref", a || o),
					  (0, i.attr)(e, "ref", a || o),
					  (0, i.attr)(e, "required", l || null),
					  (0, i.attr)(e, "autocomplete", d ? null : "off"),
					  (0, i.attr)(e, "placeholder", u ? this.j.i18n(u) : ""),
					  n && c.Icon.exists(n)
						? (s.Dom.before(e, this.icon),
						  (this.icon.innerHTML = c.Icon.get(n)))
						: s.Dom.safeRemove(this.icon),
					  p
						? (s.Dom.before(this.wrapper, this.label),
						  (this.label.innerText = this.j.i18n(p)))
						: s.Dom.safeRemove(this.label),
					  this.updateValidators();
				  }),
				  (t.prototype.updateValidators = function () {
					var e,
					  t = this;
					this.validators.clear(),
					  this.state.required &&
						this.validators.add(u.inputValidators.required),
					  null === (e = this.state.validators) ||
						void 0 === e ||
						e.forEach(function (e) {
						  var o = u.inputValidators[e];
						  o && t.validators.add(o);
						});
				  }),
				  Object.defineProperty(t.prototype, "error", {
					set: function (e) {
					  this.setMod("has-error", Boolean(e)),
						e
						  ? ((this.__errorBox.innerText = this.j.i18n(
							  e,
							  this.j.i18n(this.state.label || ""),
							)),
							this.container.appendChild(this.__errorBox))
						  : s.Dom.safeRemove(this.__errorBox);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "value", {
					get: function () {
					  return this.nativeInput.value;
					},
					set: function (e) {
					  this.value !== e &&
						((this.nativeInput.value = e), this.onChangeValue());
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.onChangeStateValue = function () {
					var e = this.state.value.toString();
					e !== this.value && (this.value = e);
				  }),
				  (t.prototype.onChangeValue = function () {
					var e,
					  t,
					  o = this.value;
					this.state.value !== o &&
					  ((this.state.value = o),
					  this.j.e.fire(this, "change", o),
					  null === (t = (e = this.state).onChange) ||
						void 0 === t ||
						t.call(e, o));
				  }),
				  (t.prototype.validate = function () {
					var e = this;
					return (
					  (this.error = ""),
					  (0, a.toArray)(this.validators).every(function (t) {
						return t(e);
					  })
					);
				  }),
				  (t.prototype.createContainer = function (t) {
					var o = e.prototype.createContainer.call(this);
					(this.wrapper = this.j.c.div(this.getFullElName("wrapper"))),
					  this.nativeInput ||
						(this.nativeInput = this.createNativeInput());
					var n = this.nativeInput;
					return (
					  n.classList.add(this.getFullElName("input")),
					  this.wrapper.appendChild(n),
					  o.appendChild(this.wrapper),
					  (0, i.attr)(n, "dir", this.j.o.direction || "auto"),
					  o
					);
				  }),
				  (t.prototype.createNativeInput = function (e) {
					return this.j.create.element("input");
				  }),
				  (t.prototype.focus = function () {
					this.nativeInput.focus();
				  }),
				  Object.defineProperty(t.prototype, "isFocused", {
					get: function () {
					  return this.nativeInput === this.j.od.activeElement;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.onChangeFocus = function () {
					this.setMod("focused", this.isFocused);
				  }),
				  (t.defaultState = {
					className: "",
					autocomplete: !0,
					name: "",
					value: "",
					icon: "",
					label: "",
					ref: "",
					type: "text",
					placeholder: "",
					required: !1,
					validators: [],
				  }),
				  n.__decorate(
					[(0, l.watch)("state.clearButton")],
					t.prototype,
					"onChangeClear",
					null,
				  ),
				  n.__decorate(
					[(0, l.watch)("state.className")],
					t.prototype,
					"onChangeClassName",
					null,
				  ),
				  n.__decorate(
					[
					  (0, l.watch)([
						"state.name",
						"state.type",
						"state.label",
						"state.placeholder",
						"state.autocomplete",
						"state.icon",
					  ]),
					  (0, l.debounce)(),
					],
					t.prototype,
					"onChangeState",
					null,
				  ),
				  n.__decorate(
					[(0, l.watch)("state.value")],
					t.prototype,
					"onChangeStateValue",
					null,
				  ),
				  n.__decorate([l.autobind], t.prototype, "onChangeValue", null),
				  (o = n.__decorate([l.component], t))
				);
			  })(r.UIElement);
			t.UIInput = d;
		  },
		  75840: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UISelect = void 0);
			var n = o(20255);
			o(64194);
			var r = o(67309),
			  i = o(11441),
			  a = o(30194),
			  s = o(60081),
			  l = (function (e) {
				function t(t, r) {
				  var i = e.call(this, t, r) || this;
				  return (
					(i.state = n.__assign({}, o.defaultState)),
					Object.assign(i.state, r),
					i
				  );
				}
				var o;
				return (
				  n.__extends(t, e),
				  (o = t),
				  (t.prototype.className = function () {
					return "UISelect";
				  }),
				  (t.prototype.createContainer = function (t) {
					var o,
					  n = e.prototype.createContainer.call(this, t),
					  i = this.j,
					  a = this.nativeInput,
					  s = function () {
						return i.create.element("option");
					  };
					if (void 0 !== t.placeholder) {
					  var l = s();
					  (l.value = ""), (l.text = i.i18n(t.placeholder)), a.add(l);
					}
					return (
					  null === (o = t.options) ||
						void 0 === o ||
						o.forEach(function (e) {
						  var t = s();
						  (t.value = e.value.toString()),
							(t.text = i.i18n(e.text)),
							a.add(t);
						}),
					  t.size && t.size > 0 && (0, r.attr)(a, "size", t.size),
					  t.multiple && (0, r.attr)(a, "multiple", ""),
					  n
					);
				  }),
				  (t.prototype.createNativeInput = function () {
					return this.j.create.element("select");
				  }),
				  (t.prototype.updateValidators = function () {
					e.prototype.updateValidators.call(this),
					  this.state.required &&
						(this.validators.delete(s.inputValidators.required),
						this.validators.add(s.selectValidators.required));
				  }),
				  (t.defaultState = n.__assign(
					n.__assign({}, a.UIInput.defaultState),
					{ options: [], size: 1, multiple: !1 },
				  )),
				  (o = n.__decorate([i.component], t))
				);
			  })(a.UIInput);
			t.UISelect = l;
		  },
		  60081: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.selectValidators = t.inputValidators = void 0),
			  (t.inputValidators = o(63355)),
			  (t.selectValidators = o(65935));
		  },
		  63355: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.url = t.required = void 0);
			var n = o(64350),
			  r = o(33941);
			(t.required = function (e) {
			  return (
				!!(0, r.trim)(e.value).length ||
				((e.error = "Please fill out this field"), !1)
			  );
			}),
			  (t.url = function (e) {
				return (
				  !!(0, n.isURL)((0, r.trim)(e.value)) ||
				  ((e.error = "Please enter a web address"), !1)
				);
			  });
		  },
		  65935: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.required = void 0);
			var n = o(33941);
			t.required = function (e) {
			  return (
				!!(0, n.trim)(e.value).length ||
				((e.error = "Please fill out this field"), !1)
			  );
			};
		  },
		  61479: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIGroup = void 0);
			var n = o(20255);
			o(70375);
			var r = o(53929),
			  i = o(43441),
			  a = o(40332),
			  s = (o(52378), o(24263)),
			  l = o(45113),
			  c = (function (e) {
				function t(t, o, n) {
				  var r = e.call(this, t, n) || this;
				  return (
					(r.options = n),
					(r.syncMod = !1),
					(r.elements = []),
					(r.buttonSize = "middle"),
					null == o ||
					  o.forEach(function (e) {
						return e && r.append(e);
					  }),
					(null == n ? void 0 : n.name) && (r.name = n.name),
					r
				  );
				}
				var o;
				return (
				  n.__extends(t, e),
				  (o = t),
				  (t.prototype.className = function () {
					return "UIGroup";
				  }),
				  Object.defineProperty(t.prototype, "allChildren", {
					get: function () {
					  for (
						var e = [],
						  t = n.__spreadArray([], n.__read(this.elements), !1);
						t.length;
  
					  ) {
						var r = t.shift();
						(0, a.isArray)(r)
						  ? t.push.apply(t, n.__spreadArray([], n.__read(r), !1))
						  : l.Component.isInstanceOf(r, o)
							? t.push.apply(
								t,
								n.__spreadArray([], n.__read(r.elements), !1),
							  )
							: r && e.push(r);
					  }
					  return e;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.update = function () {
					this.elements.forEach(function (e) {
					  return e.update();
					}),
					  this.setMod("size", this.buttonSize);
				  }),
				  (t.prototype.append = function (e, t) {
					var o = this;
					return (0, a.isArray)(e)
					  ? (e.forEach(function (e) {
						  return o.append(e, t);
						}),
						this)
					  : (this.elements.push(e),
						e.name &&
						  e.container.classList.add(this.getFullElName(e.name)),
						t
						  ? this.getElm(t).appendChild(e.container)
						  : this.appendChildToContainer(e.container),
						(e.parentElement = this),
						e.update(),
						this);
				  }),
				  (t.prototype.afterSetMod = function (e, t) {
					this.syncMod &&
					  this.elements.forEach(function (o) {
						return o.setMod(e, t);
					  });
				  }),
				  (t.prototype.appendChildToContainer = function (e) {
					this.container.appendChild(e);
				  }),
				  (t.prototype.remove = function (e) {
					var t = this.elements.indexOf(e);
					return (
					  -1 !== t &&
						(this.elements.splice(t, 1),
						s.Dom.safeRemove(e.container),
						(e.parentElement = null)),
					  this
					);
				  }),
				  (t.prototype.clear = function () {
					return (
					  this.elements.forEach(function (e) {
						return e.destruct();
					  }),
					  (this.elements.length = 0),
					  this
					);
				  }),
				  (t.prototype.destruct = function () {
					return this.clear(), e.prototype.destruct.call(this);
				  }),
				  n.__decorate(
					[(0, i.watch)("buttonSize")],
					t.prototype,
					"update",
					null,
				  ),
				  (o = n.__decorate([i.component], t))
				);
			  })(r.UIElement);
			t.UIGroup = c;
		  },
		  3249: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(61479), t),
			  n.__exportStar(o(47970), t),
			  n.__exportStar(o(75018), t),
			  n.__exportStar(o(58495), t);
		  },
		  47970: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIList = void 0);
			var n = o(20255);
			o(90235);
			var r = o(32070),
			  i = o(43441),
			  a = o(61479),
			  s = o(75018),
			  l = o(58495),
			  c = o(96031),
			  u = o(97642),
			  d = o(38546),
			  p = o(14556),
			  f = o(45113),
			  h = (function (e) {
				function t(t) {
				  var o = e.call(this, t) || this;
				  return (
					(o.mode = "horizontal"),
					(o.removeButtons = []),
					o.onChangeMode(),
					o
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UIList";
				  }),
				  (t.prototype.onChangeMode = function () {
					this.setMod("mode", this.mode);
				  }),
				  (t.prototype.makeGroup = function () {
					return new a.UIGroup(this.jodit);
				  }),
				  Object.defineProperty(t.prototype, "buttons", {
					get: function () {
					  return this.allChildren.filter(function (e) {
						return f.Component.isInstanceOf(e, c.UIButton);
					  });
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.getButtonsNames = function () {
					return this.buttons
					  .map(function (e) {
						return (e instanceof c.UIButton && e.state.name) || "";
					  })
					  .filter(function (e) {
						return "" !== e;
					  });
				  }),
				  (t.prototype.setRemoveButtons = function (e) {
					return (this.removeButtons = e || []), this;
				  }),
				  (t.prototype.build = function (e, t) {
					var o = this;
					void 0 === t && (t = null),
					  (e = (0, p.splitArray)(e)),
					  this.clear();
					var n,
					  i = !1,
					  a = this.makeGroup();
					this.append(a), a.setMod("line", !0);
					var c = function (e) {
						var r = null;
						switch (e.name) {
						  case "\n":
							(a = o.makeGroup()).setMod("line", !0),
							  (n = o.makeGroup()),
							  a.append(n),
							  o.append(a);
							break;
						  case "|":
							i || ((i = !0), (r = new s.UISeparator(o.j)));
							break;
						  case "---":
							n.setMod("before-spacer", !0);
							var c = new l.UISpacer(o.j);
							a.append(c),
							  (n = o.makeGroup()),
							  a.append(n),
							  (i = !1);
							break;
						  default:
							(i = !1), (r = o.makeButton(e, t));
						}
						r &&
						  (n || ((n = o.makeGroup()), a.append(n)), n.append(r));
					  },
					  f = function (e) {
						return !o.removeButtons.includes(e.name);
					  };
					return (
					  e.forEach(function (e) {
						if ((0, u.isButtonGroup)(e)) {
						  var t = e.buttons.filter(function (e) {
							return e;
						  });
						  t.length &&
							((n = o.makeGroup())
							  .setMod("separated", !0)
							  .setMod("group", e.group),
							a.append(n),
							(0, r.getStrongControlTypes)(t, o.j.o.controls)
							  .filter(f)
							  .forEach(c));
						} else {
						  n || ((n = o.makeGroup()), a.append(n));
						  var i = (0, d.getControlType)(e, o.j.o.controls);
						  f(i) && c(i);
						}
					  }),
					  this.update(),
					  this
					);
				  }),
				  (t.prototype.makeButton = function (e, t) {
					return new c.UIButton(this.j);
				  }),
				  n.__decorate(
					[(0, i.watch)("mode")],
					t.prototype,
					"onChangeMode",
					null,
				  ),
				  n.__decorate([i.component], t)
				);
			  })(a.UIGroup);
			t.UIList = h;
		  },
		  75018: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UISeparator = void 0);
			var n = o(20255),
			  r = o(53929),
			  i = o(11441),
			  a = (function (e) {
				function t() {
				  return (null !== e && e.apply(this, arguments)) || this;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UISeparator";
				  }),
				  n.__decorate([i.component], t)
				);
			  })(r.UIElement);
			t.UISeparator = a;
		  },
		  58495: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UISpacer = void 0);
			var n = o(20255),
			  r = o(53929),
			  i = o(11441),
			  a = (function (e) {
				function t() {
				  return (null !== e && e.apply(this, arguments)) || this;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UISpacer";
				  }),
				  n.__decorate([i.component], t)
				);
			  })(r.UIElement);
			t.UISpacer = a;
		  },
		  97642: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.flatButtonsSet = t.isButtonGroup = void 0);
			var n = o(20255),
			  r = o(49781);
			(t.isButtonGroup = function (e) {
			  return (0, r.isArray)(e.buttons);
			}),
			  (t.flatButtonsSet = function (e, o) {
				var r = o.getRegisteredButtonGroups();
				return new Set(
				  e.reduce(function (e, o) {
					var i;
					return (
					  (0, t.isButtonGroup)(o)
						? (e = e.concat(
							n.__spreadArray(
							  n.__spreadArray([], n.__read(o.buttons), !1),
							  n.__read(
								null !== (i = r[o.group]) && void 0 !== i
								  ? i
								  : [],
							  ),
							  !1,
							),
						  ))
						: e.push(o),
					  e
					);
				  }, []),
				);
			  });
		  },
		  38546: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.findControlType = t.getControlType = void 0);
			var n = o(20255),
			  r = o(40332),
			  i = o(93166);
			function a(e, t) {
			  var o = n.__read(e.split(/\./), 2),
				i = o[0],
				a = o[1],
				s = t;
			  return (
				null != a ? void 0 !== t[i] && (s = t[i]) : (a = i),
				s[a]
				  ? n.__assign({ name: a }, (0, r.ConfigFlatten)(s[a]))
				  : void 0
			  );
			}
			(t.getControlType = function (e, t) {
			  var o;
			  return (
				t || (t = i.Config.defaultOptions.controls),
				(0, r.isString)(e)
				  ? (o = a(e, t) || { name: e, command: e, tooltip: e })
				  : void 0 !==
					  t[
						(o = n.__assign(
						  { name: "empty" },
						  (0, r.ConfigFlatten)(e),
						)).name
					  ] &&
					(o = n.__assign(
					  n.__assign({}, (0, r.ConfigFlatten)(t[o.name])),
					  (0, r.ConfigFlatten)(o),
					)),
				o
			  );
			}),
			  (t.findControlType = a);
		  },
		  32070: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getStrongControlTypes = void 0);
			var n = o(38546),
			  r = o(93166),
			  i = o(49781),
			  a = o(76502);
			t.getStrongControlTypes = function (e, t) {
			  return (
				(0, i.isArray)(e)
				  ? e
				  : (0, a.keys)(e, !1).map(function (t) {
					  return (0, a.ConfigProto)({ name: t }, e[t] || {});
					})
			  ).map(function (e) {
				return (0, n.getControlType)(
				  e,
				  t || r.Config.defaultOptions.controls,
				);
			  });
			};
		  },
		  77904: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Icon = void 0);
			var n = o(26911),
			  r = o(40332),
			  i = (function () {
				function e() {}
				return (
				  (e.getIcon = function (t) {
					return /<svg/i.test(t)
					  ? t
					  : e.icons[t] ||
						  e.icons[t.replace(/-/g, "_")] ||
						  e.icons[t.replace(/_/g, "-")] ||
						  e.icons[(0, r.camelCase)(t)] ||
						  e.icons[(0, r.kebabCase)(t)] ||
						  e.icons[t.toLowerCase()];
				  }),
				  (e.exists = function (e) {
					return void 0 !== this.getIcon(e);
				  }),
				  (e.get = function (e, t) {
					return (
					  void 0 === t && (t = "<span></span>"), this.getIcon(e) || t
					);
				  }),
				  (e.set = function (e, t) {
					return (this.icons[e.replace("_", "-")] = t), this;
				  }),
				  (e.makeIcon = function (t, o) {
					var r, i;
					if (o) {
					  var a = o.name.replace(/[^a-zA-Z0-9]/g, "_");
					  if (o.iconURL)
						(i = t.c.span()),
						  (0, n.css)(
							i,
							"backgroundImage",
							"url(" +
							  o.iconURL.replace(
								"{basePath}",
								(null == t ? void 0 : t.basePath) || "",
							  ) +
							  ")",
						  );
					  else {
						var s =
						  t.e.fire("getIcon", o.name, o, a) ||
						  e.get(o.name, "") ||
						  (null === (r = t.o.extraIcons) || void 0 === r
							? void 0
							: r[o.name]);
						s &&
						  ((i = t.c.fromHTML(s.trim())),
						  /^<svg/i.test(o.name) ||
							i.classList.add("jodit-icon_" + a));
					  }
					}
					return (
					  i &&
						(i.classList.add("jodit-icon"), (i.style.fill = o.fill)),
					  i
					);
				  }),
				  (e.icons = {}),
				  e
				);
			  })();
			t.Icon = i;
		  },
		  2074: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(53929), t),
			  n.__exportStar(o(96516), t),
			  n.__exportStar(o(35799), t),
			  n.__exportStar(o(3249), t),
			  n.__exportStar(o(95963), t),
			  n.__exportStar(o(77904), t),
			  n.__exportStar(o(63682), t);
		  },
		  35799: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(12680), t);
		  },
		  12680: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Popup = void 0);
			var n = o(20255);
			o(88477);
			var r = o(24263),
			  i = o(40332),
			  a = (o(52378), o(53929)),
			  s = o(43441),
			  l = o(45113),
			  c = o(17332),
			  u = (function (e) {
				function t(t, o) {
				  void 0 === o && (o = !0);
				  var n = e.call(this, t) || this;
				  return (
					(n.smart = o),
					(n.isOpened = !1),
					(n.strategy = "leftBottom"),
					(n.viewBound = function () {
					  return {
						left: 0,
						top: 0,
						width: n.ow.innerWidth,
						height: n.ow.innerHeight,
					  };
					}),
					(n.childrenPopups = new Set()),
					(0, i.attr)(n.container, "role", "popup"),
					n
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "Popup";
				  }),
				  (t.prototype.updateParentElement = function (o) {
					var n = this;
					return (
					  o !== this &&
						l.Component.isInstanceOf(o, t) &&
						(this.childrenPopups.forEach(function (e) {
						  !o.closest(e) && e.isOpened && e.close();
						}),
						this.childrenPopups.has(o) ||
						  this.j.e.on(o, "beforeClose", function () {
							n.childrenPopups.delete(o);
						  }),
						this.childrenPopups.add(o)),
					  e.prototype.updateParentElement.call(this, o)
					);
				  }),
				  (t.prototype.setContent = function (e) {
					r.Dom.detach(this.container);
					var t,
					  o = this.j.c.div(
						"".concat(this.componentName, "__content"),
					  );
					return (
					  l.Component.isInstanceOf(e, a.UIElement)
						? ((t = e.container), (e.parentElement = this))
						: (t = (0, i.isString)(e) ? this.j.c.fromHTML(e) : e),
					  o.appendChild(t),
					  this.container.appendChild(o),
					  this.updatePosition(),
					  this
					);
				  }),
				  (t.prototype.open = function (e, o, n) {
					if (
					  (void 0 === o && (o = !1),
					  (0, i.markOwner)(this.jodit, this.container),
					  this.calculateZIndex(),
					  (this.isOpened = !0),
					  this.addGlobalListeners(),
					  (this.targetBound = o ? this.getKeepBound(e) : e),
					  n)
					)
					  n.appendChild(this.container);
					else {
					  var r = (0, c.getContainer)(this.jodit, t);
					  n !== this.container.parentElement &&
						r.appendChild(this.container);
					}
					return (
					  this.updatePosition(),
					  this.j.e.fire(this, "afterOpen"),
					  this
					);
				  }),
				  (t.prototype.calculateZIndex = function () {
					var e = this;
					if (!this.container.style.zIndex) {
					  var t = function (t) {
						  var o = t.container.style.zIndex || t.o.zIndex;
						  return (
							!!o &&
							(e.setZIndex(1 + parseInt(o.toString(), 10)), !0)
						  );
						},
						o = this.j;
					  if (!t(o))
						for (var n = this.parentElement; n; ) {
						  if (t(o)) return;
						  if (n.container.style.zIndex)
							return void this.setZIndex(
							  1 +
								parseInt(n.container.style.zIndex.toString(), 10),
							);
						  if (!n.parentElement && n.container.parentElement) {
							var r = a.UIElement.closestElement(
							  n.container.parentElement,
							  a.UIElement,
							);
							if (r) {
							  n = r;
							  continue;
							}
						  }
						  n = n.parentElement;
						}
					}
				  }),
				  (t.prototype.getKeepBound = function (e) {
					var t = this,
					  o = e(),
					  a = this.od.elementFromPoint(o.left, o.top);
					if (!a) return e;
					var s = r.Dom.isHTMLElement(a) ? a : a.parentElement,
					  l = (0, i.position)(s, this.j);
					return function () {
					  var o = e(),
						r = (0, i.position)(s, t.j);
					  return n.__assign(n.__assign({}, o), {
						top: o.top + (r.top - l.top),
						left: o.left + (r.left - l.left),
					  });
					};
				  }),
				  (t.prototype.updatePosition = function () {
					if (!this.isOpened) return this;
					var e = n.__read(
						this.calculatePosition(
						  this.targetBound(),
						  this.viewBound(),
						  (0, i.position)(this.container, this.j),
						),
						2,
					  ),
					  t = e[0];
					return (
					  this.setMod("strategy", e[1]),
					  (0, i.css)(this.container, { left: t.left, top: t.top }),
					  this.childrenPopups.forEach(function (e) {
						return e.updatePosition();
					  }),
					  this
					);
				  }),
				  (t.prototype.throttleUpdatePosition = function () {
					this.updatePosition();
				  }),
				  (t.prototype.calculatePosition = function (e, o, r, a) {
					void 0 === a && (a = this.strategy);
					var s = { left: e.left, right: e.left - (r.width - e.width) },
					  l = { bottom: e.top + e.height, top: e.top - r.height },
					  c = Object.keys(s).reduce(function (e, t) {
						return e.concat(
						  Object.keys(l).map(function (e) {
							return "".concat(t).concat((0, i.ucfirst)(e));
						  }),
						);
					  }, []),
					  u = function (e) {
						var t = n.__read((0, i.kebabCase)(e).split("-"), 2);
						return {
						  left: s[t[0]],
						  top: l[t[1]],
						  width: r.width,
						  height: r.height,
						};
					  },
					  d = function (e) {
						return t.boxInView(u(a), e)
						  ? a
						  : c.find(function (o) {
							  if (t.boxInView(u(o), e)) return o;
							}) || null;
					  },
					  p = d((0, i.position)(this.j.container, this.j));
					return (
					  (p && t.boxInView(u(p), o)) || (p = d(o) || p || a),
					  [u(p), p]
					);
				  }),
				  (t.boxInView = function (e, t) {
					return !(
					  -2 > e.top - t.top ||
					  -2 > e.left - t.left ||
					  -2 > t.top + t.height - (e.top + e.height) ||
					  -2 > t.left + t.width - (e.left + e.width)
					);
				  }),
				  (t.prototype.close = function () {
					return this.isOpened
					  ? ((this.isOpened = !1),
						this.childrenPopups.forEach(function (e) {
						  return e.close();
						}),
						this.j.e.fire(this, "beforeClose"),
						this.j.e.fire("beforePopupClose", this),
						this.removeGlobalListeners(),
						r.Dom.safeRemove(this.container),
						this)
					  : this;
				  }),
				  (t.prototype.closeOnOutsideClick = function (e) {
					this.isOpened && !this.isOwnClick(e) && this.close();
				  }),
				  (t.prototype.isOwnClick = function (e) {
					if (!e.target) return !1;
					var o = a.UIElement.closestElement(e.target, t);
					return Boolean(o && (this === o || o.closest(this)));
				  }),
				  (t.prototype.addGlobalListeners = function () {
					var e = this,
					  t = this.throttleUpdatePosition,
					  o = this.ow;
					c.eventEmitter.on("closeAllPopups", this.close),
					  this.smart &&
						this.j.e
						  .on("escape", this.close)
						  .on("mousedown touchstart", this.closeOnOutsideClick)
						  .on(
							o,
							"mousedown touchstart",
							this.closeOnOutsideClick,
						  ),
					  this.j.e
						.on("closeAllPopups", this.close)
						.on("resize", t)
						.on(this.container, "scroll mousewheel", t)
						.on(o, "scroll", t)
						.on(o, "resize", t),
					  r.Dom.up(this.j.container, function (o) {
						o && e.j.e.on(o, "scroll mousewheel", t);
					  });
				  }),
				  (t.prototype.removeGlobalListeners = function () {
					var e = this,
					  t = this.throttleUpdatePosition,
					  o = this.ow;
					c.eventEmitter.off("closeAllPopups", this.close),
					  this.smart &&
						this.j.e
						  .off("escape", this.close)
						  .off("mousedown touchstart", this.closeOnOutsideClick)
						  .off(
							o,
							"mousedown touchstart",
							this.closeOnOutsideClick,
						  ),
					  this.j.e
						.off("closeAllPopups", this.close)
						.off("resize", t)
						.off(this.container, "scroll mousewheel", t)
						.off(o, "scroll", t)
						.off(o, "resize", t),
					  r.Dom.up(this.j.container, function (o) {
						o && e.j.e.off(o, "scroll mousewheel", t);
					  });
				  }),
				  (t.prototype.setZIndex = function (e) {
					this.container.style.zIndex = e.toString();
				  }),
				  (t.prototype.destruct = function () {
					return this.close(), e.prototype.destruct.call(this);
				  }),
				  n.__decorate([s.autobind], t.prototype, "updatePosition", null),
				  n.__decorate(
					[(0, s.throttle)(10), s.autobind],
					t.prototype,
					"throttleUpdatePosition",
					null,
				  ),
				  n.__decorate([s.autobind], t.prototype, "close", null),
				  n.__decorate(
					[s.autobind],
					t.prototype,
					"closeOnOutsideClick",
					null,
				  ),
				  t
				);
			  })(a.UIElement);
			t.Popup = u;
		  },
		  63682: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ProgressBar = void 0);
			var n = o(20255);
			o(50197);
			var r = o(24263),
			  i = (function (e) {
				function t() {
				  return (null !== e && e.apply(this, arguments)) || this;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "ProgressBar";
				  }),
				  (t.prototype.render = function () {
					return "<div><div></div></div>";
				  }),
				  (t.prototype.show = function () {
					return (
					  (this.j.workplace || this.j.container).appendChild(
						this.container,
					  ),
					  this
					);
				  }),
				  (t.prototype.hide = function () {
					return r.Dom.safeRemove(this.container), this;
				  }),
				  (t.prototype.progress = function (e) {
					return (
					  (this.container.style.width = e.toFixed(2) + "%"), this
					);
				  }),
				  (t.prototype.destruct = function () {
					return this.hide(), e.prototype.destruct.call(this);
				  }),
				  t
				);
			  })(o(53929).UIElement);
			t.ProgressBar = i;
		  },
		  43608: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ViewWithToolbar = void 0);
			var n = o(20255);
			o(39008);
			var r = o(75902),
			  i = o(40332),
			  a = o(64968),
			  s = o(81438),
			  l = o(56562),
			  c = o(97642),
			  u = o(43441),
			  d = (function (e) {
				function t(t, o) {
				  void 0 === o && (o = !1);
				  var n = e.call(this, t, o) || this;
				  return (
					(n.toolbar = (0, s.makeCollection)(n)),
					(n.defaultToolbarContainer = n.c.div("jodit-toolbar__box")),
					(n.registeredButtons = new Set()),
					(n.groupToButtons = {}),
					(n.isJodit = !1),
					(n.isJodit = o),
					n.e.on("beforeToolbarBuild", n.beforeToolbarBuild),
					n
				  );
				}
				return (
				  n.__extends(t, e),
				  Object.defineProperty(t.prototype, "toolbarContainer", {
					get: function () {
					  return this.o.fullsize ||
						(!(0, i.isString)(this.o.toolbar) &&
						  !a.Dom.isHTMLElement(this.o.toolbar))
						? (this.o.toolbar &&
							a.Dom.appendChildFirst(
							  this.container,
							  this.defaultToolbarContainer,
							),
						  this.defaultToolbarContainer)
						: (0, i.resolveElement)(
							this.o.toolbar,
							this.o.shadowRoot || this.od,
						  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.setPanel = function (e) {
					(this.o.toolbar = e), this.buildToolbar();
				  }),
				  (t.prototype.buildToolbar = function () {
					if (this.o.toolbar) {
					  var e = this.o.buttons
						? (0, i.splitArray)(this.o.buttons)
						: [];
					  this.toolbar
						.setRemoveButtons(this.o.removeButtons)
						.build(e.concat(this.o.extraButtons || []))
						.appendTo(this.toolbarContainer);
					}
				  }),
				  (t.prototype.getRegisteredButtonGroups = function () {
					return this.groupToButtons;
				  }),
				  (t.prototype.registerButton = function (e) {
					var t;
					this.registeredButtons.add(e);
					var o = null !== (t = e.group) && void 0 !== t ? t : "other";
					return (
					  this.groupToButtons[o] || (this.groupToButtons[o] = []),
					  null != e.position
						? (this.groupToButtons[o][e.position] = e.name)
						: this.groupToButtons[o].push(e.name),
					  this
					);
				  }),
				  (t.prototype.unregisterButton = function (e) {
					var t;
					this.registeredButtons.delete(e);
					var o = null !== (t = e.group) && void 0 !== t ? t : "other",
					  n = this.groupToButtons[o];
					if (n) {
					  var r = n.indexOf(e.name);
					  -1 !== r && n.splice(r, 1),
						0 === n.length && delete this.groupToButtons[o];
					}
					return this;
				  }),
				  (t.prototype.beforeToolbarBuild = function (e) {
					var t = this;
					if (Object.keys(this.groupToButtons).length)
					  return e.map(function (e) {
						return (0, c.isButtonGroup)(e) &&
						  e.group &&
						  t.groupToButtons[e.group]
						  ? {
							  group: e.group,
							  buttons: n.__spreadArray(
								n.__spreadArray([], n.__read(e.buttons), !1),
								n.__read(t.groupToButtons[e.group]),
								!1,
							  ),
							}
						  : e;
					  });
				  }),
				  (t.prototype.destruct = function () {
					this.isDestructed ||
					  (this.setStatus(l.STATUSES.beforeDestruct),
					  this.e.off("beforeToolbarBuild", this.beforeToolbarBuild),
					  this.toolbar.destruct(),
					  e.prototype.destruct.call(this));
				  }),
				  n.__decorate(
					[u.autobind],
					t.prototype,
					"beforeToolbarBuild",
					null,
				  ),
				  t
				);
			  })(r.View);
			t.ViewWithToolbar = d;
		  },
		  75902: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.View = void 0);
			var n = o(20255),
			  r = o(77462),
			  i = o(40332),
			  a = o(86893),
			  s = o(87837),
			  l = o(17332),
			  c = o(43441),
			  u = o(59829),
			  d = o(55395),
			  p = o(71014),
			  f = (function (e) {
				function t(t, n) {
				  void 0 === n && (n = !1);
				  var i = e.call(this) || this;
				  return (
					(i.isJodit = n),
					(i.isView = !0),
					(i.parent = null),
					(i.mods = {}),
					(i.components = new Set()),
					(i.version = "3.24.9"),
					(i.buffer = r.Storage.makeStorage()),
					(i.storage = r.Storage.makeStorage(!0, i.componentName)),
					(i.OPTIONS = o.defaultOptions),
					(i.__isFullSize = !1),
					(i.__whoLocked = ""),
					(i.isLockedNotBy = function (e) {
					  return i.isLocked && i.__whoLocked !== e;
					}),
					(i.__modulesInstances = new Map()),
					(i.id = new Date().getTime().toString()),
					(i.buffer = r.Storage.makeStorage()),
					i.initOptions(t),
					i.initOwners(),
					(i.events = new d.EventEmitter(i.od)),
					(i.create = new s.Create(i.od)),
					(i.container = i.c.div("jodit ".concat(i.componentName))),
					(i.progressbar = new s.ProgressBar(i)),
					(i.message = new p.UIMessages(i, i.container)),
					i
				  );
				}
				var o;
				return (
				  n.__extends(t, e),
				  (o = t),
				  Object.defineProperty(t.prototype, "basePath", {
					get: function () {
					  return this.o.basePath ? this.o.basePath : a.BASE_PATH;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "defaultTimeout", {
					get: function () {
					  return (0, i.isVoid)(this.o.defaultTimeout)
						? 100
						: this.o.defaultTimeout;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "c", {
					get: function () {
					  return this.create;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "container", {
					get: function () {
					  return this.__container;
					},
					set: function (e) {
					  this.__container = e;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "e", {
					get: function () {
					  return this.events;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "options", {
					get: function () {
					  return this.__options;
					},
					set: function (e) {
					  this.__options = e;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "o", {
					get: function () {
					  return this.options;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.i18n = function (e) {
					for (var t = [], o = 1; arguments.length > o; o++)
					  t[o - 1] = arguments[o];
					return (0, i.i18n)(e, t, this.options);
				  }),
				  (t.prototype.toggleFullSize = function (e) {
					void 0 === e && (e = !this.__isFullSize),
					  e !== this.__isFullSize &&
						((this.__isFullSize = e),
						this.e.fire("toggleFullSize", e));
				  }),
				  Object.defineProperty(t.prototype, "isLocked", {
					get: function () {
					  return "" !== this.__whoLocked;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.lock = function (e) {
					return (
					  void 0 === e && (e = "any"),
					  !this.isLocked && ((this.__whoLocked = e), !0)
					);
				  }),
				  (t.prototype.unlock = function () {
					return !!this.isLocked && ((this.__whoLocked = ""), !0);
				  }),
				  Object.defineProperty(t.prototype, "isFullSize", {
					get: function () {
					  return this.__isFullSize;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.getVersion = function () {
					return "3.24.9";
				  }),
				  (t.getVersion = function () {
					return "3.24.9";
				  }),
				  (t.prototype.initOptions = function (e) {
					this.options = (0, i.ConfigProto)(
					  e || {},
					  (0, i.ConfigProto)(this.options || {}, o.defaultOptions),
					);
				  }),
				  (t.prototype.initOwners = function () {
					var e;
					this.ownerWindow =
					  null !== (e = this.o.ownerWindow) && void 0 !== e
						? e
						: window;
				  }),
				  (t.prototype.attachEvents = function (e) {
					var t = this;
					if (e) {
					  var o = null == e ? void 0 : e.events;
					  o &&
						Object.keys(o).forEach(function (e) {
						  return t.e.on(e, o[e]);
						});
					}
				  }),
				  (t.prototype.getInstance = function (e, t) {
					var o = this.e.fire((0, i.camelCase)("getInstance_" + e), t);
					if (o) return o;
					var n = l.modules[e],
					  r = this.__modulesInstances;
					if (!(0, i.isFunction)(n))
					  throw (0, i.error)("Need real module name");
					if (!r.has(e)) {
					  var a =
						n.prototype instanceof s.ViewComponent
						  ? new n(this, t)
						  : new n(t);
					  this.components.add(a), r.set(e, a);
					}
					return r.get(e);
				  }),
				  (t.prototype.addDisclaimer = function (e) {
					this.container.appendChild(e);
				  }),
				  (t.prototype.beforeDestruct = function () {
					this.e.fire(s.STATUSES.beforeDestruct, this),
					  this.components.forEach(function (e) {
						(0, i.isDestructable)(e) &&
						  !e.isInDestruct &&
						  e.destruct();
					  }),
					  this.components.clear();
				  }),
				  (t.prototype.destruct = function () {
					this.isDestructed ||
					  (this.progressbar.destruct(),
					  this.message.destruct(),
					  this.async && this.async.destruct(),
					  this.events && this.e.destruct(),
					  this.buffer && this.buffer.clear(),
					  s.Dom.safeRemove(this.container),
					  e.prototype.destruct.call(this));
				  }),
				  (t.esNext = !1),
				  n.__decorate(
					[(0, c.hook)(s.STATUSES.beforeDestruct)],
					t.prototype,
					"beforeDestruct",
					null,
				  ),
				  (o = n.__decorate([(0, c.derive)(u.Mods, u.Elms)], t))
				);
			  })(s.Component);
			(t.View = f),
			  (f.defaultOptions = {
				extraButtons: [],
				textIcons: !1,
				namespace: "",
				removeButtons: [],
				zIndex: 100002,
				defaultTimeout: 100,
				fullsize: !1,
				showTooltip: !0,
				useNativeTooltip: !1,
				buttons: [],
				globalFullSize: !0,
				language: "auto",
			  });
		  },
		  37920: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Jodit = void 0);
			var n = o(20255),
			  r = o(93166),
			  i = o(86893),
			  a = o(87837),
			  s = o(40332),
			  l = o(77462),
			  c = o(86893),
			  u = o(17332),
			  d = o(43441),
			  p = o(59829),
			  f = o(30056),
			  h = "data-jodit-default-style-display",
			  m = "data-jodit-default-classes",
			  Jodit = (function (e) {
				function Jodit(o, n) {
				  var r = e.call(this, n, !0) || this;
				  (r.isJodit = !0),
					(r.commands = new Map()),
					(r.__selectionLocked = null),
					(r.__wasReadOnly = !1),
					(r.createInside = new a.Create(function () {
					  return r.ed;
					}, r.o.createAttributes)),
					(r.editorIsActive = !1),
					(r.__mode = i.MODE_WYSIWYG),
					(r.__callChangeCount = 0),
					(r.__isSilentChange = !1),
					(r.__elementToPlace = new Map());
				  try {
					var c = (0, s.resolveElement)(o, r.o.shadowRoot || r.od);
					if (t.isJoditAssigned(c)) return c.component;
				  } catch (e) {
					throw (r.destruct(), e);
				  }
				  r.setStatus(a.STATUSES.beforeInit),
					(r.id =
					  (0, s.attr)(
						(0, s.resolveElement)(o, r.o.shadowRoot || r.od),
						"id",
					  ) || new Date().getTime().toString()),
					(u.instances[r.id] = r),
					(r.storage = l.Storage.makeStorage(!0, r.id)),
					r.attachEvents(n),
					r.e.on(r.ow, "resize", function () {
					  r.e && r.e.fire("resize");
					}),
					r.e.on("prepareWYSIWYGEditor", r.__prepareWYSIWYGEditor),
					(r.selection = new a.Select(r));
				  var d = r.beforeInitHook();
				  return (
					(0, s.callPromise)(d, function () {
					  r.e.fire("beforeInit", r),
						u.pluginSystem.__init(r),
						r.e.fire("afterPluginSystemInit", r),
						r.e.on("changePlace", function () {
						  r.setReadOnly(r.o.readonly),
							r.setDisabled(r.o.disabled);
						}),
						(r.places.length = 0);
					  var e = r.addPlace(o, n);
					  (u.instances[r.id] = r),
						(0, s.callPromise)(e, function () {
						  r.e && r.e.fire("afterInit", r),
							r.afterInitHook(),
							r.setStatus(a.STATUSES.ready),
							r.e.fire("afterConstructor", r);
						});
					}),
					r
				  );
				}
				var t;
				return (
				  n.__extends(Jodit, e),
				  (t = Jodit),
				  (Jodit.prototype.className = function () {
					return "Jodit";
				  }),
				  (Jodit.prototype.waitForReady = function () {
					var e = this;
					return this.isReady
					  ? Promise.resolve(this)
					  : this.async.promise(function (t) {
						  e.hookStatus("ready", function () {
							return t(e);
						  });
						});
				  }),
				  Object.defineProperty(Jodit, "ready", {
					get: function () {
					  return new Promise(function (e) {
						u.eventEmitter.on("oditready", e);
					  });
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "text", {
					get: function () {
					  if (this.editor) return this.editor.innerText || "";
					  var e = this.createInside.div();
					  return (
						(e.innerHTML = this.getElementValue()), e.innerText || ""
					  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "defaultTimeout", {
					get: function () {
					  return (0, s.isNumber)(this.o.defaultTimeout)
						? this.o.defaultTimeout
						: r.Config.defaultOptions.defaultTimeout;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (Jodit.atom = function (e) {
					return (0, s.markAsAtomic)(e);
				  }),
				  (Jodit.make = function (e, t) {
					return new this(e, t);
				  }),
				  (Jodit.isJoditAssigned = function (e) {
					return (
					  e &&
					  (0, s.isJoditObject)(e.component) &&
					  !e.component.isInDestruct
					);
				  }),
				  Object.defineProperty(Jodit, "defaultOptions", {
					get: function () {
					  return r.Config.defaultOptions;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (Jodit.prototype.__setPlaceField = function (e, t) {
					this.currentPlace ||
					  ((this.currentPlace = {}),
					  (this.places = [this.currentPlace])),
					  (this.currentPlace[e] = t);
				  }),
				  Object.defineProperty(Jodit.prototype, "element", {
					get: function () {
					  return this.currentPlace.element;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "editor", {
					get: function () {
					  return this.currentPlace.editor;
					},
					set: function (e) {
					  this.__setPlaceField("editor", e);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "container", {
					get: function () {
					  return this.currentPlace.container;
					},
					set: function (e) {
					  this.__setPlaceField("container", e);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "workplace", {
					get: function () {
					  return this.currentPlace.workplace;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "statusbar", {
					get: function () {
					  return this.currentPlace.statusbar;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "iframe", {
					get: function () {
					  return this.currentPlace.iframe;
					},
					set: function (e) {
					  this.__setPlaceField("iframe", e);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "history", {
					get: function () {
					  return this.currentPlace.history;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "observer", {
					get: function () {
					  return this.history;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "editorWindow", {
					get: function () {
					  return this.currentPlace.editorWindow;
					},
					set: function (e) {
					  this.__setPlaceField("editorWindow", e);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "ew", {
					get: function () {
					  return this.editorWindow;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "editorDocument", {
					get: function () {
					  return this.currentPlace.editorWindow.document;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "ed", {
					get: function () {
					  return this.editorDocument;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "options", {
					get: function () {
					  return this.currentPlace.options;
					},
					set: function (e) {
					  this.__setPlaceField("options", e);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "s", {
					get: function () {
					  return this.selection;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "uploader", {
					get: function () {
					  return this.getInstance("Uploader", this.o.uploader);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "filebrowser", {
					get: function () {
					  var e = this,
						t = (0, s.ConfigProto)(
						  {
							defaultTimeout: e.defaultTimeout,
							uploader: e.o.uploader,
							language: e.o.language,
							license: e.o.license,
							theme: e.o.theme,
							shadowRoot: e.o.shadowRoot,
							defaultCallback: function (t) {
							  t.files &&
								t.files.length &&
								t.files.forEach(function (o, n) {
								  var r = t.baseurl + o;
								  t.isImages && t.isImages[n]
									? e.s.insertImage(
										r,
										null,
										e.o.imageDefaultWidth,
									  )
									: e.s.insertNode(
										e.createInside.fromHTML(
										  "<a href='"
											.concat(r, "' title='")
											.concat(r, "'>")
											.concat(r, "</a>"),
										),
									  );
								});
							},
						  },
						  this.o.filebrowser,
						);
					  return e.getInstance("FileBrowser", t);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(Jodit.prototype, "mode", {
					get: function () {
					  return this.__mode;
					},
					set: function (e) {
					  this.setMode(e);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (Jodit.prototype.getNativeEditorValue = function () {
					var e = this.e.fire("beforeGetNativeEditorValue");
					return (0, s.isString)(e)
					  ? e
					  : this.editor
						? this.editor.innerHTML
						: this.getElementValue();
				  }),
				  (Jodit.prototype.setNativeEditorValue = function (e) {
					var t = { value: e };
					this.e.fire("beforeSetNativeEditorValue", t) ||
					  (this.editor && (this.editor.innerHTML = t.value));
				  }),
				  Object.defineProperty(Jodit.prototype, "value", {
					get: function () {
					  return this.getEditorValue();
					},
					set: function (e) {
					  this.setEditorValue(e), this.history.__processChanges();
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (Jodit.prototype.synchronizeValues = function () {
					this.__imdSynchronizeValues();
				  }),
				  (Jodit.prototype.__imdSynchronizeValues = function () {
					this.setEditorValue();
				  }),
				  (Jodit.prototype.getEditorValue = function (e, t) {
					var o;
					if (
					  (void 0 === e && (e = !0),
					  void 0 !== (o = this.e.fire("beforeGetValueFromEditor", t)))
					)
					  return o;
					(o = this.getNativeEditorValue().replace(
					  i.INVISIBLE_SPACE_REG_EXP(),
					  "",
					)),
					  e &&
						(o = o.replace(
						  /<span[^>]+id="jodit-selection_marker_[^>]+><\/span>/g,
						  "",
						)),
					  "<br>" === o && (o = "");
					var n = { value: o };
					return this.e.fire("afterGetValueFromEditor", n, t), n.value;
				  }),
				  (Jodit.prototype.setEditorValue = function (e) {
					var t = this.e.fire("beforeSetValueToEditor", e);
					if (!1 !== t)
					  if (((0, s.isString)(t) && (e = t), this.editor)) {
						if (!(0, s.isString)(e) && !(0, s.isVoid)(e))
						  throw (0, s.error)("value must be string");
						(0, s.isVoid)(e) ||
						  this.getNativeEditorValue() === e ||
						  this.setNativeEditorValue(e),
						  this.e.fire("postProcessSetEditorValue");
						var o = this.getElementValue(),
						  n = this.getEditorValue();
						if (
						  !this.__isSilentChange &&
						  o !== n &&
						  i.SAFE_COUNT_CHANGE_CALL > this.__callChangeCount
						) {
						  this.__setElementValue(n),
							(this.__callChangeCount += 1);
						  try {
							this.history.__upTick(),
							  this.e.fire("change", n, o),
							  this.e.fire(this.history, "change", n, o);
						  } finally {
							this.__callChangeCount = 0;
						  }
						}
					  } else void 0 !== e && this.__setElementValue(e);
				  }),
				  (Jodit.prototype.updateElementValue = function () {
					this.__setElementValue(this.getEditorValue());
				  }),
				  (Jodit.prototype.getElementValue = function () {
					return void 0 !== this.element.value
					  ? this.element.value
					  : this.element.innerHTML;
				  }),
				  (Jodit.prototype.setElementValue = function (e) {
					var t = this.getElementValue();
					return (
					  (void 0 === e || ((0, s.isString)(e) && e !== t)) &&
						(null != e || (e = t),
						e !== this.getEditorValue() && this.setEditorValue(e)),
					  this.__setElementValue(e)
					);
				  }),
				  (Jodit.prototype.__setElementValue = function (e) {
					var t = this;
					if (!(0, s.isString)(e))
					  throw (0, s.error)("value must be string");
					if (
					  this.element !== this.container &&
					  e !== this.getElementValue()
					) {
					  var o = { value: e },
						n = this.e.fire("beforeSetElementValue", o);
					  (0, s.callPromise)(n, function () {
						void 0 !== t.element.value
						  ? (t.element.value = o.value)
						  : (t.element.innerHTML = o.value),
						  t.e.fire("afterSetElementValue", o);
					  });
					}
				  }),
				  (Jodit.prototype.registerCommand = function (e, t, o) {
					var n = e.toLowerCase(),
					  r = this.commands.get(n);
					if (
					  (void 0 === r && this.commands.set(n, (r = [])),
					  r.push(t),
					  !(0, s.isFunction)(t))
					) {
					  var i =
						this.o.commandToHotkeys[n] ||
						this.o.commandToHotkeys[e] ||
						t.hotkeys;
					  i &&
						this.registerHotkeyToCommand(
						  i,
						  n,
						  null == o ? void 0 : o.stopPropagation,
						);
					}
					return this;
				  }),
				  (Jodit.prototype.registerHotkeyToCommand = function (e, t, o) {
					var n = this;
					void 0 === o && (o = !0);
					var r = (0, s.asArray)(e)
					  .map(s.normalizeKeyAliases)
					  .map(function (e) {
						return e + ".hotkey";
					  })
					  .join(" ");
					this.e.off(r).on(r, function (e, r) {
					  return (
						r && (r.shouldStop = null == o || o), n.execCommand(t)
					  );
					});
				  }),
				  (Jodit.prototype.execCommand = function (e, t, o) {
					for (var r, i = [], a = 3; arguments.length > a; a++)
					  i[a - 3] = arguments[a];
					if (
					  (this.s.isFocused() || this.s.focus(),
					  !this.o.readonly ||
						this.o.allowCommandsInReadOnly.includes(e))
					) {
					  var s;
					  if (
						((e = e.toLowerCase()),
						!1 !==
						  (s = (r = this.e).fire.apply(
							r,
							n.__spreadArray(
							  ["beforeCommand", e, t, o],
							  n.__read(i),
							  !1,
							),
						  )) &&
						  (s = this.__execCustomCommands.apply(
							this,
							n.__spreadArray([e, t, o], n.__read(i), !1),
						  )),
						!1 !== s)
					  )
						if ((this.s.focus(), "selectall" === e))
						  this.s.select(this.editor, !0),
							this.s.expandSelection();
						else
						  try {
							s = this.nativeExecCommand(e, t, o);
						  } catch (e) {}
					  return (
						this.e.fire("afterCommand", e, t, o),
						this.setEditorValue(),
						s
					  );
					}
				  }),
				  (Jodit.prototype.nativeExecCommand = function (e, t, o) {
					this.__isSilentChange = !0;
					try {
					  return this.ed.execCommand(e, t, o);
					} finally {
					  this.__isSilentChange = !1;
					}
				  }),
				  (Jodit.prototype.__execCustomCommands = function (e, t, o) {
					for (var r = this, i = [], a = 3; arguments.length > a; a++)
					  i[a - 3] = arguments[a];
					e = e.toLowerCase();
					var l,
					  c = this.commands.get(e);
					if (void 0 !== c)
					  return (
						c.forEach(function (a) {
						  var c,
							u = (c = (0, s.isFunction)(a)
							  ? a
							  : a.exec).call.apply(
							  c,
							  n.__spreadArray([r, e, t, o], n.__read(i), !1),
							);
						  void 0 !== u && (l = u);
						}),
						l
					  );
				  }),
				  (Jodit.prototype.lock = function (t) {
					return (
					  void 0 === t && (t = "any"),
					  !!e.prototype.lock.call(this, t) &&
						((this.__selectionLocked = this.s.save()),
						this.s.clear(),
						this.editor.classList.add("jodit_lock"),
						this.e.fire("lock", !0),
						!0)
					);
				  }),
				  (Jodit.prototype.unlock = function () {
					return (
					  !!e.prototype.unlock.call(this) &&
					  (this.editor.classList.remove("jodit_lock"),
					  this.__selectionLocked && this.s.restore(),
					  this.e.fire("lock", !1),
					  !0)
					);
				  }),
				  (Jodit.prototype.getMode = function () {
					return this.mode;
				  }),
				  (Jodit.prototype.isEditorMode = function () {
					return this.getRealMode() === i.MODE_WYSIWYG;
				  }),
				  (Jodit.prototype.getRealMode = function () {
					if (this.getMode() !== i.MODE_SPLIT) return this.getMode();
					var e = this.od.activeElement;
					return e &&
					  (e === this.iframe ||
						a.Dom.isOrContains(this.editor, e) ||
						a.Dom.isOrContains(this.toolbar.container, e))
					  ? i.MODE_WYSIWYG
					  : i.MODE_SOURCE;
				  }),
				  (Jodit.prototype.setMode = function (e) {
					var t = this,
					  o = this.getMode(),
					  n = { mode: parseInt(e.toString(), 10) },
					  r = [
						"jodit-wysiwyg_mode",
						"jodit-source__mode",
						"jodit_split_mode",
					  ];
					!1 !== this.e.fire("beforeSetMode", n) &&
					  ((this.__mode = [
						i.MODE_SOURCE,
						i.MODE_WYSIWYG,
						i.MODE_SPLIT,
					  ].includes(n.mode)
						? n.mode
						: i.MODE_WYSIWYG),
					  this.o.saveModeInStorage &&
						this.storage.set("jodit_default_mode", this.mode),
					  r.forEach(function (e) {
						t.container.classList.remove(e);
					  }),
					  this.container.classList.add(r[this.mode - 1]),
					  o !== this.getMode() && this.e.fire("afterSetMode"));
				  }),
				  (Jodit.prototype.toggleMode = function () {
					var e = this.getMode();
					[
					  i.MODE_SOURCE,
					  i.MODE_WYSIWYG,
					  this.o.useSplitMode ? i.MODE_SPLIT : 9,
					].includes(e + 1)
					  ? (e += 1)
					  : (e = i.MODE_WYSIWYG),
					  this.setMode(e);
				  }),
				  (Jodit.prototype.setDisabled = function (e) {
					this.o.disabled = e;
					var t = this.__wasReadOnly;
					this.setReadOnly(e || t),
					  (this.__wasReadOnly = t),
					  this.editor &&
						(this.editor.setAttribute("aria-disabled", e.toString()),
						this.container.classList.toggle("jodit_disabled", e),
						this.e.fire("disabled", e));
				  }),
				  (Jodit.prototype.getDisabled = function () {
					return this.o.disabled;
				  }),
				  (Jodit.prototype.setReadOnly = function (e) {
					this.__wasReadOnly !== e &&
					  ((this.__wasReadOnly = e),
					  (this.o.readonly = e),
					  e
						? this.editor &&
						  this.editor.removeAttribute("contenteditable")
						: this.editor &&
						  this.editor.setAttribute("contenteditable", "true"),
					  this.e && this.e.fire("readonly", e));
				  }),
				  (Jodit.prototype.getReadOnly = function () {
					return this.o.readonly;
				  }),
				  (Jodit.prototype.focus = function () {
					this.getMode() !== i.MODE_SOURCE && this.s.focus();
				  }),
				  Object.defineProperty(Jodit.prototype, "isFocused", {
					get: function () {
					  return this.s.isFocused();
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (Jodit.prototype.beforeInitHook = function () {}),
				  (Jodit.prototype.afterInitHook = function () {}),
				  (Jodit.prototype.initOptions = function (e) {
					this.options = (0, s.ConfigProto)(
					  e || {},
					  r.Config.defaultOptions,
					);
				  }),
				  (Jodit.prototype.initOwners = function () {
					(this.editorWindow = this.o.ownerWindow),
					  (this.ownerWindow = this.o.ownerWindow);
				  }),
				  (Jodit.prototype.addPlace = function (e, t) {
					var o = this,
					  n = (0, s.resolveElement)(e, this.o.shadowRoot || this.od);
					this.attachEvents(t),
					  n.attributes &&
						(0, s.toArray)(n.attributes).forEach(function (e) {
						  var n = e.name,
							i = e.value;
						  void 0 === r.Config.defaultOptions[n] ||
							(t && void 0 !== t[n]) ||
							(-1 !== ["readonly", "disabled"].indexOf(n) &&
							  (i = "" === i || "true" === i),
							/^[0-9]+(\.)?([0-9]+)?$/.test(i.toString()) &&
							  (i = Number(i)),
							(o.options[n] = i));
						});
					var i = this.c.div("jodit-container");
					i.classList.add("jodit"),
					  i.classList.add("jodit-container"),
					  i.classList.add(
						"jodit_theme_".concat(this.o.theme || "default"),
					  ),
					  v(this.o.className, i),
					  this.o.containerStyle &&
						(0, s.css)(i, this.o.containerStyle);
					var l = this.o.styleValues;
					Object.keys(l).forEach(function (e) {
					  var t = (0, s.kebabCase)(e);
					  i.style.setProperty("--jd-".concat(t), l[e]);
					}),
					  i.setAttribute("contenteditable", "false");
					var c = null;
					this.o.inline &&
					  (-1 === ["TEXTAREA", "INPUT"].indexOf(n.nodeName) &&
						((i = n),
						n.setAttribute(m, n.className.toString()),
						(c = i.innerHTML),
						(i.innerHTML = "")),
					  i.classList.add("jodit_inline"),
					  i.classList.add("jodit-container")),
					  n !== i &&
						(n.style.display && n.setAttribute(h, n.style.display),
						(n.style.display = "none"));
					var u = this.c.div("jodit-workplace", {
					  contenteditable: !1,
					});
					i.appendChild(u),
					  this.message.destruct(),
					  (this.message = new a.UIMessages(this, u)),
					  n.parentNode && n !== i && n.parentNode.insertBefore(i, n),
					  Object.defineProperty(n, "component", {
						enumerable: !1,
						configurable: !0,
						value: this,
					  });
					var d = this.c.div("jodit-wysiwyg", {
					  contenteditable: !0,
					  "aria-disabled": !1,
					  tabindex: this.o.tabIndex,
					});
					u.appendChild(d);
					var p = {
					  editor: d,
					  element: n,
					  container: i,
					  workplace: u,
					  statusbar: new a.StatusBar(this, i),
					  options: this.isReady
						? (0, s.ConfigProto)(t || {}, r.Config.defaultOptions)
						: this.options,
					  history: new a.History(this),
					  editorWindow: this.ow,
					};
					this.__elementToPlace.set(d, p),
					  this.setCurrentPlace(p),
					  this.places.push(p),
					  this.setNativeEditorValue(this.getElementValue());
					var f = this.__initEditor(c),
					  g = this.options;
					return (0, s.callPromise)(f, function () {
					  g.enableDragAndDropFileToEditor &&
						g.uploader &&
						(g.uploader.url || g.uploader.insertImageAsBase64URI) &&
						o.uploader.bind(o.editor),
						o.__elementToPlace.get(o.editor) ||
						  o.__elementToPlace.set(o.editor, p),
						o.e.fire("afterAddPlace", p);
					});
				  }),
				  (Jodit.prototype.addDisclaimer = function (e) {
					this.workplace.appendChild(e);
				  }),
				  (Jodit.prototype.setCurrentPlace = function (e) {
					this.currentPlace !== e &&
					  (this.isEditorMode() || this.setMode(i.MODE_WYSIWYG),
					  (this.currentPlace = e),
					  this.buildToolbar(),
					  this.isReady && this.e.fire("changePlace", e));
				  }),
				  (Jodit.prototype.__initEditor = function (e) {
					var t = this,
					  o = this.__createEditor();
					return (0, s.callPromise)(o, function () {
					  if (!t.isInDestruct) {
						if (t.element !== t.container) {
						  var o = t.getElementValue();
						  o !== t.getEditorValue() && t.setEditorValue(o);
						} else null != e && t.setEditorValue(e);
						var n = t.o.defaultMode;
						if (t.o.saveModeInStorage) {
						  var r = t.storage.get("jodit_default_mode");
						  "string" == typeof r && (n = parseInt(r, 10));
						}
						t.setMode(n),
						  t.o.readonly &&
							((t.__wasReadOnly = !1), t.setReadOnly(!0)),
						  t.o.disabled && t.setDisabled(!0);
						try {
						  t.ed.execCommand(
							"defaultParagraphSeparator",
							!1,
							t.o.enter.toLowerCase(),
						  );
						} catch (e) {}
						try {
						  t.ed.execCommand("enableObjectResizing", !1, "false");
						} catch (e) {}
						try {
						  t.ed.execCommand(
							"enableInlineTableEditing",
							!1,
							"false",
						  );
						} catch (e) {}
					  }
					});
				  }),
				  (Jodit.prototype.__createEditor = function () {
					var e = this,
					  t = this.editor,
					  o = this.e.fire("createEditor", this);
					return (0, s.callPromise)(o, function () {
					  if (!e.isInDestruct) {
						if (
						  ((!1 === o || (0, s.isPromise)(o)) &&
							a.Dom.safeRemove(t),
						  v(e.o.editorClassName || e.o.editorCssClass, e.editor),
						  e.o.editorCssClass &&
							e.editor.classList.add(e.o.editorCssClass),
						  e.o.style && (0, s.css)(e.editor, e.o.style),
						  e.e
							.on("synchro", function () {
							  e.setEditorValue();
							})
							.on("focus", function () {
							  e.editorIsActive = !0;
							})
							.on("blur", function () {
							  return (e.editorIsActive = !1);
							}),
						  e.__prepareWYSIWYGEditor(),
						  e.o.direction)
						) {
						  var n =
							"rtl" === e.o.direction.toLowerCase() ? "rtl" : "ltr";
						  (e.container.style.direction = n),
							e.container.setAttribute("dir", n),
							e.toolbar.setDirection(n);
						}
						e.o.triggerChangeEvent &&
						  e.e.on(
							"change",
							e.async.debounce(function () {
							  e.e && e.e.fire(e.element, "change");
							}, e.defaultTimeout),
						  );
					  }
					});
				  }),
				  (Jodit.prototype.__prepareWYSIWYGEditor = function () {
					var e = this,
					  t = this.editor;
					if (this.o.direction) {
					  var o =
						"rtl" === this.o.direction.toLowerCase() ? "rtl" : "ltr";
					  (this.editor.style.direction = o),
						this.editor.setAttribute("dir", o);
					}
					this.e
					  .on(t, "mousedown touchstart focus", function () {
						var o = e.__elementToPlace.get(t);
						o && e.setCurrentPlace(o);
					  })
					  .on(t, "compositionend", this.synchronizeValues)
					  .on(
						t,
						"selectionchange selectionstart keydown keyup input keypress dblclick mousedown mouseup click copy cut dragstart drop dragover paste resize touchstart touchend focus blur",
						function (t) {
						  if (
							!e.o.readonly &&
							!e.__isSilentChange &&
							!(t instanceof e.ew.KeyboardEvent && t.isComposing) &&
							e.e &&
							e.e.fire
						  ) {
							if (!1 === e.e.fire(t.type, t)) return !1;
							e.synchronizeValues();
						  }
						},
					  );
				  }),
				  (Jodit.prototype.fetch = function (e, t) {
					var o = this,
					  r = new f.Ajax(
						n.__assign({ url: e }, t),
						this.o.defaultAjaxOptions,
					  ),
					  i = function () {
						o.e.off("beforeDestruct", i),
						  o.progressbar.progress(100).hide(),
						  r.destruct();
					  };
					this.e.one("beforeDestruct", i),
					  this.progressbar.show().progress(30);
					var a = r.send();
					return (
					  a.finally(i).catch(function () {
						return null;
					  }),
					  a
					);
				  }),
				  (Jodit.prototype.destruct = function () {
					var t = this;
					if (
					  !this.isInDestruct &&
					  (this.setStatus(a.STATUSES.beforeDestruct),
					  this.__elementToPlace.clear(),
					  this.editor)
					) {
					  var o = this.getEditorValue();
					  this.storage.clear(),
						this.buffer.clear(),
						this.commands.clear(),
						(this.__selectionLocked = null),
						this.e.off(this.ow, "resize"),
						this.e.off(this.ow),
						this.e.off(this.od),
						this.e.off(this.od.body),
						this.places.forEach(function (e) {
						  var n = e.container,
							r = e.workplace,
							i = e.statusbar,
							l = e.element,
							c = e.iframe,
							u = e.editor,
							d = e.history;
						  if (l !== n)
							if (l.hasAttribute(h)) {
							  var p = (0, s.attr)(l, h);
							  p && ((l.style.display = p), l.removeAttribute(h));
							} else l.style.display = "";
						  else
							l.hasAttribute(m) &&
							  ((l.className = (0, s.attr)(l, m) || ""),
							  l.removeAttribute(m));
						  l.hasAttribute("style") &&
							!(0, s.attr)(l, "style") &&
							l.removeAttribute("style"),
							i.destruct(),
							t.e.off(n),
							t.e.off(l),
							t.e.off(u),
							a.Dom.safeRemove(r),
							a.Dom.safeRemove(u),
							n !== l && a.Dom.safeRemove(n),
							Object.defineProperty(l, "component", {
							  enumerable: !1,
							  configurable: !0,
							  value: null,
							}),
							a.Dom.safeRemove(c),
							n === l && (l.innerHTML = o),
							d.destruct();
						}),
						(this.places.length = 0),
						(this.currentPlace = {}),
						delete u.instances[this.id],
						e.prototype.destruct.call(this);
					}
				  }),
				  (Jodit.fatMode = !1),
				  (Jodit.plugins = u.pluginSystem),
				  (Jodit.modules = u.modules),
				  (Jodit.ns = u.modules),
				  (Jodit.decorators = {}),
				  (Jodit.constants = i),
				  (Jodit.instances = u.instances),
				  (Jodit.lang = c.lang),
				  (Jodit.core = { Plugin: a.Plugin }),
				  n.__decorate([d.cache], Jodit.prototype, "uploader", null),
				  n.__decorate([d.cache], Jodit.prototype, "filebrowser", null),
				  n.__decorate(
					[(0, d.throttle)()],
					Jodit.prototype,
					"synchronizeValues",
					null,
				  ),
				  n.__decorate(
					[(0, d.watch)(":internalChange")],
					Jodit.prototype,
					"updateElementValue",
					null,
				  ),
				  n.__decorate(
					[d.autobind],
					Jodit.prototype,
					"__prepareWYSIWYGEditor",
					null,
				  ),
				  (t = n.__decorate([(0, d.derive)(p.Dlgs)], Jodit))
				);
			  })(a.ViewWithToolbar);
			function v(e, t) {
			  e &&
				e.split(/\s+/).forEach(function (e) {
				  return t.classList.add(e);
				});
			}
			t.Jodit = Jodit;
		  },
		  26435: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(10172),
			  r = {},
			  i = o(90643),
			  a = o(52532),
			  s = o(75178),
			  l = o(51048),
			  c = o(22999),
			  u = o(34145),
			  d = o(40272),
			  p = o(2978),
			  f = o(99113),
			  h = o(51923),
			  m = o(21268),
			  v = o(37289),
			  g = o(26501),
			  y = o(17084),
			  _ = o(96891),
			  b = o(31211),
			  w = o(31109),
			  S = o(79375),
			  C = o(21042),
			  j = o(73895);
			r = {
			  ar: i,
			  cs_cz: a,
			  de: s,
			  en: l,
			  es: c,
			  fr: u,
			  he: d,
			  hu: p,
			  id: f,
			  it: h,
			  ja: m,
			  ko: v,
			  mn: g,
			  nl: y,
			  pl: _,
			  pt_br: b,
			  ru: w,
			  tr: S,
			  zh_cn: C,
			  zh_tw: j,
			};
			var E = o(11399),
			  x = function (e) {
				return e ? e.default || e : {};
			  },
			  k = {};
			(0, n.isArray)(x(E)) &&
			  x(E).forEach(function (e, t) {
				k[t] = e;
			  }),
			  Object.keys(r).forEach(function (e) {
				var t = x(r[e]);
				(0, n.isArray)(t)
				  ? ((r[e] = {}),
					t.forEach(function (t, o) {
					  r[e][k[o]] = t;
					}))
				  : (r[e] = t);
			  }),
			  (t.default = r);
		  },
		  60403: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ContextMenu = void 0);
			var n = o(20255);
			o(47086);
			var r = o(35799),
			  i = o(96516),
			  a = o(10172),
			  s = o(11441),
			  l = (function (e) {
				function t() {
				  return (null !== e && e.apply(this, arguments)) || this;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "ContextMenu";
				  }),
				  (t.prototype.show = function (e, t, o) {
					var n = this,
					  r = this,
					  s = this.j.c.div(this.getFullElName("actions"));
					(0, a.isArray)(o) &&
					  (o.forEach(function (e) {
						if (e) {
						  var t = (0, i.Button)(
							n.jodit,
							e.icon || "empty",
							e.title,
						  );
						  n.jodit && t.setParentView(n.jodit),
							t.setMod("context", "menu"),
							t.onAction(function (t) {
							  var o;
							  return (
								null === (o = e.exec) ||
								  void 0 === o ||
								  o.call(r, t),
								r.close(),
								!1
							  );
							}),
							s.appendChild(t.container);
						}
					  }),
					  this.setContent(s).open(function () {
						return { left: e, top: t, width: 0, height: 0 };
					  }, !0));
				  }),
				  n.__decorate([s.component], t)
				);
			  })(r.Popup);
			t.ContextMenu = l;
		  },
		  97528: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Alert = void 0);
			var n = o(6690),
			  r = o(40332),
			  i = o(64968),
			  a = o(2074);
			t.Alert = function (e, t, o, s) {
			  void 0 === s && (s = "jodit-dialog_alert"),
				(0, r.isFunction)(t) && ((o = t), (t = void 0));
			  var l = this instanceof n.Dialog ? this : new n.Dialog(),
				c = l.c.div(s),
				u = (0, a.Button)(l, "ok", "Ok");
			  return (
				(0, r.asArray)(e).forEach(function (e) {
				  c.appendChild(i.Dom.isNode(e) ? e : l.c.fromHTML(e));
				}),
				u.onAction(function () {
				  (o && (0, r.isFunction)(o) && !1 === o(l)) || l.close();
				}),
				l.setFooter([u]),
				l.open(c, t || "&nbsp;", !0, !0),
				u.focus(),
				l
			  );
			};
		  },
		  47360: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Confirm = void 0);
			var n = o(6690),
			  r = o(42096),
			  i = o(96031);
			t.Confirm = function (e, t, o) {
			  var a = this instanceof n.Dialog ? this : new n.Dialog(),
				s = a.c.fromHTML('<form class="jodit-dialog_prompt"></form>'),
				l = a.c.element("label");
			  (0, r.isFunction)(t) && ((o = t), (t = void 0)),
				l.appendChild(a.c.fromHTML(e)),
				s.appendChild(l);
			  var c = function (e) {
				  return function () {
					(o && !1 === o(e)) || a.close();
				  };
				},
				u = (0, i.Button)(a, "cancel", "Cancel"),
				d = (0, i.Button)(a, "ok", "Yes");
			  return (
				u.onAction(c(!1)),
				d.onAction(c(!0)),
				a.e.on(s, "submit", function () {
				  return c(!0)(), !1;
				}),
				a.setFooter([d, u]),
				a.open(s, t || "&nbsp;", !0, !0),
				d.focus(),
				a
			  );
			};
		  },
		  6690: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Dialog = void 0);
			var n = o(20255);
			o(16462);
			var r = o(93166),
			  i = o(86893),
			  a = o(40332),
			  s = (o(52378), o(43608)),
			  l = o(64968),
			  c = o(56562),
			  u = o(17332),
			  d = o(43441),
			  p = o(75902),
			  f = o(2074),
			  h = o(71014);
			(r.Config.prototype.dialog = {
			  namespace: "",
			  extraButtons: [],
			  resizable: !0,
			  draggable: !0,
			  buttons: ["dialog.close"],
			  removeButtons: [],
			  toolbarButtonSize: "middle",
			  zIndex: "inherit",
			}),
			  (r.Config.prototype.controls.dialog = {
				close: {
				  icon: "cancel",
				  exec: function (e) {
					e.close();
				  },
				},
			  });
			var m = (function (e) {
			  function t(t) {
				return;
				void 0 === t && (t = {});
				var o = e.call(this, t) || this;
				(o.destroyAfterClose = !1),
				  (o.moved = !1),
				  (o.resizable = !1),
				  (o.draggable = !1),
				  (o.startX = 0),
				  (o.startY = 0),
				  (o.startPoint = { x: 0, y: 0, w: 0, h: 0 }),
				  (o.lockSelect = function () {
					o.setMod("moved", !0);
				  }),
				  (o.unlockSelect = function () {
					o.setMod("moved", !1);
				  }),
				  (o.onResize = function () {
					o.options &&
					  o.o.resizable &&
					  !o.moved &&
					  o.isOpened &&
					  !o.offsetX &&
					  !o.offsetY &&
					  o.setPosition();
				  }),
				  (o.isModal = !1),
				  (o.isOpened = !1);
				var n = o;
				(n.options = (0, a.ConfigProto)(
				  t,
				  (0, a.ConfigProto)(
					r.Config.prototype.dialog,
					p.View.defaultOptions,
				  ),
				)),
				  l.Dom.safeRemove(n.container);
				var i = o.getFullElName.bind(o);
				(n.container = o.c.fromHTML(
				  '<div class="jodit jodit-dialog '
					.concat(o.componentName, '">\n\t\t\t\t<div class="')
					.concat(i("overlay"), '"></div>\n\t\t\t\t<div class="')
					.concat(
					  o.getFullElName("panel"),
					  '">\n\t\t\t\t\t<div class="',
					)
					.concat(i("header"), '">\n\t\t\t\t\t\t<div class="')
					.concat(
					  i("header-title"),
					  '"></div>\n\t\t\t\t\t\t<div class="',
					)
					.concat(
					  i("header-toolbar"),
					  '"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="',
					)
					.concat(i("content"), '"></div>\n\t\t\t\t\t<div class="')
					.concat(i("footer"), '"></div>\n\t\t\t\t\t<div class="')
					.concat(i("resizer"), '">')
					.concat(
					  f.Icon.get("resize_handler"),
					  "</div>\n\t\t\t\t</div>\n\t\t\t</div>",
					),
				)),
				  o.o.zIndex &&
					(o.container.style.zIndex = o.o.zIndex.toString()),
				  (0, a.attr)(n.container, "role", "dialog"),
				  Object.defineProperty(n.container, "component", { value: o }),
				  n
					.setMod("theme", n.o.theme || "default")
					.setMod("resizable", Boolean(n.o.resizable));
				var s = n.getElm("panel"),
				  c = n.getElm("resizer"),
				  d = n.getElm("header-title"),
				  m = n.getElm("content"),
				  v = n.getElm("footer"),
				  g = n.getElm("header-toolbar");
				o.message.destruct(),
				  (o.message = new h.UIMessages(o, s)),
				  (o.dialog = s),
				  (o.resizer = c),
				  (o.dialogbox_header = d),
				  (o.dialogbox_content = m),
				  (o.dialogbox_footer = v),
				  (o.dialogbox_toolbar = g),
				  (0, a.css)(n.dialog, {
					maxWidth: n.options.maxWidth,
					minHeight: n.options.minHeight,
					minWidth: n.options.minWidth,
				  });
				var y = n.getElm("header");
				y && n.e.on(y, "pointerdown touchstart", n.onHeaderMouseDown),
				  n.e.on(n.resizer, "mousedown touchstart", n.onResizerMouseDown);
				var _ = u.pluginSystem.get("fullsize");
				return (
				  (0, a.isFunction)(_) && _(n),
				  o.e
					.on(n.container, "close_dialog", n.close)
					.on(o.ow, "keydown", o.onEsc)
					.on(o.ow, "resize", o.onResize),
				  o
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.className = function () {
				  return "Dialog";
				}),
				Object.defineProperty(t.prototype, "destination", {
				  get: function () {
					var e;
					return null !== (e = this.o.shadowRoot) && void 0 !== e
					  ? e
					  : this.od.body;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.setElements = function (e, t) {
				  var o = this,
					n = [];
				  (0, a.asArray)(t).forEach(function (t) {
					if ((0, a.isArray)(t)) {
					  var r = o.c.div(o.getFullElName("column"));
					  return n.push(r), e.appendChild(r), o.setElements(r, t);
					}
					var i;
					(i = (0, a.isString)(t)
					  ? o.c.fromHTML(t)
					  : (0, a.hasContainer)(t)
						? t.container
						: t),
					  n.push(i),
					  i.parentNode !== e && e.appendChild(i);
				  }),
					(0, a.toArray)(e.childNodes).forEach(function (t) {
					  -1 === n.indexOf(t) && e.removeChild(t);
					});
				}),
				(t.prototype.onMouseUp = function () {
				  (this.draggable || this.resizable) &&
					(this.removeGlobalResizeListeners(),
					(this.draggable = !1),
					(this.resizable = !1),
					this.unlockSelect(),
					this.e &&
					  (this.removeGlobalResizeListeners(),
					  this.e.fire(this, "endResize endMove")));
				}),
				(t.prototype.onHeaderMouseDown = function (e) {
				  var t = e.target;
				  !this.o.draggable ||
					(t && t.nodeName.match(/^(INPUT|SELECT)$/)) ||
					((this.draggable = !0),
					(this.startX = e.clientX),
					(this.startY = e.clientY),
					(this.startPoint.x = (0, a.css)(this.dialog, "left")),
					(this.startPoint.y = (0, a.css)(this.dialog, "top")),
					this.setMaxZIndex(),
					e.cancelable && e.preventDefault(),
					this.lockSelect(),
					this.addGlobalResizeListeners(),
					this.e && this.e.fire(this, "startMove"));
				}),
				(t.prototype.onMouseMove = function (e) {
				  this.draggable &&
					this.o.draggable &&
					(this.setPosition(
					  this.startPoint.x + e.clientX - this.startX,
					  this.startPoint.y + e.clientY - this.startY,
					),
					this.e &&
					  this.e.fire(
						this,
						"move",
						e.clientX - this.startX,
						e.clientY - this.startY,
					  ),
					e.stopImmediatePropagation()),
					this.resizable &&
					  this.o.resizable &&
					  (this.setSize(
						this.startPoint.w + e.clientX - this.startX,
						this.startPoint.h + e.clientY - this.startY,
					  ),
					  this.e &&
						this.e.fire(
						  this,
						  "resizeDialog",
						  e.clientX - this.startX,
						  e.clientY - this.startY,
						));
				}),
				(t.prototype.onEsc = function (e) {
				  if (
					this.isOpened &&
					e.key === i.KEY_ESC &&
					!0 !== this.getMod("static")
				  ) {
					var t = this.getMaxZIndexDialog();
					t ? t.close() : this.close(), e.stopImmediatePropagation();
				  }
				}),
				(t.prototype.onResizerMouseDown = function (e) {
				  (this.resizable = !0),
					(this.startX = e.clientX),
					(this.startY = e.clientY),
					(this.startPoint.w = this.dialog.offsetWidth),
					(this.startPoint.h = this.dialog.offsetHeight),
					this.lockSelect(),
					this.addGlobalResizeListeners(),
					this.e && this.e.fire(this, "startResize");
				}),
				(t.prototype.addGlobalResizeListeners = function () {
				  var e = this;
				  e.e
					.on(e.ow, "pointermove touchmove", e.onMouseMove)
					.on(e.ow, "pointerup touchend", e.onMouseUp);
				}),
				(t.prototype.removeGlobalResizeListeners = function () {
				  var e = this;
				  e.e
					.off(e.ow, "mousemove pointermove", e.onMouseMove)
					.off(e.ow, "mouseup pointerup", e.onMouseUp);
				}),
				(t.prototype.setSize = function (e, t) {
				  return (
					null == e && (e = this.dialog.offsetWidth),
					null == t && (t = this.dialog.offsetHeight),
					(0, a.css)(this.dialog, { width: e, height: t }),
					this
				  );
				}),
				(t.prototype.calcAutoSize = function () {
				  return this.setSize("auto", "auto"), this.setSize(), this;
				}),
				(t.prototype.setPosition = function (e, t) {
				  var o = this.ow.innerWidth / 2 - this.dialog.offsetWidth / 2,
					n = this.ow.innerHeight / 2 - this.dialog.offsetHeight / 2;
				  return (
					0 > o && (o = 0),
					0 > n && (n = 0),
					void 0 !== e &&
					  void 0 !== t &&
					  ((this.offsetX = e),
					  (this.offsetY = t),
					  (this.moved =
						Math.abs(e - o) > 100 || Math.abs(t - n) > 100)),
					(this.dialog.style.left = (e || o) + "px"),
					(this.dialog.style.top = (t || n) + "px"),
					this
				  );
				}),
				(t.prototype.setHeader = function (e) {
				  return this.setElements(this.dialogbox_header, e), this;
				}),
				(t.prototype.setContent = function (e) {
				  return this.setElements(this.dialogbox_content, e), this;
				}),
				(t.prototype.setFooter = function (e) {
				  return (
					this.setElements(this.dialogbox_footer, e),
					this.setMod("footer", Boolean(e)),
					this
				  );
				}),
				(t.prototype.getZIndex = function () {
				  return parseInt((0, a.css)(this.container, "zIndex"), 10) || 0;
				}),
				(t.prototype.getMaxZIndexDialog = function () {
				  var e,
					t,
					o = 0,
					n = this;
				  return (
					(0, a.$$)(".jodit-dialog", this.destination).forEach(
					  function (r) {
						(e = r.component),
						  (t = parseInt((0, a.css)(r, "zIndex"), 10)),
						  e.isOpened && !isNaN(t) && t > o && ((n = e), (o = t));
					  },
					),
					n
				  );
				}),
				(t.prototype.setMaxZIndex = function () {
				  if (!this.getMod("static")) {
					var e = 20000004,
					  t = 0;
					(0, a.$$)(".jodit-dialog", this.destination).forEach(
					  function (o) {
						(t = parseInt((0, a.css)(o, "zIndex"), 10)),
						  (e = Math.max(isNaN(t) ? 0 : t, e));
					  },
					),
					  (this.container.style.zIndex = (e + 1).toString());
				  }
				}),
				(t.prototype.toggleFullSize = function (t) {
				  (0, a.isVoid)(t) && (t = !this.getMod("fullsize")),
					this.setMod("fullsize", t),
					e.prototype.toggleFullSize.call(this, t);
				}),
				(t.prototype.open = function (e, t, o, n) {
				  if (
					(u.eventEmitter.fire("closeAllPopups hideHelpers"),
					!1 === this.e.fire(this, "beforeOpen"))
				  )
					return this;
				  (0, a.isBoolean)(e) && (o = e),
					(0, a.isBoolean)(t) && (n = t),
					(this.destroyAfterClose = !0 === o);
				  var r = (0, a.isBoolean)(e) ? void 0 : e,
					i = (0, a.isBoolean)(t) ? void 0 : t;
				  return (
					void 0 !== i && this.setHeader(i),
					r && this.setContent(r),
					this.setMod("active", !0),
					(this.isOpened = !0),
					this.setModal(n),
					this.destination.appendChild(this.container),
					!0 !== this.getMod("static")
					  ? (this.setPosition(this.offsetX, this.offsetY),
						this.setMaxZIndex())
					  : this.container.style.removeProperty("z-index"),
					this.o.fullsize && this.toggleFullSize(!0),
					this.e.fire("afterOpen", this),
					this
				  );
				}),
				(t.prototype.setModal = function (e) {
				  return (
					(this.isModal = Boolean(e)),
					this.setMod("modal", this.isModal),
					this
				  );
				}),
				(t.prototype.close = function () {
				  return (
					this.isDestructed ||
					  !this.isOpened ||
					  !0 === this.getMod("static") ||
					  !1 === this.e.fire("beforeClose", this) ||
					  (this.setMod("active", !1),
					  (this.isOpened = !1),
					  this.isFullSize && this.toggleFullSize(!1),
					  l.Dom.safeRemove(this.container),
					  this.removeGlobalResizeListeners(),
					  this.destroyAfterClose && this.destruct(),
					  this.e.fire(this, "afterClose"),
					  this.e.fire(this.ow, "joditCloseDialog")),
					this
				  );
				}),
				(t.prototype.buildToolbar = function () {
				  this.o.buttons &&
					this.toolbar
					  .build((0, a.splitArray)(this.o.buttons))
					  .setMod("mode", "header")
					  .appendTo(this.dialogbox_toolbar);
				}),
				(t.prototype.destruct = function () {
				  this.isInDestruct ||
					(this.setStatus(c.STATUSES.beforeDestruct),
					this.isOpened && this.close(),
					this.events &&
					  (this.removeGlobalResizeListeners(),
					  this.events
						.off(this.container, "close_dialog", self.close)
						.off(this.ow, "keydown", this.onEsc)
						.off(this.ow, "resize", this.onResize)),
					e.prototype.destruct.call(this));
				}),
				n.__decorate([d.autobind], t.prototype, "onMouseUp", null),
				n.__decorate(
				  [d.autobind],
				  t.prototype,
				  "onHeaderMouseDown",
				  null,
				),
				n.__decorate([d.autobind], t.prototype, "onMouseMove", null),
				n.__decorate([d.autobind], t.prototype, "onEsc", null),
				n.__decorate(
				  [d.autobind],
				  t.prototype,
				  "onResizerMouseDown",
				  null,
				),
				n.__decorate([d.autobind], t.prototype, "close", null),
				n.__decorate(
				  [(0, d.hook)("ready")],
				  t.prototype,
				  "buildToolbar",
				  null,
				),
				n.__decorate([d.component], t)
			  );
			})(s.ViewWithToolbar);
			t.Dialog = m;
		  },
		  92080: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Confirm = t.Prompt = t.Alert = t.Dialog = void 0);
			var n = o(6690);
			Object.defineProperty(t, "Dialog", {
			  enumerable: !0,
			  get: function () {
				return n.Dialog;
			  },
			});
			var r = o(97528);
			Object.defineProperty(t, "Alert", {
			  enumerable: !0,
			  get: function () {
				return r.Alert;
			  },
			});
			var i = o(35789);
			Object.defineProperty(t, "Prompt", {
			  enumerable: !0,
			  get: function () {
				return i.Prompt;
			  },
			});
			var a = o(47360);
			Object.defineProperty(t, "Confirm", {
			  enumerable: !0,
			  get: function () {
				return a.Confirm;
			  },
			});
		  },
		  35789: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Prompt = void 0);
			var n = o(92080),
			  r = o(2074),
			  i = o(40332);
			t.Prompt = function (e, t, o, a, s) {
			  var l = this instanceof n.Dialog ? this : new n.Dialog(),
				c = (0, r.Button)(l, "cancel", "Cancel"),
				u = (0, r.Button)(l, "ok", "Ok"),
				d = l.c.element("form", { class: "jodit-dialog_prompt" }),
				p = l.c.element("input", { autofocus: !0, class: "jodit-input" }),
				f = l.c.element("label");
			  (0, i.isFunction)(t) && ((o = t), (t = void 0)),
				a && (0, i.attr)(p, "placeholder", a),
				f.appendChild(l.c.text(e)),
				d.appendChild(f),
				d.appendChild(p),
				c.onAction(l.close);
			  var h = function () {
				(o && (0, i.isFunction)(o) && !1 === o(p.value)) || l.close();
			  };
			  return (
				u.onAction(h),
				l.e.on(d, "submit", function () {
				  return h(), !1;
				}),
				l.setFooter([u, c]),
				l.open(d, t || "&nbsp;", !0, !0),
				p.focus(),
				void 0 !== s && s.length && ((p.value = s), p.select()),
				l
			  );
			};
		  },
		  34468: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255),
			  r = o(64968),
			  i = o(40332),
			  a = o(46341),
			  s = o(2074),
			  l = o(21347),
			  c = o(35503),
			  u = o(66267),
			  d = o(36303),
			  p = o(48096),
			  f = "jodit-filebrowser-preview",
			  h = function (e, t) {
				return (
				  void 0 === e && (e = "next"),
				  void 0 === t && (t = "right"),
				  '<div class="'
					.concat(f, "__navigation ")
					.concat(f, "__navigation_arrow_")
					.concat(e, '">') +
					"" +
					s.Icon.get("angle-" + t) +
					"</a>"
				);
			  };
			t.default = function (e) {
			  if (!e.o.contextMenu) return function () {};
			  var t = (0, a.makeContextMenu)(e);
			  return function (o) {
				var a = (0, l.getItem)(o.target, e.container);
				if (a) {
				  var s = a,
					m = e.options,
					v = function (e) {
					  return (0, i.attr)(s, e) || "";
					};
				  return (
					e.async.setTimeout(function () {
					  var g = (0, l.elementToItem)(a, (0, u.elementsMap)(e));
					  g &&
						((e.state.activeElements = [g]),
						t.show(o.clientX, o.clientY, [
						  !(
							"1" === v("data-is-file") ||
							!m.editImage ||
							(!e.dataProvider.canI("ImageResize") &&
							  !e.dataProvider.canI("ImageCrop"))
						  ) && {
							icon: "pencil",
							title: "Edit",
							exec: function () {
							  return c.openImageEditor.call(
								e,
								v("href"),
								v("data-name"),
								v("data-path"),
								v("data-source"),
							  );
							},
						  },
						  !!e.dataProvider.canI("FileRename") && {
							icon: "italic",
							title: "Rename",
							exec: function () {
							  e.e.fire(
								"fileRename.filebrowser",
								v("data-name"),
								v("data-path"),
								v("data-source"),
							  );
							},
						  },
						  !!e.dataProvider.canI("FileRemove") && {
							icon: "bin",
							title: "Delete",
							exec: function () {
							  return n.__awaiter(
								void 0,
								void 0,
								Promise,
								function () {
								  var t;
								  return n.__generator(this, function (o) {
									switch (o.label) {
									  case 0:
										return (
										  o.trys.push([0, 2, , 3]),
										  [
											4,
											(0, p.deleteFile)(
											  e,
											  v("data-name"),
											  v("data-source"),
											),
										  ]
										);
									  case 1:
										return o.sent(), [3, 3];
									  case 2:
										return (t = o.sent()), [2, e.status(t)];
									  case 3:
										return (
										  (e.state.activeElements = []),
										  [2, (0, d.loadTree)(e).catch(e.status)]
										);
									}
								  });
								},
							  );
							},
						  },
						  !!m.preview && {
							icon: "eye",
							title: "Preview",
							exec: function () {
							  var t = e.dlg({
								  buttons: ["fullsize", "dialog.close"],
								}),
								o = e.c.div(
								  f,
								  '<div class="jodit-icon_loader"></div>',
								),
								n = e.c.div(f + "__box"),
								a = e.c.fromHTML(h()),
								l = e.c.fromHTML(h("prev", "left")),
								c = function (i) {
								  var c = e.c.element("img");
								  c.setAttribute("src", i);
								  var u = function () {
									var i;
									e.isInDestruct ||
									  (e.e.off(c, "load"),
									  r.Dom.detach(o),
									  m.showPreviewNavigation &&
										(r.Dom.prevWithClass(
										  s,
										  e.files.getFullElName("item"),
										) && o.appendChild(l),
										r.Dom.nextWithClass(
										  s,
										  e.files.getFullElName("item"),
										) && o.appendChild(a)),
									  o.appendChild(n),
									  n.appendChild(c),
									  t.setPosition(),
									  null ===
										(i = null == e ? void 0 : e.events) ||
										void 0 === i ||
										i.fire("previewOpenedAndLoaded"));
								  };
								  e.e.on(c, "load", u), c.complete && u();
								};
							  e.e.on([a, l], "click", function () {
								if (
								  !(s =
									this === a
									  ? r.Dom.nextWithClass(
										  s,
										  e.files.getFullElName("item"),
										)
									  : r.Dom.prevWithClass(
										  s,
										  e.files.getFullElName("item"),
										))
								)
								  throw (0, i.error)("Need element");
								r.Dom.detach(o),
								  r.Dom.detach(n),
								  (o.innerHTML =
									'<div class="jodit-icon_loader"></div>'),
								  c(v("href"));
							  }),
								e.e.on("beforeDestruct", function () {
								  t.destruct();
								}),
								t.container.classList.add(f + "__dialog"),
								t.setContent(o),
								t.setPosition(),
								t.open(),
								c(v("href")),
								e.events
								  .on("beforeDestruct", function () {
									t.destruct();
								  })
								  .fire("previewOpened");
							},
						  },
						  {
							icon: "upload",
							title: "Download",
							exec: function () {
							  var t = v("href");
							  t && e.ow.open(t);
							},
						  },
						]));
					}, e.defaultTimeout),
					e.e
					  .on("beforeClose", function () {
						return t.close();
					  })
					  .on("beforeDestruct", function () {
						return t.destruct();
					  }),
					o.stopPropagation(),
					o.preventDefault(),
					!1
				  );
				}
			  };
			};
		  },
		  66267: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.elementsMap = void 0);
			var o = new WeakMap();
			t.elementsMap = function (e) {
			  var t = o.get(e);
			  return t || o.set(e, (t = {})), t;
			};
		  },
		  63511: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.FileBrowserItem = void 0);
			var n = o(40332),
			  r = (function () {
				function e(e) {
				  var t = this;
				  (this.data = e),
					Object.keys(e).forEach(function (o) {
					  t[o] = e[o];
					});
				}
				return (
				  (e.create = function (t) {
					return t instanceof e ? t : new e(t);
				  }),
				  Object.defineProperty(e.prototype, "path", {
					get: function () {
					  return (0, n.normalizePath)(
						this.data.source.path ? this.data.source.path + "/" : "/",
					  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(e.prototype, "imageURL", {
					get: function () {
					  var e = this.time || new Date().getTime().toString(),
						t = this.data,
						o = t.source,
						r = t.thumb || t.file;
					  return t.thumbIsAbsolute && r
						? r
						: (0, n.normalizeUrl)(o.baseurl, o.path, r || "") +
							"?_tmst=" +
							encodeURIComponent(e);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(e.prototype, "fileURL", {
					get: function () {
					  var e = this.data.name,
						t = this.data,
						o = t.file,
						r = t.source;
					  return (
						void 0 !== o && (e = o),
						t.fileIsAbsolute && e
						  ? e
						  : (0, n.normalizeUrl)(r.baseurl, r.path, e || "")
					  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(e.prototype, "time", {
					get: function () {
					  var e = this.data.changed;
					  return (
						(e &&
						  ("number" == typeof e
							? new Date(e).toLocaleString()
							: e)) ||
						""
					  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(e.prototype, "uniqueHashKey", {
					get: function () {
					  var e = this.data;
					  return [e.sourceName, e.name, e.file, this.time, e.thumb]
						.join("_")
						.toLowerCase()
						.replace(/[^0-9a-z\-.]/g, "-");
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (e.prototype.toJSON = function () {
					return this.data;
				  }),
				  e
				);
			  })();
			t.FileBrowserItem = r;
		  },
		  38097: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255),
			  r = o(93166),
			  i = o(10172),
			  a = o(41374),
			  s = o(6102);
			(r.Config.prototype.filebrowser = {
			  namespace: "",
			  extraButtons: [],
			  filter: function (e, t) {
				return (
				  (t = t.toLowerCase()),
				  (0, i.isString)(e)
					? -1 !== e.toLowerCase().indexOf(t)
					: (0, i.isString)(e.name)
					  ? -1 !== e.name.toLowerCase().indexOf(t)
					  : !(0, i.isString)(e.file) ||
						-1 !== e.file.toLowerCase().indexOf(t)
				);
			  },
			  sortBy: "changed-desc",
			  sort: function (e, t, o) {
				var r = n.__read(o.toLowerCase().split("-"), 2),
				  a = r[0],
				  l = "asc" === r[1],
				  c = function (e, t) {
					return t > e ? (l ? -1 : 1) : e > t ? (l ? 1 : -1) : 0;
				  };
				if ((0, i.isString)(e))
				  return c(e.toLowerCase(), t.toLowerCase());
				if (void 0 === e[a] || "name" === a)
				  return (0, i.isString)(e.name)
					? c(e.name.toLowerCase(), t.name.toLowerCase())
					: (0, i.isString)(e.file)
					  ? c(e.file.toLowerCase(), t.file.toLowerCase())
					  : 0;
				switch (a) {
				  case "changed":
					var u = new Date(e.changed).getTime(),
					  d = new Date(t.changed).getTime();
					return l ? u - d : d - u;
				  case "size":
					return (
					  (u = (0, s.humanSizeToBytes)(e.size)),
					  (d = (0, s.humanSizeToBytes)(t.size)),
					  l ? u - d : d - u
					);
				}
				return 0;
			  },
			  editImage: !0,
			  preview: !0,
			  showPreviewNavigation: !0,
			  showSelectButtonInPreview: !0,
			  contextMenu: !0,
			  howLongShowMsg: 3e3,
			  createNewFolder: !0,
			  deleteFolder: !0,
			  renameFolder: !0,
			  moveFolder: !0,
			  moveFile: !0,
			  permissionsPresets: {
				allowFileDownload: void 0,
				allowFileMove: void 0,
				allowFileRemove: void 0,
				allowFileRename: void 0,
				allowFileUpload: void 0,
				allowFileUploadRemote: void 0,
				allowFiles: void 0,
				allowFolderCreate: void 0,
				allowFolderMove: void 0,
				allowFolderRemove: void 0,
				allowFolderRename: void 0,
				allowFolderTree: void 0,
				allowFolders: void 0,
				allowGeneratePdf: void 0,
				allowImageCrop: void 0,
				allowImageResize: void 0,
			  },
			  showFoldersPanel: !0,
			  storeLastOpenedFolder: !0,
			  width: 859,
			  height: 400,
			  buttons: [
				"filebrowser.upload",
				"filebrowser.remove",
				"filebrowser.update",
				"filebrowser.select",
				"filebrowser.edit",
				"|",
				"filebrowser.tiles",
				"filebrowser.list",
				"|",
				"filebrowser.filter",
				"|",
				"filebrowser.sort",
			  ],
			  removeButtons: [],
			  fullsize: !1,
			  showTooltip: !0,
			  view: null,
			  isSuccess: function (e) {
				return e.success;
			  },
			  getMessage: function (e) {
				return void 0 !== e.data.messages &&
				  (0, i.isArray)(e.data.messages)
				  ? e.data.messages.join(" ")
				  : "";
			  },
			  showFileName: !0,
			  showFileSize: !0,
			  showFileChangeTime: !0,
			  saveStateInStorage: {
				storeLastOpenedFolder: !0,
				storeView: !0,
				storeSortBy: !0,
			  },
			  pixelOffsetLoadNewChunk: 200,
			  getThumbTemplate: function (e, t, o) {
				var n = this.options,
				  r = this.files.getFullElName("item"),
				  i = n.showFileName,
				  a = n.showFileSize && e.size,
				  s = n.showFileChangeTime && e.time,
				  l = "";
				void 0 !== e.file && (l = e.file);
				var c = '<div class="'
				  .concat(r, '-info">')
				  .concat(
					i
					  ? '<span class="'
						  .concat(r, '-info-filename">')
						  .concat(l, "</span>")
					  : "",
				  )
				  .concat(
					a
					  ? '<span class="'
						  .concat(r, '-info-filesize">')
						  .concat(e.size, "</span>")
					  : "",
				  )
				  .concat(
					s
					  ? '<span class="'
						  .concat(r, '-info-filechanged">')
						  .concat(s, "</span>")
					  : "",
					"</div>",
				  );
				return '<a\n\t\t\tdata-jodit-filebrowser-item="true"\n\t\t\tdata-is-file="'
				  .concat(
					e.isImage ? 0 : 1,
					'"\n\t\t\tdraggable="true"\n\t\t\tclass="',
				  )
				  .concat(r, '"\n\t\t\thref="')
				  .concat(e.fileURL, '"\n\t\t\tdata-source="')
				  .concat(o, '"\n\t\t\tdata-path="')
				  .concat(e.path, '"\n\t\t\tdata-name="')
				  .concat(l, '"\n\t\t\ttitle="')
				  .concat(l, '"\n\t\t\tdata-url="')
				  .concat(e.fileURL, '">\n\t\t\t\t<img\n\t\t\t\t\tdata-is-file="')
				  .concat(e.isImage ? 0 : 1, '"\n\t\t\t\t\tdata-src="')
				  .concat(e.fileURL, '"\n\t\t\t\t\tsrc="')
				  .concat(e.imageURL, '"\n\t\t\t\t\talt="')
				  .concat(l, '"\n\t\t\t\t\tloading="lazy"\n\t\t\t\t/>\n\t\t\t\t')
				  .concat(i || a || s ? c : "", "\n\t\t\t</a>");
			  },
			  ajax: n.__assign(
				n.__assign({}, r.Config.prototype.defaultAjaxOptions),
				{
				  url: "",
				  data: {},
				  cache: !0,
				  contentType: "application/x-www-form-urlencoded; charset=UTF-8",
				  method: "POST",
				  processData: !0,
				  headers: {},
				  prepareData: function (e) {
					return e;
				  },
				  process: function (e) {
					return e;
				  },
				},
			  ),
			  create: { data: { action: "folderCreate" } },
			  getLocalFileByUrl: { data: { action: "getLocalFileByUrl" } },
			  resize: { data: { action: "imageResize" } },
			  crop: { data: { action: "imageCrop" } },
			  fileMove: { data: { action: "fileMove" } },
			  folderMove: { data: { action: "folderMove" } },
			  fileRename: { data: { action: "fileRename" } },
			  folderRename: { data: { action: "folderRename" } },
			  fileRemove: { data: { action: "fileRemove" } },
			  folderRemove: { data: { action: "folderRemove" } },
			  items: { data: { action: "files" } },
			  folder: { data: { action: "folders" } },
			  permissions: { data: { action: "permissions" } },
			}),
			  (r.Config.prototype.controls.filebrowser = {
				upload: {
				  icon: "plus",
				  isInput: !0,
				  isDisabled: function (e) {
					return !e.dataProvider.canI("FileUpload");
				  },
				  getContent: function (e) {
					var t = new a.UIFileInput(e, {
					  onlyImages: e.state.onlyImages,
					});
					return (
					  e.e.fire("bindUploader.filebrowser", t.container),
					  t.container
					);
				  },
				},
				remove: {
				  icon: "bin",
				  isDisabled: function (e) {
					return (
					  !e.state.activeElements.length ||
					  !e.dataProvider.canI("FileRemove")
					);
				  },
				  exec: function (e) {
					e.e.fire("fileRemove.filebrowser");
				  },
				},
				update: {
				  exec: function (e) {
					e.e.fire("update.filebrowser");
				  },
				},
				select: {
				  icon: "check",
				  isDisabled: function (e) {
					return !e.state.activeElements.length;
				  },
				  exec: function (e) {
					e.e.fire("select.filebrowser");
				  },
				},
				edit: {
				  icon: "pencil",
				  isDisabled: function (e) {
					var t = e.state.activeElements;
					return (
					  1 !== t.length ||
					  !t[0].isImage ||
					  !(
						e.dataProvider.canI("ImageCrop") ||
						e.dataProvider.canI("ImageResize")
					  )
					);
				  },
				  exec: function (e) {
					e.e.fire("edit.filebrowser");
				  },
				},
				tiles: {
				  icon: "th",
				  isActive: function (e) {
					return "tiles" === e.state.view;
				  },
				  exec: function (e) {
					e.e.fire("view.filebrowser", "tiles");
				  },
				},
				list: {
				  icon: "th-list",
				  isActive: function (e) {
					return "list" === e.state.view;
				  },
				  exec: function (e) {
					e.e.fire("view.filebrowser", "list");
				  },
				},
				filter: {
				  isInput: !0,
				  getContent: function (e, t, o) {
					var n = o.container.querySelector(".jodit-input");
					if (n) return n;
					var r = e.c.element("input", {
					  class: "jodit-input",
					  placeholder: e.i18n("Filter"),
					});
					return (
					  (r.value = e.state.filterWord),
					  e.e.on(
						r,
						"keydown mousedown",
						e.async.debounce(function () {
						  e.e.fire("filter.filebrowser", r.value);
						}, e.defaultTimeout),
					  ),
					  r
					);
				  },
				},
				sort: {
				  isInput: !0,
				  getContent: function (e) {
					var t = e.c.fromHTML(
					  '<select class="jodit-input jodit-select">' +
						'<option value="changed-asc">'.concat(
						  e.i18n("Sort by changed"),
						  " (⬆)</option>",
						) +
						'<option value="changed-desc">'.concat(
						  e.i18n("Sort by changed"),
						  " (⬇)</option>",
						) +
						'<option value="name-asc">'.concat(
						  e.i18n("Sort by name"),
						  " (⬆)</option>",
						) +
						'<option value="name-desc">'.concat(
						  e.i18n("Sort by name"),
						  " (⬇)</option>",
						) +
						'<option value="size-asc">'.concat(
						  e.i18n("Sort by size"),
						  " (⬆)</option>",
						) +
						'<option value="size-desc">'.concat(
						  e.i18n("Sort by size"),
						  " (⬇)</option>",
						) +
						"</select>",
					);
					return (
					  (t.value = e.state.sortBy),
					  e.e
						.on("sort.filebrowser", function (e) {
						  t.value !== e && (t.value = e);
						})
						.on(t, "change", function () {
						  e.e.fire("sort.filebrowser", t.value);
						}),
					  t
					);
				  },
				},
			  });
		  },
		  82530: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.DEFAULT_SOURCE_NAME = void 0);
			var n = o(20255),
			  r = o(40332),
			  i = o(30056),
			  a = o(43441),
			  s = o(63511);
			t.DEFAULT_SOURCE_NAME = "default";
			var l = (function () {
			  function e(e, t) {
				(this.parent = e),
				  (this.options = t),
				  (this.__currentPermissions = null),
				  (this.ajaxInstances = new Map()),
				  (this.progressHandler = function (e) {});
			  }
			  return (
				Object.defineProperty(e.prototype, "o", {
				  get: function () {
					return this.options;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.get = function (e) {
				  var t = this,
					o = this.ajaxInstances;
				  if (o.has(e)) {
					var n = o.get(e);
					null == n || n.abort(), o.delete(e);
				  }
				  var a = (0, r.ConfigProto)(
					void 0 !== this.options[e] ? this.options[e] : {},
					(0, r.ConfigProto)(
					  { onProgress: this.progressHandler },
					  this.o.ajax,
					),
				  );
				  a.prepareData && (a.data = a.prepareData.call(this, a.data));
				  var s = new i.Ajax(a);
				  o.set(e, s);
				  var l = s.send();
				  return (
					l
					  .finally(function () {
						s.destruct(), o.delete(e), t.progressHandler(100);
					  })
					  .catch(function () {
						return null;
					  }),
					l
					  .then(function (e) {
						return e.json();
					  })
					  .then(function (e) {
						if (e && !t.isSuccess(e))
						  throw new Error(t.getMessage(e));
						return e;
					  })
				  );
				}),
				(e.prototype.onProgress = function (e) {
				  this.progressHandler = e;
				}),
				(e.prototype.permissions = function (e, t) {
				  return n.__awaiter(this, void 0, Promise, function () {
					var o = this;
					return n.__generator(this, function (n) {
					  return this.o.permissions
						? ((this.o.permissions.data.path = e),
						  (this.o.permissions.data.source = t),
						  this.o.permissions.url
							? [
								2,
								this.get("permissions").then(function (e) {
								  var t = o.o.permissions.process;
								  if ((t || (t = o.o.ajax.process), t)) {
									var n = t.call(self, e);
									n.data.permissions &&
									  (o.__currentPermissions =
										n.data.permissions);
								  }
								  return o.__currentPermissions;
								}),
							  ]
							: [2, null])
						: [2, null];
					});
				  });
				}),
				(e.prototype.canI = function (e) {
				  var t = "allow" + e,
					o = this.o.permissionsPresets[t];
				  return void 0 !== o
					? o
					: null == this.__currentPermissions ||
						void 0 === this.__currentPermissions[t] ||
						this.__currentPermissions[t];
				}),
				(e.prototype.__items = function (e, t, o, n) {
				  var r = this,
					i = this.options;
				  return i.items
					? ((i.items.data.path = e),
					  (i.items.data.source = t),
					  (i.items.data.mods = o),
					  this.get("items").then(function (e) {
						var t = r.o.items.process;
						return (
						  t || (t = r.o.ajax.process),
						  t && (e = t.call(self, e)),
						  n(e)
						);
					  }))
					: Promise.reject("Set Items api options");
				}),
				(e.prototype.items = function (e, t, o) {
				  var n = this;
				  return (
					void 0 === o && (o = {}),
					this.__items(e, t, o, function (e) {
					  return n.generateItemsList(e.data.sources, o);
					})
				  );
				}),
				(e.prototype.itemsEx = function (e, t, o) {
				  var n = this;
				  return (
					void 0 === o && (o = {}),
					this.__items(e, t, o, function (e) {
					  return {
						items: n.generateItemsList(e.data.sources, o),
						loadedTotal:
						  ((t = e.data.sources),
						  t.reduce(function (e, t) {
							return e + t.files.length;
						  }, 0)),
					  };
					  var t;
					})
				  );
				}),
				(e.prototype.generateItemsList = function (e, t) {
				  var o = this;
				  void 0 === t && (t = {});
				  var i = [];
				  return (
					e.forEach(function (e) {
					  if (e.files && e.files.length) {
						var a = o.o.sort;
						(0, r.isFunction)(a) &&
						  t.sortBy &&
						  e.files.sort(function (e, o) {
							return a(e, o, t.sortBy);
						  }),
						  e.files.forEach(function (r) {
							(function (e) {
							  var n;
							  return (
								!(null === (n = t.filterWord) || void 0 === n
								  ? void 0
								  : n.length) ||
								void 0 === o.o.filter ||
								o.o.filter(e, t.filterWord)
							  );
							})(r) &&
							  (function (e) {
								return (
								  "folder" === e.type ||
								  !t.onlyImages ||
								  void 0 === e.isImage ||
								  e.isImage
								);
							  })(r) &&
							  i.push(
								s.FileBrowserItem.create(
								  n.__assign(n.__assign({}, r), {
									sourceName: e.name,
									source: e,
								  }),
								),
							  );
						  });
					  }
					}),
					i
				  );
				}),
				(e.prototype.tree = function (e, t) {
				  return n.__awaiter(this, void 0, Promise, function () {
					var o = this;
					return n.__generator(this, function (n) {
					  switch (n.label) {
						case 0:
						  return (
							(e = (0, r.normalizeRelativePath)(e)),
							this.o.folder
							  ? [4, this.permissions(e, t)]
							  : [2, Promise.reject("Set Folder Api options")]
						  );
						case 1:
						  return (
							n.sent(),
							(this.o.folder.data.path = e),
							(this.o.folder.data.source = t),
							[
							  2,
							  this.get("folder").then(function (e) {
								var t = o.o.folder.process;
								return (
								  t || (t = o.o.ajax.process),
								  t && (e = t.call(self, e)),
								  e.data.sources
								);
							  }),
							]
						  );
					  }
					});
				  });
				}),
				(e.prototype.getPathByUrl = function (e) {
				  var t = this;
				  return (
					(0, r.set)("options.getLocalFileByUrl.data.url", e, this),
					this.get("getLocalFileByUrl").then(function (e) {
					  if (t.isSuccess(e)) return e.data;
					  throw (0, r.error)(t.getMessage(e));
					})
				  );
				}),
				(e.prototype.createFolder = function (e, t, o) {
				  var n = this,
					i = this.o.create;
				  if (!i) throw (0, r.error)("Set Create api options");
				  return (
					(i.data.source = o),
					(i.data.path = t),
					(i.data.name = e),
					this.get("create").then(function (e) {
					  if (n.isSuccess(e)) return !0;
					  throw (0, r.error)(n.getMessage(e));
					})
				  );
				}),
				(e.prototype.move = function (e, t, o, n) {
				  var i = this,
					a = n ? "fileMove" : "folderMove",
					s = this.options[a];
				  if (!s) throw (0, r.error)("Set Move api options");
				  return (
					(s.data.from = e),
					(s.data.path = t),
					(s.data.source = o),
					this.get(a).then(function (e) {
					  if (i.isSuccess(e)) return !0;
					  throw (0, r.error)(i.getMessage(e));
					})
				  );
				}),
				(e.prototype.remove = function (e, t, o, n) {
				  var i = this,
					a = this.o[e];
				  if (!a) throw (0, r.error)('Set "'.concat(e, '" api options'));
				  return (
					(a.data.path = t),
					(a.data.name = o),
					(a.data.source = n),
					this.get(e).then(function (e) {
					  return (
						a.process && (e = a.process.call(i, e)), i.getMessage(e)
					  );
					})
				  );
				}),
				(e.prototype.fileRemove = function (e, t, o) {
				  return this.remove("fileRemove", e, t, o);
				}),
				(e.prototype.folderRemove = function (e, t, o) {
				  return this.remove("folderRemove", e, t, o);
				}),
				(e.prototype.rename = function (e, t, o, n, i) {
				  var a = this,
					s = this.o[e];
				  if (!s) throw (0, r.error)('Set "'.concat(e, '" api options'));
				  return (
					(s.data.path = t),
					(s.data.name = o),
					(s.data.newname = n),
					(s.data.source = i),
					this.get(e).then(function (e) {
					  return (
						s.process && (e = s.process.call(self, e)),
						a.getMessage(e)
					  );
					})
				  );
				}),
				(e.prototype.folderRename = function (e, t, o, n) {
				  return this.rename("folderRename", e, t, o, n);
				}),
				(e.prototype.fileRename = function (e, t, o, n) {
				  return this.rename("fileRename", e, t, o, n);
				}),
				(e.prototype.changeImage = function (e, t, o, n, r, i) {
				  this.o[e] || (this.o[e] = { data: {} });
				  var a = this.o[e];
				  return (
					void 0 === a.data && (a.data = { action: e }),
					(a.data.newname = r || n),
					i && (a.data.box = i),
					(a.data.path = t),
					(a.data.name = n),
					(a.data.source = o),
					this.get(e).then(function () {
					  return !0;
					})
				  );
				}),
				(e.prototype.crop = function (e, t, o, n, r) {
				  return this.changeImage("crop", e, t, o, n, r);
				}),
				(e.prototype.resize = function (e, t, o, n, r) {
				  return this.changeImage("resize", e, t, o, n, r);
				}),
				(e.prototype.getMessage = function (e) {
				  return this.options.getMessage(e);
				}),
				(e.prototype.isSuccess = function (e) {
				  return this.options.isSuccess(e);
				}),
				(e.prototype.destruct = function () {
				  this.ajaxInstances.forEach(function (e) {
					return e.destruct();
				  }),
					this.ajaxInstances.clear();
				}),
				n.__decorate([a.autobind], e)
			  );
			})();
			t.default = l;
		  },
		  46341: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.makeContextMenu = t.makeDataProvider = void 0);
			var n = o(82530),
			  r = o(60403);
			(t.makeDataProvider = function (e, t) {
			  return new n.default(e, t);
			}),
			  (t.makeContextMenu = function (e) {
				return new r.ContextMenu(e);
			  });
		  },
		  48096: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.deleteFile = void 0),
			  (t.deleteFile = function (e, t, o) {
				return e.dataProvider
				  .fileRemove(e.state.currentPath, t, o)
				  .then(function (o) {
					e.status(o || e.i18n('File "%s" was deleted', t), !0);
				  })
				  .catch(e.status);
			  });
		  },
		  4253: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.loadItems = void 0),
			  (t.loadItems = function (e) {
				return (
				  e.files.setMod("active", !0),
				  e.files.setMod("loading", !0),
				  e.dataProvider
					.items(e.state.currentPath, e.state.currentSource, {
					  sortBy: e.state.sortBy,
					  onlyImages: e.state.onlyImages,
					  filterWord: e.state.filterWord,
					})
					.then(function (t) {
					  t &&
						((e.state.elements = t), (e.state.activeElements = []));
					})
					.catch(e.status)
					.finally(function () {
					  return e.files.setMod("loading", !1);
					})
				);
			  });
		  },
		  36303: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.loadTree = void 0);
			var n = o(20255),
			  r = o(64968),
			  i = o(4253);
			t.loadTree = function (e) {
			  return n.__awaiter(this, void 0, Promise, function () {
				var t, o;
				return n.__generator(this, function (n) {
				  return (
					e.tree.setMod("active", !0),
					r.Dom.detach(e.tree.container),
					(t = (0, i.loadItems)(e)),
					e.o.showFoldersPanel
					  ? (e.tree.setMod("loading", !0),
						(o = e.dataProvider
						  .tree(e.state.currentPath, e.state.currentSource)
						  .then(function (t) {
							e.state.sources = t;
						  })
						  .catch(e.status)
						  .finally(function () {
							return e.tree.setMod("loading", !1);
						  })),
						[2, Promise.all([o, t])])
					  : (e.tree.setMod("active", !1), [2, t])
				  );
				});
			  });
			};
		  },
		  50885: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isFileBrowserFilesItem = t.FileBrowser = void 0);
			var n = o(20255);
			o(40692);
			var r = o(93166),
			  i = o(86893),
			  a = o(77462),
			  s = o(40332),
			  l = o(64968),
			  c = o(46341),
			  u = o(86774),
			  d = o(21347),
			  p = o(44734),
			  f = o(82530),
			  h = o(43441),
			  m = o(98782),
			  v = o(55395),
			  g = o(36303),
			  y = o(4253),
			  _ = o(56562),
			  b = o(59829),
			  w = o(43608);
			o(38097);
			var S = (function (e) {
			  function t(t) {
				var o,
				  n = this;
				((n = e.call(this, t) || this).browser = n.c.div(
				  n.componentName,
				)),
				  (n.status_line = n.c.div(n.getFullElName("status"))),
				  (n.tree = new m.FileBrowserTree(n)),
				  (n.files = new m.FileBrowserFiles(n)),
				  (n.state = (0, v.observable)({
					currentPath: "",
					currentSource: f.DEFAULT_SOURCE_NAME,
					currentBaseUrl: "",
					activeElements: [],
					elements: [],
					sources: [],
					view: "tiles",
					sortBy: "changed-desc",
					filterWord: "",
					onlyImages: !1,
				  })),
				  (n.errorHandler = function (e) {
					(0, s.isAbort)(e) ||
					  (e instanceof Error
						? n.status(n.i18n(e.message))
						: n.status(n.dataProvider.getMessage(e)));
				  }),
				  (n.close = function () {
					n._dialog.close();
				  }),
				  n.attachEvents(t);
				var i = n;
				(i.options = (0, s.ConfigProto)(
				  t || {},
				  r.Config.defaultOptions.filebrowser,
				)),
				  (i.storage = a.Storage.makeStorage(
					Boolean(n.o.saveStateInStorage),
					n.componentName,
				  )),
				  (i.dataProvider = (0, c.makeDataProvider)(i, i.options)),
				  (i._dialog = n.dlg({
					minWidth: Math.min(700, screen.width),
					minHeight: 300,
					buttons:
					  null !== (o = n.o.headerButtons) && void 0 !== o
						? o
						: ["fullsize", "dialog.close"],
				  })),
				  n.proxyDialogEvents(i),
				  (i.browser.component = n),
				  (i.container = i.browser),
				  i.o.showFoldersPanel && i.browser.appendChild(i.tree.container),
				  i.browser.appendChild(i.files.container),
				  i.browser.appendChild(i.status_line),
				  p.selfListeners.call(i),
				  d.nativeListeners.call(i),
				  u.stateListeners.call(i),
				  i._dialog.setSize(i.o.width, i.o.height),
				  [
					"getLocalFileByUrl",
					"crop",
					"resize",
					"create",
					"fileMove",
					"folderMove",
					"fileRename",
					"folderRename",
					"fileRemove",
					"folderRemove",
					"folder",
					"items",
					"permissions",
				  ].forEach(function (e) {
					null != n.options[e] &&
					  (n.options[e] = (0, s.ConfigProto)(n.options[e], n.o.ajax));
				  });
				var l = n.o.saveStateInStorage || {
					storeLastOpenedFolder: !1,
					storeView: !1,
					storeSortBy: !1,
				  },
				  h = l.storeSortBy,
				  g = l.storeLastOpenedFolder,
				  y = l.storeView && n.storage.get("view");
				(i.state.view =
				  y && null == n.o.view
					? "list" === y
					  ? "list"
					  : "tiles"
					: "list" === i.o.view
					  ? "list"
					  : "tiles"),
				  i.files.setMod("view", i.state.view);
				var b = h && i.storage.get("sortBy");
				if (b) {
				  var w = b.split("-");
				  i.state.sortBy = ["changed", "name", "size"].includes(w[0])
					? b
					: "changed-desc";
				} else i.state.sortBy = i.o.sortBy || "changed-desc";
				if (g) {
				  var S = i.storage.get("currentPath"),
					C = i.storage.get("currentSource");
				  (i.state.currentPath = null != S ? S : ""),
					(i.state.currentSource = null != C ? C : "");
				}
				return i.initUploader(i), i.setStatus(_.STATUSES.ready), n;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.className = function () {
				  return "Filebrowser";
				}),
				(t.prototype.onSelect = function (e) {
				  var t = this;
				  return function () {
					if (t.state.activeElements.length) {
					  var o = [],
						n = [];
					  t.state.activeElements.forEach(function (e) {
						var t = e.fileURL;
						t && (o.push(t), n.push(e.isImage || !1));
					  }),
						t.close();
					  var r = { baseurl: "", files: o, isImages: n };
					  (0, s.isFunction)(e) && e(r), t.close();
					}
					return !1;
				  };
				}),
				Object.defineProperty(t.prototype, "isOpened", {
				  get: function () {
					return (
					  this._dialog.isOpened &&
					  "none" !== this.browser.style.display
					);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.status = function (e, t) {
				  e &&
					!(0, s.isAbort)(e) &&
					((0, s.isString)(e) || (e = e.message),
					(0, s.isString)(e) &&
					  (0, s.trim)(e).length &&
					  this.message.message(
						e,
						t ? "success" : "error",
						this.o.howLongShowMsg,
					  ));
				}),
				(t.prototype.open = function (e, t) {
				  var o = this;
				  return (
					void 0 === e && (e = this.o.defaultCallback),
					void 0 === t && (t = !1),
					(this.state.onlyImages = t),
					this.async.promise(function (t, n) {
					  if (!o.o.items || !o.o.items.url)
						throw (0, s.error)(
						  "Need set options.filebrowser.ajax.url",
						);
					  var r = 0;
					  o.e
						.off(o.files.container, "dblclick")
						.on(o.files.container, "dblclick", o.onSelect(e))
						.on(o.files.container, "touchstart", function () {
						  var t = new Date().getTime();
						  i.EMULATE_DBLCLICK_TIMEOUT > t - r && o.onSelect(e)(),
							(r = t);
						})
						.off("select.filebrowser")
						.on("select.filebrowser", o.onSelect(e));
					  var a = o.c.div();
					  o.toolbar.build(o.__getButtons()).appendTo(a),
						o._dialog.open(o.browser, a),
						o.e.fire("sort.filebrowser", o.state.sortBy),
						(0, g.loadTree)(o).then(t, n);
					})
				  );
				}),
				(t.prototype.__getButtons = function () {
				  var e,
					t = this;
				  return (
					null !== (e = this.o.buttons) && void 0 !== e ? e : []
				  ).filter(function (e) {
					if (!(0, s.isString)(e)) return !0;
					switch (e) {
					  case "filebrowser.upload":
						return t.dataProvider.canI("FileUpload");
					  case "filebrowser.edit":
						return (
						  t.dataProvider.canI("ImageResize") ||
						  t.dataProvider.canI("ImageCrop")
						);
					  case "filebrowser.remove":
						return t.dataProvider.canI("FileRemove");
					}
					return !0;
				  });
				}),
				(t.prototype.initUploader = function (e) {
				  var t,
					o = this,
					n = this,
					i =
					  null === (t = null == e ? void 0 : e.options) ||
					  void 0 === t
						? void 0
						: t.uploader,
					a = (0, s.ConfigProto)(
					  i || {},
					  r.Config.defaultOptions.uploader,
					),
					l = function () {
					  return (0, y.loadItems)(o);
					};
				  (n.uploader = n.getInstance("Uploader", a)),
					n.uploader
					  .setPath(n.state.currentPath)
					  .setSource(n.state.currentSource)
					  .bind(n.browser, l, n.errorHandler),
					this.state.on(
					  ["change.currentPath", "change.currentSource"],
					  function () {
						o.uploader
						  .setPath(o.state.currentPath)
						  .setSource(o.state.currentSource);
					  },
					),
					n.e.on("bindUploader.filebrowser", function (e) {
					  n.uploader.bind(e, l, n.errorHandler);
					});
				}),
				(t.prototype.proxyDialogEvents = function (e) {
				  var t = this;
				  ["afterClose", "beforeOpen"].forEach(function (o) {
					e._dialog.events.on(e.dlg, o, function () {
					  t.e.fire(o);
					});
				  });
				}),
				(t.prototype.destruct = function () {
				  this.isInDestruct ||
					(e.prototype.destruct.call(this),
					this._dialog.destruct(),
					this.events && this.e.off(".filebrowser"),
					this.uploader && this.uploader.destruct());
				}),
				n.__decorate([h.autobind], t.prototype, "status", null),
				n.__decorate([h.autobind], t.prototype, "open", null),
				n.__decorate([(0, h.derive)(b.Dlgs)], t)
			  );
			})(w.ViewWithToolbar);
			(t.FileBrowser = S),
			  (t.isFileBrowserFilesItem = function (e) {
				return (
				  l.Dom.isElement(e) &&
				  e.classList.contains(
					m.FileBrowserFiles.prototype.getFullElName("item"),
				  )
				);
			  });
		  },
		  63463: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(50885), t);
		  },
		  21347: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.nativeListeners = t.elementToItem = t.getItem = void 0);
			var n = o(20255),
			  r = o(40332),
			  i = o(34468),
			  a = o(64968),
			  s = o(66267),
			  l = o(36303);
			(t.getItem = function (e, t, o) {
			  return (
				void 0 === o && (o = "a"),
				a.Dom.closest(
				  e,
				  function (e) {
					return a.Dom.isTag(e, o);
				  },
				  t,
				)
			  );
			}),
			  (t.elementToItem = function (e, t) {
				return t[e.dataset.key || ""].item;
			  }),
			  (t.nativeListeners = function () {
				var e = this,
				  o = !1,
				  a = (0, s.elementsMap)(this),
				  c = this;
				c.e
				  .on(c.tree.container, "dragstart", function (e) {
					var n = (0, t.getItem)(e.target, c.container);
					n && c.o.moveFolder && (o = n);
				  })
				  .on(c.tree.container, "drop", function (n) {
					if ((c.o.moveFile || c.o.moveFolder) && o) {
					  var i = (0, r.attr)(o, "-path") || "";
					  if (
						!c.o.moveFolder &&
						o.classList.contains(e.tree.getFullElName("item"))
					  )
						return !1;
					  if (
						o.classList.contains(e.files.getFullElName("item")) &&
						((i += (0, r.attr)(o, "-name")), !c.o.moveFile)
					  )
						return !1;
					  var a = (0, t.getItem)(n.target, c.container);
					  if (!a) return;
					  c.dataProvider
						.move(
						  i,
						  (0, r.attr)(a, "-path") || "",
						  (0, r.attr)(a, "-source") || "",
						  o.classList.contains(e.files.getFullElName("item")),
						)
						.then(function () {
						  return (0, l.loadTree)(e);
						})
						.catch(c.status),
						(o = !1);
					}
				  })
				  .on(c.files.container, "contextmenu", (0, i.default)(c))
				  .on(c.files.container, "click", function (t) {
					(0, r.ctrlKey)(t) || (e.state.activeElements = []);
				  })
				  .on(c.files.container, "click", function (e) {
					var o = (0, t.getItem)(e.target, c.container);
					if (o) {
					  var i = (0, t.elementToItem)(o, a);
					  if (i)
						return (
						  (c.state.activeElements = (0, r.ctrlKey)(e)
							? n.__spreadArray(
								n.__spreadArray(
								  [],
								  n.__read(c.state.activeElements),
								  !1,
								),
								[i],
								!1,
							  )
							: [i]),
						  e.stopPropagation(),
						  !1
						);
					}
				  })
				  .on(c.files.container, "dragstart", function (e) {
					if (c.o.moveFile) {
					  var n = (0, t.getItem)(e.target, c.container);
					  if (!n) return;
					  o = n;
					}
				  })
				  .on(c.container, "drop", function (e) {
					return e.preventDefault();
				  });
			  });
		  },
		  44734: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.selfListeners = void 0);
			var n = o(20255),
			  r = o(10172),
			  i = o(40332),
			  a = o(82530),
			  s = o(35503),
			  l = o(36303),
			  c = o(4253),
			  u = o(48096);
			t.selfListeners = function () {
			  var e = this,
				t = this.state,
				o = this.dataProvider,
				d = this;
			  d.e
				.on("view.filebrowser", function (e) {
				  e !== t.view && (t.view = e);
				})
				.on("sort.filebrowser", function (e) {
				  e !== t.sortBy && ((t.sortBy = e), (0, c.loadItems)(d));
				})
				.on("filter.filebrowser", function (e) {
				  e !== t.filterWord && ((t.filterWord = e), (0, c.loadItems)(d));
				})
				.on("openFolder.filebrowser", function (e) {
				  var t;
				  (t =
					".." === e.name
					  ? e.path
						  .split("/")
						  .filter(function (e) {
							return e.length;
						  })
						  .slice(0, -1)
						  .join("/")
					  : (0, i.normalizePath)(e.path, e.name)),
					(d.state.currentPath = t),
					(d.state.currentSource =
					  "." === e.name ? a.DEFAULT_SOURCE_NAME : e.source);
				})
				.on("removeFolder.filebrowser", function (e) {
				  d.confirm("Are you sure?", "Delete", function (t) {
					t &&
					  o
						.folderRemove(e.path, e.name, e.source)
						.then(function (e) {
						  return d.status(e, !0), (0, l.loadTree)(d);
						})
						.catch(d.status);
				  });
				})
				.on("renameFolder.filebrowser", function (e) {
				  d.prompt(
					"Enter new name",
					"Rename",
					function (t) {
					  if (!(0, r.isValidName)(t))
						return d.status(d.i18n("Enter new name")), !1;
					  o.folderRename(e.path, e.name, t, e.source)
						.then(function (e) {
						  return (
							(d.state.activeElements = []),
							d.status(e, !0),
							(0, l.loadTree)(d)
						  );
						})
						.catch(d.status);
					},
					"type name",
					e.name,
				  );
				})
				.on("addFolder.filebrowser", function (e) {
				  d.prompt(
					"Enter Directory name",
					"Create directory",
					function (t) {
					  o.createFolder(t, e.path, e.source)
						.then(function () {
						  return (0, l.loadTree)(d);
						})
						.catch(d.status);
					},
					"type name",
				  );
				})
				.on("fileRemove.filebrowser", function () {
				  d.state.activeElements.length &&
					d.confirm("Are you sure?", "", function (e) {
					  if (e) {
						var t = [];
						d.state.activeElements.forEach(function (e) {
						  t.push(
							(0, u.deleteFile)(
							  d,
							  e.file || e.name || "",
							  e.sourceName,
							),
						  );
						}),
						  (d.state.activeElements = []),
						  Promise.all(t).then(function () {
							return (0, l.loadTree)(d).catch(d.status);
						  }, d.status);
					  }
					});
				})
				.on("edit.filebrowser", function () {
				  if (1 === d.state.activeElements.length) {
					var t = n.__read(e.state.activeElements, 1)[0];
					s.openImageEditor.call(
					  d,
					  t.fileURL,
					  t.file || "",
					  t.path,
					  t.sourceName,
					);
				  }
				})
				.on("fileRename.filebrowser", function (e, t, n) {
				  1 === d.state.activeElements.length &&
					d.prompt(
					  "Enter new name",
					  "Rename",
					  function (i) {
						if (!(0, r.isValidName)(i))
						  return d.status(d.i18n("Enter new name")), !1;
						o.fileRename(t, e, i, n)
						  .then(function (e) {
							(d.state.activeElements = []),
							  d.status(e, !0),
							  (0, c.loadItems)(d);
						  })
						  .catch(d.status);
					  },
					  "type name",
					  e,
					);
				})
				.on("update.filebrowser", function () {
				  (0, l.loadTree)(e).then(e.status, e.status);
				});
			};
		  },
		  86774: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.stateListeners = void 0);
			var n = o(64968),
			  r = o(89693),
			  i = o(2074),
			  a = o(66267),
			  s = o(36303);
			t.stateListeners = function () {
			  var e = this,
				t = (0, a.elementsMap)(this),
				o = this,
				l = o.state,
				c = o.files,
				u = o.create,
				d = o.options;
			  l.on(
				["change.currentPath", "change.currentSource"],
				this.async.debounce(function () {
				  e.o.saveStateInStorage &&
					e.o.saveStateInStorage.storeLastOpenedFolder &&
					e.storage
					  .set("currentPath", e.state.currentPath)
					  .set("currentSource", e.state.currentSource),
					(0, s.loadTree)(e).catch(e.status);
				}, this.defaultTimeout),
			  )
				.on("beforeChange.activeElements", function () {
				  l.activeElements.forEach(function (e) {
					var o = t[e.uniqueHashKey].elm;
					o &&
					  o.classList.remove(c.getFullElName("item", "active", !0));
				  });
				})
				.on("change.activeElements", function () {
				  e.e.fire("changeSelection"),
					l.activeElements.forEach(function (e) {
					  var o = t[e.uniqueHashKey].elm;
					  o && o.classList.add(c.getFullElName("item", "active", !0));
					});
				})
				.on("change.view", function () {
				  c.setMod("view", l.view),
					e.o.saveStateInStorage &&
					  e.o.saveStateInStorage.storeView &&
					  e.storage.set("view", l.view);
				})
				.on("change.sortBy", function () {
				  e.o.saveStateInStorage &&
					e.o.saveStateInStorage.storeSortBy &&
					e.storage.set("sortBy", l.sortBy);
				})
				.on(
				  "change.elements",
				  this.async.debounce(function () {
					n.Dom.detach(c.container),
					  l.elements.length
						? l.elements.forEach(function (o) {
							e.files.container.appendChild(
							  (function (o) {
								var n = o.uniqueHashKey;
								if (t[n]) return t[n].elm;
								var r = u.fromHTML(
								  d.getThumbTemplate.call(
									e,
									o,
									o.source,
									o.sourceName.toString(),
								  ),
								);
								return (
								  (r.dataset.key = n),
								  (t[n] = { item: o, elm: r }),
								  t[n].elm
								);
							  })(o),
							);
						  })
						: c.container.appendChild(
							u.div(
							  e.componentName + "_no-files_true",
							  e.i18n("There are no files"),
							),
						  );
				  }, this.defaultTimeout),
				)
				.on(
				  "change.sources",
				  this.async.debounce(function () {
					n.Dom.detach(e.tree.container),
					  l.sources.forEach(function (t) {
						var o = t.name;
						if (
						  (o &&
							"default" !== o &&
							e.tree.container.appendChild(
							  u.div(e.tree.getFullElName("source-title"), o),
							),
						  t.folders.forEach(function (n) {
							var a,
							  s = u.a(
								e.tree.getFullElName("item"),
								{
								  draggable: "draggable",
								  href: "#",
								  "data-path": (0, r.normalizePath)(
									t.path,
									n + "/",
								  ),
								  "data-name": n,
								  "data-source": o,
								  "data-source-path": t.path,
								},
								u.span(e.tree.getFullElName("item-title"), n),
							  ),
							  l = function (i) {
								return function (a) {
								  e.e.fire("".concat(i, ".filebrowser"), {
									name: n,
									path: (0, r.normalizePath)(t.path + "/"),
									source: o,
								  }),
									a.stopPropagation(),
									a.preventDefault();
								};
							  };
							e.e.on(s, "click", l("openFolder")),
							  e.tree.container.appendChild(s),
							  ".." !== n &&
								"." !== n &&
								(d.renameFolder &&
								  e.dataProvider.canI("FolderRename") &&
								  ((a = (0, i.Button)(e, {
									icon: { name: "pencil" },
									name: "rename",
									tooltip: "Rename",
									size: "tiny",
								  })).onAction(l("renameFolder")),
								  s.appendChild(a.container)),
								d.deleteFolder &&
								  e.dataProvider.canI("FolderRemove") &&
								  ((a = (0, i.Button)(e, {
									icon: { name: "cancel" },
									name: "remove",
									tooltip: "Delete",
									size: "tiny",
								  })).onAction(l("removeFolder")),
								  s.appendChild(a.container)));
						  }),
						  d.createNewFolder &&
							e.dataProvider.canI("FolderCreate"))
						) {
						  var n = (0, i.Button)(
							e,
							"plus",
							"Add folder",
							"secondary",
						  );
						  n.onAction(function () {
							e.e.fire("addFolder", {
							  path: (0, r.normalizePath)(t.path + "/"),
							  source: o,
							});
						  }),
							e.tree.append(n);
						}
					  });
				  }, this.defaultTimeout),
				);
			};
		  },
		  21505: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.FileBrowserFiles = void 0);
			var n = o(20255);
			o(27452);
			var r = (function (e) {
			  function t() {
				return (null !== e && e.apply(this, arguments)) || this;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.className = function () {
				  return "FilebrowserFiles";
				}),
				t
			  );
			})(o(2074).UIGroup);
			t.FileBrowserFiles = r;
		  },
		  98782: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(21505), t), n.__exportStar(o(42472), t);
		  },
		  42472: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.FileBrowserTree = void 0);
			var n = o(20255);
			o(51422);
			var r = (function (e) {
			  function t() {
				return (null !== e && e.apply(this, arguments)) || this;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.className = function () {
				  return "FilebrowserTree";
				}),
				t
			  );
			})(o(2074).UIGroup);
			t.FileBrowserTree = r;
		  },
		  3107: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Command = void 0);
			var o = (function () {
			  function e(e, t, o, n) {
				(this.oldValue = e),
				  (this.newValue = t),
				  (this.history = o),
				  (this.tick = n);
			  }
			  return (
				(e.prototype.undo = function () {
				  this.history.snapshot.restore(this.oldValue);
				}),
				(e.prototype.redo = function () {
				  this.history.snapshot.restore(this.newValue);
				}),
				e
			  );
			})();
			t.Command = o;
		  },
		  15432: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.History = void 0);
			var n = o(20255),
			  r = o(93166),
			  i = o(56562),
			  a = o(31648),
			  s = o(3621),
			  l = o(3107),
			  c = o(43441);
			(r.Config.prototype.history = {
			  enable: !0,
			  maxHistoryLength: 1 / 0,
			  timeout: 1e3,
			}),
			  (r.Config.prototype.observer = r.Config.prototype.history);
			var u = (function (e) {
			  function t(t, o, n) {
				void 0 === o && (o = new s.Stack(t.o.history.maxHistoryLength)),
				  void 0 === n && (n = new a.Snapshot(t));
				var r = e.call(this, t) || this;
				return (
				  (r.updateTick = 0),
				  (r.__stack = o),
				  (r.snapshot = n),
				  t.o.history.enable &&
					t.e.on("afterAddPlace.history", function () {
					  r.isInDestruct ||
						((r.startValue = r.snapshot.make()),
						t.events
						  .on("internalChange internalUpdate", function () {
							r.startValue = r.snapshot.make();
						  })
						  .on(
							t.editor,
							[
							  "changeSelection",
							  "selectionstart",
							  "selectionchange",
							  "mousedown",
							  "mouseup",
							  "keydown",
							  "keyup",
							]
							  .map(function (e) {
								return e + ".history";
							  })
							  .join(" "),
							function () {
							  r.startValue.html === r.j.getNativeEditorValue() &&
								(r.startValue = r.snapshot.make());
							},
						  )
						  .on(r, "change.history", r.onChange));
					}),
				  r
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.className = function () {
				  return "History";
				}),
				Object.defineProperty(t.prototype, "startValue", {
				  get: function () {
					return this.__startValue;
				  },
				  set: function (e) {
					this.__startValue = e;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.__upTick = function () {
				  this.updateTick += 1;
				}),
				(t.prototype.onChange = function () {
				  this.__processChanges();
				}),
				(t.prototype.__processChanges = function () {
				  !this.snapshot.isBlocked &&
					this.j.o.history.enable &&
					this.updateStack();
				}),
				(t.prototype.updateStack = function (e) {
				  void 0 === e && (e = !1);
				  var t = this.snapshot.make();
				  if (!a.Snapshot.equal(t, this.startValue)) {
					var o = new l.Command(
					  this.startValue,
					  t,
					  this,
					  this.updateTick,
					);
					if (e) {
					  var n = this.__stack.current();
					  n && this.updateTick === n.tick && this.__stack.replace(o);
					} else this.__stack.push(o);
					(this.startValue = t), this.fireChangeStack();
				  }
				}),
				(t.prototype.redo = function () {
				  this.__stack.redo() &&
					((this.startValue = this.snapshot.make()),
					this.fireChangeStack());
				}),
				(t.prototype.canRedo = function () {
				  return this.__stack.canRedo();
				}),
				(t.prototype.undo = function () {
				  this.__stack.undo() &&
					((this.startValue = this.snapshot.make()),
					this.fireChangeStack());
				}),
				(t.prototype.canUndo = function () {
				  return this.__stack.canUndo();
				}),
				(t.prototype.clear = function () {
				  (this.startValue = this.snapshot.make()),
					this.__stack.clear(),
					this.fireChangeStack();
				}),
				Object.defineProperty(t.prototype, "length", {
				  get: function () {
					return this.__stack.length;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.fireChangeStack = function () {
				  var e;
				  this.j &&
					!this.j.isInDestruct &&
					(null === (e = this.j.events) ||
					  void 0 === e ||
					  e.fire("changeStack"));
				}),
				(t.prototype.destruct = function () {
				  this.isInDestruct ||
					(this.j.events && this.j.e.off(".history"),
					this.snapshot.destruct(),
					e.prototype.destruct.call(this));
				}),
				n.__decorate([(0, c.debounce)()], t.prototype, "onChange", null),
				t
			  );
			})(i.ViewComponent);
			t.History = u;
		  },
		  31648: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Snapshot = void 0);
			var n = o(20255),
			  r = o(56562),
			  i = o(64968),
			  a = o(86893),
			  s = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (t.__isBlocked = !1), t;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "Snapshot";
				  }),
				  (t.equal = function (e, t) {
					return (
					  e.html === t.html &&
					  JSON.stringify(e.range) === JSON.stringify(t.range)
					);
				  }),
				  (t.countNodesBeforeInParent = function (e) {
					if (!e.parentNode) return 0;
					for (
					  var t = e.parentNode.childNodes, o = 0, n = null, r = 0;
					  t.length > r;
					  r += 1
					) {
					  if (
						(!n ||
						  this.isIgnoredNode(t[r]) ||
						  (i.Dom.isText(n) && i.Dom.isText(t[r])) ||
						  (o += 1),
						t[r] === e)
					  )
						return o;
					  n = t[r];
					}
					return 0;
				  }),
				  (t.strokeOffset = function (e, t) {
					for (; i.Dom.isText(e); )
					  i.Dom.isText((e = e.previousSibling)) &&
						e.nodeValue &&
						(t += e.nodeValue.length);
					return t;
				  }),
				  (t.prototype.calcHierarchyLadder = function (e) {
					var o = [];
					if (
					  !e ||
					  !e.parentNode ||
					  !i.Dom.isOrContains(this.j.editor, e)
					)
					  return [];
					for (; e && e !== this.j.editor; )
					  e &&
						!t.isIgnoredNode(e) &&
						o.push(t.countNodesBeforeInParent(e)),
						(e = e.parentNode);
					return o.reverse();
				  }),
				  (t.prototype.getElementByLadder = function (e) {
					var t,
					  o = this.j.editor;
					for (t = 0; o && e.length > t; t += 1) o = o.childNodes[e[t]];
					return o;
				  }),
				  Object.defineProperty(t.prototype, "isBlocked", {
					get: function () {
					  return this.__isBlocked;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.__block = function (e) {
					this.__isBlocked = e;
				  }),
				  (t.prototype.transaction = function (e) {
					this.__block(!0);
					try {
					  e();
					} catch (e) {}
					this.__block(!1);
				  }),
				  (t.prototype.make = function () {
					var e = {
					  html: "",
					  range: {
						startContainer: [],
						startOffset: 0,
						endContainer: [],
						endOffset: 0,
					  },
					};
					e.html = this.removeJoditSelection(this.j.editor);
					var o = this.j.s.sel;
					if (o && o.rangeCount) {
					  var n = o.getRangeAt(0),
						r = this.calcHierarchyLadder(n.startContainer),
						i = this.calcHierarchyLadder(n.endContainer),
						a = t.strokeOffset(n.startContainer, n.startOffset),
						s = t.strokeOffset(n.endContainer, n.endOffset);
					  r.length || n.startContainer === this.j.editor || (a = 0),
						i.length || n.endContainer === this.j.editor || (s = 0),
						(e.range = {
						  startContainer: r,
						  startOffset: a,
						  endContainer: i,
						  endOffset: s,
						});
					}
					return e;
				  }),
				  (t.prototype.restore = function (e) {
					var t = this;
					this.transaction(function () {
					  var o = t.storeScrollState();
					  t.j.getNativeEditorValue() !== e.html &&
						(t.j.value = e.html),
						t.restoreOnlySelection(e),
						t.restoreScrollState(o);
					});
				  }),
				  (t.prototype.storeScrollState = function () {
					return [this.j.ow.scrollY, this.j.editor.scrollTop];
				  }),
				  (t.prototype.restoreScrollState = function (e) {
					var t = this.j,
					  o = t.ow;
					o.scrollTo(o.scrollX, e[0]), (t.editor.scrollTop = e[1]);
				  }),
				  (t.prototype.restoreOnlySelection = function (e) {
					try {
					  if (e.range) {
						var t = this.j.ed.createRange();
						t.setStart(
						  this.getElementByLadder(e.range.startContainer),
						  e.range.startOffset,
						),
						  t.setEnd(
							this.getElementByLadder(e.range.endContainer),
							e.range.endOffset,
						  ),
						  this.j.s.selectRange(t);
					  }
					} catch (e) {
					  this.j.editor.lastChild &&
						this.j.s.setCursorAfter(this.j.editor.lastChild);
					}
				  }),
				  (t.prototype.destruct = function () {
					this.__block(!1), e.prototype.destruct.call(this);
				  }),
				  (t.isIgnoredNode = function (e) {
					return (
					  (i.Dom.isText(e) && !e.nodeValue) || i.Dom.isTemporary(e)
					);
				  }),
				  (t.prototype.removeJoditSelection = function (e) {
					var t = e.cloneNode(!0);
					return (
					  t
						.querySelectorAll("[".concat(a.TEMP_ATTR, "]"))
						.forEach(i.Dom.unwrap),
					  t.innerHTML
					);
				  }),
				  t
				);
			  })(r.ViewComponent);
			t.Snapshot = s;
		  },
		  3621: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Stack = void 0);
			var o = (function () {
			  function e(e) {
				(this.size = e), (this.commands = []), (this.stackPosition = -1);
			  }
			  return (
				Object.defineProperty(e.prototype, "length", {
				  get: function () {
					return this.commands.length;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.clearRedo = function () {
				  this.commands.length = this.stackPosition + 1;
				}),
				(e.prototype.clear = function () {
				  (this.commands.length = 0), (this.stackPosition = -1);
				}),
				(e.prototype.push = function (e) {
				  this.clearRedo(),
					this.commands.push(e),
					(this.stackPosition += 1),
					this.commands.length > this.size &&
					  (this.commands.shift(), (this.stackPosition -= 1));
				}),
				(e.prototype.replace = function (e) {
				  this.commands[this.stackPosition] = e;
				}),
				(e.prototype.current = function () {
				  return this.commands[this.stackPosition];
				}),
				(e.prototype.undo = function () {
				  return (
					!!this.canUndo() &&
					(this.commands[this.stackPosition] &&
					  this.commands[this.stackPosition].undo(),
					(this.stackPosition -= 1),
					!0)
				  );
				}),
				(e.prototype.redo = function () {
				  return (
					!!this.canRedo() &&
					((this.stackPosition += 1),
					this.commands[this.stackPosition] &&
					  this.commands[this.stackPosition].redo(),
					!0)
				  );
				}),
				(e.prototype.canUndo = function () {
				  return this.stackPosition >= 0;
				}),
				(e.prototype.canRedo = function () {
				  return this.commands.length - 1 > this.stackPosition;
				}),
				e
			  );
			})();
			t.Stack = o;
		  },
		  95356: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(77904);
			(n.Config.prototype.imageeditor = {
			  min_width: 20,
			  min_height: 20,
			  closeAfterSave: !1,
			  width: "85%",
			  height: "85%",
			  crop: !0,
			  resize: !0,
			  resizeUseRatio: !0,
			  resizeMinWidth: 20,
			  resizeMinHeight: 20,
			  cropUseRatio: !0,
			  cropDefaultWidth: "70%",
			  cropDefaultHeight: "70%",
			}),
			  r.Icon.set("crop", o(3610)).set("resize", o(56170));
		  },
		  35503: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.openImageEditor = t.ImageEditor = void 0);
			var n = o(20255);
			o(62820);
			var r = o(93166),
			  i = o(56562),
			  a = o(40332),
			  s = o(64968),
			  l = o(96516),
			  c = o(9249),
			  u = o(43441);
			o(95356);
			var d = "jodit-image-editor",
			  p = "resize",
			  f = "crop",
			  h = (function (e) {
				function t(t) {
				  var n = e.call(this, t) || this;
				  (n.resizeUseRatio = !0),
					(n.cropUseRatio = !0),
					(n.clicked = !1),
					(n.start_x = 0),
					(n.start_y = 0),
					(n.top_x = 0),
					(n.top_y = 0),
					(n.width = 0),
					(n.height = 0),
					(n.activeTab = p),
					(n.naturalWidth = 0),
					(n.naturalHeight = 0),
					(n.ratio = 0),
					(n.new_h = 0),
					(n.new_w = 0),
					(n.diff_x = 0),
					(n.diff_y = 0),
					(n.cropBox = { x: 0, y: 0, w: 0, h: 0 }),
					(n.resizeBox = { w: 0, h: 0 }),
					(n.calcCropBox = function () {
					  var e = n.crop_box.parentNode,
						t = 0.8 * e.offsetWidth,
						o = 0.8 * e.offsetHeight,
						r = t,
						i = o,
						s = n.naturalWidth,
						l = n.naturalHeight;
					  t > s && o > l
						? ((r = s), (i = l))
						: n.ratio > t / o
						  ? ((r = t), (i = l * (t / s)))
						  : ((r = s * (o / l)), (i = o)),
						(0, a.css)(n.crop_box, { width: r, height: i });
					}),
					(n.showCrop = function () {
					  if (n.cropImage) {
						n.calcCropBox();
						var e =
						  n.cropImage.offsetWidth ||
						  n.image.offsetWidth ||
						  n.image.naturalWidth;
						n.new_w = o.calcValueByPercent(e, n.o.cropDefaultWidth);
						var t =
						  n.cropImage.offsetHeight ||
						  n.image.offsetHeight ||
						  n.image.naturalHeight;
						(n.new_h = n.cropUseRatio
						  ? n.new_w / n.ratio
						  : o.calcValueByPercent(t, n.o.cropDefaultHeight)),
						  (0, a.css)(n.cropHandler, {
							backgroundImage:
							  "url(" + (0, a.attr)(n.cropImage, "src") + ")",
							width: n.new_w,
							height: n.new_h,
							left: e / 2 - n.new_w / 2,
							top: t / 2 - n.new_h / 2,
						  }),
						  n.j.e.fire(n.cropHandler, "updatesize");
					  }
					}),
					(n.updateCropBox = function () {
					  if (n.cropImage) {
						var e = n.cropImage.offsetWidth / n.naturalWidth,
						  t = n.cropImage.offsetHeight / n.naturalHeight;
						(n.cropBox.x = (0, a.css)(n.cropHandler, "left") / e),
						  (n.cropBox.y = (0, a.css)(n.cropHandler, "top") / t),
						  (n.cropBox.w = n.cropHandler.offsetWidth / e),
						  (n.cropBox.h = n.cropHandler.offsetHeight / t),
						  (n.sizes.textContent =
							n.cropBox.w.toFixed(0) +
							"x" +
							n.cropBox.h.toFixed(0));
					  }
					}),
					(n.updateResizeBox = function () {
					  (n.resizeBox.w = n.image.offsetWidth || n.naturalWidth),
						(n.resizeBox.h = n.image.offsetHeight || n.naturalHeight);
					}),
					(n.setHandlers = function () {
					  var e = n,
						t = (0, a.refs)(n.editor),
						o = t.widthInput,
						r = t.heightInput;
					  e.j.e
						.on(
						  [
							e.editor.querySelector(".jodit_bottomright"),
							e.cropHandler,
						  ],
						  "mousedown.".concat(d),
						  n.onResizeHandleMouseDown,
						)
						.on(n.j.ow, "resize.".concat(d), function () {
						  n.j.e.fire(e.resizeHandler, "updatesize"),
							e.showCrop(),
							n.j.e.fire(e.cropHandler, "updatesize");
						}),
						e.j.e
						  .on(
							(0, a.toArray)(
							  n.editor.querySelectorAll(
								".".concat(d, "__slider-title"),
							  ),
							),
							"click",
							n.onTitleModeClick,
						  )
						  .on([o, r], "input", n.onChangeSizeInput);
					  var i = (0, a.refs)(n.editor),
						s = i.keepAspectRatioResize,
						l = i.keepAspectRatioCrop;
					  s &&
						s.addEventListener("change", function () {
						  n.resizeUseRatio = s.checked;
						}),
						l &&
						  l.addEventListener("change", function () {
							n.cropUseRatio = l.checked;
						  }),
						e.j.e
						  .on(e.resizeHandler, "updatesize", function () {
							(0, a.css)(e.resizeHandler, {
							  top: 0,
							  left: 0,
							  width: e.image.offsetWidth || e.naturalWidth,
							  height: e.image.offsetHeight || e.naturalHeight,
							}),
							  n.updateResizeBox();
						  })
						  .on(e.cropHandler, "updatesize", function () {
							if (e.cropImage) {
							  var t = (0, a.css)(e.cropHandler, "left"),
								o = (0, a.css)(e.cropHandler, "top"),
								n = e.cropHandler.offsetWidth,
								r = e.cropHandler.offsetHeight;
							  0 > t && (t = 0),
								0 > o && (o = 0),
								t + n > e.cropImage.offsetWidth &&
								  ((n = e.cropImage.offsetWidth - t),
								  e.cropUseRatio && (r = n / e.ratio)),
								o + r > e.cropImage.offsetHeight &&
								  ((r = e.cropImage.offsetHeight - o),
								  e.cropUseRatio && (n = r * e.ratio)),
								(0, a.css)(e.cropHandler, {
								  width: n,
								  height: r,
								  left: t,
								  top: o,
								  backgroundPosition:
									-t - 1 + "px " + (-o - 1) + "px",
								  backgroundSize:
									e.cropImage.offsetWidth +
									"px " +
									e.cropImage.offsetHeight +
									"px",
								}),
								e.updateCropBox();
							}
						  }),
						Object.values(e.buttons).forEach(function (t) {
						  t.onAction(function () {
							var n = {
							  action: e.activeTab,
							  box: e.activeTab === p ? e.resizeBox : e.cropBox,
							};
							switch (t) {
							  case e.buttons.saveas:
								e.j.prompt(
								  "Enter new name",
								  "Save in new file",
								  function (t) {
									if (!(0, a.trim)(t))
									  return (
										e.j.alert("The name should not be empty"),
										!1
									  );
									e.onSave(t, n, e.hide, function (t) {
									  e.j.alert(t.message);
									});
								  },
								);
								break;
							  case e.buttons.save:
								e.onSave(void 0, n, e.hide, function (t) {
								  e.j.alert(t.message);
								});
								break;
							  case e.buttons.reset:
								e.activeTab === p
								  ? ((0, a.css)(e.image, {
									  width: null,
									  height: null,
									}),
									(o.value = e.naturalWidth.toString()),
									(r.value = e.naturalHeight.toString()),
									e.j.e.fire(e.resizeHandler, "updatesize"))
								  : e.showCrop();
							}
						  });
						});
					}),
					(n.options =
					  t && t.o && t.o.imageeditor
						? t.o.imageeditor
						: r.Config.defaultOptions.imageeditor);
				  var i = n.options;
				  (n.resizeUseRatio = i.resizeUseRatio),
					(n.cropUseRatio = i.cropUseRatio),
					(n.buttons = {
					  reset: (0, l.Button)(n.j, "update", "Reset"),
					  save: (0, l.Button)(n.j, "save", "Save"),
					  saveas: (0, l.Button)(n.j, "save", "Save as ..."),
					}),
					(n.activeTab = i.resize ? p : f),
					(n.editor = (0, c.form)(n.j, n.options));
				  var s = (0, a.refs)(n.editor),
					u = s.cropBox;
				  return (
					(n.resize_box = s.resizeBox),
					(n.crop_box = u),
					(n.sizes = n.editor.querySelector(
					  "."
						.concat(d, "__area.")
						.concat(d, "__area_crop .jodit-image-editor__sizes"),
					)),
					(n.resizeHandler = n.editor.querySelector(
					  ".".concat(d, "__resizer"),
					)),
					(n.cropHandler = n.editor.querySelector(
					  ".".concat(d, "__croper"),
					)),
					(n._dialog = n.j.dlg({
					  buttons: ["fullsize", "dialog.close"],
					})),
					n._dialog.setContent(n.editor),
					n._dialog.setSize(n.o.width, n.o.height),
					n._dialog.setHeader([
					  n.buttons.reset,
					  n.buttons.save,
					  n.buttons.saveas,
					]),
					n.setHandlers(),
					n
				  );
				}
				var o;
				return (
				  n.__extends(t, e),
				  (o = t),
				  (t.prototype.className = function () {
					return "ImageEditor";
				  }),
				  (t.prototype.onTitleModeClick = function (e) {
					var t = this,
					  o = e.target,
					  n = null == o ? void 0 : o.parentElement;
					if (n) {
					  (0, a.$$)(
						".".concat(d, "__slider,.").concat(d, "__area"),
						t.editor,
					  ).forEach(function (e) {
						return e.classList.remove("".concat(d, "_active"));
					  }),
						n.classList.add("".concat(d, "_active")),
						(this.activeTab = (0, a.attr)(n, "-area") || p);
					  var r = t.editor.querySelector(
						".".concat(d, "__area.").concat(d, "__area_") +
						  t.activeTab,
					  );
					  r && r.classList.add("".concat(d, "_active")),
						t.activeTab === f && t.showCrop();
					}
				  }),
				  (t.prototype.onChangeSizeInput = function (e) {
					var t,
					  o = this,
					  n = e.target,
					  r = (0, a.refs)(this.editor),
					  i = r.widthInput,
					  s = r.heightInput,
					  l = "widthInput" === (0, a.attr)(n, "data-ref"),
					  c = parseInt(n.value, 10),
					  u = l ? o.o.min_height : o.o.min_width;
					c > (l ? o.o.min_width : o.o.min_height) &&
					  ((0, a.css)(o.image, l ? "width" : "height", c),
					  o.resizeUseRatio &&
						(t = l
						  ? Math.round(c / o.ratio)
						  : Math.round(c * o.ratio)) > u &&
						((0, a.css)(o.image, l ? "height" : "width", t),
						l ? (s.value = t.toString()) : (i.value = t.toString()))),
					  this.j.e.fire(o.resizeHandler, "updatesize");
				  }),
				  (t.prototype.onResizeHandleMouseDown = function (e) {
					var t = this;
					(t.target = e.target),
					  e.preventDefault(),
					  e.stopImmediatePropagation(),
					  (t.clicked = !0),
					  (t.start_x = e.clientX),
					  (t.start_y = e.clientY),
					  t.activeTab === f
						? ((t.top_x = (0, a.css)(t.cropHandler, "left")),
						  (t.top_y = (0, a.css)(t.cropHandler, "top")),
						  (t.width = t.cropHandler.offsetWidth),
						  (t.height = t.cropHandler.offsetHeight))
						: ((t.width = t.image.offsetWidth),
						  (t.height = t.image.offsetHeight)),
					  t.j.e
						.on(this.j.ow, "mousemove", this.onGlobalMouseMove)
						.one(this.j.ow, "mouseup", this.onGlobalMouseUp);
				  }),
				  (t.prototype.onGlobalMouseUp = function (e) {
					this.clicked &&
					  ((this.clicked = !1),
					  e.stopImmediatePropagation(),
					  this.j.e.off(
						this.j.ow,
						"mousemove",
						this.onGlobalMouseMove,
					  ));
				  }),
				  (t.prototype.onGlobalMouseMove = function (e) {
					var t = this;
					if (t.clicked) {
					  var o = (0, a.refs)(this.editor),
						n = o.widthInput,
						r = o.heightInput;
					  (t.diff_x = e.clientX - t.start_x),
						(t.diff_y = e.clientY - t.start_y),
						(t.activeTab === p && t.resizeUseRatio) ||
						(t.activeTab === f && t.cropUseRatio)
						  ? t.diff_x
							? ((t.new_w = t.width + t.diff_x),
							  (t.new_h = Math.round(t.new_w / t.ratio)))
							: ((t.new_h = t.height + t.diff_y),
							  (t.new_w = Math.round(t.new_h * t.ratio)))
						  : ((t.new_w = t.width + t.diff_x),
							(t.new_h = t.height + t.diff_y)),
						t.activeTab === p
						  ? (t.new_w > t.o.resizeMinWidth &&
							  ((0, a.css)(t.image, "width", t.new_w + "px"),
							  (n.value = t.new_w.toString())),
							t.new_h > t.o.resizeMinHeight &&
							  ((0, a.css)(t.image, "height", t.new_h + "px"),
							  (r.value = t.new_h.toString())),
							this.j.e.fire(t.resizeHandler, "updatesize"))
						  : (t.target !== t.cropHandler
							  ? (t.top_x + t.new_w > t.cropImage.offsetWidth &&
								  (t.new_w = t.cropImage.offsetWidth - t.top_x),
								t.top_y + t.new_h > t.cropImage.offsetHeight &&
								  (t.new_h = t.cropImage.offsetHeight - t.top_y),
								(0, a.css)(t.cropHandler, {
								  width: t.new_w,
								  height: t.new_h,
								}))
							  : (t.top_x + t.diff_x + t.cropHandler.offsetWidth >
								  t.cropImage.offsetWidth &&
								  (t.diff_x =
									t.cropImage.offsetWidth -
									t.top_x -
									t.cropHandler.offsetWidth),
								(0, a.css)(
								  t.cropHandler,
								  "left",
								  t.top_x + t.diff_x,
								),
								t.top_y + t.diff_y + t.cropHandler.offsetHeight >
								  t.cropImage.offsetHeight &&
								  (t.diff_y =
									t.cropImage.offsetHeight -
									t.top_y -
									t.cropHandler.offsetHeight),
								(0, a.css)(
								  t.cropHandler,
								  "top",
								  t.top_y + t.diff_y,
								)),
							this.j.e.fire(t.cropHandler, "updatesize"));
					}
				  }),
				  Object.defineProperty(t.prototype, "o", {
					get: function () {
					  return this.options;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.hide = function () {
					this._dialog.close();
				  }),
				  (t.prototype.open = function (e, t) {
					var o = this;
					return this.j.async.promise(function (n) {
					  var r = new Date().getTime();
					  (o.image = o.j.c.element("img")),
						(0, a.$$)("img,.jodit-icon_loader", o.resize_box).forEach(
						  s.Dom.safeRemove,
						),
						(0, a.$$)("img,.jodit-icon_loader", o.crop_box).forEach(
						  s.Dom.safeRemove,
						),
						(0, a.css)(o.cropHandler, "background", "transparent"),
						(o.onSave = t),
						o.resize_box.appendChild(
						  o.j.c.element("i", { class: "jodit-icon_loader" }),
						),
						o.crop_box.appendChild(
						  o.j.c.element("i", { class: "jodit-icon_loader" }),
						),
						/\?/.test(e) ? (e += "&_tst=" + r) : (e += "?_tst=" + r),
						o.image.setAttribute("src", e),
						o._dialog.open();
					  var i = (0, a.refs)(o.editor),
						l = i.widthInput,
						c = i.heightInput,
						u = function () {
						  o.isDestructed ||
							(o.image.removeEventListener("load", u),
							(o.naturalWidth = o.image.naturalWidth),
							(o.naturalHeight = o.image.naturalHeight),
							(l.value = o.naturalWidth.toString()),
							(c.value = o.naturalHeight.toString()),
							(o.ratio = o.naturalWidth / o.naturalHeight),
							o.resize_box.appendChild(o.image),
							(o.cropImage = o.image.cloneNode(!0)),
							o.crop_box.appendChild(o.cropImage),
							s.Dom.safeRemove.apply(
							  null,
							  (0, a.$$)(".jodit-icon_loader", o.editor),
							),
							o.activeTab === f && o.showCrop(),
							o.j.e.fire(o.resizeHandler, "updatesize"),
							o.j.e.fire(o.cropHandler, "updatesize"),
							o._dialog.setPosition(),
							o.j.e.fire("afterImageEditor"),
							n(o._dialog));
						};
					  o.image.addEventListener("load", u),
						o.image.complete && u();
					});
				  }),
				  (t.prototype.destruct = function () {
					this.isDestructed ||
					  (this._dialog &&
						!this._dialog.isInDestruct &&
						this._dialog.destruct(),
					  s.Dom.safeRemove(this.editor),
					  this.j.e &&
						this.j.e
						  .off(this.j.ow, "mousemove", this.onGlobalMouseMove)
						  .off(this.j.ow, "mouseup", this.onGlobalMouseUp)
						  .off(this.ow, ".".concat(d))
						  .off(".".concat(d)),
					  e.prototype.destruct.call(this));
				  }),
				  (t.calcValueByPercent = function (e, t) {
					var o,
					  n = t.toString(),
					  r = parseFloat(e.toString());
					return (o = /^[-+]?[0-9]+(px)?$/.exec(n))
					  ? parseInt(n, 10)
					  : (o = /^([-+]?[0-9.]+)%$/.exec(n))
						? Math.round(r * (parseFloat(o[1]) / 100))
						: r || 0;
				  }),
				  n.__decorate(
					[u.autobind],
					t.prototype,
					"onTitleModeClick",
					null,
				  ),
				  n.__decorate(
					[(0, u.debounce)(), u.autobind],
					t.prototype,
					"onChangeSizeInput",
					null,
				  ),
				  n.__decorate(
					[u.autobind],
					t.prototype,
					"onResizeHandleMouseDown",
					null,
				  ),
				  n.__decorate(
					[u.autobind],
					t.prototype,
					"onGlobalMouseUp",
					null,
				  ),
				  n.__decorate(
					[(0, u.throttle)(10)],
					t.prototype,
					"onGlobalMouseMove",
					null,
				  ),
				  n.__decorate([u.autobind], t.prototype, "hide", null),
				  n.__decorate([u.autobind], t.prototype, "open", null),
				  (o = n.__decorate([u.component], t))
				);
			  })(i.ViewComponent);
			(t.ImageEditor = h),
			  (t.openImageEditor = function (e, t, o, n, r, i) {
				var s = this;
				return this.getInstance("ImageEditor", this.o).open(
				  e,
				  function (e, l, c, u) {
					return (0, a.call)(
					  "resize" === l.action
						? s.dataProvider.resize
						: s.dataProvider.crop,
					  o,
					  n,
					  t,
					  e,
					  l.box,
					)
					  .then(function (e) {
						e && (c(), r && r());
					  })
					  .catch(function (e) {
						u(e), i && i(e);
					  });
				  },
				);
			  });
		  },
		  9249: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.form = void 0);
			var n = o(2074),
			  r = "jodit-image-editor",
			  i = n.Icon.get.bind(n.Icon),
			  a = function (e, t) {
				return (
				  void 0 === t && (t = "jodti-image-editor_active"), e ? t : ""
				);
			  };
			t.form = function (e, t) {
			  var o = e.i18n.bind(e),
				n = function (e, t, n) {
				  return (
					void 0 === n && (n = !0),
					'<div class="jodit-form__group">\n\t\t\t<label>'
					  .concat(
						o(e),
						"</label>\n\n\t\t\t<label class='jodit-switcher'>\n\t\t\t\t<input ",
					  )
					  .concat(a(n, "checked"), ' data-ref="')
					  .concat(
						t,
						'" type="checkbox"/>\n\t\t\t\t<span class="jodit-switcher__slider"></span>\n\t\t\t</label>\n\t</div>',
					  )
				  );
				};
			  return e.create.fromHTML(
				'<form class="'
				  .concat(
					r,
					' jodit-properties">\n\t\t<div class="jodit-grid jodit-grid_xs-column">\n\t\t\t<div class="jodit_col-lg-3-4 jodit_col-sm-5-5">\n\t\t\t',
				  )
				  .concat(
					t.resize
					  ? '<div class="'
						  .concat(r, "__area ")
						  .concat(r, "__area_resize ")
						  .concat(
							r,
							'_active">\n\t\t\t\t\t\t\t<div data-ref="resizeBox" class="',
						  )
						  .concat(r, '__box"></div>\n\t\t\t\t\t\t\t<div class="')
						  .concat(
							r,
							'__resizer">\n\t\t\t\t\t\t\t\t<i class="jodit_bottomright"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>',
						  )
					  : "",
					"\n\t\t\t",
				  )
				  .concat(
					t.crop
					  ? '<div class="'
						  .concat(r, "__area ")
						  .concat(r, "__area_crop ")
						  .concat(
							a(!t.resize),
							'">\n\t\t\t\t\t\t\t<div data-ref="cropBox" class="',
						  )
						  .concat(r, '__box">\n\t\t\t\t\t\t\t\t<div class="')
						  .concat(
							r,
							'__croper">\n\t\t\t\t\t\t\t\t\t<i class="jodit_bottomright"></i>\n\t\t\t\t\t\t\t\t\t<i class="',
						  )
						  .concat(
							r,
							'__sizes"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>',
						  )
					  : "",
					'\n\t\t\t</div>\n\t\t\t<div class="jodit_col-lg-1-4 jodit_col-sm-5-5">\n\t\t\t',
				  )
				  .concat(
					t.resize
					  ? '<div data-area="resize" class="'
						  .concat(r, "__slider ")
						  .concat(r, '_active">\n\t\t\t\t\t\t\t<div class="')
						  .concat(r, '__slider-title">\n\t\t\t\t\t\t\t\t')
						  .concat(i("resize"), "\n\t\t\t\t\t\t\t\t")
						  .concat(
							o("Resize"),
							'\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="',
						  )
						  .concat(
							r,
							'__slider-content">\n\t\t\t\t\t\t\t\t<div class="jodit-form__group">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t',
						  )
						  .concat(
							o("Width"),
							'\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<input type="number" data-ref="widthInput" class="jodit-input"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="jodit-form__group">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t',
						  )
						  .concat(
							o("Height"),
							'\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<input type="number" data-ref="heightInput" class="jodit-input"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t',
						  )
						  .concat(
							n("Keep Aspect Ratio", "keepAspectRatioResize"),
							"\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>",
						  )
					  : "",
					"\n\t\t\t",
				  )
				  .concat(
					t.crop
					  ? '<div data-area="crop" class="'
						  .concat(r, "__slider ")
						  .concat(
							a(!t.resize),
							'\'">\n\t\t\t\t\t\t\t<div class="',
						  )
						  .concat(r, '__slider-title">\n\t\t\t\t\t\t\t\t')
						  .concat(i("crop"), "\n\t\t\t\t\t\t\t\t")
						  .concat(
							o("Crop"),
							'\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="',
						  )
						  .concat(r, '__slider-content">\n\t\t\t\t\t\t\t\t')
						  .concat(
							n("Keep Aspect Ratio", "keepAspectRatioCrop"),
							"\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>",
						  )
					  : "",
					"\n\t\t\t</div>\n\t\t</div>\n\t</form>",
				  ),
			  );
			};
		  },
		  87837: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.PluginSystem =
				t.UIMessages =
				t.Uploader =
				t.ToolbarCollection =
				t.ToolbarEditorCollection =
				t.Table =
				t.StatusBar =
				t.CommitStyle =
				t.Select =
				t.Snapshot =
				t.History =
				t.ImageEditor =
				t.Helpers =
				t.ViewWithToolbar =
				t.View =
				t.Icon =
				t.ProgressBar =
				t.UIBlock =
				t.UICheckbox =
				t.UITextArea =
				t.UIInput =
				t.UIForm =
				t.UIList =
				t.UIGroup =
				t.UISeparator =
				t.Popup =
				t.UIButton =
				t.UIElement =
				t.Create =
				t.Plugin =
				t.LazyWalker =
				t.Dom =
				t.ContextMenu =
				t.STATUSES =
				t.ViewComponent =
				t.Component =
				t.Async =
				  void 0);
			var n = o(20255);
			n.__exportStar(o(55395), t);
			var r = o(22630);
			Object.defineProperty(t, "Async", {
			  enumerable: !0,
			  get: function () {
				return r.Async;
			  },
			}),
			  n.__exportStar(o(30056), t);
			var i = o(56562);
			Object.defineProperty(t, "Component", {
			  enumerable: !0,
			  get: function () {
				return i.Component;
			  },
			}),
			  Object.defineProperty(t, "ViewComponent", {
				enumerable: !0,
				get: function () {
				  return i.ViewComponent;
				},
			  }),
			  Object.defineProperty(t, "STATUSES", {
				enumerable: !0,
				get: function () {
				  return i.STATUSES;
				},
			  });
			var a = o(60403);
			Object.defineProperty(t, "ContextMenu", {
			  enumerable: !0,
			  get: function () {
				return a.ContextMenu;
			  },
			}),
			  n.__exportStar(o(92080), t);
			var s = o(64968);
			Object.defineProperty(t, "Dom", {
			  enumerable: !0,
			  get: function () {
				return s.Dom;
			  },
			}),
			  Object.defineProperty(t, "LazyWalker", {
				enumerable: !0,
				get: function () {
				  return s.LazyWalker;
				},
			  });
			var l = o(57549);
			Object.defineProperty(t, "Plugin", {
			  enumerable: !0,
			  get: function () {
				return l.Plugin;
			  },
			});
			var c = o(42841);
			Object.defineProperty(t, "Create", {
			  enumerable: !0,
			  get: function () {
				return c.Create;
			  },
			});
			var u = o(2074);
			Object.defineProperty(t, "UIElement", {
			  enumerable: !0,
			  get: function () {
				return u.UIElement;
			  },
			}),
			  Object.defineProperty(t, "UIButton", {
				enumerable: !0,
				get: function () {
				  return u.UIButton;
				},
			  }),
			  Object.defineProperty(t, "Popup", {
				enumerable: !0,
				get: function () {
				  return u.Popup;
				},
			  }),
			  Object.defineProperty(t, "UISeparator", {
				enumerable: !0,
				get: function () {
				  return u.UISeparator;
				},
			  }),
			  Object.defineProperty(t, "UIGroup", {
				enumerable: !0,
				get: function () {
				  return u.UIGroup;
				},
			  }),
			  Object.defineProperty(t, "UIList", {
				enumerable: !0,
				get: function () {
				  return u.UIList;
				},
			  }),
			  Object.defineProperty(t, "UIForm", {
				enumerable: !0,
				get: function () {
				  return u.UIForm;
				},
			  }),
			  Object.defineProperty(t, "UIInput", {
				enumerable: !0,
				get: function () {
				  return u.UIInput;
				},
			  }),
			  Object.defineProperty(t, "UITextArea", {
				enumerable: !0,
				get: function () {
				  return u.UITextArea;
				},
			  }),
			  Object.defineProperty(t, "UICheckbox", {
				enumerable: !0,
				get: function () {
				  return u.UICheckbox;
				},
			  }),
			  Object.defineProperty(t, "UIBlock", {
				enumerable: !0,
				get: function () {
				  return u.UIBlock;
				},
			  }),
			  Object.defineProperty(t, "ProgressBar", {
				enumerable: !0,
				get: function () {
				  return u.ProgressBar;
				},
			  }),
			  Object.defineProperty(t, "Icon", {
				enumerable: !0,
				get: function () {
				  return u.Icon;
				},
			  });
			var d = o(75902);
			Object.defineProperty(t, "View", {
			  enumerable: !0,
			  get: function () {
				return d.View;
			  },
			});
			var p = o(43608);
			Object.defineProperty(t, "ViewWithToolbar", {
			  enumerable: !0,
			  get: function () {
				return p.ViewWithToolbar;
			  },
			}),
			  n.__exportStar(o(63463), t);
			var f = o(40332);
			t.Helpers = f;
			var h = o(35503);
			Object.defineProperty(t, "ImageEditor", {
			  enumerable: !0,
			  get: function () {
				return h.ImageEditor;
			  },
			});
			var m = o(15432);
			Object.defineProperty(t, "History", {
			  enumerable: !0,
			  get: function () {
				return m.History;
			  },
			});
			var v = o(31648);
			Object.defineProperty(t, "Snapshot", {
			  enumerable: !0,
			  get: function () {
				return v.Snapshot;
			  },
			});
			var g = o(2123);
			Object.defineProperty(t, "Select", {
			  enumerable: !0,
			  get: function () {
				return g.Select;
			  },
			}),
			  Object.defineProperty(t, "CommitStyle", {
				enumerable: !0,
				get: function () {
				  return g.CommitStyle;
				},
			  });
			var y = o(38603);
			Object.defineProperty(t, "StatusBar", {
			  enumerable: !0,
			  get: function () {
				return y.StatusBar;
			  },
			});
			var _ = o(25120);
			Object.defineProperty(t, "Table", {
			  enumerable: !0,
			  get: function () {
				return _.Table;
			  },
			});
			var b = o(81698);
			Object.defineProperty(t, "ToolbarEditorCollection", {
			  enumerable: !0,
			  get: function () {
				return b.ToolbarEditorCollection;
			  },
			});
			var w = o(72719);
			Object.defineProperty(t, "ToolbarCollection", {
			  enumerable: !0,
			  get: function () {
				return w.ToolbarCollection;
			  },
			}),
			  n.__exportStar(o(3890), t);
			var S = o(50454);
			Object.defineProperty(t, "Uploader", {
			  enumerable: !0,
			  get: function () {
				return S.Uploader;
			  },
			});
			var C = o(71014);
			Object.defineProperty(t, "UIMessages", {
			  enumerable: !0,
			  get: function () {
				return C.UIMessages;
			  },
			});
			var j = o(44540);
			Object.defineProperty(t, "PluginSystem", {
			  enumerable: !0,
			  get: function () {
				return j.PluginSystem;
			  },
			});
		  },
		  37762: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIMessage = void 0);
			var n = o(20255),
			  r = o(2074),
			  i = o(11441),
			  a = (function (e) {
				function t(t, o) {
				  var n = e.call(this, t) || this;
				  return (
					n.setMod("active", !0),
					n.setMod("variant", o.variant),
					(n.container.textContent = o.text),
					n
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UIMessage";
				  }),
				  n.__decorate([i.component], t)
				);
			  })(r.UIElement);
			t.UIMessage = a;
		  },
		  71014: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UIMessages = void 0);
			var n = o(20255);
			o(63421);
			var r = o(26911),
			  i = o(61479),
			  a = o(11441),
			  s = o(46163),
			  l = o(37762),
			  c = (function (e) {
				function t(t, o, n) {
				  void 0 === n && (n = { defaultTimeout: 3e3, defaultOffset: 5 });
				  var r = e.call(this, t) || this;
				  return (
					(r.__box = o), (r.options = n), (r.__messages = new Set()), r
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UIMessages";
				  }),
				  (t.prototype.info = function (e, t) {
					this.__message(e, "info", t);
				  }),
				  (t.prototype.success = function (e, t) {
					this.__message(e, "success", t);
				  }),
				  (t.prototype.error = function (e, t) {
					this.__message(e, "error", t);
				  }),
				  (t.prototype.message = function (e, t, o) {
					this.__message(e, t, o);
				  }),
				  (t.prototype.__message = function (e, t, o) {
					void 0 === t && (t = "info");
					var n = e + ":" + t;
					if (this.__messages.has(n))
					  this.async.updateTimeout(
						n,
						o || this.options.defaultTimeout,
					  );
					else {
					  this.__box.appendChild(this.container);
					  var r = new l.UIMessage(this.j, { text: e, variant: t });
					  this.append(r),
						this.__calcOffsets(),
						this.__messages.add(n);
					  var i = this.__getRemoveCallback(r, n);
					  this.j.e.on(r.container, "pointerdown", i),
						this.async.setTimeout(i, {
						  label: n,
						  timeout: o || this.options.defaultTimeout,
						});
					}
				  }),
				  (t.prototype.__getRemoveCallback = function (e, t) {
					var o = this,
					  n = function (r) {
						r && r.preventDefault(),
						  e.isInDestruct ||
							(o.async.clearTimeout(t),
							o.j.e.off(e.container, "pointerdown", n),
							o.__messages.delete(t),
							e.setMod("active", !1),
							o.async.setTimeout(function () {
							  o.remove(e), e.destruct(), o.__calcOffsets();
							}, 300));
					  };
					return n;
				  }),
				  (t.prototype.__calcOffsets = function () {
					var e = this,
					  t = 5;
					this.elements.forEach(function (o) {
					  (0, r.css)(o.container, "bottom", t + "px"),
						(t += o.container.offsetHeight + e.options.defaultOffset);
					});
				  }),
				  n.__decorate(
					[(0, s.watch)(":errorMessage")],
					t.prototype,
					"__message",
					null,
				  ),
				  n.__decorate([a.component], t)
				);
			  })(i.UIGroup);
			t.UIMessages = c;
		  },
		  38603: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.StatusBar = void 0);
			var n = o(20255);
			o(32115);
			var r = o(56562),
			  i = o(64968),
			  a = o(59829),
			  s = o(43441),
			  l = (function (e) {
				function t(t, o) {
				  var n = e.call(this, t) || this;
				  return (
					(n.target = o),
					(n.mods = {}),
					(n.container = t.c.div("jodit-status-bar")),
					o.appendChild(n.container),
					n.hide(),
					n
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "StatusBar";
				  }),
				  (t.prototype.hide = function () {
					this.container.classList.add("jodit_hidden");
				  }),
				  (t.prototype.show = function () {
					this.container.classList.remove("jodit_hidden");
				  }),
				  Object.defineProperty(t.prototype, "isShown", {
					get: function () {
					  return !this.container.classList.contains("jodit_hidden");
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.getHeight = function () {
					var e, t;
					return null !==
					  (t =
						null === (e = this.container) || void 0 === e
						  ? void 0
						  : e.offsetHeight) && void 0 !== t
					  ? t
					  : 0;
				  }),
				  (t.prototype.findEmpty = function (e) {
					void 0 === e && (e = !1);
					for (
					  var t = this.getElms(e ? "item-right" : "item"), o = 0;
					  t.length > o;
					  o += 1
					)
					  if (!t[o].innerHTML.trim().length) return t[o];
				  }),
				  (t.prototype.append = function (e, t) {
					var o;
					void 0 === t && (t = !1);
					var n =
					  this.findEmpty(t) ||
					  this.j.c.div(this.getFullElName("item"));
					t && n.classList.add(this.getFullElName("item-right")),
					  n.appendChild(e),
					  null === (o = this.container) ||
						void 0 === o ||
						o.appendChild(n),
					  this.j.o.statusbar && this.show(),
					  this.j.e.fire("resize");
				  }),
				  (t.prototype.destruct = function () {
					this.isInDestruct ||
					  (this.setStatus(r.STATUSES.beforeDestruct),
					  i.Dom.safeRemove(this.container),
					  e.prototype.destruct.call(this));
				  }),
				  n.__decorate([s.component, (0, s.derive)(a.Mods, a.Elms)], t)
				);
			  })(r.ViewComponent);
			t.StatusBar = l;
		  },
		  25120: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Table = void 0);
			var n = o(20255),
			  r = o(86893),
			  i = o(64968),
			  a = o(40332),
			  s = o(56562),
			  l = o(17332),
			  c = o(43441),
			  u = new WeakMap(),
			  d = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (t.selected = new Set()), t;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "Table";
				  }),
				  (t.prototype.recalculateStyles = function () {
					var e = (0, l.getContainer)(this.j, t, "style", !0),
					  o = [];
					this.selected.forEach(function (e) {
					  var t = (0, a.cssPath)(e);
					  t && o.push(t);
					}),
					  (e.innerHTML = o.length
						? o.join(",") +
						  "{".concat(
							this.jodit.options.table.selectionCellStyle,
							"}",
						  )
						: "");
				  }),
				  (t.prototype.addSelection = function (e) {
					this.selected.add(e), this.recalculateStyles();
					var o = i.Dom.closest(e, "table", this.j.editor);
					if (o) {
					  var n = t.selectedByTable.get(o) || new Set();
					  n.add(e), t.selectedByTable.set(o, n);
					}
				  }),
				  (t.prototype.removeSelection = function (e) {
					this.selected.delete(e), this.recalculateStyles();
					var o = i.Dom.closest(e, "table", this.j.editor);
					if (o) {
					  var n = t.selectedByTable.get(o);
					  n && (n.delete(e), n.size || t.selectedByTable.delete(o));
					}
				  }),
				  (t.prototype.getAllSelectedCells = function () {
					return (0, a.toArray)(this.selected);
				  }),
				  (t.getSelectedCellsByTable = function (e) {
					var o = t.selectedByTable.get(e);
					return o ? (0, a.toArray)(o) : [];
				  }),
				  (t.prototype.destruct = function () {
					return this.selected.clear(), e.prototype.destruct.call(this);
				  }),
				  (t.getRowsCount = function (e) {
					return e.rows.length;
				  }),
				  (t.getColumnsCount = function (e) {
					return t.formalMatrix(e).reduce(function (e, t) {
					  return Math.max(e, t.length);
					}, 0);
				  }),
				  (t.formalMatrix = function (e, t) {
					for (
					  var o = [[]],
						n = (0, a.toArray)(e.rows),
						r = function (e, n) {
						  void 0 === o[n] && (o[n] = []);
						  for (
							var r, i, a = e.colSpan, s = e.rowSpan, l = 0;
							o[n][l];
  
						  )
							l += 1;
						  for (i = 0; s > i; i += 1)
							for (r = 0; a > r; r += 1) {
							  if (
								(void 0 === o[n + i] && (o[n + i] = []),
								t && !1 === t(e, n + i, l + r, a, s))
							  )
								return !1;
							  o[n + i][l + r] = e;
							}
						},
						i = 0;
					  n.length > i;
					  i += 1
					)
					  for (
						var s = (0, a.toArray)(n[i].cells), l = 0;
						s.length > l;
						l += 1
					  )
						if (!1 === r(s[l], i)) return o;
					return o;
				  }),
				  (t.formalCoordinate = function (e, o, n) {
					void 0 === n && (n = !1);
					var r = 0,
					  i = 0,
					  a = 1,
					  s = 1;
					return (
					  t.formalMatrix(e, function (e, t, l, c, u) {
						if (o === e)
						  return (
							(r = t),
							(i = l),
							(a = c || 1),
							(s = u || 1),
							n && ((i += (c || 1) - 1), (r += (u || 1) - 1)),
							!1
						  );
					  }),
					  [r, i, a, s]
					);
				  }),
				  (t.appendRow = function (e, o, n, r) {
					var i, s;
					if (o)
					  (s = o.cloneNode(!0)),
						(0, a.$$)("td,th", o).forEach(function (e) {
						  var t = (0, a.attr)(e, "rowspan");
						  if (t && parseInt(t, 10) > 1) {
							var o = parseInt(t, 10) - 1;
							(0, a.attr)(e, "rowspan", o > 1 ? o : null);
						  }
						}),
						(0, a.$$)("td,th", s).forEach(function (e) {
						  e.innerHTML = "";
						});
					else {
					  var l = t.getColumnsCount(e);
					  s = r.element("tr");
					  for (var c = 0; l > c; c += 1)
						s.appendChild(r.element("td"));
					}
					n && o && o.nextSibling
					  ? o.parentNode &&
						o.parentNode.insertBefore(s, o.nextSibling)
					  : !n && o
						? o.parentNode && o.parentNode.insertBefore(s, o)
						: (
							(null === (i = e.getElementsByTagName("tbody")) ||
							void 0 === i
							  ? void 0
							  : i[0]) || e
						  ).appendChild(s);
				  }),
				  (t.removeRow = function (e, o) {
					var n,
					  r = t.formalMatrix(e),
					  s = e.rows[o];
					r[o].forEach(function (t, l) {
					  if (((n = !1), 0 > o - 1 || r[o - 1][l] !== t))
						if (r[o + 1] && r[o + 1][l] === t) {
						  if (t.parentNode === s && t.parentNode.nextSibling) {
							n = !0;
							for (var c = l + 1; r[o + 1][c] === t; ) c += 1;
							var u = i.Dom.next(
							  t.parentNode,
							  function (e) {
								return i.Dom.isTag(e, "tr");
							  },
							  e,
							);
							u &&
							  (r[o + 1][c]
								? u.insertBefore(t, r[o + 1][c])
								: u.appendChild(t));
						  }
						} else i.Dom.safeRemove(t);
					  else n = !0;
					  if (n && (t.parentNode === s || t !== r[o][l - 1])) {
						var d = t.rowSpan;
						(0, a.attr)(t, "rowspan", d - 1 > 1 ? d - 1 : null);
					  }
					}),
					  i.Dom.safeRemove(s);
				  }),
				  (t.appendColumn = function (e, o, n, r) {
					var s,
					  l = t.formalMatrix(e);
					for (
					  (void 0 === o || 0 > o) && (o = t.getColumnsCount(e) - 1),
						s = 0;
					  l.length > s;
					  s += 1
					) {
					  var c = r.element("td"),
						u = l[s][o],
						d = !1;
					  n
						? ((l[s] && u && o + 1 >= l[s].length) ||
							u !== l[s][o + 1]) &&
						  (u.nextSibling
							? i.Dom.before(u.nextSibling, c)
							: u.parentNode && u.parentNode.appendChild(c),
						  (d = !0))
						: (0 > o - 1 ||
							(l[s][o] !== l[s][o - 1] && l[s][o].parentNode)) &&
						  (i.Dom.before(l[s][o], c), (d = !0)),
						d ||
						  (0, a.attr)(
							l[s][o],
							"colspan",
							parseInt((0, a.attr)(l[s][o], "colspan") || "1", 10) +
							  1,
						  );
					}
				  }),
				  (t.removeColumn = function (e, o) {
					var n,
					  r = t.formalMatrix(e);
					r.forEach(function (e, t) {
					  var s = e[o];
					  if (
						((n = !1),
						0 > o - 1 || r[t][o - 1] !== s
						  ? e.length > o + 1 && r[t][o + 1] === s
							? (n = !0)
							: i.Dom.safeRemove(s)
						  : (n = !0),
						n && (0 > t - 1 || s !== r[t - 1][o]))
					  ) {
						var l = s.colSpan;
						(0, a.attr)(
						  s,
						  "colspan",
						  l - 1 > 1 ? (l - 1).toString() : null,
						);
					  }
					});
				  }),
				  (t.getSelectedBound = function (e, o) {
					var n,
					  r,
					  i,
					  a = [
						[1 / 0, 1 / 0],
						[0, 0],
					  ],
					  s = t.formalMatrix(e);
					for (n = 0; s.length > n; n += 1)
					  for (r = 0; s[n] && s[n].length > r; r += 1)
						o.includes(s[n][r]) &&
						  ((a[0][0] = Math.min(n, a[0][0])),
						  (a[0][1] = Math.min(r, a[0][1])),
						  (a[1][0] = Math.max(n, a[1][0])),
						  (a[1][1] = Math.max(r, a[1][1])));
					for (n = a[0][0]; a[1][0] >= n; n += 1)
					  for (i = 1, r = a[0][1]; a[1][1] >= r; r += 1) {
						for (; s[n] && s[n][r - i] && s[n][r] === s[n][r - i]; )
						  (a[0][1] = Math.min(r - i, a[0][1])),
							(a[1][1] = Math.max(r - i, a[1][1])),
							(i += 1);
						for (
						  i = 1;
						  s[n] && s[n][r + i] && s[n][r] === s[n][r + i];
  
						)
						  (a[0][1] = Math.min(r + i, a[0][1])),
							(a[1][1] = Math.max(r + i, a[1][1])),
							(i += 1);
						for (i = 1; s[n - i] && s[n][r] === s[n - i][r]; )
						  (a[0][0] = Math.min(n - i, a[0][0])),
							(a[1][0] = Math.max(n - i, a[1][0])),
							(i += 1);
						for (i = 1; s[n + i] && s[n][r] === s[n + i][r]; )
						  (a[0][0] = Math.min(n + i, a[0][0])),
							(a[1][0] = Math.max(n + i, a[1][0])),
							(i += 1);
					  }
					return a;
				  }),
				  (t.normalizeTable = function (e) {
					var o,
					  n,
					  r,
					  i,
					  s = [],
					  l = t.formalMatrix(e);
					for (n = 0; l[0].length > n; n += 1) {
					  for (r = 1e6, i = !1, o = 0; l.length > o; o += 1)
						if (void 0 !== l[o][n]) {
						  if (2 > l[o][n].colSpan) {
							i = !0;
							break;
						  }
						  r = Math.min(r, l[o][n].colSpan);
						}
					  if (!i)
						for (o = 0; l.length > o; o += 1)
						  void 0 !== l[o][n] &&
							t.mark(
							  l[o][n],
							  "colspan",
							  l[o][n].colSpan - r + 1,
							  s,
							);
					}
					for (o = 0; l.length > o; o += 1) {
					  for (r = 1e6, i = !1, n = 0; l[o].length > n; n += 1)
						if (void 0 !== l[o][n]) {
						  if (2 > l[o][n].rowSpan) {
							i = !0;
							break;
						  }
						  r = Math.min(r, l[o][n].rowSpan);
						}
					  if (!i)
						for (n = 0; l[o].length > n; n += 1)
						  void 0 !== l[o][n] &&
							t.mark(
							  l[o][n],
							  "rowspan",
							  l[o][n].rowSpan - r + 1,
							  s,
							);
					}
					for (o = 0; l.length > o; o += 1)
					  for (n = 0; l[o].length > n; n += 1)
						void 0 !== l[o][n] &&
						  (l[o][n].hasAttribute("rowspan") &&
							1 === l[o][n].rowSpan &&
							(0, a.attr)(l[o][n], "rowspan", null),
						  l[o][n].hasAttribute("colspan") &&
							1 === l[o][n].colSpan &&
							(0, a.attr)(l[o][n], "colspan", null),
						  l[o][n].hasAttribute("class") &&
							!(0, a.attr)(l[o][n], "class") &&
							(0, a.attr)(l[o][n], "class", null));
					t.unmark(s);
				  }),
				  (t.mergeSelected = function (e, o) {
					var n,
					  s = [],
					  l = t.getSelectedBound(e, t.getSelectedCellsByTable(e)),
					  c = 0,
					  u = null,
					  d = 0,
					  f = 0,
					  h = 0,
					  m = new Set(),
					  v = [];
					l &&
					  (l[0][0] - l[1][0] || l[0][1] - l[1][1]) &&
					  (t.formalMatrix(e, function (e, r, i, g, y) {
						if (
						  !(
							l[0][0] > r ||
							r > l[1][0] ||
							l[0][1] > i ||
							i > l[1][1]
						  )
						) {
						  if (m.has((n = e))) return;
						  m.add(n),
							r === l[0][0] &&
							  n.style.width &&
							  (c += n.offsetWidth),
							"" !==
							  (0, a.trim)(
								e.innerHTML.replace(/<br(\/)?>/g, ""),
							  ) && s.push(e.innerHTML),
							g > 1 && (f += g - 1),
							y > 1 && (h += y - 1),
							u
							  ? (t.mark(n, "remove", 1, v),
								p(o).removeSelection(n))
							  : ((u = e), (d = i));
						}
					  }),
					  (f = l[1][1] - l[0][1] + 1),
					  (h = l[1][0] - l[0][0] + 1),
					  u &&
						(f > 1 && t.mark(u, "colspan", f, v),
						h > 1 && t.mark(u, "rowspan", h, v),
						c &&
						  (t.mark(
							u,
							"width",
							((c / e.offsetWidth) * 100).toFixed(r.ACCURACY) + "%",
							v,
						  ),
						  d && t.setColumnWidthByDelta(e, d, 0, !0, v)),
						(u.innerHTML = s.join("<br/>")),
						p(o).addSelection(u),
						m.delete(u),
						t.unmark(v),
						t.normalizeTable(e),
						(0, a.toArray)(e.rows).forEach(function (e, t) {
						  e.cells.length || i.Dom.safeRemove(e);
						})));
				  }),
				  (t.splitHorizontal = function (e, o) {
					var n,
					  r,
					  a,
					  s,
					  l,
					  c = [];
					t.getSelectedCellsByTable(e).forEach(function (u) {
					  (r = o.createInside.element("td")).appendChild(
						o.createInside.element("br"),
					  ),
						(a = o.createInside.element("tr")),
						(n = t.formalCoordinate(e, u)),
						2 > u.rowSpan
						  ? (t.formalMatrix(e, function (e, o, r) {
							  n[0] === o &&
								n[1] !== r &&
								e !== u &&
								t.mark(e, "rowspan", e.rowSpan + 1, c);
							}),
							i.Dom.after(i.Dom.closest(u, "tr", e), a),
							a.appendChild(r))
						  : (t.mark(u, "rowspan", u.rowSpan - 1, c),
							t.formalMatrix(e, function (t, o, r) {
							  o > n[0] &&
								n[0] + u.rowSpan > o &&
								n[1] > r &&
								t.parentNode.rowIndex === o &&
								(l = t),
								o > n[0] && t === u && (s = e.rows[o]);
							}),
							l
							  ? i.Dom.after(l, r)
							  : s.insertBefore(r, s.firstChild)),
						u.colSpan > 1 && t.mark(r, "colspan", u.colSpan, c),
						t.unmark(c),
						p(o).removeSelection(u);
					}),
					  this.normalizeTable(e);
				  }),
				  (t.splitVertical = function (e, o) {
					var n,
					  a,
					  s,
					  l = [];
					t.getSelectedCellsByTable(e).forEach(function (c) {
					  (n = t.formalCoordinate(e, c)),
						2 > c.colSpan
						  ? t.formalMatrix(e, function (e, o, r) {
							  n[1] === r &&
								n[0] !== o &&
								e !== c &&
								t.mark(e, "colspan", e.colSpan + 1, l);
							})
						  : t.mark(c, "colspan", c.colSpan - 1, l),
						(a = o.createInside.element("td")).appendChild(
						  o.createInside.element("br"),
						),
						c.rowSpan > 1 && t.mark(a, "rowspan", c.rowSpan, l);
					  var u = c.offsetWidth;
					  i.Dom.after(c, a),
						t.mark(
						  c,
						  "width",
						  (100 * (s = u / e.offsetWidth / 2)).toFixed(
							r.ACCURACY,
						  ) + "%",
						  l,
						),
						t.mark(
						  a,
						  "width",
						  (100 * s).toFixed(r.ACCURACY) + "%",
						  l,
						),
						t.unmark(l),
						p(o).removeSelection(c);
					}),
					  t.normalizeTable(e);
				  }),
				  (t.setColumnWidthByDelta = function (e, o, n, i, a) {
					for (
					  var s = t.formalMatrix(e), l = 0, c = 0;
					  s.length > c;
					  c += 1
					)
					  if (1 >= (u = s[c][o]).colSpan || 1 >= s.length) {
						t.mark(
						  u,
						  "width",
						  (((u.offsetWidth + n) / e.offsetWidth) * 100).toFixed(
							r.ACCURACY,
						  ) + "%",
						  a,
						),
						  (l = c);
						break;
					  }
					for (c = l + 1; s.length > c; c += 1) {
					  var u;
					  t.mark((u = s[c][o]), "width", null, a);
					}
					i || t.unmark(a);
				  }),
				  (t.mark = function (e, t, o, n) {
					var r;
					n.push(e);
					var i = null !== (r = u.get(e)) && void 0 !== r ? r : {};
					(i[t] = void 0 === o ? 1 : o), u.set(e, i);
				  }),
				  (t.unmark = function (e) {
					e.forEach(function (e) {
					  var t = u.get(e);
					  t &&
						(Object.keys(t).forEach(function (o) {
						  var n = t[o];
						  switch (o) {
							case "remove":
							  i.Dom.safeRemove(e);
							  break;
							case "rowspan":
							  (0, a.attr)(
								e,
								"rowspan",
								(0, a.isNumber)(n) && n > 1 ? n : null,
							  );
							  break;
							case "colspan":
							  (0, a.attr)(
								e,
								"colspan",
								(0, a.isNumber)(n) && n > 1 ? n : null,
							  );
							  break;
							case "width":
							  null == n
								? (e.style.removeProperty("width"),
								  (0, a.attr)(e, "style") ||
									(0, a.attr)(e, "style", null))
								: (e.style.width = n.toString());
						  }
						  delete t[o];
						}),
						u.delete(e));
					});
				  }),
				  (t.selectedByTable = new WeakMap()),
				  n.__decorate(
					[(0, c.debounce)()],
					t.prototype,
					"recalculateStyles",
					null,
				  ),
				  t
				);
			  })(s.ViewComponent);
			t.Table = d;
			var p = function (e) {
			  return e.getInstance("Table", e.o);
			};
		  },
		  48197: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ToolbarButton = void 0);
			var n = o(20255);
			o(53362);
			var r = o(96516),
			  i = o(43441),
			  a = o(64968),
			  s = o(12680),
			  l = o(81438),
			  c = o(40332),
			  u = o(77904),
			  d = o(72719),
			  p = o(29411),
			  f = o(38546),
			  h = (function (e) {
				function t(t, o, i) {
				  void 0 === i && (i = null);
				  var a = e.call(this, t) || this;
				  return (
					(a.control = o),
					(a.target = i),
					(a.state = n.__assign(
					  n.__assign({}, (0, r.UIButtonState)()),
					  { theme: "toolbar", currentValue: "", hasTrigger: !1 },
					)),
					(a.openedPopup = null),
					t.e.on([a.button, a.trigger], "mousedown", function (e) {
					  return e.preventDefault();
					}),
					a.onAction(a.onClick),
					a.hookStatus(p.STATUSES.ready, function () {
					  a.initFromControl(), a.initTooltip(), a.update();
					}),
					o.mods &&
					  Object.keys(o.mods).forEach(function (e) {
						o.mods && a.setMod(e, o.mods[e]);
					  }),
					a
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "ToolbarButton";
				  }),
				  Object.defineProperty(t.prototype, "toolbar", {
					get: function () {
					  return this.closest(d.ToolbarCollection);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "button", {
					get: function () {
					  return this.container.querySelector(
						"button.".concat(this.componentName, "__button"),
					  );
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.update = function () {
					var t = this.control,
					  o = this.state,
					  n = this.closest(d.ToolbarCollection);
					(o.disabled = this.calculateDisabledStatus(n)),
					  (o.activated = this.calculateActivatedStatus(n)),
					  (0, c.isFunction)(t.update) && n && t.update(this, n.jodit),
					  e.prototype.update.call(this);
				  }),
				  (t.prototype.calculateActivatedStatus = function (e) {
					return (
					  !((0, c.isJoditObject)(this.j) && !this.j.editorIsActive) &&
					  (!(
						!(0, c.isFunction)(this.control.isActive) ||
						!this.control.isActive(this.j, this.control, this)
					  ) ||
						Boolean(e && e.shouldBeActive(this)))
					);
				  }),
				  (t.prototype.calculateDisabledStatus = function (e) {
					return (
					  !!this.j.o.disabled ||
					  !(
						!this.j.o.readonly ||
						(this.j.o.activeButtonsInReadOnly &&
						  this.j.o.activeButtonsInReadOnly.includes(
							this.control.name,
						  ))
					  ) ||
					  !(
						!(0, c.isFunction)(this.control.isDisabled) ||
						!this.control.isDisabled(this.j, this.control, this)
					  ) ||
					  Boolean(e && e.shouldBeDisabled(this))
					);
				  }),
				  (t.prototype.onChangeActivated = function () {
					(0, c.attr)(
					  this.button,
					  "aria-pressed",
					  this.state.activated,
					),
					  e.prototype.onChangeActivated.call(this);
				  }),
				  (t.prototype.onChangeText = function () {
					(0, c.isFunction)(this.control.template)
					  ? (this.text.innerHTML = this.control.template(
						  this.j,
						  this.control.name,
						  this.j.i18n(this.state.text),
						))
					  : e.prototype.onChangeText.call(this),
					  this.setMod(
						"text-icons",
						Boolean(this.text.innerText.trim().length),
					  );
				  }),
				  (t.prototype.onChangeTabIndex = function () {
					(0, c.attr)(this.button, "tabindex", this.state.tabIndex);
				  }),
				  (t.prototype.onChangeTooltip = function () {
					(0, c.attr)(this.button, "aria-label", this.state.tooltip),
					  e.prototype.onChangeTooltip.call(this);
				  }),
				  (t.prototype.createContainer = function () {
					var t = this.componentName,
					  o = this.j.c.span(t),
					  n = e.prototype.createContainer.call(this);
					return (
					  (0, c.attr)(o, "role", "listitem"),
					  n.classList.remove(t),
					  n.classList.add(t + "__button"),
					  Object.defineProperty(n, "component", { value: this }),
					  o.appendChild(n),
					  (this.trigger = this.j.c.fromHTML(
						'<span role="trigger" class="'
						  .concat(t, '__trigger">')
						  .concat(u.Icon.get("chevron"), "</span>"),
					  )),
					  o
					);
				  }),
				  (t.prototype.focus = function () {
					var e;
					null === (e = this.container.querySelector("button")) ||
					  void 0 === e ||
					  e.focus();
				  }),
				  (t.prototype.onChangeHasTrigger = function () {
					this.state.hasTrigger
					  ? this.container.appendChild(this.trigger)
					  : a.Dom.safeRemove(this.trigger),
					  this.setMod("with-trigger", this.state.hasTrigger || null);
				  }),
				  (t.prototype.onChangeDisabled = function () {
					var e = this.state.disabled ? "disabled" : null;
					(0, c.attr)(this.trigger, "disabled", e),
					  (0, c.attr)(this.button, "disabled", e),
					  (0, c.attr)(this.container, "disabled", e);
				  }),
				  (t.prototype.initTooltip = function () {
					var e = this;
					this.j.o.textIcons ||
					  !this.j.o.showTooltip ||
					  this.j.o.useNativeTooltip ||
					  this.j.e
						.off(this.container, "mouseenter mouseleave")
						.on(this.container, "mousemove", function (t) {
						  e.state.tooltip &&
							!e.state.disabled &&
							e.j.e.fire(
							  "delayShowTooltip",
							  function () {
								return { x: t.clientX + 10, y: t.clientY + 10 };
							  },
							  e.state.tooltip,
							);
						})
						.on(this.container, "mouseleave", function () {
						  e.j.e.fire("hideTooltip");
						});
				  }),
				  (t.prototype.initFromControl = function () {
					var e,
					  t = this.control,
					  o = this.state;
					this.updateSize(), (o.name = t.name);
					var n = this.j.o.textIcons;
					if (
					  !0 === n ||
					  ((0, c.isFunction)(n) && n(t.name)) ||
					  t.template
					)
					  (o.icon = (0, r.UIButtonState)().icon),
						(o.text = t.text || t.name);
					else {
					  if (t.iconURL) o.icon.iconURL = t.iconURL;
					  else {
						var i = t.icon || t.name;
						o.icon.name =
						  u.Icon.exists(i) ||
						  (null === (e = this.j.o.extraIcons) || void 0 === e
							? void 0
							: e[i])
							? i
							: "";
					  }
					  t.iconURL || o.icon.name || (o.text = t.text || t.name);
					}
					t.tooltip &&
					  (o.tooltip = this.j.i18n(
						(0, c.isFunction)(t.tooltip)
						  ? t.tooltip(this.j, t, this)
						  : t.tooltip,
					  )),
					  (o.hasTrigger = Boolean(t.list || (t.popup && t.exec)));
				  }),
				  (t.prototype.onTriggerClick = function (e) {
					var t,
					  o,
					  n,
					  r = this;
					if (this.openedPopup) this.closePopup();
					else {
					  var i = this.control;
					  if (((e.buffer = { actionTrigger: this }), i.list))
						return this.openControlList(i);
					  if ((0, c.isFunction)(i.popup)) {
						var a = this.openPopup();
						if (
						  ((a.parentElement = this),
						  !1 !==
							this.j.e.fire(
							  (0, c.camelCase)(
								"before-".concat(i.name, "-open-popup"),
							  ),
							  this.target,
							  i,
							  a,
							))
						) {
						  var s =
							  null !==
								(n =
								  null !==
									(o =
									  null === (t = this.toolbar) || void 0 === t
										? void 0
										: t.getTarget(this)) && void 0 !== o
									? o
									: this.target) && void 0 !== n
								? n
								: null,
							l = i.popup(this.j, s, i, this.closePopup, this);
						  l &&
							a
							  .setContent(
								(0, c.isString)(l) ? this.j.c.fromHTML(l) : l,
							  )
							  .open(
								function () {
								  return (0, c.position)(r.container);
								},
								!1,
								this.j.o.allowTabNavigation
								  ? this.container
								  : void 0,
							  );
						}
						this.j.e.fire(
						  (0, c.camelCase)(
							"after-".concat(i.name, "-open-popup"),
						  ),
						  a.container,
						);
					  }
					}
				  }),
				  (t.prototype.openControlList = function (e) {
					var t,
					  o = this,
					  r =
						null !== (t = this.jodit.options.controls) && void 0 !== t
						  ? t
						  : {},
					  i = function (e) {
						return (0, f.findControlType)(e, r);
					  },
					  a = e.list,
					  s = this.openPopup(),
					  u = (0, l.makeCollection)(this.j);
					(s.parentElement = this),
					  (u.parentElement = s),
					  (u.mode = "vertical");
					var d = function (t, r) {
					  if ((0, c.isString)(r) && i(r))
						return n.__assign({ name: r.toString() }, i(r));
					  if ((0, c.isString)(t) && i(t))
						return n.__assign(
						  n.__assign({ name: t.toString() }, i(t)),
						  "object" == typeof r ? r : {},
						);
					  (function (e) {
						return (
						  (0, c.isPlainObject)(e) && "title" in e && "value" in e
						);
					  })(t) && ((r = t.value), (t = t.title));
					  var a = e.childTemplate,
						s = {
						  name: t.toString(),
						  template:
							a &&
							function (e, t, n) {
							  return a(e, t, n, o);
							},
						  exec: e.childExec
							? function (t, o, r) {
								var i;
								return null === (i = e.childExec) || void 0 === i
								  ? void 0
								  : i.call(
									  e,
									  t,
									  o,
									  n.__assign(n.__assign({}, r), {
										parentControl: e,
									  }),
									);
							  }
							: e.exec,
						  data: e.data,
						  command: e.command,
						  isActive: e.isChildActive,
						  isDisabled: e.isChildDisabled,
						  mode: e.mode,
						  args: n.__spreadArray(
							n.__spreadArray(
							  [],
							  n.__read(e.args ? e.args : []),
							  !1,
							),
							[t, r],
							!1,
						  ),
						};
					  return (0, c.isString)(r) && (s.text = r), s;
					};
					u.build(
					  (0, c.isArray)(a)
						? a.map(d)
						: (0, c.keys)(a, !1).map(function (e) {
							return d(e, a[e]);
						  }),
					  this.target,
					),
					  s.setContent(u.container).open(
						function () {
						  return (0, c.position)(o.container);
						},
						!1,
						this.j.o.allowTabNavigation ? this.container : void 0,
					  ),
					  (this.state.activated = !0);
				  }),
				  (t.prototype.onOutsideClick = function (e) {
					this.openedPopup &&
					  ((e &&
						a.Dom.isNode(e.target) &&
						(a.Dom.isOrContains(this.container, e.target) ||
						  this.openedPopup.isOwnClick(e))) ||
						this.closePopup());
				  }),
				  (t.prototype.openPopup = function () {
					return (
					  this.closePopup(),
					  (this.openedPopup = new s.Popup(this.j, !1)),
					  this.j.e
						.on(this.ow, "mousedown touchstart", this.onOutsideClick)
						.on("escape closeAllPopups", this.onOutsideClick),
					  this.openedPopup
					);
				  }),
				  (t.prototype.closePopup = function () {
					this.openedPopup &&
					  (this.j.e
						.off(this.ow, "mousedown touchstart", this.onOutsideClick)
						.off("escape closeAllPopups", this.onOutsideClick),
					  (this.state.activated = !1),
					  this.openedPopup.close(),
					  this.openedPopup.destruct(),
					  (this.openedPopup = null));
				  }),
				  (t.prototype.onClick = function (e) {
					var t,
					  o,
					  n,
					  r,
					  i,
					  a,
					  s,
					  l = this.control;
					if ((0, c.isFunction)(l.exec)) {
					  var u =
						  null !==
							(n =
							  null !==
								(o =
								  null === (t = this.toolbar) || void 0 === t
									? void 0
									: t.getTarget(this)) && void 0 !== o
								? o
								: this.target) && void 0 !== n
							? n
							: null,
						d = l.exec(this.j, u, {
						  control: l,
						  originalEvent: e,
						  button: this,
						});
					  if (
						(!1 !== d &&
						  !0 !== d &&
						  (null ===
							(i =
							  null === (r = this.j) || void 0 === r
								? void 0
								: r.e) ||
							void 0 === i ||
							i.fire("synchro"),
						  this.parentElement && this.parentElement.update(),
						  null ===
							(s =
							  null === (a = this.j) || void 0 === a
								? void 0
								: a.e) ||
							void 0 === s ||
							s.fire("closeAllPopups afterExec")),
						!1 !== d)
					  )
						return;
					}
					return l.list
					  ? this.openControlList(l)
					  : (0, c.isFunction)(l.popup)
						? this.onTriggerClick(e)
						: void (
							(l.command || l.name) &&
							((0, c.call)(
							  (0, c.isJoditObject)(this.j)
								? this.j.execCommand.bind(this.j)
								: this.j.od.execCommand.bind(this.j.od),
							  l.command || l.name,
							  !1,
							  l.args && l.args[0],
							),
							this.j.e.fire("closeAllPopups"))
						  );
				  }),
				  (t.prototype.destruct = function () {
					return this.closePopup(), e.prototype.destruct.call(this);
				  }),
				  n.__decorate(
					[(0, i.watch)("state.tooltip")],
					t.prototype,
					"onChangeTooltip",
					null,
				  ),
				  n.__decorate(
					[(0, i.watch)("state.hasTrigger")],
					t.prototype,
					"onChangeHasTrigger",
					null,
				  ),
				  n.__decorate(
					[(0, i.watch)("trigger:click")],
					t.prototype,
					"onTriggerClick",
					null,
				  ),
				  n.__decorate([i.autobind], t.prototype, "onOutsideClick", null),
				  n.__decorate([i.autobind], t.prototype, "closePopup", null),
				  n.__decorate([i.component], t)
				);
			  })(r.UIButton);
			t.ToolbarButton = h;
		  },
		  34375: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ToolbarContent = void 0);
			var n = o(20255);
			o(48904);
			var r = o(96516),
			  i = o(64968),
			  a = o(40332),
			  s = o(43441),
			  l = (function (e) {
				function t(t, o, n) {
				  void 0 === n && (n = null);
				  var r = e.call(this, t) || this;
				  return (
					(r.control = o),
					(r.target = n),
					r.container.classList.add(
					  "".concat(r.componentName, "_").concat(r.clearName(o.name)),
					),
					(0, a.attr)(r.container, "role", "content"),
					r
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "ToolbarContent";
				  }),
				  (t.prototype.update = function () {
					var t = this.control.getContent(this.j, this.control, this);
					((0, a.isString)(t) || t.parentNode !== this.container) &&
					  (i.Dom.detach(this.container),
					  this.container.appendChild(
						(0, a.isString)(t) ? this.j.create.fromHTML(t) : t,
					  )),
					  e.prototype.update.call(this);
				  }),
				  (t.prototype.createContainer = function () {
					return this.j.c.span(this.componentName);
				  }),
				  n.__decorate([s.component], t)
				);
			  })(r.UIButton);
			t.ToolbarContent = l;
		  },
		  3890: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(48197), t), n.__exportStar(o(34375), t);
		  },
		  72719: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ToolbarCollection = void 0);
			var n = o(20255);
			o(85796);
			var r = o(40332),
			  i = o(2074),
			  a = o(81438),
			  s = o(43441),
			  l = (function (e) {
				function t(t) {
				  var o = e.call(this, t) || this;
				  return (
					(o.__listenEvents =
					  "updatePlugins updateToolbar changeStack mousedown mouseup keydown change afterInit readonly afterResize selectionchange changeSelection focus afterSetMode touchstart focus blur"),
					(o.update = o.j.async.debounce(
					  o.__immediateUpdate,
					  function () {
						return o.j.defaultTimeout;
					  },
					)),
					(o.__tooltip = null),
					o.__initEvents(),
					(o.__tooltip = i.UITooltip.make(t)),
					o
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "ToolbarCollection";
				  }),
				  Object.defineProperty(t.prototype, "firstButton", {
					get: function () {
					  return n.__read(this.buttons, 1)[0] || null;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.makeButton = function (e, t) {
					return (
					  void 0 === t && (t = null), (0, a.makeButton)(this.j, e, t)
					);
				  }),
				  (t.prototype.shouldBeActive = function (e) {}),
				  (t.prototype.shouldBeDisabled = function (e) {}),
				  (t.prototype.getTarget = function (e) {
					return e.target || null;
				  }),
				  (t.prototype.__immediateUpdate = function () {
					this.isDestructed ||
					  this.j.isLocked ||
					  (e.prototype.update.call(this),
					  this.j.e.fire("afterUpdateToolbar"));
				  }),
				  (t.prototype.setDirection = function (e) {
					(this.container.style.direction = e),
					  this.container.setAttribute("dir", e);
				  }),
				  (t.prototype.__initEvents = function () {
					this.j.e
					  .on(this.__listenEvents, this.update)
					  .on("afterSetMode focus", this.__immediateUpdate);
				  }),
				  (t.prototype.hide = function () {
					this.container.remove();
				  }),
				  (t.prototype.show = function () {
					this.appendTo(this.j.toolbarContainer);
				  }),
				  (t.prototype.showInline = function (e) {
					throw (0, r.error)(
					  "The method is not implemented for this class.",
					);
				  }),
				  (t.prototype.build = function (t, o) {
					void 0 === o && (o = null);
					var n = this.j.e.fire("beforeToolbarBuild", t);
					return n && (t = n), e.prototype.build.call(this, t, o), this;
				  }),
				  (t.prototype.destruct = function () {
					var t;
					this.isDestructed ||
					  (null === (t = this.__tooltip) ||
						void 0 === t ||
						t.destruct(),
					  this.j.e
						.off(this.__listenEvents, this.update)
						.off("afterSetMode focus", this.__immediateUpdate),
					  e.prototype.destruct.call(this));
				  }),
				  n.__decorate(
					[s.autobind],
					t.prototype,
					"__immediateUpdate",
					null,
				  ),
				  n.__decorate([s.component], t)
				);
			  })(i.UIList);
			t.ToolbarCollection = l;
		  },
		  81698: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ToolbarEditorCollection = void 0);
			var n = o(20255),
			  r = o(72719),
			  i = o(86893),
			  a = o(64968),
			  s = o(40332),
			  l = o(43441),
			  c = (function (e) {
				function t(t) {
				  var o = e.call(this, t) || this;
				  return (
					(o.checkActiveStatus = function (e, t) {
					  var n = 0,
						r = 0;
					  return (
						Object.keys(e).forEach(function (i) {
						  var a = e[i];
						  (0, s.isFunction)(a)
							? a(o.j, (0, s.css)(t, i).toString()) && (n += 1)
							: -1 !== a.indexOf((0, s.css)(t, i).toString()) &&
							  (n += 1),
							(r += 1);
						}),
						r === n
					  );
					}),
					o.prependInvisibleInput(o.container),
					o
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "ToolbarEditorCollection";
				  }),
				  (t.prototype.shouldBeDisabled = function (t) {
					var o = e.prototype.shouldBeDisabled.call(this, t);
					if (void 0 !== o) return o;
					var n =
					  void 0 === t.control.mode ? i.MODE_WYSIWYG : t.control.mode;
					return !(n === i.MODE_SPLIT || n === this.j.getRealMode());
				  }),
				  (t.prototype.shouldBeActive = function (t) {
					var o = this,
					  n = e.prototype.shouldBeActive.call(this, t);
					if (void 0 !== n) return n;
					var r = this.j.selection ? this.j.s.current() : null;
					if (!r) return !1;
					if (t.control.tags) {
					  var i = t.control.tags;
					  if (
						a.Dom.up(
						  r,
						  function (e) {
							if (e && -1 !== i.indexOf(e.nodeName.toLowerCase()))
							  return !0;
						  },
						  this.j.editor,
						)
					  )
						return !0;
					}
					if (t.control.css) {
					  var s = t.control.css;
					  if (
						a.Dom.up(
						  r,
						  function (e) {
							if (e && !a.Dom.isText(e))
							  return o.checkActiveStatus(s, e);
						  },
						  this.j.editor,
						)
					  )
						return !0;
					}
					return !1;
				  }),
				  (t.prototype.getTarget = function (e) {
					return e.target || this.j.s.current() || null;
				  }),
				  (t.prototype.prependInvisibleInput = function (e) {
					var t = this.j.create.element("input", {
					  tabIndex: -1,
					  disabled: !0,
					  style:
						"width: 0; height:0; position: absolute; visibility: hidden;",
					});
					a.Dom.appendChildFirst(e, t);
				  }),
				  (t.prototype.showInline = function (e) {
					this.jodit.e.fire("showInlineToolbar", e);
				  }),
				  (t.prototype.hide = function () {
					this.jodit.e.fire("hidePopup"),
					  e.prototype.hide.call(this),
					  this.jodit.e.fire("toggleToolbar");
				  }),
				  (t.prototype.show = function () {
					e.prototype.show.call(this),
					  this.jodit.e.fire("toggleToolbar");
				  }),
				  n.__decorate([l.component], t)
				);
			  })(r.ToolbarCollection);
			t.ToolbarEditorCollection = c;
		  },
		  81438: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.makeButton = t.makeCollection = void 0);
			var n = o(40332),
			  r = o(72719),
			  i = o(81698),
			  a = o(48197),
			  s = o(34375);
			(t.makeCollection = function (e, t) {
			  var o = (0, n.isJoditObject)(e)
				? new i.ToolbarEditorCollection(e)
				: new r.ToolbarCollection(e);
			  return (
				e.o.textIcons && o.container.classList.add("jodit_text_icons"),
				t && (o.parentElement = t),
				e.o.toolbarButtonSize && (o.buttonSize = e.o.toolbarButtonSize),
				o
			  );
			}),
			  (t.makeButton = function (e, t, o) {
				if ((void 0 === o && (o = null), (0, n.isFunction)(t.getContent)))
				  return new s.ToolbarContent(e, t, o);
				var r = new a.ToolbarButton(e, t, o);
				return (r.state.tabIndex = e.o.allowTabNavigation ? 0 : -1), r;
			  });
		  },
		  36262: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255),
			  r = o(93166),
			  i = o(49781),
			  a = o(77892);
			(r.Config.prototype.enableDragAndDropFileToEditor = !0),
			  (r.Config.prototype.uploader = {
				url: "",
				insertImageAsBase64URI: !1,
				imagesExtensions: ["jpg", "png", "jpeg", "gif"],
				headers: null,
				data: null,
				filesVariableName: function (e) {
				  return "files[".concat(e, "]");
				},
				withCredentials: !1,
				pathVariableName: "path",
				format: "json",
				method: "POST",
				prepareData: function (e) {
				  return e;
				},
				isSuccess: function (e) {
				  return e.success;
				},
				getMessage: function (e) {
				  return void 0 !== e.data.messages &&
					(0, i.isArray)(e.data.messages)
					? e.data.messages.join(" ")
					: "";
				},
				processFileName: function (e, t, o) {
				  return [e, t, o];
				},
				process: function (e) {
				  return e.data;
				},
				error: function (e) {
				  this.j.e.fire("errorMessage", e.message, "error", 4e3);
				},
				getDisplayName: function (e, t) {
				  return e + t;
				},
				defaultHandlerSuccess: function (e) {
				  var t = this,
					o = this.j || this;
				  (0, a.isJoditObject)(o) &&
					e.files &&
					e.files.length &&
					e.files.forEach(function (r, i) {
					  var a = n.__read(
						  e.isImages && e.isImages[i]
							? ["img", "src"]
							: ["a", "href"],
						  2,
						),
						s = a[0],
						l = a[1],
						c = o.createInside.element(s);
					  c.setAttribute(l, e.baseurl + r),
						"a" === s &&
						  (c.textContent = o.o.uploader.getDisplayName.call(
							t,
							e.baseurl,
							r,
						  )),
						"img" === s
						  ? o.s.insertImage(c, null, o.o.imageDefaultWidth)
						  : o.s.insertNode(c);
					});
				},
				defaultHandlerError: function (e) {
				  this.j.e.fire("errorMessage", e.message);
				},
				contentType: function (e) {
				  return (
					(void 0 === this.ow.FormData || "string" == typeof e) &&
					"application/x-www-form-urlencoded; charset=UTF-8"
				  );
				},
			  });
		  },
		  55778: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.buildData = void 0);
			var n = o(40332);
			t.buildData = function (e, t) {
			  if ((0, n.isFunction)(e.o.buildData))
				return e.o.buildData.call(e, t);
			  var o = e.ow.FormData;
			  if (void 0 !== o) {
				if (t instanceof o) return t;
				if ((0, n.isString)(t)) return t;
				var r = new o();
				return (
				  Object.keys(t).forEach(function (e) {
					r.append(e, t[e]);
				  }),
				  r
				);
			  }
			  return t;
			};
		  },
		  98099: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.dataURItoBlob = void 0),
			  (t.dataURItoBlob = function (e) {
				for (
				  var t = atob(e.split(",")[1]),
					o = e.split(",")[0].split(":")[1].split(";")[0],
					n = new ArrayBuffer(t.length),
					r = new Uint8Array(n),
					i = 0;
				  t.length > i;
				  i += 1
				)
				  r[i] = t.charCodeAt(i);
				return new Blob([r], { type: o });
			  });
		  },
		  41566: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.hasItems = t.hasFiles = void 0);
			var n = o(20255);
			n.__exportStar(o(32937), t),
			  n.__exportStar(o(98099), t),
			  n.__exportStar(o(55778), t),
			  n.__exportStar(o(30863), t),
			  n.__exportStar(o(20704), t),
			  (t.hasFiles = function (e) {
				return Boolean(e && e.files && e.files.length > 0);
			  }),
			  (t.hasItems = function (e) {
				return Boolean(e && e.items && e.items.length > 0);
			  });
		  },
		  32937: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.processOldBrowserDrag = void 0);
			var n = o(86893),
			  r = o(17332),
			  i = o(40332),
			  a = o(64968),
			  s = o(41566);
			t.processOldBrowserDrag = function (e, t, o, l, c) {
			  if (t && (!t.types.length || t.types[0] !== n.TEXT_PLAIN)) {
				var u = e.j.c.div("", {
				  tabindex: -1,
				  style:
					"left: -9999px; top: 0; width: 0; height: 100%;line-height: 140%; overflow: hidden; position: fixed; z-index: 2147483647; word-break: break-all;",
				  contenteditable: !0,
				});
				(0, r.getContainer)(e.j, e.constructor).appendChild(u);
				var d = (0, i.isJoditObject)(e.j) ? e.j.s.save() : null;
				u.focus(),
				  e.j.async.setTimeout(function () {
					var t = u.firstChild;
					if ((a.Dom.safeRemove(u), t && t.hasAttribute("src"))) {
					  var n = (0, i.attr)(t, "src") || "";
					  d && (0, i.isJoditObject)(e.j) && e.j.s.restore(),
						(0, s.sendFiles)(
						  e,
						  [(0, s.dataURItoBlob)(n)],
						  o,
						  l,
						).finally(c);
					}
				  }, e.j.defaultTimeout);
			  }
			};
		  },
		  20704: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.sendFiles = void 0);
			var n = o(20255),
			  r = o(40332),
			  i = o(30863);
			t.sendFiles = function (e, t, o, a, s) {
			  if (!t) return Promise.reject((0, r.error)("Need files"));
			  var l = e.o,
				c = (0, r.toArray)(t);
			  if (!c.length) return Promise.reject((0, r.error)("Need files"));
			  var u = [];
			  if (l.insertImageAsBase64URI) {
				var d,
				  p = void 0,
				  f = function () {
					if ((d = c[p]) && d.type) {
					  var t = d.type.match(/\/([a-z0-9]+)/i),
						n = t[1] ? t[1].toLowerCase() : "";
					  if (l.imagesExtensions.includes(n)) {
						var i = new FileReader();
						u.push(
						  e.j.async.promise(function (t, n) {
							(i.onerror = n),
							  (i.onloadend = function () {
								var n = {
								  baseurl: "",
								  files: [i.result],
								  isImages: [!0],
								};
								((0, r.isFunction)(o)
								  ? o
								  : l.defaultHandlerSuccess
								).call(e, n),
								  t(n);
							  }),
							  i.readAsDataURL(d);
						  }),
						),
						  (c[p] = null);
					  }
					}
				  };
				for (p = 0; c.length > p; p += 1) f();
			  }
			  if (
				(c = c.filter(function (e) {
				  return e;
				})).length
			  ) {
				var h = new FormData();
				h.append(l.pathVariableName, e.path),
				  h.append("source", e.source);
				var m = void 0;
				for (p = 0; c.length > p; p += 1)
				  if ((m = c[p])) {
					var v = /\.[\d\w]+$/.test(m.name),
					  g = m.type.match(/\/([a-z0-9]+)/i),
					  y = g && g[1] ? g[1].toLowerCase() : "",
					  _ = c[p].name || Math.random().toString().replace(".", "");
					if (!v && y) {
					  var b = y;
					  ["jpeg", "jpg"].includes(b) && (b = "jpeg|jpg"),
						new RegExp(".(" + b + ")$", "i").test(_) ||
						  (_ += "." + y);
					}
					var w = n.__read(
					  l.processFileName.call(e, l.filesVariableName(p), c[p], _),
					  3,
					);
					h.append(w[0], w[1], w[2]);
				  }
				s && s(h),
				  l.data &&
					(0, r.isPlainObject)(l.data) &&
					Object.keys(l.data).forEach(function (e) {
					  h.append(e, l.data[e]);
					}),
				  l.prepareData.call(e, h),
				  u.push(
					(0, i.send)(e, h)
					  .then(function (t) {
						return l.isSuccess.call(e, t)
						  ? (((0, r.isFunction)(o)
							  ? o
							  : l.defaultHandlerSuccess
							).call(e, l.process.call(e, t)),
							t)
						  : (((0, r.isFunction)(a)
							  ? a
							  : l.defaultHandlerError
							).call(e, (0, r.error)(l.getMessage.call(e, t))),
							t);
					  })
					  .then(function () {
						e.j.events && e.j.e.fire("filesWereUploaded");
					  }),
				  );
			  }
			  return Promise.all(u);
			};
		  },
		  30863: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.send = t.ajaxInstances = void 0);
			var n = o(30056),
			  r = o(40332),
			  i = o(55778);
			(t.ajaxInstances = new WeakMap()),
			  (t.send = function (e, o) {
				var a = (0, i.buildData)(e, o),
				  s = function (o) {
					var i = new n.Ajax({
						xhr: function () {
						  var t = new XMLHttpRequest();
						  return (
							void 0 !== e.j.ow.FormData && t.upload
							  ? (e.j.progressbar.show().progress(10),
								t.upload.addEventListener(
								  "progress",
								  function (t) {
									if (t.lengthComputable) {
									  var o = t.loaded / t.total;
									  (o *= 100),
										e.j.progressbar.show().progress(o),
										100 > o || e.j.progressbar.hide();
									}
								  },
								  !1,
								))
							  : e.j.progressbar.hide(),
							t
						  );
						},
						method: e.o.method || "POST",
						data: o,
						url: (0, r.isFunction)(e.o.url) ? e.o.url(o) : e.o.url,
						headers: e.o.headers,
						queryBuild: e.o.queryBuild,
						contentType: e.o.contentType.call(e, o),
						withCredentials: e.o.withCredentials || !1,
					  }),
					  a = t.ajaxInstances.get(e);
					return (
					  a || ((a = new Set()), t.ajaxInstances.set(e, a)),
					  a.add(i),
					  e.j.e.one("beforeDestruct", i.destruct),
					  i
						.send()
						.then(function (e) {
						  return e.json();
						})
						.catch(function (t) {
						  e.o.error.call(e, t);
						})
						.finally(function () {
						  i.destruct(), null == a || a.delete(i);
						})
					);
				  };
				return (0, r.isPromise)(a)
				  ? a.then(s).catch(function (t) {
					  e.o.error.call(e, t);
					})
				  : s(a);
			  });
		  },
		  50454: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.Uploader = void 0);
			var n = o(20255);
			o(28654);
			var r = o(93166),
			  i = o(86893),
			  a = o(40332),
			  s = o(56562),
			  l = o(41566);
			o(36262);
			var c = (function (e) {
			  function t(t, o) {
				var n = e.call(this, t) || this;
				return (
				  (n.path = ""),
				  (n.source = "default"),
				  (n.options = (0, a.ConfigProto)(
					o || {},
					(0, a.ConfigProto)(
					  r.Config.defaultOptions.uploader,
					  (0, a.isJoditObject)(t) ? t.o.uploader : {},
					),
				  )),
				  n
				);
			  }
			  return (
				n.__extends(t, e),
				Object.defineProperty(t.prototype, "j", {
				  get: function () {
					return this.jodit;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.className = function () {
				  return "Uploader";
				}),
				Object.defineProperty(t.prototype, "o", {
				  get: function () {
					return this.options;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.setPath = function (e) {
				  return (this.path = e), this;
				}),
				(t.prototype.setSource = function (e) {
				  return (this.source = e), this;
				}),
				(t.prototype.bind = function (e, t, o) {
				  var n = function () {
					  e.classList.remove("jodit_drag_hover");
					},
					r = this,
					a = function (e) {
					  var a,
						s,
						c,
						u = e.clipboardData,
						d = function (e) {
						  s &&
							(e.append("extension", c),
							e.append("mimetype", s.type));
						};
					  if (!i.IS_IE && (0, l.hasFiles)(u))
						return (0, l.sendFiles)(r, u.files, t, o).finally(n), !1;
					  if (i.IS_IE)
						return (0, l.processOldBrowserDrag)(r, u, t, o, n);
					  if ((0, l.hasItems)(u)) {
						var p = u.items;
						for (a = 0; p.length > a; a += 1)
						  if ("file" === p[a].kind && "image/png" === p[a].type) {
							if ((s = p[a].getAsFile())) {
							  var f = s.type.match(/\/([a-z0-9]+)/i);
							  (c = f[1] ? f[1].toLowerCase() : ""),
								(0, l.sendFiles)(r, [s], t, o, d).finally(n);
							}
							e.preventDefault();
							break;
						  }
					  }
					};
				  r.j && r.j.editor !== e
					? r.j.e.on(e, "paste", a)
					: r.j.e.on("beforePaste", a),
					this.attachEvents(e, t, o, n);
				}),
				(t.prototype.attachEvents = function (e, t, o, n) {
				  var r = this;
				  r.j.e
					.on(
					  e,
					  "dragend dragover dragenter dragleave drop",
					  function (e) {
						e.preventDefault();
					  },
					)
					.on(e, "dragover", function (t) {
					  ((0, l.hasFiles)(t.dataTransfer) ||
						(0, l.hasItems)(t.dataTransfer)) &&
						(e.classList.add("jodit_drag_hover"), t.preventDefault());
					})
					.on(e, "dragend dragleave", function (t) {
					  e.classList.remove("jodit_drag_hover"),
						(0, l.hasFiles)(t.dataTransfer) && t.preventDefault();
					})
					.on(e, "drop", function (i) {
					  e.classList.remove("jodit_drag_hover"),
						(0, l.hasFiles)(i.dataTransfer) &&
						  (i.preventDefault(),
						  i.stopImmediatePropagation(),
						  (0, l.sendFiles)(r, i.dataTransfer.files, t, o).finally(
							n,
						  ));
					});
				  var i = e.querySelector("input[type=file]");
				  i &&
					r.j.e.on(i, "change", function () {
					  (0, l.sendFiles)(r, i.files, t, o)
						.then(function () {
						  (i.value = ""),
							/safari/i.test(navigator.userAgent) ||
							  ((i.type = ""), (i.type = "file"));
						})
						.finally(n);
					});
				}),
				(t.prototype.uploadRemoteImage = function (e, t, o) {
				  var n = this,
					r = n.o,
					i = (0, a.isFunction)(o) ? o : r.defaultHandlerError;
				  (0, l.send)(n, { action: "fileUploadRemote", url: e })
					.then(function (e) {
					  r.isSuccess.call(n, e)
						? ((0, a.isFunction)(t)
							? t
							: r.defaultHandlerSuccess
						  ).call(n, r.process.call(n, e))
						: i.call(n, (0, a.error)(r.getMessage.call(n, e)));
					})
					.catch(function (e) {
					  return i.call(n, e);
					});
				}),
				(t.prototype.destruct = function () {
				  this.setStatus(s.STATUSES.beforeDestruct);
				  var t = l.ajaxInstances.get(this);
				  t &&
					(t.forEach(function (e) {
					  try {
						e.destruct();
					  } catch (e) {}
					}),
					t.clear()),
					e.prototype.destruct.call(this);
				}),
				t
			  );
			})(s.ViewComponent);
			t.Uploader = c;
		  },
		  75243: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.ColorPickerWidget = void 0),
			  o(60819);
			var n = o(40332),
			  r = o(2074),
			  i = o(64968);
			r.Icon.set("palette", o(95331)),
			  (t.ColorPickerWidget = function (e, t, o) {
				var a = "jodit-color-picker",
				  s = (0, n.normalizeColor)(o),
				  l = e.c.div(a),
				  c = e.o.textIcons
					? "<span>".concat(e.i18n("palette"), "</span>")
					: r.Icon.get("palette"),
				  u = function (e) {
					var t = [];
					return (
					  (0, n.isPlainObject)(e)
						? Object.keys(e).forEach(function (o) {
							t.push(
							  '<div class="'
								.concat(a, "__group ")
								.concat(a, "__group-")
								.concat(o, '">'),
							),
							  t.push(u(e[o])),
							  t.push("</div>");
						  })
						: (0, n.isArray)(e) &&
						  e.forEach(function (e) {
							t.push(
							  "<span class='"
								.concat(a, "__color-item ")
								.concat(
								  s === e ? a + "__color-item_active_true" : "",
								  "' title=\"",
								)
								.concat(e, '" style="background-color:')
								.concat(e, '" data-color="')
								.concat(e, '"></span>'),
							);
						  }),
					  t.join("")
					);
				  };
				l.appendChild(
				  e.c.fromHTML(
					'<div class="'
					  .concat(a, '__groups">')
					  .concat(u(e.o.colors), "</div>"),
				  ),
				),
				  l.appendChild(
					e.c.fromHTML(
					  '<div data-ref="extra" class="'.concat(
						a,
						'__extra"></div>',
					  ),
					),
				  );
				var d = (0, n.refs)(l).extra;
				return (
				  e.o.showBrowserColorPicker &&
					(0, n.hasBrowserColorPicker)() &&
					(d.appendChild(
					  e.c.fromHTML(
						'<div class="'
						  .concat(a, '__native">')
						  .concat(
							c,
							'<input type="color" value="#ffffff"/></div>',
						  ),
					  ),
					),
					e.e.on(l, "change", function (e) {
					  e.stopPropagation();
					  var o = e.target;
					  if (o && o.tagName && i.Dom.isTag(o, "input")) {
						var r = o.value || "";
						(0, n.isFunction)(t) && t(r), e.preventDefault();
					  }
					})),
				  e.e.on(l, "mousedown touchend", function (o) {
					o.stopPropagation(), o.preventDefault();
					var r = o.target;
					if (
					  ((r &&
						r.tagName &&
						!i.Dom.isTag(r, "svg") &&
						!i.Dom.isTag(r, "path")) ||
						!r.parentNode ||
						(r = i.Dom.closest(r.parentNode, "span", e.editor)),
					  i.Dom.isTag(r, "span") &&
						r.classList.contains(a + "__color-item"))
					) {
					  var s = (0, n.attr)(r, "-color") || "";
					  t && (0, n.isFunction)(t) && t(s);
					}
				  }),
				  e.e.fire("afterGenerateColorPicker", l, d, t, s),
				  l
				);
			  });
		  },
		  83029: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.FileSelectorWidget = void 0);
			var n = o(40332),
			  r = o(64968),
			  i = o(2074),
			  a = o(60929);
			t.FileSelectorWidget = function (e, t, o, s, l) {
			  var c;
			  void 0 === l && (l = !0);
			  var u = [];
			  if (
				t.upload &&
				e.o.uploader &&
				(e.o.uploader.url || e.o.uploader.insertImageAsBase64URI)
			  ) {
				var d = e.c.fromHTML(
				  '<div class="jodit-drag-and-drop__file-box">' +
					"<strong>".concat(
					  e.i18n(l ? "Drop image" : "Drop file"),
					  "</strong>",
					) +
					"<span><br>".concat(e.i18n("or click"), "</span>") +
					'<input type="file" accept="'.concat(
					  l ? "image/*" : "*",
					  '" tabindex="-1" dir="auto" multiple=""/>',
					) +
					"</div>",
				);
				e.uploader.bind(
				  d,
				  function (o) {
					var r = (0, n.isFunction)(t.upload)
					  ? t.upload
					  : e.o.uploader.defaultHandlerSuccess;
					(0, n.isFunction)(r) && r.call(e, o),
					  e.e.fire("closeAllPopups");
				  },
				  function (t) {
					e.e.fire("errorMessage", t.message),
					  e.e.fire("closeAllPopups");
				  },
				),
				  u.push({ icon: "upload", name: "Upload", content: d });
			  }
			  if (
				(t.filebrowser &&
				  (e.o.filebrowser.ajax.url || e.o.filebrowser.items.url) &&
				  u.push({
					icon: "folder",
					name: "Browse",
					content: function () {
					  s && s(),
						t.filebrowser && e.filebrowser.open(t.filebrowser, l);
					},
				  }),
				t.url)
			  ) {
				var p = new i.UIButton(e, {
					type: "submit",
					variant: "primary",
					text: "Insert",
				  }),
				  f = new i.UIForm(e, [
					new i.UIInput(e, {
					  required: !0,
					  label: "URL",
					  name: "url",
					  type: "text",
					  placeholder: "https://",
					}),
					new i.UIInput(e, { name: "text", label: "Alternative text" }),
					new i.UIBlock(e, [p]),
				  ]);
				(c = null),
				  o &&
					!r.Dom.isText(o) &&
					(r.Dom.isTag(o, "img") || (0, n.$$)("img", o).length) &&
					((c = "IMG" === o.tagName ? o : (0, n.$$)("img", o)[0]),
					(0, n.val)(
					  f.container,
					  "input[name=url]",
					  (0, n.attr)(c, "src"),
					),
					(0, n.val)(
					  f.container,
					  "input[name=text]",
					  (0, n.attr)(c, "alt"),
					),
					(p.state.text = "Update")),
				  o &&
					r.Dom.isTag(o, "a") &&
					((0, n.val)(
					  f.container,
					  "input[name=url]",
					  (0, n.attr)(o, "href"),
					),
					(0, n.val)(
					  f.container,
					  "input[name=text]",
					  (0, n.attr)(o, "title"),
					),
					(p.state.text = "Update")),
				  f.onSubmit(function (o) {
					(0, n.isFunction)(t.url) && t.url.call(e, o.url, o.text);
				  }),
				  u.push({ icon: "link", name: "URL", content: f.container });
			  }
			  return (0, a.TabsWidget)(e, u);
			};
		  },
		  718: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(75243), t),
			  n.__exportStar(o(60929), t),
			  n.__exportStar(o(83029), t);
		  },
		  60929: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.TabsWidget = void 0),
			  o(96410);
			var n = o(40332),
			  r = o(42096),
			  i = o(2074),
			  a = o(56562),
			  s = o(24263);
			t.TabsWidget = function (e, t, o) {
			  var l = e.c.div("jodit-tabs"),
				c = e.c.div("jodit-tabs__wrapper"),
				u = e.c.div("jodit-tabs__buttons"),
				d = {},
				p = [],
				f = "",
				h = 0;
			  l.appendChild(u), l.appendChild(c);
			  var m = function (e) {
				d[e] &&
				  (p.forEach(function (e) {
					e.state.activated = !1;
				  }),
				  (0, n.$$)(".jodit-tab", c).forEach(function (e) {
					e.classList.remove("jodit-tab_active");
				  }),
				  (d[e].button.state.activated = !0),
				  d[e].tab.classList.add("jodit-tab_active"));
			  };
			  if (
				(t.forEach(function (n) {
				  var l = n.icon,
					v = n.name,
					g = n.content,
					y = e.c.div("jodit-tab"),
					_ = (0, i.Button)(e, l || v, v);
				  e.e.on(_.container, "mousedown", function (e) {
					return e.preventDefault();
				  }),
					f || (f = v),
					u.appendChild(_.container),
					p.push(_),
					_.container.classList.add(
					  "jodit-tabs__button",
					  "jodit-tabs__button_columns_" + t.length,
					),
					(0, r.isFunction)(g)
					  ? y.appendChild(e.c.div("jodit-tab_empty"))
					  : y.appendChild(
						  a.Component.isInstanceOf(g, i.UIElement)
							? g.container
							: g,
						),
					c.appendChild(y),
					_.onAction(function () {
					  return (
						m(v),
						(0, r.isFunction)(g) && !s.Dom.isElement(g) && g.call(e),
						o && (o.__activeTab = v),
						!1
					  );
					}),
					(d[v] = { button: _, tab: y }),
					(h += 1);
				}),
				!h)
			  )
				return l;
			  if (
				((0, n.$$)("a", u).forEach(function (e) {
				  e.style.width = (100 / h).toFixed(10) + "%";
				}),
				m(o && o.__activeTab && d[o.__activeTab] ? o.__activeTab : f),
				o)
			  ) {
				var v = o.__activeTab;
				Object.defineProperty(o, "__activeTab", {
				  configurable: !0,
				  enumerable: !1,
				  get: function () {
					return v;
				  },
				  set: function (e) {
					(v = e), m(e);
				  },
				});
			  }
			  return l;
			};
		  },
		  55692: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }), o(33126);
			var n = o(93166),
			  r = o(40332),
			  i = o(86893),
			  a = o(17332),
			  s = o(77904);
			(n.Config.prototype.controls.about = {
			  exec: function (e) {
				var t = e.dlg(),
				  o = e.i18n.bind(e);
				t
				  .setMod("theme", e.o.theme)
				  .setHeader(o("About Jodit"))
				  .setContent(
					'<div class="jodit-about">\n\t\t\t\t\t<div>'
					  .concat(o("Jodit Editor"), " v.")
					  .concat(e.getVersion(), "</div>\n\t\t\t\t\t<div>")
					  .concat(
						o(
						  "License: %s",
						  (0, r.isLicense)(e.o.license)
							? (0, r.normalizeLicense)(e.o.license)
							: "MIT",
						),
						'</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="',
					  )
					  .concat("https://xdsoft.net/jodit/", '" target="_blank">')
					  .concat(
						"https://xdsoft.net/jodit/",
						'</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="https://xdsoft.net/jodit/docs/" target="_blank">',
					  )
					  .concat(o("Jodit User's Guide"), "</a>\n\t\t\t\t\t\t")
					  .concat(
						o("contains detailed help for using"),
						"\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>",
					  )
					  .concat(
						o(
						  "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
						),
						"</div>\n\t\t\t\t</div>",
					  ),
				  ),
				  (0, r.css)(t.dialog, { minHeight: 200, minWidth: 420 }),
				  t.open(!0);
			  },
			  tooltip: "About Jodit",
			  mode: i.MODE_SOURCE + i.MODE_WYSIWYG,
			}),
			  a.pluginSystem.add("about", function (e) {
				e.registerButton({ name: "about", group: "info" });
			  }),
			  s.Icon.set("about", o(84279));
		  },
		  66031: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.addNewLine = void 0);
			var n = o(20255);
			o(30724);
			var r = o(87837),
			  i = o(40332),
			  a = o(43441),
			  s = o(17332);
			o(46360);
			var l = "addnewline",
			  c = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.line = t.j.c.fromHTML(
					  '<div role="button" tabindex="-1" title="'
						.concat(
						  t.j.i18n("Break"),
						  '" class="jodit-add-new-line"><span>',
						)
						.concat(r.Icon.get("enter"), "</span></div>"),
					)),
					(t.isMatchedTag = function (e) {
					  return Boolean(
						e &&
						  t.j.o.addNewLineTagsTriggers.includes(
							e.nodeName.toLowerCase(),
						  ),
					  );
					}),
					(t.preview = !1),
					(t.lineInFocus = !1),
					(t.isShown = !1),
					(t.hideForce = function () {
					  t.isShown &&
						((t.isShown = !1),
						t.j.async.clearTimeout(t.timeout),
						(t.lineInFocus = !1),
						r.Dom.safeRemove(t.line),
						t.line.style.setProperty("--jd-offset-handle", "0"));
					}),
					(t.canGetFocus = function (e) {
					  return (
						null != e &&
						r.Dom.isBlock(e) &&
						!/^(img|table|iframe|hr)$/i.test(e.nodeName)
					  );
					}),
					(t.onClickLine = function (e) {
					  var o = t.j,
						n = o.createInside.element(o.o.enter);
					  t.preview && t.current && t.current.parentNode
						? t.current === o.editor
						  ? r.Dom.prepend(o.editor, n)
						  : t.current.parentNode.insertBefore(n, t.current)
						: o.editor.appendChild(n),
						o.s.setCursorIn(n),
						(0, i.scrollIntoViewIfNeeded)(n, o.editor, o.ed),
						o.synchronizeValues(),
						t.hideForce(),
						e.preventDefault();
					}),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.show = function () {
					this.isShown ||
					  this.j.o.readonly ||
					  this.j.isLocked ||
					  ((this.isShown = !0),
					  this.j.async.clearTimeout(this.timeout),
					  this.line.classList.toggle(
						"jodit-add-new-line_after",
						!this.preview,
					  ),
					  this.j.container.appendChild(this.line),
					  (this.line.style.width =
						this.j.container.clientWidth + "px"));
				  }),
				  (t.prototype.onLock = function (e) {
					e && this.isShown && this.hideForce();
				  }),
				  (t.prototype.hide = function () {
					this.isShown &&
					  !this.lineInFocus &&
					  (this.timeout = this.j.async.setTimeout(this.hideForce, {
						timeout: 500,
						label: "add-new-line-hide",
					  }));
				  }),
				  (t.prototype.afterInit = function (e) {
					var t = this;
					e.o.addNewLine &&
					  (e.e
						.on(this.line, "mousemove", function (e) {
						  e.stopPropagation();
						})
						.on(this.line, "mousedown touchstart", this.onClickLine)
						.on("change", this.hideForce)
						.on(this.line, "mouseenter", function () {
						  t.j.async.clearTimeout(t.timeout), (t.lineInFocus = !0);
						})
						.on(this.line, "mouseleave", function () {
						  t.lineInFocus = !1;
						})
						.on("changePlace", this.addEventListeners.bind(this)),
					  this.addEventListeners());
				  }),
				  (t.prototype.addEventListeners = function () {
					var e = this.j;
					e.e
					  .off(e.editor, "." + l)
					  .off(e.container, "." + l)
					  .on([e.ow, e.ew, e.editor], "scroll." + l, this.hideForce)
					  .on(e.editor, "click." + l, this.hide)
					  .on(e.container, "mouseleave." + l, this.hide)
					  .on(e.editor, "mousemove." + l, this.onMouseMove);
				  }),
				  (t.prototype.onDblClickEditor = function (e) {
					var t = this.j;
					if (
					  !t.o.readonly &&
					  t.o.addNewLineOnDBLClick &&
					  e.target === t.editor &&
					  t.s.isCollapsed()
					) {
					  var o = (0, i.offset)(t.editor, t, t.ed),
						n = e.pageY - t.ew.pageYOffset,
						r = t.createInside.element(t.o.enter);
					  Math.abs(n - o.top) < Math.abs(n - (o.height + o.top)) &&
					  t.editor.firstChild
						? t.editor.insertBefore(r, t.editor.firstChild)
						: t.editor.appendChild(r),
						t.s.setCursorIn(r),
						t.synchronizeValues(),
						this.hideForce(),
						e.preventDefault();
					}
				  }),
				  (t.prototype.onMouseMove = function (e) {
					var t = this.j,
					  o = t.ed.elementFromPoint(e.clientX, e.clientY);
					if (
					  r.Dom.isHTMLElement(o) &&
					  !r.Dom.isOrContains(this.line, o) &&
					  r.Dom.isOrContains(t.editor, o)
					)
					  if (
						(t.editor === o ||
						  this.isMatchedTag(o) ||
						  (o = r.Dom.closest(o, this.isMatchedTag, t.editor)),
						o)
					  ) {
						if (this.isMatchedTag(o)) {
						  var n = r.Dom.up(o, r.Dom.isBlock, t.editor);
						  n && n !== t.editor && (o = n);
						}
						var a = (0, i.position)(o, this.j),
						  s = !1,
						  l = e.clientY,
						  c = e.clientX;
						if (this.j.iframe) {
						  var u = (0, i.position)(this.j.iframe, this.j, !0);
						  (l += u.top), (c += u.left);
						}
						var d = this.j.o.addNewLineDeltaShow;
						Math.abs(l - a.top) > d ||
						  ((s = a.top), (this.preview = !0)),
						  Math.abs(l - (a.top + a.height)) > d ||
							((s = a.top + a.height), (this.preview = !1)),
						  !1 === s ||
						  ((t.editor !== o || this.preview) &&
							(0, i.call)(
							  this.preview ? r.Dom.prev : r.Dom.next,
							  o,
							  this.canGetFocus,
							  t.editor,
							))
							? ((this.current = !1), this.hide())
							: ((this.line.style.top = s + "px"),
							  (this.current = o),
							  this.show(),
							  this.line.style.setProperty(
								"--jd-offset-handle",
								c - a.left - 10 + "px",
							  ));
					  } else this.hide();
				  }),
				  (t.prototype.beforeDestruct = function () {
					this.j.async.clearTimeout(this.timeout),
					  this.j.e
						.off(this.line)
						.off("changePlace", this.addEventListeners),
					  r.Dom.safeRemove(this.line),
					  this.j.e
						.off([this.j.ow, this.j.ew, this.j.editor], "." + l)
						.off(this.j.container, "." + l);
				  }),
				  n.__decorate(
					[(0, a.watch)(":lock")],
					t.prototype,
					"onLock",
					null,
				  ),
				  n.__decorate([a.autobind], t.prototype, "hide", null),
				  n.__decorate(
					[(0, a.watch)(":dblclick")],
					t.prototype,
					"onDblClickEditor",
					null,
				  ),
				  n.__decorate(
					[
					  (0, a.debounce)(function (e) {
						return 5 * e.defaultTimeout;
					  }),
					],
					t.prototype,
					"onMouseMove",
					null,
				  ),
				  t
				);
			  })(r.Plugin);
			(t.addNewLine = c), s.pluginSystem.add("addNewLine", c);
		  },
		  46360: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(2074);
			(n.Config.prototype.addNewLine = !0),
			  (n.Config.prototype.addNewLineOnDBLClick = !0),
			  (n.Config.prototype.addNewLineTagsTriggers = [
				"table",
				"iframe",
				"img",
				"hr",
				"pre",
				"jodit",
			  ]),
			  (n.Config.prototype.addNewLineDeltaShow = 20),
			  r.Icon.set("enter", o(11257));
		  },
		  91241: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.backspace = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(64968),
			  a = o(86893),
			  s = o(40332),
			  l = o(10109),
			  c = o(17332),
			  u = o(90089),
			  d = o(95441);
			o(48229);
			var p = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (t.requires = ["hotkeys"]), t;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  e.e.on("afterCommand.delete", function (e) {
					"delete" === e && t.afterDeleteCommand();
				  }),
					e
					  .registerCommand(
						"deleteButton",
						{
						  exec: function () {
							return t.onDelete(!1);
						  },
						  hotkeys: e.o.delete.hotkeys.delete,
						},
						{ stopPropagation: !1 },
					  )
					  .registerCommand(
						"backspaceButton",
						{
						  exec: function () {
							return t.onDelete(!0);
						  },
						  hotkeys: e.o.delete.hotkeys.backspace,
						},
						{ stopPropagation: !1 },
					  )
					  .registerCommand("deleteWordButton", {
						exec: function () {
						  return t.onDelete(!1, "word");
						},
						hotkeys: e.o.delete.hotkeys.deleteWord,
					  })
					  .registerCommand("backspaceWordButton", {
						exec: function () {
						  return t.onDelete(!0, "word");
						},
						hotkeys: e.o.delete.hotkeys.backspaceWord,
					  })
					  .registerCommand("deleteSentenceButton", {
						exec: function () {
						  return t.onDelete(!1, "sentence");
						},
						hotkeys: e.o.delete.hotkeys.deleteSentence,
					  })
					  .registerCommand("backspaceSentenceButton", {
						exec: function () {
						  return t.onDelete(!0, "sentence");
						},
						hotkeys: e.o.delete.hotkeys.backspaceSentence,
					  });
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e.off("afterCommand.delete");
				}),
				(t.prototype.afterDeleteCommand = function () {
				  var e = this.j,
					t = e.s.current();
				  if (
					(t &&
					  i.Dom.isTag(t.firstChild, "br") &&
					  e.s.removeNode(t.firstChild),
					!(
					  (0, s.trim)(e.editor.textContent || "") ||
					  e.editor.querySelector("img,table,jodit,iframe,hr") ||
					  (t && i.Dom.closest(t, "table", e.editor))
					))
				  ) {
					e.editor.innerHTML = "";
					var o = e.s.setCursorIn(e.editor);
					e.s.removeNode(o);
				  }
				}),
				(t.prototype.onDelete = function (e, t) {
				  void 0 === t && (t = "char");
				  var o = this.j,
					n = o.selection;
				  if ((n.isFocused() || n.focus(), (0, d.checkNotCollapsed)(o)))
					return !1;
				  var r = n.range,
					c = o.createInside.text(a.INVISIBLE_SPACE);
				  try {
					if (
					  (i.Dom.safeInsertNode(r, c),
					  !i.Dom.isOrContains(o.editor, c))
					)
					  return;
					if (o.e.fire("backSpaceBeforeCases", e, c)) return !1;
					if (
					  ((0, l.moveNodeInsideStart)(o, c, e),
					  u.cases.some(function (n) {
						if ((0, s.isFunction)(n) && n(o, c, e, t)) return !0;
					  }))
					)
					  return !1;
				  } catch (e) {
					throw e;
				  } finally {
					o.e.fire("backSpaceAfterDelete", e, c),
					  this.safeRemoveEmptyNode(c);
				  }
				  return !1;
				}),
				(t.prototype.safeRemoveEmptyNode = function (e) {
				  var t,
					o,
					n = this.j.s.range;
				  n.startContainer === e &&
					(e.previousSibling
					  ? i.Dom.isText(e.previousSibling)
						? n.setStart(
							e.previousSibling,
							null !==
							  (o =
								null === (t = e.previousSibling.nodeValue) ||
								void 0 === t
								  ? void 0
								  : t.length) && void 0 !== o
							  ? o
							  : 0,
						  )
						: n.setStartAfter(e.previousSibling)
					  : e.nextSibling &&
						(i.Dom.isText(e.nextSibling)
						  ? n.setStart(e.nextSibling, 0)
						  : n.setStartBefore(e.nextSibling)),
					n.collapse(!0),
					this.j.s.selectRange(n)),
					i.Dom.safeRemove(e);
				}),
				t
			  );
			})(r.Plugin);
			(t.backspace = p), c.pluginSystem.add("backspace", p);
		  },
		  31078: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkJoinNeighbors = void 0);
			var n = o(24263),
			  r = o(30861);
			function i(e, t, o, i) {
			  if (t && n.Dom.isElement(o)) {
				n.Dom.moveContent(t, o, !i, (0, r.getMoveFilter)(e));
				for (var a = t; a && a !== e.editor && n.Dom.isEmpty(a); ) {
				  var s = a.parentElement;
				  n.Dom.safeRemove(a), (a = s);
				}
				return !0;
			  }
			  return !1;
			}
			t.checkJoinNeighbors = function (e, t, o) {
			  for (
				var r = t, a = r;
				r &&
				!n.Dom.findNotEmptySibling(r, o) &&
				r.parentElement !== e.editor;
  
			  )
				a = r = r.parentElement;
			  if (n.Dom.isElement(a) && n.Dom.isContentEditable(a, e.editor)) {
				var s = n.Dom.findNotEmptySibling(a, o);
				if (
				  s &&
				  ((function (e, t, o, r) {
					var a = n.Dom.isTag(o, ["ol", "ul"]),
					  s = n.Dom.isTag(t, ["ol", "ul"]),
					  l = function (e, t) {
						return t ? e.firstElementChild : e.lastElementChild;
					  };
					return s
					  ? ((o = e.createInside.element(e.o.enterBlock)),
						n.Dom.before(t, o),
						i(e, l(t, r), o, r))
					  : !(!o || !a || s) && i(e, t, l(o, !r), r);
				  })(e, a, s, o) ||
					i(e, a, s, o))
				)
				  return e.s.setCursorBefore(t), !0;
			  }
			  return !1;
			};
		  },
		  92156: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkJoinTwoLists = void 0);
			var n = o(24263),
			  r = o(67309),
			  i = o(30861);
			t.checkJoinTwoLists = function (e, t, o) {
			  var a = n.Dom.findSibling(t, o),
				s = n.Dom.findSibling(t, !o);
			  if (
				!n.Dom.closest(t, n.Dom.isElement, e.editor) &&
				n.Dom.isTag(a, ["ul", "ol"]) &&
				n.Dom.isTag(s, ["ul", "ol"]) &&
				n.Dom.isTag(a.lastElementChild, "li") &&
				n.Dom.isTag(s.firstElementChild, "li")
			  ) {
				var l = e.s,
				  c = l.setCursorBefore,
				  u = l.setCursorAfter,
				  d = a.lastElementChild;
				return (
				  (0, r.call)(
					o ? n.Dom.prepend : n.Dom.append,
					s.firstElementChild,
					t,
				  ),
				  n.Dom.moveContent(s, a, !o, (0, i.getMoveFilter)(e)),
				  n.Dom.safeRemove(s),
				  (0, r.call)(o ? n.Dom.append : n.Dom.prepend, d, t),
				  (0, r.call)(o ? c : u, t),
				  !0
				);
			  }
			  return !1;
			};
		  },
		  95441: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkNotCollapsed = void 0),
			  (t.checkNotCollapsed = function (e) {
				return !e.s.isCollapsed() && (e.execCommand("Delete"), !0);
			  });
		  },
		  13116: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkRemoveChar = void 0);
			var n = o(64968),
			  r = o(40332),
			  i = o(86893),
			  a = o(30861);
			t.checkRemoveChar = function e(t, o, s, l) {
			  var c,
				u,
				d,
				p,
				f = s ? -1 : 1,
				h = n.Dom.sibling(o, !s),
				m = n.Dom.sibling(o, s),
				v = null,
				g = !1,
				y = function (e) {
				  var o = n.Dom.sibling(e, s);
				  return (
					!o &&
					  e.parentNode &&
					  e.parentNode !== t.editor &&
					  (o = (0, a.findMostNestedNeighbor)(e, !s, t.editor, !0)),
					o
				  );
				};
			  for (
				m || (m = y(o));
				m && (n.Dom.isText(m) || n.Dom.isInlineBlock(m));
  
			  ) {
				for (; n.Dom.isInlineBlock(m); )
				  m = s
					? null == m
					  ? void 0
					  : m.lastChild
					: null == m
					  ? void 0
					  : m.firstChild;
				if (!m) break;
				if (
				  null === (c = m.nodeValue) || void 0 === c ? void 0 : c.length
				) {
				  var _ = (0, r.toArray)(m.nodeValue),
					b = _.length,
					w = s ? b - 1 : 0;
				  if (_[w] === i.INVISIBLE_SPACE)
					for (; _[w] === i.INVISIBLE_SPACE; ) w += f;
				  if (((p = _[w]), _[w + f] === i.INVISIBLE_SPACE)) {
					for (w += f; _[w] === i.INVISIBLE_SPACE; ) w += f;
					w += s ? 1 : -1;
				  }
				  if (
					((_ = s && 0 > w ? [] : _.slice(s ? 0 : w + 1, s ? w : b)),
					!h ||
					  !n.Dom.isText(h) ||
					  (s ? /^ / : / $/).test(
						null !== (u = h.nodeValue) && void 0 !== u ? u : "",
					  ) ||
					  !(0, r.trimInv)(h.nodeValue || "").length)
				  )
					for (
					  var S = s ? _.length - 1 : 0;
					  (s ? S >= 0 : _.length > S) && " " === _[S];
					  S += s ? -1 : 1
					)
					  _[S] = i.NBSP_SPACE;
				  m.nodeValue = _.join("");
				}
				if (
				  ((null === (d = m.nodeValue) || void 0 === d
					? void 0
					: d.length) || (v = m),
				  !(0, r.isVoid)(p) && p !== i.INVISIBLE_SPACE)
				) {
				  (g = !0),
					(0, r.call)(s ? n.Dom.after : n.Dom.before, m, o),
					("sentence" === l ||
					  ("word" === l && " " !== p && p !== i.NBSP_SPACE)) &&
					  e(t, o, s, l);
				  break;
				}
				var C = y(m);
				v && (n.Dom.safeRemove(v), (v = null)), (m = C);
			  }
			  return (
				v && (n.Dom.safeRemove(v), (v = null)),
				g &&
				  ((function (e, t) {
					for (
					  var o = e.parentElement;
					  o && n.Dom.isInlineBlock(o) && n.Dom.isTag(o, t);
  
					) {
					  var r = o.parentElement;
					  n.Dom.isEmpty(o) &&
						(n.Dom.after(o, e), n.Dom.safeRemove(o)),
						(o = r);
					}
				  })(o, ["a"]),
				  (function (e, t) {
					t.parentElement !== e.editor &&
					  n.Dom.isBlock(t.parentElement) &&
					  n.Dom.each(t.parentElement, n.Dom.isEmptyTextNode) &&
					  n.Dom.after(t, e.createInside.element("br"));
				  })(t, o),
				  t.s.setCursorBefore(o),
				  n.Dom.isTag(o.previousSibling, "br") &&
					!n.Dom.findNotEmptySibling(o, !1) &&
					n.Dom.after(o, t.createInside.element("br"))),
				g
			  );
			};
		  },
		  74217: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkRemoveContentNotEditable = void 0);
			var n = o(64968),
			  r = o(40332),
			  i = o(10109);
			t.checkRemoveContentNotEditable = function (e, t, o) {
			  var a = n.Dom.findSibling(t, o);
			  return (
				!a &&
				  t.parentElement &&
				  t.parentElement !== e.editor &&
				  (a = n.Dom.findSibling(t.parentElement, o)),
				!(
				  !n.Dom.isElement(a) ||
				  n.Dom.isContentEditable(a, e.editor) ||
				  ((0, r.call)(o ? n.Dom.before : n.Dom.after, a, t),
				  n.Dom.safeRemove(a),
				  (0, i.moveNodeInsideStart)(e, t, o),
				  (0, r.call)(o ? e.s.setCursorBefore : e.s.setCursorAfter, t),
				  0)
				)
			  );
			};
		  },
		  34181: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkRemoveEmptyNeighbor = void 0);
			var n = o(24263);
			t.checkRemoveEmptyNeighbor = function (e, t, o) {
			  var r = n.Dom.closest(t, n.Dom.isElement, e.editor);
			  if (!r) return !1;
			  var i = n.Dom.findNotEmptySibling(r, o);
			  return !(
				!i ||
				!n.Dom.isEmpty(i) ||
				(n.Dom.safeRemove(i), e.s.setCursorBefore(t), 0)
			  );
			};
		  },
		  13890: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkRemoveEmptyParent = void 0);
			var n = o(64968),
			  r = o(86893),
			  i = o(92156);
			t.checkRemoveEmptyParent = function (e, t, o) {
			  var a = !1,
				s = e.s,
				l = s.setCursorBefore,
				c = s.setCursorIn,
				u = n.Dom.closest(t, n.Dom.isElement, e.editor);
			  if (!u || !n.Dom.isEmpty(u)) return !1;
			  var d = n.Dom.findNotEmptyNeighbor(t, o, e.editor);
			  do {
				if (!u || !n.Dom.isEmpty(u) || n.Dom.isCell(u)) break;
				n.Dom.after(u, t);
				var p = n.Dom.closest(
				  u,
				  function (e) {
					return n.Dom.isElement(e) && e !== u;
				  },
				  e.editor,
				);
				n.Dom.safeRemove(u), (a = !0), (u = p);
			  } while (u);
			  return (
				!(!a || !(0, i.checkJoinTwoLists)(e, t, o)) ||
				(!d || n.Dom.isText(d) || n.Dom.isTag(d, r.INSEPARABLE_TAGS)
				  ? l(t)
				  : c(d, !o),
				a)
			  );
			};
		  },
		  8249: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkRemoveUnbreakableElement = void 0);
			var n = o(24263),
			  r = o(86893),
			  i = o(13890);
			t.checkRemoveUnbreakableElement = function (e, t, o) {
			  var a = n.Dom.findSibling(t, o);
			  return !(
				!n.Dom.isElement(a) ||
				(!n.Dom.isTag(a, r.INSEPARABLE_TAGS) && !n.Dom.isEmpty(a)) ||
				(n.Dom.safeRemove(a),
				n.Dom.isTag(a, "br") &&
				  !n.Dom.findNotEmptySibling(t, !1) &&
				  n.Dom.after(t, e.createInside.element("br")),
				e.s.setCursorBefore(t),
				n.Dom.isTag(a, "br") && (0, i.checkRemoveEmptyParent)(e, t, o),
				0)
			  );
			};
		  },
		  58368: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkTableCell = void 0);
			var n = o(24263);
			t.checkTableCell = function (e, t) {
			  return !!n.Dom.isCell(t.parentElement);
			};
		  },
		  6028: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkUnwrapFirstListItem = void 0);
			var n = o(24263),
			  r = o(76502);
			t.checkUnwrapFirstListItem = function (e, t, o) {
			  var i,
				a = n.Dom.closest(t, n.Dom.isElement, e.editor),
				s = e.s;
			  if (
				n.Dom.isTag(a, "li") &&
				(null === (i = null == a ? void 0 : a.parentElement) ||
				void 0 === i
				  ? void 0
				  : i[o ? "firstElementChild" : "lastElementChild"]) === a &&
				s.cursorInTheEdge(o, a)
			  ) {
				var l = a.parentElement,
				  c = e.createInside.element(e.o.enterBlock);
				return (
				  (0, r.call)(o ? n.Dom.before : n.Dom.after, l, c),
				  n.Dom.moveContent(a, c),
				  n.Dom.safeRemove(a),
				  n.Dom.isEmpty(l) && n.Dom.safeRemove(l),
				  (0, r.call)(o ? s.setCursorBefore : s.setCursorAfter, t),
				  !0
				);
			  }
			  return !1;
			};
		  },
		  90089: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.cases = void 0);
			var n = o(8249),
			  r = o(74217),
			  i = o(13116),
			  a = o(58368),
			  s = o(13890),
			  l = o(34181),
			  c = o(92156),
			  u = o(31078),
			  d = o(6028);
			t.cases = [
			  n.checkRemoveUnbreakableElement,
			  r.checkRemoveContentNotEditable,
			  i.checkRemoveChar,
			  a.checkTableCell,
			  s.checkRemoveEmptyParent,
			  l.checkRemoveEmptyNeighbor,
			  c.checkJoinTwoLists,
			  u.checkJoinNeighbors,
			  d.checkUnwrapFirstListItem,
			];
		  },
		  48229: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.delete = {
				hotkeys: {
				  delete: ["delete", "cmd+backspace"],
				  deleteWord: [
					"ctrl+delete",
					"cmd+alt+backspace",
					"ctrl+alt+backspace",
				  ],
				  deleteSentence: ["ctrl+shift+delete", "cmd+shift+delete"],
				  backspace: ["backspace"],
				  backspaceWord: ["ctrl+backspace"],
				  backspaceSentence: [
					"ctrl+shift+backspace",
					"cmd+shift+backspace",
				  ],
				},
			  });
		  },
		  30861: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getMoveFilter = t.findMostNestedNeighbor = void 0);
			var n = o(64968);
			(t.findMostNestedNeighbor = function (e, t, o, r) {
			  void 0 === r && (r = !1);
			  var i = function (e) {
				  return t ? e.firstChild : e.lastChild;
				},
				a = n.Dom.findNotEmptyNeighbor(e, !t, o);
			  if (r && n.Dom.isElement(a) && !n.Dom.isInlineBlock(a)) return null;
			  if (a)
				do {
				  if (!i(a)) return a;
				  a = i(a);
				} while (a);
			  return null;
			}),
			  (t.getMoveFilter = function (e) {
				return function (t) {
				  return !0 !== e.e.fire("backSpaceIsMovedIgnore", t);
				};
			  });
		  },
		  87565: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.bold = void 0);
			var n = o(20255),
			  r = o(93166),
			  i = o(40332),
			  a = o(17332),
			  s = o(77904);
			function l(e) {
			  var t = function (t) {
				var o,
				  a = r.Config.defaultOptions.controls[t],
				  s = n.__assign({}, a.css);
				return (
				  Object.keys(s).forEach(function (e) {
					o || (o = {}), (o[e] = (0, i.isArray)(s[e]) ? s[e][0] : s[e]);
				  }),
				  e.s.applyStyle(o, { element: a.tags ? a.tags[0] : void 0 }),
				  e.synchronizeValues(),
				  !1
				);
			  };
			  ["bold", "italic", "underline", "strikethrough"].forEach(
				function (t) {
				  e.registerButton({ name: t, group: "font-style" });
				},
			  ),
				["superscript", "subscript"].forEach(function (t) {
				  e.registerButton({ name: t, group: "script" });
				}),
				e
				  .registerCommand("bold", {
					exec: t,
					hotkeys: ["ctrl+b", "cmd+b"],
				  })
				  .registerCommand("italic", {
					exec: t,
					hotkeys: ["ctrl+i", "cmd+i"],
				  })
				  .registerCommand("underline", {
					exec: t,
					hotkeys: ["ctrl+u", "cmd+u"],
				  })
				  .registerCommand("strikethrough", { exec: t })
				  .registerCommand("subscript", { exec: t })
				  .registerCommand("superscript", { exec: t });
			}
			o(58334),
			  o(90740),
			  (t.bold = l),
			  a.pluginSystem.add("bold", l),
			  s.Icon.set("bold", o(25141))
				.set("italic", o(24557))
				.set("strikethrough", o(10859))
				.set("subscript", o(9813))
				.set("superscript", o(93395))
				.set("underline", o(98213));
		  },
		  90740: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.controls.subscript = {
			  tags: ["sub"],
			  tooltip: "subscript",
			}),
			  (n.Config.prototype.controls.superscript = {
				tags: ["sup"],
				tooltip: "superscript",
			  }),
			  (n.Config.prototype.controls.bold = {
				tagRegExp: /^(strong|b)$/i,
				tags: ["strong", "b"],
				css: { "font-weight": ["bold", "700"] },
				tooltip: "Bold",
			  }),
			  (n.Config.prototype.controls.italic = {
				tagRegExp: /^(em|i)$/i,
				tags: ["em", "i"],
				css: { "font-style": "italic" },
				tooltip: "Italic",
			  }),
			  (n.Config.prototype.controls.underline = {
				tagRegExp: /^(u)$/i,
				tags: ["u"],
				css: { "text-decoration-line": "underline" },
				tooltip: "Underline",
			  }),
			  (n.Config.prototype.controls.strikethrough = {
				tagRegExp: /^(s)$/i,
				tags: ["s"],
				css: { "text-decoration-line": "line-through" },
				tooltip: "Strike through",
			  });
		  },
		  58334: function () {},
		  60894: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.classSpan = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(93166),
			  a = o(64968),
			  s = o(40332),
			  l = o(17332),
			  c = o(2074);
			i.Config.prototype.controls.classSpan = {
			  command: "applyClassName",
			  exec: s.memorizeExec,
			  list: [
				"enabled",
				"disabled",
				"activated",
				"text-left",
				"text-center",
				"text-right",
				"warning",
				"error",
			  ],
			  isChildActive: function (e, t) {
				var o = e.s.current();
				if (o) {
				  var n = a.Dom.closest(o, a.Dom.isElement, e.editor) || e.editor;
				  return Boolean(
					t.args && n.classList.contains(t.args[0].toString()),
				  );
				}
				return !1;
			  },
			  isActive: function (e, t) {
				var o = e.s.current();
				if (o) {
				  var n = a.Dom.closest(o, a.Dom.isElement, e.editor) || e.editor,
					r = !1;
				  return (
					t.list &&
					  Object.keys(t.list).forEach(function (e) {
						n.classList.contains(e) && (r = !0);
					  }),
					Boolean(n && n !== e.editor && void 0 !== t.list && r)
				  );
				}
				return !1;
			  },
			  childTemplate: function (e, t, o) {
				return '<span class="'
				  .concat(t, '">')
				  .concat(e.i18n(o), "</span>");
			  },
			  tooltip: "Insert className",
			};
			var u = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (t.buttons = [{ name: "classSpan", group: "font" }]), t;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  e.registerCommand("applyClassName", function (t, o, n) {
					return e.s.applyStyle(void 0, { className: n }), !1;
				  });
				}),
				(t.prototype.beforeDestruct = function () {}),
				t
			  );
			})(r.Plugin);
			(t.classSpan = u),
			  l.pluginSystem.add("classSpan", u),
			  c.Icon.set("class-span", o(20026));
		  },
		  90302: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.cleanHtml = void 0);
			var n = o(20255),
			  r = o(67128),
			  i = o(85605),
			  a = o(43441),
			  s = o(33841),
			  l = o(17332),
			  c = o(24263),
			  u = o(57713);
			o(98889);
			var d = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.buttons = [{ name: "eraser", group: "font-style" }]),
				  (t.currentSelectionNode = null),
				  (t.walker = new s.LazyWalker(t.j.async, {
					timeout: t.j.o.cleanHTML.timeout,
				  })),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {}),
				Object.defineProperty(t.prototype, "isEditMode", {
				  get: function () {
					return !(
					  this.j.isInDestruct ||
					  !this.j.isEditorMode() ||
					  this.j.getReadOnly()
					);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.onChangeCleanHTML = function () {
				  if (this.isEditMode) {
					var e = this.j;
					this.walker.setWork(e.editor),
					  (this.currentSelectionNode = e.s.current());
				  }
				}),
				(t.prototype.startWalker = function () {
				  var e = this,
					t = this.jodit,
					o = (0, u.getHash)(this.j.o.cleanHTML.allowTags),
					n = (0, u.getHash)(this.j.o.cleanHTML.denyTags);
				  this.walker
					.on("visit", function (r) {
					  return (0, u.visitNodeWalker)(
						t,
						r,
						o,
						n,
						e.currentSelectionNode,
					  );
					})
					.on("end", function (t) {
					  e.j.e.fire(
						t
						  ? "internalChange finishedCleanHTMLWorker"
						  : "finishedCleanHTMLWorker",
					  );
					});
				}),
				(t.prototype.beforeCommand = function (e) {
				  if ("removeformat" === e.toLowerCase())
					return (
					  this.j.s.isCollapsed()
						? (0, u.removeFormatForCollapsedSelection)(this.j)
						: (0, u.removeFormatForSelection)(this.j),
					  !1
					);
				}),
				(t.prototype.onBeforeSetNativeEditorValue = function (e) {
				  var t = this.j.o.cleanHTML.useIframeSandbox
					? this.j.createInside.sandbox()
					: this.j.createInside.div();
				  return (
					(t.innerHTML = e.value),
					this.onSafeHTML(t),
					(e.value = t.innerHTML),
					(0, r.safeHTML)(t, {
					  safeJavaScriptLink: !0,
					  removeOnError: !0,
					}),
					c.Dom.safeRemove(t),
					!1
				  );
				}),
				(t.prototype.onSafeHTML = function (e) {
				  (0, r.safeHTML)(e, this.j.o.cleanHTML);
				}),
				(t.prototype.beforeDestruct = function () {
				  this.walker.destruct();
				}),
				n.__decorate(
				  [
					(0, a.watch)([
					  ":change",
					  ":afterSetMode",
					  ":afterInit",
					  ":mousedown",
					  ":keydown",
					]),
				  ],
				  t.prototype,
				  "onChangeCleanHTML",
				  null,
				),
				n.__decorate(
				  [(0, a.hook)("ready")],
				  t.prototype,
				  "startWalker",
				  null,
				),
				n.__decorate(
				  [(0, a.watch)(":beforeCommand")],
				  t.prototype,
				  "beforeCommand",
				  null,
				),
				n.__decorate(
				  [(0, a.watch)(":beforeSetNativeEditorValue")],
				  t.prototype,
				  "onBeforeSetNativeEditorValue",
				  null,
				),
				n.__decorate(
				  [(0, a.watch)(":safeHTML")],
				  t.prototype,
				  "onSafeHTML",
				  null,
				),
				t
			  );
			})(i.Plugin);
			(t.cleanHtml = d), l.pluginSystem.add("cleanHtml", d);
		  },
		  98889: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(77904);
			(n.Config.prototype.cleanHTML = {
			  timeout: 300,
			  removeEmptyElements: !0,
			  fillEmptyParagraph: !0,
			  replaceNBSP: !0,
			  replaceOldTags: { i: "em", b: "strong" },
			  allowTags: !1,
			  denyTags: "script",
			  useIframeSandbox: !1,
			  removeOnError: !0,
			  safeJavaScriptLink: !0,
			  disableCleanFilter: null,
			}),
			  (n.Config.prototype.controls.eraser = {
				command: "removeFormat",
				tooltip: "Clear Formatting",
			  }),
			  r.Icon.set("eraser", o(66911));
		  },
		  38655: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getHash = void 0);
			var n = o(33941),
			  r = o(24421);
			t.getHash = function (e) {
			  var t = /([^[]*)\[([^\]]+)]/,
				o = /[\s]*,[\s]*/,
				i = /^(.*)[\s]*=[\s]*(.*)$/,
				a = {};
			  return (0, r.isString)(e)
				? (e.split(o).map(function (e) {
					e = (0, n.trim)(e);
					var r = t.exec(e),
					  s = {};
					if (r) {
					  var l = r[2].split(o);
					  r[1] &&
						(l.forEach(function (e) {
						  e = (0, n.trim)(e);
						  var t = i.exec(e);
						  t ? (s[t[1]] = t[2]) : (s[e] = !0);
						}),
						(a[r[1].toUpperCase()] = s));
					} else a[e.toUpperCase()] = !0;
				  }),
				  a)
				: !!e &&
					(Object.keys(e).forEach(function (t) {
					  a[t.toUpperCase()] = e[t];
					}),
					a);
			};
		  },
		  57713: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(38655), t),
			  n.__exportStar(o(72170), t),
			  n.__exportStar(o(87783), t),
			  n.__exportStar(o(88972), t);
		  },
		  72170: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isInlineBlock = t.removeFormatForCollapsedSelection = void 0);
			var n = o(24263),
			  r = o(86893);
			function i(e) {
			  return (
				n.Dom.isInlineBlock(e) && !n.Dom.isTag(e, r.INSEPARABLE_TAGS)
			  );
			}
			(t.removeFormatForCollapsedSelection = function (e, t) {
			  var o = e.s,
				r = t;
			  if (!r) {
				r = e.createInside.fake();
				var a = o.range;
				n.Dom.safeInsertNode(a, r), a.collapse();
			  }
			  var s = n.Dom.furthest(r, i, e.editor);
			  if (s)
				if (o.cursorOnTheLeft(s)) n.Dom.before(s, r);
				else if (o.cursorOnTheRight(s)) n.Dom.after(s, r);
				else {
				  var l = o.splitSelection(s);
				  l && n.Dom.after(l, r);
				}
			  t || (o.setCursorBefore(r), n.Dom.safeRemove(r));
			}),
			  (t.isInlineBlock = i);
		  },
		  87783: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.removeFormatForSelection = void 0);
			var n = o(24263),
			  r = o(76502),
			  i = o(72170);
			t.removeFormatForSelection = function (e) {
			  var t = e.s,
				o = e.editor,
				a = e.createInside,
				s = t.range,
				l = s.cloneRange(),
				c = s.cloneRange(),
				u = a.fake(),
				d = a.fake();
			  l.collapse(!0),
				c.collapse(!1),
				n.Dom.safeInsertNode(l, u),
				n.Dom.safeInsertNode(c, d),
				s.setStartBefore(u),
				s.collapse(!0),
				t.selectRange(s),
				(0, i.removeFormatForCollapsedSelection)(e, u),
				s.setEndAfter(d),
				s.collapse(!1),
				t.selectRange(s),
				(0, i.removeFormatForCollapsedSelection)(e, d);
			  var p = [];
			  n.Dom.between(u, d, function (e) {
				(0, i.isInlineBlock)(e) && !n.Dom.isTag(e, ["a"]) && p.push(e),
				  n.Dom.isElement(e) &&
					(0, r.attr)(e, "style") &&
					(0, r.attr)(e, "style", null);
			  }),
				p.forEach(function (e) {
				  return n.Dom.unwrap(e);
				});
			  var f = function (e, t) {
				if (!n.Dom.findNotEmptySibling(e, t)) {
				  var i = e.parentNode;
				  if (i && i !== o && (0, r.attr)(i, "style"))
					return (0, r.attr)(i, "style", null), f(i, t), !0;
				}
			  };
			  f(u, !0) && f(d, !1),
				s.setStartAfter(u),
				s.setEndBefore(d),
				t.selectRange(s),
				n.Dom.safeRemove(u),
				n.Dom.safeRemove(d);
			};
		  },
		  9948: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.allowAttributes = void 0);
			var n = o(24263);
			t.allowAttributes = function (e, t, o, r) {
			  if (r && n.Dom.isElement(t) && !0 !== r[t.nodeName]) {
				var i = t.attributes;
				if (i && i.length) {
				  for (var a = [], s = 0; i.length > s; s += 1) {
					var l = r[t.nodeName][i[s].name];
					(!l || (!0 !== l && l !== i[s].value)) && a.push(i[s].name);
				  }
				  a.length && (o = !0),
					a.forEach(function (e) {
					  t.removeAttribute(e);
					});
				}
			  }
			  return o;
			};
		  },
		  74722: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.fillEmptyParagraph = void 0);
			var n = o(24263),
			  r = o(86893);
			t.fillEmptyParagraph = function (e, t, o) {
			  if (
				e.o.cleanHTML.fillEmptyParagraph &&
				n.Dom.isBlock(t) &&
				n.Dom.isEmpty(t, r.INSEPARABLE_TAGS)
			  ) {
				var i = e.createInside.element("br");
				return t.appendChild(i), !0;
			  }
			  return o;
			};
		  },
		  2549: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(55901), t),
			  n.__exportStar(o(9948), t),
			  n.__exportStar(o(74722), t),
			  n.__exportStar(o(75096), t),
			  n.__exportStar(o(28194), t),
			  n.__exportStar(o(94254), t),
			  n.__exportStar(o(64701), t);
		  },
		  28194: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.removeEmptyTextNode = void 0);
			var n = o(24263);
			t.removeEmptyTextNode = function (e, t, o, r, i, a) {
			  return n.Dom.isText(t) && !t.nodeValue
				? (t === a && e.s.isCollapsed() && e.s.setCursorAfter(t),
				  n.Dom.safeRemove(t),
				  !0)
				: o;
			};
		  },
		  94254: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.removeInvTextNodes = void 0);
			var n = o(86893),
			  r = o(24263);
			t.removeInvTextNodes = function (e, t, o, i, a, s) {
			  return s !== t &&
				r.Dom.isText(t) &&
				null != t.nodeValue &&
				(0, n.INVISIBLE_SPACE_REG_EXP)().test(t.nodeValue)
				? ((t.nodeValue = t.nodeValue.replace(
					(0, n.INVISIBLE_SPACE_REG_EXP)(),
					"",
				  )),
				  t === s && e.s.isCollapsed() && e.s.setCursorAfter(t),
				  t.nodeValue || r.Dom.safeRemove(t),
				  !0)
				: o;
			};
		  },
		  55901: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.replaceOldTags = void 0);
			var n = o(24263);
			t.replaceOldTags = function (e, t, o) {
			  var r = (function (e, t, o) {
				if (!o || !n.Dom.isHTMLElement(t)) return t;
				var r = o[t.nodeName.toLowerCase()] || o[t.nodeName];
				return r ? n.Dom.replace(t, r, e.createInside, !0, !1) : t;
			  })(e, t, e.o.cleanHTML.replaceOldTags);
			  return t !== r ? ((t = r), !0) : o;
			};
		  },
		  64701: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.sanitizeAttributes = void 0);
			var n = o(24263),
			  r = o(40332);
			t.sanitizeAttributes = function (e, t, o) {
			  return (
				!(
				  !n.Dom.isElement(t) ||
				  !(0, r.sanitizeHTMLElement)(t, {
					safeJavaScriptLink: e.options.cleanHTML.safeJavaScriptLink,
					removeOnError: e.options.cleanHTML.removeOnError,
				  })
				) || o
			  );
			};
		  },
		  75096: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.tryRemoveNode = void 0);
			var n = o(24263),
			  r = o(86893),
			  i = o(33941);
			t.tryRemoveNode = function (e, t, o, a, s, l) {
			  return (function (e, t, o, a, s) {
				return (
				  !(
					n.Dom.isText(t) ||
					!((a && !a[t.nodeName]) || (s && s[t.nodeName]))
				  ) ||
				  (e.o.cleanHTML.removeEmptyElements &&
					n.Dom.isElement(t) &&
					null != t.nodeName.match(r.IS_INLINE) &&
					!n.Dom.isTemporary(t) &&
					0 === (0, i.trim)(t.innerHTML).length &&
					(null == o || !n.Dom.isOrContains(t, o)))
				);
			  })(e, t, l, a, s)
				? (n.Dom.safeRemove(t), !0)
				: o;
			};
		  },
		  88972: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.visitNodeWalker = void 0);
			var n = o(20255),
			  r = o(2549),
			  i = Object.keys(r);
			t.visitNodeWalker = function (e, t, o, a, s) {
			  var l,
				c,
				u = !1,
				d = e.o.cleanHTML.disableCleanFilter;
			  try {
				for (var p = n.__values(i), f = p.next(); !f.done; f = p.next()) {
				  var h = f.value;
				  if (
					!(
					  (d && d.has(h)) ||
					  ((u = (0, r[h])(e, t, u, o, a, s)), t.isConnected)
					)
				  )
					return !0;
				}
			  } catch (e) {
				l = { error: e };
			  } finally {
				try {
				  f && !f.done && (c = p.return) && c.call(p);
				} finally {
				  if (l) throw l.error;
				}
			  }
			  return u;
			};
		  },
		  92138: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.clipboard = void 0);
			var n = o(86893),
			  r = o(40332),
			  i = o(17332);
			o(31473);
			var a = (function () {
			  function e() {
				this.buttons = [
				  { name: "cut", group: "clipboard" },
				  { name: "copy", group: "clipboard" },
				  { name: "paste", group: "clipboard" },
				  { name: "selectall", group: "clipboard" },
				];
			  }
			  return (
				(e.prototype.init = function (e) {
				  var t;
				  null === (t = this.buttons) ||
					void 0 === t ||
					t.forEach(function (t) {
					  return e.registerButton(t);
					}),
					e.e
					  .off(
						"copy."
						  .concat(n.CLIPBOARD_ID, " cut.")
						  .concat(n.CLIPBOARD_ID),
					  )
					  .on(
						"copy."
						  .concat(n.CLIPBOARD_ID, " cut.")
						  .concat(n.CLIPBOARD_ID),
						function (t) {
						  var o,
							i = e.s.html,
							a =
							  (0, r.getDataTransfer)(t) ||
							  (0, r.getDataTransfer)(e.ew) ||
							  (0, r.getDataTransfer)(t.originalEvent);
						  a &&
							(a.setData(n.TEXT_PLAIN, (0, r.stripTags)(i)),
							a.setData(n.TEXT_HTML, i)),
							e.buffer.set(n.CLIPBOARD_ID, i),
							e.e.fire("pasteStack", {
							  html: i,
							  action:
								e.o.defaultActionOnPaste || n.INSERT_AS_HTML,
							}),
							"cut" === t.type && (e.s.remove(), e.s.focus()),
							t.preventDefault(),
							null === (o = null == e ? void 0 : e.events) ||
							  void 0 === o ||
							  o.fire("afterCopy", i);
						},
					  );
				}),
				(e.prototype.destruct = function (e) {
				  var t, o;
				  null === (t = null == e ? void 0 : e.buffer) ||
					void 0 === t ||
					t.set(n.CLIPBOARD_ID, ""),
					null === (o = null == e ? void 0 : e.events) ||
					  void 0 === o ||
					  o.off("." + n.CLIPBOARD_ID);
				}),
				e
			  );
			})();
			(t.clipboard = a), i.pluginSystem.add("clipboard", a);
		  },
		  31473: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(77904);
			(n.Config.prototype.controls.cut = {
			  command: "cut",
			  isDisabled: function (e) {
				return e.s.isCollapsed();
			  },
			  tooltip: "Cut selection",
			}),
			  (n.Config.prototype.controls.copy = {
				command: "copy",
				isDisabled: function (e) {
				  return e.s.isCollapsed();
				},
				tooltip: "Copy selection",
			  }),
			  (n.Config.prototype.controls.selectall = {
				icon: "select-all",
				command: "selectall",
				tooltip: "Select all",
			  }),
			  r.Icon.set("copy", o(50018))
				.set("cut", o(99738))
				.set("paste", o(9185))
				.set("select-all", o(8619));
		  },
		  88412: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.color = void 0);
			var n = o(40332),
			  r = o(17332);
			function i(e) {
			  e.registerButton({ name: "brush", group: "color" });
			  var t = function (t, o, r) {
				var i = (0, n.normalizeColor)(r);
				switch (t) {
				  case "background":
					e.s.applyStyle({ backgroundColor: i || "" });
					break;
				  case "forecolor":
					e.s.applyStyle({ color: i || "" });
				}
				return e.synchronizeValues(), !1;
			  };
			  e.registerCommand("forecolor", t).registerCommand("background", t);
			}
			o(21924), (t.color = i), r.pluginSystem.add("color", i);
		  },
		  21924: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(40332),
			  i = o(718),
			  a = o(77904),
			  s = o(24263);
			a.Icon.set("brush", o(73894)),
			  (n.Config.prototype.controls.brush = {
				update: function (e, t) {
				  var o = (0, r.dataBind)(e, "color"),
					n = function (o, n) {
					  n &&
						n !== (0, r.css)(t.editor, o).toString() &&
						(e.state.icon.fill = n);
					};
				  if (o) {
					var i = (0, r.dataBind)(e, "color");
					n("color" === i ? i : "background-color", o);
				  } else {
					var a = t.s.current();
					if (a && !e.state.disabled) {
					  var l =
						s.Dom.closest(a, s.Dom.isElement, t.editor) || t.editor;
					  n("color", (0, r.css)(l, "color").toString()),
						n(
						  "background-color",
						  (0, r.css)(l, "background-color").toString(),
						);
					}
					(e.state.icon.fill = ""), (e.state.activated = !1);
				  }
				},
				popup: function (e, t, o, n, a) {
				  var l = "",
					c = "",
					u = [],
					d = null;
				  return (
					t &&
					  t !== e.editor &&
					  s.Dom.isNode(t) &&
					  (s.Dom.isElement(t) &&
						e.s.isCollapsed() &&
						!s.Dom.isTag(t, ["br", "hr"]) &&
						(d = t),
					  s.Dom.up(
						t,
						function (e) {
						  if (s.Dom.isHTMLElement(e)) {
							var t = (0, r.css)(e, "color", !0),
							  o = (0, r.css)(e, "background-color", !0);
							if (t) return (l = t.toString()), !0;
							if (o) return (c = o.toString()), !0;
						  }
						},
						e.editor,
					  )),
					(u = [
					  {
						name: "Background",
						content: (0, i.ColorPickerWidget)(
						  e,
						  function (t) {
							d
							  ? (d.style.backgroundColor = t)
							  : e.execCommand("background", !1, t),
							  (0, r.dataBind)(a, "color", t),
							  (0, r.dataBind)(a, "color-mode", "background"),
							  n();
						  },
						  c,
						),
					  },
					  {
						name: "Text",
						content: (0, i.ColorPickerWidget)(
						  e,
						  function (t) {
							d
							  ? (d.style.color = t)
							  : e.execCommand("forecolor", !1, t),
							  (0, r.dataBind)(a, "color", t),
							  (0, r.dataBind)(a, "color-mode", "color"),
							  n();
						  },
						  l,
						),
					  },
					]),
					"background" !== e.o.colorPickerDefaultTab &&
					  (u = u.reverse()),
					(0, i.TabsWidget)(e, u, d)
				  );
				},
				exec: function (e, t, o) {
				  var n = o.button,
					i = (0, r.dataBind)(n, "color-mode"),
					a = (0, r.dataBind)(n, "color");
				  if (!i) return !1;
				  if (
					t &&
					t !== e.editor &&
					s.Dom.isNode(t) &&
					s.Dom.isElement(t)
				  )
					switch (i) {
					  case "color":
						t.style.color = a;
						break;
					  case "background":
						t.style.backgroundColor = a;
					}
				  else e.execCommand("background" === i ? i : "forecolor", !1, a);
				},
				tooltip: "Fill color or set the text color",
			  });
		  },
		  79308: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.copyFormat = void 0);
			var n = o(93166),
			  r = o(24263),
			  i = o(26911),
			  a = o(17332),
			  s = o(77904),
			  l = "copy-format",
			  c = [
				"fontWeight",
				"fontStyle",
				"fontSize",
				"color",
				"margin",
				"padding",
				"borderWidth",
				"borderStyle",
				"borderColor",
				"borderRadius",
				"backgroundColor",
				"textDecorationLine",
				"fontFamily",
			  ],
			  u = function (e, t, o, n) {
				var r = (0, i.css)(o, t);
				return (
				  r === n[t] &&
					(r =
					  o.parentNode && o !== e.editor && o.parentNode !== e.editor
						? u(e, t, o.parentNode, n)
						: void 0),
				  r
				);
			  };
			function d(e) {
			  e.registerButton({ name: "copyformat", group: "clipboard" }),
				(0, a.extendLang)(o(9188));
			}
			(n.Config.prototype.controls.copyformat = {
			  exec: function (e, t, o) {
				var n = o.button;
				if (t) {
				  if (e.buffer.exists(l))
					e.buffer.delete(l), e.e.off(e.editor, "mouseup." + l);
				  else {
					var a = {},
					  s =
						r.Dom.up(
						  t,
						  function (e) {
							return e && !r.Dom.isText(e);
						  },
						  e.editor,
						) || e.editor,
					  d = e.createInside.span();
					e.editor.appendChild(d),
					  c.forEach(function (e) {
						a[e] = (0, i.css)(d, e);
					  }),
					  d !== e.editor && r.Dom.safeRemove(d);
					var p = (function (e, t, o) {
					  var n = {};
					  return (
						t &&
						  c.forEach(function (r) {
							(n[r] = u(e, r, t, o)),
							  r.match(/border(Style|Color)/) &&
								!n.borderWidth &&
								(n[r] = void 0);
						  }),
						n
					  );
					})(e, s, a);
					e.e.on(e.editor, "mouseup." + l, function () {
					  e.buffer.delete(l);
					  var t = e.s.current();
					  t &&
						(r.Dom.isTag(t, "img")
						  ? (0, i.css)(t, p)
						  : e.s.applyStyle(p)),
						e.e.off(e.editor, "mouseup." + l);
					}),
					  e.buffer.set(l, !0);
				  }
				  n.update();
				}
			  },
			  isActive: function (e) {
				return e.buffer.exists(l);
			  },
			  tooltip: "Paint format",
			}),
			  (t.copyFormat = d),
			  a.pluginSystem.add("copyformat", d),
			  s.Icon.set("copyformat", o(83301));
		  },
		  9188: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.zh_tw =
				t.zh_cn =
				t.tr =
				t.ru =
				t.pt_br =
				t.pl =
				t.nl =
				t.mn =
				t.ko =
				t.ja =
				t.it =
				t.id =
				t.hu =
				t.he =
				t.fr =
				t.fa =
				t.es =
				t.de =
				t.cs_cz =
				t.ar =
				  void 0);
			var n = o(80078);
			t.ar = n;
			var r = o(16986);
			t.cs_cz = r;
			var i = o(59347);
			t.de = i;
			var a = o(63640);
			t.es = a;
			var s = o(53434);
			t.fa = s;
			var l = o(85638);
			t.fr = l;
			var c = o(31743);
			t.he = c;
			var u = o(66219);
			t.hu = u;
			var d = o(50331);
			t.id = d;
			var p = o(25582);
			t.it = p;
			var f = o(82066);
			t.ja = f;
			var h = o(71925);
			t.ko = h;
			var m = o(12689);
			t.mn = m;
			var v = o(65274);
			t.nl = v;
			var g = o(58548);
			t.pl = g;
			var y = o(82958);
			t.pt_br = y;
			var _ = o(52315);
			t.ru = _;
			var b = o(87727);
			t.tr = b;
			var w = o(9396);
			t.zh_cn = w;
			var S = o(28765);
			t.zh_tw = S;
		  },
		  9412: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.draggableTags = [
				"img",
				"jodit-media",
				"jodit",
			  ]);
		  },
		  30598: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.dragAndDropElement = void 0);
			var n,
			  r = o(20255),
			  i = o(40332),
			  a = o(57549),
			  s = o(64968),
			  l = o(17332),
			  c = o(43441);
			o(9412),
			  (function (e) {
				(e[(e.IDLE = 0)] = "IDLE"),
				  (e[(e.WAIT_DRAGGING = 1)] = "WAIT_DRAGGING"),
				  (e[(e.DRAGGING = 2)] = "DRAGGING");
			  })(n || (n = {}));
			var u = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.dragList = []),
				  (t.draggable = null),
				  (t.isCopyMode = !1),
				  (t.diffStep = 10),
				  (t.startX = 0),
				  (t.startY = 0),
				  (t.state = n.IDLE),
				  t
				);
			  }
			  return (
				r.__extends(t, e),
				(t.prototype.afterInit = function () {
				  (this.dragList = this.j.o.draggableTags
					? (0, i.splitArray)(this.j.o.draggableTags)
						.filter(Boolean)
						.map(function (e) {
						  return e.toLowerCase();
						})
					: []),
					this.dragList.length &&
					  this.j.e.on("mousedown dragstart", this.onDragStart);
				}),
				(t.prototype.onDragStart = function (e) {
				  var t = this;
				  if ("dragstart" === e.type && this.draggable) return !1;
				  if (n.IDLE >= this.state) {
					var o = e.target;
					if (this.dragList.length && o) {
					  var r = function (e) {
						  return Boolean(
							e && t.dragList.includes(e.nodeName.toLowerCase()),
						  );
						},
						a =
						  s.Dom.furthest(o, r, this.j.editor) ||
						  (r(o) ? o : null);
					  a &&
						(s.Dom.isTag(a.parentElement, "a") &&
						  a.parentElement.firstChild === a &&
						  a.parentElement.lastChild === a &&
						  (a = a.parentElement),
						(this.startX = e.clientX),
						(this.startY = e.clientY),
						(this.isCopyMode = (0, i.ctrlKey)(e)),
						(this.draggable = a.cloneNode(!0)),
						(0, i.dataBind)(this.draggable, "target", a),
						(this.state = n.WAIT_DRAGGING),
						this.addDragListeners());
					}
				  }
				}),
				(t.prototype.onDrag = function (e) {
				  var o, r;
				  if (this.draggable && this.state !== n.IDLE) {
					var a = e.clientY;
					if (
					  this.state !== n.WAIT_DRAGGING ||
					  Math.sqrt(
						Math.pow(e.clientX - this.startX, 2) +
						  Math.pow(a - this.startY, 2),
					  ) >= this.diffStep
					) {
					  if (
						(this.state === n.WAIT_DRAGGING &&
						  (this.j.lock("drag-and-drop-element"),
						  (this.state = n.DRAGGING)),
						this.j.e.fire("hidePopup hideResizer"),
						!this.draggable.parentNode)
					  ) {
						var s = (0, i.dataBind)(this.draggable, "target");
						(0, i.css)(this.draggable, {
						  zIndex: 1e13,
						  pointerEvents: "none",
						  pointer: "drag",
						  position: "fixed",
						  opacity: 0.7,
						  display: "inline-block",
						  left: e.clientX,
						  top: e.clientY,
						  width:
							null !== (o = null == s ? void 0 : s.offsetWidth) &&
							void 0 !== o
							  ? o
							  : 100,
						  height:
							null !== (r = null == s ? void 0 : s.offsetHeight) &&
							void 0 !== r
							  ? r
							  : 100,
						}),
						  (0, l.getContainer)(this.j, t).appendChild(
							this.draggable,
						  );
					  }
					  (0, i.css)(this.draggable, {
						left: e.clientX,
						top: e.clientY,
					  }),
						this.j.s.insertCursorAtPoint(e.clientX, e.clientY);
					}
				  }
				}),
				(t.prototype.onDragEnd = function () {
				  this.isInDestruct ||
					(this.removeDragListeners(),
					this.j.unlock(),
					(this.state = n.IDLE),
					this.draggable &&
					  (s.Dom.safeRemove(this.draggable),
					  (this.draggable = null)));
				}),
				(t.prototype.onDrop = function () {
				  if (this.draggable && this.state >= n.DRAGGING) {
					var e = (0, i.dataBind)(this.draggable, "target");
					this.onDragEnd(), this.isCopyMode && (e = e.cloneNode(!0));
					var t = e.parentElement;
					this.j.s.insertNode(e, !0, !1),
					  t &&
						s.Dom.isEmpty(t) &&
						!s.Dom.isTag(t, ["td", "th"]) &&
						s.Dom.safeRemove(t),
					  s.Dom.isTag(e, "img") &&
						this.j.e &&
						this.j.e.fire("afterInsertImage", e),
					  this.j.e.fire("synchro");
				  } else this.onDragEnd();
				}),
				(t.prototype.addDragListeners = function () {
				  this.j.e
					.on(this.j.editor, "mousemove", this.onDrag)
					.on("mouseup", this.onDrop)
					.on([this.j.ew, this.ow], "mouseup", this.onDragEnd);
				}),
				(t.prototype.removeDragListeners = function () {
				  this.j.e
					.off(this.j.editor, "mousemove", this.onDrag)
					.off("mouseup", this.onDrop)
					.off([this.j.ew, this.ow], "mouseup", this.onDragEnd);
				}),
				(t.prototype.beforeDestruct = function () {
				  this.onDragEnd(),
					this.j.e.off("mousedown dragstart", this.onDragStart),
					this.removeDragListeners();
				}),
				r.__decorate([c.autobind], t.prototype, "onDragStart", null),
				r.__decorate(
				  [
					(0, c.throttle)(function (e) {
					  return e.defaultTimeout / 10;
					}),
				  ],
				  t.prototype,
				  "onDrag",
				  null,
				),
				r.__decorate([c.autobind], t.prototype, "onDragEnd", null),
				r.__decorate([c.autobind], t.prototype, "onDrop", null),
				t
			  );
			})(a.Plugin);
			(t.dragAndDropElement = u),
			  l.pluginSystem.add("dragAndDropElement", u);
		  },
		  19268: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.dragAndDrop = void 0);
			var n = o(20255),
			  r = o(86893),
			  i = o(24263),
			  a = o(40332),
			  s = o(57549),
			  l = o(43441),
			  c = o(63463),
			  u = o(17332),
			  d = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.isFragmentFromEditor = !1),
					(t.isCopyMode = !1),
					(t.startDragPoint = { x: 0, y: 0 }),
					(t.draggable = null),
					(t.bufferRange = null),
					(t.getText = function (e) {
					  var t = (0, a.getDataTransfer)(e);
					  return t
						? t.getData(r.TEXT_HTML) || t.getData(r.TEXT_PLAIN)
						: null;
					}),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.afterInit = function () {
					this.j.e.on(
					  [window, this.j.ed, this.j.editor],
					  "dragstart.DragAndDrop",
					  this.onDragStart,
					);
				  }),
				  (t.prototype.onDragStart = function (e) {
					var t = e.target;
					if (
					  (this.onDragEnd(),
					  (this.isFragmentFromEditor = i.Dom.isOrContains(
						this.j.editor,
						t,
						!0,
					  )),
					  (this.isCopyMode =
						!this.isFragmentFromEditor || (0, a.ctrlKey)(e)),
					  this.isFragmentFromEditor)
					) {
					  var o = this.j.s.sel,
						n = o && o.rangeCount ? o.getRangeAt(0) : null;
					  n && (this.bufferRange = n.cloneRange());
					} else this.bufferRange = null;
					(this.startDragPoint.x = e.clientX),
					  (this.startDragPoint.y = e.clientY),
					  (0, c.isFileBrowserFilesItem)(t) &&
						(t = t.querySelector("img")),
					  i.Dom.isTag(t, "img") &&
						((this.draggable = t.cloneNode(!0)),
						(0, a.dataBind)(this.draggable, "target", t)),
					  this.addDragListeners();
				  }),
				  (t.prototype.addDragListeners = function () {
					this.j.e
					  .on("dragover", this.onDrag)
					  .on("drop.DragAndDrop", this.onDrop)
					  .on(
						window,
						"dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop",
						this.onDragEnd,
					  );
				  }),
				  (t.prototype.removeDragListeners = function () {
					this.j.e
					  .off("dragover", this.onDrag)
					  .off("drop.DragAndDrop", this.onDrop)
					  .off(
						window,
						"dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop",
						this.onDragEnd,
					  );
				  }),
				  (t.prototype.onDrag = function (e) {
					this.draggable &&
					  (this.j.e.fire("hidePopup"),
					  this.j.s.insertCursorAtPoint(e.clientX, e.clientY),
					  e.preventDefault(),
					  e.stopPropagation());
				  }),
				  (t.prototype.onDragEnd = function () {
					this.draggable &&
					  (i.Dom.safeRemove(this.draggable), (this.draggable = null)),
					  (this.isCopyMode = !1),
					  this.removeDragListeners();
				  }),
				  (t.prototype.onDrop = function (e) {
					if (
					  !e.dataTransfer ||
					  !e.dataTransfer.files ||
					  !e.dataTransfer.files.length
					) {
					  if (!this.isFragmentFromEditor && !this.draggable)
						return (
						  this.j.e.fire("paste", e),
						  e.preventDefault(),
						  e.stopPropagation(),
						  !1
						);
					  var t = this.j.s.sel,
						o =
						  this.bufferRange ||
						  (t && t.rangeCount ? t.getRangeAt(0) : null),
						r = null;
					  if (!this.draggable && o)
						r = this.isCopyMode
						  ? o.cloneContents()
						  : o.extractContents();
					  else if (this.draggable)
						if (this.isCopyMode) {
						  var s = n.__read(
							  "1" === (0, a.attr)(this.draggable, "-is-file")
								? ["a", "href"]
								: ["img", "src"],
							  2,
							),
							l = s[0],
							c = s[1];
						  (r = this.j.createInside.element(l)).setAttribute(
							c,
							(0, a.attr)(this.draggable, "data-src") ||
							  (0, a.attr)(this.draggable, "src") ||
							  "",
						  ),
							"a" === l &&
							  (r.textContent = (0, a.attr)(r, c) || "");
						} else r = (0, a.dataBind)(this.draggable, "target");
					  else
						this.getText(e) &&
						  (r = this.j.createInside.fromHTML(this.getText(e)));
					  t && t.removeAllRanges(),
						this.j.s.insertCursorAtPoint(e.clientX, e.clientY),
						r &&
						  (this.j.s.insertNode(r, !1, !1),
						  o &&
							r.firstChild &&
							r.lastChild &&
							(o.setStartBefore(r.firstChild),
							o.setEndAfter(r.lastChild),
							this.j.s.selectRange(o),
							this.j.e.fire("synchro")),
						  i.Dom.isTag(r, "img") &&
							this.j.events &&
							this.j.e.fire("afterInsertImage", r)),
						e.preventDefault(),
						e.stopPropagation();
					}
					(this.isFragmentFromEditor = !1), this.removeDragListeners();
				  }),
				  (t.prototype.beforeDestruct = function () {
					this.onDragEnd(),
					  this.j.e
						.off(window, ".DragAndDrop")
						.off(".DragAndDrop")
						.off(
						  [window, this.j.ed, this.j.editor],
						  "dragstart.DragAndDrop",
						  this.onDragStart,
						);
				  }),
				  n.__decorate([l.autobind], t.prototype, "onDragStart", null),
				  n.__decorate(
					[
					  (0, l.throttle)(function (e) {
						return e.defaultTimeout / 10;
					  }),
					],
					t.prototype,
					"onDrag",
					null,
				  ),
				  n.__decorate([l.autobind], t.prototype, "onDragEnd", null),
				  n.__decorate([l.autobind], t.prototype, "onDrop", null),
				  t
				);
			  })(s.Plugin);
			(t.dragAndDrop = d), u.pluginSystem.add("dragAndDrop", d);
		  },
		  95049: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(69516), t);
		  },
		  69516: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.removeExtraBr = void 0);
			var n = o(24263);
			t.removeExtraBr = function (e, t) {
			  if (e.o.dtd.removeExtraBr && !n.Dom.isTag(t, "br")) {
				var o = n.Dom.furthest(t, n.Dom.isBlock, e.editor);
				if (
				  o &&
				  !n.Dom.isTag(o, ["table", "pre", "blockquote", "code"])
				) {
				  var r = n.Dom.isTag(t, "br")
					? t
					: n.Dom.findNotEmptySibling(t, !1);
				  if (!n.Dom.isTag(r, "br")) return;
				  e.s.setCursorBefore(r), n.Dom.safeRemove(r);
				}
			  }
			};
		  },
		  73967: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkBlockNesting = void 0);
			var n = o(24263);
			t.checkBlockNesting = function (e, t) {
			  if (
				(n.Dom.isFragment(t) && (t = t.firstChild),
				e.o.dtd.checkBlockNesting && n.Dom.isBlock(t))
			  ) {
				var o = n.Dom.furthest(e.s.current(), n.Dom.isBlock, e.editor);
				o &&
				  !e.o.dtd.blockLimits[o.tagName.toLowerCase()] &&
				  (e.s.setCursorAfter(o),
				  n.Dom.isEmpty(o) && n.Dom.safeRemove(o));
			  }
			};
		  },
		  73690: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(73967), t);
		  },
		  20173: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.dtd = {
				removeExtraBr: !0,
				checkBlockNesting: !0,
				blockLimits: {
				  article: 1,
				  aside: 1,
				  audio: 1,
				  body: 1,
				  caption: 1,
				  details: 1,
				  dir: 1,
				  div: 1,
				  dl: 1,
				  fieldset: 1,
				  figcaption: 1,
				  figure: 1,
				  footer: 1,
				  form: 1,
				  header: 1,
				  hgroup: 1,
				  main: 1,
				  menu: 1,
				  nav: 1,
				  ol: 1,
				  section: 1,
				  table: 1,
				  td: 1,
				  th: 1,
				  tr: 1,
				  ul: 1,
				  video: 1,
				},
			  });
		  },
		  96899: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255),
			  r = o(57549),
			  i = o(17332),
			  a = o(46163);
			o(20173);
			var s = o(73690),
			  l = o(95049),
			  c = (function (e) {
				function t() {
				  return (null !== e && e.apply(this, arguments)) || this;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.afterInit = function (e) {}),
				  (t.prototype.beforeDestruct = function (e) {}),
				  (t.prototype.__onBeforeInsertNode = function (e) {
					var t = this;
					Object.keys(s).forEach(function (o) {
					  s[o](t.j, e);
					});
				  }),
				  (t.prototype.__onAfterInsertNode = function (e) {
					var t = this;
					Object.keys(l).forEach(function (o) {
					  l[o](t.j, e);
					});
				  }),
				  n.__decorate(
					[(0, a.watch)(":beforeInsertNode")],
					t.prototype,
					"__onBeforeInsertNode",
					null,
				  ),
				  n.__decorate(
					[(0, a.watch)(":afterInsertNode")],
					t.prototype,
					"__onAfterInsertNode",
					null,
				  ),
				  t
				);
			  })(r.Plugin);
			i.pluginSystem.add("dtd", c);
		  },
		  33122: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.enter = void 0);
			var n = o(20255),
			  r = o(24263),
			  i = o(85605),
			  a = o(86893),
			  s = o(43441),
			  l = o(67749),
			  c = o(23217),
			  u = o(17332);
			o(26231);
			var d = (function (e) {
			  function t() {
				return (null !== e && e.apply(this, arguments)) || this;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this,
					o = e.o.enter.toLowerCase(),
					n = o === a.BR.toLowerCase();
				  e.o.enterBlock || (e.o.enterBlock = n ? a.PARAGRAPH : o),
					e.registerCommand("enter", function (e, o, n) {
					  return void 0 === n && (n = {}), t.onEnter(n);
					});
				}),
				(t.prototype.onEnterKeyDown = function (e) {
				  if (e.key === a.KEY_ENTER) {
					var t = this.j,
					  o = t.e.fire("beforeEnter", e);
					return void 0 !== o
					  ? o
					  : (t.s.isCollapsed() || t.execCommand("Delete"),
						t.s.focus(),
						this.onEnter(e),
						t.e.fire("afterEnter", e),
						t.synchronizeValues(),
						!1);
				  }
				}),
				(t.prototype.onEnter = function (e) {
				  var t = this.jodit,
					o = t.createInside.fake();
				  try {
					r.Dom.safeInsertNode(t.s.range, o),
					  (0, c.moveCursorOutFromSpecialTags)(t, o, ["a"]);
					var n = (0, c.getBlockWrapper)(o, t),
					  i = r.Dom.isTag(n, "li");
					if (
					  (!i || (null == e ? void 0 : e.shiftKey)) &&
					  (0, c.checkBR)(o, t, null == e ? void 0 : e.shiftKey)
					)
					  return !1;
					if (
					  (n ||
						(0, c.hasPreviousBlock)(o, t) ||
						(n = (0, c.wrapText)(o, t)),
					  !n)
					)
					  return (
						(0, c.insertParagraph)(o, t, i ? "li" : t.o.enter), !1
					  );
					if (!(0, c.checkUnsplittableBox)(o, t, n)) return !1;
					if (i && this.__isEmptyListLeaf(n))
					  return (0, c.processEmptyLILeaf)(o, t, n), !1;
					(0, c.splitFragment)(o, t, n);
				  } finally {
					o.isConnected && t.s.setCursorBefore(o), r.Dom.safeRemove(o);
				  }
				}),
				(t.prototype.__isEmptyListLeaf = function (e) {
				  var t = this.j.e.fire("enterIsEmptyListLeaf", e);
				  return (0, l.isBoolean)(t) ? t : r.Dom.isEmpty(e);
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e.off("keydown.enter");
				}),
				n.__decorate(
				  [(0, s.watch)(":keydown.enter")],
				  t.prototype,
				  "onEnterKeyDown",
				  null,
				),
				t
			  );
			})(i.Plugin);
			(t.enter = d), u.pluginSystem.add("enter", d);
		  },
		  94149: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkBR = void 0);
			var n = o(24263),
			  r = o(9005),
			  i = o(86893);
			function a(e) {
			  if (!e) return !1;
			  var t = n.Dom.findSibling(e, !0);
			  return !(!t || !n.Dom.isTag(t, "br")) && t;
			}
			t.checkBR = function (e, t, o) {
			  var s = Boolean(n.Dom.closest(e, ["pre", "blockquote"], t.editor));
			  if (
				t.o.enter.toLowerCase() === i.BR.toLowerCase() ||
				(o && !s) ||
				(!o && s)
			  ) {
				if (
				  s &&
				  (function (e) {
					var t = a(a(e));
					return (
					  !!t && (n.Dom.safeRemove(a(e)), n.Dom.safeRemove(t), !0)
					);
				  })(e)
				)
				  return !1;
				var l = t.createInside.element("br");
				if ((n.Dom.before(e, l), !n.Dom.findNotEmptySibling(l, !1))) {
				  var c = l.cloneNode();
				  n.Dom.after(l, c), n.Dom.before(c, e);
				}
				return (0, r.scrollIntoViewIfNeeded)(l, t.editor, t.ed), !0;
			  }
			  return !1;
			};
		  },
		  58921: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.checkUnsplittableBox = void 0);
			var n = o(24263);
			t.checkUnsplittableBox = function (e, t, o) {
			  return (
				!!n.Dom.canSplitBlock(o) ||
				(n.Dom.before(e, t.createInside.element("br")), !1)
			  );
			};
		  },
		  70638: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getBlockWrapper = void 0);
			var n = o(86893),
			  r = o(24263);
			t.getBlockWrapper = function e(t, o, i) {
			  void 0 === i && (i = n.IS_BLOCK);
			  var a = t,
				s = o.editor;
			  do {
				if (!a || a === s) break;
				if (i.test(a.nodeName))
				  return r.Dom.isTag(a, "li")
					? a
					: e(a.parentNode, o, /^li$/i) || a;
				a = a.parentNode;
			  } while (a && a !== s);
			  return null;
			};
		  },
		  50781: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.hasPreviousBlock = void 0);
			var n = o(24263);
			t.hasPreviousBlock = function (e, t) {
			  return Boolean(
				n.Dom.prev(
				  e,
				  function (e) {
					return n.Dom.isBlock(e) || n.Dom.isImage(e);
				  },
				  t.editor,
				),
			  );
			};
		  },
		  23217: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(94149), t),
			  n.__exportStar(o(58921), t),
			  n.__exportStar(o(92291), t),
			  n.__exportStar(o(70638), t),
			  n.__exportStar(o(50781), t),
			  n.__exportStar(o(90443), t),
			  n.__exportStar(o(52521), t),
			  n.__exportStar(o(81512), t),
			  n.__exportStar(o(29575), t);
		  },
		  90443: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.insertParagraph = void 0);
			var n = o(24263),
			  r = o(9005);
			t.insertParagraph = function (e, t, o, i) {
			  var a = "br" === o.toLowerCase(),
				s = t.createInside,
				l = s.element(o),
				c = s.element("br");
			  return (
				a || l.appendChild(c),
				i && i.cssText && l.setAttribute("style", i.cssText),
				n.Dom.after(e, l),
				n.Dom.before(a ? l : c, e),
				(0, r.scrollIntoViewIfNeeded)(l, t.editor, t.ed),
				l
			  );
			};
		  },
		  29575: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.moveCursorOutFromSpecialTags = void 0);
			var n = o(24263);
			t.moveCursorOutFromSpecialTags = function (e, t, o) {
			  var r = e.s,
				i = n.Dom.closest(t, o, e.editor);
			  i &&
				(r.cursorOnTheRight(i, t)
				  ? n.Dom.after(i, t)
				  : r.cursorOnTheLeft(i, t) && n.Dom.before(i, t));
			};
		  },
		  92291: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.processEmptyLILeaf = void 0);
			var n = o(24263),
			  r = o(54188),
			  i = o(90443);
			t.processEmptyLILeaf = function (e, t, o) {
			  var a = n.Dom.closest(o, ["ol", "ul"], t.editor);
			  if (a) {
				var s = a.parentElement,
				  l = n.Dom.isTag(s, "li"),
				  c = l ? s : a,
				  u = t.s.createRange();
				u.setStartAfter(o), u.setEndAfter(a);
				var d = u.extractContents();
				n.Dom.after(c, e),
				  n.Dom.safeRemove(o),
				  (0, r.$$)("li", a).length || n.Dom.safeRemove(a);
				var p = (0, i.insertParagraph)(e, t, l ? "li" : t.o.enter);
				d.querySelector("li") &&
				  (l ? p.appendChild(d) : n.Dom.after(p, d));
			  }
			};
		  },
		  52521: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.splitFragment = void 0);
			var n = o(9005),
			  r = o(24263),
			  i = o(90443);
			t.splitFragment = function (e, t, o) {
			  var a = t.s,
				s = t.o.enter.toLowerCase(),
				l = r.Dom.isTag(o, "li"),
				c = o.tagName.toLowerCase() === s || l,
				u = a.cursorOnTheRight(o, e),
				d = a.cursorOnTheLeft(o, e);
			  if (!c && (u || d))
				return (
				  u ? r.Dom.after(o, e) : r.Dom.before(o, e),
				  (0, i.insertParagraph)(e, t, s),
				  void (d && !u && r.Dom.prepend(o, e))
				);
			  var p = a.splitSelection(o, e);
			  (0, n.scrollIntoViewIfNeeded)(p, t.editor, t.ed);
			};
		  },
		  81512: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.wrapText = void 0);
			var n = o(24263);
			t.wrapText = function (e, t) {
			  var o = e;
			  n.Dom.up(
				o,
				function (e) {
				  e && e.hasChildNodes() && e !== t.editor && (o = e);
				},
				t.editor,
			  );
			  var r = n.Dom.wrapInline(o, t.o.enter, t);
			  if (n.Dom.isEmpty(r)) {
				var i = t.createInside.element("br");
				r.appendChild(i), n.Dom.before(i, e);
			  }
			  return r;
			};
		  },
		  26231: function () {},
		  10135: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.file = void 0);
			var n = o(93166),
			  r = o(24263),
			  i = o(718),
			  a = o(17332);
			function s(e) {
			  e.registerButton({ name: "file", group: "media" });
			}
			(n.Config.prototype.controls.file = {
			  popup: function (e, t, o, n) {
				var a = function (t, o) {
					void 0 === o && (o = ""),
					  e.s.insertNode(
						e.createInside.fromHTML(
						  '<a href="'
							.concat(t, '" title="')
							.concat(o, '">')
							.concat(o || t, "</a>"),
						),
					  );
				  },
				  s = null;
				return (
				  t &&
					(r.Dom.isTag(t, "a") || r.Dom.closest(t, "a", e.editor)) &&
					(s = r.Dom.isTag(t, "a")
					  ? t
					  : r.Dom.closest(t, "a", e.editor)),
				  (0, i.FileSelectorWidget)(
					e,
					{
					  filebrowser: function (e) {
						e.files &&
						  e.files.forEach(function (t) {
							return a(e.baseurl + t);
						  }),
						  n();
					  },
					  upload: !0,
					  url: function (e, t) {
						s
						  ? (s.setAttribute("href", e),
							s.setAttribute("title", t))
						  : a(e, t),
						  n();
					  },
					},
					s,
					n,
					!1,
				  )
				);
			  },
			  tags: ["a"],
			  tooltip: "Insert file",
			}),
			  (t.file = s),
			  a.pluginSystem.add("file", s);
		  },
		  66994: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.focus = void 0);
			var n = o(93166),
			  r = o(64968),
			  i = o(17332);
			function a(e) {
			  e.o.saveSelectionOnBlur &&
				e.e
				  .on("blur", function () {
					e.isEditorMode() && e.s.save(!0);
				  })
				  .on("focus", function () {
					e.s.restore();
				  });
			  var t = function () {
				if ((e.s.focus(), "end" === e.o.cursorAfterAutofocus)) {
				  var t = r.Dom.last(e.editor, function (e) {
					return r.Dom.isText(e);
				  });
				  t && e.s.setCursorIn(t, !1);
				}
			  };
			  e.e.on("afterInit", function () {
				e.o.autofocus &&
				  (e.defaultTimeout ? e.async.setTimeout(t, 300) : t());
			  }),
				e.e.on("afterInit afterAddPlace", function () {
				  e.e
					.off(e.editor, "mousedown.autofocus")
					.on(e.editor, "mousedown.autofocus", function (t) {
					  e.isEditorMode() &&
						t.target &&
						r.Dom.isBlock(t.target) &&
						!t.target.childNodes.length &&
						(e.editor === t.target
						  ? e.s.focus()
						  : e.s.setCursorIn(t.target));
					});
				});
			}
			(n.Config.prototype.autofocus = !1),
			  (n.Config.prototype.cursorAfterAutofocus = "end"),
			  (n.Config.prototype.saveSelectionOnBlur = !0),
			  (t.focus = a),
			  i.pluginSystem.add("focus", a);
		  },
		  8082: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255),
			  r = o(93166),
			  i = o(24263),
			  a = o(76502),
			  s = o(77904);
			(r.Config.prototype.defaultFontSizePoints = "px"),
			  s.Icon.set("font", o(84142)).set("fontsize", o(57292)),
			  (r.Config.prototype.controls.fontsize = {
				command: "fontsize",
				data: { cssRule: "font-size" },
				list: [
				  "8",
				  "9",
				  "10",
				  "11",
				  "12",
				  "14",
				  "16",
				  "18",
				  "24",
				  "30",
				  "36",
				  "48",
				  "60",
				  "72",
				  "96",
				],
				exec: function (e, t, o) {
				  var n = o.control;
				  return (0, a.memorizeExec)(e, t, { control: n }, function (t) {
					var o;
					return "fontsize" ===
					  (null === (o = n.command) || void 0 === o
						? void 0
						: o.toLowerCase())
					  ? "".concat(t).concat(e.o.defaultFontSizePoints)
					  : t;
				  });
				},
				childTemplate: function (e, t, o) {
				  return "".concat(o).concat(e.o.defaultFontSizePoints);
				},
				tooltip: "Font size",
				isChildActive: function (e, t) {
				  var o,
					n,
					r = e.s.current(),
					s =
					  (null === (o = t.data) || void 0 === o
						? void 0
						: o.cssRule) || "font-size",
					l =
					  (null === (n = t.data) || void 0 === n
						? void 0
						: n.normalize) ||
					  function (t) {
						return /pt$/i.test(t) &&
						  "pt" === e.o.defaultFontSizePoints
						  ? t.replace(/pt$/i, "")
						  : t;
					  };
				  if (r) {
					var c =
						i.Dom.closest(r, i.Dom.isElement, e.editor) || e.editor,
					  u = (0, a.css)(c, s);
					return Boolean(
					  u && t.args && l(t.args[0].toString()) === l(u.toString()),
					);
				  }
				  return !1;
				},
			  }),
			  (r.Config.prototype.controls.font = n.__assign(
				n.__assign({}, r.Config.prototype.controls.fontsize),
				{
				  command: "fontname",
				  list: {
					"": "Default",
					"helvetica,sans-serif": "Helvetica",
					"arial,helvetica,sans-serif": "Arial",
					"georgia,palatino,serif": "Georgia",
					"impact,charcoal,sans-serif": "Impact",
					"tahoma,geneva,sans-serif": "Tahoma",
					"times new roman,times,serif": "Times New Roman",
					"verdana,geneva,sans-serif": "Verdana",
				  },
				  childTemplate: function (e, t, o) {
					var n = !1;
					try {
					  n =
						-1 === t.indexOf("dings") &&
						document.fonts.check("16px ".concat(t), o);
					} catch (e) {}
					return '<span data-style="'
					  .concat(t, '" style="')
					  .concat(
						n ? "font-family: ".concat(t, "!important;") : "",
						'">',
					  )
					  .concat(o, "</span>");
				  },
				  data: {
					cssRule: "font-family",
					normalize: function (e) {
					  return e
						.toLowerCase()
						.replace(/['"]+/g, "")
						.replace(/[^a-z0-9]+/g, ",");
					},
				  },
				  tooltip: "Font family",
				},
			  ));
		  },
		  54798: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.font = void 0);
			var n = o(40332),
			  r = o(17332);
			function i(e) {
			  e.registerButton({ name: "font", group: "font" }).registerButton({
				name: "fontsize",
				group: "font",
			  });
			  var t = function (t, o, r) {
				switch (t) {
				  case "fontsize":
					e.s.applyStyle({ fontSize: (0, n.normalizeSize)(r) });
					break;
				  case "fontname":
					e.s.applyStyle({ fontFamily: r });
				}
				return e.synchronizeValues(), !1;
			  };
			  e.registerCommand("fontsize", t).registerCommand("fontname", t);
			}
			o(8082), (t.font = i), r.pluginSystem.add("font", i);
		  },
		  12908: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.formatBlock = void 0);
			var n = o(93166),
			  r = o(87837),
			  i = o(40332),
			  a = o(17332);
			function s(e) {
			  e.registerButton({ name: "paragraph", group: "font" }),
				e.registerCommand("formatblock", function (t, o, n) {
				  return (
					e.s.applyStyle(void 0, { element: n }),
					e.synchronizeValues(),
					!1
				  );
				});
			}
			o(77904).Icon.set("paragraph", o(18019)),
			  (n.Config.prototype.controls.paragraph = {
				command: "formatBlock",
				update: function (e, t) {
				  var o = e.control,
					n = t.s.current();
				  if (n && t.o.textIcons) {
					var i = (
						r.Dom.closest(n, r.Dom.isBlock, t.editor) || t.editor
					  ).nodeName.toLowerCase(),
					  a = o.list;
					e &&
					  o.data &&
					  o.data.currentValue !== i &&
					  a &&
					  a[i] &&
					  (t.o.textIcons
						? (e.state.text = i)
						: (e.state.icon.name = i),
					  (o.data.currentValue = i));
				  }
				  return !1;
				},
				exec: i.memorizeExec,
				data: { currentValue: "left" },
				list: {
				  p: "Normal",
				  h1: "Heading 1",
				  h2: "Heading 2",
				  h3: "Heading 3",
				  h4: "Heading 4",
				  blockquote: "Quote",
				  pre: "Code",
				},
				isChildActive: function (e, t) {
				  var o = e.s.current();
				  if (o) {
					var n = r.Dom.closest(o, r.Dom.isBlock, e.editor);
					return Boolean(
					  n &&
						n !== e.editor &&
						void 0 !== t.args &&
						n.nodeName.toLowerCase() === t.args[0],
					);
				  }
				  return !1;
				},
				isActive: function (e, t) {
				  var o = e.s.current();
				  if (o) {
					var n = r.Dom.closest(o, r.Dom.isBlock, e.editor);
					return Boolean(
					  n &&
						n !== e.editor &&
						void 0 !== t.list &&
						!r.Dom.isTag(n, "p") &&
						void 0 !== t.list[n.nodeName.toLowerCase()],
					);
				  }
				  return !1;
				},
				childTemplate: function (e, t, o) {
				  return "<"
					.concat(t, ' style="margin:0;padding:0"><span>')
					.concat(e.i18n(o), "</span></")
					.concat(t, ">");
				},
				tooltip: "Insert format block",
			  }),
			  (t.formatBlock = s),
			  a.pluginSystem.add("formatBlock", s);
		  },
		  15045: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }), o(14320);
			var n = o(93166),
			  r = o(86893),
			  i = o(77904);
			(n.Config.prototype.fullsize = !1),
			  (n.Config.prototype.globalFullSize = !0),
			  i.Icon.set("fullsize", o(45146)).set("shrink", o(53576)),
			  (n.Config.prototype.controls.fullsize = {
				exec: function (e) {
				  e.toggleFullSize();
				},
				update: function (e, t) {
				  var o = t.isFullSize ? "shrink" : "fullsize";
				  (e.state.activated = t.isFullSize),
					t.o.textIcons ? (e.state.text = o) : (e.state.icon.name = o);
				},
				tooltip: "Open in fullsize",
				mode: r.MODE_SOURCE + r.MODE_WYSIWYG,
			  });
		  },
		  65123: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.fullsize = void 0),
			  o(14320);
			var n = o(26911),
			  r = o(77892),
			  i = o(17332);
			o(15045);
			var a = new Set();
			function s(e) {
			  e.registerButton({ name: "fullsize" });
			  var t = !1,
				o = 0,
				i = 0,
				s = !1,
				l = function () {
				  var r = e.container;
				  e.events &&
					(t
					  ? ((o = (0, n.css)(r, "height", !0)),
						(i = (0, n.css)(r, "width", !0)),
						(0, n.css)(r, {
						  height: e.ow.innerHeight,
						  width: e.ow.innerWidth,
						}),
						(s = !0))
					  : s &&
						(0, n.css)(r, {
						  height: o || "auto",
						  width: i || "auto",
						}));
				},
				c = function (o) {
				  var i = e.container,
					s = e.events;
				  if (i) {
					if (
					  (void 0 === o &&
						(o = !i.classList.contains("jodit_fullsize")),
					  e.setMod("fullsize", o),
					  (e.o.fullsize = o),
					  (t = o),
					  i.classList.toggle("jodit_fullsize", o),
					  e.toolbar &&
						((0, r.isJoditObject)(e) &&
						  e.toolbarContainer.appendChild(e.toolbar.container),
						(0, n.css)(e.toolbar.container, "width", "auto")),
					  o ? a.add(i) : a.delete(i),
					  e.o.globalFullSize &&
						((1 === a.size && o) || (0 === a.size && !o)))
					) {
					  for (
						var c = i.parentNode;
						c &&
						c.nodeType !== Node.DOCUMENT_NODE &&
						c.nodeType !== Node.DOCUMENT_FRAGMENT_NODE;
  
					  )
						c.classList.toggle("jodit_fullsize-box_true", o),
						  (c = c.parentNode);
					  l();
					}
					s.fire("afterResize");
				  }
				};
			  e.o.globalFullSize && e.e.on(e.ow, "resize", l),
				e.e
				  .on("afterInit afterOpen", function () {
					var t;
					e.toggleFullSize(
					  null === (t = null == e ? void 0 : e.options) ||
						void 0 === t
						? void 0
						: t.fullsize,
					);
				  })
				  .on("toggleFullSize", c)
				  .on("beforeDestruct", function () {
					t && c(!1);
				  })
				  .on("beforeDestruct", function () {
					e.events && e.e.off(e.ow, "resize", l);
				  });
			}
			(t.fullsize = s), i.pluginSystem.add("fullsize", s);
		  },
		  16829: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.commandToHotkeys = {
				removeFormat: ["ctrl+shift+m", "cmd+shift+m"],
				insertOrderedList: ["ctrl+shift+7", "cmd+shift+7"],
				insertUnorderedList: ["ctrl+shift+8, cmd+shift+8"],
				selectall: ["ctrl+a", "cmd+a"],
			  });
		  },
		  83228: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.hotkeys = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(40332),
			  a = o(86893),
			  s = o(17332);
			o(16829);
			var l = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.onKeyPress = function (e) {
					var o = t.specialKeys[e.which],
					  n = (e.key || String.fromCharCode(e.which)).toLowerCase(),
					  r = [o || n];
					return (
					  ["alt", "ctrl", "shift", "meta"].forEach(function (t) {
						e[t + "Key"] && o !== t && r.push(t);
					  }),
					  (0, i.normalizeKeyAliases)(r.join("+"))
					);
				  }),
				  (t.specialKeys = {
					8: "backspace",
					9: "tab",
					10: "return",
					13: "return",
					16: "shift",
					17: "ctrl",
					18: "alt",
					19: "pause",
					20: "capslock",
					27: "esc",
					32: "space",
					33: "pageup",
					34: "pagedown",
					35: "end",
					36: "home",
					37: "left",
					38: "up",
					39: "right",
					40: "down",
					45: "insert",
					46: "del",
					59: ";",
					61: "=",
					91: "meta",
					96: "0",
					97: "1",
					98: "2",
					99: "3",
					100: "4",
					101: "5",
					102: "6",
					103: "7",
					104: "8",
					105: "9",
					106: "*",
					107: "+",
					109: "-",
					110: ".",
					111: "/",
					112: "f1",
					113: "f2",
					114: "f3",
					115: "f4",
					116: "f5",
					117: "f6",
					118: "f7",
					119: "f8",
					120: "f9",
					121: "f10",
					122: "f11",
					123: "f12",
					144: "numlock",
					145: "scroll",
					173: "-",
					186: ";",
					187: "=",
					188: ",",
					189: "-",
					190: ".",
					191: "/",
					192: "`",
					219: "[",
					220: "\\",
					221: "]",
					222: "'",
				  }),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  (0, i.keys)(e.o.commandToHotkeys, !1).forEach(function (t) {
					var o = e.o.commandToHotkeys[t];
					o &&
					  ((0, i.isArray)(o) || (0, i.isString)(o)) &&
					  e.registerHotkeyToCommand(o, t);
				  });
				  var o = !1;
				  e.e
					.off(".hotkeys")
					.on([e.ow, e.ew], "keydown.hotkeys", function (e) {
					  if (e.key === a.KEY_ESC) return t.j.e.fire("escape", e);
					})
					.on(
					  "keydown.hotkeys",
					  function (n) {
						var r = t.onKeyPress(n),
						  i = { shouldStop: !0 };
						if (!1 === t.j.e.fire(r + ".hotkey", n.type, i)) {
						  if (i.shouldStop)
							return (o = !0), e.e.stopPropagation("keydown"), !1;
						  n.preventDefault();
						}
					  },
					  { top: !0 },
					)
					.on(
					  "keyup.hotkeys",
					  function () {
						if (o) return (o = !1), e.e.stopPropagation("keyup"), !1;
					  },
					  { top: !0 },
					);
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.events && e.e.off(".hotkeys");
				}),
				t
			  );
			})(r.Plugin);
			(t.hotkeys = l), s.pluginSystem.add("hotkeys", l);
		  },
		  43889: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.hr = void 0);
			var n = o(93166),
			  r = o(64968),
			  i = o(17332);
			function a(e) {
			  e.registerButton({ name: "hr", group: "insert" }),
				e.registerCommand("insertHorizontalRule", function () {
				  var t = e.createInside.element("hr");
				  e.s.insertNode(t, !1, !1);
				  var o = r.Dom.closest(t.parentElement, r.Dom.isBlock, e.editor);
				  o &&
					r.Dom.isEmpty(o) &&
					o !== e.editor &&
					(r.Dom.after(o, t), r.Dom.safeRemove(o));
				  var n = r.Dom.next(t, r.Dom.isBlock, e.editor, !1);
				  return (
					n ||
					  ((n = e.createInside.element(e.o.enter)),
					  r.Dom.after(t, n)),
					e.s.setCursorIn(n),
					!1
				  );
				});
			}
			o(77904).Icon.set("hr", o(14655)),
			  (n.Config.prototype.controls.hr = {
				command: "insertHorizontalRule",
				tags: ["hr"],
				tooltip: "Insert Horizontal Line",
			  }),
			  (t.hr = a),
			  i.pluginSystem.add("hr", a);
		  },
		  2509: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.iframeBaseUrl = ""),
			  (n.Config.prototype.iframeTitle = "Jodit Editor"),
			  (n.Config.prototype.iframeDoctype = "<!DOCTYPE html>"),
			  (n.Config.prototype.iframeDefaultSrc = "about:blank"),
			  (n.Config.prototype.iframeStyle =
				'html{margin:0;padding:0;min-height: 100%;}body{box-sizing:border-box;font-size:13px;line-height:1.6;padding:10px;margin:0;background:transparent;color:#000;position:relative;z-index:2;user-select:auto;margin:0px;overflow:auto;outline:none;}table{width:100%;border:none;border-collapse:collapse;empty-cells: show;max-width: 100%;}th,td{padding: 2px 5px;border:1px solid #ccc;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}p{margin-top:0;}.jodit_editor .jodit_iframe_wrapper{display: block;clear: both;user-select: none;position: relative;}.jodit_editor .jodit_iframe_wrapper:after {position:absolute;content:"";z-index:1;top:0;left:0;right: 0;bottom: 0;cursor: pointer;display: block;background: rgba(0, 0, 0, 0);} .jodit_disabled{user-select: none;-o-user-select: none;-moz-user-select: none;-khtml-user-select: none;-webkit-user-select: none;-ms-user-select: none}'),
			  (n.Config.prototype.iframeCSSLinks = []);
		  },
		  93300: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.iframe = void 0);
			var n = o(40332),
			  r = o(40332),
			  i = o(86893),
			  a = o(17332);
			function s(e) {
			  var t = e.options;
			  e.e
				.on("afterSetMode", function () {
				  e.isEditorMode() && e.s.focus();
				})
				.on("generateDocumentStructure.iframe", function (e, o) {
				  var r = e || o.iframe.contentWindow.document;
				  if (
					(r.open(),
					r.write(
					  t.iframeDoctype +
						'<html dir="'
						  .concat(t.direction, '" class="jodit" lang="')
						  .concat((0, n.defaultLanguage)(t.language), '">') +
						"<head>" +
						"<title>".concat(t.iframeTitle, "</title>") +
						(t.iframeBaseUrl
						  ? '<base href="'.concat(t.iframeBaseUrl, '"/>')
						  : "") +
						'</head><body class="jodit-wysiwyg"></body></html>',
					),
					r.close(),
					t.iframeCSSLinks &&
					  t.iframeCSSLinks.forEach(function (e) {
						var t = r.createElement("link");
						t.setAttribute("rel", "stylesheet"),
						  t.setAttribute("href", e),
						  r.head && r.head.appendChild(t);
					  }),
					t.iframeStyle)
				  ) {
					var i = r.createElement("style");
					(i.innerHTML = t.iframeStyle),
					  r.head && r.head.appendChild(i);
				  }
				})
				.on("createEditor", function () {
				  if (t.iframe) {
					var o = e.c.element("iframe");
					(o.style.display = "block"),
					  (o.src = "about:blank"),
					  (o.className = "jodit-wysiwyg_iframe"),
					  o.setAttribute("allowtransparency", "true"),
					  o.setAttribute("tabindex", t.tabIndex.toString()),
					  o.setAttribute("frameborder", "0"),
					  e.workplace.appendChild(o),
					  (e.iframe = o);
					var a = e.e.fire("generateDocumentStructure.iframe", null, e);
					return (0, n.callPromise)(a, function () {
					  if (!e.iframe) return !1;
					  var o = e.iframe.contentWindow.document;
					  e.editorWindow = e.iframe.contentWindow;
					  var a = function () {
						  (0, n.attr)(
							o.body,
							"contenteditable",
							(e.getMode() !== i.MODE_SOURCE && !e.getReadOnly()) ||
							  null,
						  );
						},
						s = function (e) {
						  var t = /<body.*<\/body>/im,
							o = "{%%BODY%%}",
							n = t.exec(e);
						  return (
							n &&
							  (e = e
								.replace(t, o)
								.replace(/<span([^>]*?)>(.*?)<\/span>/gim, "")
								.replace(
								  /&lt;span([^&]*?)&gt;(.*?)&lt;\/span&gt;/gim,
								  "",
								)
								.replace(
								  o,
								  n[0]
									.replace(
									  /(<body[^>]+?)min-height["'\s]*:[\s"']*[0-9]+(px|%)/im,
									  "$1",
									)
									.replace(
									  /(<body[^>]+?)([\s]*["'])?contenteditable["'\s]*=[\s"']*true["']?/im,
									  "$1",
									)
									.replace(
									  /<(style|script|span)[^>]+jodit[^>]+>.*?<\/\1>/g,
									  "",
									),
								)
								.replace(
								  /(class\s*=\s*)(['"])([^"']*)(jodit-wysiwyg|jodit)([^"']*\2)/g,
								  "$1$2$3$5",
								)
								.replace(/(<[^<]+?)\sclass="[\s]*"/gim, "$1")
								.replace(/(<[^<]+?)\sstyle="[\s;]*"/gim, "$1")
								.replace(/(<[^<]+?)\sdir="[\s]*"/gim, "$1")),
							e
						  );
						};
					  if (t.editHTMLDocumentMode) {
						var l = e.element.tagName;
						if ("TEXTAREA" !== l && "INPUT" !== l)
						  throw (0, r.error)(
							"If enable `editHTMLDocumentMode` - source element should be INPUT or TEXTAREA",
						  );
						e.e
						  .on("beforeGetNativeEditorValue", function () {
							return s(
							  e.o.iframeDoctype + o.documentElement.outerHTML,
							);
						  })
						  .on(
							"beforeSetNativeEditorValue",
							function (t) {
							  var n = t.value;
							  return (
								!e.isLocked &&
								(/<(html|body)/i.test(n)
								  ? s(o.documentElement.outerHTML) !== s(n) &&
									(o.open(),
									o.write(e.o.iframeDoctype + s(n)),
									o.close(),
									(e.editor = o.body),
									e.e.fire("safeHTML", e.editor),
									a(),
									e.e.fire("prepareWYSIWYGEditor"),
									e.e.stopPropagation(
									  "beforeSetNativeEditorValue",
									))
								  : (o.body.innerHTML = n),
								!0)
							  );
							},
							{ top: !0 },
						  );
					  }
					  if (
						((e.editor = o.body),
						e.e.on("afterSetMode afterInit afterAddPlace", a),
						"auto" === t.height)
					  ) {
						o.documentElement &&
						  (o.documentElement.style.overflowY = "hidden");
						var c = e.async.throttle(function () {
						  if (e.editor && e.iframe && "auto" === t.height) {
							var o = e.ew.getComputedStyle(e.editor),
							  r =
								parseInt(o.marginTop || "0", 10) +
								parseInt(o.marginBottom || "0", 10);
							(0, n.css)(
							  e.iframe,
							  "height",
							  e.editor.offsetHeight + r,
							);
						  }
						}, e.defaultTimeout / 2);
						if (
						  (e.e
							.on("change afterInit afterSetMode resize", c)
							.on([e.iframe, e.ew, o.documentElement], "load", c)
							.on(o, "readystatechange DOMContentLoaded", c),
						  "function" == typeof ResizeObserver)
						) {
						  var u = new ResizeObserver(c);
						  u.observe(o.body),
							e.e.on("beforeDestruct", function () {
							  u.unobserve(o.body);
							});
						}
					  }
					  return (
						o.documentElement &&
						  e.e
							.on(
							  o.documentElement,
							  "mousedown touchend",
							  function () {
								e.s.isFocused() ||
								  (e.s.focus(),
								  e.editor === o.body && e.s.setCursorIn(o.body));
							  },
							)
							.on(
							  e.ew,
							  "mousedown touchstart keydown keyup touchend click mouseup mousemove scroll",
							  function (t) {
								var o;
								null === (o = e.events) ||
								  void 0 === o ||
								  o.fire(e.ow, t);
							  },
							),
						!1
					  );
					});
				  }
				});
			}
			o(2509), (t.iframe = s), a.pluginSystem.add("iframe", s);
		  },
		  18226: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.imageProcessor = {
				replaceDataURIToBlobIdInView: !0,
			  });
		  },
		  92575: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.imageProcessor = void 0);
			var n = o(20255),
			  r = o(40332),
			  i = o(57549),
			  a = o(43441),
			  s = o(86893),
			  l = o(17332);
			o(18226);
			var c = "__jodit_imageprocessor_binded",
			  u = "__jodit_imageprocessor_bindedblob-id",
			  d = (function (e) {
				function t() {
				  return (null !== e && e.apply(this, arguments)) || this;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.afterInit = function (e) {}),
				  (t.prototype.beforeDestruct = function (e) {
					var t,
					  o,
					  r = e.buffer.get(u);
					if (r) {
					  var i = Object.keys(r);
					  try {
						for (
						  var a = n.__values(i), s = a.next();
						  !s.done;
						  s = a.next()
						)
						  URL.revokeObjectURL(s.value);
					  } catch (e) {
						t = { error: e };
					  } finally {
						try {
						  s && !s.done && (o = a.return) && o.call(a);
						} finally {
						  if (t) throw t.error;
						}
					  }
					  e.buffer.delete(u);
					}
				  }),
				  (t.prototype.onAfterGetValueFromEditor = function (e, t) {
					if (t !== s.SOURCE_CONSUMER)
					  return this.onBeforeSetElementValue(e);
				  }),
				  (t.prototype.onBeforeSetElementValue = function (e) {
					var t,
					  o,
					  r = this.jodit;
					if (r.o.imageProcessor.replaceDataURIToBlobIdInView) {
					  var i = r.buffer.get(u);
					  if (i) {
						var a = Object.keys(i);
						try {
						  for (
							var s = n.__values(a), l = s.next();
							!l.done;
							l = s.next()
						  )
							for (var c = l.value; e.value.includes(c); )
							  e.value = e.value.replace(c, i[c]);
						} catch (e) {
						  t = { error: e };
						} finally {
						  try {
							l && !l.done && (o = s.return) && o.call(s);
						  } finally {
							if (t) throw t.error;
						  }
						}
					  }
					}
				  }),
				  (t.prototype.afterChange = function (e) {
					return n.__awaiter(this, void 0, Promise, function () {
					  var e;
					  return n.__generator(this, function (t) {
						return (e = this.jodit).editor
						  ? ((0, r.$$)("img", e.editor).forEach(function (t) {
							  (0, r.dataBind)(t, c) ||
								((0, r.dataBind)(t, c, !0),
								t.complete ||
								  e.e.on(t, "load", function o() {
									var n;
									!e.isInDestruct &&
									  (null === (n = e.e) ||
										void 0 === n ||
										n.fire("resize")),
									  e.e.off(t, "load", o);
								  }),
								t.src &&
								  /^data:/.test(t.src) &&
								  (function (e, t) {
									if (
									  e.o.imageProcessor
										.replaceDataURIToBlobIdInView &&
									  "undefined" != typeof ArrayBuffer &&
									  "undefined" != typeof URL
									) {
									  var o = t.src,
										n = (function (e) {
										  for (
											var t = atob(e.split(",")[1]),
											  o = e
												.split(",")[0]
												.split(":")[1]
												.split(";")[0],
											  n = new ArrayBuffer(t.length),
											  r = new Uint8Array(n),
											  i = 0;
											t.length > i;
											i++
										  )
											r[i] = t.charCodeAt(i);
										  return new Blob([n], { type: o });
										})(o);
									  (t.src = URL.createObjectURL(n)),
										e.e.fire("internalUpdate");
									  var r = e.buffer.get(u) || {};
									  (r[t.src] = o), e.buffer.set(u, r);
									}
								  })(e, t),
								e.e.on(t, "mousedown touchstart", function () {
								  e.s.select(t);
								}));
							}),
							[2])
						  : [2];
					  });
					});
				  }),
				  n.__decorate(
					[(0, a.watch)(":afterGetValueFromEditor")],
					t.prototype,
					"onAfterGetValueFromEditor",
					null,
				  ),
				  n.__decorate(
					[(0, a.watch)(":beforeSetElementValue")],
					t.prototype,
					"onBeforeSetElementValue",
					null,
				  ),
				  n.__decorate(
					[
					  (0, a.watch)([":change", ":afterInit", ":changePlace"]),
					  (0, a.debounce)(),
					],
					t.prototype,
					"afterChange",
					null,
				  ),
				  t
				);
			  })(i.Plugin);
			(t.imageProcessor = d), l.pluginSystem.add("imageProcessor", d);
		  },
		  1601: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.image = {
				dialogWidth: 600,
				openOnDblClick: !0,
				editSrc: !0,
				useImageEditor: !0,
				editTitle: !0,
				editAlt: !0,
				editLink: !0,
				editSize: !0,
				editBorderRadius: !0,
				editMargins: !0,
				editClass: !0,
				availableClasses: [],
				editStyle: !0,
				editId: !0,
				editAlign: !0,
				showPreview: !0,
				selectImageAfterClose: !0,
			  });
		  },
		  15747: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.imageProperties = void 0);
			var n = o(20255);
			o(9947);
			var r = o(87837),
			  i = o(40332),
			  a = o(718),
			  s = o(96516),
			  l = o(43441),
			  c = o(35503),
			  u = o(17332),
			  d = o(49391),
			  p = o(27506),
			  f = o(50109);
			o(1601);
			var h = function (e) {
				return (e = (0, i.trim)(e)), /^[0-9]+$/.test(e) ? e + "px" : e;
			  },
			  m = function (e) {
				return /^[-+]?[0-9.]+px$/.test(e.toString())
				  ? parseFloat(e.toString())
				  : e;
			  },
			  v = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.state = {
					  image: new Image(),
					  get ratio() {
						return (
						  this.image.naturalWidth / this.image.naturalHeight || 1
						);
					  },
					  sizeIsLocked: !0,
					  marginIsLocked: !0,
					}),
					(t.activeTabState = { __activeTab: "Image" }),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.onChangeMarginIsLocked = function () {
					var e = this;
					if (this.form) {
					  var t = (0, i.refs)(this.form),
						o = t.lockMargin;
					  [t.marginRight, t.marginBottom, t.marginLeft].forEach(
						function (t) {
						  (0, i.attr)(
							t,
							"disabled",
							e.state.marginIsLocked || null,
						  );
						},
					  ),
						(o.innerHTML = r.Icon.get(
						  this.state.marginIsLocked ? "lock" : "unlock",
						));
					}
				  }),
				  (t.prototype.onChangeSizeIsLocked = function () {
					if (this.form) {
					  var e = (0, i.refs)(this.form),
						t = e.lockSize,
						o = e.imageWidth;
					  (t.innerHTML = r.Icon.get(
						this.state.sizeIsLocked ? "lock" : "unlock",
					  )),
						t.classList.remove("jodit-properties__lock"),
						t.classList.remove("jodit-properties__unlock"),
						t.classList.add(
						  this.state.sizeIsLocked
							? "jodit-properties__lock"
							: "jodit-properties__unlock",
						),
						this.j.e.fire(o, "change");
					}
				  }),
				  (t.prototype.open = function () {
					return (
					  this.makeForm(),
					  (this.activeTabState.__activeTab = "Image"),
					  this.j.e.fire("hidePopup"),
					  (0, i.markOwner)(this.j, this.dialog.container),
					  (this.state.marginIsLocked = !0),
					  (this.state.sizeIsLocked = !0),
					  this.onChangeMarginIsLocked(),
					  this.onChangeSizeIsLocked(),
					  this.updateValues(),
					  this.dialog.open().setModal(!0).setPosition(),
					  !1
					);
				  }),
				  (t.prototype.makeForm = function () {
					var e = this;
					if (!this.dialog) {
					  this.dialog = this.j.dlg({
						minWidth: Math.min(400, screen.width),
						minHeight: 590,
						buttons: ["fullsize", "dialog.close"],
					  });
					  var t = this.j,
						o = t.o,
						n = t.i18n.bind(t),
						r = {
						  check: (0, s.Button)(t, "ok", "Apply", "primary"),
						  remove: (0, s.Button)(t, "bin", "Delete"),
						};
					  t.e.on(this.dialog, "afterClose", function () {
						e.state.image.parentNode &&
						  o.image.selectImageAfterClose &&
						  t.s.select(e.state.image);
					  }),
						r.remove.onAction(function () {
						  t.s.removeNode(e.state.image), e.dialog.close();
						});
					  var l = this.dialog;
					  l.setHeader(n("Image properties"));
					  var c = (0, d.form)(t);
					  (this.form = c), l.setContent(c);
					  var u = (0, i.refs)(this.form).tabsBox;
					  u &&
						u.appendChild(
						  (0, a.TabsWidget)(
							t,
							[
							  { name: "Image", content: (0, p.mainTab)(t) },
							  {
								name: "Advanced",
								content: (0, f.positionTab)(t),
							  },
							],
							this.activeTabState,
						  ),
						),
						r.check.onAction(this.onApply);
					  var h = (0, i.refs)(this.form),
						m = h.editImage;
					  t.e.on(h.changeImage, "click", this.openImagePopup),
						o.image.useImageEditor &&
						  t.e.on(m, "click", this.openImageEditor);
					  var v = (0, i.refs)(c),
						g = v.lockSize,
						y = v.lockMargin,
						_ = v.imageWidth,
						b = v.imageHeight;
					  g &&
						t.e.on(g, "click", function () {
						  e.state.sizeIsLocked = !e.state.sizeIsLocked;
						}),
						t.e.on(y, "click", function (t) {
						  (e.state.marginIsLocked = !e.state.marginIsLocked),
							t.preventDefault();
						});
					  var w = function (t) {
						if (
						  (0, i.isNumeric)(_.value) &&
						  (0, i.isNumeric)(b.value)
						) {
						  var o = parseFloat(_.value),
							n = parseFloat(b.value);
						  t.target === _
							? (b.value = Math.round(o / e.state.ratio).toString())
							: (_.value = Math.round(
								n * e.state.ratio,
							  ).toString());
						}
					  };
					  t.e.on(
						[_, b],
						"change keydown mousedown paste",
						function (o) {
						  e.state.sizeIsLocked &&
							t.async.setTimeout(w.bind(e, o), {
							  timeout: t.defaultTimeout,
							  label: "image-properties-changeSize",
							});
						},
					  ),
						l.setFooter([r.remove, r.check]),
						l.setSize(this.j.o.image.dialogWidth);
					}
				  }),
				  (t.prototype.updateValues = function () {
					var e,
					  t,
					  o = this,
					  n = this.j.o,
					  a = this.state.image,
					  s = (0, i.refs)(this.form),
					  l = s.marginTop,
					  c = s.marginRight,
					  u = s.marginBottom,
					  d = s.marginLeft,
					  p = s.imageSrc,
					  f = s.id,
					  h = s.classes,
					  v = s.align,
					  g = s.style,
					  y = s.imageTitle,
					  _ = s.imageAlt,
					  b = s.borderRadius,
					  w = s.imageLink,
					  S = s.imageWidth,
					  C = s.imageHeight,
					  j = s.imageLinkOpenInNewTab,
					  E = s.imageViewSrc,
					  x = s.lockSize;
					(s.lockMargin.checked = o.state.marginIsLocked),
					  (x.checked = o.state.sizeIsLocked),
					  (p.value = (0, i.attr)(a, "src") || ""),
					  E && (0, i.attr)(E, "src", (0, i.attr)(a, "src") || ""),
					  (function () {
						(y.value = (0, i.attr)(a, "title") || ""),
						  (_.value = (0, i.attr)(a, "alt") || "");
						var e = r.Dom.closest(a, "a", o.j.editor);
						e
						  ? ((w.value = (0, i.attr)(e, "href") || ""),
							(j.checked = "_blank" === (0, i.attr)(e, "target")))
						  : ((w.value = ""), (j.checked = !1));
					  })(),
					  (e =
						(0, i.attr)(a, "width") ||
						(0, i.css)(a, "width", !0) ||
						!1),
					  (t =
						(0, i.attr)(a, "height") ||
						(0, i.css)(a, "height", !0) ||
						!1),
					  (S.value =
						!1 !== e ? m(e).toString() : a.offsetWidth.toString()),
					  (C.value =
						!1 !== t ? m(t).toString() : a.offsetHeight.toString()),
					  (o.state.sizeIsLocked = (function () {
						if (
						  !(0, i.isNumeric)(S.value) ||
						  !(0, i.isNumeric)(C.value)
						)
						  return !1;
						var e = parseFloat(S.value),
						  t = parseFloat(C.value);
						return 1 > Math.abs(e - t * o.state.ratio);
					  })()),
					  (function () {
						if (n.image.editMargins) {
						  var e = !0,
							t = !1;
						  [l, c, u, d].forEach(function (o) {
							var n = (0, i.attr)(o, "data-ref") || "",
							  r = a.style.getPropertyValue((0, i.kebabCase)(n));
							if (!r) return (t = !0), void (o.value = "");
							/^[0-9]+(px)?$/.test(r) && (r = parseInt(r, 10)),
							  (o.value = r.toString() || ""),
							  ((t && o.value) ||
								(e &&
								  "marginTop" !== n &&
								  o.value !== l.value)) &&
								(e = !1);
						  }),
							(o.state.marginIsLocked = e);
						}
					  })(),
					  (h.value = ((0, i.attr)(a, "class") || "").replace(
						/jodit_focused_image[\s]*/,
						"",
					  )),
					  (f.value = (0, i.attr)(a, "id") || ""),
					  (b.value = (
						parseInt(a.style.borderRadius || "0", 10) || "0"
					  ).toString()),
					  a.style.cssFloat &&
					  -1 !==
						["left", "right"].indexOf(a.style.cssFloat.toLowerCase())
						? (v.value = (0, i.css)(a, "float"))
						: "block" === (0, i.css)(a, "display") &&
						  "auto" === a.style.marginLeft &&
						  "auto" === a.style.marginRight &&
						  (v.value = "center"),
					  (g.value = (0, i.attr)(a, "style") || "");
				  }),
				  (t.prototype.onApply = function () {
					var e = (0, i.refs)(this.form),
					  t = e.imageSrc,
					  o = e.borderRadius,
					  n = e.imageTitle,
					  a = e.imageAlt,
					  s = e.imageLink,
					  l = e.imageWidth,
					  c = e.imageHeight,
					  u = e.marginTop,
					  d = e.marginRight,
					  p = e.marginBottom,
					  f = e.marginLeft,
					  m = e.imageLinkOpenInNewTab,
					  v = e.align,
					  g = e.classes,
					  y = e.id,
					  _ = this.j.o,
					  b = this.state.image;
					if (
					  (_.image.editStyle &&
						(0, i.attr)(b, "style", e.style.value || null),
					  !t.value)
					)
					  return r.Dom.safeRemove(b), void this.dialog.close();
					(0, i.attr)(b, "src", t.value),
					  (b.style.borderRadius =
						"0" !== o.value && /^[0-9]+$/.test(o.value)
						  ? o.value + "px"
						  : ""),
					  (0, i.attr)(b, "title", n.value || null),
					  (0, i.attr)(b, "alt", a.value || null);
					var w = r.Dom.closest(b, "a", this.j.editor);
					if (
					  (s.value
						? (w || (w = r.Dom.wrap(b, "a", this.j.createInside)),
						  (0, i.attr)(w, "href", s.value),
						  (0, i.attr)(w, "target", m.checked ? "_blank" : null))
						: w && w.parentNode && w.parentNode.replaceChild(b, w),
					  l.value !== b.offsetWidth.toString() ||
						c.value !== b.offsetHeight.toString())
					) {
					  var S = (0, i.trim)(l.value) ? h(l.value) : null,
						C = (0, i.trim)(c.value) ? h(c.value) : null;
					  (0, i.css)(b, { width: S, height: C }),
						(0, i.attr)(
						  b,
						  "width",
						  (0, i.attr)(b, "width") ? S : null,
						),
						(0, i.attr)(
						  b,
						  "height",
						  (0, i.attr)(b, "height") ? C : null,
						);
					}
					var j = [u, d, p, f];
					_.image.editMargins &&
					  (this.state.marginIsLocked
						? (0, i.css)(b, "margin", h(u.value))
						: j.forEach(function (e) {
							var t = (0, i.attr)(e, "data-ref") || "";
							(0, i.css)(b, t, h(e.value));
						  })),
					  _.image.editClass &&
						(0, i.attr)(b, "class", g.value || null),
					  _.image.editId && (0, i.attr)(b, "id", y.value || null),
					  _.image.editAlign && (0, i.hAlignElement)(b, v.value),
					  this.j.synchronizeValues(),
					  this.dialog.close();
				  }),
				  (t.prototype.openImageEditor = function () {
					var e = this,
					  t = (0, i.attr)(this.state.image, "src") || "",
					  o = this.j.c.element("a"),
					  n = function () {
						o.host === location.host ||
						  e.j.confirm(
							"You can only edit your own images. Download this image on the host?",
							function (t) {
							  t &&
								e.j.uploader &&
								e.j.uploader.uploadRemoteImage(
								  o.href.toString(),
								  function (t) {
									e.j.alert(
									  "The image has been successfully uploaded to the host!",
									  function () {
										(0, i.isString)(t.newfilename) &&
										  ((0, i.attr)(
											e.state.image,
											"src",
											t.baseurl + t.newfilename,
										  ),
										  e.updateValues());
									  },
									);
								  },
								  function (t) {
									e.j.alert(
									  "There was an error loading %s",
									  t.message,
									);
								  },
								);
							},
						  );
					  };
					(o.href = t),
					  this.j.filebrowser.dataProvider
						.getPathByUrl(o.href.toString())
						.then(function (n) {
						  c.openImageEditor.call(
							e.j.filebrowser,
							o.href,
							n.name,
							n.path,
							n.source,
							function () {
							  var o = new Date().getTime();
							  (0, i.attr)(
								e.state.image,
								"src",
								t +
								  (-1 !== t.indexOf("?") ? "" : "?") +
								  "&_tmp=" +
								  o.toString(),
							  ),
								e.updateValues();
							},
							function (t) {
							  e.j.alert(t.message);
							},
						  );
						})
						.catch(function (t) {
						  e.j.alert(t.message, n);
						});
				  }),
				  (t.prototype.openImagePopup = function (e) {
					var t = this,
					  o = new r.Popup(this.j),
					  n = (0, i.refs)(this.form).changeImage;
					o.setZIndex(this.dialog.getZIndex() + 1),
					  o
						.setContent(
						  (0, a.FileSelectorWidget)(
							this.j,
							{
							  upload: function (e) {
								e.files &&
								  e.files.length &&
								  (0, i.attr)(
									t.state.image,
									"src",
									e.baseurl + e.files[0],
								  ),
								  t.updateValues(),
								  o.close();
							  },
							  filebrowser: function (e) {
								e &&
								  (0, i.isArray)(e.files) &&
								  e.files.length &&
								  ((0, i.attr)(t.state.image, "src", e.files[0]),
								  o.close(),
								  t.updateValues());
							  },
							},
							this.state.image,
							o.close,
						  ),
						)
						.open(function () {
						  return (0, i.position)(n);
						}),
					  e.stopPropagation();
				  }),
				  (t.prototype.afterInit = function (e) {
					var t = this,
					  o = this;
					e.e
					  .on("afterConstructor changePlace", function () {
						e.e
						  .off(e.editor, ".imageproperties")
						  .on(e.editor, "dblclick.imageproperties", function (n) {
							var i = n.target;
							if (r.Dom.isTag(i, "img"))
							  if (e.o.image.openOnDblClick) {
								if (!1 === t.j.e.fire("openOnDblClick", i))
								  return;
								(o.state.image = i),
								  e.o.readonly ||
									(n.stopImmediatePropagation(),
									n.preventDefault(),
									o.open());
							  } else n.stopImmediatePropagation(), e.s.select(i);
						  });
					  })
					  .on("openImageProperties.imageproperties", function (e) {
						(t.state.image = e), t.open();
					  });
				  }),
				  (t.prototype.beforeDestruct = function (e) {
					this.dialog && this.dialog.destruct(),
					  e.e
						.off(e.editor, ".imageproperties")
						.off(".imageproperties");
				  }),
				  n.__decorate(
					[(0, l.watch)("state.marginIsLocked")],
					t.prototype,
					"onChangeMarginIsLocked",
					null,
				  ),
				  n.__decorate(
					[(0, l.watch)("state.sizeIsLocked")],
					t.prototype,
					"onChangeSizeIsLocked",
					null,
				  ),
				  n.__decorate([l.autobind], t.prototype, "onApply", null),
				  n.__decorate(
					[l.autobind],
					t.prototype,
					"openImageEditor",
					null,
				  ),
				  n.__decorate([l.autobind], t.prototype, "openImagePopup", null),
				  t
				);
			  })(r.Plugin);
			(t.imageProperties = v), u.pluginSystem.add("imageProperties", v);
		  },
		  49391: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.form = void 0);
			var n = o(77904);
			t.form = function (e) {
			  var t = e.o.image,
				o = t.showPreview,
				r = t.editSize,
				i = n.Icon.get.bind(n.Icon);
			  return e.c.fromHTML(
				'<form class="jodit-properties">\n\t\t<div class="jodit-grid jodit-grid_xs-column">\n\t\t\t<div class="jodit_col-lg-2-5 jodit_col-xs-5-5">\n\t\t\t\t<div class="jodit-properties_view_box">\n\t\t\t\t\t<div style="'
				  .concat(
					o ? "" : "display:none",
					'" class="jodit-properties_image_view">\n\t\t\t\t\t\t<img data-ref="imageViewSrc" src="" alt=""/>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div style="',
				  )
				  .concat(
					r ? "" : "display:none",
					'" class="jodit-form__group jodit-properties_image_sizes">\n\t\t\t\t\t\t<input data-ref="imageWidth" type="text" class="jodit-input"/>\n\t\t\t\t\t\t<a data-ref="lockSize" class="jodit-properties__lock">',
				  )
				  .concat(
					i("lock"),
					'</a>\n\t\t\t\t\t\t<input data-ref="imageHeight" type="text" class="imageHeight jodit-input"/>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div data-ref="tabsBox" class="jodit_col-lg-3-5 jodit_col-xs-5-5"></div>\n\t\t</div>\n\t</form>',
				  ),
			  );
			};
		  },
		  27506: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.mainTab = void 0);
			var n = o(77904);
			t.mainTab = function (e) {
			  var t = e.o,
				o = e.i18n.bind(e),
				r = n.Icon.get.bind(n.Icon),
				i = t.filebrowser.ajax.url || t.uploader.url,
				a = t.image.useImageEditor;
			  return e.c.fromHTML(
				'<div style="'
				  .concat(
					t.image.editSrc ? "" : "display:none",
					'" class="jodit-form__group">\n\t\t\t<label>',
				  )
				  .concat(
					o("Src"),
					'</label>\n\t\t\t<div class="jodit-input_group">\n\t\t\t\t<input data-ref="imageSrc" class="jodit-input" type="text"/>\n\t\t\t\t<div\n\t\t\t\t\tclass="jodit-input_group-buttons"\n\t\t\t\t\tstyle="',
				  )
				  .concat(
					i ? "" : "display: none",
					'"\n\t\t\t\t>\n\t\t\t\t\t\t<a\n\t\t\t\t\t\t\tdata-ref="changeImage"\n\t\t\t\t\t\t\tclass="jodit-button"\n\t\t\t\t\t\t>',
				  )
				  .concat(
					r("image"),
					'</a>\n\t\t\t\t\t\t<a\n\t\t\t\t\t\t\tdata-ref="editImage"\n\t\t\t\t\t\t\tclass="jodit-button"\n\t\t\t\t\t\t\tstyle="',
				  )
				  .concat(a ? "" : "display: none", '"\n\t\t\t\t\t\t>')
				  .concat(
					r("crop"),
					'</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div style="',
				  )
				  .concat(
					t.image.editTitle ? "" : "display:none",
					'" class="jodit-form__group">\n\t\t\t<label>',
				  )
				  .concat(
					o("Title"),
					'</label>\n\t\t\t<input data-ref="imageTitle" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="',
				  )
				  .concat(
					t.image.editAlt ? "" : "display:none",
					'" class="jodit-form__group">\n\t\t\t<label>',
				  )
				  .concat(
					o("Alternative"),
					'</label>\n\t\t\t<input data-ref="imageAlt" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="',
				  )
				  .concat(
					t.image.editLink ? "" : "display:none",
					'" class="jodit-form__group">\n\t\t\t<label>',
				  )
				  .concat(
					o("Link"),
					'</label>\n\t\t\t<input data-ref="imageLink" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="',
				  )
				  .concat(
					t.image.editLink ? "" : "display:none",
					'" class="jodit-form__group">\n\t\t\t<label class="jodit_vertical_middle">\n\t\t\t\t<input data-ref="imageLinkOpenInNewTab" type="checkbox" class="jodit-checkbox"/>\n\t\t\t\t<span>',
				  )
				  .concat(
					o("Open link in new tab"),
					"</span>\n\t\t\t</label>\n\t\t</div>",
				  ),
			  );
			};
		  },
		  50109: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.positionTab = void 0);
			var n = o(77904);
			t.positionTab = function (e) {
			  var t = e.o,
				o = e.i18n.bind(e),
				r = n.Icon.get.bind(n.Icon),
				i = [];
			  return (
				t.image.availableClasses.length > 0
				  ? (i.push(
					  '<select data-ref="classes" class="jodit-input jodit-select">',
					),
					t.image.availableClasses.forEach(function (e) {
					  i.push(
						"string" == typeof e
						  ? '<option value="'
							  .concat(e, '">')
							  .concat(e, "</option>")
						  : '<option value="'
							  .concat(e[0], '">')
							  .concat(e[1], "</option>"),
					  );
					}),
					i.push("</select>"))
				  : i.push(
					  '<input data-ref="classes" type="text" class="jodit-input"/>',
					),
				e.c.fromHTML(
				  '<div style="'
					.concat(
					  t.image.editMargins ? "" : "display:none",
					  '" class="jodit-form__group">\n\t\t\t<label>',
					)
					.concat(
					  o("Margins"),
					  '</label>\n\t\t\t<div class="jodit-grid jodit_vertical_middle">\n\t\t\t\t<input class="jodit_col-lg-1-5 jodit-input" data-ref="marginTop" type="text" placeholder="',
					)
					.concat(
					  o("top"),
					  '"/>\n\t\t\t\t<a style="text-align: center;" data-ref="lockMargin" class="jodit-properties__lock jodit_col-lg-1-5">',
					)
					.concat(
					  r("lock"),
					  '</a>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginRight" type="text" placeholder="',
					)
					.concat(
					  o("right"),
					  '"/>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginBottom" type="text" placeholder="',
					)
					.concat(
					  o("bottom"),
					  '"/>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginLeft" type="text" placeholder="',
					)
					.concat(
					  o("left"),
					  '"/>\n\t\t\t</div>\n\t\t</div>\n\t\t<div\n\t\t\tstyle="',
					)
					.concat(
					  t.image.editAlign ? "" : "display:none",
					  '"\n\t\t\tclass="jodit-form__group"\n\t\t>\n\t\t\t<label>',
					)
					.concat(
					  o("Align"),
					  '</label>\n\t\t\t<select data-ref="align" class="jodit-select">\n\t\t\t\t<option value="">',
					)
					.concat(
					  o("--Not Set--"),
					  '</option>\n\t\t\t\t<option value="left">',
					)
					.concat(
					  o("Left"),
					  '</option>\n\t\t\t\t<option value="center">',
					)
					.concat(
					  o("Center"),
					  '</option>\n\t\t\t\t<option value="right">',
					)
					.concat(
					  o("Right"),
					  '</option>\n\t\t\t</select>\n\t\t</div>\n\t\t<div style="',
					)
					.concat(
					  t.image.editStyle ? "" : "display:none",
					  '" class="jodit-form__group">\n\t\t\t<label>',
					)
					.concat(
					  o("Styles"),
					  '</label>\n\t\t\t<input data-ref="style" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="',
					)
					.concat(
					  t.image.editClass ? "" : "display:none",
					  '" class="jodit-form__group">\n\t\t\t<label>',
					)
					.concat(o("Classes"), "</label>\n\t\t\t")
					.concat(i.join(""), '\n\t\t</div>\n\t\t<div style="')
					.concat(
					  t.image.editId ? "" : "display:none",
					  '" class="jodit-form__group">\n\t\t\t<label>Id</label>\n\t\t\t<input data-ref="id" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div\n\t\t\tstyle="',
					)
					.concat(
					  t.image.editBorderRadius ? "" : "display:none",
					  '"\n\t\t\tclass="jodit-form__group"\n\t\t>\n\t\t\t<label>',
					)
					.concat(
					  o("Border radius"),
					  '</label>\n\t\t\t\t<input data-ref="borderRadius" type="number" class="jodit-input"/>\n\t\t</div>',
					),
				)
			  );
			};
		  },
		  67547: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.image = void 0);
			var n = o(20255),
			  r = o(64968),
			  i = o(40332),
			  a = o(718),
			  s = o(93166),
			  l = o(17332);
			function c(e) {
			  e.registerButton({ name: "image", group: "media" });
			}
			o(77904).Icon.set("image", o(53477)),
			  (s.Config.prototype.controls.image = {
				popup: function (e, t, o, s) {
				  var l = null;
				  return (
					t &&
					  !r.Dom.isText(t) &&
					  r.Dom.isHTMLElement(t) &&
					  (r.Dom.isTag(t, "img") || (0, i.$$)("img", t).length) &&
					  (l = r.Dom.isTag(t, "img") ? t : (0, i.$$)("img", t)[0]),
					e.s.save(),
					(0, a.FileSelectorWidget)(
					  e,
					  {
						filebrowser: function (t) {
						  e.s.restore(),
							t.files &&
							  t.files.forEach(function (o) {
								return e.s.insertImage(
								  t.baseurl + o,
								  null,
								  e.o.imageDefaultWidth,
								);
							  }),
							s();
						},
						upload: !0,
						url: function (t, o) {
						  return n.__awaiter(void 0, void 0, void 0, function () {
							var r;
							return n.__generator(this, function (n) {
							  switch (n.label) {
								case 0:
								  return (
									e.s.restore(),
									/^[a-z\d_-]+(\.[a-z\d_-]+)+/i.test(t) &&
									  (t = "//" + t),
									(r =
									  l ||
									  e.createInside.element("img")).setAttribute(
									  "src",
									  t,
									),
									r.setAttribute("alt", o),
									l
									  ? [3, 2]
									  : [
										  4,
										  e.s.insertImage(
											r,
											null,
											e.o.imageDefaultWidth,
										  ),
										]
								  );
								case 1:
								  n.sent(), (n.label = 2);
								case 2:
								  return s(), [2];
							  }
							});
						  });
						},
					  },
					  l,
					  s,
					)
				  );
				},
				tags: ["img"],
				tooltip: "Insert Image",
			  }),
			  (t.image = c),
			  l.pluginSystem.add("image", c);
		  },
		  2916: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(64968),
			  i = o(77904),
			  a = o(26011);
			i.Icon.set("indent", o(90053)).set("outdent", o(72230)),
			  (n.Config.prototype.controls.indent = {
				tooltip: "Increase Indent",
			  }),
			  (n.Config.prototype.controls.outdent = {
				isDisabled: function (e) {
				  var t = e.s.current();
				  if (t) {
					var o = r.Dom.closest(t, r.Dom.isBlock, e.editor);
					if (o) {
					  var n = (0, a.getKey)(e.o.direction, o);
					  return !o.style[n] || 0 >= parseInt(o.style[n], 10);
					}
				  }
				  return !0;
				},
				tooltip: "Decrease Indent",
			  }),
			  (n.Config.prototype.indentMargin = 10);
		  },
		  26011: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.getKey = void 0);
			var n = o(24263);
			t.getKey = function (e, t) {
			  return ""
				.concat(n.Dom.isCell(t) ? "padding" : "margin")
				.concat("rtl" === e ? "Right" : "Left");
			};
		  },
		  71838: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.indent = void 0);
			var n = o(86893),
			  r = o(64968),
			  i = o(40332),
			  a = o(17332);
			o(2916);
			var s = o(26011);
			function l(e) {
			  e.registerButton({
				name: "indent",
				group: "indent",
			  }).registerButton({ name: "outdent", group: "indent" });
			  var t = function (t) {
				var o = [];
				return (
				  e.s.eachSelection(function (a) {
					e.s.save();
					var l = !!a && r.Dom.up(a, r.Dom.isBlock, e.editor),
					  c = e.o.enter;
					if (
					  (!l &&
						a &&
						(l = r.Dom.wrapInline(
						  a,
						  c !== n.BR ? c : n.PARAGRAPH,
						  e,
						)),
					  !l)
					)
					  return e.s.restore(), !1;
					var u = o.includes(l);
					if (l && !u) {
					  var d = (0, s.getKey)(e.o.direction, l);
					  o.push(l);
					  var p = l.style[d] ? parseInt(l.style[d], 10) : 0;
					  (l.style[d] =
						(p += e.o.indentMargin * ("outdent" === t ? -1 : 1)) > 0
						  ? p + "px"
						  : ""),
						(0, i.attr)(l, "style") || (0, i.attr)(l, "style", null);
					}
					e.s.restore();
				  }),
				  e.synchronizeValues(),
				  !1
				);
			  };
			  e.registerCommand("indent", {
				exec: t,
				hotkeys: ["ctrl+]", "cmd+]"],
			  }),
				e.registerCommand("outdent", {
				  exec: t,
				  hotkeys: ["ctrl+[", "cmd+["],
				});
			}
			(t.indent = l), a.pluginSystem.add("indent", l);
		  },
		  70022: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(55692),
			  o(66031),
			  o(91241),
			  o(87565),
			  o(60894),
			  o(90302),
			  o(92138),
			  o(88412),
			  o(79308),
			  o(19268),
			  o(30598),
			  o(33122),
			  o(10135),
			  o(66994),
			  o(54798),
			  o(12908),
			  o(65123),
			  o(83228),
			  o(43889),
			  o(93300),
			  o(67547),
			  o(92575),
			  o(15747),
			  o(71838),
			  o(54752),
			  o(54452),
			  o(46324),
			  o(27738),
			  o(61421),
			  o(27582),
			  o(76303),
			  o(19806),
			  o(52598),
			  o(19483),
			  o(15428),
			  o(47224),
			  o(83211),
			  o(88297),
			  o(72930),
			  o(51197),
			  o(2327),
			  o(47608),
			  o(90523),
			  o(69257),
			  o(14889),
			  o(95323),
			  o(37458),
			  o(71003),
			  o(86030),
			  o(17002),
			  o(1557),
			  o(82808),
			  o(48560),
			  o(32246),
			  o(45842),
			  o(23308),
			  o(19889),
			  o(20728),
			  o(96899),
			  o(18238);
		  },
		  35387: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(77904);
			(n.Config.prototype.toolbarInline = !0),
			  (n.Config.prototype.toolbarInlineForSelection = !1),
			  (n.Config.prototype.toolbarInlineDisableFor = []),
			  (n.Config.prototype.toolbarInlineDisabledButtons = ["source"]),
			  r.Icon.set("addcolumn", o(78321))
				.set("addrow", o(77654))
				.set("merge", o(43371))
				.set("th", o(52242))
				.set("splitg", o(44563))
				.set("splitv", o(53183))
				.set("th-list", o(18548)),
			  (n.Config.prototype.popup = {
				a: o(27487).Z,
				img: o(97425).default,
				cells: o(59500).Z,
				toolbar: o(55350).Z,
				jodit: o(66686).Z,
				iframe: o(66686).Z,
				"jodit-media": o(66686).Z,
				selection: [
				  "bold",
				  "underline",
				  "italic",
				  "ul",
				  "ol",
				  "\n",
				  "outdent",
				  "indent",
				  "fontsize",
				  "brush",
				  "cut",
				  "\n",
				  "paragraph",
				  "link",
				  "align",
				  "dots",
				],
			  });
		  },
		  27487: function (e, t, o) {
			"use strict";
			var n = o(76502);
			t.Z = [
			  {
				name: "eye",
				tooltip: "Open link",
				exec: function (e, t) {
				  var o = (0, n.attr)(t, "href");
				  t && o && e.ow.open(o);
				},
			  },
			  { name: "link", tooltip: "Edit link", icon: "pencil" },
			  "unlink",
			  "brush",
			  "file",
			];
		  },
		  59500: function (e, t, o) {
			"use strict";
			var n = o(10172),
			  r = o(26911),
			  i = o(718),
			  a = function (e) {
				return e.args && (0, n.isString)(e.args[0])
				  ? e.args[0].toLowerCase()
				  : "";
			  };
			t.Z = [
			//   {
			// 	name: "brush",
			// 	popup: function (e, t, o, a) {
			// 	  if ((0, n.isJoditObject)(e)) {
			// 		var s = e.getInstance("Table", e.o).getAllSelectedCells();
			// 		if (!s.length) return !1;
			// 		var l = function (t) {
			// 		  return (0, i.ColorPickerWidget)(
			// 			e,
			// 			function (o) {
			// 			  s.forEach(function (e) {
			// 				(0, r.css)(e, t, o);
			// 			  }),
			// 				e.lock(),
			// 				e.synchronizeValues(),
			// 				a(),
			// 				e.unlock();
			// 			},
			// 			(0, r.css)(s[0], t),
			// 		  );
			// 		};
			// 		return (0, i.TabsWidget)(e, [
			// 		  { name: "Background", content: l("background-color") },
			// 		  { name: "Text", content: l("color") },
			// 		  { name: "Border", content: l("border-color") },
			// 		]);
			// 	  }
			// 	},
			// 	tooltip: "Background",
			//   },
			  {
				name: "align",
				icon: "left",
				list: ["left", "center", "right"]
			  },
			  {
				name: "valign",
				list: ["Top", "Middle", "Bottom"],
				childTemplate: function (e, t, o) {
				  return o;
				},
				exec: function (e, t, o) {
				  var n = a(o.control);
				  e.getInstance("Table", e.o)
					.getAllSelectedCells()
					.forEach(function (e) {
					  (0, r.css)(e, "vertical-align", "normal" === n ? "" : n);
					});
				},
				tooltip: "Vertical align",
			  },
			  { name: "merge", command: "tablemerge", tooltip: "Merge" },
			  {
				name: "splitv",
				list: {
				  tablesplitv: "Split vertical",
				  tablesplitg: "Split horizontal",
				},
				tooltip: "Split",
			  },
			  "\n",
			  {
				name: "addcolumn",
				list: {
				  tableaddcolumnbefore: "Insert column before",
				  tableaddcolumnafter: "Insert column after",
				},
				exec: function (e, t, o) {
				  var r = o.control;
				  if ((0, n.isJoditObject)(e)) {
					var i = a(r);
					e.execCommand(i, !1, t);
				  }
				},
				tooltip: "Add column",
			  },
			  {
				name: "addrow",
				list: {
				  tableaddrowbefore: "Insert row above",
				  tableaddrowafter: "Insert row below",
				},
				exec: function (e, t, o) {
				  var r = o.control;
				  if ((0, n.isJoditObject)(e)) {
					var i = a(r);
					e.execCommand(i, !1, t);
				  }
				},
				tooltip: "Add row",
			  },
			  {
				name: "delete",
				icon: "bin",
				list: {
				  tablebin: "Delete table",
				  tablebinrow: "Delete row",
				  tablebincolumn: "Delete column",
				  tableempty: "Empty cell",
				},
				exec: function (e, t, o) {
				  var r = o.control;
				  if ((0, n.isJoditObject)(e)) {
					var i = a(r);
					e.execCommand(i, !1, t), e.e.fire("hidePopup");
				  }
				},
				tooltip: "Delete",
			  },
			];
		  },
		  66686: function (e, t, o) {
			"use strict";
			var n = o(97425);
			t.Z = [
			  {
				name: "bin",
				tooltip: "Delete",
				exec: function (e, t) {
				  t && e.s.removeNode(t);
				},
			  },
			  n.align,
			];
		  },
		  97425: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.align = void 0);
			var n = o(64968),
			  r = o(24421),
			  i = o(26911),
			  a = o(60303);
			(t.align = {
			  name: "left",
			  childTemplate: function (e, t, o) {
				return o;
			  },
			  list: ["Left", "Right", "Center", "Normal"],
			  exec: function (e, t, o) {
				var i = o.control;
				if (n.Dom.isTag(t, ["img", "jodit", "jodit-media"])) {
				  var s =
					i.args && (0, r.isString)(i.args[0])
					  ? i.args[0].toLowerCase()
					  : "";
				  if (!s) return !1;
				  (0, a.hAlignElement)(t, s),
					n.Dom.isTag(t, ["jodit", "jodit-media"]) &&
					  t.firstElementChild &&
					  (0, a.hAlignElement)(t.firstElementChild, s),
					e.synchronizeValues(),
					e.e.fire("recalcPositionPopup");
				}
			  },
			  tooltip: "Horizontal align",
			}),
			  (t.default = [
				{
				  name: "delete",
				  icon: "bin",
				  tooltip: "Delete",
				  exec: function (e, t) {
					t && e.s.removeNode(t);
				  },
				},
				// {
				//   name: "pencil",
				//   exec: function (e, t) {
				// 	"img" === t.tagName.toLowerCase() &&
				// 	  e.e.fire("openImageProperties", t);
				//   },
				//   tooltip: "Edit",
				// },
				// {
				//   name: "valign",
				//   list: ["Top", "Middle", "Bottom", "Normal"],
				//   tooltip: "Vertical align",
				//   exec: function (e, t, o) {
				// 	var a = o.control;
				// 	if (n.Dom.isTag(t, "img")) {
				// 	  var s =
				// 		a.args && (0, r.isString)(a.args[0])
				// 		  ? a.args[0].toLowerCase()
				// 		  : "";
				// 	  if (!s) return !1;
				// 	  (0, i.css)(t, "vertical-align", "normal" === s ? "" : s),
				// 		e.e.fire("recalcPositionPopup");
				// 	}
				//   },
				// },
				// t.align,
			  ]);
		  },
		  55350: function (e, t) {
			"use strict";
			t.Z = [
			  "bold",
			  "italic",
			  "|",
			  "ul",
			  "ol",
			  "eraser",
			  "|",
			  "fontsize",
			  "brush",
			  "paragraph",
			  "---",
			  "image",
			  "table",
			  "\n",
			  "link",
			  "|",
			  "align",
			  "|",
			  "undo",
			  "redo",
			  "|",
			  "copyformat",
			  "fullsize",
			  "---",
			  "dots",
			];
		  },
		  54752: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.inlinePopup = void 0);
			var n = o(20255);
			o(45109);
			var r = o(57549),
			  i = o(81438),
			  a = o(35799),
			  s = o(40332),
			  l = o(64968),
			  c = o(2074),
			  u = o(43441),
			  d = o(17332);
			o(35387);
			var p = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.requires = ["select"]),
				  (t.type = null),
				  (t.popup = new a.Popup(t.jodit, !1)),
				  (t.toolbar = (0, i.makeCollection)(t.jodit, t.popup)),
				  (t.snapRange = null),
				  (t.elmsList = (0, s.keys)(t.j.o.popup, !1).filter(function (e) {
					return !t.isExcludedTarget(e);
				  })),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.onClick = function (e) {
				  var t = this,
					o = this.elmsList,
					n = l.Dom.isTag(e, "img")
					  ? e
					  : l.Dom.closest(e, o, this.j.editor);
				  if (n && this.canShowPopupForType(n.nodeName.toLowerCase()))
					return (
					  this.showPopup(
						function () {
						  return (0, s.position)(n, t.j);
						},
						n.nodeName.toLowerCase(),
						n,
					  ),
					  !1
					);
				}),
				(t.prototype.showPopup = function (e, t, o) {
				  if (((t = t.toLowerCase()), !this.canShowPopupForType(t)))
					return !1;
				  if (this.type !== t || o !== this.previousTarget) {
					this.previousTarget = o;
					var n = this.j.o.popup[t],
					  r = void 0;
					(r = (0, s.isFunction)(n)
					  ? n(this.j, o, this.popup.close)
					  : n),
					  (0, s.isArray)(r) &&
						(this.toolbar.build(r, o),
						(this.toolbar.buttonSize = this.j.o.toolbarButtonSize),
						(r = this.toolbar.container)),
					  this.popup.setContent(r),
					  (this.type = t);
				  }
				  return this.popup.open(e), !0;
				}),
				(t.prototype.hidePopup = function (e) {
				  ((0, s.isString)(e) && e !== this.type) || this.popup.close();
				}),
				(t.prototype.onOutsideClick = function () {
				  this.popup.close();
				}),
				(t.prototype.canShowPopupForType = function (e) {
				  var t = this.j.o.popup[e.toLowerCase()];
				  return !(
					this.j.o.readonly ||
					!this.j.o.toolbarInline ||
					!t ||
					this.isExcludedTarget(e)
				  );
				}),
				(t.prototype.isExcludedTarget = function (e) {
				  return (0, s.splitArray)(this.j.o.toolbarInlineDisableFor)
					.map(function (e) {
					  return e.toLowerCase();
					})
					.includes(e.toLowerCase());
				}),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  this.j.e
					.on("getDiffButtons.mobile", function (o) {
					  if (t.toolbar === o) {
						var n = t.toolbar.getButtonsNames();
						return (0, s.toArray)(e.registeredButtons)
						  .filter(function (e) {
							return !t.j.o.toolbarInlineDisabledButtons.includes(
							  e.name,
							);
						  })
						  .filter(function (e) {
							var t = (0, s.isString)(e) ? e : e.name;
							return t && "|" !== t && "\n" !== t && !n.includes(t);
						  });
					  }
					})
					.on("hidePopup", this.hidePopup)
					.on("showInlineToolbar", this.showInlineToolbar)
					.on("showPopup", function (e, o, n) {
					  t.showPopup(
						o,
						n || ((0, s.isString)(e) ? e : e.nodeName),
						(0, s.isString)(e) ? void 0 : e,
					  );
					})
					.on("mousedown keydown", this.onSelectionStart)
					.on("change", function () {
					  t.popup.isOpened &&
						t.previousTarget &&
						!t.previousTarget.parentNode &&
						(t.hidePopup(), (t.previousTarget = void 0));
					})
					.on(
					  [this.j.ew, this.j.ow],
					  "mouseup keyup",
					  this.onSelectionEnd,
					),
					this.addListenersForElements();
				}),
				(t.prototype.onSelectionStart = function () {
				  this.snapRange = this.j.s.range.cloneRange();
				}),
				(t.prototype.onSelectionEnd = function (e) {
				  if (
					!(
					  e &&
					  e.target &&
					  c.UIElement.closestElement(e.target, a.Popup)
					)
				  ) {
					var t = this.snapRange,
					  o = this.j.s.range;
					(t &&
					  !o.collapsed &&
					  o.startContainer === t.startContainer &&
					  o.startOffset === t.startOffset &&
					  o.endContainer === t.endContainer &&
					  o.endOffset === t.endOffset) ||
					  this.onSelectionChange();
				  }
				}),
				(t.prototype.onSelectionChange = function () {
				  if (this.j.o.toolbarInlineForSelection) {
					var e = "selection",
					  t = this.j.s.sel,
					  o = this.j.s.range;
					(null == t ? void 0 : t.isCollapsed) ||
					this.isSelectedTarget(o) ||
					this.tableModule.getAllSelectedCells().length
					  ? this.type === e && this.popup.isOpened && this.hidePopup()
					  : this.j.s.current() &&
						this.showPopup(function () {
						  return o.getBoundingClientRect();
						}, e);
				  }
				}),
				(t.prototype.isSelectedTarget = function (e) {
				  var t = e.startContainer;
				  return (
					l.Dom.isElement(t) &&
					t === e.endContainer &&
					l.Dom.isTag(
					  t.childNodes[e.startOffset],
					  (0, s.keys)(this.j.o.popup, !1),
					) &&
					e.startOffset === e.endOffset - 1
				  );
				}),
				Object.defineProperty(t.prototype, "tableModule", {
				  get: function () {
					return this.j.getInstance("Table", this.j.o);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e
					.off("showPopup")
					.off(
					  [this.j.ew, this.j.ow],
					  "mouseup keyup",
					  this.onSelectionEnd,
					),
					this.removeListenersForElements();
				}),
				(t.prototype._eventsList = function () {
				  var e = this.elmsList;
				  return e
					.map(function (e) {
					  return (0, s.camelCase)("click_".concat(e));
					})
					.concat(
					  e.map(function (e) {
						return (0, s.camelCase)("touchstart_".concat(e));
					  }),
					)
					.join(" ");
				}),
				(t.prototype.addListenersForElements = function () {
				  this.j.e.on(this._eventsList(), this.onClick);
				}),
				(t.prototype.removeListenersForElements = function () {
				  this.j.e.off(this._eventsList(), this.onClick);
				}),
				(t.prototype.showInlineToolbar = function (e) {
				  var t = this;
				  this.showPopup(function () {
					return e || t.j.s.range.getBoundingClientRect();
				  }, "toolbar");
				}),
				n.__decorate([u.autobind], t.prototype, "onClick", null),
				n.__decorate(
				  [
					(0, u.wait)(function (e) {
					  return !e.j.isLocked;
					}),
				  ],
				  t.prototype,
				  "showPopup",
				  null,
				),
				n.__decorate(
				  [(0, u.watch)(":clickEditor"), u.autobind],
				  t.prototype,
				  "hidePopup",
				  null,
				),
				n.__decorate(
				  [(0, u.watch)(":outsideClick")],
				  t.prototype,
				  "onOutsideClick",
				  null,
				),
				n.__decorate([u.autobind], t.prototype, "onSelectionStart", null),
				n.__decorate([u.autobind], t.prototype, "onSelectionEnd", null),
				n.__decorate(
				  [
					(0, u.debounce)(function (e) {
					  return e.defaultTimeout;
					}),
				  ],
				  t.prototype,
				  "onSelectionChange",
				  null,
				),
				n.__decorate(
				  [u.autobind],
				  t.prototype,
				  "showInlineToolbar",
				  null,
				),
				t
			  );
			})(r.Plugin);
			(t.inlinePopup = p), d.pluginSystem.add("inlinePopup", p);
		  },
		  54452: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.justify = void 0);
			var n = o(93166),
			  r = o(24263),
			  i = o(26911),
			  a = o(60303),
			  s = o(17332);
			function l(e) {
			  e.registerButton({ name: "align", group: "indent" });
			  var t = function (t) {
				return (
				  e.s.focus(),
				  e.s.eachSelection(function (o) {
					if (o) {
					  var n = r.Dom.up(o, r.Dom.isBlock, e.editor);
					  n || (n = r.Dom.wrapInline(o, e.o.enterBlock, e)),
						(0, a.alignElement)(t, n);
					}
				  }),
				  !1
				);
			  };
			  e.registerCommand("justifyfull", t),
				e.registerCommand("justifyright", t),
				e.registerCommand("justifyleft", t),
				e.registerCommand("justifycenter", t);
			}
			o(77904).Icon.set("justify", o(87498)),
			  (n.Config.prototype.controls.align = {
				name: "left",
				tooltip: "Align",
				update: function (e, t) {
				  var o = e.control,
					n = t.s.current();
				  if (n) {
					var a = r.Dom.closest(n, r.Dom.isBlock, t.editor) || t.editor,
					  s = (0, i.css)(a, "text-align").toString();
					o.defaultValue &&
					  -1 !== o.defaultValue.indexOf(s) &&
					  (s = "left"),
					  o.data &&
						o.data.currentValue !== s &&
						o.list &&
						-1 !== o.list.indexOf(s) &&
						(t.o.textIcons
						  ? (e.state.text = s)
						  : (e.state.icon.name = s),
						(o.data.currentValue = s));
				  }
				},
				isActive: function (e, t) {
				  var o = e.s.current();
				  if (o && t.defaultValue) {
					var n = r.Dom.closest(o, r.Dom.isBlock, e.editor) || e.editor;
					return (
					  -1 ===
					  t.defaultValue.indexOf(
						(0, i.css)(n, "text-align").toString(),
					  )
					);
				  }
				  return !1;
				},
				defaultValue: ["left", "start", "inherit"],
				data: { currentValue: "left" },
				list: ["center", "left", "right", "justify"],
			  }),
			  (n.Config.prototype.controls.center = {
				command: "justifyCenter",
				css: { "text-align": "center" },
				tooltip: "Align Center",
			  }),
			  (n.Config.prototype.controls.justify = {
				command: "justifyFull",
				css: { "text-align": "justify" },
				tooltip: "Align Justify",
			  }),
			  (n.Config.prototype.controls.left = {
				command: "justifyLeft",
				css: { "text-align": "left" },
				tooltip: "Align Left",
			  }),
			  (n.Config.prototype.controls.right = {
				command: "justifyRight",
				css: { "text-align": "right" },
				tooltip: "Align Right",
			  }),
			  (t.justify = l),
			  s.pluginSystem.add("justify", l);
		  },
		  46324: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.keyArrowOutside = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(43441),
			  a = o(86893),
			  s = o(24263),
			  l = o(17332),
			  c = (function (e) {
				function t() {
				  return (null !== e && e.apply(this, arguments)) || this;
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.afterInit = function (e) {}),
				  (t.prototype.beforeDestruct = function (e) {}),
				  (t.prototype.onKeyDownArrow = function (e) {
					var t;
					if (e.key === a.KEY_RIGHT && this.j.selection.isCollapsed()) {
					  var o = this.j.selection.range,
						n = o.endContainer,
						r = o.endOffset;
					  if (
						s.Dom.isText(n) &&
						(null === (t = n.nodeValue) || void 0 === t
						  ? void 0
						  : t.length) === r
					  ) {
						var i = n.parentNode;
						s.Dom.isInlineBlock(i) &&
						  !s.Dom.findNotEmptyNeighbor(i, !1, this.j.editor) &&
						  s.Dom.after(i, this.j.createInside.text(a.NBSP_SPACE));
					  }
					}
				  }),
				  n.__decorate(
					[(0, i.watch)(":keydown")],
					t.prototype,
					"onKeyDownArrow",
					null,
				  ),
				  t
				);
			  })(r.Plugin);
			(t.keyArrowOutside = c), l.pluginSystem.add("keyArrowOutside", c);
		  },
		  19250: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.limitWords = !1),
			  (n.Config.prototype.limitChars = !1),
			  (n.Config.prototype.limitHTML = !1);
		  },
		  27738: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.limit = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(86893),
			  a = o(43441),
			  s = o(17332);
			o(19250);
			var l = (function (e) {
			  function t() {
				return (null !== e && e.apply(this, arguments)) || this;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this,
					o = e.o;
				  if (e && (o.limitWords || o.limitChars)) {
					var n = null;
					e.e
					  .off(".limit")
					  .on("beforePaste.limit", function () {
						n = e.history.snapshot.make();
					  })
					  .on(
						"keydown.limit keyup.limit beforeEnter.limit",
						this.checkPreventKeyPressOrPaste,
					  )
					  .on("change.limit", this.checkPreventChanging)
					  .on("afterPaste.limit", function () {
						if (t.__shouldDenyInput(!0) && n)
						  return (
							e.history.snapshot.restore(n),
							e.e.fire("denyPaste.limit"),
							!1
						  );
					  });
				  }
				}),
				(t.prototype.shouldPreventInsertHTML = function (e) {
				  return (
					(!e ||
					  !(
						i.COMMAND_KEYS.includes(e.key) ||
						e.ctrlKey ||
						e.metaKey
					  )) &&
					this.__shouldDenyInput(!1)
				  );
				}),
				(t.prototype.__shouldDenyInput = function (e) {
				  var t = this.jodit,
					o = t.o,
					n = o.limitWords,
					r = o.limitChars,
					i = this.__splitWords(t.o.limitHTML ? t.value : t.text);
				  if (n && c(i.length, n, e))
					return t.e.fire("denyWords.limit limit.limit"), !0;
				  var a = Boolean(r && c(i.join("").length, r, e));
				  return a && t.e.fire("denyChars.limit limit.limit"), a;
				}),
				(t.prototype.checkPreventKeyPressOrPaste = function (e) {
				  if (this.shouldPreventInsertHTML(e)) return !1;
				}),
				(t.prototype.checkPreventChanging = function (e, t) {
				  var o = this.jodit;
				  this.__shouldDenyInput(!0) && (o.value = t);
				}),
				(t.prototype.__splitWords = function (e) {
				  return e
					.replace((0, i.INVISIBLE_SPACE_REG_EXP)(), "")
					.split((0, i.SPACE_REG_EXP)())
					.filter(function (e) {
					  return e.length;
					});
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e.off(".limit");
				}),
				n.__decorate(
				  [a.autobind],
				  t.prototype,
				  "checkPreventKeyPressOrPaste",
				  null,
				),
				n.__decorate(
				  [a.autobind],
				  t.prototype,
				  "checkPreventChanging",
				  null,
				),
				t
			  );
			})(r.Plugin);
			function c(e, t, o) {
			  return o ? e > t : e >= t;
			}
			(t.limit = l), s.pluginSystem.add("limit", l);
		  },
		  29490: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(40332),
			  i = o(77904);
			(n.Config.prototype.defaultLineHeight = null),
			  i.Icon.set("line-height", o(7986)),
			  (n.Config.prototype.controls.lineHeight = {
				command: "applyLineHeight",
				tags: ["ol"],
				tooltip: "Line height",
				list: [1, 1.1, 1.2, 1.3, 1.4, 1.5, 2],
				exec: function (e, t, o) {
				  return (0, r.memorizeExec)(
					e,
					t,
					{ control: o.control },
					function (e) {
					  return e;
					},
				  );
				},
			  });
		  },
		  26752: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.zh_tw =
				t.zh_cn =
				t.tr =
				t.ru =
				t.pt_br =
				t.pl =
				t.nl =
				t.mn =
				t.ko =
				t.ja =
				t.it =
				t.id =
				t.hu =
				t.he =
				t.fr =
				t.fa =
				t.es =
				t.de =
				t.cs_cz =
				t.ar =
				  void 0);
			var n = o(47762);
			t.ar = n;
			var r = o(97495);
			t.cs_cz = r;
			var i = o(80131);
			t.de = i;
			var a = o(1201);
			t.es = a;
			var s = o(89912);
			t.fa = s;
			var l = o(3405);
			t.fr = l;
			var c = o(14129);
			t.he = c;
			var u = o(93729);
			t.hu = u;
			var d = o(16106);
			t.id = d;
			var p = o(89690);
			t.it = p;
			var f = o(33216);
			t.ja = f;
			var h = o(17282);
			t.ko = h;
			var m = o(52841);
			t.mn = m;
			var v = o(91761);
			t.nl = v;
			var g = o(61675);
			t.pl = g;
			var y = o(69709);
			t.pt_br = y;
			var _ = o(82591);
			t.ru = _;
			var b = o(87649);
			t.tr = b;
			var w = o(60268);
			t.zh_cn = w;
			var S = o(58214);
			t.zh_tw = S;
		  },
		  61421: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.lineHeight = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(40332),
			  a = o(43441),
			  s = o(24263),
			  l = o(17332);
			o(29490);
			var c = (function (e) {
			  function t(t) {
				var n = e.call(this, t) || this;
				return (
				  (n.buttons = [{ name: "lineHeight", group: "font" }]),
				  (0, l.extendLang)(o(26752)),
				  n
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  (0, i.css)(e.editor, { lineHeight: e.o.defaultLineHeight }),
					e.registerCommand("applyLineHeight", this.applyLineHeight);
				}),
				(t.prototype.applyLineHeight = function (e, t, o) {
				  var n,
					r = this.j,
					a = r.s,
					l = r.createInside,
					c = r.editor,
					u = r.o;
				  a.isFocused() || a.focus(), a.save();
				  var d = function (e) {
					var t = s.Dom.closest(e, s.Dom.isBlock, c);
					t || (t = s.Dom.wrap(e, u.enter, l));
					var r = (0, i.css)(t, "lineHeight");
					void 0 === n && (n = r.toString() !== o.toString()),
					  (0, i.css)(t, "lineHeight", n ? o : null);
				  };
				  try {
					if (a.isCollapsed()) {
					  var p = l.fake();
					  a.insertNode(p, !1, !1), d(p), s.Dom.safeRemove(p);
					} else a.eachSelection(d);
				  } finally {
					a.restore();
				  }
				}),
				(t.prototype.beforeDestruct = function (e) {
				  (0, i.css)(e.editor, { lineHeight: null });
				}),
				n.__decorate([a.autobind], t.prototype, "applyLineHeight", null),
				t
			  );
			})(r.Plugin);
			(t.lineHeight = c), l.pluginSystem.add("lineHeight", c);
		  },
		  56367: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(54238),
			  i = o(24263),
			  a = o(77904);
			(n.Config.prototype.link = {
			  formTemplate: r.formTemplate,
			  followOnDblClick: !1,
			  processVideoLink: !0,
			  processPastedLink: !0,
			  noFollowCheckbox: !0,
			  openInNewTabCheckbox: !0,
			  modeClassName: "input",
			  selectMultipleClassName: !0,
			  selectSizeClassName: 3,
			  selectOptionsClassName: [],
			  hotkeys: ["ctrl+k", "cmd+k"],
			}),
			  a.Icon.set("link", o(23075)).set("unlink", o(10655)),
			  (n.Config.prototype.controls.unlink = {
				exec: function (e, t) {
				  var o = i.Dom.closest(t, "a", e.editor);
				  o && i.Dom.unwrap(o),
					e.synchronizeValues(),
					e.e.fire("hidePopup");
				},
				tooltip: "Unlink",
			  }),
			  (n.Config.prototype.controls.link = {
				isActive: function (e) {
				  var t = e.s.current();
				  return Boolean(t && i.Dom.closest(t, "a", e.editor));
				},
				popup: function (e, t, o, n) {
				  return e.e.fire("generateLinkForm.link", t, n);
				},
				tags: ["a"],
				tooltip: "Insert link",
			  });
		  },
		  27582: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.link = void 0);
			var n = o(20255),
			  r = o(64968),
			  i = o(40332),
			  a = o(57549),
			  s = o(43441),
			  l = o(17332);
			o(56367);
			var c = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (t.buttons = [{ name: "link", group: "insert" }]), t;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  e.o.link.followOnDblClick &&
					e.e.on("dblclick.link", this.onDblClickOnLink),
					e.o.link.processPastedLink &&
					  e.e.on("processPaste.link", this.onProcessPasteLink),
					e.e.on("generateLinkForm.link", this.__generateForm),
					e.registerCommand("openLinkDialog", {
					  exec: function () {
						var o = e.dlg({ resizable: !1 }),
						  n = t.__generateForm(e.s.current(), function () {
							o.close();
						  });
						n.container.classList.add("jodit-dialog_alert"),
						  o.setContent(n),
						  o.open(),
						  e.async.requestIdleCallback(function () {
							var e = (0, i.refs)(n.container).url_input;
							null == e || e.focus();
						  });
					  },
					  hotkeys: e.o.link.hotkeys,
					});
				}),
				(t.prototype.onDblClickOnLink = function (e) {
				  if (r.Dom.isTag(e.target, "a")) {
					var t = (0, i.attr)(e.target, "href");
					t && ((location.href = t), e.preventDefault());
				  }
				}),
				(t.prototype.onProcessPasteLink = function (e, t) {
				  var o = this.jodit;
				  if ((0, i.isURL)(t) && o.o.link.processPastedLink) {
					if (
					  (o.e.stopPropagation("processPaste"),
					  o.o.link.processVideoLink)
					) {
					  var n = (0, i.convertMediaUrlToVideoEmbed)(t);
					  if (n !== t) return o.createInside.fromHTML(n);
					}
					if (o.s.isCollapsed()) {
					  var r = o.createInside.element("a");
					  return (
						r.setAttribute("href", t),
						(r.textContent = t),
						o.e.fire("applyLink", o, r, null),
						r
					  );
					}
					return (
					  o.s.applyStyle(void 0, {
						element: "a",
						attributes: { href: t },
					  }),
					  !0
					);
				  }
				}),
				(t.prototype.__generateForm = function (e, t) {
				  var o,
					n = this.jodit,
					a = n.i18n.bind(n),
					s = n.o.link,
					l = s.openInNewTabCheckbox,
					c = s.noFollowCheckbox,
					u = s.formClassName,
					d = s.modeClassName,
					p = (0, s.formTemplate)(n),
					f = (0, i.isString)(p)
					  ? n.c.fromHTML(p, {
						  target_checkbox_box: l,
						  nofollow_checkbox_box: c,
						})
					  : p,
					h = r.Dom.isElement(f) ? f : f.container,
					m = (0, i.refs)(h),
					v = m.insert,
					g = m.unlink,
					y = m.content_input_box,
					_ = m.target_checkbox,
					b = m.nofollow_checkbox,
					w = m.url_input,
					S = r.Dom.isImage(e),
					C = m.content_input,
					j = m.className_input,
					E = m.className_select;
				  C ||
					(C = n.c.element("input", {
					  type: "hidden",
					  ref: "content_input",
					})),
					u && h.classList.add(u),
					S && r.Dom.hide(y);
				  var x = function () {
					return o
					  ? o.innerText
					  : (0, i.stripTags)(n.s.range.cloneContents(), n.ed);
				  };
				  if (
					((o =
					  !(!e || !r.Dom.closest(e, "a", n.editor)) &&
					  r.Dom.closest(e, "a", n.editor)),
					!S && e && (C.value = x()),
					o)
				  ) {
					if (((w.value = (0, i.attr)(o, "href") || ""), d))
					  switch (d) {
						case "input":
						  j && (j.value = (0, i.attr)(o, "class") || "");
						  break;
						case "select":
						  if (E) {
							for (var k = 0; E.selectedOptions.length > k; k++) {
							  var T = E.options.item(k);
							  T && (T.selected = !1);
							}
							((0, i.attr)(o, "class") || "")
							  .split(" ")
							  .forEach(function (e) {
								if (e)
								  for (var t = 0; E.options.length > t; t++) {
									var o = E.options.item(t);
									(null == o ? void 0 : o.value) &&
									  o.value === e &&
									  (o.selected = !0);
								  }
							  });
						  }
					  }
					l && _ && (_.checked = "_blank" === (0, i.attr)(o, "target")),
					  c &&
						b &&
						(b.checked = "nofollow" === (0, i.attr)(o, "rel")),
					  (v.textContent = a("Update"));
				  } else r.Dom.hide(g);
				  n.editor.normalize();
				  var I = n.history.snapshot.make();
				  g &&
					n.e.on(g, "click", function (e) {
					  n.s.restore(),
						n.history.snapshot.restore(I),
						o && r.Dom.unwrap(o),
						n.synchronizeValues(),
						t(),
						e.preventDefault();
					});
				  var P = function () {
					if (!w.value.trim().length)
					  return w.focus(), w.classList.add("jodit_error"), !1;
					var e;
					n.s.restore(),
					  n.s.removeMarkers(),
					  n.editor.normalize(),
					  n.history.snapshot.restore(I);
					var a = x() !== C.value.trim(),
					  s = n.createInside;
					if (o) e = [o];
					else {
					  if (n.s.isCollapsed()) {
						var u = s.element("a");
						n.s.insertNode(u, !1, !1), (e = [u]);
					  } else {
						var p = n.s.current();
						e = r.Dom.isTag(p, ["img"])
						  ? [r.Dom.wrap(p, "a", s)]
						  : n.s.wrapInTag("a");
					  }
					  e.forEach(function (e) {
						return n.s.select(e);
					  });
					}
					return (
					  e.forEach(function (e) {
						var t;
						if (
						  ((0, i.attr)(e, "href", w.value),
						  d && (null != j ? j : E))
						)
						  if ("input" === d)
							"" === j.value &&
							  e.hasAttribute("class") &&
							  (0, i.attr)(e, "class", null),
							  "" !== j.value && (0, i.attr)(e, "class", j.value);
						  else if ("select" === d) {
							e.hasAttribute("class") &&
							  (0, i.attr)(e, "class", null);
							for (var o = 0; E.selectedOptions.length > o; o++) {
							  var r =
								null === (t = E.selectedOptions.item(o)) ||
								void 0 === t
								  ? void 0
								  : t.value;
							  r && e.classList.add(r);
							}
						  }
						if (!S) {
						  var s = e.textContent;
						  C.value.trim().length
							? a && (s = C.value)
							: (s = w.value),
							s !== e.textContent && (e.textContent = s);
						}
						l &&
						  _ &&
						  (0, i.attr)(e, "target", _.checked ? "_blank" : null),
						  c &&
							b &&
							(0, i.attr)(e, "rel", b.checked ? "nofollow" : null),
						  n.e.fire("applyLink", n, e, f);
					  }),
					  n.synchronizeValues(),
					  t(),
					  !1
					);
				  };
				  return (
					r.Dom.isElement(f)
					  ? n.e.on(f, "submit", function (e) {
						  return (
							e.preventDefault(),
							e.stopImmediatePropagation(),
							P(),
							!1
						  );
						})
					  : f.onSubmit(P),
					f
				  );
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e
					.off("generateLinkForm.link", this.__generateForm)
					.off("dblclick.link", this.onDblClickOnLink)
					.off("processPaste.link", this.onProcessPasteLink);
				}),
				n.__decorate([s.autobind], t.prototype, "onDblClickOnLink", null),
				n.__decorate(
				  [s.autobind],
				  t.prototype,
				  "onProcessPasteLink",
				  null,
				),
				n.__decorate([s.autobind], t.prototype, "__generateForm", null),
				t
			  );
			})(a.Plugin);
			(t.link = c), l.pluginSystem.add("link", c);
		  },
		  54238: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.formTemplate = void 0);
			var n = o(95963),
			  r = o(96516);
			t.formTemplate = function (e) {
			  var t = e.o.link,
				o = t.openInNewTabCheckbox,
				i = t.noFollowCheckbox,
				a = t.modeClassName,
				s = t.selectSizeClassName,
				l = t.selectMultipleClassName,
				c = t.selectOptionsClassName;
			  return new n.UIForm(e, [
				new n.UIBlock(e, [
				  new n.UIInput(e, {
					name: "url",
					type: "text",
					ref: "url_input",
					label: "URL",
					placeholder: "http://",
					required: !0,
				  }),
				]),
				new n.UIBlock(
				  e,
				  [
					new n.UIInput(e, {
					  name: "content",
					  ref: "content_input",
					  label: "Text",
					}),
				  ],
				  { ref: "content_input_box" },
				),
				a
				  ? new n.UIBlock(e, [
					  "input" === a
						? new n.UIInput(e, {
							name: "className",
							ref: "className_input",
							label: "Class name",
						  })
						: "select" === a
						  ? new n.UISelect(e, {
							  name: "className",
							  ref: "className_select",
							  label: "Class name",
							  size: s,
							  multiple: l,
							  options: c,
							})
						  : null,
					])
				  : null,
				o
				  ? new n.UICheckbox(e, {
					  name: "target",
					  ref: "target_checkbox",
					  label: "Open in new tab",
					})
				  : null,
				i
				  ? new n.UICheckbox(e, {
					  name: "nofollow",
					  ref: "nofollow_checkbox",
					  label: "No follow",
					})
				  : null,
				new n.UIBlock(
				  e,
				  [
					new r.UIButton(e, {
					  name: "unlink",
					  variant: "default",
					  text: "Unlink",
					}),
					new r.UIButton(e, {
					  name: "insert",
					  type: "submit",
					  variant: "primary",
					  text: "Insert",
					}),
				  ],
				  { align: "full" },
				),
			  ]);
			};
		  },
		  11737: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.mediaFakeTag = "jodit-media"),
			  (n.Config.prototype.mediaInFakeBlock = !0),
			  (n.Config.prototype.mediaBlocks = ["video", "audio"]);
		  },
		  76303: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.media = void 0);
			var n = o(86893),
			  r = o(76502),
			  i = o(17332);
			function a(e) {
			  var t = "jodit_fake_wrapper",
				o = e.options,
				i = o.mediaFakeTag,
				a = o.mediaBlocks;
			  o.mediaInFakeBlock &&
				e.e
				  .on("afterGetValueFromEditor", function (e) {
					var o = new RegExp(
					  "<"
						.concat(i, "[^>]+data-")
						.concat(t, "[^>]+>([^]+?)</")
						.concat(i, ">"),
					  "ig",
					);
					o.test(e.value) && (e.value = e.value.replace(o, "$1"));
				  })
				  .on(
					"change afterInit afterSetMode changePlace",
					e.async.debounce(function () {
					  e.isDestructed ||
						e.getMode() === n.MODE_SOURCE ||
						(0, r.$$)(a.join(","), e.editor).forEach(function (o) {
						  (0, r.dataBind)(o, t) ||
							((0, r.dataBind)(o, t, !0),
							(function (o) {
							  var n;
							  if (
								o.parentNode &&
								(0, r.attr)(
								  o.parentNode,
								  "data-jodit_iframe_wrapper",
								)
							  )
								o = o.parentNode;
							  else {
								var a = e.createInside.element(
								  i,
								  (((n = {
									"data-jodit-temp": 1,
									contenteditable: !1,
									draggable: !0,
								  })["data-".concat(t)] = 1),
								  n),
								);
								(0, r.attr)(a, "style", (0, r.attr)(o, "style")),
								  (a.style.display =
									"inline-block" === o.style.display
									  ? "inline-block"
									  : "block"),
								  (a.style.width = o.offsetWidth + "px"),
								  (a.style.height = o.offsetHeight + "px"),
								  o.parentNode && o.parentNode.insertBefore(a, o),
								  a.appendChild(o),
								  (o = a);
							  }
							  e.e
								.off(o, "mousedown.select touchstart.select")
								.on(
								  o,
								  "mousedown.select touchstart.select",
								  function () {
									e.s.setCursorAfter(o);
								  },
								);
							})(o));
						});
					}, e.defaultTimeout),
				  );
			}
			o(11737), (t.media = a), i.pluginSystem.add("media", a);
		  },
		  8860: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(86893),
			  i = o(81438),
			  a = o(40332),
			  s = o(72719);
			(n.Config.prototype.mobileTapTimeout = 300),
			  (n.Config.prototype.toolbarAdaptive = !0),
			  (n.Config.prototype.controls.dots = {
				mode: r.MODE_SOURCE + r.MODE_WYSIWYG,
				popup: function (e, t, o, n, r) {
				  var l = o.data;
				  return (
					void 0 === l &&
					  ((l = {
						toolbar: (0, i.makeCollection)(e),
						rebuild: function () {
						  var t;
						  if (r) {
							var o = e.e.fire(
							  "getDiffButtons.mobile",
							  r.closest(s.ToolbarCollection),
							);
							if (o && l) {
							  l.toolbar.build((0, a.splitArray)(o));
							  var n =
								(null === (t = e.toolbar.firstButton) ||
								void 0 === t
								  ? void 0
								  : t.container.offsetWidth) || 36;
							  l.toolbar.container.style.width =
								3 * (n + 4) + "px";
							}
						  }
						},
					  }),
					  (o.data = l)),
					l.rebuild(),
					l.toolbar
				  );
				},
				tooltip: "Show all",
			  });
		  },
		  19806: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.mobile = void 0);
			var n = o(40332),
			  r = o(97642),
			  i = o(17332);
			function a(e) {
			  var t = 0,
				o = (0, n.splitArray)(e.o.buttons);
			  e.o.mobileTapTimeout &&
				e.e.on("touchend", function (o) {
				  if (o.changedTouches && o.changedTouches.length) {
					var n = new Date().getTime(),
					  r = n - t;
					r > e.o.mobileTapTimeout &&
					  ((t = n),
					  1.5 * e.o.mobileTapTimeout > r &&
						e.s.insertCursorAtPoint(o.clientX, o.clientY));
				  }
				}),
				e.e.on("getDiffButtons.mobile", function (t) {
				  if (t === e.toolbar) {
					var i = (0, r.flatButtonsSet)(
						(0, n.splitArray)(e.o.buttons),
						e,
					  ),
					  a = (0, r.flatButtonsSet)(o, e);
					return (0, n.toArray)(i).reduce(function (e, t) {
					  return a.has(t) || e.push(t), e;
					}, []);
				  }
				}),
				e.o.toolbarAdaptive &&
				  e.e
					.on(
					  "resize afterInit recalcAdaptive changePlace afterAddPlace",
					  function () {
						var t;
						if (e.o.toolbar) {
						  var r = (
							  null !== (t = e.container.parentElement) &&
							  void 0 !== t
								? t
								: e.container
							).offsetWidth,
							i = (0, n.splitArray)(
							  e.isFullSize || r >= e.o.sizeLG
								? e.o.buttons
								: e.o.sizeMD > r
								  ? e.o.sizeSM > r
									? e.o.buttonsXS
									: e.o.buttonsSM
								  : e.o.buttonsMD,
							);
						  i.toString() !== o.toString() &&
							((o = i),
							e.e.fire("closeAllPopups"),
							e.toolbar
							  .setRemoveButtons(e.o.removeButtons)
							  .build(o.concat(e.o.extraButtons)));
						}
					  },
					)
					.on(e.ow, "load resize", function () {
					  return e.e.fire("recalcAdaptive");
					});
			}
			o(8860), (t.mobile = a), i.pluginSystem.add("mobile", a);
		  },
		  73013: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(63122),
			  i = function (e, t, o) {
				var n,
				  i = o.control,
				  a = "button".concat(i.command),
				  s =
					null !== (n = i.args && i.args[0]) && void 0 !== n
					  ? n
					  : (0, r.dataBind)(e, a);
				(0, r.dataBind)(e, a, s),
				  e.execCommand(i.command, !1, "default" === s ? null : s);
			  };
			o(77904).Icon.set("ol", o(15476)).set("ul", o(59403)),
			  (n.Config.prototype.controls.ul = {
				command: "insertUnorderedList",
				tags: ["ul"],
				tooltip: "Insert Unordered List",
				list: {
				  default: "Default",
				  circle: "Circle",
				  disc: "Dot",
				  square: "Quadrate",
				},
				exec: i,
			  }),
			  (n.Config.prototype.controls.ol = {
				command: "insertOrderedList",
				tags: ["ol"],
				tooltip: "Insert Ordered List",
				list: {
				  default: "Default",
				  "lower-alpha": "Lower Alpha",
				  "lower-greek": "Lower Greek",
				  "lower-roman": "Lower Roman",
				  "upper-alpha": "Upper Alpha",
				  "upper-roman": "Upper Roman",
				},
				exec: i,
			  });
		  },
		  52598: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.orderedList = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(43441),
			  a = o(17332);
			o(73013);
			var s = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.buttons = [
					{ name: "ul", group: "list" },
					{ name: "ol", group: "list" },
				  ]),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  e.registerCommand(
					"insertUnorderedList",
					this.onCommand,
				  ).registerCommand("insertOrderedList", this.onCommand);
				}),
				(t.prototype.onCommand = function (e, t, o) {
				  return (
					this.jodit.s.applyStyle(
					  { listStyleType: null != o ? o : null },
					  { element: "insertunorderedlist" === e ? "ul" : "ol" },
					),
					this.jodit.synchronizeValues(),
					!1
				  );
				}),
				(t.prototype.beforeDestruct = function (e) {}),
				n.__decorate([i.autobind], t.prototype, "onCommand", null),
				t
			  );
			})(r.Plugin);
			(t.orderedList = s), a.pluginSystem.add("orderedList", s);
		  },
		  47470: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(86893);
			(n.Config.prototype.askBeforePasteFromWord = !0),
			  (n.Config.prototype.processPasteFromWord = !0),
			  (n.Config.prototype.defaultActionOnPasteFromWord = null),
			  (n.Config.prototype.pasteFromWordActionList = [
				{ value: r.INSERT_AS_HTML, text: "Keep" },
				{ value: r.INSERT_AS_TEXT, text: "Clean" },
				{ value: r.INSERT_ONLY_TEXT, text: "Insert only Text" },
			  ]);
		  },
		  15428: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.pasteFromWord = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(40332),
			  a = o(86893),
			  s = o(43441),
			  l = o(64280),
			  c = o(17332);
			o(47470);
			var u = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (t.requires = ["paste"]), t;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {}),
				(t.prototype.beforeDestruct = function (e) {}),
				(t.prototype.processWordHTML = function (e, t, o) {
				  var n = this,
					r = this.j,
					a = r.o,
					s = a.askBeforePasteFromWord,
					c = a.defaultActionOnPasteFromWord,
					u = a.defaultActionOnPaste,
					d = a.pasteFromWordActionList;
				  return !(
					!a.processPasteFromWord ||
					!(0, i.isHtmlFromWord)(t) ||
					(s
					  ? (0, l.askInsertTypeDialog)(
						  r,
						  "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?",
						  "Word Paste Detected",
						  function (r) {
							n.insertFromWordByType(e, t, r, o);
						  },
						  d,
						)
					  : this.insertFromWordByType(e, t, c || u, o),
					0)
				  );
				}),
				(t.prototype.insertFromWordByType = function (e, t, o, n) {
				  var r;
				  switch (o) {
					case a.INSERT_AS_HTML:
					  t = (0, i.applyStyles)(t);
					  var s =
						null === (r = this.j.events) || void 0 === r
						  ? void 0
						  : r.fire("beautifyHTML", t);
					  (0, i.isString)(s) && (t = s);
					  break;
					case a.INSERT_AS_TEXT:
					  t = (0, i.cleanFromWord)(t);
					  break;
					case a.INSERT_ONLY_TEXT:
					  t = (0, i.stripTags)((0, i.cleanFromWord)(t));
				  }
				  (0, l.pasteInsertHtml)(e, this.j, t);
				}),
				n.__decorate(
				  [(0, s.watch)(":processHTML")],
				  t.prototype,
				  "processWordHTML",
				  null,
				),
				t
			  );
			})(r.Plugin);
			(t.pasteFromWord = u), c.pluginSystem.add("pasteFromWord", u);
		  },
		  47224: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.pasteStorage = void 0);
			var n = o(20255);
			o(71708);
			var r = o(86893),
			  i = o(85605),
			  a = o(24263),
			  s = o(40332),
			  l = o(96031),
			  c = o(17332),
			  u = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.currentIndex = 0),
					(t.list = []),
					(t.container = null),
					(t.listBox = null),
					(t.previewBox = null),
					(t.dialog = null),
					(t.paste = function () {
					  if (
						(t.j.s.focus(),
						t.j.s.insertHTML(t.list[t.currentIndex]),
						0 !== t.currentIndex)
					  ) {
						var e = t.list[0];
						(t.list[0] = t.list[t.currentIndex]),
						  (t.list[t.currentIndex] = e);
					  }
					  t.dialog && t.dialog.close(),
						t.j.synchronizeValues(),
						t.j.e.fire("afterPaste");
					}),
					(t.onKeyDown = function (e) {
					  var o = t.currentIndex;
					  -1 !== [r.KEY_UP, r.KEY_DOWN, r.KEY_ENTER].indexOf(e.key) &&
						(e.key === r.KEY_UP &&
						  (0 === o ? (o = t.list.length - 1) : (o -= 1)),
						e.key === r.KEY_DOWN &&
						  (o === t.list.length - 1 ? (o = 0) : (o += 1)),
						e.key !== r.KEY_ENTER
						  ? (o !== t.currentIndex && t.selectIndex(o),
							e.stopImmediatePropagation(),
							e.preventDefault())
						  : t.paste());
					}),
					(t.selectIndex = function (e) {
					  t.listBox &&
						(0, s.toArray)(t.listBox.childNodes).forEach(
						  function (o, n) {
							o.classList.remove("jodit_active"),
							  e === n &&
								t.previewBox &&
								(o.classList.add("jodit_active"),
								(t.previewBox.innerHTML = t.list[e]),
								o.focus());
						  },
						),
						(t.currentIndex = e);
					}),
					(t.showDialog = function () {
					  2 > t.list.length ||
						(t.dialog || t.createDialog(),
						t.listBox && (t.listBox.innerHTML = ""),
						t.previewBox && (t.previewBox.innerHTML = ""),
						t.list.forEach(function (e, o) {
						  var n = t.j.c.element("a");
						  (n.textContent =
							o + 1 + ". " + e.replace((0, r.SPACE_REG_EXP)(), "")),
							t.j.e.on(n, "keydown", t.onKeyDown),
							(0, s.attr)(n, "href", "#"),
							(0, s.attr)(n, "data-index", o.toString()),
							(0, s.attr)(n, "tab-index", "-1"),
							t.listBox && t.listBox.appendChild(n);
						}),
						t.dialog && t.dialog.open(),
						t.j.async.setTimeout(function () {
						  t.selectIndex(0);
						}, 100));
					}),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.createDialog = function () {
					var e = this;
					this.dialog = this.j.dlg();
					var t = (0, l.Button)(this.j, "paste", "Paste", "primary");
					t.onAction(this.paste);
					var o = (0, l.Button)(this.j, "", "Cancel");
					o.onAction(this.dialog.close),
					  (this.container = this.j.c.div()),
					  this.container.classList.add("jodit-paste-storage"),
					  (this.listBox = this.j.c.div()),
					  (this.previewBox = this.j.c.div()),
					  this.container.appendChild(this.listBox),
					  this.container.appendChild(this.previewBox),
					  this.dialog.setHeader(
						this.j.i18n("Choose Content to Paste"),
					  ),
					  this.dialog.setContent(this.container),
					  this.dialog.setFooter([t, o]),
					  this.j.e.on(this.listBox, "click dblclick", function (t) {
						var o = t.target;
						return (
						  a.Dom.isTag(o, "a") &&
							o.hasAttribute("data-index") &&
							e.selectIndex(
							  parseInt((0, s.attr)(o, "-index") || "0", 10),
							),
						  "dblclick" === t.type && e.paste(),
						  !1
						);
					  });
				  }),
				  (t.prototype.afterInit = function () {
					var e = this;
					this.j.e
					  .off("afterCopy.paste-storage")
					  .on("pasteStorageList.paste-storage", function () {
						return e.list.length;
					  })
					  .on("afterCopy.paste-storage", function (t) {
						-1 !== e.list.indexOf(t) &&
						  e.list.splice(e.list.indexOf(t), 1),
						  e.list.unshift(t),
						  e.list.length > 5 && (e.list.length = 5);
					  }),
					  this.j.registerCommand("showPasteStorage", {
						exec: this.showDialog,
						hotkeys: ["ctrl+shift+v", "cmd+shift+v"],
					  });
				  }),
				  (t.prototype.beforeDestruct = function () {
					this.dialog && this.dialog.destruct(),
					  this.j.e.off(".paste-storage"),
					  a.Dom.safeRemove(this.previewBox),
					  a.Dom.safeRemove(this.listBox),
					  a.Dom.safeRemove(this.container),
					  (this.container = null),
					  (this.listBox = null),
					  (this.previewBox = null),
					  (this.dialog = null),
					  (this.list = []);
				  }),
				  t
				);
			  })(i.Plugin);
			(t.pasteStorage = u), c.pluginSystem.add("pasteStorage", u);
		  },
		  24703: function (e, t, o) {
			"use strict";
			var n;
			Object.defineProperty(t, "__esModule", { value: !0 });
			var r = o(20255),
			  i = o(86893),
			  a = o(93166),
			  s = o(64280);
			(a.Config.prototype.askBeforePasteHTML = !0),
			  (a.Config.prototype.processPasteHTML = !0),
			  (a.Config.prototype.pasteHTMLActionList = [
				{ value: i.INSERT_AS_HTML, text: "Keep" },
				{ value: i.INSERT_AS_TEXT, text: "Insert as Text" },
				{ value: i.INSERT_ONLY_TEXT, text: "Insert only Text" },
			  ]),
			  (a.Config.prototype.memorizeChoiceWhenPasteFragment = !1),
			  (a.Config.prototype.nl2brInPlainText = !0);
			var l = "pasteStorage";
			a.Config.prototype.controls.paste = {
			  tooltip: "Paste from clipboard",
			  exec: function (e, t, o) {
				var n = o.control;
				return r.__awaiter(this, void 0, void 0, function () {
				  var t, o, a, c, u;
				  return r.__generator(this, function (r) {
					switch (r.label) {
					  case 0:
						if (n.name === l)
						  return e.execCommand("showPasteStorage"), [2];
						if (
						  (e.s.focus(), (t = ""), (o = !0), !navigator.clipboard)
						)
						  return [3, 11];
						r.label = 1;
					  case 1:
						return (
						  r.trys.push([1, 6, , 7]),
						  [4, navigator.clipboard.read()]
						);
					  case 2:
						return (a = r.sent()) && a.length
						  ? [4, a[0].getType(i.TEXT_PLAIN)]
						  : [3, 5];
					  case 3:
						return (c = r.sent()), [4, new Response(c).text()];
					  case 4:
						(t = r.sent()), (r.label = 5);
					  case 5:
						return (o = !1), [3, 7];
					  case 6:
						return r.sent(), [3, 7];
					  case 7:
						if (!o) return [3, 11];
						r.label = 8;
					  case 8:
						return (
						  r.trys.push([8, 10, , 11]),
						  [4, navigator.clipboard.readText()]
						);
					  case 9:
						return (t = r.sent()), (o = !1), [3, 11];
					  case 10:
						return r.sent(), [3, 11];
					  case 11:
						return (
						  o &&
							((t = e.buffer.get(i.CLIPBOARD_ID) || ""),
							(o = 0 === t.length)),
						  (u = e.value),
						  o
							? (e.ed.execCommand("paste"),
							  !(o = u === e.value) && e.e.fire("afterPaste"))
							: t.length
							  ? ((0, s.pasteInsertHtml)(null, e, t),
								e.e.fire("afterPaste"))
							  : o &&
								e.alert(
								  "Your browser doesn't support direct access to the clipboard.",
								  function () {
									e.s.focus();
								  },
								),
						  [2]
						);
					}
				  });
				});
			  },
			  list: ((n = {}), (n[l] = "Paste Storage"), n),
			  isChildDisabled: function (e) {
				return 2 > e.e.fire("pasteStorageList");
			  },
			};
		  },
		  64280: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.askInsertTypeDialog =
				t.getAllTypes =
				t.pasteInsertHtml =
				  void 0);
			var n = o(20255),
			  r = o(10172),
			  i = o(24263),
			  a = o(86893),
			  s = o(96031);
			(t.pasteInsertHtml = function (e, t, o) {
			  if (!t.isInDestruct) {
				(function (e) {
				  return Boolean(e && "drop" === e.type);
				})(e) && t.s.insertCursorAtPoint(e.clientX, e.clientY);
				var n = t.e.fire("beforePasteInsert", o);
				!(0, r.isVoid)(n) &&
				  ((0, r.isString)(n) || (0, r.isNumber)(n) || i.Dom.isNode(n)) &&
				  (o = n),
				  (0, r.isString)(o) &&
					(o = (function (e) {
					  var t = (e = e.replace(/<meta[^>]+?>/g, "")).search(
						/<!--StartFragment-->/i,
					  );
					  -1 !== t && (e = e.substring(t + 20));
					  var o = e.search(/<!--EndFragment-->/i);
					  return -1 !== o && (e = e.substring(0, o)), e;
					})(o)),
				  t.s.insertHTML(o);
			  }
			}),
			  (t.getAllTypes = function (e) {
				var t = e.types,
				  o = "";
				if (
				  (0, r.isArray)(t) ||
				  "[object DOMStringList]" === {}.toString.call(t)
				)
				  for (var n = 0; t.length > n; n += 1) o += t[n] + ";";
				else o = (t || a.TEXT_PLAIN).toString() + ";";
				return o;
			  }),
			  (t.askInsertTypeDialog = function (e, t, o, r, i) {
				if (!1 !== e.e.fire("beforeOpenPasteDialog", t, o, r, i)) {
				  var a = e.confirm(
					  '<div style="word-break: normal; white-space: normal">'.concat(
						e.i18n(t),
						"</div>",
					  ),
					  e.i18n(o),
					),
					l = i.map(function (t) {
					  var o = t.text,
						n = t.value;
					  return (0, s.Button)(e, {
						text: o,
						name: o.toLowerCase(),
						tabIndex: 0,
					  }).onAction(function () {
						a.close(), r(n);
					  });
					});
				  a.e.one(a, "afterClose", function () {
					e.s.isFocused() || e.s.focus();
				  });
				  var c = (0, s.Button)(e, {
					text: "Cancel",
					tabIndex: 0,
				  }).onAction(function () {
					a.close();
				  });
				  return (
					a.setFooter(
					  n.__spreadArray(
						n.__spreadArray([], n.__read(l), !1),
						[c],
						!1,
					  ),
					),
					l[0].focus(),
					(l[0].state.variant = "primary"),
					e.e.fire("afterOpenPasteDialog", a, t, o, r, i),
					a
				  );
				}
			  });
		  },
		  19483: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.paste = void 0);
			var n = o(20255),
			  r = o(85605),
			  i = o(86893),
			  a = o(24263),
			  s = o(43441),
			  l = o(40332),
			  c = o(17332),
			  u = o(64280);
			o(24703);
			var d = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.pasteStack = new l.LimitedStack(20)),
				  (t._isDialogOpened = !1),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  e.e
					.on("paste.paste", this.onPaste)
					.on("pasteStack.paste", function (e) {
					  return t.pasteStack.push(e);
					}),
					e.o.nl2brInPlainText &&
					  this.j.e.on(
						"processPaste.paste",
						this.onProcessPasteReplaceNl2Br,
					  );
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e
					.off("paste.paste", this.onPaste)
					.off("processPaste.paste", this.onProcessPasteReplaceNl2Br)
					.off(".paste");
				}),
				(t.prototype.onPaste = function (e) {
				  try {
					if (
					  !1 === this.customPasteProcess(e) ||
					  !1 === this.j.e.fire("beforePaste", e)
					)
					  return e.preventDefault(), !1;
					this.defaultPasteProcess(e);
				  } finally {
					this.j.e.fire("afterPaste", e);
				  }
				}),
				(t.prototype.customPasteProcess = function (e) {
				  if (this.j.o.processPasteHTML) {
					var t,
					  o = (0, l.getDataTransfer)(e),
					  n = {
						html: null == o ? void 0 : o.getData(i.TEXT_HTML),
						plain: null == o ? void 0 : o.getData(i.TEXT_PLAIN),
						rtf: null == o ? void 0 : o.getData(i.TEXT_RTF),
					  };
					for (t in n) {
					  var r = n[t];
					  if (
						(0, l.isHTML)(r) &&
						(this.j.e.fire("processHTML", e, r, n) ||
						  this.processHTML(e, r))
					  )
						return !1;
					}
				  }
				}),
				(t.prototype.defaultPasteProcess = function (e) {
				  var t = (0, l.getDataTransfer)(e),
					o =
					  (null == t ? void 0 : t.getData(i.TEXT_HTML)) ||
					  (null == t ? void 0 : t.getData(i.TEXT_PLAIN));
				  if (t && o && "" !== (0, l.trim)(o)) {
					var n = this.j.e.fire(
					  "processPaste",
					  e,
					  o,
					  (0, u.getAllTypes)(t),
					);
					void 0 !== n && (o = n),
					  ((0, l.isString)(o) || a.Dom.isNode(o)) &&
						this.insertByType(e, o, this.j.o.defaultActionOnPaste),
					  e.preventDefault(),
					  e.stopPropagation();
				  }
				}),
				(t.prototype.processHTML = function (e, t) {
				  var o = this;
				  if (this.j.o.askBeforePasteHTML) {
					if (this.j.o.memorizeChoiceWhenPasteFragment) {
					  var n = this.pasteStack.find(function (e) {
						return e.html === t;
					  });
					  if (n)
						return (
						  this.insertByType(
							e,
							t,
							n.action || this.j.o.defaultActionOnPaste,
						  ),
						  !0
						);
					}
					if (this._isDialogOpened) return !0;
					var r = (0, u.askInsertTypeDialog)(
					  this.j,
					  "Your code is similar to HTML. Keep as HTML?",
					  "Paste as HTML",
					  function (n) {
						(o._isDialogOpened = !1), o.insertByType(e, t, n);
					  },
					  this.j.o.pasteHTMLActionList,
					);
					return (
					  r &&
						((this._isDialogOpened = !0),
						r.e.on("beforeClose", function () {
						  o._isDialogOpened = !1;
						})),
					  !0
					);
				  }
				  return !1;
				}),
				(t.prototype.insertByType = function (e, t, o) {
				  if (
					(this.pasteStack.push({ html: t, action: o }),
					(0, l.isString)(t))
				  )
					switch ((this.j.buffer.set(i.CLIPBOARD_ID, t), o)) {
					  case i.INSERT_CLEAR_HTML:
						t = (0, l.cleanFromWord)(t);
						break;
					  case i.INSERT_ONLY_TEXT:
						t = (0, l.stripTags)(t);
						break;
					  case i.INSERT_AS_TEXT:
						t = (0, l.htmlspecialchars)(t);
					}
				  (0, u.pasteInsertHtml)(e, this.j, t);
				}),
				(t.prototype.onProcessPasteReplaceNl2Br = function (e, t, o) {
				  if (o === i.TEXT_PLAIN + ";" && !(0, l.isHTML)(t))
					return (0, l.nl2br)(t);
				}),
				n.__decorate([s.autobind], t.prototype, "onPaste", null),
				n.__decorate(
				  [s.autobind],
				  t.prototype,
				  "onProcessPasteReplaceNl2Br",
				  null,
				),
				t
			  );
			})(r.Plugin);
			(t.paste = d), c.pluginSystem.add("paste", d);
		  },
		  76952: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.showPlaceholder = !0),
			  (n.Config.prototype.placeholder = "Type something"),
			  (n.Config.prototype.useInputsPlaceholder = !0);
		  },
		  83211: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.placeholder = t.isEditorEmpty = void 0);
			var n = o(20255);
			o(51629);
			var r = o(86893),
			  i = o(67309),
			  a = o(26911),
			  s = o(37204),
			  l = o(24263),
			  c = o(85605),
			  u = o(86893),
			  d = o(43441),
			  p = o(17332);
			function f(e) {
			  var t;
			  if (!e.firstChild) return !0;
			  var o = e.firstChild;
			  if (
				u.INSEPARABLE_TAGS.has(
				  null === (t = o.nodeName) || void 0 === t
					? void 0
					: t.toLowerCase(),
				) ||
				/^(TABLE)$/i.test(o.nodeName)
			  )
				return !1;
			  var n = l.Dom.next(
				o,
				function (e) {
				  return e && !l.Dom.isEmptyTextNode(e);
				},
				e,
			  );
			  return l.Dom.isText(o) && !n
				? l.Dom.isEmptyTextNode(o)
				: !n &&
					l.Dom.each(o, function (e) {
					  return (
						!l.Dom.isTag(e, ["ul", "li", "ol"]) &&
						(l.Dom.isEmpty(e) || l.Dom.isTag(e, "br"))
					  );
					});
			}
			o(76952), (t.isEditorEmpty = f);
			var h = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.addNativeListeners = function () {
					t.j.e
					  .off(t.j.editor, "input.placeholder keydown.placeholder")
					  .on(
						t.j.editor,
						"input.placeholder keydown.placeholder",
						t.toggle,
					  );
				  }),
				  (t.addEvents = function () {
					var e = t.j;
					e.o.useInputsPlaceholder &&
					  e.element.hasAttribute("placeholder") &&
					  (t.placeholderElm.innerHTML =
						(0, i.attr)(e.element, "placeholder") || ""),
					  e.e.fire("placeholder", t.placeholderElm.innerHTML),
					  e.e
						.off(".placeholder")
						.on("changePlace.placeholder", t.addNativeListeners)
						.on(
						  "change.placeholder focus.placeholder keyup.placeholder mouseup.placeholder keydown.placeholder mousedown.placeholder afterSetMode.placeholder changePlace.placeholder",
						  t.toggle,
						)
						.on(window, "load", t.toggle),
					  t.addNativeListeners(),
					  t.toggle();
				  }),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  e.o.showPlaceholder &&
					((this.placeholderElm = e.c.fromHTML(
					  '<span data-ref="placeholder" style="display: none;" class="jodit-placeholder">'.concat(
						e.i18n(e.o.placeholder),
						"</span>",
					  ),
					)),
					"rtl" === e.o.direction &&
					  ((this.placeholderElm.style.right = "0px"),
					  (this.placeholderElm.style.direction = "rtl")),
					e.e
					  .on("readonly", function (e) {
						e ? t.hide() : t.toggle();
					  })
					  .on("changePlace", this.addEvents),
					this.addEvents());
				}),
				(t.prototype.show = function () {
				  var e = this.j;
				  if (!e.o.readonly) {
					var t = 0,
					  o = 0,
					  n = e.s.current(),
					  r =
						(n && l.Dom.closest(n, l.Dom.isBlock, e.editor)) ||
						e.editor,
					  i = e.ew.getComputedStyle(r),
					  c = e.ew.getComputedStyle(e.editor);
					e.workplace.appendChild(this.placeholderElm);
					var u = e.editor.firstChild;
					if (l.Dom.isElement(u) && !(0, s.isMarker)(u)) {
					  var d = e.ew.getComputedStyle(u);
					  (t = parseInt(d.getPropertyValue("margin-top"), 10)),
						(o = parseInt(d.getPropertyValue("margin-left"), 10)),
						(this.placeholderElm.style.fontSize =
						  parseInt(d.getPropertyValue("font-size"), 10) + "px"),
						(this.placeholderElm.style.lineHeight =
						  d.getPropertyValue("line-height"));
					} else
					  (this.placeholderElm.style.fontSize =
						parseInt(i.getPropertyValue("font-size"), 10) + "px"),
						(this.placeholderElm.style.lineHeight =
						  i.getPropertyValue("line-height"));
					(0, a.css)(this.placeholderElm, {
					  display: "block",
					  textAlign: i.getPropertyValue("text-align"),
					  paddingTop: parseInt(c.paddingTop, 10) + "px",
					  paddingLeft: parseInt(c.paddingLeft, 10) + "px",
					  paddingRight: parseInt(c.paddingRight, 10) + "px",
					  marginTop: Math.max(
						parseInt(i.getPropertyValue("margin-top"), 10),
						t,
					  ),
					  marginLeft: Math.max(
						parseInt(i.getPropertyValue("margin-left"), 10),
						o,
					  ),
					});
				  }
				}),
				(t.prototype.hide = function () {
				  l.Dom.safeRemove(this.placeholderElm);
				}),
				(t.prototype.toggle = function () {
				  var e = this.j;
				  e.editor &&
					!e.isInDestruct &&
					(e.getRealMode() === r.MODE_WYSIWYG && f(e.editor)
					  ? this.show()
					  : this.hide());
				}),
				(t.prototype.beforeDestruct = function (e) {
				  this.hide(),
					e.e.off(".placeholder").off(window, "load", this.toggle);
				}),
				n.__decorate(
				  [
					(0, d.debounce)(function (e) {
					  return e.defaultTimeout / 10;
					}, !0),
				  ],
				  t.prototype,
				  "toggle",
				  null,
				),
				t
			  );
			})(c.Plugin);
			(t.placeholder = h), p.pluginSystem.add("placeholder", h);
		  },
		  88297: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.poweredByJodit = void 0);
			var n = o(17332);
			function r(e) {
			  var t = e.o;
			  t.hidePoweredByJodit ||
				t.inline ||
				!(
				  t.showCharsCounter ||
				  t.showWordsCounter ||
				  t.showXPathInStatusbar
				) ||
				e.hookStatus("ready", function () {
				  e.statusbar.append(
					e.create.fromHTML(
					  '<a\n\t\t\t\t\t\ttabindex="-1"\n\t\t\t\t\t\tstyle="text-transform: uppercase"\n\t\t\t\t\t\tclass="jodit-status-bar-link"\n\t\t\t\t\t\ttarget="_blank"\n\t\t\t\t\t\thref="https://xdsoft.net/jodit/">\n\t\t\t\t\t\t\tPowered by Jodit\n\t\t\t\t\t\t</a>',
					),
					!0,
				  );
				});
			}
			(t.poweredByJodit = r), n.pluginSystem.add("poweredByJodit", r);
		  },
		  72930: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.preview = void 0),
			  o(54860);
			var n = o(93166),
			  r = o(86893),
			  i = o(21498),
			  a = o(17332);
			function s(e) {
			  e.registerButton({ name: "preview" }),
				e.registerCommand("preview", function (t, o, n) {
				  var r = e.dlg();
				  r.setSize(1024, 600).open("", e.i18n("Preview")).setModal(!0),
					(0, i.previewBox)(e, n, "px", r.getElm("content"));
				});
			}
			(n.Config.prototype.controls.preview = {
			  icon: "eye",
			  command: "preview",
			  mode: r.MODE_SOURCE + r.MODE_WYSIWYG,
			  tooltip: "Preview",
			}),
			  (t.preview = s),
			  a.pluginSystem.add("preview", s);
		  },
		  20137: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.generateCriticalCSS = void 0);
			var n = o(20255),
			  r = o(1853);
			t.generateCriticalCSS = function (e) {
			  var t = function (e, t) {
				  return (
					void 0 === t && (t = e.ownerDocument.styleSheets),
					(0, r.toArray)(t)
					  .map(function (e) {
						try {
						  return (0, r.toArray)(e.cssRules);
						} catch (e) {}
						return [];
					  })
					  .flat()
					  .filter(function (t) {
						try {
						  return Boolean(t && e.matches(t.selectorText));
						} catch (e) {}
						return !1;
					  })
				  );
				},
				o = (function () {
				  function o(o, r, i) {
					var a = this;
					this.css = {};
					var s = i || {},
					  l = function (t) {
						var o = t.selectorText
						  .split(",")
						  .map(function (e) {
							return e.trim();
						  })
						  .sort()
						  .join(",");
						!1 === Boolean(a.css[o]) && (a.css[o] = {});
						for (
						  var r = t.style.cssText.split(/;(?![A-Za-z0-9])/),
							i = 0;
						  r.length > i;
						  i++
						)
						  if (r[i]) {
							var s = r[i].split(":");
							(s[0] = s[0].trim()),
							  (s[1] = s[1].trim()),
							  (a.css[o][s[0]] = s[1].replace(
								/var\(([^)]+)\)/g,
								function (t, o) {
								  var r = n.__read(o.split(","), 2),
									i = r[0],
									a = r[1];
								  return (
									e.ew
									  .getComputedStyle(e.editor)
									  .getPropertyValue(i.trim()) ||
									a ||
									t
								  ).trim();
								},
							  ));
						  }
					  };
					!(function () {
					  for (
						var n = o.innerHeight,
						  i = r.createTreeWalker(
							e.editor,
							NodeFilter.SHOW_ELEMENT,
							function () {
							  return NodeFilter.FILTER_ACCEPT;
							},
						  );
						i.nextNode();
  
					  ) {
						var a = i.currentNode;
						if (n > a.getBoundingClientRect().top || s.scanFullPage) {
						  var c = t(a);
						  if (c) for (var u = 0; c.length > u; u++) l(c[u]);
						}
					  }
					})();
				  }
				  return (
					(o.prototype.generateCSS = function () {
					  var e = "";
					  for (var t in this.css)
						if (!/:not\(/.test(t)) {
						  for (var o in ((e += t + " { "), this.css[t]))
							e += o + ": " + this.css[t][o] + "; ";
						  e += "}\n";
						}
					  return e;
					}),
					o
				  );
				})();
			  try {
				return new o(e.ew, e.ed, { scanFullPage: !0 }).generateCSS();
			  } catch (e) {}
			  return "";
			};
		  },
		  51197: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.print = void 0);
			var n = o(93166),
			  r = o(17332),
			  i = o(64968),
			  a = o(93351),
			  s = o(86893),
			  l = o(17332),
			  c = o(77904),
			  u = o(20137),
			  d = o(21498);
			function p(e) {
			  e.registerButton({ name: "print" });
			}
			c.Icon.set("print", o(22860)),
			  (n.Config.prototype.controls.print = {
				exec: function (e) {
				  var t = e.create.element("iframe");
				  Object.assign(t.style, {
					position: "fixed",
					right: 0,
					bottom: 0,
					width: 0,
					height: 0,
					border: 0,
				  }),
					(0, r.getContainer)(e, n.Config).appendChild(t);
				  var o = function () {
					  e.e.off(e.ow, "mousemove", o), i.Dom.safeRemove(t);
					},
					s = t.contentWindow;
				  if (s) {
					e.e
					  .on(s, "onbeforeunload onafterprint", o)
					  .on(e.ow, "mousemove", o),
					  e.o.iframe
						? (e.e.fire(
							"generateDocumentStructure.iframe",
							s.document,
							e,
						  ),
						  (s.document.body.innerHTML = e.value))
						: (s.document.write(
							'<!doctype html><html lang="' +
							  (0, a.defaultLanguage)(e.o.language) +
							  '"><head><title></title></head><style>' +
							  (0, u.generateCriticalCSS)(e) +
							  "</style><body></body></html>",
						  ),
						  s.document.close(),
						  (0, d.previewBox)(e, void 0, "px", s.document.body));
					var l = s.document.createElement("style");
					(l.innerHTML =
					  "@media print {\n\t\t\t\t\tbody {\n\t\t\t\t\t\t\t-webkit-print-color-adjust: exact;\n\t\t\t\t\t}\n\t\t\t}"),
					  s.document.head.appendChild(l),
					  s.focus(),
					  s.print();
				  }
				},
				mode: s.MODE_SOURCE + s.MODE_WYSIWYG,
				tooltip: "Print",
			  }),
			  (t.print = p),
			  l.pluginSystem.add("print", p);
		  },
		  2327: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.redoUndo = void 0);
			var n = o(20255),
			  r = o(93166),
			  i = o(86893),
			  a = o(85605),
			  s = o(17332);
			o(77904).Icon.set("redo", o(95600)).set("undo", o(76214)),
			  (r.Config.prototype.controls.redo = {
				mode: i.MODE_SPLIT,
				isDisabled: function (e) {
				  return !e.history.canRedo();
				},
				tooltip: "Redo",
			  }),
			  (r.Config.prototype.controls.undo = {
				mode: i.MODE_SPLIT,
				isDisabled: function (e) {
				  return !e.history.canUndo();
				},
				tooltip: "Undo",
			  });
			var l = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.buttons = [
					{ name: "undo", group: "history" },
					{ name: "redo", group: "history" },
				  ]),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.beforeDestruct = function () {}),
				(t.prototype.afterInit = function (e) {
				  var t = function (t) {
					return e.history[t](), !1;
				  };
				  e.registerCommand("redo", {
					exec: t,
					hotkeys: ["ctrl+y", "ctrl+shift+z", "cmd+y", "cmd+shift+z"],
				  }),
					e.registerCommand("undo", {
					  exec: t,
					  hotkeys: ["ctrl+z", "cmd+z"],
					});
				}),
				t
			  );
			})(a.Plugin);
			(t.redoUndo = l), s.pluginSystem.add("redoUndo", l);
		  },
		  52444: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.tableAllowCellResize = !0);
		  },
		  47608: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.resizeCells = void 0);
			var n = o(20255);
			o(47818);
			var r = o(86893),
			  i = o(87837),
			  a = o(40332),
			  s = o(43441),
			  l = o(24263),
			  c = o(17332);
			o(52444);
			var u = "table_processor_observer-resize",
			  d = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.selectMode = !1),
					(t.resizeDelta = 0),
					(t.createResizeHandle = function () {
					  t.resizeHandler ||
						((t.resizeHandler = t.j.c.div("jodit-table-resizer")),
						t.j.e
						  .on(
							t.resizeHandler,
							"mousedown.table touchstart.table",
							t.onHandleMouseDown,
						  )
						  .on(t.resizeHandler, "mouseenter.table", function () {
							t.j.async.clearTimeout(t.hideTimeout);
						  }));
					}),
					(t.hideTimeout = 0),
					(t.drag = !1),
					(t.minX = 0),
					(t.maxX = 0),
					(t.startX = 0),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  Object.defineProperty(t.prototype, "module", {
					get: function () {
					  return this.j.getInstance("Table", this.j.o);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "isRTL", {
					get: function () {
					  return "rtl" === this.j.o.direction;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.showResizeHandle = function () {
					this.j.async.clearTimeout(this.hideTimeout),
					  this.j.workplace.appendChild(this.resizeHandler);
				  }),
				  (t.prototype.hideResizeHandle = function () {
					var e = this;
					this.hideTimeout = this.j.async.setTimeout(
					  function () {
						l.Dom.safeRemove(e.resizeHandler);
					  },
					  { timeout: this.j.defaultTimeout, label: "hideResizer" },
					);
				  }),
				  (t.prototype.onHandleMouseDown = function (e) {
					var t = this;
					if (!this.j.isLocked) {
					  (this.drag = !0),
						this.j.e
						  .on(
							this.j.ow,
							"mouseup.resize-cells touchend.resize-cells",
							this.onMouseUp,
						  )
						  .on(
							this.j.ew,
							"mousemove.table touchmove.table",
							this.onMouseMove,
						  ),
						(this.startX = e.clientX),
						this.j.lock(u),
						this.resizeHandler.classList.add(
						  "jodit-table-resizer_moved",
						);
					  var o,
						n = this.workTable.getBoundingClientRect();
					  if (
						((this.minX = 0),
						(this.maxX = 1e6),
						null != this.wholeTable)
					  )
						(n = this.workTable.parentNode.getBoundingClientRect()),
						  (this.minX = n.left),
						  (this.maxX = this.minX + n.width);
					  else {
						var a = i.Table.formalCoordinate(
						  this.workTable,
						  this.workCell,
						  !0,
						);
						i.Table.formalMatrix(this.workTable, function (e, n, i) {
						  a[1] === i &&
							((o = e.getBoundingClientRect()),
							(t.minX = Math.max(o.left + r.NEARBY / 2, t.minX))),
							a[1] + (t.isRTL ? -1 : 1) === i &&
							  ((o = e.getBoundingClientRect()),
							  (t.maxX = Math.min(
								o.left + o.width - r.NEARBY / 2,
								t.maxX,
							  )));
						});
					  }
					  return !1;
					}
				  }),
				  (t.prototype.onMouseMove = function (e) {
					if (this.drag) {
					  this.j.e.fire("closeAllPopups");
					  var t = e.clientX,
						o = (0, a.offset)(
						  this.resizeHandler.parentNode ||
							this.j.od.documentElement,
						  this.j,
						  this.j.od,
						  !0,
						);
					  this.minX > t && (t = this.minX),
						t > this.maxX && (t = this.maxX),
						(this.resizeDelta =
						  t - this.startX + (this.j.o.iframe ? o.left : 0)),
						(this.resizeHandler.style.left =
						  t - (this.j.o.iframe ? 0 : o.left) + "px");
					  var n = this.j.s.sel;
					  n && n.removeAllRanges();
					}
				  }),
				  (t.prototype.onMouseUp = function (e) {
					(this.selectMode || this.drag) &&
					  ((this.selectMode = !1), this.j.unlock()),
					  this.resizeHandler &&
						this.drag &&
						((this.drag = !1),
						this.j.e.off(
						  this.j.ew,
						  "mousemove.table touchmove.table",
						  this.onMouseMove,
						),
						this.resizeHandler.classList.remove(
						  "jodit-table-resizer_moved",
						),
						this.startX !== e.clientX &&
						  (null == this.wholeTable
							? this.resizeColumns()
							: this.resizeTable()),
						this.j.synchronizeValues(),
						this.j.s.focus());
				  }),
				  (t.prototype.resizeColumns = function () {
					var e = this.resizeDelta,
					  t = [];
					i.Table.setColumnWidthByDelta(
					  this.workTable,
					  i.Table.formalCoordinate(
						this.workTable,
						this.workCell,
						!0,
					  )[1],
					  e,
					  !0,
					  t,
					);
					var o = (0, a.call)(
					  this.isRTL ? l.Dom.prev : l.Dom.next,
					  this.workCell,
					  l.Dom.isCell,
					  this.workCell.parentNode,
					);
					i.Table.setColumnWidthByDelta(
					  this.workTable,
					  i.Table.formalCoordinate(this.workTable, o)[1],
					  -e,
					  !1,
					  t,
					);
				  }),
				  (t.prototype.resizeTable = function () {
					var e = this.resizeDelta * (this.isRTL ? -1 : 1),
					  t = this.workTable.offsetWidth,
					  o = (0, a.getContentWidth)(
						this.workTable.parentNode,
						this.j.ew,
					  ),
					  n = !this.wholeTable;
					if (this.isRTL ? !n : n)
					  this.workTable.style.width = ((t + e) / o) * 100 + "%";
					else {
					  var r = this.isRTL ? "marginRight" : "marginLeft",
						i = parseInt(
						  this.j.ew.getComputedStyle(this.workTable)[r] || "0",
						  10,
						);
					  (this.workTable.style.width = ((t - e) / o) * 100 + "%"),
						(this.workTable.style[r] = ((i + e) / o) * 100 + "%");
					}
				  }),
				  (t.prototype.setWorkCell = function (e, t) {
					void 0 === t && (t = null),
					  (this.wholeTable = t),
					  (this.workCell = e),
					  (this.workTable = l.Dom.up(
						e,
						function (e) {
						  return l.Dom.isTag(e, "table");
						},
						this.j.editor,
					  ));
				  }),
				  (t.prototype.calcHandlePosition = function (e, t, o, n) {
					void 0 === o && (o = 0), void 0 === n && (n = 0);
					var i = (0, a.offset)(t, this.j, this.j.ed);
					if (o > r.NEARBY && i.width - r.NEARBY > o)
					  this.hideResizeHandle();
					else {
					  var s = (0, a.offset)(
						  this.j.workplace,
						  this.j,
						  this.j.od,
						  !0,
						),
						c = (0, a.offset)(e, this.j, this.j.ed);
					  if (
						((this.resizeHandler.style.left =
						  (o > r.NEARBY ? i.left + i.width : i.left) -
						  s.left +
						  n +
						  "px"),
						Object.assign(this.resizeHandler.style, {
						  height: c.height + "px",
						  top: c.top - s.top + "px",
						}),
						this.showResizeHandle(),
						o > r.NEARBY)
					  ) {
						var u = (0, a.call)(
						  this.isRTL ? l.Dom.prev : l.Dom.next,
						  t,
						  l.Dom.isCell,
						  t.parentNode,
						);
						this.setWorkCell(t, !!u && null);
					  } else {
						var d = (0, a.call)(
						  this.isRTL ? l.Dom.next : l.Dom.prev,
						  t,
						  l.Dom.isCell,
						  t.parentNode,
						);
						this.setWorkCell(d || t, !d || null);
					  }
					}
				  }),
				  (t.prototype.afterInit = function (e) {
					var t = this;
					e.o.tableAllowCellResize &&
					  e.e
						.off(this.j.ow, ".resize-cells")
						.off(".resize-cells")
						.on(
						  "change.resize-cells afterCommand.resize-cells afterSetMode.resize-cells",
						  function () {
							(0, a.$$)("table", e.editor).forEach(t.observe);
						  },
						)
						.on(this.j.ow, "scroll.resize-cells", function () {
						  if (t.drag) {
							var o = l.Dom.up(
							  t.workCell,
							  function (e) {
								return l.Dom.isTag(e, "table");
							  },
							  e.editor,
							);
							if (o) {
							  var n = o.getBoundingClientRect();
							  t.resizeHandler.style.top = n.top + "px";
							}
						  }
						})
						.on("beforeSetMode.resize-cells", function () {
						  t.module.getAllSelectedCells().forEach(function (o) {
							t.module.removeSelection(o),
							  i.Table.normalizeTable(
								l.Dom.closest(o, "table", e.editor),
							  );
						  });
						});
				  }),
				  (t.prototype.observe = function (e) {
					var t = this;
					(0, a.dataBind)(e, u) ||
					  ((0, a.dataBind)(e, u, !0),
					  this.j.e
						.on(e, "mouseleave.resize-cells", function (e) {
						  t.resizeHandler &&
							t.resizeHandler !== e.relatedTarget &&
							t.hideResizeHandle();
						})
						.on(
						  e,
						  "mousemove.resize-cells touchmove.resize-cells",
						  this.j.async.throttle(
							function (o) {
							  if (!t.j.isLocked) {
								var n = l.Dom.up(o.target, l.Dom.isCell, e);
								n && t.calcHandlePosition(e, n, o.offsetX);
							  }
							},
							{ timeout: this.j.defaultTimeout },
						  ),
						),
					  this.createResizeHandle());
				  }),
				  (t.prototype.beforeDestruct = function (e) {
					e.events &&
					  (e.e.off(this.j.ow, ".resize-cells"),
					  e.e.off(".resize-cells"));
				  }),
				  n.__decorate(
					[s.autobind],
					t.prototype,
					"onHandleMouseDown",
					null,
				  ),
				  n.__decorate([s.autobind], t.prototype, "onMouseMove", null),
				  n.__decorate([s.autobind], t.prototype, "onMouseUp", null),
				  n.__decorate([s.autobind], t.prototype, "observe", null),
				  t
				);
			  })(i.Plugin);
			(t.resizeCells = d), c.pluginSystem.add("resizeCells", d);
		  },
		  91637: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.allowResizeX = !1),
			  (n.Config.prototype.allowResizeY = !0);
		  },
		  90523: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.resizeHandler = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(64968),
			  a = o(43441),
			  s = o(2074),
			  l = o(17332);
			o(91637);
			var c = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.isResized = !1),
				  (t.start = { x: 0, y: 0, w: 0, h: 0 }),
				  (t.handle = t.j.c.div(
					"jodit-editor__resize",
					s.Icon.get("resize_handler"),
				  )),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this,
					o = e.o,
					n = o.height,
					r = o.width,
					i = e.o.allowResizeY;
				  "auto" === n && "auto" !== r && (i = !1),
					("auto" === n && "auto" === r) ||
					  (!o.allowResizeX && !i) ||
					  (e.statusbar.setMod("resize-handle", !0),
					  e.e
						.on("toggleFullSize.resizeHandler", function () {
						  t.handle.style.display = e.isFullSize
							? "none"
							: "block";
						})
						.on(
						  this.handle,
						  "mousedown touchstart",
						  this.onHandleResizeStart,
						)
						.on(e.ow, "mouseup touchend", this.onHandleResizeEnd),
					  e.container.appendChild(this.handle));
				}),
				(t.prototype.onHandleResizeStart = function (e) {
				  (this.isResized = !0),
					(this.start.x = e.clientX),
					(this.start.y = e.clientY),
					(this.start.w = this.j.container.offsetWidth),
					(this.start.h = this.j.container.offsetHeight),
					this.j.lock(),
					this.j.e.on(
					  this.j.ow,
					  "mousemove touchmove",
					  this.onHandleResize,
					),
					e.preventDefault();
				}),
				(t.prototype.onHandleResize = function (e) {
				  this.isResized &&
					(this.j.o.allowResizeY &&
					  this.j.e.fire(
						"setHeight",
						this.start.h + e.clientY - this.start.y,
					  ),
					this.j.o.allowResizeX &&
					  this.j.e.fire(
						"setWidth",
						this.start.w + e.clientX - this.start.x,
					  ),
					this.j.e.fire("resize"));
				}),
				(t.prototype.onHandleResizeEnd = function () {
				  this.isResized &&
					((this.isResized = !1),
					this.j.e.off(
					  this.j.ow,
					  "mousemove touchmove",
					  this.onHandleResize,
					),
					this.j.unlock());
				}),
				(t.prototype.beforeDestruct = function () {
				  i.Dom.safeRemove(this.handle),
					this.j.e.off(
					  this.j.ow,
					  "mouseup touchsend",
					  this.onHandleResizeEnd,
					);
				}),
				(t.requires = ["size"]),
				n.__decorate([a.autobind], t)
			  );
			})(r.Plugin);
			(t.resizeHandler = c), l.pluginSystem.add("resizeHandler", c);
		  },
		  36560: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.allowResizeTags = [
			  "img",
			  "iframe",
			  "table",
			  "jodit",
			]),
			  (n.Config.prototype.resizer = {
				showSize: !0,
				hideSizeTimeout: 1e3,
				forImageChangeAttributes: !0,
				min_width: 10,
				min_height: 10,
				useAspectRatio: ["img"],
			  });
		  },
		  69257: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.resizer = void 0);
			var n = o(20255);
			o(6316);
			var r = o(86893),
			  i = o(86893),
			  a = o(24263),
			  s = o(40332),
			  l = o(85605),
			  c = o(17332),
			  u = o(43441),
			  d = o(17332);
			o(36560);
			var p = "__jodit-resizer_binded",
			  f = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.LOCK_KEY = "resizer"),
					(t.element = null),
					(t.isResizeMode = !1),
					(t.isShown = !1),
					(t.startX = 0),
					(t.startY = 0),
					(t.width = 0),
					(t.height = 0),
					(t.ratio = 0),
					(t.rect = t.j.c.fromHTML(
					  '<div title="'.concat(
						t.j.i18n("Press Alt for custom resizing"),
						'" class="jodit-resizer">\n\t\t\t\t<div class="jodit-resizer__top-left"></div>\n\t\t\t\t<div class="jodit-resizer__top-right"></div>\n\t\t\t\t<div class="jodit-resizer__bottom-right"></div>\n\t\t\t\t<div class="jodit-resizer__bottom-left"></div>\n\t\t\t\t<span>100x100</span>\n\t\t\t</div>',
					  ),
					)),
					(t.sizeViewer = t.rect.getElementsByTagName("span")[0]),
					(t.pointerX = 0),
					(t.pointerY = 0),
					(t.isAltMode = !1),
					(t.onClickElement = function (e) {
					  t.isResizeMode ||
						(t.element === e && t.isShown) ||
						((t.element = e),
						t.show(),
						a.Dom.isTag(t.element, "img") &&
						  !t.element.complete &&
						  t.j.e.one(t.element, "load", t.updateSize));
					}),
					(t.updateSize = function () {
					  if (!t.isInDestruct && t.isShown && t.element && t.rect) {
						t.element.width = t.element.height = Math.min(t.element.width, t.element.height);
						var e = t.getWorkplacePosition(),
						  o = (0, s.offset)(t.element, t.j, t.j.ed),
						  n = parseInt(t.rect.style.left || "0", 10),
						  r = parseInt(t.rect.style.top || "0", 10),
						  i = o.top - e.top,
						  a = o.left - e.left;
						(r === i &&
						  n === a &&
						  t.rect.offsetWidth === t.element.offsetWidth &&
						  t.rect.offsetHeight === t.element.offsetHeight) ||
						  ((0, s.css)(t.rect, {
							top: i,
							left: a,
							width: t.element.offsetWidth,
							height: t.element.offsetHeight,
						  }),
						  t.j.events &&
							(t.j.e.fire(t.element, "changesize"),
							isNaN(n) || t.j.e.fire("resize")));
					  }
					}),
					(t.hideSizeViewer = function () {
					  t.sizeViewer.style.opacity = "0";
					}),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.afterInit = function (e) {
					var t = this;
					(0, s.$$)("div", this.rect).forEach(function (o) {
					  e.e.on(
						o,
						"mousedown.resizer touchstart.resizer",
						t.onStartResizing.bind(t, o),
					  );
					}),
					  c.eventEmitter.on("hideHelpers", this.hide),
					  e.e
						.on("readonly", function (e) {
						  e && t.hide();
						})
						.on(
						  "afterInit changePlace",
						  this.addEventListeners.bind(this),
						)
						.on("afterGetValueFromEditor.resizer", function (e) {
						  var t =
							/<jodit[^>]+data-jodit_iframe_wrapper[^>]+>(.*?<iframe[^>]*>.*?<\/iframe>.*?)<\/jodit>/gi;
						  t.test(e.value) && (e.value = e.value.replace(t, "$1"));
						})
						.on("hideResizer", this.hide)
						.on("change afterInit afterSetMode", this.onChangeEditor),
					  this.addEventListeners(),
					  this.onChangeEditor();
				  }),
				  (t.prototype.onEditorClick = function (e) {
					for (
					  var t = e.target,
						o = this.j,
						n = o.editor,
						r = o.options.allowResizeTags;
					  t && t !== n;
  
					) {
					  if (a.Dom.isTag(t, r))
						return this.bind(t), void this.onClickElement(t);
					  t = t.parentNode;
					}
				  }),
				  (t.prototype.addEventListeners = function () {
					var e = this,
					  t = this.j;
					t.e
					  .off(t.editor, ".resizer")
					  .off(t.ow, ".resizer")
					  .on(t.editor, "keydown.resizer", function (t) {
						e.isShown &&
						  t.key === r.KEY_DELETE &&
						  e.element &&
						  !a.Dom.isTag(e.element, "table") &&
						  e.onDelete(t);
					  })
					  .on(t.ow, "resize.resizer", this.updateSize)
					  .on("resize.resizer", this.updateSize)
					  .on([t.ow, t.editor], "scroll.resizer", function () {
						e.isShown && !e.isResizeMode && e.hide();
					  })
					  .on(t.ow, "keydown.resizer", this.onKeyDown)
					  .on(t.ow, "keyup.resizer", this.onKeyUp)
					  .on(
						t.ow,
						"mouseup.resizer touchend.resizer",
						this.onClickOutside,
					  );
				  }),
				  (t.prototype.onStartResizing = function (e, t) {
					if (!this.element || !this.element.parentNode)
					  return this.hide(), !1;
					(this.handle = e),
					  t.cancelable && t.preventDefault(),
					  t.stopImmediatePropagation(),
					  (this.width = this.element.offsetWidth),
					  (this.height = this.element.offsetHeight),
					  (this.ratio = this.width / this.height),
					  (this.isResizeMode = !0),
					  (this.startX = t.clientX),
					  (this.startY = t.clientY),
					  (this.pointerX = t.clientX),
					  (this.pointerY = t.clientY);
					var o = this.j;
					o.e.fire("hidePopup"),
					  o.lock(this.LOCK_KEY),
					  o.e.on(
						o.ow,
						"mousemove.resizer touchmove.resizer",
						this.onResize,
					  );
				  }),
				  (t.prototype.onEndResizing = function () {
					var e = this.j;
					e.unlock(),
					  (this.isResizeMode = !1),
					  (this.isAltMode = !1),
					  e.synchronizeValues(),
					  e.e.off(
						e.ow,
						"mousemove.resizer touchmove.resizer",
						this.onResize,
					  );
				  }),
				  (t.prototype.onResize = function (e) {
					if (this.isResizeMode) {
					  if (!this.element) return;
					  (this.pointerX = e.clientX), (this.pointerY = e.clientY);
					  var t = void 0,
						o = void 0;
					  if (this.j.options.iframe) {
						var n = this.getWorkplacePosition();
						(t = e.clientX + n.left - this.startX),
						  (o = e.clientY + n.top - this.startY);
					  } else
						(t = this.pointerX - this.startX),
						  (o = this.pointerY - this.startY);
					  var r = this.handle.className,
						i = 0,
						l = 0,
						c = this.j.o.resizer.useAspectRatio;
					  !this.isAltMode &&
					  (!0 === c ||
						(Array.isArray(c) && a.Dom.isTag(this.element, c)))
						? (t
							? ((i = this.width + (r.match(/left/) ? -1 : 1) * t),
							  (l = Math.round(i / this.ratio)))
							: ((l = this.height + (r.match(/top/) ? -1 : 1) * o),
							  (i = Math.round(l * this.ratio))),
						  i > (0, s.innerWidth)(this.j.editor, this.j.ow) &&
							((i = (0, s.innerWidth)(this.j.editor, this.j.ow)),
							(l = Math.round(i / this.ratio))))
						: ((i = this.width + (r.match(/left/) ? -1 : 1) * t),
						  (l = this.height + (r.match(/top/) ? -1 : 1) * o)),
						i > this.j.o.resizer.min_width &&
						  this.applySize(
							this.element,
							"width",
							this.rect.parentNode.offsetWidth > i ? i : "100%",
						  ),
						l > this.j.o.resizer.min_height &&
						  this.applySize(this.element, "height", l),
						this.updateSize(),
						this.showSizeViewer(
						  this.element.offsetWidth,
						  this.element.offsetHeight,
						),
						e.stopImmediatePropagation();
					}
				  }),
				  (t.prototype.onKeyDown = function (e) {
					(this.isAltMode = e.key === i.KEY_ALT),
					  !this.isAltMode &&
						this.isResizeMode &&
						this.onEndResizing();
				  }),
				  (t.prototype.onKeyUp = function () {
					this.isAltMode &&
					  this.isResizeMode &&
					  this.element &&
					  ((this.width = this.element.offsetWidth),
					  (this.height = this.element.offsetHeight),
					  (this.ratio = this.width / this.height),
					  (this.startX = this.pointerX),
					  (this.startY = this.pointerY)),
					  (this.isAltMode = !1);
				  }),
				  (t.prototype.onClickOutside = function (e) {
					if (this.isShown) {
					  if (!this.isResizeMode) return this.hide();
					  e.stopImmediatePropagation(), this.onEndResizing();
					}
				  }),
				  (t.prototype.getWorkplacePosition = function () {
					return (0, s.offset)(
					  this.rect.parentNode || this.j.od.documentElement,
					  this.j,
					  this.j.od,
					  !0,
					);
				  }),
				  (t.prototype.applySize = function (e, t, o) {
					var n =
					  a.Dom.isImage(e) &&
					  this.j.o.resizer.forImageChangeAttributes;
					n && (0, s.attr)(e, t, o),
					  (n && !e.style[t]) || (0, s.css)(e, t, o);
				  }),
				  (t.prototype.onDelete = function (e) {
					this.element &&
					  ("JODIT" !== this.element.tagName
						? this.j.s.select(this.element)
						: (a.Dom.safeRemove(this.element),
						  this.hide(),
						  e.preventDefault()));
				  }),
				  (t.prototype.onChangeEditor = function () {
					this.isShown &&
					  (this.element && this.element.parentNode
						? this.updateSize()
						: this.hide()),
					  (0, s.$$)("iframe", this.j.editor).forEach(this.bind);
				  }),
				  (t.prototype.bind = function (e) {
					var t = this;
					if (
					  a.Dom.isHTMLElement(e) &&
					  this.j.o.allowResizeTags.includes(
						e.tagName.toLowerCase(),
					  ) &&
					  !(0, s.dataBind)(e, p)
					) {
					  var o;
					  if (((0, s.dataBind)(e, p, !0), a.Dom.isTag(e, "iframe"))) {
						var n = e;
						a.Dom.isHTMLElement(e.parentNode) &&
						(0, s.attr)(e.parentNode, "-jodit_iframe_wrapper")
						  ? (e = e.parentNode)
						  : ((o = this.j.createInside.element("jodit", {
							  "data-jodit-temp": 1,
							  contenteditable: !1,
							  draggable: !0,
							  "data-jodit_iframe_wrapper": 1,
							})),
							(0, s.attr)(o, "style", (0, s.attr)(e, "style")),
							(0, s.css)(o, {
							  display:
								"inline-block" === e.style.display
								  ? "inline-block"
								  : "block",
							  width: e.offsetWidth,
							  height: e.offsetHeight,
							}),
							e.parentNode && e.parentNode.insertBefore(o, e),
							o.appendChild(e),
							this.j.e.on(o, "click", function () {
							  (0, s.attr)(o, "data-jodit-wrapper_active", !0);
							}),
							(e = o)),
						  this.j.e
							.off(e, "mousedown.select touchstart.select")
							.on(
							  e,
							  "mousedown.select touchstart.select",
							  function () {
								t.j.s.select(e);
							  },
							)
							.off(e, "changesize")
							.on(e, "changesize", function () {
							  n.setAttribute("width", e.offsetWidth + "px"),
								n.setAttribute("height", e.offsetHeight + "px");
							});
					  }
					  this.j.e.on(e, "dragstart", this.hide),
						i.IS_IE &&
						  this.j.e.on(e, "mousedown", function (t) {
							a.Dom.isTag(e, "img") && t.preventDefault();
						  });
					}
				  }),
				  (t.prototype.showSizeViewer = function (e, t) {
					this.j.o.resizer.showSize &&
					  (this.sizeViewer.offsetWidth > e ||
					  this.sizeViewer.offsetHeight > t
						? this.hideSizeViewer()
						: ((this.sizeViewer.style.opacity = "1"),
						  (this.sizeViewer.textContent = ""
							.concat(e, " x ")
							.concat(t)),
						  this.j.async.setTimeout(this.hideSizeViewer, {
							timeout: this.j.o.resizer.hideSizeTimeout,
							label: "hideSizeViewer",
						  })));
				  }),
				  (t.prototype.show = function () {
					this.j.o.readonly ||
					  this.isShown ||
					  ((this.isShown = !0),
					  this.rect.parentNode ||
						((0, s.markOwner)(this.j, this.rect),
						this.j.workplace.appendChild(this.rect)),
					  this.j.isFullSize &&
						(this.rect.style.zIndex = (0, s.css)(
						  this.j.container,
						  "zIndex",
						).toString()),
					  this.updateSize());
				  }),
				  (t.prototype.hide = function () {
					this.isResizeMode ||
					  ((this.isResizeMode = !1),
					  (this.isShown = !1),
					  (this.element = null),
					  a.Dom.safeRemove(this.rect),
					  (0, s.$$)(
						"[data-jodit-wrapper_active='true']",
						this.j.editor,
					  ).forEach(function (e) {
						return (0, s.attr)(e, "data-jodit-wrapper_active", !1);
					  }));
				  }),
				  (t.prototype.beforeDestruct = function (e) {
					this.hide(),
					  c.eventEmitter.off("hideHelpers", this.hide),
					  e.e.off(this.j.ow, ".resizer").off(".resizer");
				  }),
				  n.__decorate(
					[(0, u.watch)(":click")],
					t.prototype,
					"onEditorClick",
					null,
				  ),
				  n.__decorate(
					[u.autobind],
					t.prototype,
					"onStartResizing",
					null,
				  ),
				  n.__decorate([u.autobind], t.prototype, "onEndResizing", null),
				  n.__decorate([u.autobind], t.prototype, "onResize", null),
				  n.__decorate([u.autobind], t.prototype, "onKeyDown", null),
				  n.__decorate([u.autobind], t.prototype, "onKeyUp", null),
				  n.__decorate([u.autobind], t.prototype, "onClickOutside", null),
				  n.__decorate(
					[(0, u.debounce)()],
					t.prototype,
					"onChangeEditor",
					null,
				  ),
				  n.__decorate([u.autobind], t.prototype, "bind", null),
				  n.__decorate([u.autobind], t.prototype, "hide", null),
				  t
				);
			  })(l.Plugin);
			(t.resizer = f), d.pluginSystem.add("resizer", f);
		  },
		  61975: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(77904);
			o(59535),
			  (n.Config.prototype.useSearch = !0),
			  (n.Config.prototype.search = { lazyIdleTimeout: 0 }),
			  r.Icon.set("search", o(41197)),
			  (n.Config.prototype.controls.find = {
				tooltip: "Find",
				icon: "search",
				exec: function (e, t, o) {
				  var n = o.control;
				  switch (n.args && n.args[0]) {
					case "findPrevious":
					  e.e.fire("searchPrevious");
					  break;
					case "findNext":
					  e.e.fire("searchNext");
					  break;
					case "replace":
					  e.execCommand("openReplaceDialog");
					  break;
					default:
					  e.execCommand("openSearchDialog");
				  }
				},
				list: {
				  search: "Find",
				  findNext: "Find Next",
				  findPrevious: "Find Previous",
				  replace: "Replace",
				},
				childTemplate: function (e, t, o) {
				  return o;
				},
			  });
		  },
		  73934: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(18562), t), n.__exportStar(o(3928), t);
		  },
		  18562: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.SentenceFinder = void 0);
			var n = o(20255),
			  r = o(93163),
			  i = (function () {
				function e(e) {
				  void 0 === e && (e = r.fuzzySearchIndex),
					(this.searchIndex = e),
					(this.queue = []),
					(this.value = "");
				}
				return (
				  (e.prototype.add = function (e) {
					var t,
					  o = (
						null !== (t = e.nodeValue) && void 0 !== t ? t : ""
					  ).toLowerCase();
					if (o.length) {
					  var n = this.value.length;
					  this.queue.push({
						startIndex: n,
						endIndex: n + o.length,
						node: e,
					  }),
						(this.value += o);
					}
				  }),
				  (e.prototype.ranges = function (e, t) {
					var o;
					void 0 === t && (t = 0);
					var r = [],
					  i = t,
					  a = 0,
					  s = 0;
					do {
					  if (
						((a = (o = n.__read(
						  this.searchIndex(e, this.value, i),
						  2,
						))[1]),
						-1 !== (i = o[0]))
					  ) {
						for (
						  var l = void 0, c = 0, u = void 0, d = 0, p = s;
						  this.queue.length > p;
						  p += 1
						)
						  if (
							(!l &&
							  this.queue[p].endIndex > i &&
							  ((l = this.queue[p].node),
							  (c = i - this.queue[p].startIndex)),
							l && this.queue[p].endIndex >= i + a)
						  ) {
							(u = this.queue[p].node),
							  (d = i + a - this.queue[p].startIndex),
							  (s = p);
							break;
						  }
						l &&
						  u &&
						  r.push({
							startContainer: l,
							startOffset: c,
							endContainer: u,
							endOffset: d,
						  }),
						  (i += a);
					  }
					} while (-1 !== i);
					return 0 === r.length ? null : r;
				  }),
				  e
				);
			  })();
			t.SentenceFinder = i;
		  },
		  3928: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.isSelectionWrapper =
				t.clearSelectionWrappersFromHTML =
				t.clearSelectionWrappers =
				t.getSelectionWrappers =
				t.wrapRangesTextsInTmpSpan =
				  void 0);
			var n = o(20255),
			  r = o(24263),
			  i = o(54188),
			  a = "jd-tmp-selection";
			function s(e) {
			  return (0, i.$$)("[".concat(a, "]"), e);
			}
			function l(e) {
			  return r.Dom.isElement(e) && e.hasAttribute(a);
			}
			(t.wrapRangesTextsInTmpSpan = function (e, t, o, i) {
			  var s, c, u;
			  if (
				null != e.startContainer.nodeValue &&
				null != e.endContainer.nodeValue
			  ) {
				var d = o.element("span", (((s = {})[a] = !0), s));
				r.Dom.markTemporary(d);
				var p = e.startContainer.nodeValue,
				  f = 0;
				if (0 !== e.startOffset) {
				  var h = o.text(p.substring(0, e.startOffset));
				  (e.startContainer.nodeValue = p.substring(e.startOffset)),
					r.Dom.before(e.startContainer, h),
					e.startContainer === e.endContainer &&
					  (e.endOffset -= f = e.startOffset),
					(e.startOffset = 0);
				}
				var m = e.endContainer.nodeValue;
				if (e.endOffset !== m.length) {
				  (h = o.text(m.substring(e.endOffset))),
					(e.endContainer.nodeValue = m.substring(0, e.endOffset)),
					r.Dom.after(e.endContainer, h);
				  try {
					for (
					  var v = n.__values(t), g = v.next();
					  !g.done;
					  g = v.next()
					) {
					  var y = g.value;
					  if (y.startContainer !== e.endContainer) break;
					  (y.startContainer = h),
						(y.startOffset = y.startOffset - e.endOffset - f),
						y.endContainer === e.endContainer &&
						  ((y.endContainer = h),
						  (y.endOffset = y.endOffset - e.endOffset - f));
					}
				  } catch (e) {
					c = { error: e };
				  } finally {
					try {
					  g && !g.done && (u = v.return) && u.call(v);
					} finally {
					  if (c) throw c.error;
					}
				  }
				  e.endOffset = e.endContainer.nodeValue.length;
				}
				var _ = e.startContainer;
				do {
				  if (!_) break;
				  if (
					(r.Dom.isText(_) &&
					  !l(_.parentNode) &&
					  r.Dom.wrap(_, d.cloneNode(), o),
					_ === e.endContainer)
				  )
					break;
				  var b = _.firstChild || _.nextSibling;
				  if (!b) {
					for (; _ && !_.nextSibling && _ !== i; ) _ = _.parentNode;
					b = null == _ ? void 0 : _.nextSibling;
				  }
				  _ = b;
				} while (_ && _ !== i);
			  }
			}),
			  (t.getSelectionWrappers = s),
			  (t.clearSelectionWrappers = function (e) {
				s(e).forEach(function (e) {
				  return r.Dom.unwrap(e);
				});
			  }),
			  (t.clearSelectionWrappersFromHTML = function (e) {
				return e.replace(
				  RegExp("<span[^>]+".concat(a, "[^>]+>(.*?)</span>"), "g"),
				  "$1",
				);
			  }),
			  (t.isSelectionWrapper = l);
		  },
		  59535: function () {},
		  14889: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.search = void 0);
			var n = o(20255),
			  r = o(64968),
			  i = o(57549),
			  a = o(43441),
			  s = o(72235),
			  l = o(40332),
			  c = o(17332),
			  u = o(73934);
			o(61975);
			var d = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.buttons = [{ name: "find", group: "search" }]),
				  (t.previousQuery = ""),
				  (t.drawPromise = null),
				  (t.walker = null),
				  (t.walkerCount = null),
				  (t.cache = {}),
				  (t.wrapFrameRequest = 0),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				Object.defineProperty(t.prototype, "ui", {
				  get: function () {
					return new s.UISearch(this.j);
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(t.prototype.updateCounters = function () {
				  return n.__awaiter(this, void 0, Promise, function () {
					var e;
					return n.__generator(this, function (t) {
					  switch (t.label) {
						case 0:
						  return this.ui.isOpened
							? ((e = this.ui), [4, this.calcCounts(this.ui.query)])
							: [2];
						case 1:
						  return (e.count = t.sent()), [2];
					  }
					});
				  });
				}),
				(t.prototype.onPressReplaceButton = function () {
				  this.findAndReplace(this.ui.query), this.updateCounters();
				}),
				(t.prototype.tryScrollToElement = function (e) {
				  var t = r.Dom.closest(e, r.Dom.isElement, this.j.editor);
				  t || (t = r.Dom.prev(e, r.Dom.isElement, this.j.editor)),
					t &&
					  t !== this.j.editor &&
					  (0, l.scrollIntoViewIfNeeded)(t, this.j.editor, this.j.ed);
				}),
				(t.prototype.calcCounts = function (e) {
				  return n.__awaiter(this, void 0, Promise, function () {
					return n.__generator(this, function (t) {
					  switch (t.label) {
						case 0:
						  return [4, this.findQueryBounds(e, "walkerCount")];
						case 1:
						  return [2, t.sent().length];
					  }
					});
				  });
				}),
				(t.prototype.findQueryBounds = function (e, t) {
				  return n.__awaiter(this, void 0, Promise, function () {
					var o;
					return n.__generator(this, function (n) {
					  return (
						(o = this[t]) && o.break(),
						(o = new r.LazyWalker(this.j.async, {
						  timeout: this.j.o.search.lazyIdleTimeout,
						})),
						(this[t] = o),
						[
						  2,
						  this.find(o, e).catch(function (e) {
							return [];
						  }),
						]
					  );
					});
				  });
				}),
				(t.prototype.findAndReplace = function (e) {
				  return n.__awaiter(this, void 0, Promise, function () {
					var t, o, i, a, s;
					return n.__generator(this, function (n) {
					  switch (n.label) {
						case 0:
						  return [4, this.findQueryBounds(e, "walker")];
						case 1:
						  if (!(t = n.sent()).length) return [2, !1];
						  if (
							(-1 ===
							  (o = this.findCurrentIndexInRanges(
								t,
								this.j.s.range,
							  )) && (o = 0),
							!(i = t[o]))
						  )
							return [3, 6];
						  n.label = 2;
						case 2:
						  return (
							n.trys.push([2, , 4, 5]),
							(a = this.j.ed.createRange()).setStart(
							  i.startContainer,
							  i.startOffset,
							),
							a.setEnd(i.endContainer, i.endOffset),
							a.deleteContents(),
							(s = this.j.createInside.text(this.ui.replace)),
							r.Dom.safeInsertNode(a, s),
							(0, u.clearSelectionWrappers)(this.j.editor),
							this.j.s.setCursorAfter(s),
							this.tryScrollToElement(s),
							(this.cache = {}),
							(this.ui.currentIndex = o),
							[
							  4,
							  this.findAndSelect(e, !0).catch(function (e) {
								return null;
							  }),
							]
						  );
						case 3:
						  return n.sent(), [3, 5];
						case 4:
						  return this.j.synchronizeValues(), [7];
						case 5:
						  return this.j.e.fire("afterFindAndReplace"), [2, !0];
						case 6:
						  return [2, !1];
					  }
					});
				  });
				}),
				(t.prototype.findAndSelect = function (e, t) {
				  var o;
				  return n.__awaiter(this, void 0, Promise, function () {
					var r, i, a, s;
					return n.__generator(this, function (n) {
					  switch (n.label) {
						case 0:
						  return [4, this.findQueryBounds(e, "walker")];
						case 1:
						  if (!(r = n.sent()).length) return [2, !1];
						  if (
							((this.previousQuery === e &&
							  (0, u.getSelectionWrappers)(this.j.editor)
								.length) ||
							  (null === (o = this.drawPromise) ||
								void 0 === o ||
								o.rejectCallback(),
							  this.j.async.cancelAnimationFrame(
								this.wrapFrameRequest,
							  ),
							  (0, u.clearSelectionWrappers)(this.j.editor),
							  (this.drawPromise = this.drawSelectionRanges(r))),
							(this.previousQuery = e),
							(this.ui.currentIndex =
							  (i =
								-1 == (i = this.ui.currentIndex - 1)
								  ? 0
								  : t
									? i === r.length - 1
									  ? 0
									  : i + 1
									: 0 === i
									  ? r.length - 1
									  : i - 1) + 1),
							!(a = r[i]))
						  )
							return [3, 4];
						  s = this.j.ed.createRange();
						  try {
							s.setStart(a.startContainer, a.startOffset),
							  s.setEnd(a.endContainer, a.endOffset),
							  this.j.s.selectRange(s);
						  } catch (e) {}
						  return (
							this.tryScrollToElement(a.startContainer),
							[4, this.updateCounters()]
						  );
						case 2:
						  return n.sent(), [4, this.drawPromise];
						case 3:
						  return (
							n.sent(), this.j.e.fire("afterFindAndSelect"), [2, !0]
						  );
						case 4:
						  return [2, !1];
					  }
					});
				  });
				}),
				(t.prototype.findCurrentIndexInRanges = function (e, t) {
				  return e.findIndex(function (e) {
					return (
					  e.startContainer === t.startContainer &&
					  e.startOffset === t.startOffset &&
					  e.endContainer === t.startContainer &&
					  e.endOffset === t.endOffset
					);
				  });
				}),
				(t.prototype.isValidCache = function (e) {
				  return n.__awaiter(this, void 0, Promise, function () {
					return n.__generator(this, function (t) {
					  switch (t.label) {
						case 0:
						  return [4, e];
						case 1:
						  return [
							2,
							t.sent().every(function (e) {
							  var t, o, n, r;
							  return (
								e.startContainer.isConnected &&
								e.startOffset <=
								  (null !==
									(o =
									  null === (t = e.startContainer.nodeValue) ||
									  void 0 === t
										? void 0
										: t.length) && void 0 !== o
									? o
									: 0) &&
								e.endContainer.isConnected &&
								e.endOffset <=
								  (null !==
									(r =
									  null === (n = e.endContainer.nodeValue) ||
									  void 0 === n
										? void 0
										: n.length) && void 0 !== r
									? r
									: 0)
							  );
							}),
						  ];
					  }
					});
				  });
				}),
				(t.prototype.find = function (e, t) {
				  return n.__awaiter(this, void 0, Promise, function () {
					var o,
					  i,
					  a = this;
					return n.__generator(this, function (n) {
					  switch (n.label) {
						case 0:
						  return t.length
							? (i = o = this.cache[t])
							  ? [4, this.isValidCache(o)]
							  : [3, 2]
							: [2, []];
						case 1:
						  (i = n.sent()), (n.label = 2);
						case 2:
						  return i
							? [2, o]
							: ((this.cache[t] = this.j.async.promise(
								function (o) {
								  var n = new u.SentenceFinder(
									a.j.o.search.fuzzySearch,
								  );
								  e.on("break", function () {
									o([]);
								  })
									.on("visit", function (e) {
									  return r.Dom.isText(e) && n.add(e), !1;
									})
									.on("end", function () {
									  var e;
									  o(
										null !== (e = n.ranges(t)) && void 0 !== e
										  ? e
										  : [],
									  );
									})
									.setWork(a.j.editor);
								},
							  )),
							  [2, this.cache[t]]);
					  }
					});
				  });
				}),
				(t.prototype.drawSelectionRanges = function (e) {
				  var t = this,
					o = this.j,
					r = o.async,
					i = o.createInside,
					a = o.editor;
				  r.cancelAnimationFrame(this.wrapFrameRequest);
				  var s,
					l = n.__spreadArray([], n.__read(e), !1),
					c = 0;
				  return r.promise(function (e) {
					var o = function () {
					  do {
						(s = l.shift()) &&
						  (0, u.wrapRangesTextsInTmpSpan)(s, l, i, a),
						  (c += 1);
					  } while (s && 5 >= c);
					  l.length
						? (t.wrapFrameRequest = r.requestAnimationFrame(o))
						: e();
					};
					o();
				  });
				}),
				(t.prototype.onAfterGetValueFromEditor = function (e) {
				  e.value = (0, u.clearSelectionWrappersFromHTML)(e.value);
				}),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  if (e.o.useSearch) {
					var o = this;
					e.e
					  .on("beforeSetMode.search", function () {
						t.ui.close();
					  })
					  .on(this.ui, "afterClose", function () {
						(0, u.clearSelectionWrappers)(e.editor),
						  (t.ui.currentIndex = 0),
						  (t.ui.count = 0),
						  (t.cache = {});
					  })
					  .on("click", function () {
						(t.ui.currentIndex = 0),
						  (0, u.clearSelectionWrappers)(e.editor);
					  })
					  .on("change.search", function () {
						t.cache = {};
					  })
					  .on(
						"keydown.search mousedown.search",
						e.async.debounce(function () {
						  t.ui.selInfo &&
							(e.s.removeMarkers(), (t.ui.selInfo = null)),
							t.ui.isOpened && t.updateCounters();
						}, e.defaultTimeout),
					  )
					  .on("searchNext.search searchPrevious.search", function () {
						return (
						  t.ui.isOpened || t.ui.open(),
						  o
							.findAndSelect(
							  o.ui.query,
							  "searchNext" === e.e.current,
							)
							.catch(function (e) {})
						);
					  })
					  .on("search.search", function (e, n) {
						return (
						  void 0 === n && (n = !0),
						  (t.ui.currentIndex = 0),
						  o.findAndSelect(e || "", n).catch(function (e) {})
						);
					  }),
					  e
						.registerCommand("search", {
						  exec: function (e, t, n) {
							return (
							  void 0 === n && (n = !0),
							  t && o.findAndSelect(t, n).catch(function (e) {}),
							  !1
							);
						  },
						})
						.registerCommand("openSearchDialog", {
						  exec: function (e, t) {
							return o.ui.open(t), !1;
						  },
						  hotkeys: ["ctrl+f", "cmd+f"],
						})
						.registerCommand("openReplaceDialog", {
						  exec: function (t, n, r) {
							return e.o.readonly || o.ui.open(n, r, !0), !1;
						  },
						  hotkeys: ["ctrl+h", "cmd+h"],
						});
				  }
				}),
				(t.prototype.beforeDestruct = function (e) {
				  this.ui.destruct(), e.e.off(".search");
				}),
				n.__decorate([a.cache], t.prototype, "ui", null),
				n.__decorate(
				  [(0, a.watch)("ui:needUpdateCounters")],
				  t.prototype,
				  "updateCounters",
				  null,
				),
				n.__decorate(
				  [(0, a.watch)("ui:pressReplaceButton")],
				  t.prototype,
				  "onPressReplaceButton",
				  null,
				),
				n.__decorate([a.autobind], t.prototype, "findQueryBounds", null),
				n.__decorate([a.autobind], t.prototype, "findAndReplace", null),
				n.__decorate([a.autobind], t.prototype, "findAndSelect", null),
				n.__decorate([a.autobind], t.prototype, "find", null),
				n.__decorate(
				  [(0, a.watch)(":afterGetValueFromEditor")],
				  t.prototype,
				  "onAfterGetValueFromEditor",
				  null,
				),
				t
			  );
			})(i.Plugin);
			(t.search = d), c.pluginSystem.add("search", d);
		  },
		  72235: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.UISearch = void 0);
			var n = o(20255);
			o(88582);
			var r = o(2074),
			  i = o(40332),
			  a = o(86893),
			  s = o(86893),
			  l = o(43441),
			  c = o(64968),
			  u = (function (e) {
				function t(t) {
				  var o = e.call(this, t) || this;
				  (o.selInfo = null), (o._currentIndex = 0), (o.isOpened = !1);
				  var n = (0, i.refs)(o.container),
					r = n.replace,
					a = n.cancel,
					l = n.next,
					c = n.prev,
					u = n.replaceBtn,
					d = n.current,
					p = n.count;
				  return (
					(o.queryInput = n.query),
					(o.replaceInput = r),
					(o.closeButton = a),
					(o.replaceButton = u),
					(o.currentBox = d),
					(o.countBox = p),
					t.e
					  .on(o.closeButton, "pointerdown", function () {
						return o.close(), !1;
					  })
					  .on(o.queryInput, "input", function () {
						o.currentIndex = 0;
					  })
					  .on(o.queryInput, "pointerdown", function () {
						t.s.isFocused() &&
						  (t.s.removeMarkers(), (o.selInfo = t.s.save()));
					  })
					  .on(o.replaceButton, "pointerdown", function () {
						return t.e.fire(o, "pressReplaceButton"), !1;
					  })
					  .on(l, "pointerdown", function () {
						return t.e.fire("searchNext"), !1;
					  })
					  .on(c, "pointerdown", function () {
						return t.e.fire("searchPrevious"), !1;
					  })
					  .on(o.queryInput, "input", function () {
						o.setMod(
						  "empty-query",
						  !(0, i.trim)(o.queryInput.value).length,
						);
					  })
					  .on(
						o.queryInput,
						"keydown",
						o.j.async.debounce(function (e) {
						  e.key === s.KEY_ENTER
							? (e.preventDefault(),
							  e.stopImmediatePropagation(),
							  t.e.fire("searchNext") && o.close())
							: t.e.fire(o, "needUpdateCounters");
						}, o.j.defaultTimeout),
					  ),
					o
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.className = function () {
					return "UISearch";
				  }),
				  (t.prototype.render = function () {
					return '<div>\n\t\t\t<div class="&__box">\n\t\t\t\t<div class="&__inputs">\n\t\t\t\t\t<input data-ref="query" tabindex="0" placeholder="~Search for~" type="text"/>\n\t\t\t\t\t<input data-ref="replace" tabindex="0" placeholder="~Replace with~" type="text"/>\n\t\t\t\t</div>\n\t\t\t\t<div class="&__counts">\n\t\t\t\t\t<span data-ref="counter-box">\n\t\t\t\t\t\t<span data-ref="current">0</span><span>/</span><span data-ref="count">0</span>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="&__buttons">\n\t\t\t\t\t<button data-ref="next" tabindex="0" type="button">'
					  .concat(
						r.Icon.get("angle-down"),
						'</button>\n\t\t\t\t\t<button data-ref="prev" tabindex="0" type="button">',
					  )
					  .concat(
						r.Icon.get("angle-up"),
						'</button>\n\t\t\t\t\t<button data-ref="cancel" tabindex="0" type="button">',
					  )
					  .concat(
						r.Icon.get("cancel"),
						'</button>\n\t\t\t\t\t<button data-ref="replace-btn" tabindex="0" type="button" class="jodit-ui-button">~Replace~</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>',
					  );
				  }),
				  Object.defineProperty(t.prototype, "currentIndex", {
					get: function () {
					  return this._currentIndex;
					},
					set: function (e) {
					  (this._currentIndex = e),
						(this.currentBox.innerText = e.toString());
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "count", {
					set: function (e) {
					  this.countBox.innerText = e.toString();
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "query", {
					get: function () {
					  return this.queryInput.value;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  Object.defineProperty(t.prototype, "replace", {
					get: function () {
					  return this.replaceInput.value;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.onEditorKeyDown = function (e) {
					if (this.isOpened) {
					  var t = this.j;
					  if (t.getRealMode() === a.MODE_WYSIWYG)
						switch (e.key) {
						  case s.KEY_ESC:
							this.close();
							break;
						  case s.KEY_F3:
							this.queryInput.value &&
							  (t.e.fire(
								e.shiftKey ? "searchPrevious" : "searchNext",
							  ),
							  e.preventDefault());
						}
					}
				  }),
				  (t.prototype.open = function (e, t, o) {
					void 0 === o && (o = !1),
					  this.isOpened ||
						(this.j.workplace.appendChild(this.container),
						(this.isOpened = !0)),
					  this.calcSticky(
						this.j.e.fire("getStickyState.sticky") || !1,
					  ),
					  this.j.e.fire("hidePopup"),
					  this.setMod("replace", o);
					var n = null != e ? e : (this.j.s.sel || "").toString();
					n && (this.queryInput.value = n),
					  t && (this.replaceInput.value = t),
					  this.setMod("empty-query", !n.length),
					  this.j.e.fire(this, "needUpdateCounters"),
					  n ? this.queryInput.select() : this.queryInput.focus();
				  }),
				  (t.prototype.close = function () {
					this.isOpened &&
					  (this.j.s.restore(),
					  c.Dom.safeRemove(this.container),
					  (this.isOpened = !1),
					  this.j.e.fire(this, "afterClose"));
				  }),
				  (t.prototype.calcSticky = function (e) {
					if (this.isOpened)
					  if ((this.setMod("sticky", e), e)) {
						var t = (0, i.position)(this.j.toolbarContainer);
						(0, i.css)(this.container, {
						  top: t.top + t.height,
						  left: t.left + t.width,
						});
					  } else
						(0, i.css)(this.container, { top: null, left: null });
				  }),
				  n.__decorate(
					[(0, l.watch)([":keydown", "queryInput:keydown"])],
					t.prototype,
					"onEditorKeyDown",
					null,
				  ),
				  n.__decorate([l.autobind], t.prototype, "open", null),
				  n.__decorate([l.autobind], t.prototype, "close", null),
				  n.__decorate(
					[(0, l.watch)(":toggleSticky")],
					t.prototype,
					"calcSticky",
					null,
				  ),
				  n.__decorate([l.component], t)
				);
			  })(r.UIElement);
			t.UISearch = u;
		  },
		  14189: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.tableAllowCellSelection = !0);
		  },
		  37458: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.selectCells = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(87837),
			  a = o(24263),
			  s = o(40332),
			  l = o(86893),
			  c = o(43441),
			  u = o(17332);
			o(14189);
			var d = "table_processor_observer",
			  p = "onMoveTableSelectCell",
			  f = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.requires = ["select"]),
					(t.selectedCell = null),
					(t.isSelectionMode = !1),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  Object.defineProperty(t.prototype, "module", {
					get: function () {
					  return this.j.getInstance("Table", this.j.o);
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.afterInit = function (e) {
					var t = this;
					e.o.tableAllowCellSelection &&
					  e.e
						.on("keydown.select-cells", function (e) {
						  e.key === l.KEY_TAB && t.unselectCells();
						})
						.on("beforeCommand.select-cells", this.onExecCommand)
						.on("afterCommand.select-cells", this.onAfterCommand)
						.on(
						  [
							"clickEditor",
							"mousedownTd",
							"mousedownTh",
							"touchstartTd",
							"touchstartTh",
						  ]
							.map(function (e) {
							  return e + ".select-cells";
							})
							.join(" "),
						  this.onStartSelection,
						)
						.on("clickTr clickTbody", function () {
						  var e,
							o = t.module.getAllSelectedCells().length;
						  if (o)
							return (
							  o > 1 &&
								(null === (e = t.j.s.sel) ||
								  void 0 === e ||
								  e.removeAllRanges()),
							  !1
							);
						});
				  }),
				  (t.prototype.onStartSelection = function (e) {
					if (
					  !this.j.o.readonly &&
					  (this.unselectCells(), e !== this.j.editor)
					) {
					  var t = a.Dom.closest(e, "table", this.j.editor);
					  if (e && t)
						return (
						  e.firstChild ||
							e.appendChild(this.j.createInside.element("br")),
						  (this.isSelectionMode = !0),
						  (this.selectedCell = e),
						  this.module.addSelection(e),
						  this.j.e
							.on(
							  t,
							  "mousemove.select-cells touchmove.select-cells",
							  this.j.async.throttle(this.onMove.bind(this, t), {
								label: p,
								timeout: this.j.defaultTimeout / 2,
							  }),
							)
							.on(
							  t,
							  "mouseup.select-cells touchend.select-cells",
							  this.onStopSelection.bind(this, t),
							),
						  !1
						);
					}
				  }),
				  (t.prototype.onOutsideClick = function () {
					(this.selectedCell = null), this.onRemoveSelection();
				  }),
				  (t.prototype.onChange = function () {
					this.j.isLocked ||
					  this.isSelectionMode ||
					  this.onRemoveSelection();
				  }),
				  (t.prototype.onMove = function (e, t) {
					var o,
					  n = this;
					if (
					  (!this.j.o.readonly || this.j.isLocked) &&
					  !this.j.isLockedNotBy(d)
					) {
					  var r = this.j.ed.elementFromPoint(t.clientX, t.clientY);
					  if (r) {
						var s = a.Dom.closest(r, ["td", "th"], e);
						if (s && this.selectedCell) {
						  s !== this.selectedCell && this.j.lock(d),
							this.unselectCells();
						  for (
							var l = i.Table.getSelectedBound(e, [
								s,
								this.selectedCell,
							  ]),
							  c = i.Table.formalMatrix(e),
							  u = l[0][0];
							l[1][0] >= u;
							u += 1
						  )
							for (var p = l[0][1]; l[1][1] >= p; p += 1)
							  this.module.addSelection(c[u][p]);
						  var f;
						  this.module.getAllSelectedCells().length > 1 &&
							(null === (o = this.j.s.sel) ||
							  void 0 === o ||
							  o.removeAllRanges()),
							this.j.e.fire("hidePopup"),
							t.stopPropagation(),
							(f = n.j.createInside.fromHTML(
							  '<div style="color:rgba(0,0,0,0.01);width:0;height:0">&nbsp;</div>',
							)),
							s.appendChild(f),
							n.j.async.setTimeout(function () {
							  var e;
							  null === (e = f.parentNode) ||
								void 0 === e ||
								e.removeChild(f);
							}, n.j.defaultTimeout / 5);
						}
					  }
					}
				  }),
				  (t.prototype.onRemoveSelection = function (e) {
					var t;
					if (
					  !(null === (t = null == e ? void 0 : e.buffer) ||
					  void 0 === t
						? void 0
						: t.actionTrigger) &&
					  !this.selectedCell &&
					  this.module.getAllSelectedCells().length
					)
					  return (
						this.j.unlock(),
						this.unselectCells(),
						void this.j.e.fire("hidePopup", "cells")
					  );
					(this.isSelectionMode = !1), (this.selectedCell = null);
				  }),
				  (t.prototype.onStopSelection = function (e, t) {
					var o = this;
					if (this.selectedCell) {
					  (this.isSelectionMode = !1), this.j.unlock();
					  var n = this.j.ed.elementFromPoint(t.clientX, t.clientY);
					  if (n) {
						var r = a.Dom.closest(n, ["td", "th"], e);
						if (r) {
						  var l = a.Dom.closest(r, "table", e);
						  if (!l || l === e) {
							var c = i.Table.getSelectedBound(e, [
								r,
								this.selectedCell,
							  ]),
							  u = i.Table.formalMatrix(e),
							  d = u[c[1][0]][c[1][1]],
							  f = u[c[0][0]][c[0][1]];
							this.j.e.fire(
							  "showPopup",
							  e,
							  function () {
								var e = (0, s.position)(f, o.j),
								  t = (0, s.position)(d, o.j);
								return {
								  left: e.left,
								  top: e.top,
								  width: t.left - e.left + t.width,
								  height: t.top - e.top + t.height,
								};
							  },
							  "cells",
							),
							  (0, s.$$)("table", this.j.editor).forEach(
								function (e) {
								  o.j.e.off(
									e,
									"mousemove.select-cells touchmove.select-cells mouseup.select-cells touchend.select-cells",
								  );
								},
							  ),
							  this.j.async.clearTimeout(p);
						  }
						}
					  }
					}
				  }),
				  (t.prototype.unselectCells = function (e) {
					var t = this.module,
					  o = t.getAllSelectedCells();
					o.length &&
					  o.forEach(function (o) {
						(e && e === o) || t.removeSelection(o);
					  });
				  }),
				  (t.prototype.onExecCommand = function (e) {
					if (
					  /table(splitv|splitg|merge|empty|bin|binrow|bincolumn|addcolumn|addrow)/.test(
						e,
					  )
					) {
					  e = e.replace("table", "");
					  var t = this.module.getAllSelectedCells();
					  if (t.length) {
						var o = n.__read(t, 1)[0];
						if (!o) return;
						var r = a.Dom.closest(o, "table", this.j.editor);
						if (!r) return;
						switch (e) {
						  case "splitv":
							i.Table.splitVertical(r, this.j);
							break;
						  case "splitg":
							i.Table.splitHorizontal(r, this.j);
							break;
						  case "merge":
							i.Table.mergeSelected(r, this.j);
							break;
						  case "empty":
							t.forEach(function (e) {
							  return a.Dom.detach(e);
							});
							break;
						  case "bin":
							a.Dom.safeRemove(r);
							break;
						  case "binrow":
							new Set(
							  t.map(function (e) {
								return e.parentNode;
							  }),
							).forEach(function (e) {
							  i.Table.removeRow(r, e.rowIndex);
							});
							break;
						  case "bincolumn":
							var s = new Set();
							t.reduce(function (e, t) {
							  return (
								s.has(t.cellIndex) ||
								  (e.push(t), s.add(t.cellIndex)),
								e
							  );
							}, []).forEach(function (e) {
							  i.Table.removeColumn(r, e.cellIndex);
							});
							break;
						  case "addcolumnafter":
						  case "addcolumnbefore":
							i.Table.appendColumn(
							  r,
							  o.cellIndex,
							  "addcolumnafter" === e,
							  this.j.createInside,
							);
							break;
						  case "addrowafter":
						  case "addrowbefore":
							i.Table.appendRow(
							  r,
							  o.parentNode,
							  "addrowafter" === e,
							  this.j.createInside,
							);
						}
					  }
					  return !1;
					}
				  }),
				  (t.prototype.onAfterCommand = function (e) {
					/^justify/.test(e) &&
					  this.module.getAllSelectedCells().forEach(function (t) {
						return (0, s.alignElement)(e, t);
					  });
				  }),
				  (t.prototype.beforeDestruct = function (e) {
					this.onRemoveSelection(), e.e.off(".select-cells");
				  }),
				  n.__decorate(
					[c.autobind],
					t.prototype,
					"onStartSelection",
					null,
				  ),
				  n.__decorate(
					[(0, c.watch)(":outsideClick")],
					t.prototype,
					"onOutsideClick",
					null,
				  ),
				  n.__decorate(
					[(0, c.watch)(":change")],
					t.prototype,
					"onChange",
					null,
				  ),
				  n.__decorate(
					[c.autobind],
					t.prototype,
					"onRemoveSelection",
					null,
				  ),
				  n.__decorate(
					[c.autobind],
					t.prototype,
					"onStopSelection",
					null,
				  ),
				  n.__decorate([c.autobind], t.prototype, "onExecCommand", null),
				  n.__decorate([c.autobind], t.prototype, "onAfterCommand", null),
				  t
				);
			  })(r.Plugin);
			(t.selectCells = f), u.pluginSystem.add("selectCells", f);
		  },
		  33100: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.select = {
				normalizeSelectionBeforeCutAndCopy: !1,
			  });
		  },
		  95323: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.select = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(43441),
			  a = o(26596),
			  s = o(24263),
			  l = o(2074),
			  c = o(17332);
			o(33100);
			var u = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.proxyEventsList = [
					"click",
					"mousedown",
					"touchstart",
					"mouseup",
					"touchend",
				  ]),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  this.proxyEventsList.forEach(function (o) {
					e.e.on(o + ".select", t.onStartSelection);
				  });
				}),
				(t.prototype.beforeDestruct = function (e) {
				  var t = this;
				  this.proxyEventsList.forEach(function (o) {
					e.e.on(o + ".select", t.onStartSelection);
				  });
				}),
				(t.prototype.onStartSelection = function (e) {
				  for (
					var t, o = this.j, n = e.target;
					void 0 === t && n && n !== o.editor;
  
				  )
					(t = o.e.fire(
					  (0, a.camelCase)(e.type + "_" + n.nodeName.toLowerCase()),
					  n,
					  e,
					)),
					  (n = n.parentElement);
				  "click" === e.type &&
					void 0 === t &&
					n === o.editor &&
					o.e.fire(e.type + "Editor", n, e);
				}),
				(t.prototype.onOutsideClick = function (e) {
				  var t = this,
					o = e.target;
				  s.Dom.up(o, function (e) {
					return e === t.j.editor;
				  }) ||
					l.UIElement.closestElement(o, l.Popup) ||
					this.j.e.fire("outsideClick", e);
				}),
				(t.prototype.beforeCommandCut = function (e) {
				  var t = this.j.s;
				  if ("cut" === e && !t.isCollapsed()) {
					var o = t.current();
					o &&
					  s.Dom.isOrContains(this.j.editor, o) &&
					  this.onCopyNormalizeSelectionBound();
				  }
				}),
				(t.prototype.onCopyNormalizeSelectionBound = function (e) {
				  var t = this.j,
					o = t.editor;
				  t.o.select.normalizeSelectionBeforeCutAndCopy &&
					!t.s.isCollapsed() &&
					(!e ||
					  (e.isTrusted &&
						s.Dom.isNode(e.target) &&
						s.Dom.isOrContains(o, e.target))) &&
					this.jodit.s.expandSelection();
				}),
				n.__decorate([i.autobind], t.prototype, "onStartSelection", null),
				n.__decorate(
				  [(0, i.watch)("ow:click")],
				  t.prototype,
				  "onOutsideClick",
				  null,
				),
				n.__decorate(
				  [(0, i.watch)([":beforeCommand"])],
				  t.prototype,
				  "beforeCommandCut",
				  null,
				),
				n.__decorate(
				  [(0, i.watch)([":copy", ":cut"])],
				  t.prototype,
				  "onCopyNormalizeSelectionBound",
				  null,
				),
				t
			  );
			})(r.Plugin);
			(t.select = u), c.pluginSystem.add("select", u);
		  },
		  53387: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.minWidth = 200),
			  (n.Config.prototype.maxWidth = "100%"),
			  (n.Config.prototype.minHeight = 200),
			  (n.Config.prototype.maxHeight = "auto"),
			  (n.Config.prototype.saveHeightInStorage = !1);
		  },
		  71003: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.size = void 0);
			var n = o(20255);
			o(30962);
			var r = o(61817),
			  i = o(26911),
			  a = o(85605),
			  s = o(43441),
			  l = o(17332);
			o(53387);
			var c = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.__resizeWorkspaces = t.j.async.debounce(
					t.__resizeWorkspaceImd,
					t.j.defaultTimeout,
					!0,
				  )),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  e.e
					.on("setHeight.size", this.__setHeight)
					.on("setWidth.size", this.__setWidth)
					.on("afterInit.size changePlace.size", this.__initialize, {
					  top: !0,
					})
					.on(e.ow, "load.size", this.__resizeWorkspaces)
					.on(
					  "afterInit.size resize.size afterUpdateToolbar.size scroll.size afterResize.size",
					  this.__resizeWorkspaces,
					)
					.on(
					  "toggleFullSize.size toggleToolbar.size",
					  this.__resizeWorkspaceImd,
					),
					this.__initialize();
				}),
				(t.prototype.__initialize = function () {
				  var e = this.j;
				  if (!e.o.inline) {
					var t = e.o.height;
					if (e.o.saveHeightInStorage && "auto" !== t) {
					  var o = e.storage.get("height");
					  o && (t = o);
					}
					(0, i.css)(e.editor, { minHeight: "100%" }),
					  (0, i.css)(e.container, {
						minHeight: e.o.minHeight,
						maxHeight: e.o.maxHeight,
						minWidth: e.o.minWidth,
						maxWidth: e.o.maxWidth,
					  }),
					  this.__setHeight(t),
					  this.__setWidth(e.o.width);
				  }
				}),
				(t.prototype.__setHeight = function (e) {
				  if ((0, r.isNumber)(e)) {
					var t = this.j.o,
					  o = t.minHeight,
					  n = t.maxHeight;
					(0, r.isNumber)(o) && o > e && (e = o),
					  (0, r.isNumber)(n) && e > n && (e = n);
				  }
				  (0, i.css)(this.j.container, "height", e),
					this.j.o.saveHeightInStorage &&
					  this.j.storage.set("height", e),
					this.__resizeWorkspaceImd();
				}),
				(t.prototype.__setWidth = function (e) {
				  if ((0, r.isNumber)(e)) {
					var t = this.j.o,
					  o = t.minWidth,
					  n = t.maxWidth;
					(0, r.isNumber)(o) && o > e && (e = o),
					  (0, r.isNumber)(n) && e > n && (e = n);
				  }
				  (0, i.css)(this.j.container, "width", e),
					this.__resizeWorkspaceImd();
				}),
				(t.prototype.__getNotWorkHeight = function () {
				  var e, t;
				  return (
					((null === (e = this.j.toolbarContainer) || void 0 === e
					  ? void 0
					  : e.offsetHeight) || 0) +
					((null === (t = this.j.statusbar) || void 0 === t
					  ? void 0
					  : t.getHeight()) || 0) +
					2
				  );
				}),
				(t.prototype.__resizeWorkspaceImd = function () {
				  if (
					this.j &&
					!this.j.isDestructed &&
					this.j.o &&
					!this.j.o.inline &&
					this.j.container &&
					this.j.container.parentNode
				  ) {
					var e =
					  ((0, i.css)(this.j.container, "minHeight") || 0) -
					  this.__getNotWorkHeight();
					if (
					  ((0, r.isNumber)(e) &&
						e > 0 &&
						([this.j.workplace, this.j.iframe, this.j.editor].map(
						  function (t) {
							t && (0, i.css)(t, "minHeight", e);
						  },
						),
						this.j.e.fire("setMinHeight", e)),
					  (0, r.isNumber)(this.j.o.maxHeight))
					) {
					  var t = this.j.o.maxHeight - this.__getNotWorkHeight();
					  [this.j.workplace, this.j.iframe, this.j.editor].map(
						function (e) {
						  e && (0, i.css)(e, "maxHeight", t);
						},
					  ),
						this.j.e.fire("setMaxHeight", t);
					}
					this.j.container &&
					  (0, i.css)(
						this.j.workplace,
						"height",
						"auto" !== this.j.o.height || this.j.isFullSize
						  ? this.j.container.offsetHeight -
							  this.__getNotWorkHeight()
						  : "auto",
					  );
				  }
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e
					.off(e.ow, "load.size", this.__resizeWorkspaces)
					.off(".size");
				}),
				n.__decorate(
				  [(0, s.throttle)()],
				  t.prototype,
				  "__initialize",
				  null,
				),
				n.__decorate(
				  [s.autobind],
				  t.prototype,
				  "__resizeWorkspaceImd",
				  null,
				),
				n.__decorate([s.autobind], t)
			  );
			})(a.Plugin);
			(t.size = c), l.pluginSystem.add("size", c);
		  },
		  13985: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(86893),
			  i = o(77904);
			(n.Config.prototype.beautifyHTML = !r.IS_IE),
			  (n.Config.prototype.sourceEditor = "ace"),
			  (n.Config.prototype.sourceEditorNativeOptions = {
				showGutter: !0,
				theme: "ace/theme/idle_fingers",
				mode: "ace/mode/html",
				wrap: !0,
				highlightActiveLine: !0,
			  }),
			  (n.Config.prototype.sourceEditorCDNUrlsJS = [
				"https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.2/ace.js",
			  ]),
			  (n.Config.prototype.beautifyHTMLCDNUrlsJS = [
				"https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify.min.js",
				"https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify-html.min.js",
			  ]),
			  i.Icon.set("source", o(9342)),
			  (n.Config.prototype.controls.source = {
				mode: r.MODE_SPLIT,
				exec: function (e) {
				  e.toggleMode();
				},
				isActive: function (e) {
				  return e.getRealMode() === r.MODE_SOURCE;
				},
				tooltip: "Change mode",
			  });
		  },
		  34186: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.AceEditor = void 0);
			var n = o(20255),
			  r = o(86893),
			  i = o(40332),
			  a = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.className = "jodit_ace_editor"),
					(t.proxyOnBlur = function (e) {
					  t.j.e.fire("blur", e);
					}),
					(t.proxyOnFocus = function (e) {
					  t.j.e.fire("focus", e);
					}),
					(t.proxyOnMouseDown = function (e) {
					  t.j.e.fire("mousedown", e);
					}),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.aceExists = function () {
					return void 0 !== this.j.ow.ace;
				  }),
				  (t.prototype.getLastColumnIndex = function (e) {
					return this.instance.session.getLine(e).length;
				  }),
				  (t.prototype.getLastColumnIndices = function () {
					for (
					  var e = this.instance.session.getLength(),
						t = [],
						o = 0,
						n = 0;
					  e > n;
					  n++
					)
					  (o += this.getLastColumnIndex(n)),
						n > 0 && (o += 1),
						(t[n] = o);
					return t;
				  }),
				  (t.prototype.getRowColumnIndices = function (e) {
					var t = this.getLastColumnIndices();
					if (t[0] >= e) return { row: 0, column: e };
					for (var o = 1, n = 1; t.length > n; n++)
					  e > t[n] && (o = n + 1);
					return { row: o, column: e - t[o - 1] - 1 };
				  }),
				  (t.prototype.setSelectionRangeIndices = function (e, t) {
					var o = this.getRowColumnIndices(e),
					  n = this.getRowColumnIndices(t);
					this.instance
					  .getSelection()
					  .setSelectionRange({ start: o, end: n });
				  }),
				  (t.prototype.getIndexByRowColumn = function (e, t) {
					return (
					  this.getLastColumnIndices()[e] -
					  this.getLastColumnIndex(e) +
					  t
					);
				  }),
				  (t.prototype.init = function (e) {
					var t = this,
					  o = function () {
						if (void 0 === t.instance && t.aceExists()) {
						  var o = t.j.c.div("jodit-source__mirror-fake");
						  t.container.appendChild(o),
							(t.instance = e.ow.ace.edit(o)),
							t.instance.setTheme(
							  e.o.sourceEditorNativeOptions.theme,
							),
							t.instance.renderer.setShowGutter(
							  e.o.sourceEditorNativeOptions.showGutter,
							),
							t.instance
							  .getSession()
							  .setMode(e.o.sourceEditorNativeOptions.mode),
							t.instance.setHighlightActiveLine(
							  e.o.sourceEditorNativeOptions.highlightActiveLine,
							),
							t.instance.getSession().setUseWrapMode(!0),
							t.instance.setOption("indentedSoftWrap", !1),
							t.instance.setOption(
							  "wrap",
							  e.o.sourceEditorNativeOptions.wrap,
							),
							t.instance.getSession().setUseWorker(!1),
							(t.instance.$blockScrolling = 1 / 0),
							t.instance.on("change", t.toWYSIWYG),
							t.instance.on("focus", t.proxyOnFocus),
							t.instance.on("mousedown", t.proxyOnMouseDown),
							t.instance.on("blur", t.proxyOnBlur),
							e.getRealMode() !== r.MODE_WYSIWYG &&
							  t.setValue(t.getValue());
						  var n = t.j.async.debounce(function () {
							e.isInDestruct ||
							  (t.instance.setOption(
								"maxLines",
								"auto" !== e.o.height
								  ? e.workplace.offsetHeight /
									  t.instance.renderer.lineHeight
								  : 1 / 0,
							  ),
							  t.instance.resize());
						  }, 2 * t.j.defaultTimeout);
						  e.e.on("afterResize afterSetMode", n), n(), t.onReady();
						}
					  };
					e.e.on("afterSetMode", function () {
					  (e.getRealMode() !== r.MODE_SOURCE &&
						e.getMode() !== r.MODE_SPLIT) ||
						(t.fromWYSIWYG(), o());
					}),
					  o(),
					  this.aceExists() ||
						(0, i.loadNext)(e, e.o.sourceEditorCDNUrlsJS)
						  .then(function () {
							e.isInDestruct || o();
						  })
						  .catch(function () {
							return null;
						  });
				  }),
				  (t.prototype.destruct = function () {
					var e, t;
					this.instance.off("change", this.toWYSIWYG),
					  this.instance.off("focus", this.proxyOnFocus),
					  this.instance.off("mousedown", this.proxyOnMouseDown),
					  this.instance.destroy(),
					  null ===
						(t =
						  null === (e = this.j) || void 0 === e
							? void 0
							: e.events) ||
						void 0 === t ||
						t.off("aceInited.source");
				  }),
				  (t.prototype.setValue = function (e) {
					if (!this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
					  var t = this.j.e.fire("beautifyHTML", e);
					  (0, i.isString)(t) && (e = t);
					}
					this.instance.setValue(e), this.instance.clearSelection();
				  }),
				  (t.prototype.getValue = function () {
					return this.instance.getValue();
				  }),
				  (t.prototype.setReadOnly = function (e) {
					this.instance.setReadOnly(e);
				  }),
				  Object.defineProperty(t.prototype, "isFocused", {
					get: function () {
					  return this.instance.isFocused();
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.focus = function () {
					this.instance.focus();
				  }),
				  (t.prototype.blur = function () {
					this.instance.blur();
				  }),
				  (t.prototype.getSelectionStart = function () {
					var e = this.instance.selection.getRange();
					return this.getIndexByRowColumn(e.start.row, e.start.column);
				  }),
				  (t.prototype.getSelectionEnd = function () {
					var e = this.instance.selection.getRange();
					return this.getIndexByRowColumn(e.end.row, e.end.column);
				  }),
				  (t.prototype.selectAll = function () {
					this.instance.selection.selectAll();
				  }),
				  (t.prototype.insertRaw = function (e) {
					var t = this.instance.selection.getCursor(),
					  o = this.instance.session.insert(t, e);
					this.instance.selection.setRange({ start: t, end: o }, !1);
				  }),
				  (t.prototype.setSelectionRange = function (e, t) {
					this.setSelectionRangeIndices(e, t);
				  }),
				  (t.prototype.setPlaceHolder = function (e) {}),
				  (t.prototype.replaceUndoManager = function () {
					var e = this.jodit.history;
					this.instance.commands.addCommand({
					  name: "Undo",
					  bindKey: { win: "Ctrl-Z", mac: "Command-Z" },
					  exec: function () {
						e.undo();
					  },
					}),
					  this.instance.commands.addCommand({
						name: "Redo",
						bindKey: { win: "Ctrl-Shift-Z", mac: "Command-Shift-Z" },
						exec: function () {
						  e.redo();
						},
					  });
				  }),
				  t
				);
			  })(o(36729).SourceEditor);
			t.AceEditor = a;
		  },
		  58633: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.TextAreaEditor = void 0);
			var n = o(20255),
			  r = o(26911),
			  i = o(24263),
			  a = (function (e) {
				function t() {
				  var t = (null !== e && e.apply(this, arguments)) || this;
				  return (
					(t.autosize = t.j.async.debounce(function () {
					  (t.instance.style.height = "auto"),
						(t.instance.style.height =
						  t.instance.scrollHeight + "px");
					}, t.j.defaultTimeout)),
					t
				  );
				}
				return (
				  n.__extends(t, e),
				  (t.prototype.init = function (e) {
					var t = this;
					(this.instance = e.c.element("textarea", {
					  class: "jodit-source__mirror",
					})),
					  this.container.appendChild(this.instance),
					  e.e
						.on(
						  this.instance,
						  "mousedown keydown touchstart input",
						  e.async.debounce(this.toWYSIWYG, e.defaultTimeout),
						)
						.on("setMinHeight.source", function (e) {
						  (0, r.css)(t.instance, "minHeight", e);
						})
						.on(
						  this.instance,
						  "change keydown mousedown touchstart input",
						  this.autosize,
						)
						.on("afterSetMode.source", this.autosize)
						.on(this.instance, "mousedown focus", function (t) {
						  e.e.fire(t.type, t);
						}),
					  this.autosize(),
					  this.onReady();
				  }),
				  (t.prototype.destruct = function () {
					i.Dom.safeRemove(this.instance);
				  }),
				  (t.prototype.getValue = function () {
					return this.instance.value;
				  }),
				  (t.prototype.setValue = function (e) {
					this.instance.value = e;
				  }),
				  (t.prototype.insertRaw = function (e) {
					var t = this.getValue();
					if (0 > this.getSelectionStart()) this.setValue(t + e);
					else {
					  var o = this.getSelectionStart(),
						n = this.getSelectionEnd();
					  this.setValue(
						t.substring(0, o) + e + t.substring(n, t.length),
					  );
					}
				  }),
				  (t.prototype.getSelectionStart = function () {
					return this.instance.selectionStart;
				  }),
				  (t.prototype.getSelectionEnd = function () {
					return this.instance.selectionEnd;
				  }),
				  (t.prototype.setSelectionRange = function (e, t) {
					void 0 === t && (t = e),
					  this.instance.setSelectionRange(e, t);
				  }),
				  Object.defineProperty(t.prototype, "isFocused", {
					get: function () {
					  return this.instance === this.j.od.activeElement;
					},
					enumerable: !1,
					configurable: !0,
				  }),
				  (t.prototype.focus = function () {
					this.instance.focus();
				  }),
				  (t.prototype.blur = function () {
					this.instance.blur();
				  }),
				  (t.prototype.setPlaceHolder = function (e) {
					this.instance.setAttribute("placeholder", e);
				  }),
				  (t.prototype.setReadOnly = function (e) {
					e
					  ? this.instance.setAttribute("readonly", "true")
					  : this.instance.removeAttribute("readonly");
				  }),
				  (t.prototype.selectAll = function () {
					this.instance.select();
				  }),
				  (t.prototype.replaceUndoManager = function () {
					var e = this,
					  t = this.jodit.history;
					this.j.e.on(this.instance, "keydown", function (o) {
					  if ((o.ctrlKey || o.metaKey) && "z" === o.key)
						return (
						  o.shiftKey ? t.redo() : t.undo(),
						  e.setSelectionRange(e.getValue().length),
						  !1
						);
					});
				  }),
				  t
				);
			  })(o(36729).SourceEditor);
			t.TextAreaEditor = a;
		  },
		  52834: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			n.__exportStar(o(58633), t), n.__exportStar(o(34186), t);
		  },
		  94785: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.createSourceEditor = void 0);
			var n = o(40332),
			  r = o(52834);
			t.createSourceEditor = function (e, t, o, i, a) {
			  var s;
			  if ((0, n.isFunction)(e)) s = e(t);
			  else
				switch (e) {
				  case "ace":
					if (!t.o.shadowRoot) {
					  s = new r.AceEditor(t, o, i, a);
					  break;
					}
				  default:
					s = new r.TextAreaEditor(t, o, i, a);
				}
			  return (
				s.init(t),
				s.onReadyAlways(function () {
				  s.setReadOnly(t.o.readonly);
				}),
				s
			  );
			};
		  },
		  36729: function (e, t) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.SourceEditor = void 0);
			var o = (function () {
			  function e(e, t, o, n) {
				(this.jodit = e),
				  (this.container = t),
				  (this.toWYSIWYG = o),
				  (this.fromWYSIWYG = n),
				  (this.className = ""),
				  (this.isReady = !1);
			  }
			  return (
				Object.defineProperty(e.prototype, "j", {
				  get: function () {
					return this.jodit;
				  },
				  enumerable: !1,
				  configurable: !0,
				}),
				(e.prototype.onReady = function () {
				  this.replaceUndoManager(),
					(this.isReady = !0),
					this.j.e.fire(this, "ready");
				}),
				(e.prototype.onReadyAlways = function (e) {
				  var t;
				  this.isReady
					? e()
					: null === (t = this.j.events) ||
					  void 0 === t ||
					  t.on(this, "ready", e);
				}),
				e
			  );
			})();
			t.SourceEditor = o;
		  },
		  86030: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.source = void 0);
			var n = o(20255);
			o(68197);
			var r = o(86893),
			  i = o(86893),
			  a = o(57549),
			  s = o(24263),
			  l = o(40332),
			  c = o(43441),
			  u = o(17332),
			  d = o(94785);
			o(13985);
			var p = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.buttons = [{ name: "source", group: "source" }]),
				  (t.__lock = !1),
				  (t.__oldMirrorValue = ""),
				  (t.tempMarkerStart = "{start-jodit-selection}"),
				  (t.tempMarkerStartReg = /{start-jodit-selection}/g),
				  (t.tempMarkerEnd = "{end-jodit-selection}"),
				  (t.tempMarkerEndReg = /{end-jodit-selection}/g),
				  (t.getSelectionStart = function () {
					var e, o;
					return null !==
					  (o =
						null === (e = t.sourceEditor) || void 0 === e
						  ? void 0
						  : e.getSelectionStart()) && void 0 !== o
					  ? o
					  : 0;
				  }),
				  (t.getSelectionEnd = function () {
					var e, o;
					return null !==
					  (o =
						null === (e = t.sourceEditor) || void 0 === e
						  ? void 0
						  : e.getSelectionEnd()) && void 0 !== o
					  ? o
					  : 0;
				  }),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.onInsertHTML = function (e) {
				  var t;
				  if (!this.j.o.readonly && !this.j.isEditorMode())
					return (
					  null === (t = this.sourceEditor) ||
						void 0 === t ||
						t.insertRaw(e),
					  this.toWYSIWYG(),
					  !1
					);
				}),
				(t.prototype.fromWYSIWYG = function (e) {
				  if ((void 0 === e && (e = !1), !this.__lock || !0 === e)) {
					this.__lock = !0;
					var t = this.j.getEditorValue(!1, i.SOURCE_CONSUMER);
					t !== this.getMirrorValue() && this.setMirrorValue(t),
					  (this.__lock = !1);
				  }
				}),
				(t.prototype.toWYSIWYG = function () {
				  if (!this.__lock) {
					var e = this.getMirrorValue();
					e !== this.__oldMirrorValue &&
					  ((this.__lock = !0),
					  (this.j.value = e),
					  (this.__lock = !1),
					  (this.__oldMirrorValue = e));
				  }
				}),
				(t.prototype.getNormalPosition = function (e, t) {
				  for (
					t = t.replace(
					  /<(script|style|iframe)[^>]*>[^]*?<\/\1>/im,
					  function (e) {
						for (var t = "", o = 0; e.length > o; o += 1)
						  t += i.INVISIBLE_SPACE;
						return t;
					  },
					);
					e > 0 && t[e] === i.INVISIBLE_SPACE;
  
				  )
					e--;
				  for (var o = e; o > 0; ) {
					if (
					  "<" === t[--o] &&
					  void 0 !== t[o + 1] &&
					  t[o + 1].match(/[\w/]+/i)
					)
					  return o;
					if (">" === t[o]) return e;
				  }
				  return e;
				}),
				(t.prototype.clnInv = function (e) {
				  return e.replace(r.INVISIBLE_SPACE_REG_EXP(), "");
				}),
				(t.prototype.onSelectAll = function (e) {
				  var t;
				  if (
					"selectall" === e.toLowerCase() &&
					this.j.getRealMode() === i.MODE_SOURCE
				  )
					return (
					  null === (t = this.sourceEditor) ||
						void 0 === t ||
						t.selectAll(),
					  !1
					);
				}),
				(t.prototype.getMirrorValue = function () {
				  var e;
				  return (
					(null === (e = this.sourceEditor) || void 0 === e
					  ? void 0
					  : e.getValue()) || ""
				  );
				}),
				(t.prototype.setMirrorValue = function (e) {
				  var t;
				  null === (t = this.sourceEditor) ||
					void 0 === t ||
					t.setValue(e);
				}),
				(t.prototype.setFocusToMirror = function () {
				  var e;
				  null === (e = this.sourceEditor) || void 0 === e || e.focus();
				}),
				(t.prototype.saveSelection = function () {
				  if (this.j.getRealMode() === r.MODE_WYSIWYG)
					this.j.s.save(),
					  this.j.synchronizeValues(),
					  this.fromWYSIWYG(!0);
				  else {
					if (this.j.o.editHTMLDocumentMode) return;
					var e = this.getMirrorValue();
					if (this.getSelectionStart() === this.getSelectionEnd()) {
					  var t = this.j.s.marker(!0),
						o = this.getNormalPosition(
						  this.getSelectionStart(),
						  this.getMirrorValue(),
						);
					  this.setMirrorValue(
						e.substring(0, o) +
						  this.clnInv(t.outerHTML) +
						  e.substring(o),
					  );
					} else {
					  var n = this.j.s.marker(!0),
						i = this.j.s.marker(!1),
						a =
						  ((o = this.getNormalPosition(
							this.getSelectionStart(),
							e,
						  )),
						  this.getNormalPosition(this.getSelectionEnd(), e));
					  this.setMirrorValue(
						e.substring(0, o) +
						  this.clnInv(n.outerHTML) +
						  e.substring(o, a - o) +
						  this.clnInv(i.outerHTML) +
						  e.substring(a),
					  );
					}
					this.toWYSIWYG();
				  }
				}),
				(t.prototype.removeSelection = function () {
				  if (this.j.getRealMode() === r.MODE_WYSIWYG)
					return (
					  (this.__lock = !0),
					  this.j.s.restore(),
					  void (this.__lock = !1)
					);
				  var e = this.getMirrorValue(),
					t = 0,
					o = 0;
				  try {
					if (
					  ((e = e
						.replace(
						  /<span[^>]+data-jodit-selection_marker=(["'])start\1[^>]*>[<>]*?<\/span>/gim,
						  this.tempMarkerStart,
						)
						.replace(
						  /<span[^>]+data-jodit-selection_marker=(["'])end\1[^>]*>[<>]*?<\/span>/gim,
						  this.tempMarkerEnd,
						)),
					  !this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML)
					) {
					  var n = this.j.e.fire("beautifyHTML", e);
					  (0, l.isString)(n) && (e = n);
					}
					if (
					  ((o = t = e.indexOf(this.tempMarkerStart)),
					  (e = e.replace(this.tempMarkerStartReg, "")),
					  -1 !== t)
					) {
					  var i = e.indexOf(this.tempMarkerEnd);
					  -1 !== i && (o = i);
					}
					e = e.replace(this.tempMarkerEndReg, "");
				  } finally {
					e = e
					  .replace(this.tempMarkerEndReg, "")
					  .replace(this.tempMarkerStartReg, "");
				  }
				  this.setMirrorValue(e),
					this.setMirrorSelectionRange(t, o),
					this.toWYSIWYG(),
					this.setFocusToMirror();
				}),
				(t.prototype.setMirrorSelectionRange = function (e, t) {
				  var o;
				  null === (o = this.sourceEditor) ||
					void 0 === o ||
					o.setSelectionRange(e, t);
				}),
				(t.prototype.onReadonlyReact = function () {
				  var e;
				  null === (e = this.sourceEditor) ||
					void 0 === e ||
					e.setReadOnly(this.j.o.readonly);
				}),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  if (
					((this.mirrorContainer = e.c.div("jodit-source")),
					e.workplace.appendChild(this.mirrorContainer),
					e.e.on("afterAddPlace changePlace afterInit", function () {
					  e.workplace.appendChild(t.mirrorContainer);
					}),
					(this.sourceEditor = (0, d.createSourceEditor)(
					  "area",
					  e,
					  this.mirrorContainer,
					  this.toWYSIWYG,
					  this.fromWYSIWYG,
					)),
					e.e.on(e.ow, "keydown", function (e) {
					  var o;
					  e.key === i.KEY_ESC &&
						(null === (o = t.sourceEditor) || void 0 === o
						  ? void 0
						  : o.isFocused) &&
						t.sourceEditor.blur();
					}),
					this.onReadonlyReact(),
					e.e
					  .on("placeholder.source", function (e) {
						var o;
						null === (o = t.sourceEditor) ||
						  void 0 === o ||
						  o.setPlaceHolder(e);
					  })
					  .on("change.source", this.syncValueFromWYSIWYG)
					  .on("beautifyHTML", function (e) {
						return e;
					  }),
					e.o.beautifyHTML)
				  ) {
					var o = function () {
					  var t,
						o = e.ow.html_beautify;
					  return !(
						!o ||
						e.isInDestruct ||
						(null === (t = e.events) ||
						  void 0 === t ||
						  t.off("beautifyHTML").on("beautifyHTML", function (e) {
							return o(e);
						  }),
						0)
					  );
					};
					o() || (0, l.loadNext)(e, e.o.beautifyHTMLCDNUrlsJS).then(o);
				  }
				  this.syncValueFromWYSIWYG(!0), this.initSourceEditor(e);
				}),
				(t.prototype.syncValueFromWYSIWYG = function (e) {
				  void 0 === e && (e = !1);
				  var t = this.j;
				  (t.getMode() !== i.MODE_SPLIT &&
					t.getMode() !== i.MODE_SOURCE) ||
					this.fromWYSIWYG(e);
				}),
				(t.prototype.initSourceEditor = function (e) {
				  var t,
					o = this;
				  if ("area" !== e.o.sourceEditor) {
					var n = (0, d.createSourceEditor)(
					  e.o.sourceEditor,
					  e,
					  this.mirrorContainer,
					  this.toWYSIWYG,
					  this.fromWYSIWYG,
					);
					n.onReadyAlways(function () {
					  var t, r;
					  null === (t = o.sourceEditor) ||
						void 0 === t ||
						t.destruct(),
						(o.sourceEditor = n),
						o.syncValueFromWYSIWYG(!0),
						null === (r = e.events) ||
						  void 0 === r ||
						  r.fire("sourceEditorReady", e);
					});
				  } else
					null === (t = this.sourceEditor) ||
					  void 0 === t ||
					  t.onReadyAlways(function () {
						var t;
						o.syncValueFromWYSIWYG(!0),
						  null === (t = e.events) ||
							void 0 === t ||
							t.fire("sourceEditorReady", e);
					  });
				}),
				(t.prototype.beforeDestruct = function () {
				  this.sourceEditor &&
					(this.sourceEditor.destruct(), delete this.sourceEditor),
					s.Dom.safeRemove(this.mirrorContainer);
				}),
				n.__decorate(
				  [(0, c.watch)(":insertHTML.source")],
				  t.prototype,
				  "onInsertHTML",
				  null,
				),
				n.__decorate([c.autobind], t.prototype, "fromWYSIWYG", null),
				n.__decorate([c.autobind], t.prototype, "toWYSIWYG", null),
				n.__decorate(
				  [c.autobind],
				  t.prototype,
				  "getNormalPosition",
				  null,
				),
				n.__decorate(
				  [(0, c.watch)(":beforeCommand.source")],
				  t.prototype,
				  "onSelectAll",
				  null,
				),
				n.__decorate(
				  [(0, c.watch)(":beforeSetMode.source")],
				  t.prototype,
				  "saveSelection",
				  null,
				),
				n.__decorate(
				  [(0, c.watch)(":afterSetMode.source")],
				  t.prototype,
				  "removeSelection",
				  null,
				),
				n.__decorate(
				  [c.autobind],
				  t.prototype,
				  "setMirrorSelectionRange",
				  null,
				),
				n.__decorate(
				  [(0, c.watch)(":readonly.source")],
				  t.prototype,
				  "onReadonlyReact",
				  null,
				),
				n.__decorate(
				  [c.autobind],
				  t.prototype,
				  "syncValueFromWYSIWYG",
				  null,
				),
				t
			  );
			})(a.Plugin);
			(t.source = p), u.pluginSystem.add("source", p);
		  },
		  50876: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(77904);
			(n.Config.prototype.spellcheck = !1),
			  r.Icon.set("spellcheck", o(69546)),
			  (n.Config.prototype.controls.spellcheck = {
				isActive: function (e) {
				  return e.o.spellcheck;
				},
				icon: o(69546),
				name: "spellcheck",
				command: "toggleSpellcheck",
				tooltip: "Spellcheck",
			  });
		  },
		  87882: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.zh_tw =
				t.zh_cn =
				t.tr =
				t.ru =
				t.pt_br =
				t.pl =
				t.nl =
				t.mn =
				t.ko =
				t.ja =
				t.it =
				t.id =
				t.hu =
				t.he =
				t.fr =
				t.fa =
				t.es =
				t.de =
				t.cs_cz =
				t.ar =
				  void 0);
			var n = o(5586);
			t.ar = n;
			var r = o(66023);
			t.cs_cz = r;
			var i = o(65860);
			t.de = i;
			var a = o(86055);
			t.es = a;
			var s = o(50037);
			t.fa = s;
			var l = o(7118);
			t.fr = l;
			var c = o(30298);
			t.he = c;
			var u = o(52107);
			t.hu = u;
			var d = o(31240);
			t.id = d;
			var p = o(4101);
			t.it = p;
			var f = o(69286);
			t.ja = f;
			var h = o(13402);
			t.ko = h;
			var m = o(1242);
			t.mn = m;
			var v = o(89574);
			t.nl = v;
			var g = o(63630);
			t.pl = g;
			var y = o(72212);
			t.pt_br = y;
			var _ = o(82570);
			t.ru = _;
			var b = o(19323);
			t.tr = b;
			var w = o(50279);
			t.zh_cn = w;
			var S = o(98364);
			t.zh_tw = S;
		  },
		  17002: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.spellcheck = void 0);
			var n = o(20255),
			  r = o(57549),
			  i = o(67309),
			  a = o(43441),
			  s = o(17332);
			o(50876);
			var l = (function (e) {
			  function t(t) {
				var n = e.call(this, t) || this;
				return (
				  (n.buttons = [{ group: "state", name: "spellcheck" }]),
				  (0, s.extendLang)(o(87882)),
				  n
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  e.e.on(
					"afterInit afterAddPlace prepareWYSIWYGEditor",
					this.toggleSpellcheck,
				  ),
					this.toggleSpellcheck(),
					e.registerCommand("toggleSpellcheck", function () {
					  (t.jodit.o.spellcheck = !t.jodit.o.spellcheck),
						t.toggleSpellcheck(),
						t.j.e.fire("updateToolbar");
					});
				}),
				(t.prototype.toggleSpellcheck = function () {
				  (0, i.attr)(
					this.jodit.editor,
					"spellcheck",
					this.jodit.o.spellcheck,
				  );
				}),
				(t.prototype.beforeDestruct = function (e) {}),
				n.__decorate([a.autobind], t.prototype, "toggleSpellcheck", null),
				t
			  );
			})(r.Plugin);
			(t.spellcheck = l), s.pluginSystem.add("spellcheck", l);
		  },
		  59818: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.showCharsCounter = !0),
			  (n.Config.prototype.countHTMLChars = !1),
			  (n.Config.prototype.showWordsCounter = !0);
		  },
		  1557: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.stat = void 0);
			var n = o(20255),
			  r = o(86893),
			  i = o(85605),
			  a = o(24263),
			  s = o(17332);
			o(59818);
			var l = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.charCounter = null),
				  (t.wordCounter = null),
				  (t.reInit = function () {
					t.j.o.showCharsCounter &&
					  t.charCounter &&
					  t.j.statusbar.append(t.charCounter, !0),
					  t.j.o.showWordsCounter &&
						t.wordCounter &&
						t.j.statusbar.append(t.wordCounter, !0),
					  t.j.e
						.off("change keyup", t.calc)
						.on("change keyup", t.calc),
					  t.calc();
				  }),
				  (t.calc = t.j.async.throttle(function () {
					var e = t.j.text;
					if (t.j.o.showCharsCounter && t.charCounter) {
					  var o = t.j.o.countHTMLChars
						? t.j.value
						: e.replace((0, r.SPACE_REG_EXP)(), "");
					  t.charCounter.textContent = t.j.i18n("Chars: %d", o.length);
					}
					t.j.o.showWordsCounter &&
					  t.wordCounter &&
					  (t.wordCounter.textContent = t.j.i18n(
						"Words: %d",
						e
						  .replace((0, r.INVISIBLE_SPACE_REG_EXP)(), "")
						  .split((0, r.SPACE_REG_EXP)())
						  .filter(function (e) {
							return e.length;
						  }).length,
					  ));
				  }, t.j.defaultTimeout)),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function () {
				  (this.charCounter = this.j.c.span()),
					(this.wordCounter = this.j.c.span()),
					this.j.e.on(
					  "afterInit changePlace afterAddPlace",
					  this.reInit,
					),
					this.reInit();
				}),
				(t.prototype.beforeDestruct = function () {
				  a.Dom.safeRemove(this.charCounter),
					a.Dom.safeRemove(this.wordCounter),
					this.j.e.off(
					  "afterInit changePlace afterAddPlace",
					  this.reInit,
					),
					(this.charCounter = null),
					(this.wordCounter = null);
				}),
				t
			  );
			})(i.Plugin);
			(t.stat = l), s.pluginSystem.add("stat", l);
		  },
		  40790: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166);
			(n.Config.prototype.toolbarSticky = !0),
			  (n.Config.prototype.toolbarDisableStickyForMobile = !0),
			  (n.Config.prototype.toolbarStickyOffset = 0);
		  },
		  82808: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.sticky = void 0);
			var n = o(20255);
			o(60057);
			var r = o(86893),
			  i = o(85605),
			  a = o(24263),
			  s = o(40332),
			  l = o(43441),
			  c = o(17332);
			o(40790);
			var u = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.isToolbarSticked = !1),
				  (t.createDummy = function (e) {
					r.IS_IE &&
					  !t.dummyBox &&
					  ((t.dummyBox = t.j.c.div()),
					  t.dummyBox.classList.add("jodit_sticky-dummy_toolbar"),
					  t.j.container.insertBefore(t.dummyBox, e));
				  }),
				  (t.addSticky = function (e) {
					t.isToolbarSticked ||
					  (t.createDummy(e),
					  t.j.container.classList.add("jodit_sticky"),
					  (t.isToolbarSticked = !0)),
					  (0, s.css)(e, {
						top: t.j.o.toolbarStickyOffset || null,
						width: t.j.container.offsetWidth - 2,
					  }),
					  r.IS_IE &&
						t.dummyBox &&
						(0, s.css)(t.dummyBox, { height: e.offsetHeight });
				  }),
				  (t.removeSticky = function (e) {
					t.isToolbarSticked &&
					  ((0, s.css)(e, { width: "", top: "" }),
					  t.j.container.classList.remove("jodit_sticky"),
					  (t.isToolbarSticked = !1));
				  }),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  e.e
					.on(
					  e.ow,
					  "scroll.sticky wheel.sticky mousewheel.sticky resize.sticky",
					  this.onScroll,
					)
					.on("getStickyState.sticky", function () {
					  return t.isToolbarSticked;
					});
				}),
				(t.prototype.onScroll = function () {
				  var e = this.jodit,
					t =
					  e.ow.pageYOffset ||
					  (e.od.documentElement && e.od.documentElement.scrollTop) ||
					  0,
					o = (0, s.offset)(e.container, e, e.od, !0),
					n =
					  e.getMode() === r.MODE_WYSIWYG &&
					  t + e.o.toolbarStickyOffset > o.top &&
					  o.top + o.height > t + e.o.toolbarStickyOffset &&
					  !(e.o.toolbarDisableStickyForMobile && this.isMobile());
				  if (
					e.o.toolbarSticky &&
					!0 === e.o.toolbar &&
					this.isToolbarSticked !== n
				  ) {
					var i = e.toolbarContainer;
					i && (n ? this.addSticky(i) : this.removeSticky(i)),
					  e.e.fire("toggleSticky", n);
				  }
				}),
				(t.prototype.isMobile = function () {
				  return (
					this.j &&
					this.j.options &&
					this.j.container &&
					this.j.o.sizeSM >= this.j.container.offsetWidth
				  );
				}),
				(t.prototype.beforeDestruct = function (e) {
				  this.dummyBox && a.Dom.safeRemove(this.dummyBox),
					e.e
					  .off(
						e.ow,
						"scroll.sticky wheel.sticky mousewheel.sticky resize.sticky",
						this.onScroll,
					  )
					  .off(".sticky");
				}),
				n.__decorate([(0, l.throttle)()], t.prototype, "onScroll", null),
				t
			  );
			})(i.Plugin);
			(t.sticky = u), c.pluginSystem.add("sticky", u);
		  },
		  31750: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(77904);
			(n.Config.prototype.usePopupForSpecialCharacters = !1),
			  (n.Config.prototype.specialCharacters = [
				"!",
				"&quot;",
				"#",
				"$",
				"%",
				"&amp;",
				"'",
				"(",
				")",
				"*",
				"+",
				"-",
				".",
				"/",
				"0",
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				":",
				";",
				"&lt;",
				"=",
				"&gt;",
				"?",
				"@",
				"A",
				"B",
				"C",
				"D",
				"E",
				"F",
				"G",
				"H",
				"I",
				"J",
				"K",
				"L",
				"M",
				"N",
				"O",
				"P",
				"Q",
				"R",
				"S",
				"T",
				"U",
				"V",
				"W",
				"X",
				"Y",
				"Z",
				"[",
				"]",
				"^",
				"_",
				"`",
				"a",
				"b",
				"c",
				"d",
				"e",
				"f",
				"g",
				"h",
				"i",
				"j",
				"k",
				"l",
				"m",
				"n",
				"o",
				"p",
				"q",
				"r",
				"s",
				"t",
				"u",
				"v",
				"w",
				"x",
				"y",
				"z",
				"{",
				"|",
				"}",
				"~",
				"&euro;",
				"&lsquo;",
				"&rsquo;",
				"&ldquo;",
				"&rdquo;",
				"&ndash;",
				"&mdash;",
				"&iexcl;",
				"&cent;",
				"&pound;",
				"&curren;",
				"&yen;",
				"&brvbar;",
				"&sect;",
				"&uml;",
				"&copy;",
				"&ordf;",
				"&laquo;",
				"&raquo;",
				"&not;",
				"&reg;",
				"&macr;",
				"&deg;",
				"&sup2;",
				"&sup3;",
				"&acute;",
				"&micro;",
				"&para;",
				"&middot;",
				"&cedil;",
				"&sup1;",
				"&ordm;",
				"&frac14;",
				"&frac12;",
				"&frac34;",
				"&iquest;",
				"&Agrave;",
				"&Aacute;",
				"&Acirc;",
				"&Atilde;",
				"&Auml;",
				"&Aring;",
				"&AElig;",
				"&Ccedil;",
				"&Egrave;",
				"&Eacute;",
				"&Ecirc;",
				"&Euml;",
				"&Igrave;",
				"&Iacute;",
				"&Icirc;",
				"&Iuml;",
				"&ETH;",
				"&Ntilde;",
				"&Ograve;",
				"&Oacute;",
				"&Ocirc;",
				"&Otilde;",
				"&Ouml;",
				"&times;",
				"&Oslash;",
				"&Ugrave;",
				"&Uacute;",
				"&Ucirc;",
				"&Uuml;",
				"&Yacute;",
				"&THORN;",
				"&szlig;",
				"&agrave;",
				"&aacute;",
				"&acirc;",
				"&atilde;",
				"&auml;",
				"&aring;",
				"&aelig;",
				"&ccedil;",
				"&egrave;",
				"&eacute;",
				"&ecirc;",
				"&euml;",
				"&igrave;",
				"&iacute;",
				"&icirc;",
				"&iuml;",
				"&eth;",
				"&ntilde;",
				"&ograve;",
				"&oacute;",
				"&ocirc;",
				"&otilde;",
				"&ouml;",
				"&divide;",
				"&oslash;",
				"&ugrave;",
				"&uacute;",
				"&ucirc;",
				"&uuml;",
				"&yacute;",
				"&thorn;",
				"&yuml;",
				"&OElig;",
				"&oelig;",
				"&#372;",
				"&#374",
				"&#373",
				"&#375;",
				"&sbquo;",
				"&#8219;",
				"&bdquo;",
				"&hellip;",
				"&trade;",
				"&#9658;",
				"&bull;",
				"&rarr;",
				"&rArr;",
				"&hArr;",
				"&diams;",
				"&asymp;",
			  ]),
			  r.Icon.set("symbols", o(43158)),
			  (n.Config.prototype.controls.symbols = {
				hotkeys: ["ctrl+shift+i", "cmd+shift+i"],
				tooltip: "Insert Special Character",
				popup: function (e, t, o, n) {
				  var r = e.e.fire("generateSpecialCharactersTable.symbols");
				  if (r) {
					if (e.o.usePopupForSpecialCharacters) {
					  var i = e.c.div();
					  return (
						i.classList.add("jodit-symbols"),
						i.appendChild(r),
						e.e.on(r, "close_dialog", n),
						i
					  );
					}
					e.alert(
					  r,
					  "Select Special Character",
					  void 0,
					  "jodit-symbols",
					).bindDestruct(e);
					var a = r.querySelector("a");
					a && a.focus();
				  }
				},
			  });
		  },
		  21236: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.zh_tw =
				t.zh_cn =
				t.tr =
				t.ru =
				t.pt_br =
				t.pl =
				t.nl =
				t.mn =
				t.ko =
				t.ja =
				t.it =
				t.id =
				t.hu =
				t.he =
				t.fr =
				t.fa =
				t.es =
				t.de =
				t.cs_cz =
				t.ar =
				  void 0);
			var n = o(54261);
			t.ar = n;
			var r = o(60425);
			t.cs_cz = r;
			var i = o(7057);
			t.de = i;
			var a = o(48356);
			t.es = a;
			var s = o(11428);
			t.fa = s;
			var l = o(29084);
			t.fr = l;
			var c = o(22876);
			t.he = c;
			var u = o(20890);
			t.hu = u;
			var d = o(75987);
			t.id = d;
			var p = o(60379);
			t.it = p;
			var f = o(99950);
			t.ja = f;
			var h = o(60934);
			t.ko = h;
			var m = o(45913);
			t.mn = m;
			var v = o(21994);
			t.nl = v;
			var g = o(38128);
			t.pl = g;
			var y = o(71515);
			t.pt_br = y;
			var _ = o(58194);
			t.ru = _;
			var b = o(65802);
			t.tr = b;
			var w = o(86628);
			t.zh_cn = w;
			var S = o(32210);
			t.zh_tw = S;
		  },
		  48560: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.symbols = void 0);
			var n = o(20255);
			o(33393);
			var r = o(86893),
			  i = o(85605),
			  a = o(24263),
			  s = o(76502),
			  l = o(17332);
			o(31750);
			var c = (function (e) {
			  function t(t) {
				var n = e.call(this, t) || this;
				return (
				  (n.buttons = [{ name: "symbols", group: "insert" }]),
				  (n.countInRow = 17),
				  (0, l.extendLang)(o(21236)),
				  n
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  var t = this;
				  e.e.on("generateSpecialCharactersTable.symbols", function () {
					for (
					  var o = e.c.fromHTML(
						  '<div class="jodit-symbols__container">\n\t\t\t\t\t\t<div class="jodit-symbols__container_table">\n\t\t\t\t\t\t\t<table class="jodit-symbols__table"><tbody></tbody></table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jodit-symbols__container_preview">\n\t\t\t\t\t\t\t<div class="jodit-symbols__preview"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>',
						),
						n = o.querySelector(".jodit-symbols__preview"),
						i = o.querySelector("table").tBodies[0],
						l = [],
						c = 0;
					  e.o.specialCharacters.length > c;
  
					) {
					  for (
						var u = e.c.element("tr"), d = 0;
						t.countInRow > d && e.o.specialCharacters.length > c;
						d += 1, c += 1
					  ) {
						var p = e.c.element("td"),
						  f = e.c.fromHTML(
							'<a\n\t\t\t\t\t\t\t\t\tdata-index="'
							  .concat(c, '"\n\t\t\t\t\t\t\t\t\tdata-index-j="')
							  .concat(
								d,
								'"\n\t\t\t\t\t\t\t\t\trole="option"\n\t\t\t\t\t\t\t\t\ttabindex="-1"\n\t\t\t\t\t\t\t>',
							  )
							  .concat(e.o.specialCharacters[c], "</a>"),
						  );
						l.push(f), p.appendChild(f), u.appendChild(p);
					  }
					  i.appendChild(u);
					}
					var h = t;
					return (
					  e.e
						.on(l, "focus", function () {
						  n.innerHTML = this.innerHTML;
						})
						.on(l, "mousedown", function (t) {
						  a.Dom.isTag(this, "a") &&
							(e.s.focus(),
							e.s.insertHTML(this.innerHTML),
							e.e.fire(this, "close_dialog"),
							t && t.preventDefault(),
							t && t.stopImmediatePropagation());
						})
						.on(l, "mouseenter", function () {
						  a.Dom.isTag(this, "a") && this.focus();
						})
						.on(l, "keydown", function (t) {
						  var o = t.target;
						  if (a.Dom.isTag(o, "a")) {
							var n = parseInt((0, s.attr)(o, "-index") || "0", 10),
							  i = parseInt(
								(0, s.attr)(o, "data-index-j") || "0",
								10,
							  ),
							  c = void 0;
							switch (t.key) {
							  case r.KEY_UP:
							  case r.KEY_DOWN:
								void 0 ===
								  l[
									(c =
									  t.key === r.KEY_UP
										? n - h.countInRow
										: n + h.countInRow)
								  ] &&
								  (c =
									t.key === r.KEY_UP
									  ? Math.floor(l.length / h.countInRow) *
										  h.countInRow +
										i
									  : i) >
									l.length - 1 &&
								  (c -= h.countInRow),
								  l[c] && l[c].focus();
								break;
							  case r.KEY_RIGHT:
							  case r.KEY_LEFT:
								void 0 ===
								  l[(c = t.key === r.KEY_LEFT ? n - 1 : n + 1)] &&
								  (c = t.key === r.KEY_LEFT ? l.length - 1 : 0),
								  l[c] && l[c].focus();
								break;
							  case r.KEY_ENTER:
								e.e.fire(o, "mousedown"),
								  t.stopImmediatePropagation(),
								  t.preventDefault();
							}
						  }
						}),
					  o
					);
				  });
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e.off("generateSpecialCharactersTable.symbols");
				}),
				t
			  );
			})(i.Plugin);
			(t.symbols = c), l.pluginSystem.add("symbols", c);
		  },
		  15797: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(20255).__exportStar(o(41170), t);
		  },
		  41170: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.onTabInsideLi = void 0);
			var n = o(20255),
			  r = o(24263);
			o(603),
			  (t.onTabInsideLi = function (e, t) {
				if ((void 0 === t && (t = !1), !e.o.tab.tabInsideLiInsertNewList))
				  return !1;
				var o = n.__read(
					(function (e) {
					  var t = e.createInside.fake(),
						o = e.createInside.fake(),
						n = e.s.range.cloneRange();
					  n.collapse(!0), n.insertNode(t);
					  var r = e.s.range.cloneRange();
					  return r.collapse(!1), r.insertNode(o), [t, o];
					})(e),
					2,
				  ),
				  i = o[0],
				  a = o[1];
				try {
				  var s = (function (e, t, o) {
					var n = r.Dom.closest(t, "li", e.editor);
					return (
					  !!n &&
					  !(!o && !r.Dom.isTag(n.previousElementSibling, "li")) &&
					  !(o && !r.Dom.closest(n, "li", e.editor)) &&
					  n
					);
				  })(e, i, t);
				  if (!s) return !1;
				  if (
					!(function (e, t, o) {
					  var n = r.Dom.closest(o, "li", t.editor);
					  return !(!n || (n !== e && !e.contains(n)));
					})(s, e, i)
				  )
					return !1;
				  var l = r.Dom.closest(s, ["ol", "ul"], e.editor);
				  return !(
					!l ||
					(t && !r.Dom.closest(l, "li", e.editor)) ||
					(t
					  ? (function (e, t, o) {
						  var n = r.Dom.closest(t, "li", e.editor),
							i = Array.from(t.children).filter(function (e) {
							  return r.Dom.isTag(e, "li");
							});
						  r.Dom.after(n, o);
						  var a = i.indexOf(o);
						  if (
							((0 !== a && 1 !== i.length) || r.Dom.safeRemove(t),
							a !== i.length - 1)
						  ) {
							var s = t.cloneNode();
							r.Dom.append(o, s);
							for (var l = a + 1; i.length > l; l += 1)
							  r.Dom.append(s, i[l]);
						  }
						})(e, l, s)
					  : (function (e, t, o) {
						  var n = o.previousElementSibling,
							i = n.lastElementChild,
							a = r.Dom.isTag(i, t.tagName)
							  ? i
							  : e.createInside.element(
								  t.tagName,
								  Array.from(t.attributes).reduce(function (
									e,
									t,
								  ) {
									return (e[t.name] = t.value), e;
								  }, {}),
								);
						  a.appendChild(o), i !== a && n.appendChild(a);
						})(e, l, s),
					0)
				  );
				} finally {
				  var c = e.s.createRange();
				  c.setStartAfter(i),
					c.setEndBefore(a),
					e.s.selectRange(c),
					r.Dom.safeRemove(i),
					r.Dom.safeRemove(a);
				}
				return !1;
			  });
		  },
		  56198: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.tab = { tabInsideLiInsertNewList: !0 });
		  },
		  32246: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255),
			  r = o(57549),
			  i = o(43441),
			  a = o(86893),
			  s = o(17332),
			  l = o(15797);
			o(56198);
			var c = (function (e) {
			  function t() {
				return (null !== e && e.apply(this, arguments)) || this;
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {}),
				(t.prototype.__onTab = function (e) {
				  if (e.key === a.KEY_TAB && this.__onShift(e.shiftKey))
					return !1;
				}),
				(t.prototype.__onCommand = function (e) {
				  if (
					("indent" === e || "outdent" === e) &&
					this.__onShift("outdent" === e)
				  )
					return !1;
				}),
				(t.prototype.__onShift = function (e) {
				  var t = (0, l.onTabInsideLi)(this.j, e);
				  return t && this.j.e.fire("afterTab", e), t;
				}),
				(t.prototype.beforeDestruct = function (e) {}),
				n.__decorate(
				  [(0, i.watch)(":keydown.tab")],
				  t.prototype,
				  "__onTab",
				  null,
				),
				n.__decorate(
				  [(0, i.watch)(":beforeCommand.tab")],
				  t.prototype,
				  "__onCommand",
				  null,
				),
				t
			  );
			})(r.Plugin);
			s.pluginSystem.add("tab", c);
		  },
		  23308: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.tableKeyboardNavigation = void 0);
			var n = o(86893),
			  r = o(24263),
			  i = o(25120),
			  a = o(17332);
			function s(e) {
			  e.e
				.off(".tableKeyboardNavigation")
				.on("keydown.tableKeyboardNavigation", function (t) {
				  var o, a;
				  if (
					(t.key === n.KEY_TAB ||
					  t.key === n.KEY_LEFT ||
					  t.key === n.KEY_RIGHT ||
					  t.key === n.KEY_UP ||
					  t.key === n.KEY_DOWN) &&
					((o = e.s.current()),
					(a = r.Dom.up(
					  o,
					  function (e) {
						return e && e.nodeName && /^td|th$/i.test(e.nodeName);
					  },
					  e.editor,
					)))
				  ) {
					var s = e.s.range;
					if (
					  t.key === n.KEY_TAB ||
					  o === a ||
					  (((t.key !== n.KEY_LEFT && t.key !== n.KEY_UP) ||
						!(
						  r.Dom.prev(
							o,
							function (e) {
							  return t.key === n.KEY_UP
								? r.Dom.isTag(e, "br")
								: Boolean(e);
							},
							a,
						  ) ||
						  (t.key !== n.KEY_UP &&
							r.Dom.isText(o) &&
							0 !== s.startOffset)
						)) &&
						((t.key !== n.KEY_RIGHT && t.key !== n.KEY_DOWN) ||
						  !(
							r.Dom.next(
							  o,
							  function (e) {
								return t.key === n.KEY_DOWN
								  ? r.Dom.isTag(e, "br")
								  : Boolean(e);
							  },
							  a,
							) ||
							(t.key !== n.KEY_DOWN &&
							  r.Dom.isText(o) &&
							  o.nodeValue &&
							  s.startOffset !== o.nodeValue.length)
						  )))
					) {
					  var l = r.Dom.up(
						  a,
						  function (e) {
							return e && /^table$/i.test(e.nodeName);
						  },
						  e.editor,
						),
						c = null;
					  switch (t.key) {
						case n.KEY_TAB:
						case n.KEY_LEFT:
						  var u =
							t.key === n.KEY_LEFT || t.shiftKey ? "prev" : "next";
						  (c = r.Dom[u](
							a,
							function (e) {
							  return e && /^td|th$/i.test(e.tagName);
							},
							l,
						  )) ||
							(i.Table.appendRow(
							  l,
							  "next" !== u && l.querySelector("tr"),
							  "next" === u,
							  e.createInside,
							),
							(c = r.Dom[u](a, r.Dom.isCell, l)));
						  break;
						case n.KEY_UP:
						case n.KEY_DOWN:
						  var d = 0,
							p = 0,
							f = i.Table.formalMatrix(l, function (e, t, o) {
							  e === a && ((d = t), (p = o));
							});
						  t.key === n.KEY_UP
							? void 0 !== f[d - 1] && (c = f[d - 1][p])
							: void 0 !== f[d + 1] && (c = f[d + 1][p]);
					  }
					  if (c) {
						if (c.firstChild)
						  t.key === n.KEY_TAB
							? e.s.select(c, !0)
							: e.s.setCursorIn(
								c,
								t.key === n.KEY_RIGHT || t.key === n.KEY_DOWN,
							  );
						else {
						  var h = e.createInside.element("br");
						  c.appendChild(h), e.s.setCursorBefore(h);
						}
						return !1;
					  }
					}
				  }
				});
			}
			(t.tableKeyboardNavigation = s),
			  a.pluginSystem.add("tableKeyboardNavigation", s);
		  },
		  30739: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(64968),
			  i = o(76502),
			  a = o(40332),
			  s = o(77904);
			(n.Config.prototype.table = {
			  selectionCellStyle: "border: 1px double #1e88e5 !important;",
			  useExtraClassesOptions: !1,
			}),
			  s.Icon.set("table", o(51716)),
			  (n.Config.prototype.controls.table = {
				data: {
				  cols: 10,
				  rows: 10,
				  classList: {
					"table table-bordered": "Bootstrap Bordered",
					"table table-striped": "Bootstrap Striped",
					"table table-dark": "Bootstrap Dark",
				  },
				},
				popup: function (e, t, o, n, s) {
				  for (
					var l = o.data && o.data.rows ? o.data.rows : 10,
					  c = o.data && o.data.cols ? o.data.cols : 10,
					  u = e.c.fromHTML(
						'<form class="jodit-form jodit-form__inserter"><div class="jodit-form__table-creator-box"><div class="jodit-form__container"></div><div class="jodit-form__options">' +
						  (function () {
							if (!e.o.table.useExtraClassesOptions) return "";
							var t = [];
							if (o.data) {
							  var n = o.data.classList;
							  Object.keys(n).forEach(function (e) {
								t.push(
								  '<label class="jodit_vertical_middle"><input class="jodit-checkbox" value="'
									.concat(e, '" type="checkbox"/>')
									.concat(n[e], "</label>"),
								);
							  });
							}
							return t.join("");
						  })() +
						  '</div></div><label class="jodit-form__center"><span>1</span> &times; <span>1</span></label></form>',
					  ),
					  d = u.querySelectorAll("span")[0],
					  p = u.querySelectorAll("span")[1],
					  f = u.querySelector(".jodit-form__container"),
					  h = u.querySelector(".jodit-form__options"),
					  m = [],
					  v = l * c,
					  g = 0;
					v > g;
					g += 1
				  )
					m[g] || m.push(e.c.element("span", { dataIndex: g }));
				  if (
					(e.e
					  .on(f, "mousemove", function (e, t) {
						var o = e.target;
						if (r.Dom.isTag(o, "span")) {
						  for (
							var n =
								void 0 === t || isNaN(t)
								  ? parseInt((0, i.attr)(o, "-index") || "0", 10)
								  : t || 0,
							  a = Math.ceil((n + 1) / c),
							  s = (n % c) + 1,
							  l = 0;
							m.length > l;
							l += 1
						  )
							m[l].className =
							  (l % c) + 1 > s || a < Math.ceil((l + 1) / c)
								? ""
								: "jodit_hovered";
						  (p.textContent = s.toString()),
							(d.textContent = a.toString());
						}
					  })
					  .on(f, "touchstart mousedown", function (t) {
						var o = t.target;
						if (
						  (t.preventDefault(),
						  t.stopImmediatePropagation(),
						  r.Dom.isTag(o, "span"))
						) {
						  var s = parseInt((0, i.attr)(o, "-index") || "0", 10),
							l = Math.ceil((s + 1) / c),
							u = (s % c) + 1,
							d = e.createInside,
							p = d.element("tbody"),
							f = d.element("table");
						  f.appendChild(p);
						  for (var m, v, g = null, y = 1; l >= y; y += 1) {
							m = d.element("tr");
							for (var _ = 1; u >= _; _ += 1)
							  (v = d.element("td")),
								g || (g = v),
								(0, a.css)(
								  v,
								  "width",
								  (100 / u).toFixed(4) + "%",
								),
								v.appendChild(d.element("br")),
								m.appendChild(d.text("\n")),
								m.appendChild(d.text("\t")),
								m.appendChild(v);
							p.appendChild(d.text("\n")), p.appendChild(m);
						  }
						  (0, a.$$)("input[type=checkbox]:checked", h).forEach(
							function (e) {
							  e.value.split(/[\s]+/).forEach(function (e) {
								f.classList.add(e);
							  });
							},
						  ),
							e.editor.firstChild &&
							  e.s.insertNode(d.text("\n"), !1, !1),
							e.s.insertNode(f, !1),
							g &&
							  (e.s.setCursorIn(g),
							  (0, a.scrollIntoViewIfNeeded)(g, e.editor, e.ed)),
							n();
						}
					  }),
					s && s.parentElement)
				  ) {
					for (g = 0; l > g; g += 1) {
					  for (var y = e.c.div(), _ = 0; c > _; _ += 1)
						y.appendChild(m[g * c + _]);
					  f.appendChild(y);
					}
					m[0] && (m[0].className = "hovered");
				  }
				  return u;
				},
				tooltip: "Insert table",
			  });
		  },
		  45842: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.table = void 0),
			  o(51057);
			var n = o(17332);
			function r(e) {
			  e.registerButton({ name: "table", group: "insert" });
			}
			o(30739), (t.table = r), n.pluginSystem.add("table", r);
		  },
		  79114: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(93166),
			  r = o(718),
			  i = o(40332),
			  a = o(95963),
			  s = o(96516);
			o(77904).Icon.set("video", o(49222)),
			  (n.Config.prototype.controls.video = {
				popup: function (e, t, o, n) {
				  var l = new a.UIForm(e, [
					  new a.UIBlock(e, [
						new a.UIInput(e, {
						  name: "url",
						  required: !0,
						  label: "URL",
						  placeholder: "https://",
						  validators: ["url"],
						}),
					  ]),
					  new a.UIBlock(e, [
						(0, s.Button)(e, "", "Insert", "primary").onAction(
						  function () {
							return l.submit();
						  },
						),
					  ]),
					]),
					c = new a.UIForm(e, [
					  new a.UIBlock(e, [
						new a.UITextArea(e, {
						  name: "code",
						  required: !0,
						  label: "Embed code",
						}),
					  ]),
					  new a.UIBlock(e, [
						(0, s.Button)(e, "", "Insert", "primary").onAction(
						  function () {
							return c.submit();
						  },
						),
					  ]),
					]),
					u = [],
					d = function (t) {
					  e.s.restore(), e.s.insertHTML(t), n();
					};
				  return (
					e.s.save(),
					u.push(
					  { icon: "link", name: "Link", content: l.container },
					  { icon: "source", name: "Code", content: c.container },
					),
					l.onSubmit(function (e) {
					  d((0, i.convertMediaUrlToVideoEmbed)(e.url));
					}),
					c.onSubmit(function (e) {
					  d(e.code);
					}),
					(0, r.TabsWidget)(e, u)
				  );
				},
				tags: ["iframe"],
				tooltip: "Insert youtube/vimeo video",
			  });
		  },
		  19889: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(17332);
			o(79114),
			  n.pluginSystem.add("video", function (e) {
				e.registerButton({ name: "video", group: "media" });
			  });
		  },
		  64401: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.wrapNodes = {
				exclude: ["hr", "style", "br"],
				emptyBlockAfterInit: !0,
			  });
		  },
		  20728: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255),
			  r = o(57549),
			  i = o(64968),
			  a = o(24421),
			  s = o(43441),
			  l = o(17332);
			o(64401);
			var c = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.isSuitableStart = function (e) {
					return (
					  (i.Dom.isText(e) &&
						(0, a.isString)(e.nodeValue) &&
						/[^\s]/.test(e.nodeValue)) ||
					  (t.isNotClosed(e) && !i.Dom.isTemporary(e))
					);
				  }),
				  (t.isSuitable = function (e) {
					return i.Dom.isText(e) || t.isNotClosed(e);
				  }),
				  (t.isNotClosed = function (e) {
					return (
					  i.Dom.isElement(e) &&
					  !(
						i.Dom.isBlock(e) ||
						i.Dom.isTag(e, t.j.o.wrapNodes.exclude)
					  )
					);
				  }),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function (e) {
				  "br" !== e.o.enter.toLowerCase() &&
					e.e
					  .on(
						"drop.wtn focus.wtn keydown.wtn mousedown.wtn afterInit.wtn",
						this.preprocessInput,
						{ top: !0 },
					  )
					  .on(
						"afterInit.wtn postProcessSetEditorValue.wtn",
						this.postProcessSetEditorValue,
					  );
				}),
				(t.prototype.beforeDestruct = function (e) {
				  e.e.off(".wtn");
				}),
				(t.prototype.postProcessSetEditorValue = function () {
				  var e = this.jodit;
				  if (e.isEditorMode()) {
					for (var t = e.editor.firstChild, o = !1; t; ) {
					  if (
						((t = this.checkAloneListLeaf(t, e)),
						this.isSuitableStart(t))
					  ) {
						o || e.s.save(), (o = !0);
						var n = e.createInside.element(e.o.enter);
						for (i.Dom.before(t, n); t && this.isSuitable(t); ) {
						  var r = t.nextSibling;
						  n.appendChild(t), (t = r);
						}
						n.normalize(), (t = n);
					  }
					  t = t && t.nextSibling;
					}
					o &&
					  (e.s.restore(),
					  "afterInit" === e.e.current && e.e.fire("internalChange"));
				  }
				}),
				(t.prototype.checkAloneListLeaf = function (e, t) {
				  var o = e,
					n = e;
				  do {
					if (
					  !i.Dom.isElement(n) ||
					  !i.Dom.isTag(n, "li") ||
					  i.Dom.isTag(n.parentElement, ["ul", "ol"])
					)
					  break;
					var r = i.Dom.findNotEmptySibling(n, !1);
					i.Dom.isTag(o, "ul")
					  ? o.appendChild(n)
					  : (o = i.Dom.wrap(n, "ul", t.createInside)),
					  (n = r);
				  } while (n);
				  return o;
				}),
				(t.prototype.preprocessInput = function () {
				  var e = this.jodit,
					t = "afterInit" === e.e.current;
				  if (
					e.isEditorMode() &&
					!e.editor.firstChild &&
					(e.o.wrapNodes.emptyBlockAfterInit || !t)
				  ) {
					var o = e.createInside.element(e.o.enter),
					  n = e.createInside.element("br");
					i.Dom.append(o, n),
					  i.Dom.append(e.editor, o),
					  e.s.isFocused() && e.s.setCursorBefore(n),
					  e.e.fire("internalChange");
				  }
				}),
				n.__decorate(
				  [s.autobind],
				  t.prototype,
				  "postProcessSetEditorValue",
				  null,
				),
				n.__decorate([s.autobind], t.prototype, "preprocessInput", null),
				t
			  );
			})(r.Plugin);
			l.pluginSystem.add("wrapNodes", c);
		  },
		  71707: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (o(93166).Config.prototype.showXPathInStatusbar = !0);
		  },
		  18238: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var n = o(20255);
			o(64618);
			var r = o(86893),
			  i = o(60403),
			  a = o(64968),
			  s = o(40332),
			  l = o(57549),
			  c = o(81438),
			  u = o(17332);
			o(71707);
			var d = (function (e) {
			  function t() {
				var t = (null !== e && e.apply(this, arguments)) || this;
				return (
				  (t.onContext = function (e, o) {
					return (
					  t.menu || (t.menu = new i.ContextMenu(t.j)),
					  t.menu.show(o.clientX, o.clientY, [
						{
						  icon: "bin",
						  title: e === t.j.editor ? "Clear" : "Remove",
						  exec: function () {
							e !== t.j.editor
							  ? a.Dom.safeRemove(e)
							  : (t.j.value = ""),
							  t.j.synchronizeValues();
						  },
						},
						{
						  icon: "select-all",
						  title: "Select",
						  exec: function () {
							t.j.s.select(e);
						  },
						},
					  ]),
					  !1
					);
				  }),
				  (t.onSelectPath = function (e, o) {
					t.j.s.focus();
					var n = (0, s.attr)(o.target, "-path") || "/";
					if ("/" === n) return t.j.execCommand("selectall"), !1;
					try {
					  var r = t.j.ed
						.evaluate(n, t.j.editor, null, XPathResult.ANY_TYPE, null)
						.iterateNext();
					  if (r) return t.j.s.select(r), !1;
					} catch (e) {}
					return t.j.s.select(e), !1;
				  }),
				  (t.tpl = function (e, o, n, r) {
					var i = t.j.c.fromHTML(
						'<span class="jodit-xpath__item"><a role="button" data-path="'
						  .concat(o, '" title="')
						  .concat(r, '" tabindex="-1"\'>')
						  .concat((0, s.trim)(n), "</a></span>"),
					  ),
					  a = i.firstChild;
					return (
					  t.j.e
						.on(a, "click", t.onSelectPath.bind(t, e))
						.on(a, "contextmenu", t.onContext.bind(t, e)),
					  i
					);
				  }),
				  (t.removeSelectAll = function () {
					t.selectAllButton &&
					  (t.selectAllButton.destruct(), delete t.selectAllButton);
				  }),
				  (t.appendSelectAll = function () {
					t.removeSelectAll(),
					  (t.selectAllButton = (0, c.makeButton)(
						t.j,
						n.__assign(
						  { name: "selectall" },
						  t.j.o.controls.selectall,
						),
					  )),
					  (t.selectAllButton.state.size = "tiny"),
					  t.container &&
						t.container.insertBefore(
						  t.selectAllButton.container,
						  t.container.firstChild,
						);
				  }),
				  (t.calcPathImd = function () {
					if (!t.isDestructed) {
					  var e,
						o,
						n,
						i = t.j.s.current();
					  t.container && (t.container.innerHTML = r.INVISIBLE_SPACE),
						i &&
						  a.Dom.up(
							i,
							function (r) {
							  r &&
								t.j.editor !== r &&
								!a.Dom.isText(r) &&
								((e = r.nodeName.toLowerCase()),
								(o = (0, s.getXPathByElement)(
								  r,
								  t.j.editor,
								).replace(/^\//, "")),
								(n = t.tpl(r, o, e, t.j.i18n("Select %s", e))),
								t.container &&
								  t.container.insertBefore(
									n,
									t.container.firstChild,
								  ));
							},
							t.j.editor,
						  ),
						t.appendSelectAll();
					}
				  }),
				  (t.calcPath = t.j.async.debounce(
					t.calcPathImd,
					2 * t.j.defaultTimeout,
				  )),
				  t
				);
			  }
			  return (
				n.__extends(t, e),
				(t.prototype.afterInit = function () {
				  var e = this;
				  this.j.o.showXPathInStatusbar &&
					((this.container = this.j.c.div("jodit-xpath")),
					this.j.e
					  .off(".xpath")
					  .on(
						"mouseup.xpath change.xpath keydown.xpath changeSelection.xpath",
						this.calcPath,
					  )
					  .on(
						"afterSetMode.xpath afterInit.xpath changePlace.xpath",
						function () {
						  e.j.o.showXPathInStatusbar &&
							e.container &&
							(e.j.statusbar.append(e.container),
							e.j.getRealMode() === r.MODE_WYSIWYG
							  ? e.calcPath()
							  : (e.container &&
								  (e.container.innerHTML = r.INVISIBLE_SPACE),
								e.appendSelectAll()));
						},
					  ),
					this.calcPath());
				}),
				(t.prototype.beforeDestruct = function () {
				  this.j && this.j.events && this.j.e.off(".xpath"),
					this.removeSelectAll(),
					this.menu && this.menu.destruct(),
					a.Dom.safeRemove(this.container),
					delete this.menu,
					delete this.container;
				}),
				t
			  );
			})(l.Plugin);
			u.pluginSystem.add("xpath", d);
		  },
		  89019: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  o(61227),
			  o(690),
			  o(66622),
			  o(69220),
			  o(10444),
			  Array.prototype.includes ||
				(Array.prototype.includes = function (e) {
				  return this.indexOf(e) > -1;
				}),
			  "function" != typeof Object.assign &&
				Object.defineProperty(Object, "assign", {
				  value: function (e, t) {
					if (null == e)
					  throw new TypeError(
						"Cannot convert undefined or null to object",
					  );
					for (var o = Object(e), n = 1; arguments.length > n; n++) {
					  var r = arguments[n];
					  if (null != r)
						for (var i in r)
						  Object.prototype.hasOwnProperty.call(r, i) &&
							(o[i] = r[i]);
					}
					return o;
				  },
				  writable: !0,
				  configurable: !0,
				}),
			  Array.prototype.find ||
				(Array.prototype.find = function (e) {
				  return this.indexOf(e) > -1 ? e : void 0;
				}),
			  String.prototype.endsWith ||
				(String.prototype.endsWith = function (e) {
				  return this[this.length - 1] === e;
				});
		  },
		  15261: function (e, t, o) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 }),
			  (t.valign =
				t.upload =
				t.update =
				t.unlock =
				t.settings =
				t.save =
				t.right =
				t.resize_handler =
				t.plus =
				t.pencil =
				t.ok =
				t.lock =
				t.left =
				t.info_circle =
				t.folder =
				t.file =
				t.eye =
				t.dots =
				t.chevron =
				t.check =
				t.center =
				t.cancel =
				t.bin =
				t.angle_up =
				t.angle_right =
				t.angle_left =
				t.angle_down =
				  void 0);
			var n = o(1755);
			t.angle_down = n;
			var r = o(74911);
			t.angle_left = r;
			var i = o(8805);
			t.angle_right = i;
			var a = o(16547);
			t.angle_up = a;
			var s = o(10856);
			t.bin = s;
			var l = o(98441);
			t.cancel = l;
			var c = o(52488);
			t.center = c;
			var u = o(9370);
			t.check = u;
			var d = o(66543);
			t.chevron = d;
			var p = o(608);
			t.dots = p;
			var f = o(42840);
			t.eye = f;
			var h = o(79096);
			t.file = h;
			var m = o(33014);
			t.folder = m;
			var v = o(91677);
			t.info_circle = v;
			var g = o(8259);
			t.left = g;
			var y = o(64467);
			t.lock = y;
			var _ = o(86934);
			t.ok = _;
			var b = o(76133);
			t.pencil = b;
			var w = o(45519);
			t.plus = w;
			var S = o(90265);
			t.resize_handler = S;
			var C = o(81279);
			t.right = C;
			var j = o(68899);
			t.save = j;
			var E = o(70744);
			t.settings = E;
			var x = o(19201);
			t.unlock = x;
			var k = o(84930);
			t.update = k;
			var T = o(99704);
			t.upload = T;
			var I = o(2304);
			t.valign = I;
		  },
		  80078: function (e) {
			e.exports = { "copy-format": "نسخ التنسيق" };
		  },
		  16986: function (e) {
			e.exports = { "copy-format": "Kopírovat formát" };
		  },
		  59347: function (e) {
			e.exports = { "copy-format": "Format kopierenт" };
		  },
		  63640: function (e) {
			e.exports = { "copy-format": "Copiar formato" };
		  },
		  53434: function (e) {
			e.exports = { "copy-format": "کپی کردن قالب" };
		  },
		  85638: function (e) {
			e.exports = { "copy-format": "Format de copie" };
		  },
		  31743: function (e) {
			e.exports = { "copy-format": "העתק עיצוב" };
		  },
		  66219: function (e) {
			e.exports = { "copy-format": "Formátum másolás" };
		  },
		  50331: function (e) {
			e.exports = { "copy-format": "salin format" };
		  },
		  25582: function (e) {
			e.exports = { "copy-format": "Copia il formato" };
		  },
		  82066: function (e) {
			e.exports = { "copy-format": "copyformat" };
		  },
		  71925: function (e) {
			e.exports = { "copy-format": "복사 형식" };
		  },
		  12689: function (e) {
			e.exports = { "copy-format": "Формат хуулах" };
		  },
		  65274: function (e) {
			e.exports = { "copy-format": "opmaak kopiëren" };
		  },
		  58548: function (e) {
			e.exports = { "copy-format": "format kopii" };
		  },
		  82958: function (e) {
			e.exports = { "copy-format": "Copiar formato" };
		  },
		  52315: function (e) {
			e.exports = { "copy-format": "Копировать формат" };
		  },
		  87727: function (e) {
			e.exports = { "copy-format": "Kopyalama Biçimi" };
		  },
		  9396: function (e) {
			e.exports = { "copy-format": "复制格式" };
		  },
		  28765: function (e) {
			e.exports = { "copy-format": "複製格式" };
		  },
		  47762: function (e) {
			e.exports = { "Line height": "ارتفاع الخط" };
		  },
		  97495: function (e) {
			e.exports = { "Line height": "Výška čáry" };
		  },
		  80131: function (e) {
			e.exports = { "Line height": "Zeilenhöhe" };
		  },
		  1201: function (e) {
			e.exports = { "Line height": "Altura de la línea" };
		  },
		  89912: function (e) {
			e.exports = { "Line height": "ارتفاع خط" };
		  },
		  3405: function (e) {
			e.exports = { "Line height": "Hauteur de ligne" };
		  },
		  14129: function (e) {
			e.exports = { "Line height": "גובה שורה" };
		  },
		  93729: function (e) {
			e.exports = { "Line height": "Vonal magassága" };
		  },
		  16106: function (e) {
			e.exports = { "Line height": "Tinggi baris" };
		  },
		  89690: function (e) {
			e.exports = { "Line height": "Altezza linea" };
		  },
		  33216: function (e) {
			e.exports = { "Line height": "ラインの高さ" };
		  },
		  17282: function (e) {
			e.exports = { "Line height": "선 높이" };
		  },
		  52841: function (e) {
			e.exports = { "Line height": "Зураасны өндөр" };
		  },
		  91761: function (e) {
			e.exports = { "Line height": "Lijnhoogte" };
		  },
		  61675: function (e) {
			e.exports = { "Line height": "Wysokość linii" };
		  },
		  69709: function (e) {
			e.exports = { "Line height": "Altura da linha" };
		  },
		  82591: function (e) {
			e.exports = { "Line height": "Высота линии" };
		  },
		  87649: function (e) {
			e.exports = { "Line height": "Çizgi yüksekliği" };
		  },
		  60268: function (e) {
			e.exports = { "Line height": "线高" };
		  },
		  58214: function (e) {
			e.exports = { "Line height": "ความสูงเส้น" };
		  },
		  5586: function (e) {
			e.exports = { Spellcheck: "التدقيق الإملائي" };
		  },
		  66023: function (e) {
			e.exports = { Spellcheck: "Kontrola pravopisu" };
		  },
		  65860: function (e) {
			e.exports = { Spellcheck: "Rechtschreibprüfung" };
		  },
		  86055: function (e) {
			e.exports = { Spellcheck: "Corrección ortográfica" };
		  },
		  50037: function (e) {
			e.exports = { Spellcheck: "غلطیابی املایی" };
		  },
		  7118: function (e) {
			e.exports = { Spellcheck: "Vérification Orthographique" };
		  },
		  30298: function (e) {
			e.exports = { Spellcheck: "בדיקת איות" };
		  },
		  52107: function (e) {
			e.exports = { Spellcheck: "Helyesírás-ellenőrzés" };
		  },
		  31240: function (e) {
			e.exports = { Spellcheck: "Spellchecking" };
		  },
		  4101: function (e) {
			e.exports = { Spellcheck: "Controllo ortografico" };
		  },
		  69286: function (e) {
			e.exports = { Spellcheck: "スペルチェック" };
		  },
		  13402: function (e) {
			e.exports = { Spellcheck: "맞춤법 검사" };
		  },
		  1242: function (e) {
			e.exports = { Spellcheck: "Дүрмийн алдаа шалгах" };
		  },
		  89574: function (e) {
			e.exports = { Spellcheck: "Spellingcontrole" };
		  },
		  63630: function (e) {
			e.exports = { Spellcheck: "Sprawdzanie pisowni" };
		  },
		  72212: function (e) {
			e.exports = { Spellcheck: "Verificação ortográfica" };
		  },
		  82570: function (e) {
			e.exports = { Spellcheck: "Проверка орфографии" };
		  },
		  19323: function (e) {
			e.exports = { Spellcheck: "Yazım denetimi" };
		  },
		  50279: function (e) {
			e.exports = { Spellcheck: "拼写检查" };
		  },
		  98364: function (e) {
			e.exports = { Spellcheck: "สะกดคำ" };
		  },
		  54261: function (e) {
			e.exports = { symbols: "رمز" };
		  },
		  60425: function (e) {
			e.exports = { symbols: "symbol" };
		  },
		  7057: function (e) {
			e.exports = { symbols: "Symbol" };
		  },
		  48356: function (e) {
			e.exports = { symbols: "Símbolo" };
		  },
		  11428: function (e) {
			e.exports = { symbols: "سمبل" };
		  },
		  29084: function (e) {
			e.exports = { symbols: "caractère" };
		  },
		  22876: function (e) {
			e.exports = { symbols: "תו מיוחד" };
		  },
		  20890: function (e) {
			e.exports = { symbols: "Szimbólum" };
		  },
		  75987: function (e) {
			e.exports = { symbols: "simbol" };
		  },
		  60379: function (e) {
			e.exports = { symbols: "Simbolo" };
		  },
		  99950: function (e) {
			e.exports = { symbols: "symbol" };
		  },
		  60934: function (e) {
			e.exports = { symbols: "기호" };
		  },
		  45913: function (e) {
			e.exports = { symbols: "тэмдэгт" };
		  },
		  21994: function (e) {
			e.exports = { symbols: "symbool" };
		  },
		  38128: function (e) {
			e.exports = { symbols: "symbol" };
		  },
		  71515: function (e) {
			e.exports = { symbols: "Símbolo" };
		  },
		  58194: function (e) {
			e.exports = { symbols: "символ" };
		  },
		  65802: function (e) {
			e.exports = { symbols: "Sembol" };
		  },
		  86628: function (e) {
			e.exports = { symbols: "符号" };
		  },
		  32210: function (e) {
			e.exports = { symbols: "符號" };
		  },
		  52378: function (e) {
			"use strict";
			e.exports = { assert() {} };
		  },
		},
		o = {};
	  function n(e) {
		var r = o[e];
		if (void 0 !== r) return r.exports;
		var i = (o[e] = { exports: {} });
		return t[e].call(i.exports, i, i.exports, n), i.exports;
	  }
	  (n.m = t),
		(e = []),
		(n.O = function (t, o, r, i) {
		  if (!o) {
			var a = 1 / 0;
			for (u = 0; e.length > u; u++) {
			  (o = e[u][0]), (r = e[u][1]), (i = e[u][2]);
			  for (var s = !0, l = 0; o.length > l; l++)
				(!1 & i || a >= i) &&
				Object.keys(n.O).every(function (e) {
				  return n.O[e](o[l]);
				})
				  ? o.splice(l--, 1)
				  : ((s = !1), a > i && (a = i));
			  if (s) {
				e.splice(u--, 1);
				var c = r();
				void 0 !== c && (t = c);
			  }
			}
			return t;
		  }
		  i = i || 0;
		  for (var u = e.length; u > 0 && e[u - 1][2] > i; u--) e[u] = e[u - 1];
		  e[u] = [o, r, i];
		}),
		(n.g = (function () {
		  if ("object" == typeof globalThis) return globalThis;
		  try {
			return this || new Function("return this")();
		  } catch (e) {
			if ("object" == typeof window) return window;
		  }
		})()),
		(n.o = function (e, t) {
		  return Object.prototype.hasOwnProperty.call(e, t);
		}),
		(n.r = function (e) {
		  "undefined" != typeof Symbol &&
			Symbol.toStringTag &&
			Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
			Object.defineProperty(e, "__esModule", { value: !0 });
		}),
		(function () {
		  var e = { 670: 0 };
		  n.O.j = function (t) {
			return 0 === e[t];
		  };
		  var t = function (t, o) {
			  var r,
				i,
				a = o[0],
				s = o[1],
				l = o[2],
				c = 0;
			  if (
				a.some(function (t) {
				  return 0 !== e[t];
				})
			  ) {
				for (r in s) n.o(s, r) && (n.m[r] = s[r]);
				if (l) var u = l(n);
			  }
			  for (t && t(o); a.length > c; c++)
				n.o(e, (i = a[c])) && e[i] && e[i][0](), (e[i] = 0);
			  return n.O(u);
			},
			o = (self.webpackChunkjodit = self.webpackChunkjodit || []);
		  o.forEach(t.bind(null, 0)), (o.push = t.bind(null, o.push.bind(o)));
		})();
	  var r = {};
	  return (
		(function () {
		  "use strict";
		  var e = r;
		  Object.defineProperty(e, "__esModule", { value: !0 }),
			(e.CommitMode = e.Jodit = void 0),
			n(90176),
			"undefined" != typeof window && n(89019);
		  var t = n(37920);
		  Object.defineProperty(e, "Jodit", {
			enumerable: !0,
			get: function () {
			  return t.Jodit;
			},
		  });
		  var o = n(26435),
			i = n(43441),
			a = n(86893),
			s = n(87837),
			l = n(15261);
		  n(70022),
			n(91147),
			Object.keys(a).forEach(function (e) {
			  t.Jodit[e] = a[e];
			});
		  var c = function (e) {
			return "__esModule" !== e;
		  };
		  Object.keys(l)
			.filter(c)
			.forEach(function (e) {
			  s.Icon.set(e.replace("_", "-"), l[e]);
			}),
			Object.keys(s)
			  .filter(c)
			  .forEach(function (e) {
				t.Jodit.modules[e] = s[e];
			  }),
			Object.keys(i)
			  .filter(c)
			  .forEach(function (e) {
				t.Jodit.decorators[e] = i[e];
			  }),
			["Confirm", "Alert", "Prompt"].forEach(function (e) {
			  t.Jodit[e] = s[e];
			}),
			Object.keys(o.default)
			  .filter(c)
			  .forEach(function (e) {
				t.Jodit.lang[e] = o.default[e];
			  }),
			(e.CommitMode = function () {});
		})(),
		n.O(r)
	  );
	})();
  });
  